/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(187);
	
	var _objectApplyIf = __webpack_require__(323);
	
	var _objectApplyIf2 = _interopRequireDefault(_objectApplyIf);
	
	var _arrayTo = __webpack_require__(79);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	var _d2Analysis = __webpack_require__(22);
	
	var _Dimension = __webpack_require__(84);
	
	var _Layout = __webpack_require__(85);
	
	var _InstanceManager = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// extend
	_d2Analysis.api.Dimension = _Dimension.Dimension;
	_d2Analysis.api.Layout = _Layout.Layout;
	_d2Analysis.manager.InstanceManager = _InstanceManager.InstanceManager;
	
	// references
	var refs = {
	    api: _d2Analysis.api,
	    init: _d2Analysis.init,
	    table: _d2Analysis.table
	};
	
	// inits
	var inits = [_d2Analysis.init.legendSetsInit, _d2Analysis.init.dimensionsInit];
	
	// dimension config
	var dimensionConfig = new _d2Analysis.config.DimensionConfig();
	refs.dimensionConfig = dimensionConfig;
	
	// option config
	var optionConfig = new _d2Analysis.config.OptionConfig();
	refs.optionConfig = optionConfig;
	
	// period config
	var periodConfig = new _d2Analysis.config.PeriodConfig();
	refs.periodConfig = periodConfig;
	
	// app manager
	var appManager = new _d2Analysis.manager.AppManager(refs);
	appManager.sessionName = 'eventreport';
	appManager.apiVersion = 29;
	refs.appManager = appManager;
	
	// calendar manager
	var calendarManager = new _d2Analysis.manager.CalendarManager(refs);
	refs.calendarManager = calendarManager;
	
	// request manager
	var requestManager = new _d2Analysis.manager.RequestManager(refs);
	refs.requestManager = requestManager;
	
	// i18n manager
	var i18nManager = new _d2Analysis.manager.I18nManager(refs);
	refs.i18nManager = i18nManager;
	
	// session storage manager
	var sessionStorageManager = new _d2Analysis.manager.SessionStorageManager(refs);
	refs.sessionStorageManager = sessionStorageManager;
	
	// indexed db manager
	// var indexedDbManager = new manager.IndexedDbManager(refs);
	// refs.indexedDbManager = indexedDbManager;
	
	// dependencies
	dimensionConfig.setI18nManager(i18nManager);
	dimensionConfig.init();
	optionConfig.setI18nManager(i18nManager);
	optionConfig.init();
	periodConfig.setI18nManager(i18nManager);
	periodConfig.init();
	
	appManager.applyTo([].concat((0, _arrayTo2.default)(_d2Analysis.api), (0, _arrayTo2.default)(_d2Analysis.table)));
	dimensionConfig.applyTo((0, _arrayTo2.default)(_d2Analysis.table));
	optionConfig.applyTo([].concat((0, _arrayTo2.default)(_d2Analysis.api), (0, _arrayTo2.default)(_d2Analysis.table)));
	
	// plugin
	function render(plugin, layout) {
	    var instanceRefs = _extends({}, refs);
	
	    // ui manager
	    var uiManager = new _d2Analysis.manager.UiManager(instanceRefs);
	    instanceRefs.uiManager = uiManager;
	    uiManager.applyTo([].concat((0, _arrayTo2.default)(_d2Analysis.api), (0, _arrayTo2.default)(_d2Analysis.table)));
	
	    // instance manager
	    var instanceManager = new _d2Analysis.manager.InstanceManager(instanceRefs);
	    instanceRefs.instanceManager = instanceManager;
	    instanceManager.apiResource = 'eventReport';
	    instanceManager.apiEndpoint = 'eventReports';
	    instanceManager.apiModule = 'dhis-web-event-reports';
	    instanceManager.plugin = true;
	    instanceManager.dashboard = eventReportPlugin.dashboard;
	    instanceManager.applyTo((0, _arrayTo2.default)(_d2Analysis.api));
	
	    // table manager
	    var tableManager = new _d2Analysis.manager.TableManager(instanceRefs);
	    instanceRefs.tableManager = tableManager;
	
	    // initialize
	    uiManager.setInstanceManager(instanceManager);
	
	    instanceManager.setFn(function (_layout) {
	        var sortingId = _layout.sorting ? _layout.sorting.id : null,
	            html = '',
	            tableObject;
	
	        var getHtml = function getHtml(title, _tableObject) {
	            return (eventReportPlugin.showTitles ? uiManager.getTitleHtml(title) : '') + tableObject.html;
	        };
	
	        var createPivotTable = function createPivotTable(__layout) {
	
	            // get table
	            var getTable = function getTable() {
	                var _response = __layout.getResponse();
	                var colAxis = new _d2Analysis.table.PivotTableAxis(instanceRefs, __layout, _response, 'col');
	                var rowAxis = new _d2Analysis.table.PivotTableAxis(instanceRefs, __layout, _response, 'row');
	                return new _d2Analysis.table.PivotTable(instanceRefs, __layout, _response, colAxis, rowAxis, { skipTitle: true, trueTotals: false });
	            };
	
	            // pre-sort if id
	            if (sortingId && sortingId !== 'total') {
	                __layout.sort();
	            }
	
	            // table
	            tableObject = getTable();
	
	            // sort if total
	            if (sortingId && sortingId === 'total') {
	                __layout.sort(tableObject);
	                tableObject = getTable();
	            }
	
	            tableObject.initialize();
	            tableObject.build();
	
	            html += eventReportPlugin.showTitles ? uiManager.getTitleHtml(title) : '';
	            html += tableObject.render();
	
	            uiManager.update(html, __layout.el);
	
	            // events
	            tableManager.setColumnHeaderMouseHandlers(__layout, tableObject);
	
	            // mask
	            uiManager.unmask();
	        };
	
	        var createEventDataTable = function createEventDataTable(__layout) {
	            var _response = __layout.getResponse();
	            var statusBar = uiManager.get('statusBar');
	
	            tableObject = new _d2Analysis.table.EventDataTable(refs, __layout, _response);
	
	            if (tableObject) {
	
	                var html = getHtml(__layout.title || __layout.name, tableObject);
	
	                // render
	                uiManager.update(tableObject.html, __layout.el);
	
	                __layout.sorting = layout.sorting;
	                __layout.setResponse(null);
	
	                // events
	                tableManager.setColumnHeaderMouseHandlers(__layout, tableObject);
	
	                if (statusBar) {
	                    statusBar.setStatus(__layout, _response);
	                }
	
	                // mask
	                uiManager.unmask();
	            }
	        };
	
	        if (_layout.dataType === dimensionConfig.dataType['aggregated_values']) {
	            createPivotTable(_layout);
	        } else if (_layout.dataType === dimensionConfig.dataType['individual_cases']) {
	            createEventDataTable(_layout);
	        }
	    });
	
	    if (plugin.loadingIndicator) {
	        uiManager.renderLoadingIndicator(layout.el);
	    }
	
	    if (layout.id) {
	        instanceManager.getById(layout.id, function (_layout) {
	            _layout = new _d2Analysis.api.Layout(instanceRefs, (0, _objectApplyIf2.default)(layout, _layout));
	
	            instanceManager.getReport(_layout);
	        });
	    } else {
	        instanceManager.getReport(new _d2Analysis.api.Layout(instanceRefs, layout));
	    }
	};
	
	global.eventReportPlugin = new _d2Analysis.util.Plugin({ refs: refs, inits: inits, renderFn: render, type: 'EVENT_REPORT' });
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Check if the value is an Array
	 *
	 * @param param Value to be checked
	 * @returns {boolean} Returns true when the `param` is an Array
	 *
	 * @example
	 * isArray([]); // Returns: true
	 * isArray({}); // Returns: false
	 * isArray('Hello'); // Returns: false
	 */
	exports.default = Array.isArray;
	//# sourceMappingURL=isArray.js.map

/***/ },
/* 2 */
[572, 1],
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(44);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if the value is a String
	 *
	 * @name isString
	 * @param param Value to be checked
	 * @returns {boolean} Returns true when the `param` is a String
	 */
	exports.default = _lodash2.default;
	//# sourceMappingURL=isString.js.map

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = arrayContains;
	/**
	 * Check if an array contains a specified item
	 *
	 * @param {Array} array The array to check for the item
	 * @param {*} item The item to look for in the array
	 * @returns {boolean} Returns true when the item is found, otherwise false
	 */
	function arrayContains(array, item) {
	  return Array.prototype.indexOf.call(array, item) !== -1;
	}
	//# sourceMappingURL=arrayContains.js.map

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = arrayFrom;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Create an array from a value
	 *
	 * @param {*} param Value to transform to an array
	 * @param {boolean} [isNewRef] Should return a new reference than the one from the `param` value
	 * @returns {Array} The resulting array
	 *
	 * @requires isArray
	 */
	function arrayFrom(param, isNewRef) {
	    var toArray = function toArray(iterable, start, end) {
	        if (!iterable || !iterable.length) {
	            return [];
	        }
	
	        // FIXME: This will never be called as the if check excludes type string
	        if (typeof iterable === 'string') {
	            iterable = iterable.split('');
	        }
	
	        if (supportsSliceOnNodeList) {
	            // FIXME: This does not exist
	            return slice.call(iterable, start || 0, end || iterable.length);
	        }
	
	        var array = [],
	            i;
	
	        // FIXME: start and end are always 0 and iterable.length
	        start = start || 0;
	        end = end ? end < 0 ? iterable.length + end : end : iterable.length;
	
	        for (i = start; i < end; i++) {
	            array.push(iterable[i]);
	        }
	
	        return array;
	    };
	
	    if (param === undefined || param === null) {
	        return [];
	    }
	
	    if ((0, _isArray2.default)(param)) {
	        return isNewRef ? Array.prototype.slice.call(param) : param;
	    }
	
	    var type = typeof param === 'undefined' ? 'undefined' : _typeof(param);
	    if (param && param.length !== undefined && type !== 'string' && (type !== 'function' || !param.apply)) {
	        // TODO: This function call will always fail because of supportsSliceOnNodeList being undefined
	        return toArray(param);
	    }
	
	    return [param];
	}
	//# sourceMappingURL=arrayFrom.js.map

/***/ },
/* 6 */
[566, 1, 2, 3],
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayClean;
	
	var _isEmpty = __webpack_require__(29);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Cleans the given array of _empty_ values
	 *
	 * @see {isEmpty} for how the values are determined to be empty.
	 *
	 * @param {Array} array The array to be _cleaned_
	 * @returns {Array} The clean array
	 *
	 * @throws {TypeError} When the passed array is not actually an array.
	 *
	 * @example
	 * const sourceArray = [undefined, null, true, '', {}];
	 * arrayClean(sourceArray); // Returns: [true, {}]
	 *
	 * @example
	 * arrayClean() // throws: Cannot read property 'length' of undefined
	 */
	// TODO: Could be written as `array.filter(isEmpty);`
	function arrayClean(array) {
	    var results = [],
	        i = 0,
	        ln = array.length,
	        // TODO: throws if the error is undefined
	    item;
	
	    for (; i < ln; i++) {
	        item = array[i];
	
	        if (!(0, _isEmpty2.default)(item)) {
	            results.push(item);
	        }
	    }
	
	    return results;
	}
	//# sourceMappingURL=arrayClean.js.map

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arraySort;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isNumber = __webpack_require__(9);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function arraySort(array, direction, key, emptyFirst) {
	    // supports [number], [string], [{key: number}], [{key: string}], [[string]], [[number]]
	
	    if (!(0, _isArray2.default)(array)) {
	        return;
	    }
	
	    key = !!key || (0, _isNumber2.default)(key) ? key : 'name';
	
	    array.sort(function (a, b) {
	        // if object, get the property values
	        if ((0, _isObject2.default)(a) && (0, _isObject2.default)(b)) {
	            a = a[key];
	            b = b[key];
	        }
	
	        // if array, get from the right index
	        if ((0, _isArray2.default)(a) && (0, _isArray2.default)(b)) {
	            a = a[key];
	            b = b[key];
	        }
	
	        // string
	        if ((0, _isString2.default)(a) && (0, _isString2.default)(b)) {
	            a = a.toLowerCase();
	            b = b.toLowerCase();
	
	            if (direction === 'DESC') {
	                // TODO: Case sensitive really required? Why not allow `desc`, `Desc` or `dEsC`?
	                return a < b ? 1 : a > b ? -1 : 0;
	            } else {
	                return a < b ? -1 : a > b ? 1 : 0;
	            }
	        }
	
	        // number
	        else if ((0, _isNumber2.default)(a) && (0, _isNumber2.default)(b)) {
	                return direction === 'DESC' ? b - a : a - b;
	            } else if (a === undefined || a === null) {
	                return emptyFirst ? -1 : 1;
	            } else if (b === undefined || b === null) {
	                return emptyFirst ? 1 : -1;
	            }
	
	        return -1;
	    });
	
	    return array;
	}
	//# sourceMappingURL=arraySort.js.map

/***/ },
/* 9 */
[570, 183],
/* 10 */
1,
/* 11 */,
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayUnique;
	/**
	 * Creates an array of unique values from the array passed. This function does not do a _deep_ compare.
	 * Objects with the same values will therefore not be filtered.
	 *
	 * @param {Array} array The array to create the array of uniques from
	 * @returns {Array} The array containing the unique values
	 *
	 * @throws {TypeError} Is thrown when the argument passed is not an `array`
	 *
	 * @example
	 * const sourceArray = [1, 1, 2, 3, 2, 4, 4, 3];
	 * arrayUnique(sourceArray); // returns: [1, 2, 3, 4]
	 *
	 * @example
	 * const A = {name: 'A'};
	 * const B = {name: 'B'};
	 * arrayUnique([A, A, B, B]); // Returns: [{name: 'A'}, {name: 'B'}]
	 *
	 * @example
	 * const sourceArray = [{name: 'A'}, {name: 'B'}, {name: 'B'}];
	 * arrayUnique(sourceArray); // Returns: [{name: 'A'}, {name: 'B'}, {name: 'B'}]
	 */
	function arrayUnique(array) {
	    // TODO: Could be written as `return [...(new Set(array))];`
	    var newArray = [];
	    var i = 0;
	    var len = array.length;
	    var item;
	
	    for (; i < len; i++) {
	        item = array[i];
	
	        if (newArray.indexOf(item) === -1) {
	            newArray.push(item);
	        }
	    }
	
	    return newArray;
	}
	//# sourceMappingURL=arrayUnique.js.map

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(70);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if a value is a boolean value `true` or `false`
	 *
	 * @name isBoolean
	 * @param {*} param The value to check for boolean type
	 * @returns {boolean} Returns `true` when the value is a boolean otherwise `false`
	 */
	exports.default = _lodash2.default;
	//# sourceMappingURL=isBoolean.js.map

/***/ },
/* 14 */
3,
/* 15 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var scrollbarWidth = /\bchrome\b/.test(navigator.userAgent.toLowerCase()) ? 8 : 17;
	
	exports.default = {
	    nameCmpWidth: 440 - scrollbarWidth,
	    buttonCmpWidth: 20,
	    operatorCmpWidth: 70,
	    searchCmpWidth: 70,
	    triggerCmpWidth: 17,
	    valueCmpWidth: 235,
	    rangeSetWidth: 135,
	    namePadding: '3px 3px',
	    margin: '3px 0 1px',
	    removeCmpStyle: 'padding: 0; margin-left: 3px',
	    defaultRangeSetId: 'default'
	};
	//# sourceMappingURL=containerConfig.js.map

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(71);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if the value is a Function
	 *
	 * @name isFunction
	 * @param {*} param Value to be checked
	 * @returns {boolean} Returns true when the `param` is a Function
	 */
	exports.default = _lodash2.default;
	//# sourceMappingURL=isFunction.js.map

/***/ },
/* 18 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isNumeric;
	/**
	 * Check if a value is numeric
	 *
	 * @param param Value to be checked
	 * @returns {boolean} Returns true when the `param` is a numeric value
	 */
	function isNumeric(param) {
	    if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) === 'symbol') {
	        return false;
	    }
	
	    return !isNaN(parseFloat(param)) && global.isFinite(param);
	}
	//# sourceMappingURL=isNumeric.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 19 */
[572, 10],
/* 20 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var d2Analysis = __webpack_require__(124);
	
	module.exports = d2Analysis;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DateManager = undefined;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _DateManager;
	
	exports.DateManager = _DateManager;
	exports.DateManager = _DateManager = function DateManager() {
	    this.klass = _DateManager;
	};
	
	_DateManager.toDate = function (dateString) {
	    return (0, _isString2.default)(dateString) ? new Date(dateString) : dateString;
	};
	
	_DateManager.isValid = function (param) {
	    param = this.toDate(param);
	    return Object.prototype.toString.call(param) === '[object Date]' && param.toString() !== 'Invalid Date';
	};
	
	_DateManager.getYYYYMMDD = function (param, skipValidation) {
	    param = this.toDate(param);
	
	    if (!skipValidation && !_DateManager.isValid(param)) {
	        return null;
	    }
	
	    var date = new Date(param),
	        month = '' + (1 + date.getMonth()),
	        day = '' + date.getDate();
	
	    month = month.length === 1 ? '0' + month : month;
	    day = day.length === 1 ? '0' + day : day;
	
	    return date.getFullYear() + '-' + month + '-' + day;
	};
	
	_DateManager.getTimeDifference = function (date) {
	    var seconds = Math.floor((new Date() - new Date(date)) / 1000);
	
	    // Dirty hack to avoid having negative time due to difference between client zone and server zone
	    while (seconds < 0) {
	        seconds += 3600;
	    }
	    var interval = Math.floor(seconds / 31536000);
	
	    if (interval > 1) {
	        return interval + " years";
	    }
	    interval = Math.floor(seconds / 2592000);
	    if (interval > 1) {
	        return interval + " months";
	    }
	    interval = Math.floor(seconds / 86400);
	    if (interval > 1) {
	        return interval + " days";
	    }
	    interval = Math.floor(seconds / 3600);
	    if (interval > 1) {
	        return interval + " hours";
	    }
	    interval = Math.floor(seconds / 60);
	    if (interval > 1) {
	        return interval + " minutes";
	    }
	    return Math.floor(seconds) + " seconds";
	};
	//# sourceMappingURL=DateManager.js.map

/***/ },
/* 24 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var textfieldStyle = ['padding-right: 0', 'padding-left: 5px', 'border-color: transparent', 'background: none', 'font-size: 11px', 'line-height: 13px'];
	
	var textFieldLabelStyle = ['font-size: 11px', 'font-weight: bold', 'color: #111', 'padding-left: 5px', 'padding-top: 4px', 'margin-bottom: 0'];
	
	var toggleBtnWidth = 22;
	var toggleBtnMarginTop = 48;
	var toggleBtnMarginRight = 7;
	var toggleBtnMarginLeft = 10;
	
	var windowWidth = 700;
	var borderWidth = 14;
	var filtersComboBoxWidth = 160;
	var windowCmpWidth = windowWidth - borderWidth;
	
	var createdColWidth = 120;
	var lastUpdatedColWidth = 120;
	var buttonColWidth = 60;
	var paddingColWidth = 8;
	
	exports.default = {
	    textfieldStyle: textfieldStyle,
	    textFieldLabelStyle: textFieldLabelStyle,
	    toggleBtnWidth: toggleBtnWidth,
	    toggleBtnMarginTop: toggleBtnMarginTop,
	    toggleBtnMarginRight: toggleBtnMarginRight,
	    toggleBtnMarginLeft: toggleBtnMarginLeft,
	    windowWidth: windowWidth,
	    borderWidth: borderWidth,
	    windowCmpWidth: windowCmpWidth,
	    filtersComboBoxWidth: filtersComboBoxWidth,
	    createdColWidth: createdColWidth,
	    lastUpdatedColWidth: lastUpdatedColWidth,
	    buttonColWidth: buttonColWidth,
	    paddingColWidth: paddingColWidth
	};
	//# sourceMappingURL=FavoriteStyle.js.map

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InterpretationWindow = undefined;
	
	var _SharingWindow = __webpack_require__(26);
	
	var InterpretationWindow = exports.InterpretationWindow = undefined;
	
	exports.InterpretationWindow = InterpretationWindow = function InterpretationWindow(c, sharing, interpretation, success) {
	    var appManager = c.appManager,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        i18n = c.i18nManager.get(),
	        apiPath = appManager.getApiPath(),
	        apiResource = instanceManager.apiResource,
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    var textArea = Ext.create('Ext.form.field.TextArea', {
	        cls: 'ns-textarea',
	        height: 130,
	        width: 407,
	        fieldStyle: 'padding-left:3px; padding-top:3px',
	        emptyText: i18n.write_your_interpretation + '..',
	        enableKeyEvents: true,
	        value: interpretation ? interpretation.text : undefined,
	        listeners: {
	            keyup: function keyup() {
	                shareButton.xable();
	            }
	        }
	    });
	
	    var sharingCmp = sharing ? new _SharingWindow.SharingWindow(c, sharing, true) : null;
	
	    var sharingCt = Ext.create('Ext.container.Container', {
	        style: 'padding-top:10px; padding-bottom:25px',
	        items: sharingCmp ? sharingCmp.items : []
	    });
	
	    var method = interpretation ? 'PUT' : 'POST';
	
	    var interpretationSuccess = function interpretationSuccess(text) {
	        if (interpretation) {
	            interpretation.text = text;
	        }
	        if (success) {
	            success();
	        } else {
	            instanceManager.getById(null, function (layout, isFavorite) {
	                instanceManager.getReport(layout, isFavorite, false, false, function () {
	                    uiManager.unmask();
	                });
	            });
	        }
	    };
	
	    var updateSharing = function updateSharing(obj, text) {
	        var interpretationId = interpretation ? interpretation.id : (obj.getResponseHeader('location') || '').split('/').pop(),
	            sharingId = sharing.object.id,
	            sharingBody = sharingCmp.getBody();
	
	        Ext.Ajax.request({
	            url: encodeURI(apiPath + '/sharing?type=interpretation&id=' + interpretationId),
	            method: method,
	            headers: {
	                'Content-Type': 'application/json'
	            },
	            params: Ext.encode(sharingBody),
	            callback: function callback() {
	                interpretationSuccess(text);
	            }
	        });
	    };
	
	    var shareButton = Ext.create('Ext.button.Button', {
	        text: interpretation ? i18n.update : i18n.share,
	        disabled: !interpretation,
	        xable: function xable() {
	            this.setDisabled(!textArea.getValue());
	        },
	        handler: function handler() {
	            var text = textArea.getValue();
	            var interpretationPath = interpretation ? '/interpretations/' + interpretation.id : '/interpretations/' + apiResource + '/' + instanceManager.getStateFavoriteId();
	
	            if (text) {
	                Ext.Ajax.request({
	                    url: encodeURI(apiPath + interpretationPath),
	                    method: method,
	                    params: text,
	                    headers: { 'Content-Type': 'text/html' },
	                    success: function success(obj) {
	                        sharing ? updateSharing(obj, text) : interpretationSuccess(text);
	                        textArea.reset();
	                        window.destroy();
	                    }
	                });
	            }
	        }
	    });
	
	    var window = Ext.create('Ext.window.Window', {
	        title: i18n.write_interpretation,
	        layout: 'fit',
	        bodyStyle: 'padding:4px; background-color:#fff',
	        resizable: false,
	        destroyOnBlur: true,
	        modal: true,
	        items: [textArea, sharingCt],
	        bbar: {
	            cls: 'ns-toolbar-bbar',
	            defaults: {
	                height: 24
	            },
	            items: ['->', shareButton]
	        },
	        listeners: {
	            show: function show(w) {
	                uiManager.setAnchorPosition(w, 'favoriteButton');
	
	                uiManager.enableRightClick();
	
	                if (!w.hasDestroyOnBlurHandler) {
	                    uiManager.addDestroyOnBlurHandler(w);
	                }
	            },
	            hide: function hide() {
	                uiManager.disableRightClick();
	            }
	        }
	    });
	    uiManager.reg(window, 'interpretationWindow');
	
	    return window;
	};
	//# sourceMappingURL=InterpretationWindow.js.map

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SharingWindow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SharingWindow = exports.SharingWindow = undefined;
	
	exports.SharingWindow = SharingWindow = function SharingWindow(c, sharing, configOnly) {
	    var t = this;
	
	    var appManager = c.appManager,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        i18n = c.i18nManager.get();
	
	    var apiPath = appManager.getApiPath();
	
	    var SharingAccessRow, getBody, sharingStore, sharingField, sharingButton, userGroupRowContainer, userRowContainer, sharingContainer, externalAccess, publicGroup, items, window;
	
	    SharingAccessRow = function SharingAccessRow(obj, isPublicAccess, disallowPublicAccess) {
	        var getData, store, getItems, combo, getAccess, panel;
	
	        getData = function getData() {
	            var data = [{ id: 'r-------', name: i18n.can_view }, { id: 'rw------', name: i18n.can_edit_and_view }];
	
	            if (isPublicAccess) {
	                data.unshift({ id: '--------', name: i18n.none });
	            }
	
	            return data;
	        };
	
	        store = Ext.create('Ext.data.Store', {
	            fields: ['id', 'name'],
	            data: getData()
	        });
	
	        getItems = function getItems() {
	            var items = [];
	
	            combo = Ext.create('Ext.form.field.ComboBox', {
	                style: 'margin-bottom:2px',
	                fieldLabel: isPublicAccess ? i18n.public_access : obj.name,
	                labelStyle: 'color:#333',
	                cls: 'ns-combo',
	                width: 380,
	                labelWidth: 250,
	                queryMode: 'local',
	                valueField: 'id',
	                displayField: 'name',
	                labelSeparator: null,
	                editable: false,
	                disabled: !!disallowPublicAccess,
	                value: obj.access || 'rw------',
	                store: store
	            });
	
	            items.push(combo);
	
	            if (!isPublicAccess) {
	                items.push(Ext.create('Ext.container.Container', {
	                    cls: 'ns-grid-row-icon-delete',
	                    style: 'margin-top:2px; margin-left:7px',
	                    bodyStyle: 'border:0 none; background:#fff',
	                    overCls: 'pointer',
	                    width: 16,
	                    height: 16,
	                    listeners: {
	                        render: function render(cmp) {
	                            cmp.getEl().on('click', function (e) {
	                                cmp.up('panel').destroy();
	
	                                if (window) {
	                                    window.doLayout();
	                                }
	                            });
	                        }
	                    }
	                }));
	            }
	
	            return items;
	        };
	
	        getAccess = function getAccess() {
	            return {
	                id: obj.id,
	                name: obj.name,
	                access: combo.getValue()
	            };
	        };
	
	        panel = Ext.create('Ext.panel.Panel', {
	            layout: 'column',
	            bodyStyle: 'border:0 none',
	            getAccess: getAccess,
	            items: getItems()
	        });
	
	        return panel;
	    };
	
	    getBody = function getBody() {
	        var body = {
	            object: {
	                id: sharing.object.id,
	                name: sharing.object.name,
	                publicAccess: publicGroup.down('combobox').getValue(),
	                externalAccess: externalAccess ? externalAccess.getValue() : false
	            }
	        };
	
	        if (userGroupRowContainer.items.items.length > 1) {
	            body.object.userGroupAccesses = [];
	            userGroupRowContainer.items.items.forEach(function (item, i) {
	                if (i > 0) {
	                    body.object.userGroupAccesses.push(item.getAccess());
	                }
	            });
	        }
	
	        if (userRowContainer.items.items.length > 1) {
	            body.object.userAccesses = [];
	            userRowContainer.items.items.forEach(function (item, i) {
	                if (i > 0) {
	                    body.object.userAccesses.push(item.getAccess());
	                }
	            });
	        }
	
	        return body;
	    };
	
	    // Initialize
	    sharingStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'isGroup'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/sharing/search'),
	            extraParams: {
	                pageSize: 50
	            },
	            startParam: false,
	            limitParam: false,
	            reader: {
	                type: 'json',
	                getData: function getData(data) {
	                    // manually populate the store with the records from the response
	                    // this is to avoid having to call the endpoint 2 times, one for user groups and one for users
	                    var records = [];
	
	                    data.userGroups.forEach(function (_ref) {
	                        var id = _ref.id,
	                            name = _ref.name;
	
	                        records.push({ id: id, name: name, isGroup: true });
	                    });
	
	                    data.users.forEach(function (_ref2) {
	                        var id = _ref2.id,
	                            name = _ref2.name;
	
	                        records.push({ id: id, name: name, isGroup: false });
	                    });
	
	                    return records;
	                }
	            }
	        }
	    });
	
	    var comboBoxConfig = {
	        valueField: 'id',
	        displayField: 'name',
	        queryParam: 'key',
	        queryDelay: 200,
	        minChars: 1,
	        hideTrigger: true,
	        fieldStyle: 'height:26px; padding-left:6px; border-radius:1px; font-size:11px',
	        style: 'margin-bottom:5px',
	        width: 380
	    };
	
	    sharingField = Ext.create('Ext.form.field.ComboBox', _extends({}, comboBoxConfig, {
	        emptyText: i18n.add_users_and_user_groups,
	        store: sharingStore,
	        listeners: {
	            beforeselect: function beforeselect(cb) {
	                // beforeselect instead of select, fires regardless of currently selected item
	                sharingButton.enable();
	            },
	            afterrender: function afterrender(cb) {
	                cb.inputEl.on('keyup', function (e) {
	                    if (e.getKey() !== e.ENTER) {
	                        sharingButton.disable();
	                    }
	                });
	            }
	        }
	    }));
	
	    var buttonConfig = {
	        text: '+',
	        style: 'margin-left:2px; padding-right:4px; padding-left:4px; border-radius:1px',
	        disabled: true,
	        height: 26
	    };
	
	    sharingButton = Ext.create('Ext.button.Button', _extends({}, buttonConfig, {
	        handler: function handler(b) {
	            var record = sharingStore.getById(sharingField.getValue());
	
	            if (record && record.data) {
	                if (record.data.isGroup) {
	                    userGroupRowContainer.add(SharingAccessRow({
	                        id: record.data.id,
	                        name: record.data.name,
	                        access: 'r-------'
	                    }));
	                } else {
	                    userRowContainer.add(SharingAccessRow({
	                        id: record.data.id,
	                        name: record.data.name,
	                        access: 'r-------'
	                    }));
	                }
	            }
	
	            sharingField.clearValue();
	            b.disable();
	        }
	    }));
	
	    sharingContainer = Ext.create('Ext.container.Container', {
	        bodyStyle: 'border:0 none'
	    });
	
	    var rowContainerConfig = {
	        hidden: true,
	        bodyStyle: 'border:0 none',
	        listeners: {
	            add: function add(el) {
	                if (el.items.length > 1) {
	                    // enable the whole container
	                    el.show();
	                }
	            },
	            remove: function remove(el) {
	                if (el.items.length === 1) {
	                    el.hide();
	                }
	            }
	        }
	    };
	
	    userGroupRowContainer = Ext.create('Ext.container.Container', _extends({}, rowContainerConfig, {
	        items: [{
	            html: i18n.groups_access,
	            bodyStyle: 'border:0 none; font-weight: bold'
	        }]
	    }));
	
	    userRowContainer = Ext.create('Ext.container.Container', _extends({}, rowContainerConfig, {
	        items: [{
	            html: i18n.users_access,
	            bodyStyle: 'border:0 none; font-weight: bold'
	        }]
	    }));
	
	    if (sharing.meta.allowExternalAccess) {
	        externalAccess = sharingContainer.add({
	            xtype: 'checkbox',
	            fieldLabel: i18n.allow_external_access,
	            labelSeparator: '',
	            labelWidth: 250,
	            checked: !!sharing.object.externalAccess
	        });
	    }
	
	    publicGroup = sharingContainer.add(SharingAccessRow({
	        id: sharing.object.id,
	        name: sharing.object.name,
	        access: sharing.object.publicAccess
	    }, true, !sharing.meta.allowPublicAccess));
	
	    if ((0, _isArray2.default)(sharing.object.userGroupAccesses)) {
	        sharing.object.userGroupAccesses.forEach(function (record) {
	            userGroupRowContainer.add(SharingAccessRow(record));
	        });
	    }
	
	    if ((0, _isArray2.default)(sharing.object.userAccesses)) {
	        sharing.object.userAccesses.forEach(function (record) {
	            userRowContainer.add(SharingAccessRow(record));
	        });
	    }
	
	    items = [{
	        html: sharing.object.name,
	        bodyStyle: 'border:0 none; font-weight:bold; color:#333',
	        style: 'margin-bottom:7px'
	    }, {
	        xtype: 'container',
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        items: [sharingField, sharingButton]
	    }, {
	        html: i18n.created_by + ' ' + sharing.object.user.name,
	        bodyStyle: 'border:0 none; color:#777',
	        style: 'margin-top:2px;margin-bottom:7px'
	    }, sharingContainer, userGroupRowContainer, userRowContainer];
	
	    if (configOnly) {
	        return {
	            SharingAccessRow: SharingAccessRow,
	            getBody: getBody,
	            sharingStore: sharingStore,
	            sharingField: sharingField,
	            sharingButton: sharingButton,
	            userGroupRowContainer: userGroupRowContainer,
	            userRowContainer: userRowContainer,
	            externalAccess: externalAccess,
	            publicGroup: publicGroup,
	            items: items
	        };
	    } else {
	        window = Ext.create('Ext.window.Window', {
	            title: i18n.sharing_settings,
	            bodyStyle: 'padding:5px 5px 3px; background-color:#fff',
	            resizable: false,
	            modal: true,
	            destroyOnBlur: true,
	            items: items,
	            bbar: ['->', {
	                text: i18n.save,
	                handler: function handler() {
	                    Ext.Ajax.request({
	                        url: encodeURI(apiPath + '/sharing?type=' + instanceManager.apiResource + '&id=' + sharing.object.id),
	                        method: 'POST',
	                        headers: {
	                            'Content-Type': 'application/json'
	                        },
	                        params: Ext.encode(getBody()),
	                        success: function success() {
	                            instanceManager.getById(null, function (layout, isFavorite) {
	                                instanceManager.getReport(layout, isFavorite, false, false, function () {
	                                    uiManager.unmask();
	                                });
	                            });
	                        }
	                    });
	
	                    window.destroy();
	                }
	            }],
	            listeners: {
	                show: function show(w) {
	                    var favoriteWindow = uiManager.get('favoriteWindow');
	
	                    if (favoriteWindow && favoriteWindow.rendered) {
	
	                        // position
	                        var x = (favoriteWindow.getWidth() - w.getWidth()) / 2 + favoriteWindow.getPosition()[0],
	                            y = w.getPosition()[1] / 3;
	
	                        w.setPosition(x, y);
	
	                        // blur
	                        favoriteWindow.destroyOnBlur = false;
	                    } else {
	                        uiManager.setAnchorPosition(w, 'favoriteButton');
	                    }
	
	                    if (!w.hasDestroyOnBlurHandler) {
	                        uiManager.addDestroyOnBlurHandler(w);
	                    }
	                },
	                destroy: function destroy() {
	                    var favoriteWindow = uiManager.get('favoriteWindow');
	
	                    if (favoriteWindow) {
	                        favoriteWindow.destroyOnBlur = true;
	                    }
	                }
	            }
	        });
	
	        return window;
	    }
	};
	//# sourceMappingURL=SharingWindow.js.map

/***/ },
/* 27 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayPluck;
	/**
	 *
	 * @param {Array} array
	 * @param {string|number} propertyName The property of the
	 * @returns {Array}
	 *
	 * @throws {TypeError} When the `propertyName` can not be found on an item in the `array`. This generally happens when a value in the array is `null` or `undefined`
	 *
	 * @example
	 * const values = [{name: 'John'}, {name: 'James'}];
	 * arrayPluck(values, 'name') // returns: ['John', 'James']
	 *
	 * @example
	 * const values = [{name: 'John'}, {}, {name: 'James'}];
	 * arrayPluck(values, 'name') // returns: ['John', undefined, 'James']
	 *
	 * @example
	 * const values = [undefined, {name: 'James'}];
	 * arrayPluck(values, 'name') // throws: Cannot read property 'name' of undefined
	 */
	function arrayPluck(array, propertyName) {
	    var newArray = [];
	    var i;
	    var len;
	    var item;
	
	    for (i = 0, len = array.length; i < len; i++) {
	        item = array[i];
	
	        newArray.push(item[propertyName]);
	    }
	
	    return newArray;
	}
	//# sourceMappingURL=arrayPluck.js.map

/***/ },
/* 28 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = clone;
	// TODO: Throw an error on empty `item` (Unexpected token u)
	/**
	 * Create a clone a value
	 *
	 * @param {*} item
	 *
	 * @example
	 * const person1 = {name: 'John'};
	 * const person2 = clone(person1); // Returns {name: 'John'}
	 * // but
	 * person1 !== person2 // Returns:  true
	 */
	function clone(item) {
	  return global.JSON.parse(global.JSON.stringify(item));
	}
	//# sourceMappingURL=clone.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 29 */
[568, 1],
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = uuid;
	/**
	 * Generates a universally unique identifier
	 *
	 * @see https://en.wikipedia.org/wiki/Universally_unique_identifier
	 *
	 * @returns {string} The uuid
	 */
	function uuid() {
	    var s4 = function s4() {
	        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	    };
	
	    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	}
	//# sourceMappingURL=uuid.js.map

/***/ },
/* 31 */
[568, 10],
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(49)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(101)
	  , createDesc = __webpack_require__(102);
	module.exports = __webpack_require__(32) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 34 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResponseRowIdCombination = undefined;
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponseRowIdCombination = exports.ResponseRowIdCombination = undefined;
	
	exports.ResponseRowIdCombination = ResponseRowIdCombination = function ResponseRowIdCombination(refs, config) {
	    var t = this;
	
	    config = (0, _isArray2.default)(config) ? config.reduce(function (acc, cur) {
	        return acc += (acc.length === 0 ? '' : '-') + cur;
	    }, '') : null;
	    config = (0, _isString2.default)(config) ? config : '';
	
	    // constructor
	    t.ids = config;
	};
	
	ResponseRowIdCombination.prototype.add = function (id) {
	    if (id) {
	        this.ids += (this.ids.length === 0 ? '' : '-') + id;
	    }
	};
	
	ResponseRowIdCombination.prototype.get = function () {
	    return this.ids;
	};
	
	ResponseRowIdCombination.prototype.getNames = function (response, ignoreIndexes) {
	    var ids = this.ids.split('-');
	
	    if ((0, _isArray2.default)(ignoreIndexes)) {
	        ids = ids.filter(function (id, index) {
	            return !(0, _arrayContains2.default)(ignoreIndexes, index);
	        });
	    }
	
	    return ids.map(function (id) {
	        return response.getNameById(id);
	    });
	};
	
	ResponseRowIdCombination.prototype.getIdByIds = function (ids) {
	    return this.ids.split('-').filter(function (id) {
	        return (0, _arrayContains2.default)((0, _arrayFrom2.default)(ids), id);
	    })[0];
	};
	//# sourceMappingURL=ResponseRowIdCombination.js.map

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var layout = _ref.layout,
	        i18n = _ref.i18n;
	
	
	    var nameTextField = Ext.create('Ext.form.field.Text', {
	        width: _FavoriteStyle2.default.windowCmpWidth,
	        height: 45,
	        style: 'margin-top: 2px; margin-bottom: 0',
	        fieldStyle: _FavoriteStyle2.default.textfieldStyle.join(';'),
	        fieldLabel: i18n.name,
	        labelAlign: 'top',
	        labelStyle: _FavoriteStyle2.default.textFieldLabelStyle.join(';'),
	        labelSeparator: '',
	        emptyText: 'Unnamed',
	        enableKeyEvents: true,
	        currentValue: '',
	        value: layout.name,
	        setEventChangeHandler: function setEventChangeHandler(handler) {
	            this.eventChangeHandler = handler;
	        },
	        setEventKeyUpHandler: function setEventKeyUpHandler(handler) {
	            this.eventKeyUpHandler = handler;
	        },
	        listeners: {
	            change: function change(cmp, e) {
	                if (this.eventChangeHandler) {
	                    this.eventChangeHandler(cmp, e);
	                }
	            },
	            keyup: function keyup(cmp, e) {
	                if (e.keyCode === 13 && this.eventKeyUpHandler) {
	                    this.eventKeyUpHandler(cmp, e);
	                }
	            }
	        }
	    });
	
	    var descriptionTextField = Ext.create('Ext.form.field.TextArea', {
	        width: _FavoriteStyle2.default.windowCmpWidth,
	        rows: 3,
	        style: 'margin-bottom: 0',
	        fieldStyle: _FavoriteStyle2.default.textfieldStyle.concat(['padding-top: 5px']).join(';'),
	        fieldLabel: i18n.description,
	        labelAlign: 'top',
	        labelStyle: _FavoriteStyle2.default.textFieldLabelStyle.join(';'),
	        labelSeparator: '',
	        emptyText: 'No description (optional)',
	        enableKeyEvents: true,
	        value: layout.description
	    });
	
	    var titleTextField = Ext.create('Ext.form.field.Text', {
	        width: _FavoriteStyle2.default.windowCmpWidth,
	        height: 45,
	        style: 'margin-bottom: 0',
	        fieldStyle: _FavoriteStyle2.default.textfieldStyle.join(';'),
	        fieldLabel: i18n.title,
	        labelAlign: 'top',
	        labelStyle: _FavoriteStyle2.default.textFieldLabelStyle.join(';'),
	        labelSeparator: '',
	        emptyText: 'No title (optional)',
	        enableKeyEvents: true,
	        currentValue: '',
	        value: layout.title,
	        setEventKeyUpHandler: function setEventKeyUpHandler(handler) {
	            this.eventKeyUpHandler = handler;
	        },
	        listeners: {
	            keyup: function keyup(cmp, e) {
	                if (e.keyCode === 13 && this.eventKeyUpHandler) {
	                    this.eventKeyUpHandler(cmp, e);
	                }
	            }
	        }
	    });
	
	    return {
	        nameTextField: nameTextField,
	        descriptionTextField: descriptionTextField,
	        titleTextField: titleTextField
	    };
	};
	
	var _FavoriteStyle = __webpack_require__(24);
	
	var _FavoriteStyle2 = _interopRequireDefault(_FavoriteStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=FavoriteTextCmp.js.map

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FavoriteWindow = undefined;
	
	var _RenameWindow = __webpack_require__(38);
	
	var _SharingWindow = __webpack_require__(26);
	
	var _GridHeaders = __webpack_require__(61);
	
	var _FavoriteTextCmp = __webpack_require__(36);
	
	var _FavoriteTextCmp2 = _interopRequireDefault(_FavoriteTextCmp);
	
	var _FavoriteStyle = __webpack_require__(24);
	
	var _FavoriteStyle2 = _interopRequireDefault(_FavoriteStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FavoriteWindow = exports.FavoriteWindow = undefined;
	
	exports.FavoriteWindow = FavoriteWindow = function FavoriteWindow(c, action) {
	    var appManager = c.appManager,
	        instanceManager = c.instanceManager,
	        uiManager = c.uiManager,
	        i18n = c.i18nManager.get(),
	        uiConfig = c.uiConfig,
	        apiPath = appManager.getApiPath(),
	        apiResource = instanceManager.apiResource,
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    var getDirection,
	        getStoreUrl,
	        favoriteStore,
	        filtersStore,
	        getFilterUrlParam,
	        NameWindow,
	        nameWindow,
	        nameTextfield,
	        createButton,
	        updateButton,
	        cancelButton,
	        textfieldKeyUpHandlers,
	        showFavoritesLink,
	        showFavoritesLinkCt,
	        searchTextfield,
	        filtersComboBox,
	        descriptionPanel,
	        saveButtonHandler,
	        saveButton,
	        prevButton,
	        nextButton,
	        info,
	        gridHeaders,
	        renderers,
	        windowBbarSeparator,
	        windowBbar,
	        grid,
	        titles,
	        windowItems,
	        favoriteWindow,
	        nameColWidth = _FavoriteStyle2.default.windowCmpWidth - _FavoriteStyle2.default.createdColWidth - _FavoriteStyle2.default.lastUpdatedColWidth - _FavoriteStyle2.default.buttonColWidth - _FavoriteStyle2.default.paddingColWidth - 2,
	        storeFields = 'id,name,created,lastUpdated,access,title,description,user',
	        urlFields = 'id,displayName~rename(name),created,lastUpdated,access,title,description,user',
	        sortField = 'name',
	        sortDirection = 'asc',
	        cmpToToggle = [],
	        layout = instanceManager.getStateCurrent() || {};
	
	    var _getFavoriteTextCmp = (0, _FavoriteTextCmp2.default)({ layout: layout, i18n: i18n }),
	        nameTextField = _getFavoriteTextCmp.nameTextField,
	        descriptionTextField = _getFavoriteTextCmp.descriptionTextField;
	
	    getDirection = function getDirection(keepDir) {
	        return sortDirection = keepDir ? sortDirection : sortDirection === 'asc' ? 'desc' : 'asc';
	    };
	
	    getStoreUrl = function getStoreUrl(field, keepDir) {
	        sortField = field || sortField;
	
	        var value = action === 'open' ? searchTextfield.getValue() : null;
	
	        var url = apiPath + '/' + apiEndpoint + '.json?fields=' + urlFields + (value ? '&filter=displayName:ilike:' + value : '') + '&order=' + sortField + ':' + getDirection(keepDir);
	
	        var filterParam = getFilterUrlParam(filtersComboBox.value);
	
	        if (filterParam) {
	            url += '&filter=' + filterParam;
	        }
	
	        return url;
	    };
	
	    favoriteStore = Ext.create('Ext.data.Store', {
	        fields: storeFields.split(','),
	        proxy: {
	            type: 'ajax',
	            reader: {
	                type: 'json',
	                root: apiEndpoint
	            },
	            startParam: false,
	            limitParam: false
	        },
	        isLoaded: false,
	        pageSize: 10,
	        page: 1,
	        defaultUrl: apiPath + '/' + apiEndpoint + '.json?fields=' + urlFields + '&order=name:asc',
	        loadStore: function loadStore(url) {
	            this.proxy.url = encodeURI(url || this.defaultUrl);
	
	            this.load({
	                params: {
	                    pageSize: this.pageSize,
	                    page: this.page
	                }
	            });
	        },
	        loadFn: function loadFn(fn) {
	            if (this.isLoaded) {
	                fn.call();
	            } else {
	                this.load(fn);
	            }
	        },
	        get: function get(field, value) {
	            var index = this.findExact(field, value);
	            return index === -1 ? null : this.getAt(index);
	        },
	        listeners: {
	            load: function load(store, records) {
	                if (!this.isLoaded) {
	                    this.isLoaded = true;
	                }
	
	                // pager
	                var pager = store.proxy.reader.jsonData.pager;
	
	                info.setText('Page ' + pager.page + ' of ' + pager.pageCount);
	
	                prevButton.enable();
	                nextButton.enable();
	
	                if (pager.page === 1) {
	                    prevButton.disable();
	                }
	
	                if (pager.page === pager.pageCount) {
	                    nextButton.disable();
	                }
	            }
	        }
	    });
	
	    filtersStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: [{ id: 'SHOW_ALL', name: i18n.show_all }, { id: 'CREATED_BY_ME', name: i18n.created_by_me }, { id: 'CREATED_BY_OTHERS', name: i18n.created_by_others }]
	    });
	
	    getFilterUrlParam = function getFilterUrlParam(filterId) {
	        switch (filterId) {
	            case 'SHOW_ALL':
	                return null;
	            case 'CREATED_BY_ME':
	                return 'user.id:eq:' + appManager.userAccount.id;
	            case 'CREATED_BY_OTHERS':
	                return 'user.id:neq:' + appManager.userAccount.id;
	            default:
	                return null;
	        }
	    };
	
	    textfieldKeyUpHandlers = {
	        search: function search(cmp, e) {
	            var t = cmp,
	                value = Ext.isString(value) ? value : t.getValue();
	
	            if (action === 'open' && e.keyCode === 13 && favoriteStore.getRange().length) {
	                favoriteWindow.destroy();
	                instanceManager.getById(favoriteStore.getAt(0).data.id);
	            }
	
	            if (value !== t.currentValue) {
	                t.currentValue = value;
	
	                favoriteStore.page = 1;
	                favoriteStore.loadStore(getStoreUrl(null, true));
	            }
	        }
	    };
	
	    showFavoritesLink = Ext.create('Ext.form.Label', {
	        text: i18n.show_favorites,
	        style: 'color:#226aba',
	        nextAction: 'hide',
	        textMap: {
	            hide: i18n.hide_favorites,
	            show: i18n.show_favorites
	        },
	        toggle: function toggle() {
	            var t = this;
	
	            cmpToToggle.forEach(function (cmp) {
	                cmp[t.nextAction]();
	            });
	
	            this.nextAction = this.nextAction === 'hide' ? 'show' : 'hide';
	
	            this.setText(this.textMap[this.nextAction]);
	        },
	        listeners: {
	            render: function render(cmp) {
	                var t = this,
	                    el = this.getEl();
	
	                el.setStyle('cursor', 'pointer');
	
	                el.on('click', function () {
	                    t.toggle();
	                });
	            }
	        }
	    });
	
	    showFavoritesLinkCt = Ext.create('Ext.container.Container', {
	        width: _FavoriteStyle2.default.windowCmpWidth,
	        style: 'text-align:right; padding-right:7px; padding-bottom:4px',
	        items: showFavoritesLink
	    });
	
	    searchTextfield = Ext.create('Ext.form.field.Text', {
	        width: _FavoriteStyle2.default.windowCmpWidth - _FavoriteStyle2.default.filtersComboBoxWidth,
	        height: 27,
	        style: 'margin-bottom: 1px; display: inline-block',
	        fieldStyle: _FavoriteStyle2.default.textfieldStyle.concat(['color: #333']).join(';'),
	        emptyText: i18n.search_for_favorites + '..',
	        enableKeyEvents: true,
	        currentValue: '',
	        listeners: {
	            keyup: {
	                fn: function fn(cmp, e) {
	                    textfieldKeyUpHandlers['search'](cmp, e);
	                },
	                buffer: 100
	            }
	        }
	    });
	    cmpToToggle.push(searchTextfield);
	
	    filtersComboBox = Ext.create('Ext.form.field.ComboBox', {
	        width: _FavoriteStyle2.default.filtersComboBoxWidth,
	        height: 27,
	        style: 'display: inline-block; top: 7px; right: 5px',
	        fieldLabel: 'Filter',
	        labelWidth: 30,
	        store: filtersStore,
	        displayField: 'name',
	        valueField: 'id',
	        value: 'SHOW_ALL',
	        editable: false,
	        listeners: {
	            select: function select(_ref) {
	                var value = _ref.value;
	
	                var url = getStoreUrl(null, true, [getFilterUrlParam(value)]),
	                    store = favoriteStore;
	
	                store.page = store.page <= 1 ? 1 : store.page - 1;
	                store.loadStore(url);
	            }
	        }
	    });
	    cmpToToggle.push(filtersComboBox);
	
	    saveButton = Ext.create('Ext.button.Button', {
	        text: i18n.save,
	        // DHIS2-1147: avoid server conflict error when name value is not set
	        disabled: true,
	        xable: function xable() {
	            this.setDisabled(!nameTextField.getValue());
	        },
	        handler: function handler() {
	            saveButtonHandler();
	        }
	    });
	
	    saveButtonHandler = function saveButtonHandler() {
	        var name = nameTextField.getValue();
	
	        // DHIS2-1147: avoid submitting when no name is available
	        if (!name) {
	            return;
	        }
	
	        var currentLayout = instanceManager.getStateCurrent(),
	            id = instanceManager.getStateFavoriteId(),
	            description = descriptionTextField.getValue();
	
	        var preXhr = function preXhr() {
	            favoriteWindow.destroy();
	        };
	
	        var fn = function fn(id, success, r) {
	            currentLayout.id = id || currentLayout.id;
	            instanceManager.getById(currentLayout.id, function (layout, isFavorite) {
	                instanceManager.getReport(layout, isFavorite, false, false, function () {
	                    uiManager.unmask();
	                });
	            });
	        };
	
	        currentLayout.apply({
	            id: id,
	            name: name,
	            description: description
	        }, ['id', 'name', 'description']);
	
	        // search for a favorite with the same name
	        // and ask confirmation for replacing it
	        var request = new c.api.Request(c, {
	            baseUrl: apiPath + '/' + apiEndpoint + '.json?fields=id&filter=displayName:eq:' + name,
	            type: 'ajax',
	            method: 'GET',
	            success: function success(obj, _success, r) {
	                if (obj && obj.pager.total > 0 && obj[apiEndpoint].length) {
	                    uiManager.confirmReplace(i18n.save_favorite, function () {
	                        preXhr();
	                        currentLayout.clone().put(obj[apiEndpoint][0].id, fn, true, true);
	                    });
	                } else {
	                    preXhr();
	                    currentLayout.clone().post(fn, true, true);
	                }
	            }
	        });
	
	        request.run();
	    };
	
	    prevButton = Ext.create('Ext.button.Button', {
	        text: i18n.prev,
	        handler: function handler() {
	            var url = getStoreUrl(null, true),
	                store = favoriteStore;
	
	            store.page = store.page <= 1 ? 1 : store.page - 1;
	            store.loadStore(url);
	        }
	    });
	    cmpToToggle.push(prevButton);
	
	    nextButton = Ext.create('Ext.button.Button', {
	        text: i18n.next,
	        handler: function handler() {
	            var url = getStoreUrl(null, true),
	                store = favoriteStore;
	
	            store.page = store.page + 1;
	            store.loadStore(url);
	        }
	    });
	    cmpToToggle.push(nextButton);
	
	    info = Ext.create('Ext.form.Label', {
	        cls: 'ns-label-info',
	        width: 300,
	        height: 22
	    });
	    cmpToToggle.push(info);
	
	    gridHeaders = (0, _GridHeaders.GridHeaders)({
	        width: _FavoriteStyle2.default.windowCmpWidth,
	        height: 21,
	        direction: 'asc',
	        getDirection: function getDirection() {},
	        items: [{
	            text: i18n.name,
	            textAlign: 'left',
	            width: nameColWidth,
	            height: 20,
	            handler: function handler() {
	                var url = getStoreUrl('name'),
	                    store = favoriteStore;
	
	                store.page = 1;
	                store.loadStore(url);
	            }
	        }, {
	            text: i18n.created,
	            textAlign: 'left',
	            width: _FavoriteStyle2.default.createdColWidth,
	            height: 20,
	            direction: 'asc',
	            handler: function handler() {
	                var url = getStoreUrl('created'),
	                    store = favoriteStore;
	
	                store.page = 1;
	                store.loadStore(url);
	            }
	        }, {
	            text: i18n.last_updated,
	            textAlign: 'left',
	            width: _FavoriteStyle2.default.lastUpdatedColWidth,
	            height: 20,
	            direction: 'asc',
	            handler: function handler() {
	                var url = getStoreUrl('lastUpdated'),
	                    store = favoriteStore;
	
	                store.page = 1;
	                store.loadStore(url);
	            }
	        }]
	    });
	    cmpToToggle.push(gridHeaders);
	
	    renderers = {
	        open: function open(value, metaData, record) {
	            var fn = function fn() {
	                var element = Ext.get(record.data.id);
	
	                if (element) {
	                    element = element.parent('td');
	                    element.addClsOnOver('link');
	                    element.load = function () {
	                        favoriteWindow.destroy();
	                        instanceManager.getById(record.data.id);
	                    };
	                    element.handler = function () {
	                        if (instanceManager.isStateUnsaved()) {
	                            uiManager.confirmUnsaved(i18n.open, function () {
	                                element.load();
	                            });
	                        } else {
	                            element.load();
	                        }
	                    };
	                    element.dom.setAttribute('onclick', 'Ext.get(this).handler();');
	                }
	            };
	
	            Ext.defer(fn, 100);
	
	            return '<div id="' + record.data.id + '">' + value + '</div>';
	        },
	        saveas: function saveas(value, metaData, record) {
	            var fn = function fn() {
	                var element = Ext.get(record.data.id);
	
	                if (element) {
	                    element = element.parent('td');
	                    element.handler = function () {
	                        nameTextField.setValue(record.data.name);
	                        descriptionTextField.setValue(record.data.description);
	                    };
	                    element.dom.setAttribute('onclick', 'Ext.get(this).handler();');
	                }
	            };
	
	            Ext.defer(fn, 100);
	
	            return '<div id="' + record.data.id + '">' + value + '</div>';
	        }
	    };
	
	    windowBbarSeparator = Ext.create('Ext.toolbar.Separator', {
	        height: 20,
	        style: 'border-color:transparent; border-right-color:#d1d1d1; margin-right:4px'
	    });
	    cmpToToggle.push(windowBbarSeparator);
	
	    windowBbar = function () {
	        var items = [];
	
	        items.push(info, '->', prevButton, nextButton);
	
	        if (action === 'saveas') {
	            items.push(' ', windowBbarSeparator, ' ', saveButton);
	        }
	
	        return items;
	    }();
	
	    grid = Ext.create('Ext.grid.Panel', {
	        cls: 'ns-grid',
	        scroll: false,
	        hideHeaders: true,
	        columns: [{
	            dataIndex: 'name',
	            sortable: true,
	            width: nameColWidth,
	            renderer: renderers[action]
	        }, {
	            dataIndex: 'created',
	            sortable: true,
	            width: _FavoriteStyle2.default.createdColWidth,
	            renderer: function renderer(value) {
	                return (value || '').substring(0, 16).split('T').join(', ');
	            }
	        }, {
	            dataIndex: 'lastUpdated',
	            sortable: true,
	            width: _FavoriteStyle2.default.lastUpdatedColWidth,
	            renderer: function renderer(value) {
	                return (value || '').substring(0, 16).split('T').join(', ');
	            }
	        }, {
	            xtype: 'actioncolumn',
	            sortable: false,
	            width: _FavoriteStyle2.default.buttonColWidth,
	            items: [{
	                iconCls: 'ns-grid-row-icon-edit',
	                getClass: function getClass(value, metaData, record) {
	                    return 'tooltip-favorite-edit' + (!record.data.access.update ? ' disabled' : '');
	                },
	                handler: function handler(grid, rowIndex, colIndex, col, event) {
	                    var record = this.up('grid').store.getAt(rowIndex),
	                        x = event.target.x - nameColWidth - _FavoriteStyle2.default.lastUpdatedColWidth - _FavoriteStyle2.default.borderWidth + 6,
	                        y = event.target.y - 34,
	                        layoutObj = {
	                        id: record.data.id,
	                        name: record.data.name,
	                        description: record.data.description
	                    },
	                        listeners = {},
	                        fn;
	
	                    if (record.data.access.update) {
	                        fn = function fn() {
	                            favoriteStore.loadStore(getStoreUrl(null, true));
	                        };
	
	                        listeners.show = function () {
	                            favoriteWindow.destroyOnBlur = false;
	                        };
	
	                        listeners.destroy = function () {
	                            favoriteWindow.destroyOnBlur = true;
	                        };
	
	                        nameWindow = (0, _RenameWindow.RenameWindow)(c, layoutObj, fn, listeners);
	                        nameWindow.showAt(x, y);
	                    }
	                }
	            }, {
	                iconCls: 'ns-grid-row-icon-sharing',
	                getClass: function getClass(value, metaData, record) {
	                    return 'tooltip-favorite-sharing' + (!record.data.access.manage ? ' disabled' : '');
	                },
	                handler: function handler(grid, rowIndex) {
	                    var record = this.up('grid').store.getAt(rowIndex);
	
	                    if (record.data.access.manage) {
	                        instanceManager.getSharingById(record.data.id, function (r) {
	                            (0, _SharingWindow.SharingWindow)(c, r).show();
	                        });
	                    }
	                }
	            }, {
	                iconCls: 'ns-grid-row-icon-delete',
	                getClass: function getClass(value, metaData, record) {
	                    return 'tooltip-favorite-delete' + (!record.data.access['delete'] ? ' disabled' : '');
	                },
	                handler: function handler(grid, rowIndex, colIndex, col, event) {
	                    var record = this.up('grid').store.getAt(rowIndex),
	                        id = record.data.id,
	                        message;
	
	                    if (record.data.access['delete']) {
	                        uiManager.confirmDelete(i18n.delete_favorite, function () {
	                            instanceManager.delById(id, function () {
	                                // DHIS2-1475: preserve the filter when reloading the favorite list
	                                favoriteStore.loadStore(getStoreUrl(null, true));
	
	                                if (id === instanceManager.getStateFavoriteId()) {
	                                    instanceManager.setState();
	                                }
	                            }, true, true);
	                        });
	                    }
	                }
	            }]
	        }, {
	            sortable: false,
	            width: _FavoriteStyle2.default.paddingColWidth
	        }],
	        store: favoriteStore,
	        listeners: {
	            render: function render() {
	                var size = Math.floor((uiManager.getHeight() - 330) / uiConfig.grid_row_height);
	                this.store.pageSize = size;
	                this.store.page = 1;
	                this.store.loadStore();
	
	                favoriteStore.on('load', function () {
	                    if (this.isVisible()) {
	                        this.fireEvent('afterrender');
	                    }
	                }, this);
	            },
	            afterrender: function afterrender() {
	                var fn = function fn() {
	                    var editArray = Ext.query('.tooltip-favorite-edit'),
	                        sharingArray = Ext.query('.tooltip-favorite-sharing'),
	                        deleteArray = Ext.query('.tooltip-favorite-delete'),
	                        el;
	
	                    for (var i = 0; i < editArray.length; i++) {
	                        var el = editArray[i];
	                        Ext.create('Ext.tip.ToolTip', {
	                            target: el,
	                            html: i18n.rename,
	                            'anchor': 'bottom',
	                            anchorOffset: -14,
	                            showDelay: 1000
	                        });
	                    }
	
	                    for (var i = 0; i < sharingArray.length; i++) {
	                        el = sharingArray[i];
	                        Ext.create('Ext.tip.ToolTip', {
	                            target: el,
	                            html: i18n.share_with_other_people,
	                            'anchor': 'bottom',
	                            anchorOffset: -14,
	                            showDelay: 1000
	                        });
	                    }
	
	                    for (var i = 0; i < deleteArray.length; i++) {
	                        el = deleteArray[i];
	                        Ext.create('Ext.tip.ToolTip', {
	                            target: el,
	                            html: i18n.delete_,
	                            'anchor': 'bottom',
	                            anchorOffset: -14,
	                            showDelay: 1000
	                        });
	                    }
	                };
	
	                Ext.defer(fn, 100);
	            },
	            itemmouseenter: function itemmouseenter(grid, record, item) {
	                this.currentItem = Ext.get(item);
	                this.currentItem.removeCls('x-grid-row-over');
	            },
	            select: function select() {
	                if (action === 'open') {
	                    this.currentItem.removeCls('x-grid-row-selected');
	                }
	            },
	            selectionchange: function selectionchange() {
	                this.currentItem.removeCls('x-grid-row-focused');
	            },
	            itemdblclick: function itemdblclick() {
	                if (action === 'saveas') {
	                    saveButtonHandler();
	                }
	            }
	        }
	    });
	    cmpToToggle.push(grid);
	
	    titles = {
	        open: i18n.open_favorite,
	        saveas: i18n.save_favorite_as
	    };
	
	    windowItems = function () {
	        var items = [];
	
	        if (action === 'saveas') {
	            items.push(nameTextField, descriptionTextField, showFavoritesLinkCt);
	        }
	
	        items.push(searchTextfield, filtersComboBox, gridHeaders, grid);
	
	        return items;
	    }();
	
	    favoriteWindow = Ext.create('Ext.window.Window', {
	        title: titles[action],
	        bodyStyle: 'padding:1px; background-color:#fff',
	        resizable: false,
	        modal: true,
	        width: _FavoriteStyle2.default.windowWidth,
	        destroyOnBlur: true,
	        items: windowItems,
	        bbar: windowBbar,
	        listeners: {
	            show: function show(w) {
	                var favoriteButton = uiManager.get('favoriteButton') || {};
	
	                if (favoriteButton.rendered) {
	                    uiManager.setAnchorPosition(w, favoriteButton);
	
	                    if (!w.hasDestroyOnBlurHandler) {
	                        uiManager.addDestroyOnBlurHandler(w);
	                    }
	                }
	
	                (action === 'open' ? searchTextfield : nameTextField).focus(false, 500);
	
	                if (action === 'saveas') {
	                    showFavoritesLink.toggle();
	                }
	            },
	            destroy: function destroy(w) {
	                uiManager.unreg('favoriteWindow');
	            }
	        }
	    });
	
	    nameTextField.setEventKeyUpHandler(saveButtonHandler);
	    // DHIS2-1147: enable Save button on name value change
	    nameTextField.setEventChangeHandler(function () {
	        saveButton.xable();
	    });
	
	    return favoriteWindow;
	};
	//# sourceMappingURL=FavoriteWindow.js.map

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RenameWindow = undefined;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _FavoriteTextCmp = __webpack_require__(36);
	
	var _FavoriteTextCmp2 = _interopRequireDefault(_FavoriteTextCmp);
	
	var _FavoriteStyle = __webpack_require__(24);
	
	var _FavoriteStyle2 = _interopRequireDefault(_FavoriteStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RenameWindow = exports.RenameWindow = undefined;
	
	exports.RenameWindow = RenameWindow = function RenameWindow(refs, layout, fn, listeners) {
	    var t = this,
	        appManager = refs.appManager,
	        uiManager = refs.uiManager,
	        instanceManager = refs.instanceManager,
	        i18n = refs.i18nManager.get(),
	        uiConfig = refs.uiConfig,
	        api = refs.api,
	        apiPath = appManager.getApiPath(),
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    listeners = listeners || {};
	
	    var _getFavoriteTextCmp = (0, _FavoriteTextCmp2.default)({ layout: layout, i18n: i18n }),
	        nameTextField = _getFavoriteTextCmp.nameTextField,
	        descriptionTextField = _getFavoriteTextCmp.descriptionTextField;
	
	    var renameButton = Ext.create('Ext.button.Button', {
	        text: i18n.update,
	        handler: function handler() {
	            var name = nameTextField.getValue(),
	                description = descriptionTextField.getValue(),
	                patch = function patch() {
	                var properties = {
	                    name: name,
	                    description: description
	                };
	
	                layout.apply(properties);
	
	                layout.patch(properties, function () {
	                    if (fn) {
	                        fn();
	                    }
	                    instanceManager.getById(null, function (layout, isFavorite) {
	                        instanceManager.getReport(layout, isFavorite, false, false, function () {
	                            uiManager.unmask();
	                        });
	                    });
	                    window.destroy();
	                }, true, true);
	            };
	
	            if (layout.patch) {
	                patch();
	            } else {
	                var fields = appManager.getAnalysisFields(),
	                    url = apiPath + '/' + apiEndpoint + '/' + layout.id + '.json?fields=' + fields;
	
	                $.getJSON(encodeURI(url), function (r) {
	                    layout = new api.Layout(refs, r).val();
	                    patch();
	                });
	            }
	        }
	    });
	
	    var cancelButton = Ext.create('Ext.button.Button', {
	        text: i18n.cancel,
	        handler: function handler() {
	            window.destroy();
	        }
	    });
	
	    var window = Ext.create('Ext.window.Window', {
	        title: id ? 'Rename favorite' : 'Create new favorite',
	        bodyStyle: 'padding:1px; background:#fff',
	        resizable: false,
	        modal: true,
	        items: [nameTextField, descriptionTextField],
	        destroyOnBlur: true,
	        bbar: [cancelButton, '->', renameButton],
	        listeners: {
	            show: function show(w) {
	                var favoriteButton = uiManager.get('favoriteButton') || {};
	
	                if (favoriteButton.rendered) {
	                    uiManager.setAnchorPosition(w, favoriteButton);
	
	                    if (!w.hasDestroyOnBlurHandler) {
	                        uiManager.addDestroyOnBlurHandler(w);
	                    }
	                }
	
	                nameTextField.focus(false, 500);
	
	                if (listeners.show) {
	                    listeners.show();
	                }
	            },
	            destroy: function destroy() {
	                if (listeners.destroy) {
	                    listeners.destroy();
	                }
	            }
	        }
	    });
	
	    return window;
	};
	//# sourceMappingURL=RenameWindow.js.map

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayDifference;
	
	var _arrayUnique = __webpack_require__(12);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param {Array} array1
	 * @param {Array} array2
	 * @param {boolean} biDirectional False returns A-B while true returns A-B concat B-A
	 * @returns {Array}
	 *
	 * @throws {TypeError} When `filter` can not be found on `array`. This generally happens when the array is `null` or `undefined`
	 *
	 * @example
	 * const a = [1, 2];
	 * const b = [1, 3];
	 * difference(a, b) // returns: [2]
	 * difference(a, b, true) // returns: [2, 3]
	 */
	function arrayDifference(array1, array2, biDirectional) {
	    return (0, _arrayUnique2.default)(array1.filter(function (item) {
	        return !(0, _arrayContains2.default)(array2, item);
	    }).concat(biDirectional === true ? array2.filter(function (item) {
	        return !(0, _arrayContains2.default)(array1, item);
	    }) : []));
	}
	//# sourceMappingURL=arrayDifference.js.map

/***/ },
/* 40 */
4,
/* 41 */
13,
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 43 */
[570, 69],
/* 44 */
/***/ function(module, exports) {

	/**
	 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @type Function
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(54)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(33)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(89);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(15)
	  , core      = __webpack_require__(20)
	  , hide      = __webpack_require__(33)
	  , redefine  = __webpack_require__(103)
	  , ctx       = __webpack_require__(47)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 50 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(50)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(95);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 53 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(104)('wks')
	  , uid        = __webpack_require__(53)
	  , Symbol     = __webpack_require__(15).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Dimension = undefined;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayPluck = __webpack_require__(27);
	
	var _arrayPluck2 = _interopRequireDefault(_arrayPluck);
	
	var _arrayUnique = __webpack_require__(12);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUIRED_DIMENSIONS = ['dx', 'pe', 'ou'];
	
	var Dimension = exports.Dimension = undefined;
	
	exports.Dimension = Dimension = function Dimension(refs, config) {
	    var t = this;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	    config.items = (0, _arrayFrom2.default)(config.items);
	
	    var Record = refs.api.Record;
	
	    // constructor
	
	    t.dimension = config.dimension;
	
	    t.items = config.items.map(function (record) {
	        return new Record(refs, record).val();
	    });
	
	    if (config.sorted) {
	        t.sorted = config.sorted;
	    }
	
	    t.getRefs = function () {
	        return refs;
	    };
	};
	
	Dimension.prototype.log = function (text, noError) {
	    if (!noError) {
	        console.log(text, this);
	    }
	};
	
	Dimension.prototype.val = function (noError) {
	
	    // error
	    if (!(0, _isString2.default)(this.dimension)) {
	        this.log('(Dimension) Dimension is not a string', noError);
	        return null;
	    }
	
	    // warning
	    if (!this.items.length && !(0, _arrayContains2.default)(['co', 'dy', 'longitude', 'latitude'], this.dimension)) {//todo use centralised keys
	        //this.log('(Dimension) No items', noError);
	        //return null;
	    }
	
	    return this;
	};
	
	Dimension.prototype.add = function (recordConfig) {
	    var t = this,
	        refs = t.getRefs();
	
	    var Record = refs.api.Record;
	
	
	    var record = new Record(refs, recordConfig).val();
	
	    if (record) {
	        this.items.push(record);
	    }
	};
	
	Dimension.prototype.getRecords = function (sortProperty, response, isPure) {
	    var records = response ? response.getRecordsByDimensionName(this.dimension) : this.items;
	
	    if (isPure) {
	        records = records.slice(0);
	    }
	
	    sortProperty = (0, _arrayContains2.default)(['id', 'name'], sortProperty) ? sortProperty : null;
	
	    return sortProperty ? records.sort(function (a, b) {
	        return a[sortProperty] > b[sortProperty];
	    }) : records;
	};
	
	Dimension.prototype.removeItems = function () {
	    this.items = [];
	};
	
	Dimension.prototype.isRequired = function () {
	    return (0, _arrayContains2.default)(REQUIRED_DIMENSIONS, this.dimension);
	};
	
	// dep 1
	
	Dimension.prototype.getRecordIds = function (isSorted, response, isPure) {
	    var rec = this.getRecords(isSorted ? 'id' : null, response, isPure);
	
	    return (0, _arrayPluck2.default)(rec, 'id');
	};
	
	Dimension.prototype.getRecordNames = function (isSorted, response, isPure) {
	    return (0, _arrayPluck2.default)(this.getRecords(isSorted ? 'name' : null, response, isPure), 'name');
	};
	
	Dimension.prototype.extendRecords = function (response) {
	    var t = this;
	
	    var records = t.getRecords();
	
	    records.forEach(function (record) {
	        record.setName(null, response);
	    });
	
	    return records;
	};
	
	Dimension.prototype.toPlugin = function () {
	    delete this.klass;
	
	    this.items.forEach(function (record) {
	        record.toPlugin();
	    });
	};
	
	Dimension.prototype.toPost = function () {
	    delete this.klass;
	
	    this.items.forEach(function (record) {
	        record.toPost();
	    });
	};
	
	// dep 2
	
	Dimension.prototype.url = function (isSorted, response, isFilter) {
	    var url = (isFilter ? 'filter' : 'dimension') + '=' + this.dimension,
	        records = (0, _arrayUnique2.default)(this.getRecordIds(isSorted, response, true));
	
	    url += records.length ? ':' + records.join(';') : '';
	
	    return url;
	};
	//# sourceMappingURL=Dimension.js.map

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Period = undefined;
	
	var _isNumeric = __webpack_require__(18);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayUnique = __webpack_require__(12);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	var _stringTrim = __webpack_require__(185);
	
	var _stringTrim2 = _interopRequireDefault(_stringTrim);
	
	var _numberConstrain = __webpack_require__(65);
	
	var _numberConstrain2 = _interopRequireDefault(_numberConstrain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Period = exports.Period = undefined;
	
	exports.Period = Period = function Period(config, refs) {
	    var t = this;
	
	    t.id = '' + config.id;
	    t.name = config.name;
	
	    // constants
	    t.yearOffset = 5;
	
	    // transient
	    t.year = t.id.slice(0, 4);
	    t.offset = parseInt(t.year) - new Date().getFullYear();
	    t.generator = refs.calendarManager.periodGenerator;
	
	    t.i18n = refs.i18nManager.get();
	
	    // uninitialized
	    t.sortId;
	
	    t.typeSortId;
	    t.typeName;
	
	    t.displayName;
	
	    t.getContextMenuItemsConfig;
	};
	
	Period.prototype.getPrefixedNumber = function (number) {
	    return parseInt(number) < 10 ? '0' + number : number;
	};
	
	Period.prototype.getNameByIdAndType = function (type, id, year) {
	    var t = this;
	
	    year = year || this.year;
	
	    var offset = parseInt(year) - new Date().getFullYear(),
	        periods = t.generator.generateReversedPeriods(type, offset);
	
	    for (var i = 0; i < periods.length; i++) {
	        if (periods[i].iso === id) {
	            return periods[i].name;
	        }
	    }
	};
	
	Period.prototype.getItemifiedPeriods = function (periods) {
	    var items = [];
	
	    periods = (0, _arrayFrom2.default)(periods);
	
	    for (var i = 0; i < periods.length; i++) {
	        items.push({
	            id: periods[i].iso,
	            name: periods[i].name
	        });
	    }
	
	    return items;
	};
	
	Period.prototype.gen = function (type, offset) {
	    return this.generator.generatePeriods(type, offset);
	};
	
	Period.prototype.genRev = function (type, offset) {
	    return this.generator.generateReversedPeriods(type, offset);
	};
	
	Period.prototype.getTypeById = function (id) {
	    if (!(0, _isNumeric2.default)(id.slice(0, 4))) {
	        return;
	    }
	
	    if (id.length === 4) {
	        return 'Yearly';
	    } else if ((0, _arrayContains2.default)([6, 7], id.length)) {
	        if ((0, _isNumeric2.default)(id)) {
	            return 'Monthly';
	        } else if (id.indexOf('W') !== -1) {
	            return 'Weekly';
	        } else if (id.indexOf('Q') !== -1) {
	            return 'Quarterly';
	        } else if (id.indexOf('S') !== -1) {
	            return 'SixMonthly';
	        } else if (id.indexOf('B') !== -1) {
	            return 'BiMonthly';
	        } else if (id.indexOf('Oct') !== -1) {
	            return 'FinancialOct';
	        }
	    } else if (id.length === 8) {
	        if ((0, _isNumeric2.default)(id.slice(4, 8))) {
	            return 'Daily';
	        } else if (id.indexOf('July') !== -1) {
	            return 'FinancialJuly';
	        }
	    } else if (id.length === 9) {
	        if (id.indexOf('April') !== -1) {
	            return 'FinancialApril';
	        }
	    } else if (id.length === 11) {
	        if (id.indexOf('AprilS') !== -1) {
	            return 'SixMonthlyApril';
	        }
	    }
	};
	
	Period.prototype.getNameByParents = function (parents, defaultName) {
	    if (parents.length !== 1 || parents[0].name === undefined) {
	        return defaultName;
	    }
	
	    return defaultName + ' (' + parents[0].name + ')';
	};
	
	// dep 1
	
	Period.prototype.getItemsByTypeByFinancialApril = function (type, isAll) {
	    var startDate = this.year + '-04-01';
	    var endDate = parseInt(this.year) + 1 + '-03-31';
	    var startMonth = this.year + '-04';
	    var endMonth = parseInt(this.year) + 1 + '-04';
	
	    // used by daily, weekly, monthly
	    var thisPeriods = this.gen(type, this.offset);
	    var thisSliceStartIndex;
	    var nextPeriods = this.gen(type, this.offset + 1);
	    var nextSliceEndIndex;
	
	    var thisYear;
	    var nextYear;
	
	    if (type === 'FinancialApril') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset - 1 + this.yearOffset).slice(0, 2));
	        }
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 1));
	    } else if (type === 'FinancialJuly') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset - 1 + this.yearOffset).slice(0, 2));
	    } else if (type === 'FinancialOct') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset - 1 + this.yearOffset).slice(0, 2));
	    } else if (type === 'Yearly') {
	        thisYear = this.gen(type, this.offset + this.yearOffset)[0];
	        nextYear = this.gen(type, this.offset + 1 + this.yearOffset)[0];
	
	        return this.getItemifiedPeriods([thisYear, nextYear]);
	    } else if (type === 'SixMonthlyApril') {
	        return this.getItemifiedPeriods(thisPeriods);
	    } else if (type === 'SixMonthly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods, nextPeriods.slice(0, 1)));
	    } else if (type === 'Quarterly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(1), nextPeriods.slice(0, 1)));
	    } else if (type === 'BiMonthly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(1), nextPeriods.slice(0, 2)));
	    } else if (type === 'Monthly') {
	        for (var i = 0, month; i < thisPeriods.length; i++) {
	            month = thisPeriods[i];
	
	            if (month.startDate.slice(0, 7) === startMonth) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, month; j < nextPeriods.length; j++) {
	            month = nextPeriods[j];
	
	            if (month.startDate.slice(0, 7) === endMonth) {
	                nextSliceEndIndex = j;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    } else if (type === 'Weekly') {
	        for (var i = 0, week; i < thisPeriods.length; i++) {
	            week = thisPeriods[i];
	
	            if (week.startDate.slice(0, 7) === startMonth || week.endDate.slice(0, 7) === startMonth) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, week; j < nextPeriods.length; j++) {
	            week = nextPeriods[j];
	
	            if (week.startDate.slice(0, 7) === endMonth && week.endDate.slice(0, 7) === endMonth) {
	                nextSliceEndIndex = j;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    } else if (type === 'Daily') {
	        for (var i = 0, day; i < thisPeriods.length; i++) {
	            if (thisPeriods[i].startDate === startDate) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, day; j < nextPeriods.length; j++) {
	            if (nextPeriods[j].endDate === endDate) {
	                nextSliceEndIndex = j + 1;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByFinancialJuly = function (type, isAll) {
	    var startDate = this.year + '-07-01';
	    var endDate = parseInt(this.year) + 1 + '-06-30';
	    var startMonth = this.year + '-07';
	    var endMonth = parseInt(this.year) + 1 + '-07';
	
	    // used by daily, weekly, monthly
	    var thisPeriods = this.gen(type, this.offset);
	    var thisSliceStartIndex;
	    var nextPeriods = this.gen(type, this.offset + 1);
	    var nextSliceEndIndex;
	
	    var thisYear;
	    var nextYear;
	
	    if (type === 'FinancialApril') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 2));
	    } else if (type === 'FinancialJuly') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset - 1 + this.yearOffset).slice(0, 2));
	        }
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 1));
	    } else if (type === 'FinancialOct') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset - 1 + this.yearOffset).slice(0, 2));
	    } else if (type === 'Yearly') {
	        thisYear = this.gen(type, this.offset + this.yearOffset)[0];
	        nextYear = this.gen(type, this.offset + 1 + this.yearOffset)[0];
	
	        return this.getItemifiedPeriods([thisYear, nextYear]);
	    } else if (type === 'SixMonthlyApril') {
	        return this.getItemifiedPeriods([].concat(thisPeriods, nextPeriods.slice(0, 1)));
	    } else if (type === 'SixMonthly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(1), nextPeriods.slice(0, 1)));
	    } else if (type === 'Quarterly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(2), nextPeriods.slice(0, 2)));
	    } else if (type === 'BiMonthly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(3), nextPeriods.slice(0, 3)));
	    } else if (type === 'Monthly') {
	        for (var i = 0, month; i < thisPeriods.length; i++) {
	            month = thisPeriods[i];
	
	            if (month.startDate.slice(0, 7) === startMonth) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, month; j < nextPeriods.length; j++) {
	            month = nextPeriods[j];
	
	            if (month.startDate.slice(0, 7) === endMonth) {
	                nextSliceEndIndex = j;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    } else if (type === 'Weekly') {
	        for (var i = 0, week; i < thisPeriods.length; i++) {
	            week = thisPeriods[i];
	
	            if (week.startDate.slice(0, 7) === startMonth || week.endDate.slice(0, 7) === startMonth) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, week; j < nextPeriods.length; j++) {
	            week = nextPeriods[j];
	
	            if (week.startDate.slice(0, 7) === endMonth && week.endDate.slice(0, 7) === endMonth) {
	                nextSliceEndIndex = j;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    } else if (type === 'Daily') {
	        for (var i = 0, day; i < thisPeriods.length; i++) {
	            if (thisPeriods[i].startDate === startDate) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, day; j < nextPeriods.length; j++) {
	            if (nextPeriods[j].endDate === endDate) {
	                nextSliceEndIndex = j + 1;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByFinancialOct = function (type, isAll) {
	    var startDate = this.year + '-10-01';
	    var endDate = parseInt(this.year) + 1 + '-09-30';
	    var startMonth = this.year + '-10';
	    var endMonth = parseInt(this.year) + 1 + '-10';
	
	    // used by daily, weekly, monthly
	    var thisPeriods = this.gen(type, this.offset);
	    var thisSliceStartIndex;
	    var nextPeriods = this.gen(type, this.offset + 1);
	    var nextSliceEndIndex;
	
	    var thisYear;
	    var nextYear;
	
	    if (type === 'FinancialApril') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 2));
	    } else if (type === 'FinancialJuly') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 2));
	    } else if (type === 'FinancialOct') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset - 1 + this.yearOffset).slice(0, 2));
	        }
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 1));
	    } else if (type === 'Yearly') {
	        thisYear = this.gen(type, this.offset + this.yearOffset)[0];
	        nextYear = this.gen(type, this.offset + 1 + this.yearOffset)[0];
	
	        return this.getItemifiedPeriods([thisYear, nextYear]);
	    } else if (type === 'SixMonthlyApril') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(1), nextPeriods.slice(0, 1)));
	    } else if (type === 'SixMonthly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(1), nextPeriods));
	    } else if (type === 'Quarterly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(3), nextPeriods.slice(0, 3)));
	    } else if (type === 'BiMonthly') {
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(4), nextPeriods.slice(0, 5)));
	    } else if (type === 'Monthly') {
	        for (var i = 0, month; i < thisPeriods.length; i++) {
	            month = thisPeriods[i];
	
	            if (month.startDate.slice(0, 7) === startMonth) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, month; j < nextPeriods.length; j++) {
	            month = nextPeriods[j];
	
	            if (month.startDate.slice(0, 7) === endMonth) {
	                nextSliceEndIndex = j;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    } else if (type === 'Weekly') {
	        for (var i = 0, week; i < thisPeriods.length; i++) {
	            week = thisPeriods[i];
	
	            if (week.startDate.slice(0, 7) === startMonth || week.endDate.slice(0, 7) === startMonth) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, week; j < nextPeriods.length; j++) {
	            week = nextPeriods[j];
	
	            if (week.startDate.slice(0, 7) === endMonth && week.endDate.slice(0, 7) === endMonth) {
	                nextSliceEndIndex = j;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    } else if (type === 'Daily') {
	        for (var i = 0, day; i < thisPeriods.length; i++) {
	            if (thisPeriods[i].startDate === startDate) {
	                thisSliceStartIndex = i;
	            }
	        }
	
	        for (var j = 0, day; j < nextPeriods.length; j++) {
	            if (nextPeriods[j].endDate === endDate) {
	                nextSliceEndIndex = j + 1;
	            }
	        }
	
	        return this.getItemifiedPeriods([].concat(thisPeriods.slice(thisSliceStartIndex), nextPeriods.slice(0, nextSliceEndIndex)));
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByYear = function (type) {
	    if (type === 'FinancialOct') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset - 5).slice(0, 2));
	    } else if (type === 'FinancialJuly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset - 5).slice(0, 2));
	    } else if (type === 'FinancialApril') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset - 5).slice(0, 2));
	    } else if (type === 'Yearly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset - 5).slice(0, 1));
	    } else if (type === 'SixMonthlyApril') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    } else if (type === 'SixMonthly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    } else if (type === 'Quarterly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    } else if (type === 'BiMonthly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    } else if (type === 'Monthly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    } else if (type === 'Weekly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    } else if (type === 'Daily') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset));
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeBySixmonthApril = function (type, isAll) {
	    var sixmonthaprilStr = this.id.slice(10, 11),
	        sixmonthapril = parseInt(sixmonthaprilStr);
	
	    if (type === 'FinancialOct') {
	        offset = sixmonthapril === 1 ? -1 : 0;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, 1));
	    } else if (type === 'FinancialJuly') {
	        offset = sixmonthapril === 1 ? -1 : 0;
	        sliceEndIndex = offset === -1 ? 2 : 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'FinancialApril') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 1));
	    } else if (type === 'Yearly') {
	        var sliceEndIndex = sixmonthapril === 1 ? 1 : 2;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, sliceEndIndex));
	    } else if (type === 'SixMonthlyApril') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset - 1).slice(1, 2).concat(this.gen(type, this.offset)));
	        }
	
	        return this.getItemifiedPeriods([this.gen(type, this.offset)[sixmonthapril - 1]]);
	    } else if (type === 'SixMonthly') {
	        var offset = sixmonthapril === 1 ? 0 : 1;
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(1, 2).concat(this.gen(type, this.offset + offset).slice(0, 1)));
	    } else if (type === 'Quarterly') {
	        var quarters = [];
	
	        if (sixmonthapril === 1) {
	            quarters = quarters.concat(this.gen(type, this.offset).slice(1, 3));
	        } else {
	            quarters = quarters.concat(this.gen(type, this.offset).slice(3, 4));
	            quarters = quarters.concat(this.gen(type, this.offset + 1).slice(0, 1));
	        }
	
	        return this.getItemifiedPeriods(quarters);
	    } else if (type === 'BiMonthly') {
	        var bimonths = [];
	
	        if (sixmonthapril === 1) {
	            bimonths = bimonths.concat(this.gen(type, this.offset).slice(1, 5));
	        } else {
	            bimonths = bimonths.concat(this.gen(type, this.offset).slice(4, 6));
	            bimonths = bimonths.concat(this.gen(type, this.offset + 1).slice(0, 2));
	        }
	
	        return this.getItemifiedPeriods(bimonths);
	    } else if (type === 'Monthly') {
	        var months = [];
	
	        if (sixmonthapril === 1) {
	            months = months.concat(this.gen(type, this.offset).slice(3, 9));
	        } else {
	            months = months.concat(this.gen(type, this.offset).slice(9, 12));
	            months = months.concat(this.gen(type, this.offset + 1).slice(0, 3));
	        }
	
	        return this.getItemifiedPeriods(months);
	    } else if (type === 'Weekly') {
	        var allWeeks = this.gen(type, this.offset),
	            weeks = [];
	
	        if (sixmonthapril === 1) {
	            for (var i = 0, week, sm, em; i < allWeeks.length; i++) {
	                week = allWeeks[i];
	                sm = parseInt(week.startDate.substring(5, 7));
	                em = parseInt(week.endDate.substring(5, 7));
	
	                if ((0, _numberConstrain2.default)(sm, 4, 9) === sm || (0, _numberConstrain2.default)(em, 4, 9) === em) {
	                    weeks.push(week);
	                }
	            }
	        } else {
	            var allWeeksNext = this.gen(type, this.offset + 1),
	                sliceStartIndex,
	                sliceEndIndex;
	
	            // this year
	            for (var i = 0, week, sm, em; i < allWeeks.length; i++) {
	                week = allWeeks[i];
	                sm = parseInt(week.startDate.substring(5, 7));
	                em = parseInt(week.endDate.substring(5, 7));
	
	                if (sm === 10 || em === 10) {
	                    sliceStartIndex = i;
	                    break;
	                }
	            }
	
	            weeks = weeks.concat(allWeeks.slice(sliceStartIndex));
	
	            // next year
	            for (var i = 0, week, sm, em; i < allWeeksNext.length; i++) {
	                week = allWeeks[i];
	                sm = parseInt(week.startDate.substring(5, 7));
	                em = parseInt(week.endDate.substring(5, 7));
	
	                if (sm === 4 && em === 4) {
	                    sliceEndIndex = i - 1;
	                    break;
	                }
	            }
	
	            weeks = weeks.concat(allWeeksNext.slice(0, sliceEndIndex));
	        }
	
	        return this.getItemifiedPeriods(weeks);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            days = [];
	
	        if (sixmonthapril === 1) {
	            for (var i = 0, day, m; i < allDays.length; i++) {
	                day = allDays[i];
	                m = parseInt(day.startDate.substring(5, 7));
	
	                if ((0, _numberConstrain2.default)(m, 4, 9) === m) {
	                    days.push(day);
	                }
	            }
	        } else {
	            var allDaysNext = this.gen(type, this.offset + 1),
	                sliceStartIndex,
	                sliceEndIndex;
	
	            // this year
	            for (var i = 0, day, m; i < allDays.length; i++) {
	                day = allDays[i];
	                m = parseInt(day.startDate.substring(5, 7));
	
	                if (m === 10) {
	                    sliceStartIndex = i;
	                    break;
	                }
	            }
	
	            days = days.concat(allDays.slice(sliceStartIndex));
	
	            // next year
	            for (var i = 0, day, m; i < allDaysNext.length; i++) {
	                day = allDaysNext[i];
	                m = parseInt(day.startDate.substring(5, 7));
	
	                if (m === 4) {
	                    sliceEndIndex = i - 1;
	                    break;
	                }
	            }
	
	            days = days.concat(allDaysNext.slice(0, sliceEndIndex));
	        }
	
	        return this.getItemifiedPeriods(days);
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeBySixmonth = function (type, isAll) {
	    var sixmonthStr = this.id.slice(5, 6),
	        sixmonth = parseInt(sixmonthStr),
	        firstMonth = sixmonth === 1 ? 1 : 7,
	        lastMonth = sixmonth === 1 ? 6 : 12,
	        startIndex,
	        endIndex,
	        offset,
	        sliceEndIndex;
	
	    if (type === 'FinancialOct') {
	        offset = -1;
	        sliceEndIndex = sixmonth === 1 ? 1 : 2;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'FinancialJuly') {
	        offset = sixmonth === 1 ? -1 : 0;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, 1));
	    } else if (type === 'FinancialApril') {
	        offset = sixmonth === 1 ? -1 : 0;
	        sliceEndIndex = sixmonth === 1 ? 2 : 1;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'Yearly') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset).slice(0, 1));
	    } else if (type === 'SixMonthlyApril') {
	        var allSixmonthaprils = this.gen(type, this.offset),
	            this1 = allSixmonthaprils[0],
	            this2 = allSixmonthaprils[1],
	            prev = this.gen(type, this.offset - 1)[1],
	            sixmonthaprils = [];
	
	        if (sixmonth === 1) {
	            sixmonthaprils.push(prev, this1);
	        } else if (sixmonth === 2) {
	            sixmonthaprils.push(this1, this2);
	        }
	
	        return this.getItemifiedPeriods(sixmonthaprils);
	    } else if (type === 'SixMonthly') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset));
	        }
	
	        return this.getItemifiedPeriods([this.gen(type, this.offset)[sixmonth - 1]]);
	    } else if (type === 'Quarterly') {
	        var sliceStartIndex = sixmonth === 1 ? 0 : 2,
	            sliceEndIndex = sixmonth === 1 ? 2 : 4;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'BiMonthly') {
	        var sliceStartIndex = sixmonth === 1 ? 0 : 3,
	            sliceEndIndex = sixmonth === 1 ? 3 : 6;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'Monthly') {
	        var sliceStartIndex = sixmonth === 1 ? 0 : 6,
	            sliceEndIndex = sixmonth === 1 ? 6 : 12;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'Weekly') {
	        var allWeeks = this.gen(type, this.offset),
	            weeks = [];
	
	        for (var i = 0, sd, ed, sy, ey; i < allWeeks.length; i++) {
	            sd = parseInt(allWeeks[i].startDate.substring(5, 7));
	            ed = parseInt(allWeeks[i].endDate.substring(5, 7));
	            sy = allWeeks[i].startDate.substring(0, 4);
	            ey = allWeeks[i].endDate.substring(0, 4);
	
	            if (sd >= firstMonth && sd <= lastMonth || ed >= firstMonth && ed <= lastMonth) {
	                if (sixmonth === 1 && ey !== this.year || sixmonth === 2 && sy !== this.year) {
	                    continue;
	                }
	
	                weeks.push(allWeeks[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(weeks);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            days = [];
	
	        for (var i = 0, m; i < allDays.length; i++) {
	            m = parseInt(allDays[i].iso.substring(4, 6));
	
	            if (m >= firstMonth && m <= lastMonth) {
	                days.push(allDays[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(days);
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByQuarter = function (type, isAll) {
	    var quarterStr = this.id.slice(5, 6),
	        quarter = parseInt(quarterStr),
	        firstMonth = quarter === 1 ? 1 : quarter === 2 ? 4 : quarter === 3 ? 7 : 10,
	        lastMonth = quarter === 1 ? 3 : quarter === 2 ? 6 : quarter === 3 ? 9 : 12,
	        startIndex,
	        endIndex,
	        offset;
	
	    if (type === 'FinancialOct') {
	        offset = quarter <= 3 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'FinancialJuly') {
	        offset = quarter <= 2 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'FinancialApril') {
	        offset = quarter === 1 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'Yearly') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + 5).slice(0, 1));
	    } else if (type === 'SixMonthlyApril') {
	        var offset = quarter < 2 ? -1 : quarter > 3 ? 1 : 0,
	            index = quarter < 2 || quarter > 3 ? 1 : 2;
	
	        return this.getItemifiedPeriods(this.genRev(type, this.offset + offset).slice(0, index));
	    } else if (type === 'SixMonthly') {
	        startIndex = quarter <= 2 ? 0 : 1;
	        endIndex = startIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(startIndex, endIndex));
	    } else if (type === 'Quarterly') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset));
	        }
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(quarter - 1, quarter));
	    } else if (type === 'BiMonthly') {
	        startIndex = quarter === 1 ? 0 : quarter === 2 ? 1 : quarter === 3 ? 3 : 4;
	        endIndex = startIndex + 2;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(startIndex, endIndex));
	    } else if (type === 'Monthly') {
	        startIndex = quarter === 1 ? 0 : quarter === 2 ? 3 : quarter === 3 ? 6 : 9;
	        endIndex = startIndex + 3;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(startIndex, endIndex));
	    } else if (type === 'Weekly') {
	        var allWeeks = this.gen(type, this.offset),
	            weeks = [];
	
	        for (var i = 0, sd, ed, sy, ey; i < allWeeks.length; i++) {
	            sd = parseInt(allWeeks[i].startDate.substring(5, 7));
	            ed = parseInt(allWeeks[i].endDate.substring(5, 7));
	            sy = allWeeks[i].startDate.substring(0, 4);
	            ey = allWeeks[i].endDate.substring(0, 4);
	
	            if (sd >= firstMonth && sd <= lastMonth || ed >= firstMonth && ed <= lastMonth) {
	                if (quarter === 1 && ey !== this.year || quarter === 4 && sy !== this.year) {
	                    continue;
	                }
	
	                weeks.push(allWeeks[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(weeks);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            days = [];
	
	        for (var i = 0, m; i < allDays.length; i++) {
	            m = parseInt(allDays[i].iso.substring(4, 6));
	
	            if (m >= firstMonth && m <= lastMonth) {
	                days.push(allDays[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(days);
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByBimonth = function (type, isAll) {
	    var bimonthStr = this.id.slice(4, 6),
	        bimonth = parseInt(bimonthStr),
	        firstMonth = bimonth * 2 - 1,
	        lastMonth = bimonth * 2,
	        startIndex,
	        endIndex,
	        offset;
	
	    if (type === 'FinancialOct') {
	        var isPrev = firstMonth < 10,
	            isThis = lastMonth >= 10,
	            offset = 0 + (isPrev ? -1 : 0),
	            sliceEndIndex = 0 + (isPrev ? 1 : 0) + (isThis ? 1 : 0),
	            financialoctobers = [];
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'FinancialJuly') {
	        var isPrev = firstMonth < 7,
	            isThis = lastMonth >= 7,
	            offset = 0 + (isPrev ? -1 : 0),
	            sliceEndIndex = 0 + (isPrev ? 1 : 0) + (isThis ? 1 : 0),
	            financialoctobers = [];
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'FinancialApril') {
	        var isPrev = firstMonth < 4,
	            isThis = lastMonth >= 4,
	            offset = 0 + (isPrev ? -1 : 0),
	            sliceEndIndex = 0 + (isPrev ? 1 : 0) + (isThis ? 1 : 0),
	            financialoctobers = [];
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'Yearly') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset + 5).slice(0, 1));
	    } else if (type === 'SixMonthlyApril') {
	        var sixmonthaprils = [];
	
	        if (bimonth === 1) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset - 1)[1]);
	        } else if (bimonth === 2) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset - 1)[1]);
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[0]);
	        } else if (bimonth < 5) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[0]);
	        } else if (bimonth === 5) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[0]);
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[1]);
	        } else {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[1]);
	        }
	
	        return this.getItemifiedPeriods(sixmonthaprils);
	    } else if (type === 'SixMonthly') {
	        var sliceStartIndex = bimonth < 4 ? 0 : 1,
	            sliceEndIndex = bimonth < 4 ? 1 : 2;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'Quarterly') {
	        var sliceStartIndex = bimonth === 1 ? 0 : bimonth === 2 ? 0 : bimonth === 3 ? 1 : bimonth === 4 ? 2 : bimonth === 5 ? 2 : 3,
	            sliceEndIndex = bimonth === 1 ? 1 : bimonth === 2 ? 2 : bimonth === 3 ? 2 : bimonth === 4 ? 3 : bimonth === 5 ? 4 : 4;
	
	        return this.getItemifiedPeriods(this.gen('Quarterly', this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'BiMonthly') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset));
	        }
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(bimonth - 1, bimonth));
	    } else if (type === 'Monthly') {
	        var sliceStartIndex = bimonth === 1 ? 0 : bimonth === 2 ? 2 : bimonth === 3 ? 4 : bimonth === 4 ? 6 : bimonth === 5 ? 8 : 10,
	            sliceEndIndex = bimonth === 1 ? 2 : bimonth === 2 ? 4 : bimonth === 3 ? 6 : bimonth === 4 ? 8 : bimonth === 5 ? 10 : 12;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'Weekly') {
	        var allWeeks = this.gen(type, this.offset),
	            weeks = [];
	
	        for (var i = 0, sd, ed, sy, ey; i < allWeeks.length; i++) {
	            sd = parseInt(allWeeks[i].startDate.substring(5, 7));
	            ed = parseInt(allWeeks[i].endDate.substring(5, 7));
	            sy = allWeeks[i].startDate.substring(0, 4);
	            ey = allWeeks[i].endDate.substring(0, 4);
	
	            if (sd >= firstMonth && sd <= lastMonth || ed >= firstMonth && ed <= lastMonth) {
	                if (bimonth === 1 && ey !== this.year || bimonth === 4 && sy !== this.year) {
	                    continue;
	                }
	
	                weeks.push(allWeeks[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(weeks);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            days = [];
	
	        for (var i = 0, m; i < allDays.length; i++) {
	            m = parseInt(allDays[i].iso.substring(4, 6));
	
	            if (m >= firstMonth && m <= lastMonth) {
	                days.push(allDays[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(days);
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByMonth = function (type, isAll) {
	    var monthStr = this.id.slice(4, 6),
	        month = parseInt(monthStr),
	        offset;
	
	    if (type === 'FinancialOct') {
	        offset = month <= 9 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'FinancialJuly') {
	        offset = month <= 6 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'FinancialApril') {
	        offset = month <= 3 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'Yearly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset - 5).slice(0, 1));
	    } else if (type === 'SixMonthlyApril') {
	        var offset = month < 4 ? -1 : 0,
	            index = month < 4 || month > 9 ? 1 : 2;
	
	        return this.getItemifiedPeriods(this.genRev(type, this.offset + offset).slice(0, index));
	    } else if (type === 'SixMonthly') {
	        var startIndex = month <= 6 ? 0 : 1,
	            endIndex = startIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(startIndex, endIndex));
	    } else if (type === 'Quarterly') {
	        var startIndex = month <= 3 ? 0 : month <= 6 ? 1 : month <= 9 ? 2 : 3;
	        endIndex = startIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(startIndex, endIndex));
	    } else if (type === 'BiMonthly') {
	        var startIndex = month <= 2 ? 0 : month <= 4 ? 1 : month <= 6 ? 2 : month <= 8 ? 3 : month <= 10 ? 4 : 5;
	        endIndex = startIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(startIndex, endIndex));
	    } else if (type === 'Monthly') {
	        if (isAll) {
	            return this.getItemifiedPeriods(this.gen(type, this.offset));
	        }
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(month - 1, month));
	    } else if (type === 'Weekly') {
	        var t = this,
	            isFirstOrLast = month === 1 || month === 12,
	            allWeeks = function () {
	            var a = [];
	            a = a.concat(isFirstOrLast ? t.gen(type, t.offset - 1) : []);
	            a = a.concat(t.gen(type, t.offset));
	            a = a.concat(isFirstOrLast ? t.gen(type, t.offset + 1) : []);
	            return a;
	        }(),
	            monthTestString = this.year + '-' + monthStr,
	            weeks = [];
	
	        for (var i = 0, sd, ed, week; i < allWeeks.length; i++) {
	            week = allWeeks[i];
	            sd = week.startDate;
	            ed = week.endDate;
	
	            if (sd.substring(0, 7) === monthTestString || ed.substring(0, 7) === monthTestString) {
	                weeks.push(week);
	            }
	        }
	
	        return this.getItemifiedPeriods(weeks);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            days = [];
	
	        for (var i = 0, m; i < allDays.length; i++) {
	            m = allDays[i].iso;
	
	            if (m.substring(4, 6) === monthStr) {
	                days.push(allDays[i]);
	            }
	        }
	
	        return this.getItemifiedPeriods(days);
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByWeek = function (type, isAll) {
	    var weekStr = this.id.slice(5, 7),
	        week = parseInt(weekStr),
	        allWeeks = this.gen('Weekly', this.offset),
	        weekPeriod = allWeeks[week - 1],
	        startDateMonth = parseInt(weekPeriod.startDate.substring(5, 7)),
	        endDateMonth = parseInt(weekPeriod.endDate.substring(5, 7)),
	        startDateYear = parseInt(weekPeriod.startDate.substring(0, 4)),
	        endDateYear = parseInt(weekPeriod.endDate.substring(0, 4)),
	        offset;
	
	    if (type === 'FinancialOct') {
	        var isPrev = startDateMonth < 10 || startDateYear < this.year,
	            isThis = endDateMonth >= 10 || startDateYear > this.year,
	            offset = isPrev ? -1 : 0,
	            sliceEndIndex = 1 + (isPrev ? 1 : 0) + (isThis ? 1 : 0),
	            financialaprils = [];
	
	        return this.getItemifiedPeriods(this.gen('FinancialOct', this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'FinancialJuly') {
	        var isPrev = startDateMonth < 7 || startDateYear < this.year,
	            isThis = endDateMonth >= 7 || startDateYear > this.year,
	            offset = isPrev ? -1 : 0,
	            sliceEndIndex = 1 + (isPrev ? 1 : 0) + (isThis ? 1 : 0),
	            financialaprils = [];
	
	        return this.getItemifiedPeriods(this.gen('FinancialJuly', this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'FinancialApril') {
	        var isPrev = startDateMonth < 4 || startDateYear < this.year,
	            isThis = endDateMonth >= 4 || startDateYear > this.year,
	            offset = isPrev ? -1 : 0,
	            sliceEndIndex = 1 + (isPrev ? 1 : 0) + (isThis ? 1 : 0),
	            financialaprils = [];
	
	        return this.getItemifiedPeriods(this.gen('FinancialApril', this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'Yearly') {
	        var offset = startDateYear < parseInt(this.year) ? -1 : 0,
	            sliceEndIndex = 1 + (startDateYear !== endDateYear ? 1 : 0);
	
	        return this.getItemifiedPeriods(this.gen('Yearly', this.offset + this.yearOffset + offset).slice(0, sliceEndIndex));
	    } else if (type === 'SixMonthlyApril') {
	        var sixmonthaprils = [];
	
	        if (startDateMonth < 4 || startDateYear < this.year) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset - 1)[1]);
	        }
	
	        if ((0, _numberConstrain2.default)(startDateMonth, 4, 9) === startDateMonth || (0, _numberConstrain2.default)(endDateMonth, 4, 9) === endDateMonth) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[0]);
	        }
	
	        if (endDateMonth > 9 || endDateYear > this.year) {
	            sixmonthaprils.push(this.gen('SixMonthlyApril', this.offset)[1]);
	        }
	
	        return this.getItemifiedPeriods(sixmonthaprils);
	    } else if (type === 'SixMonthly') {
	        var allSixmonths = this.gen(type, this.offset),
	            actualSixmonthIndexes = (0, _arrayUnique2.default)([Math.ceil(startDateMonth / 6), Math.ceil(endDateMonth / 6)]),
	            sixmonths = [];
	
	        for (var i = 0; i < actualSixmonthIndexes.length; i++) {
	            sixmonths.push(allSixmonths[actualSixmonthIndexes[i] - 1]);
	        }
	
	        return this.getItemifiedPeriods(sixmonths);
	    } else if (type === 'Quarterly') {
	        var allQuarters = this.gen(type, this.offset),
	            actualQuarterIndexes = (0, _arrayUnique2.default)([Math.ceil(startDateMonth / 3), Math.ceil(endDateMonth / 3)]),
	            quarters = [];
	
	        for (var i = 0; i < actualQuarterIndexes.length; i++) {
	            quarters.push(allQuarters[actualQuarterIndexes[i] - 1]);
	        }
	
	        return this.getItemifiedPeriods(quarters);
	    } else if (type === 'BiMonthly') {
	        var allBimonths = this.gen(type, this.offset),
	            actualBimonthIndexes = (0, _arrayUnique2.default)([Math.ceil(startDateMonth / 2), Math.ceil(endDateMonth / 2)]),
	            bimonths = [];
	
	        for (var i = 0; i < actualBimonthIndexes.length; i++) {
	            bimonths.push(allBimonths[actualBimonthIndexes[i] - 1]);
	        }
	
	        return this.getItemifiedPeriods(bimonths);
	    } else if (type === 'Monthly') {
	        var allMonths = this.gen(type, this.offset),
	            months = [];
	
	        if (startDateMonth === 12 && endDateMonth === 1) {
	            months.push(this.gen(type, this.offset - 1)[11]);
	            months.push(allMonths[0]);
	        } else if (startDateMonth === 1 && endDateMonth === 12) {
	            months.push(allMonths[11]);
	            months.push(this.gen(type, this.offset + 1)[0]);
	        } else {
	            var actualMonthIndexes = (0, _arrayUnique2.default)([startDateMonth, endDateMonth]);
	
	            for (var i = 0, monthIndexes = (0, _arrayUnique2.default)([startDateMonth, endDateMonth]); i < monthIndexes.length; i++) {
	                months.push(allMonths[monthIndexes[i] - 1]);
	            }
	        }
	
	        return this.getItemifiedPeriods(months);
	    } else if (type === 'Weekly') {
	        var allWeeks = this.gen(type, this.offset),
	            weekPeriod = allWeeks[week - 1];
	
	        if (isAll) {
	            return this.getItemifiedPeriods(allWeeks);
	        }
	
	        return this.getItemifiedPeriods(weekPeriod);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            startSlice,
	            endSlice,
	            weekPeriod = this.gen('Weekly', this.offset)[week - 1],
	            days = [];
	
	        if (isAll) {
	            return this.getItemifiedPeriods(allDays);
	        }
	
	        // last year
	        if (weekPeriod.startDate.slice(0, 4) < this.year) {
	            for (var i = 0, lastDaysLastYear = this.gen(type, this.offset - 1).slice(358), day; i < lastDaysLastYear.length; i++) {
	                day = lastDaysLastYear[i];
	
	                if (day.startDate === weekPeriod.startDate) {
	                    days = days.concat(lastDaysLastYear.slice(i));
	                }
	            }
	        }
	
	        // this year
	        for (var i = 0, sd; i < allDays.length; i++) {
	            sd = allDays[i].startDate;
	
	            if (sd === weekPeriod.startDate) {
	                startSlice = i;
	            } else if (sd === weekPeriod.endDate) {
	                endSlice = i + 1;
	            }
	        }
	
	        days = days.concat(allDays.slice(startSlice, endSlice));
	
	        // next year
	        if (weekPeriod.endDate.slice(0, 4) > this.year) {
	            for (var i = 0, firstDaysNextYear = this.gen(type, this.offset + 1).slice(0, 7), day; i < firstDaysNextYear.length; i++) {
	                day = firstDaysNextYear[i];
	
	                days.push(day);
	
	                if (day.endDate === weekPeriod.endDate) {
	                    break;
	                }
	            }
	        }
	
	        return this.getItemifiedPeriods(days);
	    }
	
	    return [];
	};
	
	Period.prototype.getItemsByTypeByDay = function (type, isAll) {
	    var dayStr = this.id.slice(6, 8),
	        day = parseInt(dayStr),
	        monthStr = this.id.slice(4, 6),
	        month = parseInt(monthStr),
	        offset;
	
	    if (type === 'FinancialOct') {
	        offset = month <= 9 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'FinancialJuly') {
	        offset = month <= 6 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'FinancialApril') {
	        offset = month <= 3 ? 4 : 5;
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(0, 1));
	    } else if (type === 'Yearly') {
	        return this.getItemifiedPeriods(this.genRev(type, this.offset - 5).slice(0, 1));
	    } else if (type === 'SixMonthlyApril') {
	        var offset = month < 4 ? -1 : 0,
	            sliceStartIndex = month < 4 || month > 9 ? 1 : 0,
	            sliceEndIndex = sliceStartIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset + offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'SixMonthly') {
	        var sliceStartIndex = month <= 6 ? 0 : 1,
	            sliceEndIndex = sliceStartIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'Quarterly') {
	        var sliceStartIndex = month <= 3 ? 0 : month <= 6 ? 1 : month <= 9 ? 2 : 3;
	        sliceEndIndex = sliceStartIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'BiMonthly') {
	        var sliceStartIndex = month <= 2 ? 0 : month <= 4 ? 1 : month <= 6 ? 2 : month <= 8 ? 3 : month <= 10 ? 4 : 5;
	        sliceEndIndex = sliceStartIndex + 1;
	
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(sliceStartIndex, sliceEndIndex));
	    } else if (type === 'Monthly') {
	        return this.getItemifiedPeriods(this.gen(type, this.offset).slice(month - 1, month));
	    } else if (type === 'Weekly') {
	        var allWeeks = this.gen(type, this.offset),
	            week;
	
	        for (var i = 0, sd, ed; i < allWeeks.length; i++) {
	            sd = allWeeks[i].startDate;
	            ed = allWeeks[i].endDate;
	
	            if (sd.substring(5, 7) === monthStr || ed.substring(5, 7) === monthStr) {
	                if (sd.substring(8, 10) <= dayStr || ed.substring(8, 10) >= dayStr) {
	                    week = allWeeks[i];
	                    break;
	                }
	            }
	        }
	
	        return this.getItemifiedPeriods(week);
	    } else if (type === 'Daily') {
	        var allDays = this.gen(type, this.offset),
	            day;
	
	        if (isAll) {
	            return this.getItemifiedPeriods(allDays);
	        }
	
	        for (var i = 0, sd; i < allDays.length; i++) {
	            sd = allDays[i].startDate;
	
	            if (sd.substring(5, 7) === monthStr && sd.substring(8, 10) === dayStr) {
	                day = allDays[i];
	            }
	        }
	
	        return this.getItemifiedPeriods(day);
	    }
	
	    return [];
	};
	
	//TYPE                ID              NAME
	//Financial October   2015Oct         Oct 2015 to Sep 2016
	//Financial July      2015July        Jul 2015 to Jun 2016
	//Financial April     2015April       Apr 2015 to Mar 2016
	//Yearly              2015            2015
	//Six-monthly April   2015AprilS1     Apr to Sep 2015
	//Six-monthly April   2015AprilS2     Oct to Mar 2014
	//Six-monthly         2015S1          Jan to Jun 2015
	//Quarterly           2015Q1          Jan to Mar 2015
	//Bi-monthly          201501B         Jan to Feb 2015
	//Monthly             201501          January 2015
	//Weekly              2015W1          2015W1
	//Daily               20150101        2015-01-01
	
	// dep 2
	
	Period.prototype.generateDisplayProperties = function () {
	    var p = this;
	
	    var id = p.id,
	        months = 'Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec'.split('|'),
	        offset = parseInt(p.year) - new Date().getFullYear(),
	        generator = refs.calendarManager.generator,
	        getSuffix = function getSuffix(array) {
	        return array.length > 1 ? 's' : '';
	    };
	
	    var type = p.getTypeById(id);
	
	    if (type === 'Daily') {
	        this.sortId = id;
	        this.typeSortId = '01';
	        this.typeName = 'Daily';
	        this.displayName = parseInt(this.name.split('-')[2]) + ' ' + months[new Date(this.name).getMonth()] + ', ' + this.year;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByDay('FinancialApril'),
	                    text: 'Show <span class="name">financial April ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByDay('FinancialJuly'),
	                    text: 'Show <span class="name">financial July ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByDay('FinancialOct'),
	                    text: 'Show <span class="name">financial October ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByDay('Yearly'),
	                    text: 'Show <span class="name">year ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                var periods = p.getItemsByTypeByDay('SixMonthlyApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                var periods = p.getItemsByTypeByDay('SixMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                var periods = p.getItemsByTypeByDay('Quarterly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'quarter') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                var periods = p.getItemsByTypeByDay('BiMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'bi-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                var periods = p.getItemsByTypeByDay('Monthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByDay('Weekly'),
	                    text: 'Show <span class="name">week ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.daily
	            });
	
	            items.push({
	                items: p.getItemsByTypeByDay('Daily'),
	                text: 'Show <span class="name">' + p.displayName + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByDay('Daily', true),
	                text: 'Show all <span class="name">days</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            return items;
	        };
	    } else if (type === 'Weekly') {
	        this.sortId = function () {
	            var a = id.split('W');
	            return a[0] + (a[1].length === 1 ? '000' : '00') + a[1];
	        }();
	        this.typeSortId = '02';
	        this.typeName = 'Weekly';
	        this.displayName = 'Week ' + id.split('W')[1] + ', ' + this.year;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByWeek('FinancialApril'),
	                    text: 'Show <span class="name">financial April ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByWeek('FinancialJuly'),
	                    text: 'Show <span class="name">financial July ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                var periods = p.getItemsByTypeByWeek('FinancialOct');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial October' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByWeek('Yearly'),
	                    text: 'Show <span class="name">' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                var periods = p.getItemsByTypeByWeek('SixMonthlyApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                var periods = p.getItemsByTypeByWeek('SixMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                var periods = p.getItemsByTypeByWeek('Quarterly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'quarter') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                var periods = p.getItemsByTypeByWeek('BiMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'bi-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                var periods = p.getItemsByTypeByWeek('Monthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'monthly') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.weekly
	            });
	
	            items.push({
	                items: p.getItemsByTypeByWeek('Weekly'),
	                text: 'Show <span class="name">' + p.displayName + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByWeek('Weekly', true),
	                text: 'Show all <span class="name">weeks</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByWeek('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.displayName + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'Monthly') {
	        this.sortId = this.year + '00' + id.slice(4, 6);
	        this.typeSortId = '03';
	        this.typeName = 'Monthly';
	        this.displayName = this.name.split(' ')[0] + ' ' + this.year;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeByMonth('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                var periods = p.getItemsByTypeByMonth('FinancialJuly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial July' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                var periods = p.getItemsByTypeByMonth('FinancialOct');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial October' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                var periods = p.getItemsByTypeByMonth('Yearly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">year' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                var periods = p.getItemsByTypeByMonth('SixMonthlyApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">six-month April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                var periods = p.getItemsByTypeByMonth('SixMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                var periods = p.getItemsByTypeByMonth('Quarterly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'quarter') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                var periods = p.getItemsByTypeByMonth('BiMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'bimonthly') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.monthly
	            });
	
	            items.push({
	                items: p.getItemsByTypeByMonth('Monthly'),
	                text: 'Show <span class="name">' + p.displayName + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByMonth('Monthly', true),
	                text: 'Show all <span class="name">months</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByMonth('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByMonth('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'BiMonthly') {
	        this.sortId = id.slice(0, 4) + '00' + id.slice(4, 6);
	        this.typeSortId = '04';
	        this.typeName = 'Bi-monthly';
	        this.displayName = (0, _stringTrim2.default)(this.name.split(this.year)[0]);
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('FinancialJuly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial July' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('FinancialOct');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial October' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('Yearly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('SixMonthlyApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('SixMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                var periods = p.getItemsByTypeByBimonth('Quarterly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'quarter') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.bimonthly
	            });
	
	            // bimonthly
	            items.push({
	                items: p.getItemsByTypeByBimonth('BiMonthly'),
	                text: 'Show <span class="name">' + p.displayName + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByBimonth('BiMonthly', true),
	                text: 'Show all <span class="name">bi-months</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByBimonth('Monthly'),
	                    text: 'Show <span class="name">months</span> in <span class="name">' + p.displayName + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByBimonth('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.displayName + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByBimonth('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.displayName + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'Quarterly') {
	        this.sortId = function () {
	            var a = id.split('Q');
	            return a[0] + (a[1].length === 1 ? '000' : '00') + a[1];
	        }();
	        this.typeSortId = '05';
	        this.typeName = 'Quarterly';
	        this.displayName = (0, _stringTrim2.default)(this.name.split(this.year)[0]);
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('FinancialApril'),
	                    text: 'Show <span class="name">financial April ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('FinancialJuly'),
	                    text: 'Show <span class="name">financial July ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('FinancialOct'),
	                    text: 'Show <span class="name">financial October ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('Yearly'),
	                    text: 'Show <span class="name">' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                var periods = p.getItemsByTypeByQuarter('SixMonthlyApril');
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month April') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                var periods = p.getItemsByTypeByQuarter('SixMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + p.getNameByParents(periods, 'six-month') + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.quarterly
	            });
	
	            // quarterly
	            items.push({
	                items: p.getItemsByTypeByQuarter('Quarterly'),
	                text: 'Show <span class="name">' + p.name + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByQuarter('Quarterly', true),
	                text: 'Show all <span class="name">quarters</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('Monthly'),
	                    text: 'Show <span class="name">months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByQuarter('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'SixMonthly') {
	        this.sortId = function () {
	            var a = id.split('S');
	            return a[0] + (a[1].length === 1 ? '000' : '00') + a[1];
	        }();
	        this.typeSortId = '06';
	        this.typeName = 'Six-monthly';
	        this.displayName = (0, _stringTrim2.default)(this.name.split(this.year)[0]);
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeBySixmonth('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial April ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                var periods = p.getItemsByTypeBySixmonth('FinancialJuly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial July ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                var periods = p.getItemsByTypeBySixmonth('FinancialOct');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial October' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                var periods = p.getItemsByTypeBySixmonth('Yearly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">year' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                var periods = p.getItemsByTypeBySixmonth('SixMonthlyApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">six-month April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.sixmonthly
	            });
	
	            // six-monthly
	            items.push({
	                items: p.getItemsByTypeBySixmonth('SixMonthly'),
	                text: 'Show <span class="name">' + p.name + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeBySixmonth('SixMonthly', true),
	                text: 'Show all <span class="name">six-months</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // quarterly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonth('Quarterly'),
	                    text: 'Show <span class="name">quarters</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonth('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonth('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonth('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	        //return;
	    } else if (type === 'SixMonthlyApril') {
	        this.sortId = function () {
	            var a = id.split('AprilS');
	            return a[0] + (a[1].length === 1 ? '000' : '00') + a[1];
	        }();
	        this.typeSortId = '07';
	        this.typeName = 'Six-monthly April';
	        this.displayName = (0, _stringTrim2.default)(this.name.split(this.year)[0]);
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeBySixmonthApril('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial Apri ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                var periods = p.getItemsByTypeBySixmonthApril('FinancialJuly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial July' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                var periods = p.getItemsByTypeBySixmonthApril('FinancialOct');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial October' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                var periods = p.getItemsByTypeBySixmonthApril('Yearly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">' + (getSuffix(periods) ? 'parent years' : p.year) + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.sixmonthly
	            });
	
	            // six-monthly april
	            items.push({
	                items: p.getItemsByTypeBySixmonthApril('SixMonthlyApril'),
	                text: 'Show <span class="name">' + p.name + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeBySixmonthApril('SixMonthlyApril', true),
	                text: 'Show all <span class="name">six-month Aprils</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // six-monthly
	            (function () {
	                var periods = p.getItemsByTypeBySixmonthApril('SixMonthly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">six-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonthApril('Quarterly'),
	                    text: 'Show <span class="name">quarters</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonthApril('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonthApril('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeBySixmonthApril('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'Yearly') {
	        this.sortId = id + '0000';
	        this.typeSortId = '08';
	        this.typeName = 'Yearly';
	        this.displayName = this.name;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeByYear('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                var periods = p.getItemsByTypeByYear('FinancialJuly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial July' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                var periods = p.getItemsByTypeByYear('FinancialOct');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial October' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.yearly
	            });
	
	            items.push({
	                items: p.getItemsByTypeByYear('Yearly'),
	                text: 'Show <span class="name">' + p.displayName + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // six-monthly april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('SixMonthlyApril'),
	                    text: 'Show <span class="name">six-month Aprils</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('SixMonthly'),
	                    text: 'Show <span class="name">six-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('Quarterly'),
	                    text: 'Show <span class="name">quarters</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('Monthly'),
	                    text: 'Show <span class="name">months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByYear('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'FinancialOct') {
	        this.sortId = id.slice(0, 4) + '0003';
	        this.typeSortId = '11';
	        this.typeName = 'Financial October';
	        this.displayName = this.name;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeByFinancialOct('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial july
	            (function () {
	                var periods = p.getItemsByTypeByFinancialOct('FinancialJuly');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial July' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.financial_oct
	            });
	
	            // financial october
	            items.push({
	                items: p.getItemsByTypeByFinancialOct('FinancialOct'),
	                text: 'Show <span class="name">' + p.name + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByFinancialOct('FinancialOct', true),
	                text: 'Show all <span class="name">financial Octobers</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // yearly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('Yearly'),
	                    text: 'Show <span class="name">years</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('SixMonthlyApril'),
	                    text: 'Show <span class="name">six-month Aprils</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('SixMonthly'),
	                    text: 'Show <span class="name">six-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('Quarterly'),
	                    text: 'Show <span class="name">quarters</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('Monthly'),
	                    text: 'Show <span class="name">months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialOct('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'FinancialJuly') {
	        this.sortId = id.slice(0, 4) + '0002';
	        this.typeSortId = '10';
	        this.typeName = 'Financial July';
	        this.displayName = this.name;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // drill up
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_up
	            });
	
	            // financial april
	            (function () {
	                var periods = p.getItemsByTypeByFinancialJuly('FinancialApril');
	
	                items.push({
	                    items: periods,
	                    text: 'Show <span class="name">financial April' + getSuffix(periods) + ' ' + p.year + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.financial_july
	            });
	
	            // financial july
	            items.push({
	                items: p.getItemsByTypeByFinancialJuly('FinancialJuly'),
	                text: 'Show <span class="name">' + p.name + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByFinancialJuly('FinancialJuly', true),
	                text: 'Show all <span class="name">financial Julys</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // financial oct
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('FinancialOct'),
	                    text: 'Show <span class="name">financial Octobers</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('Yearly'),
	                    text: 'Show <span class="name">years</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('SixMonthlyApril'),
	                    text: 'Show <span class="name">six-month Aprils</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('SixMonthly'),
	                    text: 'Show <span class="name">six-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('Quarterly'),
	                    text: 'Show <span class="name">quarters</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('Monthly'),
	                    text: 'Show <span class="name">months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialJuly('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    } else if (type === 'FinancialApril') {
	        this.sortId = id.slice(0, 4) + '0001';
	        this.typeSortId = '09';
	        this.typeName = 'Financial April';
	        this.displayName = this.name;
	
	        this.getContextMenuItemsConfig = function () {
	            var items = [];
	
	            // same level
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.financial_april
	            });
	
	            // financial april
	            items.push({
	                items: p.getItemsByTypeByFinancialApril('FinancialApril'),
	                text: 'Show <span class="name">' + p.name + '</span> only',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            items.push({
	                items: p.getItemsByTypeByFinancialApril('FinancialApril', true),
	                text: 'Show all <span class="name">financial Aprils</span> in <span class="name">' + p.year + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	
	            // drill down
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                text: this.i18n.drill_down
	            });
	
	            // financial july
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('FinancialJuly'),
	                    text: 'Show <span class="name">financial Julys</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // financial october
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('FinancialOct'),
	                    text: 'Show <span class="name">financial Octobers</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // yearly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('Yearly'),
	                    text: 'Show <span class="name">years</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly april
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('SixMonthlyApril'),
	                    text: 'Show <span class="name">six-month Aprils</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // six-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('SixMonthly'),
	                    text: 'Show <span class="name">six-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // quarterly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('Quarterly'),
	                    text: 'Show <span class="name">quarters</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // bi-monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('BiMonthly'),
	                    text: 'Show <span class="name">bi-months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // monthly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('Monthly'),
	                    text: 'Show <span class="name">months</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // weekly
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('Weekly'),
	                    text: 'Show <span class="name">weeks</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            // daily
	            (function () {
	                items.push({
	                    items: p.getItemsByTypeByFinancialApril('Daily'),
	                    text: 'Show <span class="name">days</span> in <span class="name">' + p.name + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            })();
	
	            return items;
	        };
	    }
	};
	//# sourceMappingURL=Period.js.map

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.defaultProxyGenerator = exports.addMerge = exports.getUniqueFactor = exports.buildTable2D = exports.getPercentageHtml = exports.getRoundedHtmlValue = exports.getNumberOfDecimals = exports.toRow = exports.getValue = exports.roundIf = undefined;
	
	var _numberToFixed = __webpack_require__(184);
	
	var _numberToFixed2 = _interopRequireDefault(_numberToFixed);
	
	var _isNumber = __webpack_require__(9);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isBoolean = __webpack_require__(13);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @description round number if needed.
	 *  @param   {number} number 
	 *  @param   {number} precision 
	 *  @returns {number}
	 */
	var roundIf = exports.roundIf = function roundIf(number, precision) {
	    number = parseFloat(number);
	    precision = parseFloat(precision);
	
	    if ((0, _isNumber2.default)(number) && (0, _isNumber2.default)(precision)) {
	        var numberOfDecimals = getNumberOfDecimals(number);
	        return numberOfDecimals > precision ? (0, _numberToFixed2.default)(number, precision) : number;
	    }
	
	    return number;
	};
	
	/** @description gets integer representation of given string.
	 *  @param   {string} str 
	 *  @returns {number}
	 */
	var getValue = exports.getValue = function getValue(str) {
	    var n = parseFloat(str);
	
	    if ((0, _isBoolean2.default)(str)) {
	        return 1;
	    }
	
	    if (!(0, _isNumber2.default)(n) || n != str) {
	        return 0;
	    }
	
	    return n;
	};
	
	/** @description turns array of arrays into a single row.
	 *  @param   {array} array 
	 *  @returns {array}
	 */
	var toRow = exports.toRow = function toRow(array) {
	
	    if (!(0, _isArray2.default)(array[0])) {
	        return [array];
	    }
	
	    var row = new Array(array[0].length);
	
	    for (var i = 0; i < row.length; i++) {
	        row[i] = [];
	    }
	
	    for (var _i = 0; _i < array.length; _i++) {
	        for (var j = 0; j < array[_i].length; j++) {
	            row[j].push(array[_i][j]);
	        }
	    }
	
	    return row;
	};
	
	/** @description returns the number of decumal of given float
	 *  @param   {number} number 
	 *  @returns {number}
	 *  @deprecated should switch to use function located in d2-utilizr
	 */
	var getNumberOfDecimals = exports.getNumberOfDecimals = function getNumberOfDecimals(number) {
	    var str = new String(number);
	    return str.indexOf('.') > -1 ? str.length - str.indexOf('.') - 1 : 0;
	};
	
	/** @description returns the rounded value of the given float.
	 *  @param   {number} value 
	 *  @param   {number} [dec=2] 
	 *  @returns {number}
	 */
	var getRoundedHtmlValue = exports.getRoundedHtmlValue = function getRoundedHtmlValue(value) {
	    var dec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	    return parseFloat(roundIf(value, 2)).toString();
	};
	
	/** @description get percentage representation of value.
	 *  @param   {number} value 
	 *  @param   {number} total 
	 *  @returns {string}
	 */
	var getPercentageHtml = exports.getPercentageHtml = function getPercentageHtml(value, total) {
	    return getRoundedHtmlValue(value / total * 100) + '%';
	};
	
	/** @description Builds a 2D array with the given dimensions
	 *  @param   {number} rows
	 *  @param   {number} columns
	 *  @returns {array}  
	 */
	var buildTable2D = exports.buildTable2D = function buildTable2D(rows, columns, fill) {
	    var table2D = new Array(rows);
	
	    for (var i = 0; i < rows; i++) {
	        table2D[i] = new Array(columns);
	        if (typeof fill !== 'undefined') table2D[i].fill(fill);
	    }
	
	    return table2D;
	};
	
	var getUniqueFactor = exports.getUniqueFactor = function getUniqueFactor(axis) {
	    if (axis.xItems && axis.xItems.unique) {
	        return axis.xItems.unique.length < 2 ? 1 : axis.size / axis.xItems.unique[0].length;
	    }
	    return null;
	};
	
	var addMerge = exports.addMerge = function addMerge(a, b) {
	    Object.keys(a).forEach(function (key) {
	        if (b[key]) {
	            a[key] += b[key];
	        }
	    });
	};
	
	var defaultProxyGenerator = exports.defaultProxyGenerator = function defaultProxyGenerator(defaultReturnValue) {
	    return new Proxy({}, { get: function get(target, name) {
	            return name in target ? target[name] : defaultReturnValue;
	        } });
	};
	//# sourceMappingURL=PivotTableUtils.js.map

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AboutWindow = undefined;
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutWindow = exports.AboutWindow = undefined;
	
	exports.AboutWindow = AboutWindow = function AboutWindow(c) {
	    var appManager = c.appManager,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        i18n = c.i18nManager.get(),
	        apiPath = appManager.getApiPath();
	
	    return Ext.create('Ext.window.Window', {
	        title: i18n.about,
	        bodyStyle: 'background:#fff; padding:6px',
	        modal: true,
	        resizable: false,
	        destroyOnBlur: true,
	        getData: function getData() {
	            var t = this;
	
	            Ext.Ajax.request({
	                url: encodeURI(apiPath + '/system/info.json'),
	                success: function success(r) {
	                    var info = Ext.decode(r.responseText),
	                        divStyle = 'padding:3px',
	                        html = '<div class="user-select">';
	
	                    if ((0, _isObject2.default)(info)) {
	                        html += '<div style="' + divStyle + '"><b>' + i18n.time_since_last_data_update + ': </b>' + info.intervalSinceLastAnalyticsTableSuccess + '</div>';
	                        html += '<div style="' + divStyle + '"><b>' + i18n.version + ': </b>' + info.version + '</div>';
	                        html += '<div style="' + divStyle + '"><b>' + i18n.revision + ': </b>' + info.revision + '</div>';
	                        html += '<div style="' + divStyle + '"><b>' + i18n.username + ': </b>' + appManager.userAccount.username + '</div>';
	                        html += '</div>';
	                    } else {
	                        html += 'No system info found';
	                    }
	
	                    t.update(html);
	                },
	                failure: function failure(r) {
	                    t.update(r.status + '\n' + r.statusText + '\n' + r.responseText);
	                },
	                callback: function callback() {
	                    t.show();
	
	                    uiManager.enableRightClick();
	
	                    var aboutButton = uiManager.get('aboutButton') || {};
	
	                    if (aboutButton.rendered) {
	                        uiManager.setAnchorPosition(t, aboutButton);
	
	                        if (!t.hasDestroyOnBlurHandler) {
	                            uiManager.addDestroyOnBlurHandler(t);
	                        }
	                    }
	                }
	            });
	        },
	        listeners: {
	            hide: function hide() {
	                uiManager.disableRightClick();
	            },
	            destroy: function destroy() {
	                uiManager.disableRightClick();
	            }
	        }
	    });
	};
	//# sourceMappingURL=AboutWindow.js.map

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EastRegion = undefined;
	
	var _DateManager = __webpack_require__(23);
	
	var _InterpretationWindow = __webpack_require__(25);
	
	var _SharingWindow = __webpack_require__(26);
	
	var _RenameWindow = __webpack_require__(38);
	
	var _arraySort = __webpack_require__(8);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EastRegion = exports.EastRegion = undefined;
	
	exports.EastRegion = EastRegion = function EastRegion(c) {
	
	    var t = this,
	        uiManager = c.uiManager,
	        uiConfig = c.uiConfig,
	        instanceManager = c.instanceManager,
	        appManager = c.appManager,
	        i18nManager = c.i18nManager;
	
	    var i18n = i18nManager.get(),
	        path = appManager.getPath(),
	        apiPath = appManager.getApiPath();
	
	    var descriptionMaxNumberCharacter = 500;
	
	    var openInterpretationWindow = function openInterpretationWindow(id, interpretation, success) {
	        var favoriteId = id || instanceManager.getStateFavoriteId();
	        instanceManager.getSharingById(favoriteId, function (r) {
	            (0, _InterpretationWindow.InterpretationWindow)(c, r, interpretation, success).show();
	        }, { allowForbidden: true });
	    };
	
	    var userCanManageInterpretation = function userCanManageInterpretation(interpretation) {
	        return interpretation.user.id == appManager.userAccount.id || appManager.isAdmin;
	    };
	
	    var userCanManageComment = function userCanManageComment(comment) {
	        return comment.user.id == appManager.userAccount.id || appManager.isAdmin;
	    };
	
	    var getLink = function getLink(text, isBold, isBrackets) {
	        return (isBrackets ? '<span class="bold">[</span> ' : '') + '<span class="eastPanelLink' + (isBold ? ' bold' : '') + '">' + text + '</span>' + (isBrackets ? ' <span class="bold">]</span>' : '');
	    };
	
	    /*
	     * FAVORITE DETAILS PANEL
	     */
	
	    var getDetailsPanelItems = function getDetailsPanelItems(layout) {
	        // Favorite loaded ->  Add favorite detail panel and update
	        // Otherwise -> Display No Favorite Panel
	        var detailsPanelItems;
	        if (instanceManager.isStateFavorite()) {
	
	            var moreText = i18n.show_more;
	            var lessText = i18n.show_less;
	            var editText = i18n.edit;
	
	            // Create Description Panel from description field
	            var getDescriptionPanel = function getDescriptionPanel(description) {
	                var descriptionItems = [];
	                if (description == undefined) {
	                    description = i18n.no_description;
	                }
	
	                var isTooLongDescription = description.length > descriptionMaxNumberCharacter;
	                var shortDescription = description.substring(0, descriptionMaxNumberCharacter) + ' ... ';
	
	                // DHIS2-2210: render line breaks
	                description = description.replace(/\n/g, '<br />');
	                shortDescription = shortDescription.replace(/\n/g, '<br />');
	
	                // Description label
	                descriptionItems.push({
	                    xtype: 'label',
	                    itemId: 'descriptionLabel',
	                    html: isTooLongDescription ? shortDescription : description,
	                    cls: 'interpretationActions'
	                });
	
	                // Longer than [descriptionMaxNumberCharacter] characters -> Create More/Less link
	                if (isTooLongDescription) {
	                    var longDescription = description;
	
	                    descriptionItems.push({
	                        xtype: 'label',
	                        html: getLink(moreText, false, true),
	                        cls: 'interpretationActions',
	                        isShortDescriptionDisplayed: true,
	                        style: 'margin: 1px 3px 0;',
	                        listeners: {
	                            render: function render(label) {
	                                label.getEl().on('click', function () {
	                                    if (this.isShortDescriptionDisplayed) {
	                                        this.up('#descriptionPanel').down('#descriptionLabel').setText(longDescription, false);
	                                        this.getEl().dom.innerHTML = getLink(lessText, false, true);
	                                    } else {
	                                        this.up('#descriptionPanel').down('#descriptionLabel').setText(shortDescription, false);
	                                        this.getEl().dom.innerHTML = getLink(moreText, false, true);
	                                    }
	                                    this.isShortDescriptionDisplayed = !this.isShortDescriptionDisplayed;
	                                    this.up('#descriptionPanel').doLayout();
	                                }, label);
	                            }
	                        }
	                    });
	                }
	
	                // Change Link
	                if (layout && layout.permission === "write") {
	                    descriptionItems.push({
	                        xtype: 'label',
	                        html: getLink(editText, false, true),
	                        cls: 'interpretationActions',
	                        style: 'margin: 1px 3px 0;',
	                        listeners: {
	                            'render': function render(label) {
	                                label.getEl().on('click', function () {
	                                    (0, _RenameWindow.RenameWindow)(c, instanceManager.getStateFavorite()).show();
	                                }, label);
	                            }
	                        }
	                    });
	                }
	
	                return descriptionItems;
	            };
	
	            // Create Sharing setting text from publicAccess and userGroupAccesses field
	            var getSharingText = function getSharingText(layout) {
	                // Public permissions
	                var sharingText = i18n.public + ': ';
	                if (layout.publicAccess == "r-------") {
	                    sharingText += i18n.read;
	                } else if (layout.publicAccess == "rw------") {
	                    sharingText += i18n.read_write;
	                } else {
	                    sharingText += i18n.none;
	                }
	
	                // User Group Accesses permissions
	                // TODO: Create a tooltip
	                if (layout.userGroupAccesses != undefined) {
	                    sharingText += ' + ';
	                    if (layout.userGroupAccesses.length > 2) {
	                        sharingText += layout.userGroupAccesses.length + ' ' + i18n.groups;
	                    } else {
	                        for (var i = 0; i < layout.userGroupAccesses.length; i++) {
	                            if (i > 0) {
	                                sharingText += ', ';
	                            }
	                            sharingText += i18n.group + ' ' + layout.userGroupAccesses[i].displayName;
	                        }
	                    }
	                }
	                return sharingText;
	            };
	
	            // Get Number of Views from analytics api and update label
	            var setNumberOfViews = function setNumberOfViews(label, favoritesId) {
	                Ext.Ajax.request({
	                    url: encodeURI(apiPath + '/dataStatistics/favorites/' + favoritesId + '.json'),
	                    method: 'GET',
	                    scope: this,
	                    success: function success(r) {
	                        label.setValue(Ext.decode(r.responseText).views);
	                    }
	                });
	                return i18n.loading + '..';
	            };
	
	            // Favorite Details Panel content when favorite loaded
	            var userCanEditSharing = layout && layout.permission === 'write';
	
	            detailsPanelItems = [{
	                xtype: 'panel',
	                itemId: 'descriptionPanel',
	                bodyStyle: 'border-style:none;',
	                style: 'margin-bottom:5px;',
	                items: [getDescriptionPanel(layout.displayDescription)]
	            }, {
	                xtype: 'displayfield',
	                fieldLabel: i18n.owner,
	                labelStyle: 'padding-top:0',
	                style: 'margin-bottom:3px',
	                itemId: 'owner',
	                value: layout.user != undefined ? layout.user.displayName : '',
	                cls: 'interpretationDetailsField'
	            }, {
	                xtype: 'displayfield',
	                itemId: 'created',
	                fieldLabel: i18n.created,
	                labelStyle: 'padding-top:0',
	                style: 'margin-bottom:3px',
	                value: layout.created,
	                cls: 'interpretationDetailsField'
	            }, {
	                xtype: 'displayfield',
	                itemId: 'lastUpdated',
	                fieldLabel: i18n.last_updated,
	                labelStyle: 'padding-top:0',
	                style: 'margin-bottom:3px',
	                value: layout.lastUpdated,
	                cls: 'interpretationDetailsField'
	            }, {
	                xtype: 'displayfield',
	                itemId: 'numberViews',
	                fieldLabel: i18n.views,
	                labelStyle: 'padding-top:0',
	                style: 'margin-bottom:3px',
	                value: i18n.loading + '..',
	                cls: 'interpretationDetailsField',
	                listeners: {
	                    'render': function render(label) {
	                        setNumberOfViews(label, layout.id);
	                    }
	                }
	            }, {
	                xtype: 'displayfield',
	                itemId: 'sharing',
	                fieldLabel: i18n.sharing,
	                labelStyle: 'padding-top:0',
	                style: 'margin-bottom:3px',
	                value: getSharingText(layout) + (userCanEditSharing ? '<span style="padding-left:10px">' + getLink(editText, false, true) + '</span>' : ''),
	                cls: 'interpretationDetailsField',
	                listeners: {
	                    'render': function render(label) {
	                        if (userCanEditSharing) {
	                            label.getEl().on('click', function () {
	                                instanceManager.getSharingById(instanceManager.getStateFavoriteId(), function (r) {
	                                    (0, _SharingWindow.SharingWindow)(c, r).show();
	                                });
	                            }, label);
	                        }
	                    }
	                }
	            }];
	        } else {
	            // Favorite Details Panel content when no favorite is loaded
	            detailsPanelItems = [{
	                xtype: 'label',
	                text: i18n.no_current_favorite,
	                cls: 'interpretationActions',
	                style: 'padding:4px 1px;'
	            }];
	        }
	
	        return {
	            xtype: 'panel',
	            bodyStyle: 'border-style:none',
	            style: 'padding:6px;',
	            itemId: 'noFavoriteDetailsPanel',
	            defaults: {
	                style: 'margin-top: 1px;'
	            },
	            items: [detailsPanelItems]
	        };
	    };
	
	    // Main Details Panel Container
	    var detailsPanel = {
	        xtype: 'panel',
	        cls: 'ns-panel-title-east-default first',
	        title: i18n.details,
	        itemId: 'detailsPanel',
	
	        addAndUpdateFavoritePanel: function addAndUpdateFavoritePanel(layout) {
	            // Remove any previous panel
	            this.removeAll(true);
	
	            this.add(getDetailsPanelItems(layout));
	        },
	
	        tools: [{
	            type: 'triple-chevron-right',
	            cls: 'tool-triple-chevron-right',
	            handler: function handler() {
	                uiManager.toggleCollapseRegion('eastRegion');
	                uiManager.get('centerRegion').toggleEastRegion();
	            }
	        }],
	
	        // By default no favorite details panel is displayed
	        items: getDetailsPanelItems()
	    };
	
	    /*
	     * INTERPRETATIONS PANEL
	     */
	
	    // Create interpretation panel depending on interpretation
	    var getInterpretationPanel = function getInterpretationPanel(layout, interpretation, displayingComments) {
	
	        var numberOfCommentsToDisplay = 3;
	
	        var getWriteCommentBox = function getWriteCommentBox(comment, visible) {
	            return {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none',
	                layout: 'column',
	                itemId: 'commentPanel-' + (comment ? comment.id : "new"),
	                hidden: !visible || !layout || layout.permission === "none",
	                style: 'margin-top: 1px;',
	                cls: 'comment greyBackground',
	                items: [{
	                    xtype: 'panel',
	                    bodyStyle: 'border-style:none',
	                    items: [{
	                        xtype: 'label',
	                        cls: 'avatar',
	                        text: appManager.userAccount.firstName[0] + appManager.userAccount.surname.split(' ')[appManager.userAccount.surname.split(' ').length - 1][0]
	                    }],
	                    columnWidth: 0.11
	                }, {
	                    xtype: 'panel',
	                    bodyStyle: 'border-style:none',
	                    autoWidth: true,
	                    layout: 'fit',
	                    flex: 1,
	                    items: [{
	                        xtype: 'textarea',
	                        itemId: 'commentArea',
	                        cls: 'commentArea',
	                        emptyText: i18n.write_your_interpretation,
	                        value: comment && comment.text,
	                        submitEmptyText: false,
	                        flex: 1,
	                        border: 0,
	                        enableKeyEvents: true,
	                        listeners: {
	                            keypress: function keypress(f, e) {
	                                if (e.getKey() == e.ENTER && !e.shiftKey) {
	                                    commentInterpretation(f, comment);
	                                }
	                            }
	                        }
	                    }, {
	                        xtype: 'panel',
	                        bodyStyle: 'border-style:none',
	                        items: [{
	                            xtype: 'label',
	                            html: getLink(i18n.post_comment),
	                            cls: 'link',
	                            listeners: {
	                                'render': function render(label) {
	                                    label.getEl().on('click', function () {
	                                        commentInterpretation(this.up("panel").up("panel").down('#commentArea'), comment);
	                                    }, label);
	                                }
	                            }
	                        }, {
	                            xtype: 'label',
	                            text: '·',
	                            hidden: !comment,
	                            style: 'margin-left: 5px; margin-right: 5px;'
	                        }, {
	                            xtype: 'label',
	                            html: getLink(i18n.cancel),
	                            hidden: !comment,
	                            cls: 'link',
	                            listeners: {
	                                'render': function render(label) {
	                                    label.getEl().on('click', function () {
	                                        cancelCommentEdit(this, comment);
	                                    }, label);
	                                }
	                            }
	                        }]
	                    }],
	                    columnWidth: 0.89
	                }]
	            };
	        };
	
	        // Create inner comments panel depending on comments
	        var getCommentsPanel = function getCommentsPanel(comments) {
	
	            var commentsPanel = [];
	
	            // Textarea to comment
	            commentsPanel.push(getWriteCommentBox(null, true));
	
	            // Comments
	            // Sorting by last updated
	            (0, _arraySort2.default)(comments, 'DESC', 'lastUpdated');
	            for (var i = 0; i < comments.length; i++) {
	                var comment = comments[i];
	                commentsPanel.push({
	                    xtype: 'panel',
	                    bodyStyle: 'border-style:none;',
	                    id: 'commentContent-' + comment.id,
	                    cls: 'comment greyBackground',
	                    layout: 'column',
	                    hidden: i > numberOfCommentsToDisplay - 1,
	                    items: [{
	                        xtype: 'panel',
	                        bodyStyle: 'border-style:none',
	                        items: [{
	                            xtype: 'label',
	                            cls: 'avatar',
	                            text: comment.user.displayName.split(' ')[0][0] + comment.user.displayName.split(' ')[comment.user.displayName.split(' ').length - 1][0]
	                        }],
	                        columnWidth: 0.11
	                    }, {
	                        xtype: 'panel',
	                        bodyStyle: 'border-style:none',
	                        items: [{
	                            xtype: 'panel',
	                            style: 'margin-bottom: 3px;',
	                            bodyStyle: 'border-style:none',
	                            items: [{
	                                xtype: 'label',
	                                html: getLink(comment.user.displayName, true),
	                                cls: 'link bold',
	                                style: 'margin-right: 7px;',
	                                listeners: {
	                                    render: function render() {
	                                        this.getEl().on('click', function () {
	                                            window.location.href = path + '/dhis-web-messaging/profile.action?id=' + comment.user.id;
	                                        });
	                                    }
	                                }
	                            }, {
	                                xtype: 'label',
	                                text: comment.text
	                            }]
	                        }, {
	                            xtype: 'label',
	                            style: 'color: #666',
	                            text: _DateManager.DateManager.getTimeDifference(comment.lastUpdated) + ' ' + i18n.ago
	                        }, {
	                            xtype: 'label',
	                            html: getLink(i18n.edit),
	                            hidden: !userCanManageComment(comment),
	                            style: 'margin-right: 5px; margin-left: 5px',
	                            listeners: {
	                                'render': function (comment_) {
	                                    return function (label) {
	                                        label.getEl().on('click', function () {
	                                            editComment(this, comment_);
	                                        }, this);
	                                    };
	                                }(comment)
	                            }
	                        }, {
	                            xtype: 'label',
	                            text: '·',
	                            style: 'margin-right: 5px;'
	                        }, {
	                            xtype: 'label',
	                            html: getLink(i18n.delete_),
	                            style: 'margin-right: 5px;',
	                            hidden: !userCanManageComment(comment),
	                            listeners: {
	                                'render': function (comment_) {
	                                    return function (label) {
	                                        label.getEl().on('click', function () {
	                                            var label = this;
	                                            uiManager.confirmCommentDelete(function () {
	                                                deleteComment(label, comment_);
	                                            });
	                                        }, this);
	                                    };
	                                }(comment)
	                            }
	                        }],
	                        columnWidth: 0.89
	                    }]
	                });
	
	                // Box to edit the comment
	                commentsPanel.push(getWriteCommentBox(comment, false));
	            }
	
	            // Show more comments
	            if (comments.length > 3 && comments.length > numberOfCommentsToDisplay) {
	                commentsPanel.push({
	                    xtype: 'panel',
	                    bodyStyle: 'border-style:none',
	                    style: 'margin-top: 1px;',
	                    cls: 'comment greyBackground',
	                    items: [{
	                        xtype: 'label',
	                        text: '[' + (comments.length - numberOfCommentsToDisplay) + ' ' + i18n.more_comments + ']',
	                        cls: 'link',
	                        listeners: {
	                            'render': function render(label) {
	                                label.getEl().on('click', function () {
	                                    numberOfCommentsToDisplay += 3;
	                                    this.up('#interpretationPanel' + interpretation.id).updateInterpretationPanelItems();
	                                }, label);
	                            }
	                        }
	                    }]
	                });
	            }
	
	            return commentsPanel;
	        };
	
	        // User has liked this interpretation -> true
	        // Otherwise -> false
	        var isLiked = function isLiked(interpretation) {
	            var userId = appManager.userAccount.id;
	            for (var i = 0; i < interpretation.likedBy.length; i++) {
	                if (interpretation.likedBy[i].id == userId) {
	                    return true;
	                }
	            }
	            return false;
	        };
	
	        var refreshInterpretationDataModel = function refreshInterpretationDataModel(interpretationPanel) {
	            Ext.Ajax.request({
	                url: encodeURI(apiPath + '/interpretations/' + interpretation.id + '.json?fields=*,user[id,displayName],likedBy[id,displayName],comments[id,lastUpdated,text,user[id,displayName]]'),
	                method: 'GET',
	                scope: this,
	                success: function success(r) {
	                    // Refreshing interpretation panel
	                    interpretation = JSON.parse(r.responseText);
	                    interpretationPanel.updateInterpretationPanelItems(interpretation);
	                }
	            });
	        };
	
	        // Call Like or Unlike interpretation, update data model and update/reload panel
	        var likeUnlikeInterpretation = function likeUnlikeInterpretation() {
	            var that = this;
	            if (isLiked(interpretation)) {
	                Ext.Ajax.request({
	                    url: encodeURI(apiPath + '/interpretations/' + interpretation.id + '/like'),
	                    method: 'DELETE',
	                    success: function success() {
	                        refreshInterpretationDataModel(that.up('#interpretationPanel' + interpretation.id));
	                    }
	                });
	            } else {
	                Ext.Ajax.request({
	                    url: encodeURI(apiPath + '/interpretations/' + interpretation.id + '/like'),
	                    method: 'POST',
	                    success: function success() {
	                        refreshInterpretationDataModel(that.up('#interpretationPanel' + interpretation.id));
	                    }
	                });
	            }
	        };
	
	        // Call comment interpretation, update data model and update/reload panel
	        var commentInterpretation = function commentInterpretation(f, comment) {
	            var text = f.getValue();
	
	            if (text.trim() != '') {
	                var commentsUrl = encodeURI(apiPath + '/interpretations/' + interpretation.id + '/comments');
	                Ext.Ajax.request({
	                    url: comment ? commentsUrl + '/' + comment.id : commentsUrl,
	                    method: comment ? 'PUT' : 'POST',
	                    params: text,
	                    headers: {
	                        'Content-Type': 'text/plain'
	                    },
	                    success: function success() {
	                        refreshInterpretationDataModel(f.up('#interpretationPanel' + interpretation.id));
	                    }
	                });
	            }
	        };
	
	        // Update an interpretation update data model and update/reload panel
	        var editInterpretation = function editInterpretation(el) {
	            openInterpretationWindow(null, interpretation, function () {
	                var interpretationPanel = el.up('#interpretationPanel' + interpretation.id);
	                interpretationPanel.updateInterpretationPanelItems(interpretation);
	            });
	        };
	
	        // Delete an interpretation and return to main interpretations panel
	        var deleteInterpretation = function deleteInterpretation() {
	            Ext.Ajax.request({
	                url: encodeURI(apiPath + '/interpretations/' + interpretation.id),
	                method: 'DELETE',
	                success: function success() {
	                    instanceManager.getById(instanceManager.getStateCurrent().id);
	                }
	            });
	        };
	
	        // Delete a comment interpretation, update data model and update/reload panel
	        var deleteComment = function deleteComment(el, comment) {
	            Ext.Ajax.request({
	                url: encodeURI(apiPath + '/interpretations/' + interpretation.id + '/comments/' + comment.id),
	                method: 'DELETE',
	                success: function success() {
	                    refreshInterpretationDataModel(el.up('#interpretationPanel' + interpretation.id));
	                }
	            });
	        };
	
	        var editComment = function editComment(label, comment) {
	            var commentBox = label.up('#commentContent-' + comment.id);
	            var editableCommentBox = commentBox.next();
	            commentBox.hide();
	            editableCommentBox.show();
	        };
	
	        var cancelCommentEdit = function cancelCommentEdit(label, comment) {
	            var editableCommentBox = label.up('#commentPanel-' + comment.id);
	            var commentBox = editableCommentBox.prev();
	            editableCommentBox.hide();
	            commentBox.show();
	        };
	
	        // Create tooltip for Like link
	        var getTooltipLike = function getTooltipLike() {
	            var toolTipLike = "";
	            for (var i = 0; i < interpretation.likedBy.length; i++) {
	                toolTipLike += interpretation.likedBy[i].displayName + "</br>";
	            }
	            return toolTipLike;
	        };
	
	        // Get inner items for interpretation panel.
	        var getInterpretationPanelItems = function getInterpretationPanelItems(interpretation, displayingComments) {
	
	            var interpretationPanelItems = [{
	                xtype: 'panel',
	                bodyStyle: 'border-style:none',
	                style: 'margin-bottom: 6px;',
	                items: [{
	                    xtype: 'label',
	                    html: getLink(interpretation.user.displayName, true),
	                    style: 'margin-right:7px;',
	                    listeners: {
	                        render: function render() {
	                            var element = this.getEl();
	
	                            element.on('click', function () {
	                                window.location.href = path + '/dhis-web-messaging/profile.action?id=' + interpretation.user.id;
	                            });
	                        }
	                    }
	                }, {
	                    xtype: 'label',
	                    style: 'color:#666',
	                    text: _DateManager.DateManager.getYYYYMMDD(interpretation.lastUpdated, true)
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none',
	                style: 'margin-bottom: 8px;',
	                items: [{
	                    xtype: 'label',
	                    text: interpretation.text
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none',
	                cls: 'likeContainer',
	                itemId: 'likePanelUnselected',
	                hidden: displayingComments,
	                items: [{
	                    xtype: 'label',
	                    html: '<div class="thumbs_up greyBackground">' + interpretation.likes + ' ' + i18n.people_like_this + '<span style="padding:0 5px">·</span>' + interpretation.comments.length + ' ' + i18n.people_commented + '</div>'
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none',
	                style: 'margin-top: 1px;',
	                itemId: 'likePanelSelected',
	                hidden: !displayingComments,
	
	                items: [{
	                    xtype: 'panel',
	                    bodyStyle: 'border-style:none',
	                    style: 'margin-bottom: 5px;',
	                    hidden: !layout || layout.permission === "none",
	
	                    items: [{
	                        xtype: 'label',
	                        html: isLiked(interpretation) ? getLink(i18n.unlike) : getLink(i18n.like),
	                        style: 'margin-right: 5px;',
	                        listeners: {
	                            'render': function render(label) {
	                                label.getEl().on('click', likeUnlikeInterpretation, this);
	                            }
	                        }
	                    }, {
	                        xtype: 'label',
	                        text: '·',
	                        style: 'margin-right: 5px;'
	                    }, {
	                        xtype: 'label',
	                        html: getLink(i18n.comment),
	                        style: 'margin-right: 5px;',
	                        listeners: {
	                            'render': function render(label) {
	                                label.getEl().on('click', function () {
	                                    this.up('#interpretationPanel' + interpretation.id).down('#commentPanel-new').show();
	                                    this.up('#interpretationPanel' + interpretation.id).down('#commentArea').focus();
	                                }, this);
	                            }
	                        }
	                    }, {
	                        xtype: 'label',
	                        text: '·',
	                        style: 'margin-right: 5px;'
	                    }, {
	                        xtype: 'label',
	                        html: getLink(i18n.edit),
	                        hidden: !userCanManageInterpretation(interpretation),
	                        style: 'margin-right: 5px;',
	                        listeners: {
	                            'render': function render(label) {
	                                label.getEl().on('click', function () {
	                                    editInterpretation(this);
	                                }, this);
	                            }
	                        }
	                    }, {
	                        xtype: 'label',
	                        text: '·',
	                        style: 'margin-right: 5px;'
	                    }, {
	                        xtype: 'label',
	                        html: getLink(i18n.delete_),
	                        hidden: !userCanManageInterpretation(interpretation),
	                        style: 'margin-right: 5px;',
	                        listeners: {
	                            'render': function render(label) {
	                                label.getEl().on('click', function () {
	                                    uiManager.confirmInterpretationDelete(function () {
	                                        deleteInterpretation();
	                                    });
	                                }, this);
	                            }
	                        }
	                    }]
	                }, {
	                    xtype: 'panel',
	                    bodyStyle: 'border-style:none',
	                    cls: 'likeContainer',
	                    items: [{
	                        xtype: 'label',
	                        html: '<div class="thumbs_up greyBackground">' + getLink(interpretation.likes + ' ' + i18n.people) + ' ' + i18n.like_this + '</div>',
	                        listeners: {
	                            'render': function render(label) {
	
	                                if (interpretation.likedBy.length > 0) {
	                                    Ext.create('Ext.tip.ToolTip', {
	                                        target: label.getEl(),
	                                        html: getTooltipLike(),
	                                        bodyStyle: 'background-color: white;border'
	                                    });
	                                }
	                            }
	                        }
	                    }]
	                }]
	            }, {
	                xtype: 'panel',
	                hidden: !displayingComments,
	                bodyStyle: 'border-style:none',
	                itemId: 'comments',
	                items: [getCommentsPanel(interpretation.comments)]
	            }];
	            return interpretationPanelItems;
	        };
	
	        // Interpretation panel per single interpretation
	        var interpretationPanel = {
	            xtype: 'panel',
	            bodyStyle: 'border-style:none;',
	            style: 'padding:6px; border-bottom:1px solid #d0d0d0;',
	            cls: 'clickable',
	            instanceManager: instanceManager,
	            interpretation: interpretation,
	            displayingComments: displayingComments,
	            itemId: 'interpretationPanel' + interpretation.id,
	
	            // Update inner interpretation panel items depending on interpretation. If none is provided, previously store one will be used
	            updateInterpretationPanelItems: function updateInterpretationPanelItems(interpretation) {
	                if (interpretation != undefined) {
	                    this.interpretation = interpretation;
	                }
	                this.removeAll(true);
	                this.add(getInterpretationPanelItems(this.interpretation, this.displayingComments));
	
	                // Remove pointer effect. This is not clickable any more
	                if (this.displayingComments) {
	                    this.removeCls('clickable');
	                } else {
	                    this.addCls('clickable');
	                }
	            },
	
	            // Expand comments on click
	            expandComments: function expandComments() {
	                if (!this.displayingComments) {
	                    for (var i = 0; i < this.up("#interpretationsPanel").items.items.length; i++) {
	                        if (this.up("#interpretationsPanel").items.items[i].interpretation != undefined) {
	                            this.up("#interpretationsPanel").items.items[i].displayingComments = this.up("#interpretationsPanel").items.items[i].id == this.id;
	                            //this.up("#interpretationsPanel").items.items[i].numberOfCommentsToDisplay = 3;
	                            this.up("#interpretationsPanel").items.items[i].updateInterpretationPanelItems();
	                        }
	                    }
	
	                    // Swop top panel
	                    this.up("[xtype='panel']").down('#shareInterpretation').hide();
	                    this.up("[xtype='panel']").down('#backToToday').show();
	
	                    // Update canvas with favorite as it was by the time the interpretation was created
	                    uiManager.updateInterpretation(interpretation);
	                }
	            },
	
	            items: getInterpretationPanelItems(interpretation, displayingComments),
	
	            listeners: {
	                'render': function render(panel) {
	                    panel.body.on('click', this.expandComments, this);
	                },
	                scope: interpretationPanel
	            }
	        };
	        return interpretationPanel;
	    };
	
	    var getTopInterpretationsPanel = function getTopInterpretationsPanel(layout, interpretations, displayingInterpretation) {
	        var topInterpretationPanelItems = [];
	
	        var shareInterpretationPanel = {
	            xtype: 'panel',
	            bodyStyle: 'border-style:none',
	            style: 'padding:6px; border-width:0 0 1px 0; border-style:solid;',
	            hidden: displayingInterpretation || !layout || layout.permission === "none",
	            itemId: 'shareInterpretation',
	            items: [{
	                xtype: 'label',
	                html: getLink(i18n.write_interpretation),
	                cls: 'interpretationActions',
	                listeners: {
	                    'render': function render(label) {
	                        label.getEl().on('click', function () {
	                            openInterpretationWindow();
	                        }, label);
	                    }
	                }
	            }]
	        };
	
	        var noInterpretationsPanel = {
	            xtype: 'panel',
	            bodyStyle: 'border-style:none',
	            style: 'padding:6px; border-width:0; border-bottom:1px solid #d0d0d0',
	            items: [{
	                xtype: 'label',
	                text: i18n.no_interpretations,
	                cls: 'interpretationActions'
	            }]
	        };
	
	        var backToTodayPanel = {
	            xtype: 'panel',
	            bodyStyle: 'border-style:none',
	            style: 'padding:6px; border:1px solid #dadada; border-width:0 0 1px 0;',
	            hidden: !displayingInterpretation,
	            itemId: 'backToToday',
	            items: [{
	                xtype: 'label',
	                html: getLink('<< ' + i18n.clear_interpretation),
	                cls: 'interpretationActions link',
	                listeners: {
	                    'render': function render(label) {
	                        label.getEl().on('click', function () {
	                            instanceManager.getById(instanceManager.getStateCurrent().id);
	                        }, label);
	                    }
	                }
	            }]
	        };
	
	        if (instanceManager.isStateFavorite() && !instanceManager.isStateDirty()) {
	            // Interpretations Panel when no favorite is loaded
	            topInterpretationPanelItems.push(shareInterpretationPanel);
	
	            if (interpretations == undefined) {
	                // Interpretations Panel when no favorite is loaded
	                topInterpretationPanelItems.push(noInterpretationsPanel);
	            } else {
	                topInterpretationPanelItems.push(backToTodayPanel);
	            }
	        } else {
	            topInterpretationPanelItems.push(noInterpretationsPanel);
	        }
	
	        // Add Share/Back to Today Panel.
	        // If displayingInterpretation on canvas -> Back to Today
	        // Otherwise -> Share Interpretation
	        var topInterpretationPanel = {
	            xtype: 'panel',
	            bodyStyle: 'border-style:none',
	            style: 'border-width:0',
	            items: topInterpretationPanelItems
	        };
	
	        return topInterpretationPanel;
	    };
	
	    // Main Interpretations Panel Container
	    var interpretationsPanel = {
	        xtype: 'panel',
	        cls: 'ns-panel-title-east-default',
	        bodyStyle: 'border-bottom-width: 0',
	        title: i18n.interpretations,
	        itemId: 'interpretationsPanel',
	        displayingInterpretation: false,
	
	        getInterpretationPanel: getInterpretationPanel,
	        getTopInterpretationsPanel: getTopInterpretationsPanel,
	
	        addAndUpdateInterpretationsPanel: function addAndUpdateInterpretationsPanel(layout) {
	            layout = layout || {};
	
	            // Remove any previous panel
	            this.removeAll(true);
	
	            var interpretations = layout.interpretations;
	            var interpretationId = layout.interpretationId;
	
	            //Get top interpretations panel depending on interpretations and if we are displaying an interpretation
	            this.add(this.getTopInterpretationsPanel(layout, interpretations, interpretationId != undefined));
	
	            // Add an interpretation panel per interpretation
	            if (interpretations != undefined && interpretations.length > 0) {
	                for (var i = 0; i < interpretations.length; i++) {
	                    if (interpretations[i].id == interpretationId || interpretationId == undefined) {
	                        this.add(this.getInterpretationPanel(layout, interpretations[i], interpretations[i].id == interpretationId));
	                    }
	                }
	            }
	        },
	
	        // By default no interpretations panel is displayed
	        items: getTopInterpretationsPanel()
	    };
	
	    /*
	     * RIGHT PANEL CONTAINER
	     */
	    var rightPanel = Ext.create('Ext.panel.Panel', {
	        region: 'east',
	        openInterpretationWindow: openInterpretationWindow,
	        preventHeader: true,
	        collapsible: true,
	        collapseMode: 'mini',
	        collapsed: true,
	        border: false,
	        width: uiConfig.west_width + uiManager.getScrollbarSize().width,
	        items: [detailsPanel, interpretationsPanel],
	        cls: 'eastPanel',
	        setState: function setState(layout) {
	            this.getComponent('detailsPanel').addAndUpdateFavoritePanel(layout);
	
	            // Favorite loaded with interpretations ->  Add interpretation panel and update
	
	            this.getComponent('interpretationsPanel').addAndUpdateInterpretationsPanel(layout);
	        },
	        listeners: {
	            expand: function expand() {
	                this.doLayout();
	            }
	        }
	    });
	
	    return rightPanel;
	};
	//# sourceMappingURL=EastRegion.js.map

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FavoriteButton = undefined;
	
	var _FavoriteWindow = __webpack_require__(37);
	
	var _RenameWindow = __webpack_require__(38);
	
	var _SharingWindow = __webpack_require__(26);
	
	var _InterpretationWindow = __webpack_require__(25);
	
	var _LinkWindow = __webpack_require__(159);
	
	var _TranslateWindow = __webpack_require__(163);
	
	var FavoriteButton = exports.FavoriteButton = undefined;
	
	exports.FavoriteButton = FavoriteButton = function FavoriteButton(c) {
	    var appManager = c.appManager,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        i18n = c.i18nManager.get();
	
	    return Ext.create('Ext.button.Button', {
	        text: i18n.favorites,
	        menu: {},
	        handler: function handler(b) {
	            b.menu = Ext.create('Ext.menu.Menu', {
	                closeAction: 'destroy',
	                shadow: false,
	                showSeparator: false,
	                items: function () {
	                    var getTitle = function getTitle(text) {
	                        return text + '&nbsp;&nbsp;&nbsp;';
	                    };
	
	                    var newItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.new_),
	                        iconCls: 'ns-menu-item-favorite-new',
	                        disabled: !instanceManager.isStateCurrent(),
	                        handler: function handler() {
	                            if (instanceManager.isStateUnsaved()) {
	                                uiManager.confirmUnsaved(i18n.new_favorite, function () {
	                                    instanceManager.setState();
	                                });
	                            } else {
	                                instanceManager.setState();
	                            }
	                        }
	                    });
	                    uiManager.reg(newItem, 'newItem');
	
	                    var openItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.open),
	                        iconCls: 'ns-menu-item-favorite-open',
	                        handler: function handler() {
	                            uiManager.reg((0, _FavoriteWindow.FavoriteWindow)(c, 'open'), 'favoriteWindow').show();
	                        }
	                    });
	                    uiManager.reg(openItem, 'openItem');
	
	                    var saveItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.save),
	                        iconCls: 'ns-menu-item-favorite-save',
	                        disabled: !instanceManager.isStateDirty(),
	                        handler: function handler() {
	                            var layout = instanceManager.getStateCurrent(),
	                                favorite = instanceManager.getStateFavorite();
	
	                            if (!favorite) {
	                                saveAsItem.handlerFn();
	                                return;
	                            }
	
	                            layout.apply(favorite, ['id', 'name', 'description']);
	
	                            layout.clone().put(layout.id, function () {
	                                instanceManager.getById(layout.id, function (layout, isFavorite) {
	                                    instanceManager.getReport(layout, isFavorite, false, false, function () {
	                                        uiManager.unmask();
	                                    });
	                                });
	                            }, true, true);
	                        }
	                    });
	                    uiManager.reg(saveItem, 'saveItem');
	
	                    var saveAsItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.save_as),
	                        iconCls: 'ns-menu-item-favorite-save',
	                        disabled: !instanceManager.isStateCurrent(),
	                        handlerFn: function handlerFn() {
	                            (0, _FavoriteWindow.FavoriteWindow)(c, 'saveas').show();
	                        },
	                        handler: function handler() {
	                            this.handlerFn();
	                        }
	                    });
	                    uiManager.reg(saveAsItem, 'saveAsItem');
	
	                    var renameItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.rename),
	                        iconCls: 'ns-menu-item-favorite-rename',
	                        disabled: !instanceManager.isStateFavorite(),
	                        handler: function handler() {
	                            (0, _RenameWindow.RenameWindow)(c, instanceManager.getStateFavorite()).show();
	                        }
	                    });
	                    uiManager.reg(saveAsItem, 'renameItem');
	
	                    var translateItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.translate),
	                        iconCls: 'ns-menu-item-favorite-translate',
	                        disabled: !instanceManager.isStateFavorite(),
	                        handler: function handler() {
	                            (0, _TranslateWindow.TranslateWindow)(c, instanceManager.getStateFavorite()).show();
	                        }
	                    });
	                    uiManager.reg(saveAsItem, 'translateItem');
	
	                    var shareItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.share),
	                        iconCls: 'ns-menu-item-favorite-share',
	                        disabled: function () {
	                            var fav = instanceManager.getStateFavorite();
	
	                            if (fav && (!fav.getAccess() || fav.getAccess().manage)) {
	                                return false;
	                            }
	
	                            return true;
	                        }(),
	                        handler: function handler() {
	                            instanceManager.getSharingById(instanceManager.getStateFavoriteId(), function (r) {
	                                (0, _SharingWindow.SharingWindow)(c, r).show();
	                            });
	                        }
	                    });
	                    uiManager.reg(interpretationItem, 'interpretationItem');
	
	                    var interpretationItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.write_interpretation),
	                        iconCls: 'ns-menu-item-favorite-interpretation',
	                        disabled: !instanceManager.isStateFavorite(),
	                        handler: function handler() {
	                            instanceManager.getSharingById(instanceManager.getStateFavoriteId(), function (r) {
	                                (0, _InterpretationWindow.InterpretationWindow)(c, r).show();
	                            });
	                        }
	                    });
	                    uiManager.reg(interpretationItem, 'interpretationItem');
	
	                    var linkItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.get_link),
	                        iconCls: 'ns-menu-item-favorite-link',
	                        disabled: !instanceManager.isStateFavorite(),
	                        handler: function handler() {
	                            (0, _LinkWindow.LinkWindow)(c).show();
	                        }
	                    });
	                    uiManager.reg(linkItem, 'linkItem');
	
	                    var deleteItem = Ext.create('Ext.menu.Item', {
	                        text: getTitle(i18n.delete_),
	                        iconCls: 'ns-menu-item-favorite-delete',
	                        disabled: !instanceManager.isStateFavorite(),
	                        handler: function handler() {
	                            uiManager.confirmDelete(i18n.delete_favorite, function () {
	                                instanceManager.getStateFavorite().del(function () {
	                                    instanceManager.setState();
	                                });
	                            });
	                        }
	                    });
	                    uiManager.reg(deleteItem, 'deleteItem');
	
	                    return [newItem, '-', openItem, '-', saveItem, saveAsItem, '-',
	                    //discardItem,
	                    //'-',
	                    renameItem, translateItem, '-', shareItem, interpretationItem, linkItem, '-', deleteItem];
	                }(),
	                listeners: {
	                    show: function show() {
	                        uiManager.setAnchorPosition(b.menu, b);
	                    },
	                    hide: function hide() {
	                        b.menu.destroy();
	                    },
	                    destroy: function destroy(m) {
	                        b.menu = null;
	                    }
	                }
	            });
	
	            b.menu.show();
	        }
	    });
	};
	//# sourceMappingURL=FavoriteButton.js.map

/***/ },
/* 61 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var GridHeaders = exports.GridHeaders = undefined;
	
	exports.GridHeaders = GridHeaders = function GridHeaders(config) {
	    return Ext.create('Ext.toolbar.Toolbar', $.extend(config, {
	        cls: 'd2analysis-gridheaders'
	    }));
	};
	//# sourceMappingURL=GridHeaders.js.map

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InterpretationItem = undefined;
	
	var _InterpretationWindow = __webpack_require__(25);
	
	var InterpretationItem = exports.InterpretationItem = undefined;
	
	exports.InterpretationItem = InterpretationItem = function InterpretationItem(c) {
	    var instanceManager = c.instanceManager,
	        i18nManager = c.i18nManager,
	        i18n = c.i18nManager.get();
	
	    return Ext.create('Ext.menu.Item', {
	        text: i18n.write_interpretation + '&nbsp;&nbsp;',
	        iconCls: 'ns-menu-item-tablelayout',
	        disabled: true,
	        xable: function xable() {
	            this.setDisabled(!instanceManager.isStateSaved());
	        },
	        handler: function handler() {
	            (0, _InterpretationWindow.InterpretationWindow)(c).show();
	        }
	    });
	};
	//# sourceMappingURL=InterpretationItem.js.map

/***/ },
/* 63 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var PluginItem = exports.PluginItem = undefined;
	
	exports.PluginItem = PluginItem = function PluginItem(c) {
	    var appManager = c.appManager,
	        instanceManager = c.instanceManager,
	        uiManager = c.uiManager,
	        i18nManager = c.i18nManager,
	        i18n = c.i18nManager.get();
	
	    return Ext.create('Ext.menu.Item', {
	        text: i18n.embed_in_web_page + '&nbsp;&nbsp;',
	        iconCls: 'ns-menu-item-datasource',
	        disabled: true,
	        xable: function xable() {
	            this.setDisabled(!instanceManager.isStateCurrent());
	        },
	        handler: function handler() {
	            var textArea,
	                window,
	                text = '',
	                version = 'v' + parseFloat(appManager.systemInfo.version.split('.').join('')),
	                layout = instanceManager.getStateCurrent();
	
	            text += '<html>\n<head>\n';
	            text += '<link rel="stylesheet" href="//dhis2-cdn.org/' + version + '/ext/resources/css/ext-plugin-gray.css" />\n';
	            text += '<script src="//dhis2-cdn.org/' + version + '/ext/ext-all.js"></script>\n';
	            text += '<script src="//dhis2-cdn.org/' + version + '/plugin/table.js"></script>\n';
	            text += '</head>\n\n<body>\n';
	            text += '<div id="table1"></div>\n\n';
	            text += '<script>\n\n';
	            text += 'Ext.onReady(function() {\n\n';
	            text += 'DHIS.getTable(' + JSON.stringify(layout.toPlugin('table1'), null, 2) + ');\n\n';
	            text += '});\n\n';
	            text += '</script>\n\n';
	            text += '</body>\n</html>';
	
	            textArea = Ext.create('Ext.form.field.TextArea', {
	                width: 700,
	                height: 400,
	                readOnly: true,
	                cls: 'ns-textarea monospaced',
	                value: text
	            });
	
	            window = Ext.create('Ext.window.Window', {
	                title: i18n.embed_in_web_page + (layout.displayName ? '<span style="font-weight:normal">&nbsp;|&nbsp;&nbsp;' + layout + '</span>' : ''),
	                layout: 'fit',
	                modal: true,
	                resizable: false,
	                items: textArea,
	                destroyOnBlur: true,
	                bbar: ['->', {
	                    text: 'Select',
	                    handler: function handler() {
	                        textArea.selectText();
	                    }
	                }],
	                listeners: {
	                    show: function show(w) {
	                        uiManager.setAnchorPosition(w, 'shareButton');
	
	                        uiManager.enableRightClick();
	
	                        if (!w.hasDestroyOnBlurHandler) {
	                            uiManager.addDestroyOnBlurHandler(w);
	                        }
	                    },
	                    hide: function hide() {
	                        uiManager.disableRightClick();
	                    }
	                }
	            });
	
	            window.show();
	        }
	    });
	};
	//# sourceMappingURL=PluginItem.js.map

/***/ },
/* 64 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDefined;
	/**
	 * Check if `param` is defined.
	 *
	 * @param {*} param The value to check
	 * @returns {boolean} Returns `false` when `param` is `undefined` otherwise true.
	 */
	function isDefined(param) {
	  return typeof param !== 'undefined';
	}
	//# sourceMappingURL=isDefined.js.map

/***/ },
/* 65 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = numberConstrain;
	/**
	 * Constrains the value between the passed min and max
	 *
	 * @param {Number} number The value to be constrained
	 * @param {Number} min The minumum number that the value should be within
	 * @param {Number} max The maximum number that the value should be within
	 * @returns {Number|*} The resulting number
	 */
	function numberConstrain(number, min, max) {
	    number = parseFloat(number);
	
	    if (!isNaN(min)) {
	        number = Math.max(number, min);
	    }
	    if (!isNaN(max)) {
	        number = Math.min(number, max);
	    }
	    return number;
	}
	//# sourceMappingURL=numberConstrain.js.map

/***/ },
/* 66 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = objectApplyIf;
	/**
	 * Applies properties from "config" if they are undefined in "object.
	 *
	 * @param {Object} object The object to receive properties
	 * @param {Object} config The object to pass properties
	 * @returns {Object} The object that may have received properties
	 *
	 * @example
	 * let object = {id: 1}
	 * const config = {id: 2, name: 'Name'}
	 * objectApplyIf(object, config); // returns: {id: 1, name: 'Name'}
	 */
	function objectApplyIf(object, config) {
	    var property;
	
	    if (object) {
	        for (property in config) {
	            if (object[property] === undefined) {
	                object[property] = config[property];
	            }
	        }
	    }
	
	    return object;
	}
	//# sourceMappingURL=objectApplyIf.js.map

/***/ },
/* 67 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stringReplaceAll;
	/**
	 * Replace all occurrences of the `matchValue` within the `str` parameter.
	 *
	 * @param {string} str The string to operate on
	 * @param {string} matchValue The value to match on
	 * @param {string|function} replaceValue The value to replace the matches with
	 * @param {boolean} ignore Case sensitivity ignore flag. Pass `true` to ignore case. (Defaults to `false`)
	 * @returns {XML|void|string|*} The resulting string.
	 */
	function stringReplaceAll(str, matchValue, replaceValue, ignore) {
	  return str.replace(new RegExp(matchValue.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"), ignore ? "gi" : "g"), typeof replaceValue == "string" ? replaceValue.replace(/\$/g, "$$$$") : replaceValue);
	}
	//# sourceMappingURL=stringReplaceAll.js.map

/***/ },
/* 68 */
12,
/* 69 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * Check if a number is finite
	 *
	 * @param param Number to be checked
	 * @returns {boolean} Returns true when the `param` is a finite number
	 */
	exports.default = Number.isFinite || function (param) {
	  return typeof param === 'number' && global.isFinite(param);
	};
	//# sourceMappingURL=numberIsFinite.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 70 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a boolean primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isBoolean(false);
	 * // => true
	 *
	 * _.isBoolean(null);
	 * // => false
	 */
	function isBoolean(value) {
	  return value === true || value === false ||
	    (isObjectLike(value) && objectToString.call(value) == boolTag);
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isBoolean;


/***/ },
/* 71 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array constructors, and
	  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isFunction;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(78)(module)))

/***/ },
/* 73 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(78)(module)))

/***/ },
/* 75 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AkbCSEONG4ApgAAALZJREFUOMtjYBgFgwwoyckHqsgrJOKWl1NRkpefhizGhMxhZGR48J+BYZ6irFwxhmZ5OQ1GRqbzjP8ZHuN1hbKcopWSvMJ/JTnFKJiYvKycuLK8whtFeYWl6OoZsRoir+DAwMCwn4GBIZr5N9P2v6z/bv1jYFh//+GDNKIMYGBgYFCUl3di+Pd/LyMj0xNGhn8X7z565INNHTMuAz58/HhfSEDgLCMjo/iHv38Dv3/+9H80mWEHAFxcLtq0p2COAAAAAElFTkSuQmCC"

/***/ },
/* 76 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMeChwOIa4e0gAAAQtJREFUOMvlkj9Kg0EQxd8slsFGsfLbN/uNImhhsBeskjqFCCJY24mFNhYqXsUbiBfQIyiIIEo8hH+za5PE1Zg9gL7yN7zHm9kF/pfqKmyaZztnRs7V1PVxzP0MCVVoi6SzJHjNDIuA3CXBdIllTXTDvKaabOUGo74E6nGJfTXxodUPWcsM80aNSj0psawJO/2Q4V1MuWLU50DdLbGBHACIk20IuuldLoeTXtoC0JMUL4osD/LNpU4Eum4CN4PB/VN3T1I8EHG3Rt8cx35/duq5eX0Iszo5XKfyh0a+Gf1yiY0evdIr8/o4U1fuu1GjkQvj2Mg/anBqNQHXjQ93lK15KjHuIGG/xP6oPgFIPWmq9LOmhgAAAABJRU5ErkJggg=="

/***/ },
/* 77 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMeCh401ZSl4gAAASJJREFUOMvl0L9KA0EQx/HfXgwBiyPETryZ2Z2YIiAKtgqxiaCFjWDhA4j4CjYGbH0DBcEHsAiIpfoUgnIEW8EYBP+AtxZKitxl7XXKT/HdmQX+9ijxcT2hnd/MEXccSXduadGMNkoAUKtWb2Gii1ocfz4Nnq/HWXkqvqpk0eF7/3WzP+ifFG/FNK/MH5rQfsjsjMRKkjqW7vgTmRaUJasT7YXs+3RJLcvNysa6KYw5ooayvGhCRyGz0zKpLD1lOQeAaDTkTbQGoISSOQuZKftleJDP/GluG2HpKEumzLMhc8wtJfGWbDsXsSwHyvKmzM2QOea2kniXyFY+IrL782ozZMNNErs62pgAAOPxCPjGfa93N/yDYqt4b7bTh/QS/2e+APm4a833Y1DsAAAAAElFTkSuQmCC"

/***/ },
/* 78 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 79 */
[566, 10, 19, 14],
/* 80 */
17,
/* 81 */
18,
/* 82 */,
/* 83 */,
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Dimension = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _arrayContains = __webpack_require__(40);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayUnique = __webpack_require__(68);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	var _isString = __webpack_require__(14);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isBoolean = __webpack_require__(41);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isObject = __webpack_require__(19);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isEmpty = __webpack_require__(31);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _d2Analysis = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dimension = exports.Dimension = function Dimension(refs, c, applyConfig, forceApplyConfig) {
	    var t = this;
	
	    var _ignoreUrlDimensions = ['dy', 'longitude', 'latitude'];
	
	    c = (0, _isObject2.default)(c) ? c : {};
	
	    // inherit
	    _extends(t, new _d2Analysis.Dimension(refs, c, applyConfig));
	
	    // props
	    if ((0, _isString2.default)(c.filter)) {
	        t.filter = c.filter;
	    }
	
	    if ((0, _isString2.default)(c.name)) {
	        t.name = c.name;
	    }
	
	    if ((0, _isObject2.default)(c.legendSet)) {
	        t.legendSet = c.legendSet;
	    }
	
	    // force apply
	    _extends(t, forceApplyConfig);
	
	    t.getIgnoreUrlDimensions = function () {
	        return _ignoreUrlDimensions;
	    };
	
	    t.getRefs = function () {
	        return refs;
	    };
	};
	
	Dimension.prototype = _d2Analysis.Dimension.prototype;
	
	Dimension.prototype.isIgnoreDimension = function () {
	    return (0, _arrayContains2.default)(this.getIgnoreUrlDimensions(), this.dimension);
	};
	
	// dep 1
	
	Dimension.prototype.url = function (isSorted, response, isFilter) {
	    if (this.isIgnoreDimension()) {
	        return '';
	    }
	
	    var url = (isFilter ? 'filter' : 'dimension') + '=' + this.dimension;
	
	    if ((0, _isObject2.default)(this.legendSet)) {
	        url += '-' + this.legendSet.id;
	    }
	
	    var records = (0, _arrayUnique2.default)(this.getRecordIds(isSorted, response, true));
	
	    if (records.length) {
	        url += ':' + records.join(';');
	    }
	
	    if ((0, _isString2.default)(this.filter)) {
	        url += ':' + this.filter;
	    }
	
	    return url;
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Layout = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isArray = __webpack_require__(10);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isBoolean = __webpack_require__(41);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isEmpty = __webpack_require__(31);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isNumber = __webpack_require__(43);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isNumeric = __webpack_require__(81);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _isObject = __webpack_require__(19);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(14);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _d2Analysis = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = exports.Layout = function Layout(refs, c, applyConfig, forceApplyConfig) {
	    var t = this;
	
	    c = (0, _isObject2.default)(c) ? c : {};
	
	    // inherit
	    _extends(t, new _d2Analysis.Layout(refs, c, applyConfig));
	
	    // program
	    t.program = (0, _isObject2.default)(c.program) ? c.program : null;
	    t.programStage = (0, _isObject2.default)(c.programStage) ? c.programStage : null;
	
	    // data type
	    t.dataType = (0, _isString2.default)(c.dataType) ? c.dataType : refs.dimensionConfig.getDefaultDataType();
	
	    // options
	    t.showColTotals = (0, _isBoolean2.default)(c.colTotals) ? c.colTotals : (0, _isBoolean2.default)(c.showColTotals) ? c.showColTotals : true;
	    t.showRowTotals = (0, _isBoolean2.default)(c.rowTotals) ? c.rowTotals : (0, _isBoolean2.default)(c.showRowTotals) ? c.showRowTotals : true;
	    t.showColSubTotals = (0, _isBoolean2.default)(c.colSubTotals) ? c.colSubTotals : (0, _isBoolean2.default)(c.showColSubTotals) ? c.showColSubTotals : true;
	    t.showRowSubTotals = (0, _isBoolean2.default)(c.rowSubTotals) ? c.rowSubTotals : (0, _isBoolean2.default)(c.showRowSubTotals) ? c.showRowSubTotals : true;
	    t.showDimensionLabels = (0, _isBoolean2.default)(c.showDimensionLabels) ? c.showDimensionLabels : (0, _isBoolean2.default)(c.showDimensionLabels) ? c.showDimensionLabels : true;
	    t.showDataItemPrefix = (0, _isBoolean2.default)(c.showDataItemPrefix) ? c.showDataItemPrefix : (0, _isBoolean2.default)(c.showDataItemPrefix) ? c.showDataItemPrefix : true;
	    t.hideEmptyRows = (0, _isBoolean2.default)(c.hideEmptyRows) ? c.hideEmptyRows : false;
	    t.hideNaData = (0, _isBoolean2.default)(c.hideNaData) ? c.hideNaData : false;
	    t.collapseDataDimensions = (0, _isBoolean2.default)(c.collapseDataDimensions) ? c.collapseDataDimensions : false;
	    t.outputType = (0, _isString2.default)(c.outputType) ? c.outputType : refs.optionConfig.getOutputType('event').id;
	    t.programStatus = (0, _isString2.default)(c.programStatus) ? c.programStatus : refs.optionConfig.getProgramStatus('def').id;
	    t.eventStatus = (0, _isString2.default)(c.eventStatus) ? c.eventStatus : refs.optionConfig.getEventStatus('def').id;
	
	    t.topLimit = (0, _isNumeric2.default)(c.topLimit) ? c.topLimit : 0;
	    t.sortOrder = (0, _isNumber2.default)(c.sortOrder) ? c.sortOrder : 0;
	
	    t.completedOnly = (0, _isBoolean2.default)(c.completedOnly) ? c.completedOnly : false;
	    t.showHierarchy = (0, _isBoolean2.default)(c.showHierarchy) ? c.showHierarchy : false;
	
	    t.displayDensity = (0, _isString2.default)(c.displayDensity) && !(0, _isEmpty2.default)(c.displayDensity) ? c.displayDensity : refs.optionConfig.getDisplayDensity('normal').id;
	    t.fontSize = (0, _isString2.default)(c.fontSize) && !(0, _isEmpty2.default)(c.fontSize) ? c.fontSize : refs.optionConfig.getFontSize('normal').id;
	    t.digitGroupSeparator = (0, _isString2.default)(c.digitGroupSeparator) && !(0, _isEmpty2.default)(c.digitGroupSeparator) ? c.digitGroupSeparator : refs.optionConfig.getDigitGroupSeparator('space').id;
	    t.legendSet = (0, _isObject2.default)(c.legendSet) ? c.legendSet : null;
	
	    // value, aggregation type
	    if ((0, _isObject2.default)(c.value) && (0, _isString2.default)(c.value.id)) {
	        t.value = c.value;
	
	        if ((0, _isString2.default)(c.aggregationType)) {
	            t.aggregationType = c.aggregationType;
	        }
	    }
	
	    // paging
	    if ((0, _isObject2.default)(c.paging) && (0, _isNumeric2.default)(c.paging.pageSize) && (0, _isNumeric2.default)(c.paging.page)) {
	        t.paging = c.paging;
	    }
	
	    // graph map
	    t.parentGraphMap = (0, _isObject2.default)(c.parentGraphMap) ? c.parentGraphMap : null;
	
	    // report table
	    t.reportingPeriod = (0, _isObject2.default)(c.reportParams) && (0, _isBoolean2.default)(c.reportParams.paramReportingPeriod) ? c.reportParams.paramReportingPeriod : (0, _isBoolean2.default)(c.reportingPeriod) ? c.reportingPeriod : false;
	    t.organisationUnit = (0, _isObject2.default)(c.reportParams) && (0, _isBoolean2.default)(c.reportParams.paramOrganisationUnit) ? c.reportParams.paramOrganisationUnit : (0, _isBoolean2.default)(c.organisationUnit) ? c.organisationUnit : false;
	    t.parentOrganisationUnit = (0, _isObject2.default)(c.reportParams) && (0, _isBoolean2.default)(c.reportParams.paramParentOrganisationUnit) ? c.reportParams.paramParentOrganisationUnit : (0, _isBoolean2.default)(c.parentOrganisationUnit) ? c.parentOrganisationUnit : false;
	
	    // force apply
	    _extends(t, forceApplyConfig);
	
	    t.getRefs = function () {
	        return refs;
	    };
	};
	
	Layout.prototype = _d2Analysis.Layout.prototype;
	
	Layout.prototype.val = function () {
	    var t = this;
	
	    return t.program && t.programStage && (t.columns || t.rows) ? this : null;
	};
	
	Layout.prototype.clone = function () {
	    var t = this,
	        refs = this.getRefs();
	
	    var Layout = refs.api.Layout;
	
	
	    var layout = new Layout(refs, JSON.parse(JSON.stringify(t)));
	
	    layout.setResponse(t.getResponse());
	    layout.setAccess(t.getAccess());
	    layout.setDataDimensionItems(t.getDataDimensionItems());
	
	    return layout;
	};
	
	Layout.prototype.toPost = function () {
	    var t = this,
	        refs = t.getRefs();
	
	    var optionConfig = refs.optionConfig;
	
	    t.toPostSuper();
	
	    if (t.programStatus === optionConfig.getProgramStatus('def').id) {
	        delete t.programStatus;
	    }
	
	    if (t.eventStatus === optionConfig.getEventStatus('def').id) {
	        delete t.eventStatus;
	    }
	};
	
	Layout.prototype.getDataTypeUrl = function () {
	    var t = this,
	        refs = t.getRefs();
	
	    var dimensionConfig = refs.dimensionConfig;
	
	
	    var defaultDataTypeUrl = dimensionConfig.dataTypeUrl[dimensionConfig.getDefaultDataType()];
	
	    var url = dimensionConfig.dataTypeUrl[this.dataType] || defaultDataTypeUrl;
	
	    return url || '';
	};
	
	Layout.prototype.getProgramUrl = function () {
	    return (0, _isObject2.default)(this.program) ? '/' + this.program.id : '';
	};
	
	// dep 1
	
	Layout.prototype.req = function (source, format, isSorted, isTableLayout, isFilterAsDimension) {
	    var t = this,
	        refs = this.getRefs();
	
	    var Request = refs.api.Request;
	    var optionConfig = refs.optionConfig,
	        appManager = refs.appManager,
	        instanceManager = refs.instanceManager,
	        dimensionConfig = refs.dimensionConfig;
	
	
	    var request = new Request(refs);
	
	    var defAggTypeId = optionConfig.getAggregationType('def').id,
	        displayProperty = this.displayProperty || appManager.getAnalyticsDisplayProperty();
	
	    source = source || instanceManager.analyticsEndpoint + this.getDataTypeUrl() + this.getProgramUrl();
	
	    // dimensions
	    this.getDimensions(false, isSorted).forEach(function (dimension) {
	        request.add(dimension.url(isSorted));
	    });
	
	    // filters
	    if (this.filters) {
	        this.filters.forEach(function (dimension) {
	            var isFilter = !(isFilterAsDimension && dimension.isRequired());
	
	            request.add(dimension.url(isSorted, null, isFilter));
	        });
	    }
	
	    // stage
	    if ((0, _isObject2.default)(this.programStage)) {
	        request.add('stage=' + this.programStage.id);
	    }
	
	    // display property
	    request.add('displayProperty=' + displayProperty.toUpperCase());
	
	    // completed only
	    if (this.completedOnly) {
	        request.add('completedOnly=true');
	    }
	
	    // normal request only
	    if (!isTableLayout) {
	        // hierarchy
	        if (this.showHierarchy) {
	            request.add('hierarchyMeta=true');
	        }
	
	        // outputType type
	        if ((0, _isString2.default)(this.outputType)) {
	            request.add('outputType=' + this.outputType);
	        }
	
	        // program status
	        if ((0, _isString2.default)(this.programStatus) && this.programStatus !== optionConfig.getProgramStatus('def').id) {
	            request.add('programStatus=' + this.programStatus);
	        }
	
	        // event status
	        if ((0, _isString2.default)(this.eventStatus) && this.eventStatus !== optionConfig.getEventStatus('def').id) {
	            request.add('eventStatus=' + this.eventStatus);
	        }
	
	        // limit, sortOrder
	        if ((0, _isNumber2.default)(this.topLimit) && this.topLimit && this.dataType === dimensionConfig.dataType['aggregated_values']) {
	            request.add('limit=' + this.topLimit);
	
	            var sortOrder = (0, _isNumber2.default)(this.sortOrder) ? this.sortOrder : 1;
	
	            request.add('sortOrder=' + (sortOrder < 0 ? 'ASC' : 'DESC'));
	        }
	
	        // value, aggregationType
	        if (this.value) {
	            request.add('value=' + ((0, _isString2.default)(this.value) ? this.value : (0, _isObject2.default)(this.value) ? this.value.id : null));
	
	            if ((0, _isString2.default)(this.aggregationType)) {
	                request.add('aggregationType=' + this.aggregationType);
	            }
	        }
	
	        // collapse data items
	        if (this.collapseDataDimensions) {
	            request.add('collapseDataDimensions=true');
	        }
	
	        // dates
	        if ((0, _isString2.default)(this.startDate) && (0, _isString2.default)(this.endDate)) {
	            request.add('startDate=' + this.startDate);
	            request.add('endDate=' + this.endDate);
	        }
	
	        // user org unit
	        if ((0, _isArray2.default)(this.userOrgUnit) && this.userOrgUnit.length) {
	            request.add(this.getUserOrgUnitUrl());
	        }
	
	        // relative period date
	        if (this.relativePeriodDate) {
	            request.add('relativePeriodDate=' + this.relativePeriodDate);
	        }
	
	        // sorting
	        if ((0, _isObject2.default)(this.sorting) && this.dataType === dimensionConfig.dataType['individual_cases']) {
	            if ((0, _isString2.default)(this.sorting.direction) && (0, _isString2.default)(this.sorting.id)) {
	                request.add(this.sorting.direction.toLowerCase() + '=' + this.sorting.id);
	            }
	        }
	
	        // paging
	        if (this.dataType === dimensionConfig.dataType['individual_cases']) {
	            var paging = this.paging || {};
	
	            request.add('pageSize=' + (paging.pageSize || 100));
	            request.add('page=' + (paging.page || 1));
	        }
	    } else {
	        // table layout
	        request.add('tableLayout=true');
	
	        // columns
	        //request.add('columns=' + this.getDimensionNames(false, false, this.columns).join(';'));
	        request.add('columns=' + this.getDimensions(false, false, this.columns).filter(function (dim) {
	            return dim.dimension !== 'dy';
	        }).map(function (dim) {
	            return dim.dimension;
	        }).join(';'));
	
	        // rows
	        //request.add('rows=' + this.getDimensionNames(false, false, this.rows).join(';'));
	        request.add('rows=' + this.getDimensions(false, false, this.rows).filter(function (dim) {
	            return dim.dimension !== 'dy';
	        }).map(function (dim) {
	            return dim.dimension;
	        }).join(';'));
	
	        // hide empty columns
	        if (this.hideEmptyColumns) {
	            request.add('hideEmptyColumns=true');
	        }
	
	        // hide empty rows
	        if (this.hideEmptyRows) {
	            request.add('hideEmptyRows=true');
	        }
	
	        // show hierarchy
	        if (this.showHierarchy) {
	            request.add('showHierarchy=true');
	        }
	    }
	
	    // relative orgunits / user
	    if (this.hasRecordIds(appManager.userIdDestroyCacheKeys, true)) {
	        request.add('user=' + appManager.userAccount.id);
	    }
	
	    // base
	    request.setBaseUrl(this.getRequestPath(source, format));
	
	    return request;
	};
	
	// dep 2
	
	Layout.prototype.data = function (source, format) {
	    var t = this,
	        refs = this.getRefs();
	
	    var uiManager = refs.uiManager;
	
	    var request = t.req(source, format);
	
	    request.setType(t.getDefaultFormat());
	
	    request.setError(function (r) {
	        // 409
	        // DHIS2-2020: 503 error (perhaps analytics maintenance mode)
	        if ((0, _isObject2.default)(r) && (r.status == 409 || r.status == 503)) {
	            uiManager.unmask();
	
	            if ((0, _isString2.default)(r.responseText)) {
	                uiManager.alert(JSON.parse(r.responseText));
	            }
	        }
	    });
	
	    return request.run();
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InstanceManager = undefined;
	
	var _isFunction = __webpack_require__(80);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _d2Analysis = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.InstanceManager = _d2Analysis.InstanceManager;
	
	
	_d2Analysis.InstanceManager.prototype.getReport = function (layout, isFavorite, skipState, forceUiState, fn) {
	    var t = this,
	        refs = t.getRefs();
	
	    // var { indexedDbManager } = refs;
	
	    var Response = refs.api.Response;
	
	
	    var _fn = function _fn() {
	        if (!skipState) {
	            t.setState(layout, isFavorite, false, forceUiState);
	        }
	
	        (fn || t.getFn())(layout);
	    };
	
	    // layout
	    if (!layout) {
	        layout = t.getLayout();
	
	        if (!layout) {
	            return;
	        }
	    }
	
	    // validation
	    if ((0, _isFunction2.default)(layout.val) && !layout.val()) {
	        return;
	    }
	
	    t.uiManager.mask();
	
	    // response
	    var response = layout.getResponse();
	
	    // fn
	    if (response) {
	        _fn();
	    } else {
	        layout.data().done(function (res) {
	            layout.setResponse(new Response(refs, res));
	
	            _fn();
	
	            // (NO LONGER USING INDEXEDDB)
	
	            // var optionSetIds = res.headers.filter(h => !!h.optionSet).map(h => h.optionSet);
	
	            // var fn = function() {
	            // layout.setResponse(new Response(refs, res));
	
	            // _fn();
	            // };
	
	            // init
	            // if (optionSetIds.length) {
	            //     indexedDbManager.getOptionSets(optionSetIds, fn);
	            // }
	            // else {
	            //     fn();
	            // }
	        });
	    }
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(107);
	module.exports = __webpack_require__(20).Array.fill;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(108);
	module.exports = __webpack_require__(20).Array.find;

/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(21);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(52)
	  , toIndex  = __webpack_require__(105)
	  , toLength = __webpack_require__(51);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(47)
	  , IObject  = __webpack_require__(99)
	  , toObject = __webpack_require__(52)
	  , toLength = __webpack_require__(51)
	  , asc      = __webpack_require__(94);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(21)
	  , isArray  = __webpack_require__(100)
	  , SPECIES  = __webpack_require__(54)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(93);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 95 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(21)
	  , document = __webpack_require__(15).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 97 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(32) && !__webpack_require__(49)(function(){
	  return Object.defineProperty(__webpack_require__(96)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(46);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(46);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(90)
	  , IE8_DOM_DEFINE = __webpack_require__(98)
	  , toPrimitive    = __webpack_require__(106)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(32) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 102 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(15)
	  , hide      = __webpack_require__(33)
	  , has       = __webpack_require__(97)
	  , SRC       = __webpack_require__(53)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(20).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(50)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(21);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(48);
	
	$export($export.P, 'Array', {fill: __webpack_require__(91)});
	
	__webpack_require__(45)('fill');

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(48)
	  , $find   = __webpack_require__(92)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(45)(KEY);

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(34)();
	// imports
	
	
	// module
	exports.push([module.id, ".x-body,.x-btn-default-small .x-btn-inner,.x-btn-default-toolbar-small .x-btn-inner,.x-form-item,.x-form-item-label,.x-grid-cell-inner,.x-panel-header-text-default,.x-window-header-text-default,body{font-size:11px;font-family:Helvetica Neue,Helvetica,Arial,\"sans-serif\"!important}#init{display:table;margin:300px auto;font-size:13px;color:#444}#init .brand{font-weight:600;padding-right:5px}::-webkit-scrollbar{width:8px;height:7px;border:0 none}::-webkit-scrollbar-track:horizontal{background-color:#ddd;margin:0 2px;border-bottom:1px solid #fff}::-webkit-scrollbar-thumb:horizontal{background-color:#bbb;border-bottom:1px solid #fff}::-webkit-scrollbar-track:vertical{background-color:#e1e1e1;margin:1px 0;border-right:1px solid #fff}::-webkit-scrollbar-thumb:vertical{background-color:#bbb;border-right:1px solid #fff}.user-select{-webkit-touch-callout:text;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}.x-scroller-vertical{border:0 none}.disabled{opacity:.4;cursor:default!important}.disabled-toolbar{opacity:1}.x-splitter{display:none}.fixed{position:fixed}.pointer{cursor:pointer}.cursor-default{cursor:default}.td-nobreak{white-space:nowrap}.td-collapsed,.td-hidden{display:none}.td-sortable{background-image:url(" + __webpack_require__(198) + ");background-repeat:no-repeat;background-position:100%;padding-right:15px!important}.td-sortable-asc{background-image:url(" + __webpack_require__(196) + ")}.td-sortable-desc{background-image:url(" + __webpack_require__(75) + ")}.text-weak{color:#303038}.align-left{text-align:left!important}.align-right{text-align:right!important}.font-size-0{font-size:0!important}.ns-form-item-label-top{padding-left:2px;float:none;clear:none;display:block;margin-bottom:2px!important;color:#333}.ns-form-item-label-top-padding{padding-top:3px}.ns-container-default{border:0 none;background:#fff}.text-medium{font-weight:600}.spinner{width:20px;height:20px;margin:50px auto;background-color:#aaa;border-radius:100%;-webkit-animation:sk-scaleout .8s infinite ease-in-out;animation:sk-scaleout .8s infinite ease-in-out}@-webkit-keyframes sk-scaleout{0%{-webkit-transform:scale(0)}to{-webkit-transform:scale(1);opacity:0}}@keyframes sk-scaleout{0%{-webkit-transform:scale(0);transform:scale(0)}to{-webkit-transform:scale(1);transform:scale(1);opacity:0}}table.pivot{border-collapse:collapse;border-spacing:0;border:0 none}table.pivot.displaydensity-COMFORTABLE td{padding-top:7px!important;padding-right:7px;padding-bottom:7px!important;padding-left:7px!important}table.pivot.displaydensity-NORMAL td{padding-top:5px!important;padding-right:5px;padding-bottom:5px!important;padding-left:5px!important}table.pivot.displaydensity-COMPACT td{padding-top:4px!important;padding-right:4px;padding-bottom:4px!important;padding-left:4px!important}table.pivot.fontsize-LARGE td{font-size:13px!important}table.pivot.fontsize-NORMAL td{font-size:11px!important}table.pivot.fontsize-SMALL td{font-size:10px!important}.pivot td{padding:5px;border:1px solid #b2b2b2}.pivot-filter{background-color:#c7d5e9;text-align:center;padding:7px!important;color:#222;font-weight:600}table.pivot.displaydensity-COMFORTABLE td.pivot-filter{padding:9px!important}table.pivot.displaydensity-COMPACT td.pivot-filter{padding:5px!important}.pivot-dim{background-color:#dae6f8;text-align:center}.pivot-dim.highlighted{background-color:#c5d8f6}.pivot-dim-subtotal{background-color:#cad6e8;text-align:center}.pivot-dim-total{background-color:#bac6d8;text-align:center}.pivot-dim-total.highlighted{background-color:#adb8c9}.pivot-dim-label{white-space:nowrap;text-align:center}.pivot-dim-label,.pivot-empty{background-color:#cddaed}.pivot-transparent-column{background-color:#fff;border-top-color:#fff!important;border-right-color:#fff!important}.pivot-transparent-row{background-color:#fff;border-bottom-color:#fff!important;border-left-color:#fff!important}.pivot-value{background-color:#fff;text-align:right;max-width:700px}.pivot-value.highlighted{background-color:#f3f3f3}.pivot-value-subtotal{background-color:#f4f4f4;white-space:nowrap;text-align:right}.pivot-value-subtotal-total{background-color:#e7e7e7;white-space:nowrap;text-align:right}.pivot-value-total{background-color:#e4e4e4;white-space:nowrap;text-align:right}.pivot-value-total-subgrandtotal{background-color:#d8d8d8;white-space:nowrap;text-align:right}.pivot-value-grandtotal{background-color:#c8c8c8;white-space:nowrap;text-align:right}.pivot td.legend{padding:0}.pivot div.legendCt{display:table;float:right;width:100%}.pivot div.arrowCt{display:table-cell;vertical-align:top;width:8px}.pivot div.arrow{width:0;height:0}.pivot div.number{display:table-cell}.pivot div.legendColor{display:table-cell;width:2px}.ns-viewport-text *{padding:3px 10px;font-size:13px;color:#777}.ns-viewport-text h3{font-size:13px;font-weight:500;color:#333;padding:0 0 8px}.x-panel-body{font-size:11px}.x-panel .x-grid-body{border-style:none}.ns-panel-title-data,.ns-panel-title-dimension,.ns-panel-title-organisationunit,.ns-panel-title-period{height:17px;background-repeat:no-repeat;padding-left:20px}.ns-panel-title-data{background-image:url(" + __webpack_require__(205) + ")}.ns-panel-title-period{background-image:url(" + __webpack_require__(236) + ")}.ns-panel-title-organisationunit{background-image:url(" + __webpack_require__(235) + ")}.ns-panel-title-dimension{background-image:url(" + __webpack_require__(206) + ")}.ns-dxselector .x-mask{background:transparent}.ns-dxselector.x-item-disabled{opacity:.6}.ns-form-widget .x-form-item-label-left{padding-left:4px;color:#444}.ns-form-widget .x-form-text{font-size:10px!important;padding:3px 1px 1px 4px;border-top-left-radius:1px;border-bottom-left-radius:1px}.ns-form-widget .x-form-item{margin-bottom:3px}.ns-form-widget .x-btn-default-small{border-radius:1px}.x-webkit .x-form-empty-field{line-height:14px}.x-form-text,textarea.x-form-field{font-size:10px}.x-form-item-label{font-size:11px;color:#111}.ns-combo .x-form-text{padding-left:5px}.ns-combo .small .x-form-field{padding-top:2px}.ns-combo input{border-radius:1px 0 0 0}.ns-combo.h21 .x-form-trigger{height:21px!important}.ns-combo.h22 .x-form-trigger{height:22px!important}.ns-combo.h24 .x-form-trigger{height:24px!important}.ns-optionselector .x-boundlist-selected{background-color:#fff;border-color:#fff}.ns-optionselector .x-boundlist-selected.x-boundlist-item-over{background-color:#ddd;border-color:#ddd}.ns-trigger-filter .x-form-trigger{height:22px!important;background:url(" + __webpack_require__(204) + ") 0 0 no-repeat;border-top:1px solid #b5b8c8;border-right:1px solid #b5b8c8}.ns-trigger-filter-focused .x-form-trigger{border:1px solid #a1a1a1;border-left:0 none}.ns-trigger-filter .x-form-trigger-over{background:url(" + __webpack_require__(203) + ") 0 0 no-repeat}.x-fit-item{border-style:none}.x-boundlist-item{color:#333;padding:3px 2px 3px 4px;font-size:10px;border:1px solid transparent}.x-boundlist-item-over{background-color:#e1e1e1;border-color:#e1e1e1}.x-boundlist-selected{background-color:#d3d3d3;border-color:#d3d3d3}.ns-multiselect{color:#111}.ns-toolbar-multiselect-left .x-docked-top{border-top-left-radius:1px;border-right:0 none}.ns-toolbar-multiselect-right .x-docked-top{border-top-right-radius:1px}.ns-toolbar-multiselect-leftright .x-docked-top{border-top-left-radius:1px;border-top-right-radius:1px}.ns-toolbar-multiselect-left .ns-toolbar-multiselect-left-label,.ns-toolbar-multiselect-leftright .ns-toolbar-multiselect-leftright-label,.ns-toolbar-multiselect-right .ns-toolbar-multiselect-right-label{font-size:11px;color:#222}.ns-toolbar-multiselect-left .ns-toolbar-multiselect-left-label{padding-left:6px}.ns-toolbar-multiselect-right .ns-toolbar-multiselect-right-label{padding-right:7px}.ns-toolbar-multiselect-leftright .ns-toolbar-multiselect-leftright-label{padding-left:4px}.ns-toolbar-multiselect-left .x-boundlist-item-over,.ns-toolbar-multiselect-right .x-boundlist-item-over{background-color:transparent;border-color:transparent}.ns-toolbar-multiselect-left .x-boundlist-selected,.ns-toolbar-multiselect-right .x-boundlist-selected{background-color:#e5e5e5;border-color:#e5e5e5}.ns-toolbar-multiselect-left .x-panel-body{border-right:0 none}.ns-multiselect-fixed .x-panel-body{border-bottom:0 none}.ns-multiselect-fixed .x-boundlist-item{color:#777;cursor:auto}.ns-multiselect-fixed .x-boundlist-item-over{background-color:transparent;border-color:transparent}.ns-multiselect-dynamic .x-panel-body{border-top:0 none}.x-form-cb-label-after{padding-left:1px;font-size:11px;color:#333;position:relative;top:-1px}.x-form-checkbox{background-image:url(" + __webpack_require__(202) + ")}.x-form-cb-wrap{padding-top:2px;line-height:12px}.ns-checkbox .x-form-item-label{padding-left:5px}.ns-checkbox .x-form-cb-label-after{margin-left:3px;font-size:11px}.x-toolbar .x-toolbar-separator-horizontal{height:15px;border-right:1px solid #f2f2f2}.x-toolbar.x-item-disabled{opacity:1}.x-toolbar-default{border-color:#dadada;background-image:none;background-color:#f6f6f6}.ns-toolbar-btn-menu{margin-top:4px}.x-tool-triple-chevron-left{background-image:url(" + __webpack_require__(76) + ")!important}.x-tool-triple-chevron-right{background-image:url(" + __webpack_require__(77) + ")!important}.tool-triple-chevron-right img{width:20px!important}.x-menu-body{border-color:#bbb;border-radius:2px}.x-menu-item-active .x-menu-item-link{border-radius:0;border-color:#e1e1e1;background-color:#e1e1e1;background-image:none}.x-menu-body{padding:0}.x-box-inner{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.x-menu-body .x-box-inner,.x-menu-item{background-color:#fafafa}.x-menu-item-link{padding:4px 5px 4px 26px}.x-menu-item-text{color:#111}.ns-menu-item-noicon .x-menu-item-link{padding-left:10px}.ns-menu-item-advanced,.ns-menu-item-datasource,.ns-menu-item-image,.ns-menu-item-scheme,.ns-menu-item-selected,.ns-menu-item-tablelayout,.ns-menu-item-unselected{padding-left:18px}.ns-menu-item-image{background-image:url(" + __webpack_require__(210) + ")}.ns-menu-item-tablelayout{background-image:url(" + __webpack_require__(212) + ")}.ns-menu-item-datasource{background-image:url(" + __webpack_require__(209) + ")}.ns-menu-item-advanced{background-image:url(" + __webpack_require__(208) + ")}.ns-menu-item-scheme{background-image:url(" + __webpack_require__(211) + ")}.ns-menu-item-selected{background-image:url(" + __webpack_require__(201) + ")}.ns-menu-item-unselected{background-image:url(" + __webpack_require__(200) + ")}.ns-btn-menu{margin-top:2px}.ns-menu-item-favorite-new{background-image:url(" + __webpack_require__(217) + ")}.ns-menu-item-favorite-open{background-image:url(" + __webpack_require__(218) + ")}.ns-menu-item-favorite-save{background-image:url(" + __webpack_require__(221) + ")}.ns-menu-item-favorite-restore{background-image:url(" + __webpack_require__(220) + ")}.ns-menu-item-favorite-rename{background-image:url(" + __webpack_require__(219) + ")}.ns-menu-item-favorite-share{background-image:url(" + __webpack_require__(222) + ")}.ns-menu-item-favorite-interpretation{background-image:url(" + __webpack_require__(215) + ")}.ns-menu-item-favorite-link{background-image:url(" + __webpack_require__(216) + ")}.ns-menu-item-favorite-delete{background-image:url(" + __webpack_require__(214) + ")}.ns-menu-item-favorite-translate{background-image:url(" + __webpack_require__(223) + ")}.x-btn-arrow{background-image:url(" + __webpack_require__(191) + ")!important}.x-btn-default-toolbar-small,.x-btn-default-toolbar-small-over,.x-btn-default-toolbar-small-pressed{border-radius:1px}.x-btn-default-toolbar-small-over,.x-btn-default-toolbar-small-pressed{border-color:#bbb}.x-btn-default-toolbar-small-over{background-image:none;background-color:#f3f3f3;background-image:-webkit-gradient(linear,50% 0,50% 100%,color-stop(0,#f2f2f2),color-stop(100%,#f7f7f7));background-image:-webkit-linear-gradient(top,#f2f2f2,#f7f7f7);background-image:linear-gradient(top,#f2f2f2,#f7f7f7)}.x-btn-default-toolbar-small-icon button{width:32px!important}.x-btn-default-toolbar-small-icon .x-btn-icon{width:32px;height:32px}.x-btn-default-small{border-radius:1px}.x-btn-default-toolbar-small-pressed{border-color:#aaa;background-image:none;background-color:#d6d6d6;background-image:-webkit-gradient(linear,50% 0,50% 100%,color-stop(0,#d1d1d1),color-stop(100%,#e5e5e5));background-image:-webkit-linear-gradient(top,#d1d1d1,#e5e5e5);background-image:linear-gradient(top,#d1d1d1,#e5e5e5)}.ns-button-icon-gear{width:22px!important;height:22px!important;background:url(" + __webpack_require__(225) + ") no-repeat}.ns-button-icon-table{background:url(" + __webpack_require__(238) + ") no-repeat}.ns-button-icon-chart{background:url(" + __webpack_require__(199) + ") no-repeat}.ns-button-icon-map{background:url(" + __webpack_require__(233) + ") no-repeat}.ns-button-icon-arrowleft{background:url(" + __webpack_require__(192) + ") no-repeat}.ns-button-icon-arrowleftdouble{background:url(" + __webpack_require__(193) + ") no-repeat}.ns-button-icon-arrowlefttriple{background:url(" + __webpack_require__(76) + ") no-repeat;width:26px!important}.ns-button-icon-arrowright{background:url(" + __webpack_require__(194) + ") no-repeat}.ns-button-icon-arrowrightdouble{background:url(" + __webpack_require__(195) + ") no-repeat}.ns-button-icon-arrowrighttriple{background:url(" + __webpack_require__(77) + ") no-repeat;width:26px!important}.ns-button-icon-arrowupdouble{background:url(" + __webpack_require__(197) + ") no-repeat;width:26px!important}.ns-button-icon-arrowdown{background:url(" + __webpack_require__(75) + ") no-repeat}.ns-button-icon-search{background:url(" + __webpack_require__(237) + ") 1px 1px no-repeat}.ns-button-icon-nodeselectchild{background:url(" + __webpack_require__(234) + ") 1px 1px no-repeat}.ns-button-organisationunitselection .x-btn-center{width:18px!important}.ns-button-icon.x-btn-default-toolbar-small-disabled{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=25)\";opacity:.25}.ns-button-combotrigger{background-image:url(" + __webpack_require__(240) + ");background-position:0 0;width:17px;border-top-right-radius:2px}.ns-button-combotrigger-disabled,.ns-button-combotrigger-disabled *{opacity:.8;cursor:default!important}.ns-linkbutton.x-btn-default-small{border:1px solid transparent;background:transparent}.ns-linkbutton .x-btn-inner{color:#3162c5;padding:0}.ns-linkbutton.x-btn-over .x-btn-inner{text-decoration:underline}.x-tip{border-radius:2px;padding:1px 4px;border:1px solid #111;background-color:#111}.x-tip .x-tip-body{font-size:10px;color:#fff;-webkit-text-stroke:.2px #fff}.x-tip-anchor{border-top-color:#111}.x-mask-msg{padding:0;border:0 none;background-image:none;background-color:transparent}.x-mask-msg div{background-position:11px}.x-mask-msg .x-mask-loading{border:0 none;background-color:#000;color:#fff;border-radius:2px;padding:12px 14px 12px 31px;opacity:.65}.x-grid-row-selected .x-grid-cell{background-color:#eaeaea!important;border-style:solid;border-color:transparent}.ns-grid-row-icon-dashboard,.ns-grid-row-icon-delete,.ns-grid-row-icon-edit,.ns-grid-row-icon-overwrite,.ns-grid-row-icon-sharing{width:16px;height:16px;cursor:pointer}.ns-grid-row-icon-edit{background:url(" + __webpack_require__(228) + ") no-repeat}.ns-grid-row-icon-overwrite{background:url(" + __webpack_require__(229) + ") no-repeat;margin-left:4px}.ns-grid-row-icon-sharing{background:url(" + __webpack_require__(230) + ") no-repeat;margin-left:4px}.ns-grid-row-icon-dashboard{background:url(" + __webpack_require__(226) + ") no-repeat;margin-left:4px}.ns-grid-row-icon-delete{background:url(" + __webpack_require__(227) + ") no-repeat;margin-left:4px}.ns-grid-row-icon-disabled img.ns-grid-row-icon-dashboard,.ns-grid-row-icon-disabled img.ns-grid-row-icon-sharing{cursor:pointer!important}.ns-grid .x-grid-cell-inner,.ns-grid .x-grid-cell-inner *{font-size:11px!important}.ns-grid .x-grid-cell-inner{padding-top:3px;padding-bottom:3px}.ns-grid .x-column-header-text{color:#333}.ns-grid .x-grid-header-ct{border-bottom-width:1px!important;border-bottom-color:#d6d6d6}.ns-grid .x-grid-body{border:1px solid #d6d6d6;border-top:0 none!important}.ns-grid .x-grid-dirty-cell{background-image:none}.ns-grid .x-grid-row{vertical-align:middle}.ns-grid .x-grid-row .x-grid-cell{border-top:0 none}.ns-grid .link,.ns-grid .link *{cursor:pointer;cursor:hand;color:#001eff;text-decoration:underline}.x-window .x-window-header-text-default{font-size:10px;text-transform:uppercase;text-align:center;color:#444;padding-left:8px;padding-top:1px}.ns-window-title-favorite{padding-left:19px;background-image:url(" + __webpack_require__(224) + ")}.ns-window-title-interpretation{padding-left:19px;background-image:url(" + __webpack_require__(231) + ")}.ns-window-title-datatable{padding-left:19px;background-image:url(" + __webpack_require__(207) + ")}.ns-window-title-messagebox{padding-left:16px;background-position-y:1px}.ns-window-title-messagebox.error{background-image:url(" + __webpack_require__(213) + ")}.ns-window-title-messagebox.warning{background-image:url(" + __webpack_require__(241) + ")}.ns-window-confirm-list .x-panel-body{color:#444;font-size:10px;border-style:none}.ns-label-period-heading,.ns-label-period-heading-options{font-size:11px;font-weight:700;color:#333;line-height:18px}.ns-label-period-heading-options{background-color:#e1e1e1;padding:1px 5px;border-radius:2px}.ns-label-info{font-size:10px!important;color:#666;padding-left:4px;height:22px;line-height:21px}.ns-label-date{display:block;font-size:10px;color:#333;text-decoration:underline;cursor:pointer}.ns-label-date:hover{color:#666}.ns-textfield-alt1 .x-form-field,.ns-textfield .x-form-field{height:26px;padding-left:4px;border-radius:1px;font-size:11px;color:#333}.ns-textfield .x-form-item-label{padding-left:5px;line-height:20px}.ns-textfield-alt1 .x-form-item-label{padding-left:5px;line-height:8px}.x-tree-icon-leaf{background-image:url(" + __webpack_require__(232) + ")}.ns-tree.x-tree-panel .x-grid-row .x-grid-cell-inner{height:17px;font-size:10px}.ns-tree .x-grid-table{width:100%!important}.ns-tree .x-grid-row-selected .x-grid-cell,.ns-tree .x-grid-row-selected .x-grid-rowwrap-div{background-color:#e0e0e0;border-radius:2px 2px 2px 2px}.ns-tree .x-grid-cell{border-radius:2px 2px 2px 2px}#treepanel-contextmenu{border-radius:3px;border:1px solid #ddd}.ns-statusbar .x-panel-body-default{padding:5px 0 0 6px;border:0 none;background-color:transparent;color:#111;vertical-align:top;font-size:10px;line-height:14px}.ns-accordion .x-accordion-item .x-accordion-hd{padding:6px 5px 4px 8px;border:0 none;cursor:pointer;border-radius:0;background-image:none;background-color:#e0e0e0;background-image:-webkit-gradient(linear,50% 0,50% 100%,color-stop(0,#dedede),color-stop(100%,#e6e6e6))!important;background-image:-webkit-linear-gradient(top,#ddd,#e6e6e6)!important;background-image:linear-gradient(top,#ddd,#e6e6e6)!important}.ns-accordion .collapsed .x-accordion-hd{padding-bottom:5px!important}.ns-accordion .x-accordion-item{border-radius:1px;border:1px solid #c5c5c5;border-top:0 none}.ns-accordion .ns-accordion-first{border-top:1px solid #c5c5c5}.ns-accordion .x-accordion-hd .x-panel-header-text{font-weight:700;cursor:pointer}.ns-accordion .x-accordion-body{padding:1px;border-top:1px solid #c5c5c5!important}.ns-accordion .x-accordion-hd-sibling-expanded{-o-box-shadow:none;box-shadow:none}.ns-accordion .ns-toolbar-multiselect-left,.ns-accordion .ns-toolbar-multiselect-right{margin-bottom:0}.ns-accordion .ns-combo .x-form-text,.ns-accordion .ns-combo .x-form-trigger{height:24px;padding-top:1px}.ns-accordion .ns-combo .x-form-item-label{padding:4px 0 0}.ns-accordion .x-component.x-panel-header-text-container.x-box-item.x-component-default{width:100%!important}.ns-textarea .x-form-field{font-size:11px;line-height:14px!important}.ns-textarea.monospaced textarea{font-family:monospace,consolas,courier new;padding:4px;border:0 none}.favorite-li{padding:0}.favorite-li:hover{color:#222}.ns-chart-tips{border-radius:2px;padding:1px 4px 2px;border:2px solid #777;background-color:#f1f1f1}.ns-chart-tips .x-tip-body{background-color:#f1f1f1;font-size:13px;font-weight:400;color:#444;-webkit-text-stroke:0}.legend3Lines .x-legend .x-legend-items{display:inline-block!important}.legend3Lines .x-legend .x-legend-item{float:left!important;width:205px!important;overflow:hidden}.legend3Lines .x-legend{height:110px!important;width:400px!important}.x-tip,.x-tip-body,.x-tip-body span{width:auto!important;background-color:grey!important;border:0}.eastPanel .clickable,.eastPanel .clickable div,.eastPanel .clickable label{cursor:pointer!important}.eastPanel .thumbs_up{background-image:url(" + __webpack_require__(239) + ");background-position:5px 5px;padding:7px 25px;background-repeat:no-repeat}.eastPanel .greyBackground,.eastPanel .greyBackground div{background-color:#efefef}.eastPanel .comment{padding:5px;margin-top:1px}.eastPanel .eastPanelLink{cursor:pointer;color:#3162c5}.eastPanel .eastPanelLink:hover{color:#1c3974}.eastPanel .bold{font-weight:700}.eastPanel .interpretationActions{line-height:16px}.eastPanel .interpretationDetailsField{white-space:nowrap;font-weight:700;line-height:18px}.eastPanel .avatar{height:30px;width:30px;border-radius:50%;display:inline-block;background-color:#bdbdbd;text-align:center;line-height:30px;font-size:14px;color:#000;font-weight:700}.eastPanel .commentArea textarea{margin-bottom:5px;font-size:12px}.ns-panel-title-east-default .x-panel-header{background:#e6e6e6;border-top-width:0;border-left-width:0;box-shadow:none;-webkit-box-shadow:none;padding-top:8px;padding-bottom:7px;padding-left:7px}.ns-panel-title-east-default.first .x-panel-header{border-top-width:1px}.ns-panel-title-east-default .x-panel-body{border-left:0}", ""]);
	
	// exports


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Axis = undefined;
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Axis = exports.Axis = undefined;
	
	exports.Axis = Axis = function Axis(refs, config) {
	    var t = [];
	
	    var _refs$api = refs.api,
	        Axis = _refs$api.Axis,
	        Dimension = _refs$api.Dimension;
	
	
	    config = (0, _arrayFrom2.default)(config);
	
	    // constructor
	    config.forEach(function (dimensionConfig) {
	        t.push(new Dimension(refs, dimensionConfig).val());
	    });
	
	    // prototype
	    t.log = function (text, noError) {
	        if (!noError) {
	            console.log(text, this, config);
	        }
	    };
	
	    t.val = function (noError) {
	        if (!this.length) {
	            this.log('(Axis) No dimensions', noError);
	            return null;
	        }
	
	        return this;
	    };
	
	    t.add = function (dimensionConfig, skipValidation) {
	        var dimension = skipValidation ? dimensionConfig : new Dimension(refs, dimensionConfig).val();
	
	        if (dimension) {
	            t.push(dimension);
	        }
	    };
	
	    t.clone = function () {
	        return Axis(refs, this);
	    };
	
	    t.empty = function () {
	        var cache = t.slice(0);
	
	        for (var i = 0, len = t.length; i < len; i++) {
	            t.pop();
	        }
	
	        return cache;
	    };
	
	    t.getRecordIds = function (isSorted, asString) {
	        var ids = asString ? '' : [];
	
	        t.forEach(function (dimension, dIndex, dArray) {
	            dimension.getRecordIds(isSorted, null, true).forEach(function (id, nIndex, nArray) {
	                if (asString) {
	                    ids += id + (nIndex !== nArray.length - 1 ? ', ' : '');
	                } else {
	                    ids.push(id);
	                }
	            });
	
	            if (asString) {
	                ids += dIndex !== dArray.length - 1 ? ' - ' : '';
	            }
	        });
	
	        return ids;
	    };
	
	    t.getRecordNames = function (isSorted, response, asString) {
	        var names = asString ? '' : [];
	
	        t.forEach(function (dimension, dIndex, dArray) {
	            dimension.getRecordNames(isSorted, response, true).forEach(function (name, nIndex, nArray) {
	                if (asString) {
	                    names += name + (nIndex !== nArray.length - 1 ? ', ' : '');
	                } else {
	                    names.push(name);
	                }
	            });
	
	            if (asString) {
	                names += dIndex !== dArray.length - 1 ? ' - ' : '';
	            }
	        });
	
	        return names;
	    };
	
	    t.getDimension = function (dimensionName) {
	        return this.find(function (dimension) {
	            return dimension.dimension === dimensionName;
	        });
	    };
	
	    t.getDimensionNames = function () {
	        var names = [];
	
	        this.forEach(function (dimension) {
	            names.push(dimension.dimension);
	        });
	
	        return names;
	    };
	
	    t.has = function (dimensionName) {
	        return !!t.getDimension(dimensionName);
	    };
	
	    t.sorted = function () {
	        return t.clone().sort(function (a, b) {
	            return a.dimension > b.dimension;
	        });
	    };
	
	    t.extendRecords = function (response) {
	        t.forEach(function (dimension) {
	            dimension.extendRecords(response);
	        });
	    };
	
	    t.strip = function () {
	        var rest = [];
	
	        while (t.length > 1) {
	            rest.push(t.pop());
	        }
	
	        return rest.reverse();
	    };
	
	    t.toPlugin = function () {
	        delete t.klass;
	
	        t.forEach(function (item) {
	            item.toPlugin();
	        });
	    };
	
	    t.replaceDimensionByName = function (dimension) {
	        for (var i = 0; i < this.length; ++i) {
	            if (this[i].dimension === dimension.dimension) {
	                this[i] = dimension;
	            }
	        }
	    };
	
	    return t;
	};
	//# sourceMappingURL=Axis.js.map

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Layout = undefined;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isBoolean = __webpack_require__(13);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isDefined = __webpack_require__(64);
	
	var _isDefined2 = _interopRequireDefault(_isDefined);
	
	var _isNumber = __webpack_require__(9);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _arrayClean = __webpack_require__(7);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayPluck = __webpack_require__(27);
	
	var _arrayPluck2 = _interopRequireDefault(_arrayPluck);
	
	var _arraySort = __webpack_require__(8);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _DateManager = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = exports.Layout = undefined;
	
	exports.Layout = Layout = function Layout(refs, c, applyConfig, forceApplyConfig) {
	    var t = this;
	
	    refs = (0, _isObject2.default)(refs) ? refs : {};
	
	    var _refs$api = refs.api,
	        Axis = _refs$api.Axis,
	        Sorting = _refs$api.Sorting;
	
	
	    c = (0, _isObject2.default)(c) ? c : {};
	    $.extend(c, applyConfig);
	
	    // private
	    var _path = refs.appManager.getApiPath();
	    var _source = '/analytics';
	    var _format = 'json';
	
	    var _response;
	    var _access;
	
	    var _dataDimensionItems;
	
	    // constructor
	    t.columns = Axis(refs, c.columns).val(true);
	    t.rows = Axis(refs, c.rows).val(true);
	    t.filters = Axis(refs, c.filters).val(true);
	
	    // access
	    _access = (0, _isObject2.default)(c.access) ? c.access : null;
	
	    // data dimension items
	    _dataDimensionItems = (0, _isArray2.default)(c.dataDimensionItems) ? c.dataDimensionItems : null;
	
	    // non model
	
	    // id
	    if ((0, _isString2.default)(c.id)) {
	        t.id = c.id;
	    }
	
	    // interpretationId
	    if ((0, _isString2.default)(c.interpretationId)) {
	        t.interpretationId = c.interpretationId;
	    }
	
	    // DHIS2-2784: propagate both name and displayName
	    // to avoid name being replaced by a translation in the translate dialog
	    // name
	    if ((0, _isString2.default)(c.name)) {
	        t.name = c.name;
	    }
	
	    t.displayName = (0, _arrayClean2.default)([c.displayName, c.displayShortName, c.name, c.shortName]).find(function (item) {
	        return (0, _isString2.default)(item);
	    });
	
	    // title
	    t.title = (0, _arrayClean2.default)([c.displayShortName, c.title]).find(function (item) {
	        return (0, _isString2.default)(item);
	    });
	
	    // description
	    if ((0, _isString2.default)(c.description)) {
	        t.description = c.description;
	    }
	
	    // sorting
	    if ((0, _isObject2.default)(c.sorting) && (0, _isDefined2.default)(c.sorting.id) && (0, _isString2.default)(c.sorting.direction)) {
	        t.sorting = new Sorting(refs, c.sorting);
	    }
	
	    // displayProperty
	    if ((0, _isString2.default)(c.displayProperty)) {
	        t.displayProperty = c.displayProperty;
	    }
	
	    // userOrgUnit
	    if ((0, _arrayFrom2.default)(c.userOrgUnit).length) {
	        t.userOrgUnit = (0, _arrayFrom2.default)(c.userOrgUnit);
	    }
	
	    // startDate
	    if ((0, _isString2.default)(c.startDate)) {
	        t.startDate = c.startDate;
	    }
	
	    // endDate
	    if ((0, _isString2.default)(c.endDate)) {
	        t.endDate = c.endDate;
	    }
	
	    // relative period date
	    if (_DateManager.DateManager.getYYYYMMDD(c.relativePeriodDate)) {
	        t.relativePeriodDate = _DateManager.DateManager.getYYYYMMDD(c.relativePeriodDate);
	    }
	
	    //description
	    if ((0, _isString2.default)(c.displayDescription)) {
	        t.displayDescription = c.displayDescription;
	    }
	
	    //interpretations
	    if ((0, _arrayFrom2.default)(c.interpretations).length) {
	        t.interpretations = (0, _isArray2.default)(c.interpretations) ? c.interpretations : null;
	    }
	
	    //lastUpdated
	    if (_DateManager.DateManager.getYYYYMMDD(c.lastUpdated)) {
	        t.lastUpdated = _DateManager.DateManager.getYYYYMMDD(c.lastUpdated);
	    }
	
	    //created
	    if (_DateManager.DateManager.getYYYYMMDD(c.created)) {
	        t.created = _DateManager.DateManager.getYYYYMMDD(c.created);
	    }
	
	    //favorite user
	    if ((0, _isObject2.default)(c.user)) {
	        t.user = c.user;
	    }
	
	    //public access
	    if ((0, _isString2.default)(c.publicAccess)) {
	        t.publicAccess = c.publicAccess;
	    }
	
	    //permission
	    if ((0, _isString2.default)(c.permission)) {
	        t.permission = c.permission;
	    }
	
	    //user group accesses
	    if ((0, _arrayFrom2.default)(c.userGroupAccesses).length) {
	        t.userGroupAccesses = c.userGroupAccesses;
	    }
	
	    if (c.el && (0, _isString2.default)(c.el)) {
	        t.el = c.el;
	    }
	
	    // translations
	    if ((0, _arrayFrom2.default)(c.translations).length) {
	        t.translations = c.translations;
	    }
	
	    $.extend(t, forceApplyConfig);
	
	    // setter/getter
	    t.getResponse = function () {
	        return _response;
	    };
	
	    t.setResponse = function (r) {
	        _response = r;
	    };
	
	    t.getAccess = function () {
	        return _access;
	    };
	
	    t.setAccess = function (a) {
	        _access = a;
	    };
	
	    t.getDataDimensionItems = function () {
	        return _dataDimensionItems;
	    };
	
	    t.setDataDimensionItems = function (a) {
	        _dataDimensionItems = a;
	    };
	
	    t.getDefaultPath = function () {
	        return _path;
	    };
	
	    t.getDefaultSource = function () {
	        return _source;
	    };
	
	    t.getDefaultFormat = function () {
	        return _format;
	    };
	
	    t.getRequestPath = function (s, f) {
	        return (_path || refs.appManager.getPath()) + (s || _source) + '.' + (f || _format);
	    };
	
	    t.getRefs = function () {
	        return refs;
	    };
	};
	
	Layout.prototype.log = function (text, noError) {
	    if (!noError) {
	        console.log(text, this);
	    }
	};
	
	Layout.prototype.alert = function (text, noError) {
	    if (!noError) {
	        alert(text);
	    }
	};
	
	Layout.prototype.apply = function (obj, keys) {
	    var t = this;
	
	    if (!(0, _isObject2.default)(obj)) {
	        return t;
	    }
	
	    var preservedProps = ['name', 'description'];
	
	    keys = (0, _isArray2.default)(keys) ? keys : preservedProps;
	
	    keys.forEach(function (key) {
	        t[key] = obj[key];
	    });
	
	    return t;
	};
	
	Layout.prototype.toRows = function (includeFilter) {
	    this.rows = (0, _arrayClean2.default)(this.rows.concat(this.columns.empty(), includeFilter ? this.filters.empty() : []));
	};
	
	Layout.prototype.getAxes = function (includeFilter) {
	    return (0, _arrayClean2.default)([this.columns, this.rows, includeFilter ? this.filters : null]);
	};
	
	Layout.prototype.getUserOrgUnitUrl = function () {
	    if ((0, _isArray2.default)(this.userOrgUnit) && this.userOrgUnit.length) {
	        return 'userOrgUnit=' + this.userOrgUnit.join(';');
	    }
	};
	
	Layout.prototype.applyInterpretation = function (interpretation) {
	    this.setResponse(null);
	    this.relativePeriodDate = interpretation.created;
	    this.interpretationId = interpretation.id;
	};
	
	Layout.prototype.setSharing = function (sharing) {
	    this.publicAccess = sharing.publicAccess;
	    this.externalAccess = sharing.externalAccess;
	    this.userGroupAccesses = sharing.userGroupAccesses;
	    this.userAccesses = sharing.userAccesses;
	};
	
	// dep 1
	
	Layout.prototype.hasDimension = function (dimensionName, includeFilter) {
	    return this.getAxes(includeFilter).some(function (axis) {
	        return axis.has(dimensionName);
	    });
	};
	
	Layout.prototype.getDimensions = function (includeFilter, isSorted, axes) {
	    var dimensions = [];
	
	    axes = (0, _arrayClean2.default)(axes ? (0, _arrayFrom2.default)(axes) : this.getAxes(includeFilter));
	
	    axes.forEach(function (axis) {
	        dimensions = dimensions.concat(axis);
	    });
	
	    return isSorted ? dimensions.sort(function (a, b) {
	        return a.dimension > b.dimension;
	    }) : dimensions;
	};
	
	Layout.prototype.getRecords = function (includeFilter, response) {
	    var t = this;
	
	    var records = [];
	
	    this.getAxes(includeFilter).forEach(function (axis) {
	        axis.forEach(function (dimension) {
	            records = records.concat(dimension.getRecords(null, response));
	        });
	    });
	
	    return records;
	};
	
	Layout.prototype.extendRecords = function (response) {
	    this.getAxes(true).forEach(function (axis) {
	        axis.extendRecords(response);
	    });
	};
	
	Layout.prototype.stripAxes = function (includeFilter, skipAddToFilter) {
	    var t = this,
	        refs = t.getRefs();
	
	    var Axis = refs.api.Axis;
	
	
	    if (!skipAddToFilter && !t.filters) {
	        t.filters = new Axis(refs);
	    }
	
	    t.getAxes(includeFilter).forEach(function (axis) {
	        axis.strip().forEach(function (dimension) {
	            if (!skipAddToFilter) {
	                t.filters.add(dimension);
	            }
	        });
	    });
	};
	
	Layout.prototype.replaceDimensionByName = function (dimension, includeFilter) {
	    this.getAxes(includeFilter).forEach(function (axis) {
	        if (axis.has(dimension.dimension)) {
	            axis.replaceDimensionByName(dimension);
	        }
	    });
	};
	
	// dep 2
	
	Layout.prototype.getRecordIds = function (includeFilter) {
	    var ids = [];
	
	    this.getRecords(includeFilter).forEach(function (record) {
	        ids.push(record.id);
	    });
	
	    return ids;
	};
	
	Layout.prototype.getDimension = function (dimensionName) {
	    return this.getDimensions(true).find(function (dimension) {
	        return dimension.dimension === dimensionName;
	    });
	};
	
	Layout.prototype.getDimensionNames = function (includeFilter, isSorted, axes) {
	    var names = (0, _arrayPluck2.default)(this.getDimensions(includeFilter, false, axes), 'dimension');
	
	    return isSorted ? names.sort() : names;
	};
	
	Layout.prototype.getDimensionNameIdsMap = function (response) {
	    var map = {};
	
	    response = response || this.getResponse();
	
	    this.getDimensions(true).forEach(function (dimension) {
	        map[dimension.dimension] = dimension.getRecordIds(false, response);
	    });
	
	    return map;
	};
	
	Layout.prototype.removeDimensionItems = function (includeFilter) {
	    this.getDimensions(includeFilter).forEach(function (dimension) {
	        dimension.removeItems();
	    });
	};
	
	Layout.prototype.val = function (noError) {
	    var refs = this.getRefs();
	    var i18nManager = refs.i18nManager;
	
	    if (!(this.columns || this.rows)) {
	        this.alert(i18nManager.get('at_least_one_dimension_must_be_specified_as_row_or_column'), noError); //todo alert
	        return null;
	    }
	
	    if (!this.hasDimension(refs.dimensionConfig.get('period').dimensionName, true)) {
	        this.alert(i18nManager.get('at_least_one_period_must_be_specified_as_column_row_or_filter'), noError); //todo alert
	        return null;
	    }
	
	    return this;
	};
	
	Layout.prototype.toPlugin = function (el) {
	    var t = this,
	        refs = this.getRefs();
	
	    var appManager = refs.appManager,
	        optionConfig = refs.optionConfig,
	        layout;
	
	    if (t.id) {
	        layout = {
	            id: t.id
	        };
	    } else {
	        layout = t.clone();
	
	        // columns, rows, filters
	        layout.getAxes(true).forEach(function (item) {
	            item.toPlugin();
	        });
	
	        // properties
	        var deleteIfTruthy = ['showRowTotals', 'showColTotals', 'showColSubTotals', 'showRowSubTotals', 'showDimensionLabels', 'showValues'];
	
	        var deleteIfFalsy = ['hideEmptyRows', 'hideEmptyColumns', 'stickyColumnDimension', 'stickyRowDimension', 'skipRounding', 'showHierarchy', 'completedOnly', 'hideLegend', 'hideTitle', 'title', 'legendSet', 'sorting', 'targetLineValue', 'targetLineTitle', 'baseLineValue', 'baseLineTitle', 'rangeAxisMaxValue', 'rangeAxisMinValue', 'rangeAxisSteps', 'rangeAxisDecimals', 'rangeAxisTitle', 'domainAxisTitle', 'regression', 'cumulative', 'sortOrder', 'topLimit'];
	
	        var deleteAnyway = ['klass', 'name', 'parentGraphMap', 'reportingPeriod', 'organisationUnit', 'parentOrganisationUnit', 'cumulative', 'sortOrder', 'topLimit', 'displayDescription', 'displayName', 'interpretations', 'lastUpdated', 'created', 'user', 'publicAccess', 'permission', 'userGroupAccesses', 'prototype', 'url'];
	
	        deleteIfTruthy.forEach(function (item) {
	            if (!!layout[item]) {
	                delete layout[item];
	            }
	        });
	
	        deleteIfFalsy.forEach(function (item) {
	            if (!layout[item]) {
	                delete layout[item];
	            }
	        });
	
	        deleteAnyway.forEach(function (item) {
	            delete layout[item];
	        });
	
	        if (layout.displayDensity === optionConfig.getDisplayDensity('normal').id) {
	            delete layout.displayDensity;
	        }
	
	        if (layout.fontSize === optionConfig.getFontSize('normal').id) {
	            delete layout.fontSize;
	        }
	
	        if (layout.digitGroupSeparator === optionConfig.getDigitGroupSeparator('space').id) {
	            delete layout.digitGroupSeparator;
	        }
	
	        if (layout.aggregationType === optionConfig.getAggregationType('def').id) {
	            delete layout.aggregationType;
	        }
	
	        if (layout.numberType === optionConfig.getNumberType('value').id) {
	            delete layout.numberType;
	        }
	
	        if (layout.dataApprovalLevel && layout.dataApprovalLevel.id === optionConfig.getDataApprovalLevel('def').id) {
	            delete layout.dataApprovalLevel;
	        }
	
	        if (layout.regressionType === 'NONE') {
	            delete layout.regressionType;
	        }
	    }
	
	    layout.url = appManager.getPath();
	
	    if (el) {
	        layout.el = el;
	    }
	
	    return layout;
	};
	
	Layout.prototype.toPostSuper = function () {
	    delete this.klass;
	    delete this.getResponse;
	    delete this.setResponse;
	    delete this.getAccess;
	    delete this.setAccess;
	    delete this.getDataDimensionItems;
	    delete this.setDataDimensionItems;
	    delete this.getRequestPath;
	
	    this.getDimensions(true).forEach(function (dimension) {
	        dimension.toPost();
	    });
	
	    this.rowTotals = this.showRowTotals;
	    delete this.showRowTotals;
	
	    this.colTotals = this.showColTotals;
	    delete this.showColTotals;
	
	    this.rowSubTotals = this.showRowSubTotals;
	    delete this.showRowSubTotals;
	
	    this.colSubTotals = this.showColSubTotals;
	    delete this.showColSubTotals;
	
	    this.reportParams = {
	        paramReportingPeriod: this.reportingPeriod,
	        paramOrganisationUnit: this.organisationUnit,
	        paramParentOrganisationUnit: this.parentOrganisationUnit
	    };
	
	    delete this.reportingPeriod;
	    delete this.organisationUnit;
	    delete this.parentOrganisationUnit;
	
	    delete this.parentGraphMap;
	
	    delete this.id;
	    delete this.el;
	
	    delete this.displayDescription;
	    delete this.interpretations;
	    delete this.lastUpdated;
	    delete this.created;
	    delete this.user;
	    delete this.publicAccess;
	    delete this.permission, delete this.userGroupAccesses;
	    delete this.displayName;
	};
	
	Layout.prototype.toSession = function () {
	    var t = this;
	
	    var response = t.getResponse();
	
	    t.extendRecords(response);
	
	    return t;
	};
	
	Layout.prototype.sort = function (table) {
	    var t = this,
	        refs = t.getRefs();
	
	    var _refs$api2 = refs.api,
	        Record = _refs$api2.Record,
	        Dimension = _refs$api2.Dimension,
	        ResponseRowIdCombination = _refs$api2.ResponseRowIdCombination;
	
	
	    var id = this.sorting.id,
	        direction = this.sorting.direction,
	        dimension = this.rows[0],
	        response = this.getResponse(),
	        idValueMap = table ? table.idValueMap : response.getIdValueMap(t),
	        records = [],
	        ids,
	        sortingId,
	        obj;
	
	    if (!(0, _isString2.default)(id)) {
	        return;
	    }
	
	    ids = this.getDimensionNameIdsMap(response)[dimension.dimension];
	
	    ids.forEach(function (item) {
	        var validId = new ResponseRowIdCombination(refs, [id, item]).get();
	        sortingId = parseFloat(idValueMap[validId]);
	
	        obj = {
	            id: item,
	            sortingId: (0, _isNumber2.default)(sortingId) ? sortingId : Number.MAX_VALUE * -1
	        };
	
	        records.push(obj);
	    });
	
	    // sort
	    (0, _arraySort2.default)(records, direction, 'sortingId');
	
	    // dimension
	    dimension.items = records.map(function (record) {
	        return new Record(refs, record);
	    });
	    dimension.sorted = true;
	
	    this.sorting.id = id;
	};
	
	// dep 3
	
	Layout.prototype.hasRecordIds = function (idParam, includeFilter) {
	    var ids = this.getRecordIds(includeFilter);
	    var has = false;
	
	    idParam = (0, _arrayFrom2.default)(idParam);
	
	    idParam.forEach(function (id) {
	        if ((0, _arrayContains2.default)(ids, id)) {
	            has = true;
	        }
	    });
	
	    return has;
	};
	
	Layout.prototype.getFirstDxId = function () {
	    return this.getDimension('dx').getRecordIds()[0];
	};
	
	Layout.prototype.del = function (fn, doMask, doUnmask) {
	    var t = this,
	        refs = this.getRefs();
	
	    var instanceManager = refs.instanceManager;
	
	    instanceManager.delById(t.id, fn, doMask, doUnmask);
	};
	
	Layout.prototype.toPost = function () {
	    var t = this;
	
	    t.toPostSuper();
	};
	
	Layout.prototype.isDimensionInRows = function (dimensionName) {
	    return this.rows.getDimensionNames().indexOf(dimensionName) !== -1;
	};
	
	// dep 4
	
	Layout.prototype.toPut = function () {
	    this.toPost();
	};
	
	Layout.prototype.isPeriodInRows = function () {
	    return this.isDimensionInRows('pe');
	};
	
	Layout.prototype.isOrganisationUnitInRows = function () {
	    return this.isDimensionInRows('ou');
	};
	
	// dep 5
	
	Layout.prototype.post = function (fn, doMask, doUnmask) {
	    var t = this,
	        refs = this.getRefs();
	
	    var appManager = refs.appManager,
	        instanceManager = refs.instanceManager,
	        uiManager = refs.uiManager;
	
	    var apiPath = appManager.getApiPath(),
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    var url = apiPath + '/' + apiEndpoint;
	
	    if (doMask) {
	        uiManager.mask();
	    }
	
	    // "Save as" mode, t.id is present, copy settings from original
	    if (t.id) {
	        instanceManager.getSharingById(t.id, function (sharing) {
	            // set sharing
	            if ((0, _isObject2.default)(sharing) && (0, _isObject2.default)(sharing.object)) {
	                t.setSharing(sharing.object);
	            }
	        });
	    }
	
	    t.toPost();
	
	    // post
	    var postRequest = new refs.api.Request(refs, {
	        baseUrl: url,
	        type: 'ajax',
	        method: 'POST',
	        data: JSON.stringify(t),
	        success: function success(obj, _success, r) {
	            var id = (r.getResponseHeader('location') || '').split('/').pop();
	
	            if (!(0, _isString2.default)(id)) {
	                console.log('Layout post', 'Invalid id', id);
	            }
	
	            if (doUnmask) {
	                uiManager.unmask();
	            }
	
	            if (fn) {
	                fn(id, _success, r);
	            }
	        }
	    });
	
	    postRequest.run();
	    //    });
	};
	
	Layout.prototype.put = function (id, fn, doMask, doUnmask) {
	    var t = this,
	        refs = this.getRefs();
	
	    var appManager = refs.appManager,
	        instanceManager = refs.instanceManager,
	        uiManager = refs.uiManager;
	
	    var apiPath = appManager.getApiPath(),
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    var url = apiPath + '/' + apiEndpoint + '/' + id;
	
	    if (doMask) {
	        uiManager.mask();
	    }
	
	    instanceManager.getSharingById(t.id, function (sharing) {
	        t.toPut();
	
	        // set sharing
	        if ((0, _isObject2.default)(sharing) && (0, _isObject2.default)(sharing.object)) {
	            t.setSharing(sharing.object);
	        }
	
	        // put
	        var putRequest = new refs.api.Request(refs, {
	            baseUrl: url,
	            type: 'ajax',
	            method: 'PUT',
	            data: JSON.stringify(t),
	            success: function success(obj, _success2, r) {
	                if (doUnmask) {
	                    uiManager.unmask();
	                }
	
	                if (fn) {
	                    fn(id, _success2, r);
	                }
	            },
	            error: function error(r) {
	                if ((0, _arrayContains2.default)([403], parseInt(r.httpStatusCode))) {
	                    r.message = i18n.you_do_not_have_access_to_all_items_in_this_favorite || r.message;
	                }
	
	                if (doMask) {
	                    uiManager.unmask();
	                }
	
	                uiManager.alert(r);
	            }
	        });
	
	        putRequest.run();
	    });
	};
	
	Layout.prototype.patch = function (properties, fn, doMask, doUnmask) {
	    var t = this,
	        refs = this.getRefs();
	
	    var appManager = refs.appManager,
	        instanceManager = refs.instanceManager,
	        uiManager = refs.uiManager;
	
	    var apiPath = appManager.getApiPath(),
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    var url = apiPath + '/' + apiEndpoint + '/' + t.id;
	
	    if (!(0, _isObject2.default)(properties)) {
	        return;
	    }
	
	    if (doMask) {
	        uiManager.mask();
	    }
	
	    var patchRequest = new refs.api.Request(refs, {
	        baseUrl: url,
	        type: 'ajax',
	        method: 'PATCH',
	        data: JSON.stringify(properties),
	        dataType: 'text',
	        headers: appManager.defaultRequestHeaders,
	        success: function success(obj, _success3, r) {
	            if (doUnmask) {
	                uiManager.unmask();
	            }
	
	            if (fn) {
	                fn(null, _success3, r);
	            }
	        }
	    });
	
	    patchRequest.run();
	};
	
	Layout.prototype.req = function (source, format, isSorted, isTableLayout, isFilterAsDimension) {
	    var t = this,
	        refs = this.getRefs();
	
	    var Request = refs.api.Request;
	
	
	    var optionConfig = refs.optionConfig,
	        appManager = refs.appManager,
	        request = new Request(refs);
	
	    var defAggTypeId = optionConfig.getAggregationType('def').id,
	        displayProperty = this.displayProperty || appManager.getAnalyticsDisplayProperty();
	
	    // dimensions
	    this.getDimensions(false, isSorted).forEach(function (dimension) {
	        request.add(dimension.url(isSorted));
	    });
	
	    // filters
	    if (this.filters) {
	        this.filters.forEach(function (dimension) {
	            var isFilter = !(isFilterAsDimension && dimension.isRequired());
	
	            request.add(dimension.url(isSorted, null, isFilter));
	        });
	    }
	
	    // skip rounding
	    if (this.skipRounding) {
	        request.add('skipRounding=true');
	    }
	
	    // display property
	    request.add('displayProperty=' + displayProperty.toUpperCase());
	
	    // completed only
	    if (this.completedOnly) {
	        request.add('completedOnly=true');
	    }
	
	    // normal request only
	    if (!isTableLayout) {
	        // hierarchy
	        if (this.showHierarchy) {
	            request.add('hierarchyMeta=true');
	        }
	
	        // aggregation type
	        if ((0, _isString2.default)(this.aggregationType) && this.aggregationType !== defAggTypeId) {
	            request.add('aggregationType=' + this.aggregationType);
	        }
	
	        // user org unit
	        if ((0, _isArray2.default)(this.userOrgUnit) && this.userOrgUnit.length) {
	            request.add(this.getUserOrgUnitUrl());
	        }
	
	        // data approval level
	        if ((0, _isObject2.default)(this.dataApprovalLevel) && (0, _isString2.default)(this.dataApprovalLevel.id) && this.dataApprovalLevel.id !== 'DEFAULT') {
	            request.add('approvalLevel=' + this.dataApprovalLevel.id);
	        }
	
	        // relative period date
	        if (this.relativePeriodDate) {
	            request.add('relativePeriodDate=' + this.relativePeriodDate);
	        }
	
	        // measure criteria
	        if (this.measureCriteria) {
	            request.add('measureCriteria=' + this.measureCriteria);
	        }
	    } else {
	        // table layout
	        request.add('tableLayout=true');
	
	        // columns
	        request.add('columns=' + this.getDimensionNames(false, false, this.columns).join(';'));
	
	        // rows
	        request.add('rows=' + this.getDimensionNames(false, false, this.rows).join(';'));
	
	        // hide empty columns
	        if (this.hideEmptyColumns) {
	            request.add('hideEmptyColumns=true');
	        }
	
	        // hide empty rows
	        if (this.hideEmptyRows) {
	            request.add('hideEmptyRows=true');
	        }
	
	        // show hierarchy
	        if (this.showHierarchy) {
	            request.add('showHierarchy=true');
	        }
	    }
	
	    // relative orgunits / user
	    if (this.hasRecordIds(appManager.userIdDestroyCacheKeys, true)) {
	        request.add('user=' + appManager.userAccount.id);
	    }
	
	    // base
	    request.setBaseUrl(this.getRequestPath(source, format));
	
	    return request;
	};
	
	// dep 5
	
	Layout.prototype.data = function (source, format) {
	    var t = this,
	        refs = this.getRefs();
	
	    var uiManager = refs.uiManager;
	
	    var metaDataRequest = this.req(source, format);
	    var dataRequest = this.req(source, format, true);
	
	    var errorFn = function errorFn(r) {
	        // 409
	        // DHIS2-2020: 503 error (perhaps analytics maintenance mode)
	        if ((0, _isObject2.default)(r) && (r.status == 409 || r.status === 503)) {
	            uiManager.unmask();
	
	            if ((0, _isString2.default)(r.responseText)) {
	                uiManager.alert(JSON.parse(r.responseText));
	            }
	        }
	    };
	
	    metaDataRequest.setType(this.getDefaultFormat());
	    dataRequest.setType(this.getDefaultFormat());
	
	    metaDataRequest.add('skipData=true');
	    dataRequest.add('skipMeta=true');
	
	    metaDataRequest.add('includeMetadataDetails=true');
	    dataRequest.add('includeNumDen=true');
	
	    metaDataRequest.setError(errorFn);
	    dataRequest.setError(errorFn);
	
	    return {
	        metaData: metaDataRequest.run(),
	        data: dataRequest.run()
	    };
	};
	//# sourceMappingURL=Layout.js.map

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OrganisationUnit = undefined;
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrganisationUnit = exports.OrganisationUnit = undefined;
	
	exports.OrganisationUnit = OrganisationUnit = function OrganisationUnit(refs, config) {
	    var t = this;
	
	    t.id = config.id;
	    t.refs = refs;
	    t.i18n = refs.i18nManager.get();
	
	    // dynamic
	    t.ancestors = [];
	    t.level = null;
	};
	
	OrganisationUnit.prototype.getLevel = function () {
	    return this.level;
	};
	
	OrganisationUnit.prototype.setLevel = function (level) {
	    this.level = level;
	};
	
	OrganisationUnit.prototype.getAncestors = function () {
	    return this.ancestors;
	};
	
	OrganisationUnit.prototype.setAncestors = function (ancestors) {
	    this.ancestors = (0, _arrayFrom2.default)(ancestors);
	};
	
	OrganisationUnit.prototype.getInstanceManager = function () {
	    return this.refs.instanceManager;
	};
	
	OrganisationUnit.prototype.getAppManager = function () {
	    return this.refs.appManager;
	};
	
	OrganisationUnit.prototype.getUpperLevels = function () {
	    return this.getAncestors();
	};
	
	// dep 1
	
	OrganisationUnit.prototype.getAncestorsRequest = function (shouldRun) {
	    var Request = this.refs.api.Request;
	
	
	    var request = new Request(refs, {
	        baseUrl: this.getAppManager().getApiPath() + '/organisationUnits/' + this.id + '.json',
	        type: 'json',
	        params: ['fields=id,level,ancestors[id,level,displayName~rename(name)]', 'paging=false']
	    });
	
	    return shouldRun ? request.run() : request;
	};
	
	OrganisationUnit.prototype.getOrganisationUnitLevels = function () {
	    return this.getAppManager().organisationUnitLevels;
	};
	
	OrganisationUnit.prototype.getResponse = function () {
	    return this.getInstanceManager().getStateCurrent().getResponse();
	};
	
	OrganisationUnit.prototype.getRootAncestor = function () {
	    var sorted = this.getAncestors().slice().sort(function (a, b) {
	        return a.level > b.level;
	    });
	
	    return sorted.length ? sorted[0] : this;
	};
	
	OrganisationUnit.prototype.getParent = function () {
	    var ancestors = this.getAncestors().slice().sort(function (a, b) {
	        return a.level > b.level;
	    });
	
	    return ancestors.length ? ancestors[ancestors.length - 1] : null;
	};
	
	// dep 2
	
	OrganisationUnit.prototype.getHierarchyName = function () {
	    var _this = this;
	
	    return this.getOrganisationUnitLevels().find(function (ou) {
	        return ou.level === _this.getLevel();
	    }).name;
	};
	
	OrganisationUnit.prototype.isRoot = function () {
	    var ancestor = this.getRootAncestor();
	
	    return ancestor ? this.getLevel() === ancestor.level : false;
	};
	
	OrganisationUnit.prototype.getName = function () {
	    return this.getResponse().getNameById(this.id);
	};
	
	// dep 3
	
	OrganisationUnit.prototype.getSublevels = function () {
	    var _this2 = this;
	
	    var level = this.getLevel();
	
	    var sublevels = this.getOrganisationUnitLevels().filter(function (ou) {
	        return ou.level > level;
	    });
	
	    sublevels = sublevels.map(function (ou) {
	        return {
	            id: _this2.id,
	            name: ou.name.toLowerCase(),
	            level: ou.level
	        };
	    });
	
	    return sublevels;
	};
	
	// dep 4
	
	OrganisationUnit.prototype.getContextMenuItemsConfig = function () {
	    var _this3 = this;
	
	    // fun goes here
	    var items = [];
	
	    var sublevels = this.getSublevels();
	    var upperLevels = this.getUpperLevels();
	
	    // generate upper levels
	    if (upperLevels.length > 0) {
	        items.push({
	            isSubtitle: true,
	            style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	            html: this.i18n.drill_up
	        });
	
	        upperLevels.forEach(function (ou) {
	            items.push({
	                items: [{ id: ou.id }],
	                text: 'Show <span class="name">' + ou.name + '</span>',
	                iconCls: 'ns-menu-item-float'
	            });
	        });
	    }
	
	    // generate menu item for current level
	    items.push({
	        isSubtitle: true,
	        style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	        html: this.getHierarchyName()
	    });
	
	    items.push({
	        items: [{ id: this.id }],
	        text: 'Show only <span class="name">' + this.getName() + '</span>',
	        iconCls: 'ns-menu-item-float'
	    });
	
	    if (this.getParent()) {
	        items.push({
	            items: [{ id: this.getParent().id + ';LEVEL-' + this.getLevel() }],
	            text: 'Show all <span class="name">' + this.getHierarchyName() + ' units in ' + this.getParent().name + '</span>',
	            iconCls: 'ns-menu-item-float'
	        });
	    }
	
	    // generate menu items for sublevels
	    if (sublevels.length > 0) {
	        (function () {
	            var root = _this3.getRootAncestor();
	
	            items.push({
	                isSubtitle: true,
	                style: 'padding: 5px 5px 5px 5px; font-size: 120%; font-weight:bold',
	                html: _this3.i18n.drill_down
	            });
	
	            sublevels.forEach(function (ou) {
	                items.push({
	                    items: [{ id: ou.id + ';' + 'LEVEL-' + ou.level }],
	                    text: 'Show all <span class="name">' + ou.name.toLowerCase() + ' units in ' + _this3.getName() + '</span>',
	                    iconCls: 'ns-menu-item-float'
	                });
	            });
	
	            sublevels.forEach(function (ou) {
	                if (root.level !== _this3.getLevel()) {
	                    items.push({
	                        items: [{ id: root.id + ';' + 'LEVEL-' + ou.level }],
	                        text: 'Show all <span class="name">' + ou.name + ' units</span>',
	                        iconCls: 'ns-menu-item-float'
	                    });
	                }
	            });
	        })();
	    }
	
	    return items;
	};
	//# sourceMappingURL=OrganisationUnit.js.map

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Record = undefined;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Record = exports.Record = undefined;
	
	exports.Record = Record = function Record(refs, config) {
	    var t = this;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    // constructor
	    t.id = config.id;
	    t.name = config.name;
	
	    // tmp 2.22
	    t.objectName = config.objectName;
	
	    if ((0, _isString2.default)(config.dimensionItemType)) {
	        t.dimensionItemType = config.dimensionItemType;
	    }
	};
	
	Record.prototype.log = function (text, noError) {
	    if (!noError) {
	        console.log(text, this);
	    }
	};
	
	Record.prototype.val = function (noError) {
	    if (!this || !(0, _isString2.default)(this.id)) {
	        this.log('(Record) Id is not a string', noError);
	        return null;
	    }
	
	    return this;
	};
	
	Record.prototype.setName = function (name, response) {
	    this.name = name || this.name || (this.id && response ? response.getNameById(this.id) : null);
	};
	
	Record.prototype.toPlugin = function () {
	    delete this.klass;
	};
	
	Record.prototype.toPost = function () {
	    delete this.klass;
	    delete this.name;
	    delete this.dimensionItemType;
	};
	//# sourceMappingURL=Record.js.map

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Request = undefined;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isFunction = __webpack_require__(17);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isEmpty = __webpack_require__(29);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _arrayClean = __webpack_require__(7);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Request = exports.Request = undefined;
	
	exports.Request = Request = function Request(refs, config) {
	    var t = this;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    // constructor
	    t.method = (0, _isString2.default)(config.method) ? config.method : 'GET';
	    t.headers = (0, _isObject2.default)(config.headers) ? config.headers : refs.appManager.defaultRequestHeaders;
	    t.dataType = (0, _isString2.default)(config.dataType) ? config.dataType : 'json';
	    t.contentType = (0, _isString2.default)(config.contentType) ? config.contentType : null;
	    t.success = (0, _isFunction2.default)(config.success) ? config.success : function () {
	        t.defaultSuccess();
	    };
	    t.error = (0, _isFunction2.default)(config.error) ? config.error : function () {
	        t.defaultError();
	    };
	    t.complete = (0, _isFunction2.default)(config.complete) ? config.complete : function () {
	        t.defaultComplete();
	    };
	
	    t.type = (0, _isString2.default)(config.type) ? config.type : 'ajax';
	    t.baseUrl = (0, _isString2.default)(config.baseUrl) ? config.baseUrl : '';
	    t.params = (0, _arrayFrom2.default)(config.params);
	    t.data = config.data ? config.data : null;
	    t.manager = config.manager || null;
	
	    t.beforeRun = (0, _isFunction2.default)(config.beforeRun) ? config.beforeRun : null;
	    t.afterRun = (0, _isFunction2.default)(config.afterRun) ? config.afterRun : null;
	
	    // defaults
	    t.defaultSuccess = function () {
	        var t = this;
	
	        if (t.manager) {
	            t.manager.ok(t);
	        }
	    };
	
	    t.defaultError = function () {};
	    t.defaultComplete = function () {};
	};
	
	Request.prototype.log = function (text, noError) {
	    if (!noError) {
	        console.log(text, this);
	    }
	};
	
	Request.prototype.alert = function (text, noError) {
	    if (!noError) {
	        alert(text);
	    }
	};
	
	Request.prototype.handle = function (statusCode, noError) {
	    var url = this.url(),
	        text;
	
	    if ((0, _arrayContains2.default)([413, 414], statusCode)) {
	        if (isIE()) {
	            text = 'Too many items selected (url has ' + url.length + ' characters). Internet Explorer accepts maximum 2048 characters.';
	        } else {
	            var len = url.length > 8000 ? '8000' : url.length > 4000 ? '4000' : '2000';
	            text = 'Too many items selected (url has ' + url.length + ' characters). Please reduce to less than ' + len + ' characters.';
	        }
	    }
	
	    if (text) {
	        text += '\n\n' + 'Hint: A good way to reduce the number of items is to use relative periods and level/group organisation unit selection modes.';
	
	        this.alert(text);
	    }
	};
	
	Request.prototype.add = function (param) {
	    var t = this;
	
	    if ((0, _isString2.default)(param)) {
	        t.params.push(param);
	    } else if ((0, _isArray2.default)(param)) {
	        param.forEach(function (item) {
	            if ((0, _isString2.default)(item)) {
	                t.params.push(item);
	            }
	        });
	    } else if ((0, _isObject2.default)(param)) {
	        for (var key in param) {
	            if (param.hasOwnProperty(key) && !(0, _isEmpty2.default)(param[key])) {
	                t.params.push(key + '=' + param[key]);
	            }
	        }
	    }
	
	    return this;
	};
	
	Request.prototype.setBaseUrl = function (baseUrl) {
	    if ((0, _isString2.default)(baseUrl)) {
	        this.baseUrl = baseUrl;
	    }
	};
	
	Request.prototype.setType = function (type) {
	    if ((0, _isString2.default)(type)) {
	        this.type = type;
	    }
	};
	
	Request.prototype.setManager = function (manager) {
	    this.manager = manager;
	};
	
	Request.prototype.setSuccess = function (fn) {
	    if ((0, _isFunction2.default)(fn)) {
	        this.success = fn;
	    }
	};
	
	Request.prototype.setError = function (fn) {
	    if ((0, _isFunction2.default)(fn)) {
	        this.error = fn;
	    }
	};
	
	Request.prototype.setBeforeRun = function (fn) {
	    if ((0, _isFunction2.default)(fn)) {
	        this.beforeRun = fn;
	    }
	};
	
	Request.prototype.setComplete = function (fn) {
	    if ((0, _isFunction2.default)(fn)) {
	        this.complete = fn;
	    }
	};
	
	Request.prototype.url = function (extraParams) {
	    var params = (0, _arrayClean2.default)([].concat(this.params, (0, _arrayFrom2.default)(extraParams)));
	
	    return this.baseUrl + (params.length ? '?' + params.join('&') : '');
	};
	
	// dep 1
	
	Request.prototype.run = function (config) {
	    var t = this,
	        url = encodeURI(this.url());
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    var success = config.success || t.success,
	        error = config.error || t.error,
	        complete = config.complete || t.complete;
	
	    var completeFn = function completeFn() {
	        if ((0, _isFunction2.default)(t.afterRun)) {
	            t.afterRun();
	        }
	
	        complete();
	    };
	
	    if (t.beforeRun && t.beforeRun() === false) {
	        return;
	    }
	
	    if (t.type === 'json') {
	        return $.getJSON(url, success).error(error).complete(complete);
	    } else {
	        var method = config.method || t.method,
	            headers = config.headers || t.headers,
	            dataType = config.dataType || t.dataType,
	            contentType = config.contentType || t.contentType,
	            data = config.data || t.data,
	            xhr = {};
	
	        xhr.url = url;
	        xhr.method = method;
	        xhr.type = method;
	        xhr.data = data;
	        headers && (xhr.headers = headers);
	        dataType && (xhr.dataType = dataType);
	        contentType && (xhr.contentType = contentType);
	        xhr.success = success;
	        xhr.error = error;
	        xhr.complete = completeFn;
	
	        return $.ajax(xhr);
	    }
	};
	//# sourceMappingURL=Request.js.map

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Response = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _arrayClean = __webpack_require__(7);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayInsert = __webpack_require__(178);
	
	var _arrayInsert2 = _interopRequireDefault(_arrayInsert);
	
	var _arraySort = __webpack_require__(8);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _arrayUnique = __webpack_require__(12);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	var _objectApplyIf = __webpack_require__(66);
	
	var _objectApplyIf2 = _interopRequireDefault(_objectApplyIf);
	
	var _clone = __webpack_require__(28);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _isBoolean = __webpack_require__(13);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isDefined = __webpack_require__(64);
	
	var _isDefined2 = _interopRequireDefault(_isDefined);
	
	var _isEmpty = __webpack_require__(29);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isNumber = __webpack_require__(9);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isNumeric = __webpack_require__(18);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _getParseMiddleware = __webpack_require__(170);
	
	var _getParseMiddleware2 = _interopRequireDefault(_getParseMiddleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Response = exports.Response = function Response(refs, config) {
	    var t = this;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    var appManager = refs.appManager,
	        indexedDbManager = refs.indexedDbManager,
	        i18nManager = refs.i18nManager;
	    var _refs$api = refs.api,
	        ResponseHeader = _refs$api.ResponseHeader,
	        ResponseRow = _refs$api.ResponseRow;
	
	
	    var i18n = i18nManager.get();
	
	    var booleanMap = {
	        '0': i18n.no || 'No',
	        '1': i18n.yes || 'Yes'
	    };
	
	    var OUNAME = 'ouname',
	        OU = 'ou';
	
	    var DEFAULT_COLLECT_IGNORE_HEADERS = ['psi', 'ps', 'eventdate', 'longitude', 'latitude', 'ouname', 'oucode', 'eventdate', 'eventdate'];
	
	    var DEFAULT_PREFIX_IGNORE_HEADERS = ['dy'].concat(DEFAULT_COLLECT_IGNORE_HEADERS);
	
	    //DIMENSIONS      ITEMS    -> COLLECT         PREFIX
	
	    //- required                        V               V           no             no
	
	    //- legendSet                       V               V           no             no
	    //- !dimensions                     x               x           yes            yes
	
	    //- optionset, !dimensions          x               x           yes            yes
	    //- optionset                       V               x           no             yes
	
	    // functions
	    var isPrefixHeader = function isPrefixHeader(header, dimensions) {
	        if ((0, _arrayContains2.default)(DEFAULT_PREFIX_IGNORE_HEADERS, header.name)) {
	            return false;
	        }
	
	        return (0, _isEmpty2.default)(dimensions);
	    };
	
	    var isCollectHeader = function isCollectHeader(header, dimensions) {
	        if ((0, _arrayContains2.default)(DEFAULT_COLLECT_IGNORE_HEADERS, header.name)) {
	            return false;
	        }
	
	        return (0, _isEmpty2.default)(dimensions);
	    };
	
	    var getHeader = function getHeader(name) {
	        return t.headers.find(function (header) {
	            return header.name === name;
	        });
	    };
	    var hasHeader = function hasHeader(name) {
	        return getHeader(name) !== undefined;
	    };
	
	    t.getPrefixedId = function (id, prefix) {
	        return (prefix || '') + '_' + id;
	    };
	
	    t.getSortedUniqueRowIdStringsByHeader = function (header) {
	        var parseByType = (0, _getParseMiddleware2.default)(header.valueType);
	        var parseString = (0, _getParseMiddleware2.default)('STRING');
	
	        return (0, _arraySort2.default)((0, _arrayClean2.default)((0, _arrayUnique2.default)(t.rows.map(function (responseRow) {
	            return parseByType(responseRow.getAt(header.index));
	        })))).map(function (id) {
	            return parseString(id);
	        });
	    };
	
	    t.getNameByIdsByValueType = function (id, valueType) {
	        if (valueType === 'BOOLEAN') {
	            return booleanMap[id];
	        }
	
	        return id;
	    };
	
	    t.optionCodeIdMap = function () {
	        var dimensions = config.metaData.dimensions;
	        var items = config.metaData.items;
	        var map = {};
	
	        config.headers.filter(function (header) {
	            return (0, _isString2.default)(header.optionSet);
	        }).forEach(function (header) {
	            var optionIds = dimensions[header.name];
	
	            var mapByDimension = optionIds.map(function (id) {
	                return _defineProperty({}, items[id].code, id);
	            }).reduce(function (map, obj) {
	                return _extends(map, obj);
	            }, {});
	
	            map[header.name] = mapByDimension;
	        });
	
	        return map;
	    }();
	
	    // headers
	    t.headers = (config.headers || []).map(function (header, index) {
	        var dimensions = config.metaData.dimensions;
	
	        var prefixConfig = isPrefixHeader(header, dimensions[header.name]) ? { isPrefix: true } : {};
	        var collectConfig = isCollectHeader(header, dimensions[header.name]) ? { isCollect: true } : {};
	
	        return new ResponseHeader(refs, header, _extends({}, prefixConfig, collectConfig, { index: index }));
	    });
	
	    // rows
	    t.rows = function () {
	        var headersWithOptionSet = t.headers.filter(function (header) {
	            return header.optionSet;
	        });
	        var rows = config.rows;
	
	        if (headersWithOptionSet.length) {
	            rows = rows.slice();
	
	            // replace option code with option uid
	            headersWithOptionSet.forEach(function (header) {
	                rows.forEach(function (row) {
	                    var id = t.optionCodeIdMap[header.name][row[header.index]];
	
	                    if (id) {
	                        row[header.index] = id;
	                    }
	                });
	            });
	        }
	        // map to ResponseRow
	        return rows.map(function (row) {
	            return ResponseRow(refs, row);
	        });
	    }();
	
	    // metadata
	    t.metaData = function () {
	        var metaData = _extends({}, config.metaData);
	
	        var dimensions = metaData.dimensions,
	            items = metaData.items;
	
	        // populate metaData dimensions and items
	        t.headers.filter(function (header) {
	            return !(0, _arrayContains2.default)(DEFAULT_COLLECT_IGNORE_HEADERS, header.name);
	        }).forEach(function (header) {
	            var ids;
	
	            // collect row values
	            if (header.isCollect) {
	                ids = t.getSortedUniqueRowIdStringsByHeader(header);
	                dimensions[header.name] = ids;
	            } else {
	                ids = dimensions[header.name];
	            }
	
	            if (header.isPrefix) {
	
	                // create prefixed dimensions array
	                dimensions[header.name] = ids.map(function (id) {
	                    return t.getPrefixedId(id, header.name);
	                });
	
	                // create items
	                if (header.optionSet) {
	                    dimensions[header.name].forEach(function (prefixedId, index) {
	                        var id = ids[index];
	                        var optionSet = header.optionSet;
	
	                        var name = indexedDbManager.getCachedOptionName(id, optionSet);
	
	                        items[prefixedId] = { name: metaData.items[name] ? metaData.items[name].name : name };
	                    });
	                } else {
	                    dimensions[header.name].forEach(function (prefixedId, index) {
	                        var id = ids[index];
	                        var valueType = header.valueType;
	
	                        var name = t.getNameByIdsByValueType(id, valueType);
	
	                        items[prefixedId] = { name: name };
	                    });
	                }
	            }
	        });
	
	        // for events, add items from 'ouname'
	        if (hasHeader(OUNAME) && hasHeader(OU)) {
	            var ounameHeaderIndex = getHeader(OUNAME).getIndex();
	            var ouHeaderIndex = getHeader(OU).getIndex();
	
	            for (var i = 0, row, ouId, ouName, item; i < t.rows.length; i++) {
	                row = t.rows[i];
	                ouId = row.getAt(ouHeaderIndex);
	
	                if (items[ouId] !== undefined) {
	                    continue;
	                }
	
	                ouName = row.getAt(ounameHeaderIndex);
	
	                items[ouId] = {
	                    name: ouName
	                };
	            }
	        }
	
	        return metaData;
	    }();
	
	    // transient
	    t.nameHeaderMap = function () {
	        var map = {};
	
	        t.headers.forEach(function (header) {
	            map[header.name] = header;
	        });
	
	        return map;
	    }();
	
	    // uninitialized
	    t.idValueMap;
	    t.sortedRows;
	
	    t.getRefs = function () {
	        return refs;
	    };
	};
	
	Response.prototype.sortOrganisationUnitsHierarchy = function () {
	    var _this = this;
	
	    var organisationUnits = this.metaData.dimensions.ou;
	
	    var _loop = function _loop(i) {
	        var organisationUnit = organisationUnits[i],
	            hierarchyPrefix = _this.metaData.ouHierarchy[organisationUnit],
	            hierarchyIds = [organisationUnit],
	            hierarchyNames = [];
	
	        hierarchyPrefix.split('/').reverse().forEach(function (ouId) {
	            hierarchyIds.unshift(ouId);
	        });
	
	        hierarchyIds.map(function (ouId) {
	            if (_this.metaData.items[ouId]) {
	                hierarchyNames.push(_this.metaData.items[ouId].name);
	            }
	        });
	
	        organisationUnits[i] = {
	            id: organisationUnit,
	            fullName: hierarchyNames.join(' / ')
	        };
	    };
	
	    for (var i = 0; i < organisationUnits.length; ++i) {
	        _loop(i);
	    }
	
	    (0, _arraySort2.default)(organisationUnits, null, 'fullName');
	
	    this.metaData.dimensions.ou = organisationUnits.map(function (ou) {
	        return ou.id;
	    });
	};
	
	Response.prototype.clone = function () {
	    var refs = this.getRefs();
	
	    var Response = refs.api.Response;
	
	
	    return new Response(refs, this);
	};
	
	Response.prototype.getHeaderByName = function (name) {
	    return this.nameHeaderMap[name];
	};
	
	Response.prototype.getHeaderByIndex = function (index) {
	    return this.headers[index];
	};
	
	Response.prototype.getHeaderIndexByName = function (name) {
	    var header = this.nameHeaderMap[name] || {};
	
	    return header.index;
	};
	
	Response.prototype.getOptionSetHeaders = function () {
	    return t.headers.filter(function (header) {
	        return (0, _isString2.default)(header.optionSet) || isArray(header.optionSet);
	    });
	};
	
	Response.prototype.getNameById = function (id) {
	    return (this.metaData.items[id] || {}).name || id;
	};
	
	Response.prototype.getHierarchyNameById = function (id, isHierarchy, isHtml) {
	    var metaData = this.metaData,
	        name = '';
	
	    var items = metaData.items;
	
	    if (isHierarchy && metaData.ouHierarchy.hasOwnProperty(id)) {
	        var a = (0, _arrayClean2.default)(metaData.ouHierarchy[id].split('/'));
	
	        a.forEach(function (id) {
	            name += (isHtml ? '<span class="text-weak">' : '') + items[id].name + (isHtml ? '</span>' : '') + ' / ';
	        });
	    }
	
	    return name;
	};
	
	Response.prototype.getIdsByDimensionName = function (dimensionName) {
	    return this.metaData.dimensions ? this.metaData.dimensions[dimensionName] || [] : [];
	};
	
	Response.prototype.addMetaDataItems = function (items) {
	    this.metaData.items = _extends(this.metaData.items, items);
	};
	
	Response.prototype.addOuHierarchyDimensions = function () {
	    var t = this;
	
	    var headers = t.headers,
	        ouHierarchy = t.metaData.ouHierarchy,
	        rows = t.rows,
	        ouIndex,
	        numLevels = 0,
	        initArray = [],
	        newHeaders = [],
	        ou = 'ou',
	        a;
	
	    if (!ouHierarchy) {
	        return;
	    }
	
	    // get ou index
	    for (var i = 0, header; i < headers.length; i++) {
	        if (headers[i].name === ou) {
	            ouIndex = i;
	            break;
	        }
	    }
	
	    // get numLevels
	    for (var i = 0; i < rows.length; i++) {
	        numLevels = Math.max(numLevels, (0, _arrayClean2.default)(ouHierarchy[rows[i][ouIndex]].split('/')).length);
	    }
	
	    // init array
	    for (var i = 0; i < numLevels; i++) {
	        initArray.push('');
	    }
	
	    // extend rows
	    for (var i = 0, row, ouArray; i < rows.length; i++) {
	        row = rows[i];
	        ouArray = (0, _objectApplyIf2.default)((0, _arrayClean2.default)(ouHierarchy[row[ouIndex]].split('/')), (0, _clone2.default)(initArray));
	
	        (0, _arrayInsert2.default)(row, ouIndex, ouArray);
	    }
	
	    // create new headers
	    for (var i = 0; i < numLevels; i++) {
	        newHeaders.push({
	            column: 'Organisation unit',
	            hidden: false,
	            meta: true,
	            name: 'ou',
	            type: 'java.lang.String'
	        });
	    }
	
	    (0, _arrayInsert2.default)(headers, ouIndex, newHeaders);
	
	    return t;
	};
	
	Response.prototype.printResponseCSV = function () {
	    var t = this;
	
	    var headers = t.headers,
	        items = t.metaData.items,
	        rows = t.rows,
	        csv = '',
	        alink;
	
	    // headers
	    for (var i = 0; i < headers.length; i++) {
	        csv += '"' + headers[i].column + '"' + (i < headers.length - 1 ? ',' : '\n');
	    }
	
	    // rows
	    for (var i = 0; i < rows.length; i++) {
	        for (var j = 0, val, isMeta; j < rows[i].length; j++) {
	            val = rows[i][j];
	            isMeta = headers[j].meta;
	
	            csv += '"' + (isMeta && items[val] && (0, _isString2.default)(items[val].name) ? items[val].name : val) + '"';
	            csv += j < rows[i].length - 1 ? ',' : '\n';
	        }
	    }
	
	    alink = document.createElement('a');
	    alink.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv));
	    alink.setAttribute('download', 'data.csv');
	    alink.click();
	};
	
	Response.prototype.getFilteredHeaders = function (names) {
	    return this.headers.filter(function (header) {
	        return (0, _arrayContains2.default)(names, header.name);
	    });
	};
	
	Response.prototype.getOrganisationUnitsIds = function () {
	    return this.metaData.dimensions.ou;
	};
	
	// dep 1
	Response.prototype.getHeaderNameByIndex = function (index) {
	    return this.getHeaderByIndex(index).name;
	};
	
	Response.prototype.getHeaderIndexOrder = function (dimensionNames) {
	    var _this2 = this;
	
	    return dimensionNames.map(function (name) {
	        return _this2.getHeaderIndexByName(name);
	    });
	};
	
	Response.prototype.getIdsByDimensionNames = function (dimensionName) {
	    var _this3 = this;
	
	    return (0, _arrayClean2.default)(dimensionName.reduce(function (ids, name) {
	        return ids.concat(_this3.getIdsByDimensionName(name) || []);
	    }, []));
	};
	
	Response.prototype.getItemName = function (id, isHierarchy, isHtml) {
	    return this.getHierarchyNameById(id, isHierarchy) + this.getNameById(id);
	};
	
	Response.prototype.getRecordsByDimensionName = function (dimensionName) {
	    var _this4 = this;
	
	    var refs = this.getRefs(),
	        Record = refs.api.Record;
	
	
	    var ids = this.getIdsByDimensionName(dimensionName) || [],
	        records = ids.map(function (id) {
	        return new Record(refs, { id: id, name: _this4.getNameById(id) }).val();
	    });
	
	    return (0, _arrayClean2.default)(records);
	};
	
	Response.prototype.getValueHeader = function () {
	    return this.getHeaderByName('value');
	};
	
	Response.prototype.getNumeratorHeader = function () {
	    return this.getHeaderByName('numerator');
	};
	
	Response.prototype.getDenominatorHeader = function () {
	    return this.getHeaderByName('denominator');
	};
	
	Response.prototype.getFactorHeader = function () {
	    return this.getHeaderByName('factor');
	};
	
	Response.prototype.hasIdByDimensionName = function (id, dimensionName) {
	    return (0, _arrayContains2.default)(this.getIdsByDimensionName(dimensionName), id);
	};
	
	// dep 2
	Response.prototype.getValueHeaderIndex = function () {
	    return this.getValueHeader() ? this.getValueHeader().getIndex() : null;
	};
	
	Response.prototype.getNumeratorHeaderIndex = function () {
	    return this.getNumeratorHeader() ? this.getNumeratorHeader().getIndex() : null;
	};
	
	Response.prototype.getDenominatorHeaderIndex = function () {
	    return this.getDenominatorHeader() ? this.getDenominatorHeader().getIndex() : null;
	};
	
	Response.prototype.getFactorHeaderIndex = function () {
	    return this.getFactorHeader() ? this.getFactorHeader().getIndex() : null;
	};
	
	// dep 3
	Response.prototype.getSortedRows = function () {
	    if (this.sortedRows) {
	        return this.sortedRows;
	    }
	
	    var valueHeaderIndex = this.getValueHeaderIndex();
	
	    // filter
	    var rows = this.rows.filter(function (row) {
	        return (0, _isNumeric2.default)(row[valueHeaderIndex]);
	    });
	
	    // parse
	    rows.forEach(function (row) {
	        return row.toFloat(valueHeaderIndex);
	    });
	
	    // sort
	    (0, _arraySort2.default)(rows, 'DESC', valueHeaderIndex);
	
	    return this.sortedRows = rows;
	};
	
	Response.prototype.getIdValueMap = function (layout) {
	    return this.idValueMap = this.getIdMap(layout, 'value');
	};
	
	Response.prototype.getIdDenominatorMap = function (layout) {
	    return this.idDenominatorMap = this.getIdMap(layout, 'denominator');
	};
	
	Response.prototype.getIdNumeratorMap = function (layout) {
	    return this.idNumeratorMap = this.getIdMap(layout, 'numerator');
	};
	
	Response.prototype.getIdFactorMap = function (layout) {
	    return this.idFactorMap = this.getIdMap(layout, 'factor');
	};
	
	Response.prototype.getIdMap = function (layout, name) {
	    var _this5 = this;
	
	    var refs = this.getRefs(),
	        ResponseRowIdCombination = refs.api.ResponseRowIdCombination,
	        headerIndexOrder = (0, _arrayClean2.default)(this.getHeaderIndexOrder(layout.getDimensionNames())),
	        idMap = {};
	
	
	    this.rows.forEach(function (responseRow) {
	        var idCombination = new ResponseRowIdCombination(refs),
	            key = void 0,
	            rowValue = void 0,
	            header = void 0;
	
	        headerIndexOrder.forEach(function (index) {
	            header = _this5.getHeaderByIndex(index);
	            rowValue = responseRow.getAt(index);
	            key = header.isPrefix ? _this5.getPrefixedId(rowValue, header.name) : rowValue;
	
	            idCombination.add(key);
	        });
	
	        responseRow.setIdCombination(idCombination);
	        idMap[idCombination.get()] = responseRow.getAt(_this5.getHeaderByName(name).getIndex());
	    });
	
	    return idMap;
	};
	
	// dep 4
	Response.prototype.getValue = function (param, layout) {
	    var _getRefs = this.getRefs(),
	        ResponseRowIdCombination = _getRefs.refs.api,
	        id = param instanceof ResponseRowIdCombination ? param.get() : param;
	
	    return this.getIdValueMap(layout)[id];
	};
	
	Response.prototype.getExtremalRows = function (limit, isTop, isBottom) {
	    limit = (0, _isNumeric2.default)(limit) ? parseInt(limit) : 10;
	    isTop = (0, _isBoolean2.default)(isTop) ? isTop : true;
	    isBottom = (0, _isBoolean2.default)(isBottom) ? isBottom : true;
	
	    var sortedRows = this.getSortedRows(),
	        len = sortedRows.length;
	
	    return [].concat(_toConsumableArray(isTop ? sortedRows.slice(0, limit) : []), _toConsumableArray(isBottom ? sortedRows.slice(len - limit, len) : []));
	};
	
	// dep 5
	Response.prototype.getValues = function (paramArray, layout) {
	    var _this6 = this;
	
	    return (0, _arrayFrom2.default)(paramArray).map(function (param) {
	        return _this6.getValue(param, layout);
	    });
	};
	//# sourceMappingURL=Response.js.map

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResponseHeader = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isNumeric = __webpack_require__(18);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponseHeader = exports.ResponseHeader = undefined;
	
	exports.ResponseHeader = ResponseHeader = function ResponseHeader(refs, config, extraConfig) {
	    var t = this;
	
	    t.isPrefix = false;
	    t.isCollect = false;
	    t.index;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    // constructor
	    _extends(t, config, extraConfig);
	};
	
	ResponseHeader.prototype.setIndex = function (index) {
	    if ((0, _isNumeric2.default)(index)) {
	        this.index = parseInt(index);
	    }
	};
	
	ResponseHeader.prototype.getIndex = function (index) {
	    return this.index;
	};
	//# sourceMappingURL=ResponseHeader.js.map

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResponseRow = undefined;
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponseRow = exports.ResponseRow = undefined;
	
	exports.ResponseRow = ResponseRow = function ResponseRow(refs, config) {
	    var t = (0, _arrayFrom2.default)(config);
	
	    t.getAt = function (index) {
	        return this[index];
	    };
	
	    t.setIdCombination = function (idCombination) {
	        t.idCombination = idCombination;
	    };
	
	    t.getNames = function (response, ignoreIndexes) {
	        if (!t.idCombination) {
	            t.setIdCombination(new refs.api.ResponseRowIdCombination(refs, t));
	        }
	
	        return t.idCombination.getNames(response, ignoreIndexes);
	    };
	
	    t.toFloat = function (index) {
	        t[index] = parseFloat(t[index]);
	    };
	
	    t.getRowHtml = function (response, trClass, tdClass, ignoreIndexes) {
	        trClass = trClass ? ' class="' + trClass + '"' : '';
	        tdClass = tdClass ? ' class="' + tdClass + '"' : '';
	
	        var tdStyle = ' style="padding:0 5px"';
	
	        return '<tr' + trClass + '>' + t.getNames(response, ignoreIndexes).map(function (name) {
	            return '<td' + tdClass + tdStyle + '>' + name + '</td>';
	        }).join('') + '</tr>';
	    };
	
	    // uninitialized
	    t.idCombination;
	
	    return t;
	};
	//# sourceMappingURL=ResponseRow.js.map

/***/ },
/* 118 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Sorting = exports.Sorting = undefined;
	
	exports.Sorting = Sorting = function Sorting(refs, config) {
	    var t = this;
	
	    t.id = config.id || null;
	    t.direction = config.direction || null;
	    t.emptyFirst = config.emptyFirst || false;
	
	    var _keyMap = {
	        'asc': 'DESC',
	        'desc': 'ASC'
	    };
	
	    t.getKeyMap = function () {
	        return _keyMap;
	    };
	};
	
	Sorting.prototype.toggleDirection = function () {
	    this.direction = this.getKeyMap()[(this.direction || '').toLowerCase()];
	};
	//# sourceMappingURL=Sorting.js.map

/***/ },
/* 119 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ChartConfig = exports.ChartConfig = undefined;
	
	exports.ChartConfig = ChartConfig = function ChartConfig() {
	    var t = this;
	
	    t.client = {
	        series: 'series',
	        category: 'category',
	        filter: 'filter',
	        column: 'column',
	        stackedcolumn: 'stackedcolumn',
	        bar: 'bar',
	        stackedbar: 'stackedbar',
	        line: 'line',
	        area: 'area',
	        pie: 'pie',
	        radar: 'radar',
	        gauge: 'gauge'
	    };
	
	    t.server = {
	        column: 'COLUMN',
	        stackedcolumn: 'STACKED_COLUMN',
	        bar: 'BAR',
	        stackedbar: 'STACKED_BAR',
	        line: 'LINE',
	        area: 'AREA',
	        pie: 'PIE',
	        radar: 'RADAR',
	        gauge: 'GAUGE'
	    };
	
	    t.consts = {
	        domain: 'domain_',
	        targetLine: 'targetline_',
	        baseLine: 'baseline_',
	        trendLine: 'trendline_'
	    };
	
	    t.style = {
	        inset: 30,
	        fontFamily: 'Arial,Sans-serif,Roboto,Helvetica,Consolas'
	    };
	
	    t.theme = {
	        dv1: ['#94ae0a', '#1d5991', '#a61120', '#ff8809', '#7c7474', '#a61187', '#ffd13e', '#24ad9a', '#a66111', '#414141', '#4500c4', '#1d5700']
	    };
	
	    // transient
	
	    t.c2s = {};
	    t.s2c = {};
	
	    // initialize
	    (function () {
	        Object.keys(t.client).forEach(function (key) {
	            t.c2s[t.client[key]] = t.server[key];
	        });
	
	        Object.keys(t.server).forEach(function (key) {
	            t.s2c[t.server[key]] = t.client[key];
	        });
	    })();
	};
	//# sourceMappingURL=ChartConfig.js.map

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DimensionConfig = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DimensionConfig = exports.DimensionConfig = undefined;
	
	exports.DimensionConfig = DimensionConfig = function DimensionConfig() {
	    var t = this;
	
	    // service
	    var i18nManager;
	
	    // uninitialized
	    var dimensions = {};
	
	    // dimension name map
	    var dimensionNameDimensionMap = {
	        'dx': 'data',
	        'co': 'category',
	        'pe': 'period',
	        'ou': 'organisationUnit'
	    };
	
	    var defaultDataType = 'aggregated_values';
	
	    // data type
	    t.dataType = {
	        'aggregated_values': 'AGGREGATED_VALUES',
	        'individual_cases': 'EVENTS'
	    };
	
	    t.dataTypeUrl = {
	        'AGGREGATED_VALUES': '/events/aggregate',
	        'EVENTS': '/events/query'
	    };
	
	    // value type
	    t.valueType = {
	        'numeric_types': ['NUMBER', 'UNIT_INTERVAL', 'PERCENTAGE', 'INTEGER', 'INTEGER_POSITIVE', 'INTEGER_NEGATIVE', 'INTEGER_ZERO_OR_POSITIVE'],
	        'text_types': ['TEXT', 'LONG_TEXT', 'LETTER', 'PHONE_NUMBER', 'EMAIL'],
	        'boolean_types': ['BOOLEAN', 'TRUE_ONLY'],
	        'date_types': ['DATE', 'DATETIME'],
	        'aggregate_aggregatable_types': ['BOOLEAN', 'TRUE_ONLY', 'TEXT', 'LONG_TEXT', 'LETTER', 'INTEGER', 'INTEGER_POSITIVE', 'INTEGER_NEGATIVE', 'INTEGER_ZERO_OR_POSITIVE', 'NUMBER', 'UNIT_INTERVAL', 'PERCENTAGE', 'COORDINATE'],
	        'tracker_aggregatable_types': ['NUMBER', 'UNIT_INTERVAL', 'PERCENTAGE', 'INTEGER', 'INTEGER_POSITIVE', 'INTEGER_NEGATIVE', 'INTEGER_ZERO_OR_POSITIVE', 'BOOLEAN', 'TRUE_ONLY']
	    };
	
	    // setter
	    var setDimensions = function setDimensions() {
	        dimensions = _extends(dimensions, {
	            data: {
	                value: 'data',
	                name: i18nManager.get('data') || 'Data',
	                id: 'dx',
	                dimensionName: 'dx',
	                objectName: 'dx'
	            },
	            category: {
	                name: i18nManager.get('assigned_categories') || 'Assigned categories',
	                id: 'co',
	                dimensionName: 'co',
	                objectName: 'co'
	            },
	            indicator: {
	                value: 'indicator',
	                name: i18nManager.get('indicators') || 'Indicators',
	                dimensionName: 'dx',
	                objectName: 'in'
	            },
	            dataElement: {
	                value: 'dataElement',
	                name: i18nManager.get('data_elements') || 'Data elements',
	                dimensionName: 'dx',
	                objectName: 'de'
	            },
	            operand: {
	                value: 'operand',
	                name: i18nManager.get('operand') || 'Operand',
	                dimensionName: 'dx',
	                objectName: 'dc'
	            },
	            dataSet: {
	                value: 'dataSet',
	                name: i18nManager.get('data_sets') || 'Data sets',
	                dimensionName: 'dx',
	                objectName: 'ds'
	            },
	            eventDataItem: {
	                value: 'eventDataItem',
	                name: i18nManager.get('event_data_items') || 'Event data items',
	                dimensionName: 'dx',
	                objectName: 'di'
	            },
	            programIndicator: {
	                value: 'programIndicator',
	                name: i18nManager.get('program_indicators') || 'Program indicators',
	                dimensionName: 'dx',
	                objectName: 'pi'
	            },
	            period: {
	                value: 'period',
	                name: i18nManager.get('periods') || 'Periods',
	                id: 'pe',
	                dimensionName: 'pe',
	                objectName: 'pe'
	            },
	            fixedPeriod: {
	                value: 'period'
	            },
	            relativePeriod: {
	                value: 'relativePeriod'
	            },
	            startEndDate: {
	                value: 'dates',
	                name: i18nManager.get('start_end_dates')
	            },
	            organisationUnit: {
	                value: 'organisationUnit',
	                name: i18nManager.get('i18n.organisation_units') || 'Organisation units',
	                id: 'ou',
	                dimensionName: 'ou',
	                objectName: 'ou'
	            },
	            dimension: {
	                value: 'dimension'
	                //objectName: 'di'
	            },
	            value: {
	                value: 'value'
	            }
	        });
	    };
	
	    // init
	    t.init = function () {
	        setDimensions();
	    };
	
	    // prototype
	    t.add = function (param) {
	        (0, _arrayFrom2.default)(param).forEach(function (dimension) {
	            dimension.dimensionName = dimension.dimensionName || dimension.id;
	            dimension.objectName = dimension.objectName || dimension.id;
	
	            dimensions[dimension.id] = dimension;
	        });
	    };
	
	    t.get = function (name) {
	        var map = dimensionNameDimensionMap;
	
	        return name ? dimensions[name] || dimensions[map[name]] : dimensions;
	    };
	
	    t.getDimensionNameMap = function () {
	        var map = {};
	
	        for (var name in dimensions) {
	            if (dimensions.hasOwnProperty(name)) {
	                map[dimensions[name].dimensionName] = dimensions[name];
	            }
	        }
	
	        return map;
	    };
	
	    t.getObjectNameMap = function () {
	        var map = {};
	
	        for (var name in dimensions) {
	            if (dimensions.hasOwnProperty(name)) {
	                map[dimensions[name].objectName] = dimensions[name];
	            }
	        }
	
	        return map;
	    };
	
	    t.getDefaultDataType = function () {
	        return t.dataType[defaultDataType];
	    };
	
	    t.setI18nManager = function (manager) {
	        i18nManager = manager;
	    };
	};
	
	DimensionConfig.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.dimensionConfig = t;
	    });
	};
	//# sourceMappingURL=DimensionConfig.js.map

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OptionConfig = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	var _arraySort = __webpack_require__(8);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _stringReplaceAll = __webpack_require__(67);
	
	var _stringReplaceAll2 = _interopRequireDefault(_stringReplaceAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OptionConfig = exports.OptionConfig = undefined;
	
	exports.OptionConfig = OptionConfig = function OptionConfig() {
	    var t = this;
	
	    // service
	    var i18nManager;
	
	    // uninitialized
	    var displayDensity;
	    var fontSize;
	    var digitGroupSeparator;
	    var aggregationType;
	    var numberType;
	    var outputType;
	    var dataApprovalLevel;
	    var dataSetMetric;
	    var legendDisplayStyle;
	    var legendDisplayStrategy;
	    var programStatus;
	    var eventStatus;
	
	    // setter
	    var setDisplayDensity = function setDisplayDensity() {
	        displayDensity = {
	            'comfortable': {
	                index: 1,
	                id: 'COMFORTABLE',
	                name: i18nManager.get('comfortable') || 'Comfortable'
	            },
	            'normal': {
	                index: 2,
	                id: 'NORMAL',
	                name: i18nManager.get('normal') || 'Normal'
	            },
	            'compact': {
	                index: 3,
	                id: 'COMPACT',
	                name: i18nManager.get('compact') || 'Compact'
	            }
	        };
	    };
	
	    var setFontSize = function setFontSize() {
	        fontSize = {
	            'large': {
	                index: 1,
	                id: 'LARGE',
	                name: i18nManager.get('large') || 'Large'
	            },
	            'normal': {
	                index: 2,
	                id: 'NORMAL',
	                name: i18nManager.get('normal') || 'Normal'
	            },
	            'small': {
	                index: 3,
	                id: 'SMALL',
	                name: i18nManager.get('small') || 'Small'
	            }
	        };
	    };
	
	    var setDigitGroupSeparator = function setDigitGroupSeparator() {
	        digitGroupSeparator = {
	            'none': {
	                index: 1,
	                id: 'NONE',
	                name: i18nManager.get('none') || 'None',
	                value: ''
	            },
	            'space': {
	                index: 2,
	                id: 'SPACE',
	                name: i18nManager.get('space') || 'Space',
	                value: '&nbsp;'
	            },
	            'comma': {
	                index: 3,
	                id: 'COMMA',
	                name: i18nManager.get('comma') || 'Comma',
	                value: ','
	            }
	        };
	    };
	
	    var setAggregationType = function setAggregationType() {
	        aggregationType = {
	            'def': {
	                index: 1,
	                id: 'DEFAULT',
	                name: i18nManager.get('by_data_element') || 'By data element'
	            },
	            'count': {
	                index: 2,
	                id: 'COUNT',
	                name: i18nManager.get('count') || 'Count'
	            },
	            'avg': {
	                index: 3,
	                id: 'AVERAGE',
	                name: i18nManager.get('average') || 'Average'
	            },
	            'avg-sum-org-unit': {
	                index: 3,
	                id: 'AVERAGE_SUM_ORG_UNIT',
	                name: i18nManager.get('average_sum_org_unit') || 'Average (sum in org unit hierarchy)'
	            },
	            'sum': {
	                index: 3,
	                id: 'SUM',
	                name: i18nManager.get('sum') || 'Sum'
	            },
	            'stddev': {
	                index: 4,
	                id: 'STDDEV',
	                name: i18nManager.get('stddev') || 'Standard deviation'
	            },
	            'variance': {
	                index: 5,
	                id: 'VARIANCE',
	                name: i18nManager.get('variance') || 'Variance'
	            },
	            'min': {
	                index: 6,
	                id: 'MIN',
	                name: i18nManager.get('min') || 'Min'
	            },
	            'max': {
	                index: 7,
	                id: 'MAX',
	                name: i18nManager.get('max') || 'Max'
	            },
	            'last': {
	                index: 8,
	                id: 'LAST',
	                name: i18nManager.get('last') || 'Last value'
	            },
	            'last-average-org-unit': {
	                index: 9,
	                id: 'LAST_AVERAGE_ORG_UNIT',
	                name: i18nManager.get('last_average_org_unit') || 'Last value (average in org unit hierarchy)'
	            }
	        };
	    };
	
	    var setNumberType = function setNumberType() {
	        numberType = {
	            'value': {
	                index: 1,
	                id: 'VALUE',
	                name: i18nManager.get('value') || 'Value'
	            },
	            'percentofrow': {
	                index: 2,
	                id: 'ROW_PERCENTAGE',
	                name: i18nManager.get('percent_of_row') || 'Percentage of row'
	            },
	            'percentofcolumn': {
	                index: 3,
	                id: 'COLUMN_PERCENTAGE',
	                name: i18nManager.get('percent_of_column') || 'Percentage of column'
	            }
	        };
	    };
	
	    var setOutputType = function setOutputType() {
	        outputType = {
	            'event': {
	                index: 1,
	                id: 'EVENT',
	                name: i18nManager.get('event') || 'Event'
	            },
	            'enrollment': {
	                index: 2,
	                id: 'ENROLLMENT',
	                name: i18nManager.get('enrollment') || 'Enrollment'
	            },
	            'trackedentityinstance': {
	                index: 3,
	                id: 'TRACKED_ENTITY_INSTANCE',
	                name: i18nManager.get('tracked_entity_instance') || 'Tracked entity instance'
	            }
	        };
	    };
	
	    var setDataApprovalLevel = function setDataApprovalLevel() {
	        dataApprovalLevel = {
	            'def': {
	                index: 1,
	                id: 'DEFAULT',
	                name: i18nManager.get('show_all_data') || 'Show all data'
	            }
	        };
	    };
	
	    var setDataSetMetric = function setDataSetMetric() {
	        dataSetMetric = {
	            'reportingRates': {
	                index: 1,
	                id: 'REPORTING_RATE',
	                name: i18nManager.get('reporting_rates') || 'Reporting rates'
	            },
	            'reportingRatesOnTime': {
	                index: 2,
	                id: 'REPORTING_RATE_ON_TIME',
	                name: i18nManager.get('reporting_rates_on_time') || 'Reporting rates on time'
	            },
	            'actualReports': {
	                index: 3,
	                id: 'ACTUAL_REPORTS',
	                name: i18nManager.get('actual_reports') || 'Actual reports'
	            },
	            'actualReportsOnTime': {
	                index: 4,
	                id: 'ACTUAL_REPORTS_ON_TIME',
	                name: i18nManager.get('actual_reports_on_time') || 'Actual reports on time'
	            },
	            'expectedReports': {
	                index: 5,
	                id: 'EXPECTED_REPORTS',
	                name: i18nManager.get('expected_reports') || 'Expected reports'
	            }
	        };
	    };
	
	    var setLegendDisplayStyle = function setLegendDisplayStyle() {
	        legendDisplayStyle = {
	            'fill': {
	                index: 2,
	                id: 'FILL',
	                name: i18nManager.get('background_color') || 'Background color'
	            },
	            'text': {
	                index: 3,
	                id: 'TEXT',
	                name: i18nManager.get('text_color') || 'Text color'
	            }
	        };
	    };
	
	    var setLegendDisplayStrategy = function setLegendDisplayStrategy() {
	        legendDisplayStrategy = {
	            'fixed': {
	                index: 1,
	                id: 'FIXED',
	                name: i18nManager.get('all_data_items') || 'All'
	            },
	            'by_data_item': {
	                index: 2,
	                id: 'BY_DATA_ITEM',
	                name: i18nManager.get('by_data_item') || 'By data item'
	            }
	        };
	    };
	
	    var setProgramStatus = function setProgramStatus() {
	        programStatus = {
	            'def': {
	                index: 1,
	                id: 'DEFAULT',
	                name: i18nManager.get('all') || 'All'
	            },
	            'active': {
	                index: 2,
	                id: 'ACTIVE',
	                name: i18nManager.get('active') || 'Active'
	            },
	            'completed': {
	                index: 3,
	                id: 'COMPLETED',
	                name: i18nManager.get('completed') || 'Completed'
	            },
	            'cancelled': {
	                index: 4,
	                id: 'CANCELLED',
	                name: i18nManager.get('cancelled') || 'Cancelled'
	            }
	        };
	    };
	
	    var setEventStatus = function setEventStatus() {
	        eventStatus = {
	            'def': {
	                index: 1,
	                id: 'DEFAULT',
	                name: i18nManager.get('all') || 'All'
	            },
	            'active': {
	                index: 2,
	                id: 'ACTIVE',
	                name: i18nManager.get('active') || 'Active'
	            },
	            'completed': {
	                index: 3,
	                id: 'COMPLETED',
	                name: i18nManager.get('completed') || 'Completed'
	            },
	            'scheduled': {
	                index: 4,
	                id: 'SCHEDULE',
	                name: i18nManager.get('scheduled') || 'Scheduled'
	            },
	            'overdue': {
	                index: 5,
	                id: 'OVERDUE',
	                name: i18nManager.get('overdue') || 'Overdue'
	            },
	            'skipped': {
	                index: 6,
	                id: 'SKIPPED',
	                name: i18nManager.get('skipped') || 'Skipped'
	            }
	        };
	    };
	
	    // logic
	    var getRecords = function getRecords(optionType) {
	        var records = [];
	
	        for (var option in optionType) {
	            if (optionType.hasOwnProperty(option)) {
	                records.push(optionType[option]);
	            }
	        }
	
	        (0, _arraySort2.default)(records, 'ASC', 'index');
	
	        return records;
	    };
	
	    // init
	    t.init = function () {
	        setDisplayDensity();
	        setFontSize();
	        setDigitGroupSeparator();
	        setAggregationType();
	        setNumberType();
	        setOutputType();
	        setDataApprovalLevel();
	        setDataSetMetric();
	        setLegendDisplayStyle();
	        setLegendDisplayStrategy();
	        setProgramStatus();
	        setEventStatus();
	    };
	
	    // prototype
	    t.getDisplayDensity = function (key) {
	        return key ? displayDensity[key] : displayDensity;
	    };
	
	    t.getFontSize = function (key) {
	        return key ? fontSize[key] : fontSize;
	    };
	
	    t.getDigitGroupSeparator = function (key) {
	        return key ? digitGroupSeparator[key] : digitGroupSeparator;
	    };
	
	    t.getAggregationType = function (key) {
	        return key ? aggregationType[key] : aggregationType;
	    };
	
	    t.getNumberType = function (key) {
	        return key ? numberType[key] : numberType;
	    };
	
	    t.getOutputType = function (key) {
	        return key ? outputType[key] : outputType;
	    };
	
	    t.getDataApprovalLevel = function (key) {
	        return key ? dataApprovalLevel[key] : dataApprovalLevel;
	    };
	
	    t.getDataSetMetric = function (key) {
	        return key ? dataSetMetric[key] : dataSetMetric;
	    };
	
	    t.getLegendDisplayStyle = function (key) {
	        return key ? legendDisplayStyle[key] : legendDisplayStyle;
	    };
	
	    t.getLegendDisplayStrategy = function (key) {
	        return key ? legendDisplayStrategy[key] : legendDisplayStrategy;
	    };
	
	    t.getProgramStatus = function (key) {
	        return key ? programStatus[key] : programStatus;
	    };
	
	    t.getEventStatus = function (key) {
	        return key ? eventStatus[key] : eventStatus;
	    };
	
	    t.getDisplayDensityRecords = function () {
	        return getRecords(displayDensity);
	    };
	
	    t.getFontSizeRecords = function () {
	        return getRecords(fontSize);
	    };
	
	    t.getDigitGroupSeparatorRecords = function () {
	        return getRecords(digitGroupSeparator);
	    };
	
	    t.getAggregationTypeRecords = function () {
	        return getRecords(aggregationType);
	    };
	
	    t.getNumberTypeRecords = function () {
	        return getRecords(numberType);
	    };
	
	    t.getOutputTypeRecords = function () {
	        return getRecords(outputType);
	    };
	
	    t.getDataSetMetricRecords = function () {
	        return getRecords(dataSetMetric);
	    };
	
	    t.getLegendDisplayStyleRecords = function () {
	        return getRecords(legendDisplayStyle);
	    };
	
	    t.getLegendDisplayStrategyRecords = function () {
	        return getRecords(legendDisplayStrategy);
	    };
	
	    t.getProgramStatusRecords = function () {
	        return getRecords(programStatus);
	    };
	
	    t.getEventStatusRecords = function () {
	        return getRecords(eventStatus);
	    };
	
	    t.getDigitGroupSeparatorIdMap = function () {
	        var map = {};
	
	        for (var separator in digitGroupSeparator) {
	            if (digitGroupSeparator.hasOwnProperty(separator)) {
	                map[digitGroupSeparator[separator].id] = digitGroupSeparator[separator];
	            }
	        }
	
	        return map;
	    };
	
	    t.setI18nManager = function (manager) {
	        i18nManager = manager;
	    };
	};
	
	OptionConfig.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.optionConfig = t;
	    });
	};
	
	OptionConfig.prototype.getDigitGroupSeparatorValueById = function (id) {
	    var t = this;
	
	    var separator = t.getDigitGroupSeparatorIdMap()[id];
	
	    return separator ? separator.value : '';
	};
	
	// dep 1
	
	OptionConfig.prototype.prettyPrint = function (number, separator, noHtml) {
	    var t = this;
	
	    var spaceId = t.getDigitGroupSeparator('space').id,
	        noneId = t.getDigitGroupSeparator('none').id,
	        noneValue = t.getDigitGroupSeparator('none').value;
	
	    separator = separator || spaceId;
	
	    if (separator === noneId) {
	        return number;
	    }
	
	    var _split = ('' + number).split('.'),
	        _split2 = _slicedToArray(_split, 2),
	        num = _split2[0],
	        dec = _split2[1];
	
	    var pp = num.replace(/\B(?=(\d{3})+(?!\d))/g, t.getDigitGroupSeparatorValueById(separator) || noneValue) + (dec ? '.' + dec : '');
	
	    if (noHtml) {
	        pp = (0, _stringReplaceAll2.default)(pp, "&nbsp;", " ");
	    }
	
	    return pp;
	};
	//# sourceMappingURL=OptionConfig.js.map

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PeriodConfig = undefined;
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PeriodConfig = exports.PeriodConfig = undefined;
	
	exports.PeriodConfig = PeriodConfig = function PeriodConfig() {
	    var t = this;
	
	    // service
	    var i18nManager;
	
	    // uninitialized
	    var periodTypes;
	
	    // setter
	    var setPeriodTypes = function setPeriodTypes() {
	        periodTypes = {
	            'Daily': i18nManager.get('daily') || 'Daily',
	            'Weekly': i18nManager.get('weekly') || 'Weekly',
	            'WeeklyWednesday': i18nManager.get('weekly_wednesday') || 'Weekly (Start Wednesday)',
	            'WeeklyThursday': i18nManager.get('weekly_thursday') || 'Weekly (Start Thursday)',
	            'WeeklySaturday': i18nManager.get('weekly_saturday') || 'Weekly (Start Saturday)',
	            'WeeklySunday': i18nManager.get('weekly_sunday') || 'Weekly (Start Sunday)',
	            'Monthly': i18nManager.get('monthly') || 'Monthly',
	            'BiMonthly': i18nManager.get('bimonthly') || 'BiMonthly',
	            'Quarterly': i18nManager.get('quarterly') || 'Quarterly',
	            'SixMonthly': i18nManager.get('sixmonthly') || 'SixMonthly',
	            'SixMonthlyApril': i18nManager.get('sixmonthly_april') || 'SixMonthly April',
	            'Yearly': i18nManager.get('yearly') || 'Yearly',
	            'FinancialOct': i18nManager.get('financial_oct') || 'Financial year (Start October)',
	            'FinancialJuly': i18nManager.get('financial_july') || 'Financial year (Start July)',
	            'FinancialApril': i18nManager.get('financial_april') || 'Financial year (Start April)'
	        };
	    };
	
	    // init
	    t.init = function () {
	        setPeriodTypes();
	    };
	
	    // prototype
	    t.getPeriodTypeRecords = function () {
	        var records = [];
	
	        for (var type in periodTypes) {
	            if (periodTypes.hasOwnProperty(type)) {
	                records.push({
	                    id: type,
	                    name: periodTypes[type]
	                });
	            }
	        }
	
	        return records;
	    };
	
	    t.setI18nManager = function (manager) {
	        i18nManager = manager;
	    };
	};
	
	PeriodConfig.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.periodConfig = t;
	    });
	};
	//# sourceMappingURL=PeriodConfig.js.map

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UiConfig = undefined;
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UiConfig = exports.UiConfig = undefined;
	
	exports.UiConfig = UiConfig = function UiConfig() {
	    var branch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'aggregate';
	
	    var t = this;
	
	    var layout = {
	        'aggregate': {
	            west_width: 424,
	            west_fieldset_width: 420,
	            west_width_padding: 2,
	            west_fill: 2,
	            west_fill_accordion_indicator: 81,
	            west_fill_accordion_dataelement: 81,
	            west_fill_accordion_dataset: 81,
	            west_fill_accordion_eventdataitem: 81,
	            west_fill_accordion_programindicator: 81,
	            west_fill_accordion_period: 340,
	            west_fill_accordion_organisationunit: 58,
	            west_fill_accordion_group: 31,
	            west_maxheight_accordion_indicator: 400,
	            west_maxheight_accordion_dataelement: 400,
	            west_maxheight_accordion_dataset: 400,
	            west_maxheight_accordion_period: 513,
	            west_maxheight_accordion_organisationunit: 900,
	            west_maxheight_accordion_group: 340,
	            west_maxheight_accordion_options: 449,
	            west_scrollbarheight_accordion_indicator: 300,
	            west_scrollbarheight_accordion_dataelement: 300,
	            west_scrollbarheight_accordion_dataset: 300,
	            west_scrollbarheight_accordion_period: 450,
	            west_scrollbarheight_accordion_organisationunit: 450,
	            west_scrollbarheight_accordion_group: 300,
	            east_tbar_height: 31,
	            east_gridcolumn_height: 30,
	            form_label_width: 55,
	            window_favorite_ypos: 100,
	            window_confirm_width: 250,
	            window_share_width: 500,
	            grid_favorite_width: 420,
	            grid_row_height: 27,
	            treepanel_minheight: 135,
	            treepanel_maxheight: 400,
	            treepanel_fill_default: 310,
	            treepanel_toolbar_menu_width_group: 140,
	            treepanel_toolbar_menu_width_level: 120,
	            multiselect_minheight: 100,
	            multiselect_maxheight: 250,
	            multiselect_fill_default: 345,
	            multiselect_fill_reportingrates: 315
	        },
	        'tracker': {
	            west_width: 452,
	            west_fill: 2,
	            west_fill_accordion_indicator: 56,
	            west_fill_accordion_dataelement: 59,
	            west_fill_accordion_dataset: 31,
	            west_fill_accordion_period: 365,
	            west_fill_accordion_organisationunit: 58,
	            west_maxheight_accordion_indicator: 450,
	            west_maxheight_accordion_dataset: 350,
	            west_maxheight_accordion_period: 405,
	            west_maxheight_accordion_organisationunit: 500,
	            west_scrollbarheight_accordion_indicator: 300,
	            west_scrollbarheight_accordion_dataset: 250,
	            west_scrollbarheight_accordion_period: 405,
	            west_scrollbarheight_accordion_organisationunit: 350,
	            east_tbar_height: 31,
	            east_gridcolumn_height: 30,
	            form_label_width: 55,
	            window_favorite_ypos: 100,
	            window_confirm_width: 250,
	            window_share_width: 500,
	            grid_favorite_width: 420,
	            grid_row_height: 27,
	            treepanel_minheight: 135,
	            treepanel_maxheight: 400,
	            treepanel_fill_default: 310,
	            treepanel_toolbar_menu_width_group: 140,
	            treepanel_toolbar_menu_width_level: 120,
	            multiselect_minheight: 100,
	            multiselect_maxheight: 250,
	            multiselect_fill_default: 345,
	            multiselect_fill_reportingrates: 315
	        }
	    };
	
	    t.checkout = function () {
	        var branch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : branch;
	
	        $.extend(t, layout[branch]);
	    };
	
	    (function () {
	        t.checkout();
	    })();
	};
	
	UiConfig.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.uiConfig = t;
	    });
	};
	//# sourceMappingURL=UiConfig.js.map

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ux = exports.override = exports.util = exports.init = exports.ui = exports.config = exports.manager = exports.table = exports.api = exports.StatusBar = exports.LimitContainer = exports.GroupSetContainer = exports.DataElementStringContainer = exports.DataElementIntegerContainer = exports.DataElementDateContainer = exports.DataElementBooleanContainer = exports.extChartOverrides = exports.extOverrides = exports.Plugin = exports.SimpleRegression = exports.categoryOptionGroupSetsInit = exports.userFavoritesInit = exports.dataApprovalLevelsInit = exports.dimensionsInit = exports.optionSetsInit = exports.legendSetsInit = exports.organisationUnitLevelsInit = exports.rootNodesInit = exports.isAdminInit = exports.authViewUnapprovedDataInit = exports.i18nInit = exports.WestRegionTrackerItems = exports.WestRegionAggregateItems = exports.IntegrationButton = exports.ChartTypeToolbar = exports.ChartDownloadButtonItems = exports.GridHeaders = exports.AboutWindow = exports.PluginItem = exports.InterpretationItem = exports.InterpretationWindow = exports.FavoriteButton = exports.FavoriteWindow = exports.EastRegion = exports.NorthRegion = exports.Viewport = exports.ChartConfig = exports.UiConfig = exports.OptionConfig = exports.PeriodConfig = exports.DimensionConfig = exports.TableManager = exports.InstanceManager = exports.UiManager = exports.IndexedDbManager = exports.SessionStorageManager = exports.RequestManager = exports.I18nManager = exports.CalendarManager = exports.DateManager = exports.AppManager = exports.EventDataTable = exports.PivotTable = exports.PivotTableAxis = exports.Sorting = exports.Response = exports.ResponseRowIdCombination = exports.ResponseRow = exports.ResponseHeader = exports.Request = exports.Period = exports.Layout = exports.Axis = exports.Dimension = exports.Record = undefined;
	
	__webpack_require__(87);
	
	__webpack_require__(88);
	
	var _Record = __webpack_require__(113);
	
	var _Dimension = __webpack_require__(55);
	
	var _Axis = __webpack_require__(110);
	
	var _Layout = __webpack_require__(111);
	
	var _Period = __webpack_require__(56);
	
	var _Request = __webpack_require__(114);
	
	var _ResponseHeader = __webpack_require__(116);
	
	var _ResponseRow = __webpack_require__(117);
	
	var _ResponseRowIdCombination = __webpack_require__(35);
	
	var _Response = __webpack_require__(115);
	
	var _Sorting = __webpack_require__(118);
	
	var _PivotTableAxis = __webpack_require__(149);
	
	var _PivotTable = __webpack_require__(148);
	
	var _EventDataTable = __webpack_require__(147);
	
	var _AppManager = __webpack_require__(136);
	
	var _DateManager = __webpack_require__(23);
	
	var _CalendarManager = __webpack_require__(137);
	
	var _I18nManager = __webpack_require__(138);
	
	var _RequestManager = __webpack_require__(141);
	
	var _SessionStorageManager = __webpack_require__(142);
	
	var _IndexedDbManager = __webpack_require__(139);
	
	var _UiManager = __webpack_require__(144);
	
	var _InstanceManager = __webpack_require__(140);
	
	var _TableManager = __webpack_require__(143);
	
	var _DimensionConfig = __webpack_require__(120);
	
	var _PeriodConfig = __webpack_require__(122);
	
	var _OptionConfig = __webpack_require__(121);
	
	var _UiConfig = __webpack_require__(123);
	
	var _ChartConfig = __webpack_require__(119);
	
	var _Viewport = __webpack_require__(164);
	
	var _NorthRegion = __webpack_require__(160);
	
	var _EastRegion = __webpack_require__(59);
	
	var _FavoriteWindow = __webpack_require__(37);
	
	var _FavoriteButton = __webpack_require__(60);
	
	var _InterpretationWindow = __webpack_require__(25);
	
	var _InterpretationItem = __webpack_require__(62);
	
	var _PluginItem = __webpack_require__(63);
	
	var _AboutWindow = __webpack_require__(58);
	
	var _GridHeaders = __webpack_require__(61);
	
	var _ChartDownloadButtonItems = __webpack_require__(151);
	
	var _ChartTypeToolbar = __webpack_require__(152);
	
	var _IntegrationButton = __webpack_require__(157);
	
	var _WestRegionAggregateItems = __webpack_require__(165);
	
	var _WestRegionTrackerItems = __webpack_require__(166);
	
	var _i18nInit = __webpack_require__(129);
	
	var _authViewUnapprovedDataInit = __webpack_require__(125);
	
	var _isAdminInit = __webpack_require__(130);
	
	var _rootNodesInit = __webpack_require__(134);
	
	var _organisationUnitLevelsInit = __webpack_require__(133);
	
	var _legendSetsInit = __webpack_require__(131);
	
	var _optionSetsInit = __webpack_require__(132);
	
	var _dimensionsInit = __webpack_require__(128);
	
	var _dataApprovalLevelsInit = __webpack_require__(127);
	
	var _userFavoritesInit = __webpack_require__(135);
	
	var _categoryOptionGroupSetsInit = __webpack_require__(126);
	
	var _SimpleRegression = __webpack_require__(168);
	
	var _Plugin = __webpack_require__(167);
	
	var _extOverrides = __webpack_require__(146);
	
	var _extChartOverrides = __webpack_require__(145);
	
	var _DataElementBooleanContainer = __webpack_require__(171);
	
	var _DataElementDateContainer = __webpack_require__(172);
	
	var _DataElementIntegerContainer = __webpack_require__(173);
	
	var _DataElementStringContainer = __webpack_require__(174);
	
	var _GroupSetContainer = __webpack_require__(175);
	
	var _LimitContainer = __webpack_require__(176);
	
	var _StatusBar = __webpack_require__(177);
	
	exports.Record = _Record.Record;
	exports.Dimension = _Dimension.Dimension;
	exports.Axis = _Axis.Axis;
	exports.Layout = _Layout.Layout;
	exports.Period = _Period.Period;
	exports.Request = _Request.Request;
	exports.ResponseHeader = _ResponseHeader.ResponseHeader;
	exports.ResponseRow = _ResponseRow.ResponseRow;
	exports.ResponseRowIdCombination = _ResponseRowIdCombination.ResponseRowIdCombination;
	exports.Response = _Response.Response;
	exports.Sorting = _Sorting.Sorting;
	exports.PivotTableAxis = _PivotTableAxis.PivotTableAxis;
	exports.PivotTable = _PivotTable.PivotTable;
	exports.EventDataTable = _EventDataTable.EventDataTable;
	exports.AppManager = _AppManager.AppManager;
	exports.DateManager = _DateManager.DateManager;
	exports.CalendarManager = _CalendarManager.CalendarManager;
	exports.I18nManager = _I18nManager.I18nManager;
	exports.RequestManager = _RequestManager.RequestManager;
	exports.SessionStorageManager = _SessionStorageManager.SessionStorageManager;
	exports.IndexedDbManager = _IndexedDbManager.IndexedDbManager;
	exports.UiManager = _UiManager.UiManager;
	exports.InstanceManager = _InstanceManager.InstanceManager;
	exports.TableManager = _TableManager.TableManager;
	exports.DimensionConfig = _DimensionConfig.DimensionConfig;
	exports.PeriodConfig = _PeriodConfig.PeriodConfig;
	exports.OptionConfig = _OptionConfig.OptionConfig;
	exports.UiConfig = _UiConfig.UiConfig;
	exports.ChartConfig = _ChartConfig.ChartConfig;
	exports.Viewport = _Viewport.Viewport;
	exports.NorthRegion = _NorthRegion.NorthRegion;
	exports.EastRegion = _EastRegion.EastRegion;
	exports.FavoriteWindow = _FavoriteWindow.FavoriteWindow;
	exports.FavoriteButton = _FavoriteButton.FavoriteButton;
	exports.InterpretationWindow = _InterpretationWindow.InterpretationWindow;
	exports.InterpretationItem = _InterpretationItem.InterpretationItem;
	exports.PluginItem = _PluginItem.PluginItem;
	exports.AboutWindow = _AboutWindow.AboutWindow;
	exports.GridHeaders = _GridHeaders.GridHeaders;
	exports.ChartDownloadButtonItems = _ChartDownloadButtonItems.ChartDownloadButtonItems;
	exports.ChartTypeToolbar = _ChartTypeToolbar.ChartTypeToolbar;
	exports.IntegrationButton = _IntegrationButton.IntegrationButton;
	exports.WestRegionAggregateItems = _WestRegionAggregateItems.WestRegionAggregateItems;
	exports.WestRegionTrackerItems = _WestRegionTrackerItems.WestRegionTrackerItems;
	exports.i18nInit = _i18nInit.i18nInit;
	exports.authViewUnapprovedDataInit = _authViewUnapprovedDataInit.authViewUnapprovedDataInit;
	exports.isAdminInit = _isAdminInit.isAdminInit;
	exports.rootNodesInit = _rootNodesInit.rootNodesInit;
	exports.organisationUnitLevelsInit = _organisationUnitLevelsInit.organisationUnitLevelsInit;
	exports.legendSetsInit = _legendSetsInit.legendSetsInit;
	exports.optionSetsInit = _optionSetsInit.optionSetsInit;
	exports.dimensionsInit = _dimensionsInit.dimensionsInit;
	exports.dataApprovalLevelsInit = _dataApprovalLevelsInit.dataApprovalLevelsInit;
	exports.userFavoritesInit = _userFavoritesInit.userFavoritesInit;
	exports.categoryOptionGroupSetsInit = _categoryOptionGroupSetsInit.categoryOptionGroupSetsInit;
	exports.SimpleRegression = _SimpleRegression.SimpleRegression;
	exports.Plugin = _Plugin.Plugin;
	exports.extOverrides = _extOverrides.extOverrides;
	exports.extChartOverrides = _extChartOverrides.extChartOverrides;
	exports.DataElementBooleanContainer = _DataElementBooleanContainer.DataElementBooleanContainer;
	exports.DataElementDateContainer = _DataElementDateContainer.DataElementDateContainer;
	exports.DataElementIntegerContainer = _DataElementIntegerContainer.DataElementIntegerContainer;
	exports.DataElementStringContainer = _DataElementStringContainer.DataElementStringContainer;
	exports.GroupSetContainer = _GroupSetContainer.GroupSetContainer;
	exports.LimitContainer = _LimitContainer.LimitContainer;
	exports.StatusBar = _StatusBar.StatusBar;
	var api = exports.api = {
	    Record: _Record.Record,
	    Dimension: _Dimension.Dimension,
	    Axis: _Axis.Axis,
	    Layout: _Layout.Layout,
	    Period: _Period.Period,
	    Request: _Request.Request,
	    ResponseHeader: _ResponseHeader.ResponseHeader,
	    ResponseRow: _ResponseRow.ResponseRow,
	    ResponseRowIdCombination: _ResponseRowIdCombination.ResponseRowIdCombination,
	    Response: _Response.Response,
	    Sorting: _Sorting.Sorting
	};
	
	var table = exports.table = {
	    PivotTableAxis: _PivotTableAxis.PivotTableAxis,
	    PivotTable: _PivotTable.PivotTable,
	    EventDataTable: _EventDataTable.EventDataTable
	};
	
	var manager = exports.manager = {
	    AppManager: _AppManager.AppManager,
	    DateManager: _DateManager.DateManager,
	    CalendarManager: _CalendarManager.CalendarManager,
	    I18nManager: _I18nManager.I18nManager,
	    RequestManager: _RequestManager.RequestManager,
	    SessionStorageManager: _SessionStorageManager.SessionStorageManager,
	    IndexedDbManager: _IndexedDbManager.IndexedDbManager,
	    UiManager: _UiManager.UiManager,
	    InstanceManager: _InstanceManager.InstanceManager,
	    TableManager: _TableManager.TableManager
	};
	
	var config = exports.config = {
	    DimensionConfig: _DimensionConfig.DimensionConfig,
	    PeriodConfig: _PeriodConfig.PeriodConfig,
	    OptionConfig: _OptionConfig.OptionConfig,
	    UiConfig: _UiConfig.UiConfig,
	    ChartConfig: _ChartConfig.ChartConfig
	};
	
	var ui = exports.ui = {
	    Viewport: _Viewport.Viewport,
	    NorthRegion: _NorthRegion.NorthRegion,
	    EastRegion: _EastRegion.EastRegion,
	    FavoriteWindow: _FavoriteWindow.FavoriteWindow,
	    FavoriteButton: _FavoriteButton.FavoriteButton,
	    InterpretationWindow: _InterpretationWindow.InterpretationWindow,
	    InterpretationItem: _InterpretationItem.InterpretationItem,
	    PluginItem: _PluginItem.PluginItem,
	    AboutWindow: _AboutWindow.AboutWindow,
	    GridHeaders: _GridHeaders.GridHeaders,
	    ChartDownloadButtonItems: _ChartDownloadButtonItems.ChartDownloadButtonItems,
	    ChartTypeToolbar: _ChartTypeToolbar.ChartTypeToolbar,
	    IntegrationButton: _IntegrationButton.IntegrationButton,
	    WestRegionAggregateItems: _WestRegionAggregateItems.WestRegionAggregateItems,
	    WestRegionTrackerItems: _WestRegionTrackerItems.WestRegionTrackerItems
	};
	
	var init = exports.init = {
	    i18nInit: _i18nInit.i18nInit,
	    authViewUnapprovedDataInit: _authViewUnapprovedDataInit.authViewUnapprovedDataInit,
	    isAdminInit: _isAdminInit.isAdminInit,
	    rootNodesInit: _rootNodesInit.rootNodesInit,
	    organisationUnitLevelsInit: _organisationUnitLevelsInit.organisationUnitLevelsInit,
	    legendSetsInit: _legendSetsInit.legendSetsInit,
	    optionSetsInit: _optionSetsInit.optionSetsInit,
	    dimensionsInit: _dimensionsInit.dimensionsInit,
	    dataApprovalLevelsInit: _dataApprovalLevelsInit.dataApprovalLevelsInit,
	    userFavoritesInit: _userFavoritesInit.userFavoritesInit,
	    categoryOptionGroupSetsInit: _categoryOptionGroupSetsInit.categoryOptionGroupSetsInit
	};
	
	var util = exports.util = {
	    SimpleRegression: _SimpleRegression.SimpleRegression,
	    Plugin: _Plugin.Plugin
	};
	
	var override = exports.override = {
	    extOverrides: _extOverrides.extOverrides,
	    extChartOverrides: _extChartOverrides.extChartOverrides
	};
	
	var ux = exports.ux = {
	    DataElementBooleanContainer: _DataElementBooleanContainer.DataElementBooleanContainer,
	    DataElementDateContainer: _DataElementDateContainer.DataElementDateContainer,
	    DataElementIntegerContainer: _DataElementIntegerContainer.DataElementIntegerContainer,
	    DataElementStringContainer: _DataElementStringContainer.DataElementStringContainer,
	    GroupSetContainer: _GroupSetContainer.GroupSetContainer,
	    LimitContainer: _LimitContainer.LimitContainer,
	    StatusBar: _StatusBar.StatusBar
	};
	//# sourceMappingURL=index.js.map

/***/ },
/* 125 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var authViewUnapprovedDataInit = exports.authViewUnapprovedDataInit = undefined;
	
	exports.authViewUnapprovedDataInit = authViewUnapprovedDataInit = function authViewUnapprovedDataInit(c) {
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager;
	
	    return {
	        baseUrl: appManager.getApiPath() + '/me/authorization/F_VIEW_UNAPPROVED_DATA',
	        success: function success(r) {
	            appManager.viewUnapprovedData = r;
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=authViewUnapprovedDataInit.js.map

/***/ },
/* 126 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var categoryOptionGroupSetsInit = exports.categoryOptionGroupSetsInit = undefined;
	
	exports.categoryOptionGroupSetsInit = categoryOptionGroupSetsInit = function categoryOptionGroupSetsInit(c) {
	    var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        dimensionConfig = c.dimensionConfig,
	        apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: apiPath + '/categoryOptionGroupSets.json',
	        params: ['fields=id,' + displayPropertyUrl + ',dataDimensionType', 'paging=false'].concat(extraParams),
	        success: function success(r) {
	            appManager.addCategoryOptionGroupSets(r.categoryOptionGroupSets);
	
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=categoryOptionGroupSetsInit.js.map

/***/ },
/* 127 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var dataApprovalLevelsInit = exports.dataApprovalLevelsInit = undefined;
	
	exports.dataApprovalLevelsInit = dataApprovalLevelsInit = function dataApprovalLevelsInit(c) {
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: apiPath + '/dataApprovalLevels.json',
	        params: ['order=level:asc', 'fields=id,displayName~rename(name),level', 'paging=false'],
	        success: function success(r) {
	            appManager.addDataApprovalLevels(r.dataApprovalLevels);
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=dataApprovalLevelsInit.js.map

/***/ },
/* 128 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var dimensionsInit = exports.dimensionsInit = undefined;
	
	exports.dimensionsInit = dimensionsInit = function dimensionsInit(c) {
	    var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        dimensionConfig = c.dimensionConfig,
	        apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: apiPath + '/dimensions.json',
	        params: ['fields=id,' + displayPropertyUrl + ',dimensionType', 'paging=false'].concat(extraParams),
	        success: function success(r) {
	            appManager.addDimensions(r.dimensions);
	            dimensionConfig.add(r.dimensions);
	
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=dimensionsInit.js.map

/***/ },
/* 129 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var i18nInit = exports.i18nInit = undefined;
	
	exports.i18nInit = i18nInit = function i18nInit(refs) {
	    var t = this,
	        appManager = refs.appManager,
	        requestManager = refs.requestManager,
	        i18nManager = refs.i18nManager,
	        uiLocale = appManager.getUiLocale(),
	        isUiLocaleDefault = appManager.isUiLocaleDefault(),
	        defaultUiLocale = appManager.defaultUiLocale;
	
	    return {
	        baseUrl: 'i18n/i18n_app.properties',
	        type: 'ajax',
	        dataType: 'text',
	        headers: {
	            'Accept': 'text/plain; charset=utf-8'
	        },
	        success: function success(r) {
	            var t = this;
	
	            i18nManager.add(dhis2.util.parseJavaProperties(r));
	
	            if (isUiLocaleDefault) {
	                requestManager.ok(t);
	            } else {
	                $.ajax({
	                    url: 'i18n/i18n_app_' + uiLocale + '.properties',
	                    success: function success(r) {
	                        i18nManager.add(dhis2.util.parseJavaProperties(r));
	                    },
	                    error: function error() {
	                        console.log('(i18n) No translations found for system locale (' + uiLocale + ')');
	                    },
	                    complete: function complete() {
	                        requestManager.ok(t);
	                    }
	                });
	            }
	        },
	        error: function error() {
	            $.ajax({
	                url: 'i18n/i18n_app_' + uiLocale + '.properties',
	                success: function success(r) {
	                    i18nManager.add(dhis2.util.parseJavaProperties(r));
	                },
	                error: function error() {
	                    alert('(i18n) No translations found for system locale (' + uiLocale + ') or default locale (' + defaultUiLocale + ')');
	                },
	                complete: function complete() {
	                    requestManager.ok(this);
	                }
	            });
	        }
	    };
	};
	//# sourceMappingURL=i18nInit.js.map

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var isAdminInit = exports.isAdminInit = undefined;
	
	exports.isAdminInit = isAdminInit = function isAdminInit(c) {
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        apiPath = appManager.getApiPath();
	
	    return {
	        baseUrl: appManager.getPath() + '/api/me/authorization/ALL',
	        success: function success(r) {
	            appManager.isAdmin = r;
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=isAdminInit.js.map

/***/ },
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var legendSetsInit = exports.legendSetsInit = undefined;
	
	exports.legendSetsInit = legendSetsInit = function legendSetsInit(c) {
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: apiPath + '/legendSets.json',
	        params: ['fields=id,displayName~rename(name),legends[id,displayName~rename(name),startValue,endValue,color]', 'paging=false'],
	        success: function success(r) {
	            appManager.addLegendSets(r.legendSets);
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=legendSetsInit.js.map

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.optionSetsInit = undefined;
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var optionSetsInit = exports.optionSetsInit = undefined;
	
	exports.optionSetsInit = optionSetsInit = function optionSetsInit(refs) {
	    var t = this;
	
	    var appManager = refs.appManager,
	        requestManager = refs.requestManager,
	        indexedDbManager = refs.indexedDbManager;
	    var Request = refs.api.Request;
	
	
	    var apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: '.',
	        type: 'ajax',
	        dataType: 'text',
	        disableCaching: false,
	        success: function success() {
	            indexedDbManager.open().done(function () {
	
	                // check if idb has any option sets
	                indexedDbManager.getKeys('optionSets').done(function (keys) {
	                    if (keys.length === 0) {
	                        new Request(refs, {
	                            baseUrl: appManager.getApiPath() + '/optionSets.json',
	                            params: ['fields=id,name,version,options[code,name]', 'paging=false'],
	                            success: function success(r) {
	                                var optionSets = r.optionSets;
	
	                                if (optionSets.length) {
	                                    indexedDbManager.setAll('optionSets', optionSets).done(function () {
	                                        requestManager.ok(t);
	                                    });
	                                } else {
	                                    requestManager.ok(t);
	                                }
	                            }
	                        }).run();
	
	                        //Ext.Ajax.request({
	                        //url: appManager.getApiPath() + '/optionSets.json?fields=id,name,version,options[code,name]&paging=false',
	                        //success: function(r) {
	                        //var sets = Ext.decode(r.responseText).optionSets;
	
	                        //if (sets.length) {
	                        //indexedDbManager.setAll('optionSets', sets).done(function() {
	                        //requestManager.ok(t);
	                        //});
	                        //}
	                        //else {
	                        //requestManager.ok(t);
	                        //}
	                        //}
	                        //});
	                    } else {
	                        new Request(refs, {
	                            baseUrl: appManager.getApiPath() + '/optionSets.json',
	                            params: ['fields=id,version', 'paging=false'],
	                            success: function success(r) {
	
	                                //Ext.Ajax.request({
	                                //url: appManager.getApiPath() + '/optionSets.json?fields=id,version&paging=false',
	                                //disableCaching: false,
	                                //success: function(r) {
	                                var optionSets = r.optionSets || [],
	                                    ids = [],
	                                    filters = [],
	                                    callbacks = 0;
	
	                                var updateStore = function updateStore() {
	                                    if (++callbacks === optionSets.length) {
	                                        if (!ids.length) {
	                                            requestManager.ok(t);
	                                            return;
	                                        }
	
	                                        for (var i = 0; i < ids.length; i++) {
	                                            filters.push('filter=id:eq:' + ids[i]);
	                                        }
	
	                                        new Request(refs, {
	                                            baseUrl: appManager.getApiPath() + '/optionSets.json',
	                                            params: filters.concat(['fields=id,name,version,options[code,name]', 'paging=false']),
	                                            success: function success(r) {
	                                                var optionSets = r.optionSets;
	
	                                                indexedDbManager.setAll('optionSets', optionSets).done(function () {
	                                                    requestManager.ok(t);
	                                                });
	                                            }
	                                        }).run();
	
	                                        //Ext.Ajax.request({
	                                        //url: appManager.getApiPath() + '/optionSets.json?fields=id,name,version,options[code,name]&paging=false' + url,
	                                        //success: function(r) {
	                                        //var sets = Ext.decode(r.responseText).optionSets;
	
	                                        //indexedDbManager.setAll('optionSets', sets).done(function() {
	                                        //requestManager.ok(t);
	                                        //});
	                                        //}
	                                        //});
	                                    }
	                                };
	
	                                var registerOptionSet = function registerOptionSet(optionSet) {
	                                    indexedDbManager.get('optionSets', optionSet.id).done(function (obj) {
	                                        if (!(0, _isObject2.default)(obj) || obj.version !== optionSet.version) {
	                                            ids.push(optionSet.id);
	                                        }
	
	                                        updateStore();
	                                    });
	                                };
	
	                                if (optionSets.length) {
	                                    optionSets.forEach(function (optionSet) {
	                                        return registerOptionSet(optionSet);
	                                    });
	                                } else {
	                                    requestManager.ok(t);
	                                }
	                            }
	                        }).run();
	                    }
	                });
	            });
	        }
	    };
	};
	//# sourceMappingURL=optionSetsInit.js.map

/***/ },
/* 133 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var organisationUnitLevelsInit = exports.organisationUnitLevelsInit = undefined;
	
	exports.organisationUnitLevelsInit = organisationUnitLevelsInit = function organisationUnitLevelsInit(c) {
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: apiPath + '/organisationUnitLevels.json',
	        params: ['fields=id,displayName~rename(name),level', 'paging=false'],
	        success: function success(r) {
	            appManager.addOrganisationUnitLevels(r.organisationUnitLevels);
	
	            if (!r.organisationUnitLevels.length) {
	                alert('No organisation unit levels found');
	            }
	
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=organisationUnitLevelsInit.js.map

/***/ },
/* 134 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var rootNodesInit = exports.rootNodesInit = undefined;
	
	exports.rootNodesInit = rootNodesInit = function rootNodesInit(c) {
	    var t = this,
	        appManager = c.appManager,
	        requestManager = c.requestManager,
	        apiPath = appManager.getApiPath(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl();
	
	    return {
	        baseUrl: apiPath + '/organisationUnits.json',
	        params: ['userDataViewFallback=true', 'fields=id,' + displayPropertyUrl + ',children[id,' + displayPropertyUrl + ']', 'paging=false'],
	        success: function success(r) {
	            appManager.addRootNodes(r.organisationUnits);
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=rootNodesInit.js.map

/***/ },
/* 135 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var userFavoritesInit = exports.userFavoritesInit = undefined;
	
	exports.userFavoritesInit = userFavoritesInit = function userFavoritesInit(refs) {
	    var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	    var t = this;
	
	    var appManager = refs.appManager,
	        requestManager = refs.requestManager,
	        instanceManager = refs.instanceManager;
	
	    var apiPath = appManager.getApiPath(),
	        username = appManager.userAccount.userCredentials.username,
	        eventType = instanceManager.dataStatisticsEventType;
	
	    return {
	        baseUrl: apiPath + '/dataStatistics/favorites.json',
	        params: ['eventType=' + eventType, 'username=' + username, 'pageSize=' + pageSize],
	        success: function success(response) {
	            appManager.userFavorites = response;
	            requestManager.ok(this);
	        }
	    };
	};
	//# sourceMappingURL=userFavoritesInit.js.map

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AppManager = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isFunction = __webpack_require__(17);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isNumeric = __webpack_require__(18);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _stringReplaceAll = __webpack_require__(67);
	
	var _stringReplaceAll2 = _interopRequireDefault(_stringReplaceAll);
	
	var _arrayClean = __webpack_require__(7);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arraySort = __webpack_require__(8);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	var _arrayUnique = __webpack_require__(12);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var AppManager = exports.AppManager = undefined;
	
	exports.AppManager = AppManager = function AppManager(refs) {
	    var t = this;
	
	    t.refs = (0, _isObject2.default)(refs) ? refs : {};
	
	    // constants
	    t.defaultUiLocale = 'en';
	    t.defaultDisplayProperty = 'displayName';
	    t.defaultAnalyticsDisplayProperty = 'name';
	    t.defaultIndexedDb = 'dhis2';
	    t.rootNodeId = 'root';
	
	    t.defaultRequestHeaders = {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json'
	    };
	
	    t.defaultAnalysisFields = ['*', 'interpretations[*,user[id,displayName],likedBy[id,displayName],comments[id,lastUpdated,text,user[id,displayName]]]', 'columns[dimension,filter,legendSet[id],items[dimensionItem~rename(id),dimensionItemType,$]]', 'rows[dimension,filter,legendSet[id],items[dimensionItem~rename(id),dimensionItemType,$]]', 'filters[dimension,filter,legendSet[id],items[dimensionItem~rename(id),dimensionItemType,$]]', 'access', 'userGroupAccesses', 'publicAccess', 'displayDescription', 'user[displayName]', '!href', '!rewindRelativePeriods', '!userOrganisationUnit', '!userOrganisationUnitChildren', '!userOrganisationUnitGrandChildren', '!externalAccess', '!relativePeriods', '!columnDimensions', '!rowDimensions', '!filterDimensions', '!organisationUnitGroups', '!itemOrganisationUnitGroups', '!indicators', '!dataElements', '!dataElementOperands', '!dataElementGroups', '!dataSets', '!periods', '!organisationUnitLevels', '!organisationUnits'];
	
	    t.displayPropertyMap = {
	        'name': 'displayName',
	        'displayName': 'displayName',
	        'shortName': 'displayShortName',
	        'displayShortName': 'displayShortName'
	    };
	
	    t.userIdDestroyCacheKeys = ['USER_ORGUNIT', 'USER_ORGUNIT_CHILDREN', 'USER_ORGUNIT_GRANDCHILDREN'];
	
	    t.ignoreResponseHeaders = ['dy', 'value', 'psi', 'ps', 'eventdate', 'longitude', 'latitude', 'ouname', 'oucode'];
	
	    // uninitialized
	    t.appName;
	    t.sessionName;
	    t.manifest;
	    t.env;
	    t.systemInfo;
	    t.systemSettings;
	    t.userAccount;
	    t.calendar;
	    t.periodGenerator;
	    t.viewUnapprovedData;
	
	    t.rootNodes = [];
	    t.organisationUnitLevels = [];
	    t.dimensions = [];
	    t.categoryOptionGroupSets = [];
	    t.dimensions = [];
	    t.legendSets = [];
	    t.dataApprovalLevels = [];
	    t.userFavorites = [];
	
	    // transient
	    t.path;
	    t.dateFormat;
	    t.relativePeriod;
	    t.uiLocale;
	    t.displayProperty;
	    t.displayPropertyUrl;
	    t.analyticsDisplayProperty;
	    t.analysisFields;
	    t.legendSetMap;
	
	    // optional
	    t.manifestVersion;
	    t.apiVersion;
	
	    // fns
	    t.getUrlParam = function (s) {
	        var output = '';
	        var href = window.location.href;
	        if (href.indexOf('?') > -1) {
	            var query = href.substr(href.indexOf('?') + 1);
	            var query = query.split('&');
	            for (var i = 0; i < query.length; i++) {
	                if (query[i].indexOf('=') > -1) {
	                    var a = query[i].split('=');
	                    if (a[0].toLowerCase() === s) {
	                        output = a[1];
	                        break;
	                    }
	                }
	            }
	        }
	        return unescape(output);
	    };
	
	    // event handler array
	    t.getEventHandlerArray = function () {
	        var a = [];
	
	        a.run = function (params) {
	            a.forEach(function (fn) {
	                fn(params.cmp, params.width, params.height, params.eOpts);
	            });
	        };
	
	        return a;
	    };
	};
	
	AppManager.prototype.init = function (callbackFn) {
	    var t = this;
	
	    // manifest
	    var manifestReq = function manifestReq() {
	        new t.refs.api.Request(t.refs, {
	            baseUrl: 'manifest.webapp',
	            type: 'json',
	            success: function success(response) {
	                t.manifest = response;
	                t.env = ('production');
	                t.setAuth();
	                t.logVersion();
	
	                systemInfoReq();
	            }
	        }).run();
	    };
	
	    // system info
	    var systemInfoReq = function systemInfoReq() {
	        new t.refs.api.Request(t.refs, {
	            baseUrl: t.getApiPath() + '/system/info.json',
	            type: 'json',
	            success: function success(response) {
	                t.systemInfo = response;
	                t.path = response.contextPath;
	
	                systemSettingsReq();
	            }
	        }).run();
	    };
	
	    // system settings
	    var systemSettingsReq = function systemSettingsReq() {
	        new t.refs.api.Request(t.refs, {
	            baseUrl: t.getApiPath() + '/systemSettings.json',
	            type: 'json',
	            params: ['key=keyCalendar', 'key=keyDateFormat', 'key=keyAnalysisRelativePeriod', 'key=keyHideUnapprovedDataInAnalytics', 'key=keyAnalysisDigitGroupSeparator', 'key=keyIgnoreAnalyticsApprovalYearThreshold'],
	            success: function success(response) {
	                t.systemSettings = response;
	
	                userAccountReq();
	            }
	        }).run();
	    };
	
	    // user account
	    var userAccountReq = function userAccountReq() {
	        new t.refs.api.Request(t.refs, {
	            baseUrl: t.getApiPath() + '/me.json',
	            type: 'json',
	            params: ['fields=id,firstName,surname,userCredentials[username],settings'],
	            success: function success(response) {
	                t.userAccount = response;
	
	                var calendarManager = t.refs.calendarManager;
	
	                calendarManager.setBaseUrl(t.getPath());
	                calendarManager.setDateFormat(t.getDateFormat());
	                calendarManager.init(t.systemSettings.keyCalendar);
	
	                // allow for other code to be executed after all the init stuff is done
	                if (callbackFn) {
	                    callbackFn();
	                }
	            }
	        }).run();
	    };
	
	    manifestReq();
	};
	
	AppManager.prototype.logVersion = function () {
	    if (console && this.manifest && this.manifest.version) {
	        var version = 'v' + this.manifest.version;
	        var name = this.manifest.name || null;
	
	        var msg = (0, _arrayClean2.default)([name, version]).join(' ');
	        var fn = console.info || console.log;
	
	        fn.call(console, msg);
	    }
	};
	
	AppManager.prototype.getPath = function () {
	    var dhis = this.manifest ? this.manifest.activities.dhis : {};
	
	    return this.path ? this.path : this.env === 'production' ? dhis.href : dhis.devHref || dhis.href;
	};
	
	AppManager.prototype.getManifestFullVersionNumber = function () {
	    var t = this;
	
	    return t.manifest && (0, _isNumeric2.default)(parseInt(t.manifest.version)) ? parseInt(t.manifest.version) : t.manifestVersion || undefined;
	};
	
	AppManager.prototype.getApiVersion = function () {
	    return this.apiVersion;
	};
	
	AppManager.prototype.getDateFormat = function () {
	    return this.dateFormat ? this.dateFormat : this.dateFormat = (0, _isString2.default)(this.systemSettings.keyDateFormat) ? this.systemSettings.keyDateFormat.toLowerCase() : 'yyyy-mm-dd';
	};
	
	AppManager.prototype.getRelativePeriod = function () {
	    return this.relativePeriod ? this.relativePeriod : this.relativePeriod = this.systemSettings.keyAnalysisRelativePeriod || 'LAST_12_MONTHS';
	};
	
	AppManager.prototype.getUiLocale = function () {
	    return this.uiLocale ? this.uiLocale : this.uiLocale = this.userAccount.settings.keyUiLocale || this.defaultUiLocale;
	};
	
	AppManager.prototype.getDisplayProperty = function () {
	    if (this.displayProperty) {
	        return this.displayProperty;
	    }
	
	    var keyAnalysisDisplayProperty = this.userAccount && this.userAccount.settings ? this.userAccount.settings.keyAnalysisDisplayProperty : null;
	
	    return this.displayProperty = this.displayPropertyMap[keyAnalysisDisplayProperty || this.defaultDisplayProperty];
	};
	
	AppManager.prototype.getAnalyticsDisplayProperty = function () {
	    if (this.analyticsDisplayProperty) {
	        return this.analyticsDisplayProperty;
	    }
	
	    var keyAnalysisDisplayProperty = this.userAccount && this.userAccount.settings ? this.userAccount.settings.keyAnalysisDisplayProperty : null;
	
	    return this.analyticsDisplayProperty = (keyAnalysisDisplayProperty || this.defaultAnalyticsDisplayProperty).toUpperCase();
	};
	
	AppManager.prototype.getRootNodes = function () {
	    return this.rootNodes;
	};
	
	AppManager.prototype.addRootNodes = function (param) {
	    var t = this,
	        nodes = (0, _arrayFrom2.default)(param);
	
	    nodes.forEach(function (node) {
	        node.expanded = true;
	        node.path = '/' + t.rootId + '/' + node.id;
	    });
	
	    t.rootNodes = (0, _arrayClean2.default)(t.rootNodes.concat(nodes));
	};
	
	AppManager.prototype.addOrganisationUnitLevels = function (param) {
	    this.organisationUnitLevels = (0, _arrayClean2.default)(this.organisationUnitLevels.concat((0, _arrayFrom2.default)(param)));
	
	    (0, _arraySort2.default)(this.organisationUnitLevels, 'ASC', 'level');
	};
	
	AppManager.prototype.addLegendSets = function (param) {
	    this.legendSets = (0, _arrayClean2.default)(this.legendSets.concat((0, _arrayFrom2.default)(param)));
	
	    (0, _arraySort2.default)(this.legendSets, 'ASC', 'name');
	};
	
	AppManager.prototype.getLegendSetById = function (id) {
	    var t = this;
	
	    if (t.legendSetMap) {
	        return t.legendSetMap[id];
	    }
	
	    t.legendSetMap = {};
	
	    t.legendSets.forEach(function (set) {
	        t.legendSetMap[set.id] = set;
	    });
	
	    return t.legendSetMap[id];
	};
	
	AppManager.prototype.addDimensions = function (param) {
	    this.dimensions = (0, _arrayClean2.default)(this.dimensions.concat((0, _arrayFrom2.default)(param)));
	
	    (0, _arraySort2.default)(this.dimensions, 'ASC', 'name');
	};
	
	AppManager.prototype.addCategoryOptionGroupSets = function (param) {
	    this.categoryOptionGroupSets = (0, _arrayClean2.default)(this.categoryOptionGroupSets.concat((0, _arrayFrom2.default)(param)));
	
	    (0, _arraySort2.default)(this.categoryOptionGroupSets, 'ASC', 'name');
	};
	
	AppManager.prototype.addDataApprovalLevels = function (param) {
	    this.dataApprovalLevels = (0, _arrayClean2.default)(this.dataApprovalLevels.concat((0, _arrayFrom2.default)(param)));
	
	    (0, _arraySort2.default)(this.dataApprovalLevels, 'ASC', 'level');
	};
	
	AppManager.prototype.addIgnoreResponseHeaders = function (headers, append) {
	    var t = this;
	
	    t.ignoreResponseHeaders = (0, _arrayUnique2.default)([].concat(_toConsumableArray(append ? t.ignoreResponseHeaders : []), _toConsumableArray(headers)));
	};
	
	AppManager.prototype.setAuth = function (binary, ascii) {
	    var J = 'jQuery' in window ? window['jQuery'] : undefined;
	    var E = 'Ext' in window ? window['Ext'] : undefined;
	    var headers;
	    var auth;
	
	    if (binary || ascii) {
	        headers = {
	            Authorization: ascii ? ascii : 'Basic ' + btoa(binary)
	        };
	    } else if (this.env !== 'production' && this.manifest && (0, _isString2.default)(this.manifest.activities.dhis.auth)) {
	        headers = {
	            Authorization: 'Basic ' + btoa(this.manifest.activities.dhis.auth)
	        };
	    }
	
	    if (headers) {
	        if (J) {
	            J.ajaxSetup({
	                headers: headers
	            });
	        }
	
	        if (E && (0, _isObject2.default)(E.Ajax)) {
	            E.Ajax.defaultHeaders = headers;
	        }
	    }
	};
	
	AppManager.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.appManager = t;
	    });
	};
	
	// dep 1
	
	AppManager.prototype.getApiPath = function () {
	    var t = this;
	
	    var version = t.getApiVersion() || '';
	
	    return t.getPath() + '/api' + (version ? '/' + version : '');
	};
	
	AppManager.prototype.getLegendColorByValue = function (id, value) {
	    var t = this,
	        color;
	
	    var legendSet = t.getLegendSetById(id);
	
	    for (var i = 0, legend; i < legendSet.legends.length; i++) {
	        legend = legendSet.legends[i];
	
	        if (value >= parseFloat(legend.startValue) && value < parseFloat(legend.endValue)) {
	            color = legend.color;
	            break;
	        }
	    }
	
	    return color;
	};
	
	AppManager.prototype.getDisplayPropertyUrl = function () {
	    if (this.displayPropertyUrl) {
	        return this.displayPropertyUrl;
	    }
	
	    var key = this.getDisplayProperty();
	
	    return this.displayPropertyUrl = key + '~rename(name)';
	};
	
	AppManager.prototype.isUiLocaleDefault = function () {
	    return this.getUiLocale() === this.defaultUiLocale;
	};
	
	AppManager.prototype.getAnalysisFields = function () {
	    return this.analysisFields ? this.analysisFields : this.analysisFields = (0, _stringReplaceAll2.default)(this.defaultAnalysisFields.join(','), '$', this.getDisplayPropertyUrl());
	};
	
	AppManager.prototype.getRootNode = function () {
	    return this.getRootNodes()[0];
	};
	
	// dep 2
	
	AppManager.prototype.getLegendSetIdByDxId = function (id, fn) {
	    if (!((0, _isString2.default)(id) && (0, _isFunction2.default)(fn))) {
	        return;
	    }
	
	    var t = this;
	
	    var legendSetId;
	
	    new t.refs.api.Request(t.refs, {
	        type: 'json',
	        baseUrl: t.getApiPath() + '/indicators.json',
	        params: ['filter=id:eq:' + id, 'fields=legendSet[id]', 'paging=false'],
	        success: function success(json) {
	            if ((0, _isArray2.default)(json.indicators) && json.indicators.length) {
	                if ((0, _isObject2.default)(json.indicators[0].legendSet)) {
	                    var legendSet = json.indicators[0].legendSet;
	
	                    if ((0, _isObject2.default)(legendSet)) {
	                        legendSetId = legendSet.id;
	                    }
	                }
	            }
	        },
	        complete: function complete() {
	            fn(legendSetId);
	        }
	    }).run();
	};
	
	AppManager.prototype.getOptionSets = function (response, callbackFn) {
	    var optionSetHeaders = response.getOptionSetHeaders();
	    var dhis2 = window.dhis2;
	
	    if (optionSetHeaders.length) {
	        var callbacks = 0,
	            optionMap = {};
	
	        var fn = function fn() {
	            if (++callbacks === optionSetHeaders.length) {
	                response.metaData.optionNames = optionMap;
	                callbackFn();
	            }
	        };
	
	        var getObjectMap = function getObjectMap(array) {
	            var idProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
	            var nameProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';
	            var namePrefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	            if (!((0, _isArray2.default)(array) && array.length)) {
	                return {};
	            }
	
	            var map = {};
	
	            array.forEach(function (obj) {
	                map[namePrefix + obj[idProperty]] = obj[nameProperty];
	            });
	
	            return map;
	        };
	
	        var getOptions = function getOptions(optionSetId, dataElementId) {
	            dhis2.er.store.get('optionSets', optionSetId).done(function (obj) {
	                _extends(optionMap, getObjectMap(obj.options, 'code', 'name', dataElementId));
	                fn();
	            });
	        };
	
	        // execute
	        optionSetHeaders.forEach(function (header) {
	            var optionSetIds = (0, _arrayFrom2.default)(header.optionSet);
	            var dataElementId = header.name;
	
	            optionSetIds.forEach(function (id) {
	                getOptions(id, dataElementId);
	            });
	        });
	    } else {
	        callbackFn();
	    }
	};
	//# sourceMappingURL=AppManager.js.map

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CalendarManager = undefined;
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarManager = exports.CalendarManager = undefined;
	
	exports.CalendarManager = CalendarManager = function CalendarManager(refs, config) {
	    var t = this;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    // constructor
	    t.baseUrl = config.baseUrl || '..';
	    t.dateFormat = config.dateFormat || 'yyyy-MM-dd';
	    t.defaultCalendarId = 'gregorian';
	    t.defaultCalendarIsoId = 'iso8601';
	    t.calendarIds = ['coptic', 'ethiopian', 'islamic', 'julian', 'nepali', 'thai', 'persian'];
	
	    // uninitialized
	    t.calendar;
	    t.periodGenerator;
	
	    // transient
	    t.calendarIdMap;
	};
	
	CalendarManager.prototype.setBaseUrl = function (baseUrl) {
	    this.baseUrl = baseUrl;
	};
	
	CalendarManager.prototype.setDateFormat = function (dateFormat) {
	    this.dateFormat = dateFormat;
	};
	
	CalendarManager.prototype.getPeriodScriptUrl = function () {
	    return this.baseUrl + '/dhis-web-commons/javascripts/dhis2/dhis2.period.js';
	};
	
	CalendarManager.prototype.getCalendarScriptUrl = function (calendarId) {
	    return this.baseUrl + '/dhis-web-commons/javascripts/jQuery/calendars/jquery.calendars.' + calendarId + '.min.js';
	};
	
	CalendarManager.prototype.getCalendarIdMap = function () {
	    if (this.calendarIdMap) {
	        return this.calendarIdMap;
	    }
	
	    this.calendarIdMap = {};
	    this.calendarIdMap[this.defaultCalendarIsoId] = this.defaultCalendarId;
	
	    return this.calendarIdMap;
	};
	
	CalendarManager.prototype.createCalendar = function (calendarId) {
	    this.calendar = $.calendars.instance(calendarId);
	};
	
	CalendarManager.prototype.createPeriodGenerator = function (calendarId) {
	    this.periodGenerator = new dhis2.period.PeriodGenerator(this.calendar, this.dateFormat);
	};
	
	CalendarManager.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.calendarManager = t;
	    });
	};
	
	// dep 1
	
	CalendarManager.prototype.init = function (calendarId, dateFormat) {
	    calendarId = this.getCalendarIdMap()[calendarId] || calendarId || this.defaultCalendarId;
	
	    if (this.calendar && this.periodGenerator) {
	        return;
	    }
	
	    var t = this,
	        periodUrl = t.getPeriodScriptUrl(),
	        success = function success() {
	        t.createCalendar(calendarId);
	        t.createPeriodGenerator(calendarId);
	    };
	
	    if ((0, _arrayContains2.default)(t.calendarIds, calendarId)) {
	        var calendarUrl = t.getCalendarScriptUrl(calendarId);
	
	        $.getScript(calendarUrl, function () {
	            $.getScript(periodUrl, function () {
	                success();
	            });
	        });
	    } else {
	        $.getScript(periodUrl, function () {
	            success();
	        });
	    }
	};
	//# sourceMappingURL=CalendarManager.js.map

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.I18nManager = undefined;
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var I18nManager = exports.I18nManager = undefined;
	
	exports.I18nManager = I18nManager = function I18nManager(refs, config) {
	    var t = this;
	
	    var translations = config || {};
	
	    // prototype
	    t.add = function (obj, force) {
	        if (force) {
	            translations = obj;
	        } else {
	            $.extend(translations, obj);
	        }
	    };
	
	    t.get = function (key) {
	        return key ? translations[key] : translations;
	    };
	};
	
	I18nManager.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.i18nManager = t;
	    });
	};
	//# sourceMappingURL=I18nManager.js.map

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.IndexedDbManager = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexedDbManager = exports.IndexedDbManager = undefined;
	
	exports.IndexedDbManager = IndexedDbManager = function IndexedDbManager() {
	    var t = this;
	
	    // constants
	    var _db = 'dhis2';
	    var _objectStores = ['optionSets'];
	
	    _extends(t, new dhis2.storage.Store({
	        name: _db,
	        objectStores: _objectStores,
	        adapters: [dhis2.storage.IndexedDBAdapter, dhis2.storage.DomSessionStorageAdapter, dhis2.storage.InMemoryAdapter]
	    }));
	
	    // cache
	    t.cachedOptionSets = {};
	};
	
	IndexedDbManager.prototype.getCachedOptionSet = function (id) {
	    return this.cachedOptionSets[id];
	};
	
	IndexedDbManager.prototype.setCachedOptionSet = function (optionSet) {
	    this.cachedOptionSets[optionSet.id] = optionSet;
	};
	
	IndexedDbManager.prototype.hasCachedOptionSet = function (id) {
	    return id in this.cachedOptionSets;
	};
	
	// dep 1
	
	IndexedDbManager.prototype.getOptionSets = function (ids, callbackFn) {
	    ids = (0, _arrayFrom2.default)(ids);
	
	    var t = this;
	    var callbacks = 0;
	    var requestIds = [];
	    var optionSets = [];
	
	    var fn = function fn() {
	        if (!requestIds.length || requestIds.length === ++callbacks) {
	            callbackFn(optionSets);
	        }
	    };
	
	    // cached option sets
	    ids.forEach(function (id) {
	        var cachedOptionSet = t.getCachedOptionSet(id);
	
	        if (cachedOptionSet) {
	            optionSets.push(cachedOptionSet);
	        } else {
	            requestIds.push(id);
	        }
	    });
	
	    // requested option sets
	    if (requestIds.length) {
	        requestIds.forEach(function (id) {
	            t.get('optionSets', id).done(function (requestedOptionSet) {
	                t.setCachedOptionSet(requestedOptionSet);
	                optionSets.push(requestedOptionSet);
	
	                fn();
	            });
	        });
	    } else {
	        fn();
	    }
	};
	
	// dep 2
	
	IndexedDbManager.prototype.getCachedOption = function (code, optionSetId) {
	    var cachedOptionSet = this.getCachedOptionSet(optionSetId);
	
	    if (!cachedOptionSet) {
	        console.log('WARNING: Option set with id "' + optionSetId + '" not found');
	        return;
	    }
	
	    if (!cachedOptionSet.options) {
	        console.log('WARNING: Option set with id "' + optionSetId + '" has no options');
	        return;
	    }
	
	    return cachedOptionSet.options.find(function (option) {
	        return option.code === code;
	    });
	};
	
	// dep 3
	
	IndexedDbManager.prototype.getCachedOptionName = function (code, optionSetId) {
	    var cachedOption = this.getCachedOption(code, optionSetId);
	
	    if (!cachedOption) {
	        console.log('WARNING: Option set with id "' + optionSetId + '" has no option with code "' + code + '"');
	        return code;
	    }
	
	    return cachedOption.name;
	};
	//# sourceMappingURL=IndexedDbManager.js.map

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InstanceManager = undefined;
	
	var _isFunction = __webpack_require__(17);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InstanceManager = exports.InstanceManager = undefined;
	
	exports.InstanceManager = InstanceManager = function InstanceManager(refs) {
	    var t = this;
	
	    refs = (0, _isObject2.default)(refs) ? refs : {};
	
	    t.appManager = refs.appManager;
	    t.uiManager = refs.uiManager;
	    t.i18nManager = refs.i18nManager;
	    t.tableManager = refs.tableManager;
	    t.sessionStorageManager = refs.sessionStorageManager;
	
	    // state
	    var _state = {
	        favorite: null,
	        current: null
	    };
	
	    // done fn
	    var fn;
	
	    // initialized
	    t.plugin = false;
	    t.dashboard = false;
	
	    // configurable
	    t.apiResource;
	    t.apiEndpoint;
	    t.analyticsEndpoint = '/analytics';
	    t.dataStatisticsEventType;
	
	    // getter/setter
	    t.isStateFavorite = function () {
	        return !!_state.favorite;
	    };
	
	    t.isStateCurrent = function () {
	        return !!_state.current;
	    };
	
	    t.isStateDirty = function () {
	        return _state.favorite !== _state.current;
	    };
	
	    t.isStateSaved = function () {
	        return t.isStateFavorite() ? !t.isStateDirty() : false;
	    };
	
	    t.isStateUnsaved = function () {
	        return t.isStateFavorite() ? t.isStateDirty() : false;
	    };
	
	    t.getStateFavorite = function () {
	        return t.isStateFavorite() ? _state.favorite.clone() : _state.favorite;
	    };
	
	    t.getStateFavoriteId = function () {
	        return t.isStateFavorite() ? _state.favorite.id : null;
	    };
	
	    t.getStateFavoriteName = function () {
	        return t.isStateFavorite() ? _state.favorite.name : null;
	    };
	
	    t.getStateCurrent = function () {
	        return _state.current ? _state.current.clone() : _state.current;
	    };
	
	    t.setState = function (curr, isFavorite, skipStateWest, forceUiState) {
	        _state.current = curr ? curr : null;
	
	        if (!_state.current || isFavorite) {
	            _state.favorite = _state.current;
	        }
	
	        if (t.sessionStorageManager && _state.current) {
	            t.sessionStorageManager.set(_state.current.toSession(), t.appManager.sessionName);
	        }
	
	        var current = _state.current ? _state.current.clone() : null;
	        var favorite = _state.favorite ? _state.favorite.clone() : null;
	
	        t.uiManager.setState(current, favorite, isFavorite, skipStateWest, forceUiState);
	    };
	
	    t.setStateIf = function (curr, isFavorite) {
	        if (curr.id === t.getStateFavoriteId()) {
	            t.setState(curr, isFavorite);
	        }
	    };
	
	    t.getFn = function () {
	        return fn;
	    };
	
	    t.setFn = function (func) {
	        fn = func;
	    };
	
	    t.getRefs = function () {
	        return refs;
	    };
	};
	
	InstanceManager.prototype.getLayout = function (layoutConfig, fromFavorite) {
	    var t = this,
	        refs = t.getRefs(),
	        favorite = t.getStateFavorite(),
	        layout;
	
	    var Layout = refs.api.Layout;
	
	
	    layoutConfig = layoutConfig || t.uiManager.getUiState();
	
	    layout = new Layout(refs, layoutConfig);
	
	    if (layout) {
	        layout = favorite && fromFavorite ? favorite.apply(layout, Object.keys(layout)) : layout.apply(favorite);
	    }
	
	    return layout;
	};
	
	InstanceManager.prototype.getById = function (id, fn, doMask, doUnmask) {
	    var t = this,
	        refs = t.getRefs();
	
	    var _refs$api = refs.api,
	        Layout = _refs$api.Layout,
	        Request = _refs$api.Request;
	
	
	    id = (0, _isString2.default)(id) ? id : t.getStateFavoriteId() || null;
	
	    if (!(0, _isString2.default)(id)) {
	        console.log('Instance manager, getById, invalid id', id);
	        return;
	    }
	
	    var appManager = t.appManager;
	    var uiManager = t.uiManager;
	    var i18n = t.i18nManager ? t.i18nManager.get() : {};
	
	    fn = fn || function (layout, isFavorite) {
	        t.getReport(layout, isFavorite);
	    };
	
	    var request = new Request(refs, {
	        baseUrl: appManager.getApiPath() + '/' + t.apiEndpoint + '/' + id + '.json',
	        type: 'json',
	        beforeRun: function beforeRun() {
	            if (doMask) {
	                uiManager.mask();
	            }
	        },
	        afterRun: function afterRun() {
	            if (doUnmask) {
	                uiManager.unmask();
	            }
	        },
	        success: function success(r) {
	            $.ajax({
	                url: appManager.getApiPath() + '/' + t.apiEndpoint + '/' + id,
	                type: 'PATCH',
	                data: JSON.stringify({}),
	                // avoid jQuery choke on empty 200 Success response
	                dataType: 'text',
	                headers: appManager.defaultRequestHeaders,
	                success: function success(sharing) {
	                    var layout = new Layout(refs, r, { permission: "write" });
	                    fn(layout, true);
	                },
	                error: function error(xhr) {
	                    var permission = xhr.status === 404 ? "none" : "read";
	                    var layout = new Layout(refs, r, { permission: permission });
	                    fn(layout, true);
	                }
	            });
	        },
	        error: function error(r) {
	            if ((0, _arrayContains2.default)([403], parseInt(r.httpStatusCode))) {
	                r.message = i18n.you_do_not_have_access_to_all_items_in_this_favorite || r.message;
	            }
	
	            uiManager.alert(r);
	        }
	    });
	
	    request.add({
	        fields: appManager.getAnalysisFields()
	    });
	
	    request.run();
	};
	
	InstanceManager.prototype.delById = function (id, fn, doMask, doUnmask) {
	    if (!(0, _isString2.default)(id)) {
	        console.log('Invalid id', id);
	        return;
	    }
	
	    var t = this,
	        refs = this.getRefs();
	
	    var Request = refs.api.Request;
	
	
	    var appManager = t.appManager;
	    var uiManager = t.uiManager;
	    var i18n = t.i18nManager.get();
	
	    var request = new Request(refs, {
	        baseUrl: appManager.getApiPath() + '/' + t.apiEndpoint + '/' + id,
	        method: 'DELETE',
	        beforeRun: function beforeRun() {
	            if (doMask) {
	                uiManager.mask();
	            }
	        },
	        success: function (_success) {
	            function success(_x, _x2, _x3) {
	                return _success.apply(this, arguments);
	            }
	
	            success.toString = function () {
	                return _success.toString();
	            };
	
	            return success;
	        }(function (obj, success, r) {
	            if (doUnmask) {
	                uiManager.unmask();
	            }
	
	            fn && fn(obj, success, r);
	        }),
	        error: function error(r) {
	            uiManager.unmask();
	
	            uiManager.alert(r);
	        }
	    });
	
	    request.run();
	};
	
	InstanceManager.prototype.getSharingById = function (id, fn, options) {
	    var t = this,
	        refs = this.getRefs();
	    options = options || {};
	
	    var Request = refs.api.Request;
	
	
	    var appManager = t.appManager;
	
	    var request = new Request(refs, {
	        baseUrl: appManager.getApiPath() + '/sharing',
	        type: 'json',
	        success: function success(r) {
	            fn && fn(r);
	        },
	        error: function error(res) {
	            // If allowForbidden enabled, call the callback anyway, with an empty object
	            if (res.status == 403 && options.allowForbidden) {
	                success(null);
	            } else {
	                t.uiManager.alert(res);
	                t.uiManager.unmask();
	            }
	        }
	    });
	
	    request.add({
	        type: t.apiResource,
	        id: id
	    });
	
	    request.run();
	};
	
	InstanceManager.prototype.getUiState = function () {
	    return this.uiManager.getUiState();
	};
	
	InstanceManager.prototype.postDataStatistics = function () {
	    var t = this,
	        refs = this.getRefs();
	
	    var Request = refs.api.Request;
	
	
	    var request = new Request(refs, {
	        baseUrl: t.appManager.getApiPath() + '/dataStatistics',
	        method: 'POST'
	    });
	
	    request.add({
	        eventType: t.dataStatisticsEventType,
	        favorite: t.getStateFavoriteId()
	    });
	
	    request.run();
	};
	
	InstanceManager.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.instanceManager = t;
	    });
	};
	
	InstanceManager.prototype.getInterpretationById = function (id, fn) {
	    if (!(0, _isString2.default)(id)) {
	        console.log('Invalid id', id);
	        return;
	    }
	
	    var t = this,
	        refs = this.getRefs();
	
	    var Request = refs.api.Request;
	
	
	    var appManager = t.appManager;
	    var uiManager = t.uiManager;
	
	    var request = new Request(refs, {
	        baseUrl: appManager.getApiPath() + '/interpretations/' + id + '.json',
	        type: 'json',
	        success: function success(r) {
	            if ((0, _isFunction2.default)(fn)) {
	                fn(r);
	            }
	        },
	        error: function error(r) {
	            uiManager.alert(r);
	        },
	        complete: function complete(r) {
	            if (!(0, _isFunction2.default)(fn)) {
	                uiManager.unmask();
	            }
	        }
	    });
	
	    request.add({
	        fields: 'id,created'
	    });
	
	    request.run();
	};
	
	// dep 1
	
	InstanceManager.prototype.getData = function (layout) {
	    layout = layout || this.getLayout();
	
	    return layout.data();
	};
	
	InstanceManager.prototype.getReport = function (layout, isFavorite, skipState, forceUiState, fn) {
	    var _ref = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {},
	        noError = _ref.noError,
	        errorMessage = _ref.errorMessage;
	
	    var t = this,
	        refs = this.getRefs();
	
	    var Response = refs.api.Response;
	
	
	    var _fn = function _fn() {
	        if (!skipState) {
	            t.setState(layout, isFavorite, false, forceUiState);
	        }
	
	        (fn || t.getFn())(layout);
	    };
	
	    // layout
	    if (!layout) {
	        layout = t.getLayout(undefined, true);
	
	        if (!layout) {
	            return;
	        }
	    }
	
	    // validation
	    if ((0, _isFunction2.default)(layout.val) && !layout.val(noError)) {
	        if (errorMessage) {
	            t.uiManager.updateErrorMessage(errorMessage, layout.el);
	        }
	        return;
	    }
	
	    t.uiManager.mask();
	
	    // response
	    var response = layout.getResponse();
	
	    // fn
	    if (response) {
	        _fn();
	    } else {
	        var reqMap = layout.data();
	
	        reqMap.metaData.done(function (md) {
	            reqMap.data.done(function (res) {
	                res.metaData = md.metaData;
	
	                var response = new Response(refs, res);
	
	                if (layout.showHierarchy === true) {
	                    response.sortOrganisationUnitsHierarchy();
	                }
	
	                layout.setResponse(response);
	
	                _fn();
	            });
	        });
	    }
	};
	//# sourceMappingURL=InstanceManager.js.map

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RequestManager = undefined;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isFunction = __webpack_require__(17);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestManager = exports.RequestManager = undefined;
	
	exports.RequestManager = RequestManager = function RequestManager(refs, config) {
	    var t = this;
	
	    config = (0, _isObject2.default)(config) ? config : {};
	
	    // constructor
	    t.requests = (0, _isArray2.default)(config.requests) ? config.requests : [];
	
	    t.responses = [];
	
	    t.fn = (0, _isFunction2.default)(config.fn) ? config.fn : function () {
	        console.log('Request manager done');
	    };
	
	    t.fnParams = [];
	};
	
	RequestManager.prototype.add = function (param) {
	    var t = this,
	        requests = (0, _arrayFrom2.default)(param);
	
	    requests.forEach(function (request) {
	        request.setManager(t);
	    });
	
	    this.requests = [].concat(this.requests, requests);
	};
	
	RequestManager.prototype.set = function (fn, params) {
	    this.fn = fn;
	
	    if (params) {
	        this.fnParams = params;
	    }
	};
	
	RequestManager.prototype.ok = function (xhr, suppress) {
	    this.responses.push(xhr);
	
	    if (!suppress) {
	        this.resolve();
	    }
	};
	
	RequestManager.prototype.run = function () {
	    this.requests.forEach(function (request) {
	        request.run();
	    });
	};
	
	RequestManager.prototype.resolve = function () {
	    if (this.responses.length === this.requests.length) {
	        this.fn(this.fnParams);
	    }
	};
	
	RequestManager.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.requestManager = t;
	    });
	};
	//# sourceMappingURL=RequestManager.js.map

/***/ },
/* 142 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SessionStorageManager = exports.SessionStorageManager = undefined;
	
	exports.SessionStorageManager = SessionStorageManager = function SessionStorageManager(refs) {
	    var t = this;
	
	    // constants
	    t.db = 'dhis2';
	    t.supported = 'sessionStorage' in window && window['sessionStorage'] !== null;
	
	    // fn
	    t.supportHandler = function () {
	        if (!this.supported) {
	            alert("Your browser is outdated and does not support local storage. Please upgrade your browser.");
	            return;
	        }
	
	        return true;
	    };
	};
	
	SessionStorageManager.prototype.get = function (session) {
	    if (!this.supportHandler()) {
	        return;
	    }
	
	    var db = JSON.parse(sessionStorage.getItem(this.db)) || {};
	
	    return db[session];
	};
	
	SessionStorageManager.prototype.set = function (layout, session, redirectUrl) {
	    if (!this.supportHandler()) {
	        return;
	    }
	
	    var db = JSON.parse(sessionStorage.getItem(this.db)) || {};
	    db[session] = layout;
	    sessionStorage.setItem(this.db, JSON.stringify(db));
	
	    if (redirectUrl) {
	        window.location.href = redirectUrl;
	    }
	};
	//# sourceMappingURL=SessionStorageManager.js.map

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TableManager = undefined;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _Period = __webpack_require__(56);
	
	var _Dimension = __webpack_require__(55);
	
	var _OrganisationUnit = __webpack_require__(112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableManager = exports.TableManager = undefined;
	
	exports.TableManager = TableManager = function TableManager(c) {
	    var t = this;
	
	    var appManager = c.appManager,
	        instanceManager = c.instanceManager,
	        uiManager = c.uiManager,
	        sessionStorageManager = c.sessionStorageManager,
	        dimensionConfig = c.dimensionConfig;
	
	    // Metadata item types to provide details about
	    var METADATA_DETAILED_TYPES = ['CATEGORY_OPTION', 'DATA_ELEMENT', 'PROGRAM_INDICATOR', 'INDICATOR'];
	
	    var toggleDirection = function toggleDirection(direction) {
	        return direction.toUpperCase() === 'ASC' ? 'DESC' : 'ASC';
	    };
	
	    var sortIdMap = {
	        'pe': 'eventdate',
	        'ou': 'ouname'
	    };
	
	    var getSortId = function getSortId(id, type) {
	        if (type === dimensionConfig.dataType['aggregated_values']) {
	            return id;
	        }
	
	        return sortIdMap[id] || id;
	    };
	
	    var onColumnHeaderMouseClick = function onColumnHeaderMouseClick(layout, id) {
	        var sortId = getSortId(id);
	
	        if (layout.sorting && layout.sorting.id === sortId) {
	            layout.sorting.direction = toggleDirection(layout.sorting.direction);
	        } else {
	            layout.sorting = {
	                id: getSortId(id, layout.dataType),
	                direction: 'DESC'
	            };
	        }
	
	        instanceManager.getReport(layout);
	    };
	
	    var onColumnHeaderMouseOver = function onColumnHeaderMouseOver(el) {
	        var elObject = $(el);
	
	        if (elObject) {
	            elObject.addClass('pointer highlighted');
	        }
	    };
	
	    var onColumnHeaderMouseOut = function onColumnHeaderMouseOut(el) {
	        var elObject = $(el);
	
	        if (elObject) {
	            elObject.removeClass('pointer highlighted');
	        }
	    };
	
	    t.setColumnHeaderMouseHandlers = function (layout, table) {
	        var elObjects = table.sortableIdObjects,
	            dom;
	
	        elObjects.forEach(function (item) {
	            dom = document.getElementById(item.uuid);
	
	            if (dom) {
	                dom.layout = layout;
	                dom.metaDataId = item.id;
	                dom.onColumnHeaderMouseClick = onColumnHeaderMouseClick;
	                dom.onColumnHeaderMouseOver = onColumnHeaderMouseOver;
	                dom.onColumnHeaderMouseOut = onColumnHeaderMouseOut;
	
	                dom.setAttribute('onclick', 'this.onColumnHeaderMouseClick(this.layout, this.metaDataId)');
	                dom.setAttribute('onmouseover', 'this.onColumnHeaderMouseOver(this)');
	                dom.setAttribute('onmouseout', 'this.onColumnHeaderMouseOut(this)');
	            }
	        });
	    };
	
	    var onValueMouseClick = function onValueMouseClick(layout, table, uuid) {
	        var uuidObjectMap = table.getUuidObjectMap(),
	            response = layout.getResponse(),
	            parentGraphMap = {},
	            objects = [],
	            path = appManager.getPath(),
	            dom = document.getElementById(uuid),
	            periodId = dom.getAttribute('data-period-id'),
	            ouId = dom.getAttribute('data-ou-id'),
	            i18n = layout.getRefs().i18nManager.get(),
	            menu;
	
	        var uuids = table.uuidDimUuidsMap[uuid];
	
	        // modify layout dimension items based on uuid objects
	
	        // get objects
	        for (var i = 0; i < uuids.length; i++) {
	            objects.push(uuidObjectMap[uuids[i]]);
	        }
	
	        // clear layoutConfig dimension items
	        layout.removeDimensionItems();
	
	        // add new items
	        for (var i = 0, obj, axis, dimension; i < objects.length; i++) {
	            obj = objects[i];
	
	            axis = obj.axis === 'column' ? layout.columns || [] : layout.rows || [];
	
	            if (axis.length) {
	                dimension = axis[obj.dim];
	
	                dimension.add({
	                    id: obj.id,
	                    name: response.getNameById(obj.id)
	                });
	            }
	        }
	
	        // parent graph map
	        for (var i = 0, id; i < objects.length; i++) {
	            id = objects[i].id;
	
	            if (layout.parentGraphMap && layout.parentGraphMap.hasOwnProperty(id)) {
	                parentGraphMap[id] = layout.parentGraphMap[id];
	            }
	        }
	
	        layout.parentGraphMap = parentGraphMap;
	
	        layout.toSession();
	
	        var menuItems = [{
	            text: i18n.open_selection_as,
	            iconCls: 'ns-menu-item-datasource',
	            menu: [{
	                text: i18n.open_selection_as_chart,
	                iconCls: 'ns-button-icon-chart',
	                param: 'chart',
	                handler: function handler() {
	                    sessionStorageManager.set(layout, 'analytical', path + '/dhis-web-visualizer/index.html?s=analytical');
	                },
	                listeners: {
	                    render: function render() {
	                        //TODO
	                        this.getEl().on('mouseover', function () {
	                            onValueMenuMouseHover(table, uuid, 'mouseover', 'chart');
	                        });
	
	                        this.getEl().on('mouseout', function () {
	                            onValueMenuMouseHover(table, uuid, 'mouseout', 'chart');
	                        });
	                    }
	                }
	            }, {
	                text: i18n.open_selection_as_map,
	                iconCls: 'ns-button-icon-map',
	                param: 'map',
	                disabled: true,
	                handler: function handler() {
	                    sessionStorageManager.set(layout, 'analytical', path + '/dhis-web-mapping/index.html?s=analytical');
	                },
	                listeners: {
	                    render: function render() {
	                        this.getEl().on('mouseover', function () {
	                            onValueMenuMouseHover(table, uuid, 'mouseover', 'map');
	                        });
	
	                        this.getEl().on('mouseout', function () {
	                            onValueMenuMouseHover(table, uuid, 'mouseout', 'map');
	                        });
	                    }
	                }
	            }]
	        }];
	
	        if (periodId) {
	            var periodMenuItems = [];
	            var period = new _Period.Period({
	                id: periodId,
	                name: response.getNameById(periodId)
	            }, layout.getRefs());
	
	            period.generateDisplayProperties();
	
	            var periods = period.getContextMenuItemsConfig();
	
	            for (var _i = 0, periodItem; _i < periods.length; ++_i) {
	                periodItem = periods[_i];
	
	                if (periodItem.isSubtitle) {
	                    periodMenuItems.push({
	                        xtype: 'label',
	                        html: periodItem.text,
	                        style: periodItem.style
	                    });
	
	                    continue;
	                }
	
	                periodMenuItems.push({
	                    text: periodItem.text,
	                    iconCls: periodItem.iconCls,
	                    peReqItems: periodItem.items,
	                    handler: function handler() {
	                        var layout = instanceManager.getStateCurrent();
	                        var peDimension = new _Dimension.Dimension(layout.getRefs(), { dimension: 'pe', items: this.peReqItems });
	
	                        layout.replaceDimensionByName(peDimension);
	
	                        layout.setResponse(null);
	
	                        instanceManager.getReport(layout, false, false, true);
	                    }
	                });
	            }
	
	            menuItems.push({
	                text: i18n.period_drill_down_up,
	                iconCls: 'ns-menu-item-datasource',
	                menu: periodMenuItems
	            });
	        }
	
	        // menu
	        menu = Ext.create('Ext.menu.Menu', {
	            shadow: true,
	            showSeparator: false,
	            items: menuItems
	        });
	
	        if (ouId) {
	            (function () {
	                menu.add({
	                    uid: 'OU_MENU',
	                    text: i18n.organisation_units_drill_down || 'Org unit drill down/up',
	                    iconCls: 'ns-menu-item-datasource',
	                    menu: {
	                        items: [{ html: '<div class="spinner"></div>' }]
	                    }
	                });
	
	                var ouMenu = menu.items.findBy(function (submenu) {
	                    return submenu.uid === 'OU_MENU';
	                });
	                var organisationUnit = new _OrganisationUnit.OrganisationUnit(layout.getRefs(), { id: ouId });
	
	                uiManager.mask();
	
	                organisationUnit.getAncestorsRequest(true).done(function (data) {
	                    organisationUnit.setAncestors(data.ancestors);
	                    organisationUnit.setLevel(data.level);
	
	                    var organisationUnitMenuItems = organisationUnit.getContextMenuItemsConfig();
	
	                    // setting click handler
	                    for (var i = 0; i < organisationUnitMenuItems.length; ++i) {
	                        var ou = organisationUnitMenuItems[i];
	
	                        if (ou.isSubtitle) {
	                            continue;
	                        }
	
	                        ou.handler = function () {
	                            var layout = instanceManager.getStateCurrent();
	                            var ouDimension = new _Dimension.Dimension(layout.getRefs(), { dimension: 'ou', items: this.items });
	
	                            layout.replaceDimensionByName(ouDimension);
	
	                            layout.setResponse(null);
	
	                            instanceManager.getReport(layout, false, false, true);
	                        };
	                    }
	
	                    ouMenu.menu.removeAll();
	                    ouMenu.menu.add(organisationUnitMenuItems);
	                    uiManager.unmask();
	                });
	            })();
	        }
	
	        menu.showAt(function () {
	            var el = Ext.get(uuid),
	                xy = el.getXY();
	
	            xy[0] += el.getWidth() - 5;
	            xy[1] += el.getHeight() - 5;
	
	            return xy;
	        }());
	    };
	
	    var onValueMouseOver = function onValueMouseOver(uuid) {
	        Ext.get(uuid).addCls('highlighted');
	    };
	
	    var onValueMouseOut = function onValueMouseOut(uuid) {
	        Ext.get(uuid).removeCls('highlighted');
	    };
	
	    var onValueMenuMouseHover = function onValueMenuMouseHover(table, uuid, event, param) {
	        var uuidDimUuidsMap = table.uuidDimUuidsMap,
	            dimUuids;
	
	        // dimension elements
	        if (param === 'chart') {
	            if ((0, _isString2.default)(uuid) && (0, _isArray2.default)(uuidDimUuidsMap[uuid])) {
	                dimUuids = uuidDimUuidsMap[uuid];
	
	                for (var i = 0, el; i < dimUuids.length; i++) {
	                    el = Ext.get(dimUuids[i]);
	
	                    if (el) {
	                        if (event === 'mouseover') {
	                            el.addCls('highlighted');
	                        } else if (event === 'mouseout') {
	                            el.removeCls('highlighted');
	                        }
	                    }
	                }
	            }
	        }
	    };
	
	    t.setValueMouseHandlers = function (layout, table) {
	        var uuids = table.valueUuids,
	            valueEl;
	
	        for (var uuid in uuids) {
	            valueEl = Ext.get(uuids[uuid]);
	
	            if (valueEl && !isNaN(parseFloat(valueEl.dom.textContent))) {
	                valueEl.dom.onValueMouseClick = onValueMouseClick;
	                valueEl.dom.onValueMouseOver = onValueMouseOver;
	                valueEl.dom.onValueMouseOut = onValueMouseOut;
	                valueEl.dom.layout = layout;
	                valueEl.dom.table = table;
	                valueEl.dom.setAttribute('onclick', 'this.onValueMouseClick(this.layout, this.table, this.id);');
	                valueEl.dom.setAttribute('onmouseover', 'this.onValueMouseOver(this);');
	                valueEl.dom.setAttribute('onmouseout', 'this.onValueMouseOut(this);');
	            }
	        }
	    };
	
	    t.setDimensionMouseHandlers = function (layout, table) {
	        var response = layout.getResponse();
	
	        var setMouseHandler = function setMouseHandler(obj) {
	            var item = response.metaData.items[obj.id];
	
	            if (item && (0, _arrayContains2.default)(METADATA_DETAILED_TYPES, item.dimensionItemType)) {
	                (function () {
	                    var html = '<p>Type: ' + item.dimensionItemType + '</p>';
	
	                    if (item.description) {
	                        html += '<p>Description: ' + item.description + '</p>';
	                    }
	
	                    if (item.code) {
	                        html += '<p>Code: ' + item.code + '</p>';
	                    }
	
	                    var tip = Ext.create('Ext.tip.ToolTip', {
	                        target: Ext.get(obj.uuid),
	                        bodyStyle: 'font-size: 110%',
	                        html: html
	                    });
	
	                    Ext.get(obj.uuid).on({
	                        mouseover: function mouseover() {
	                            Ext.Function.createBuffered(tip.show, 1000, tip);
	                        }
	                    });
	                })();
	            }
	        };
	
	        if (table.colAxis && table.colAxis.uuidObjectMap) {
	            for (var key in table.colAxis.uuidObjectMap) {
	                if (table.colAxis.uuidObjectMap.hasOwnProperty(key)) {
	                    setMouseHandler(table.colAxis.uuidObjectMap[key]);
	                }
	            }
	        }
	
	        if (table.rowAxis && table.rowAxis.uuidObjectMap) {
	            for (var _key in table.rowAxis.uuidObjectMap) {
	                if (table.rowAxis.uuidObjectMap.hasOwnProperty(_key)) {
	                    setMouseHandler(table.rowAxis.uuidObjectMap[_key]);
	                }
	            }
	        }
	    };
	};
	//# sourceMappingURL=TableManager.js.map

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UiManager = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isFunction = __webpack_require__(17);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _arrayTo = __webpack_require__(6);
	
	var _arrayTo2 = _interopRequireDefault(_arrayTo);
	
	var _ConfirmWindow = __webpack_require__(154);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UiManager = exports.UiManager = undefined;
	
	exports.UiManager = UiManager = function UiManager(refs) {
	    var t = this;
	
	    refs = (0, _isObject2.default)(refs) ? refs : {};
	
	    t.appManager = refs.appManager;
	    t.instanceManager = refs.instanceManager;
	    t.i18nManager;
	
	    t.preventMask = false;
	    t.introHtmlIsAsync = false;
	
	    var components = {};
	
	    var componentTags = {
	        onCurrent: [],
	        onFavorite: []
	    };
	
	    var componentGroups = {};
	
	    var defaultUpdateComponentName = 'centerRegion';
	
	    var theme = 'meringue';
	
	    var introHtml = '';
	
	    var introFn = Function.prototype;
	    var updateIntroHtml = Function.prototype;
	
	    var updateFn = function updateFn(content, elementId) {
	        var el = document.getElementById(elementId);
	
	        if (elementId && el) {
	            el.innerHTML = content;
	            return;
	        }
	
	        if (content) {
	            t.getUpdateComponent().update(content);
	            return;
	        }
	
	        t.getIntroHtml().then(function (html) {
	            t.getUpdateComponent().renew(html);
	        });
	    };
	
	    var updateInterpretationFn = function updateInterpretationFn(interpretation, layout) {
	        var layout = layout || t.instanceManager.getStateCurrent();
	
	        if (layout) {
	            layout.applyInterpretation(interpretation);
	
	            t.instanceManager.getReport(layout, true);
	        }
	    };
	
	    var resizeHandlers = t.appManager.getEventHandlerArray();
	
	    var withErrorStyle = function withErrorStyle(content) {
	        return '<div style="padding:20px; font-size:13px; color:#60606a">' + content + '</div>';
	    };
	
	    // setters
	    t.setInstanceManager = function (instanceManager) {
	        t.instanceManager = instanceManager;
	    };
	
	    t.setI18nManager = function (i18nManager) {
	        t.i18nManager = i18nManager;
	    };
	
	    t.setUpdateFn = function (fn) {
	        updateFn = fn;
	    };
	
	    t.setUpdateInterpretationFn = function (fn) {
	        updateInterpretationFn = fn;
	    };
	
	    // components
	    t.reg = function (cmp, name, tags, groups, doNotOverwrite) {
	        if (components.hasOwnProperty(name) && doNotOverwrite) {
	            return;
	        }
	
	        // cmp
	        components[name] = cmp;
	
	        // tags
	        if ((0, _isString2.default)(tags)) {
	            tags.split(',').forEach(function (tag) {
	                if ((0, _isArray2.default)(componentTags[tag])) {
	                    componentTags[tag].push(cmp);
	                }
	            });
	        }
	
	        // groups
	        if ((0, _isString2.default)(groups)) {
	            groups.split(',').forEach(function (group) {
	                componentGroups[group] = (0, _isArray2.default)(componentGroups[group]) ? componentGroups[group] : [];
	                componentGroups[group].push(cmp);
	            });
	        }
	
	        return cmp;
	    };
	
	    t.unreg = function (name) {
	        delete components[name];
	    };
	
	    t.get = function (name) {
	        return components[name] || document.getElementById(name) || null;
	    };
	
	    t.subscribe = function (component, fn) {
	        t.get(component) && t.get(component).subscribe(fn);
	    };
	
	    t.setScrollFn = function (component, fn) {
	        t.get(component) && t.get(component).setScroll(fn);
	    };
	
	    t.removeScrollFn = function (component) {
	        t.get(component) && t.get(component).removeScroll();
	    };
	
	    t.setOnResizeFn = function (component, fn) {
	        t.get(component) && t.get(component).setOnResize(fn);
	    };
	
	    t.removeResizeFn = function (component) {
	        t.get(component) && t.get(component).removeOnResize();
	    };
	
	    t.scrollTo = function (component, x, y) {
	        t.get(component) && t.get(component).scrollTo(x, y);
	    };
	
	    t.getByGroup = function (groupName) {
	        return componentGroups[groupName];
	    };
	
	    t.getUpdateComponent = function () {
	        return t.get(defaultUpdateComponentName);
	    };
	
	    t.setUpdateComponent = function (name) {
	        defaultUpdateComponentName = name;
	    };
	
	    t.componentFrom = function (param) {
	        return (0, _isString2.default)(param) ? t.get(param) : param;
	    };
	
	    t.update = function (content, elementId) {
	        updateFn(content, elementId);
	    };
	
	    t.updateErrorMessage = function (content, elementId) {
	        t.update(withErrorStyle(content), elementId);
	    };
	
	    t.toggleCollapseRegion = function (region) {
	        t.get(region).toggleCollapse();
	    };
	
	    t.updateInterpretation = function (interpretation, layout) {
	        updateInterpretationFn(interpretation, layout);
	    };
	
	    // state
	    t.setState = function (currentState, favoriteState, isFavorite, skipStateWest, forceUiState, skipStateCenter) {
	        var north = t.get('northRegion'),
	            west = t.get('westRegion'),
	            east = t.get('eastRegion');
	
	        // app, not plugin
	        if (!t.instanceManager.plugin) {
	
	            // set url state
	            if (favoriteState) {
	                t.setUrlState('?id=' + favoriteState.id + (favoriteState.interpretationId ? '&interpretationid=' + favoriteState.interpretationId : ''));
	            } else {
	                t.setUrlState('.');
	            }
	
	            // toolbar
	            if (north) {
	                north.setState(currentState, isFavorite);
	            }
	
	            // current
	            componentTags.onCurrent.forEach(function (item) {
	                item.setDisabled(!(currentState && item.enable));
	            });
	
	            // favorite
	            componentTags.onFavorite.forEach(function (item) {
	                item.setDisabled(!(currentState && item.enable && isFavorite));
	            });
	
	            // west
	            if (forceUiState || west && !skipStateWest && (!currentState || isFavorite)) {
	                west.setState(currentState);
	            }
	
	            // east
	            if (east) {
	                east.setState(currentState);
	            }
	        }
	
	        // set init text
	        if (!currentState) {
	            t.update();
	        }
	    };
	
	    t.setUrlState = function (text) {
	        global.history.pushState(null, null, text);
	    };
	
	    // theme
	    t.getTheme = function () {
	        return theme;
	    };
	
	    t.setTheme = function (newTheme) {
	        theme = newTheme;
	    };
	
	    // intro
	    t.getIntroHtml = function () {
	        if (t.introHtmlIsAsync) {
	            return updateIntroHtml();
	        }
	        return introHtml;
	    };
	
	    t.setUpdateIntroHtmlFn = function (fn) {
	        updateIntroHtml = fn;
	    };
	
	    t.setIntroHtml = function (html) {
	        return introHtml = html;
	    };
	
	    t.setIntroFn = function (fn) {
	        introFn = fn;
	    };
	
	    t.callIntroFn = function () {
	        introFn();
	    };
	
	    // browser
	    t.getScrollbarSize = function () {
	        var size,
	            body = document.body,
	            div = document.createElement('div');
	
	        div.style.width = div.style.height = '100px';
	        div.style.overflow = 'scroll';
	        div.style.position = 'absolute';
	
	        body.appendChild(div);
	
	        size = {
	            width: div.offsetWidth - div.clientWidth,
	            height: div.offsetHeight - div.clientHeight
	        };
	
	        body.removeChild(div);
	
	        return size;
	    };
	
	    t.isScrolled = function (e) {
	        var el = e.srcElement,
	            scrollBottom = el.scrollTop + el.clientHeight / el.scrollHeight * el.scrollHeight;
	
	        return scrollBottom / el.scrollHeight > 0.9;
	    };
	
	    // multiselect
	    t.msSetHeight = function (ms, panel, fill) {
	        var toolbarHeight = 25,
	            height;
	
	        ms.forEach(function (item) {
	            height = panel.getHeight() - fill - (item.hasToolbar ? toolbarHeight : 0);
	            item.setHeight(height);
	        });
	    };
	
	    t.msSelect = function (a, s) {
	        var selected = a.getValue();
	        if (selected.length) {
	            var array = [];
	            selected.forEach(function (item) {
	                array.push(a.store.getAt(a.store.findExact('id', item)));
	            });
	            s.store.add(array);
	        }
	        t.msFilterAvailable(a, s);
	    };
	
	    t.msSelectAll = function (a, s, isReverse) {
	        var array = a.store.getRange();
	        if (isReverse) {
	            array.reverse();
	        }
	        s.store.add(array);
	        t.msFilterAvailable(a, s);
	    };
	
	    t.msUnselect = function (a, s) {
	        var selected = s.getValue();
	        if (selected.length) {
	            selected.forEach(function (id) {
	                a.store.add(s.store.getAt(s.store.findExact('id', id)));
	                s.store.remove(s.store.getAt(s.store.findExact('id', id)));
	            });
	            t.msFilterAvailable(a, s);
	            a.store.sortStore();
	        }
	    };
	
	    t.msUnselectAll = function (a, s) {
	        a.store.add(s.store.getRange());
	        s.store.removeAll();
	        t.msFilterAvailable(a, s);
	        a.store.sortStore();
	    };
	
	    t.msFilterAvailable = function (a, s) {
	        if (a.store.getRange().length && s.store.getRange().length) {
	            var recordsToRemove = [];
	
	            a.store.each(function (ar) {
	                var removeRecord = false;
	
	                s.store.each(function (sr) {
	                    if (sr.data.id === ar.data.id) {
	                        removeRecord = true;
	                    }
	                });
	
	                if (removeRecord) {
	                    recordsToRemove.push(ar);
	                }
	            });
	
	            a.store.remove(recordsToRemove);
	        }
	    };
	
	    // mask
	    t.mask = function (component, message) {
	        component = (0, _isObject2.default)(component) ? component : t.get(component) || t.getUpdateComponent();
	
	        if (!(0, _isObject2.default)(component) || t.preventMask) {
	            //console.log('mask: no component', component, message);
	            return;
	        }
	
	        message = message || 'Loading..';
	
	        if (component.mask && component.mask.destroy) {
	            component.mask.destroy();
	            component.mask = null;
	        }
	
	        component.mask = new Ext.create('Ext.LoadMask', component, {
	            shadow: false,
	            msg: message,
	            style: 'box-shadow:0',
	            bodyStyle: 'box-shadow:0'
	        });
	
	        component.mask.show();
	    };
	
	    t.unmask = function (component) {
	        component = (0, _isObject2.default)(component) ? component : t.get(component) || t.getUpdateComponent();
	
	        if (!(0, _isObject2.default)(component)) {
	            //console.log('unmask: no component', component, message);
	            return;
	        }
	
	        if (component.mask && component.mask.destroy) {
	            component.mask.destroy();
	            component.mask = null;
	        }
	    };
	
	    // window
	    t.setAnchorPosition = function (w, target) {
	        target = t.componentFrom(target);
	
	        var txy = target.getPosition ? target.getPosition() : target.getXY ? target.getXY() : null,
	            th = target.getHeight(),
	            vpw = t.get('viewport').getWidth(),
	            ww = w.getWidth();
	
	        var tx = txy[0],
	            ty = txy[1] + th + 4;
	
	        if (tx + ww > vpw) {
	            w.setPosition(vpw - ww - 2, ty);
	        } else {
	            w.setPosition(tx, ty);
	        }
	    };
	
	    t.getBodyMask = function () {
	        return Ext.getBody().child('.x-mask');
	    };
	
	    t.addHideOnBlurHandler = function (w) {
	        t.getBodyMask().on('click', function () {
	            if (w.hideOnBlur) {
	                w.hide();
	            }
	        });
	
	        w.hasHideOnBlurHandler = true;
	    };
	
	    t.addDestroyOnBlurHandler = function (w) {
	        t.getBodyMask().on('click', function () {
	            if (w.destroyOnBlur) {
	                w.destroy();
	            }
	        });
	
	        w.hasDestroyOnBlurHandler = true;
	    };
	
	    // alert
	    t.alert = function (obj) {
	        var config = {},
	            type,
	            window;
	
	        if (!obj || (0, _isObject2.default)(obj) && !obj.message && !obj.responseText) {
	            return;
	        }
	
	        // if response object
	        if ((0, _isObject2.default)(obj) && obj.responseText && !obj.message) {
	            obj = JSON.parse(obj.responseText);
	        }
	
	        // if string
	        if ((0, _isString2.default)(obj)) {
	            obj = {
	                status: 'ERROR',
	                message: obj
	            };
	        }
	
	        // web message
	        type = (obj.status || 'INFO').toLowerCase();
	
	        config.title = obj.status;
	        config.iconCls = 'ns-window-title-messagebox ' + type;
	
	        // html
	        config.html = '';
	        config.html += obj.httpStatusCode ? 'Code: ' + obj.httpStatusCode + '<br>' : '';
	        config.html += obj.httpStatus ? 'Status: ' + obj.httpStatus + '<br><br>' : '';
	        config.html += obj.message + (obj.message.substr(obj.message.length - 1) === '.' ? '' : '.');
	
	        // bodyStyle
	        config.bodyStyle = 'padding: 12px; background: #fff; max-width: 600px; max-height: ' + t.getHeight() / 2 + 'px';
	
	        // destroy handler
	        config.modal = true;
	        config.destroyOnBlur = true;
	
	        // listeners
	        config.listeners = {
	            show: function show(w) {
	                w.setPosition(w.getPosition()[0], w.getPosition()[1] / 2);
	
	                if (!w.hasDestroyOnBlurHandler) {
	                    t.addDestroyOnBlurHandler(w);
	                }
	            }
	        };
	
	        window = Ext.create('Ext.window.Window', config);
	
	        window.show();
	    };
	
	    // context menu
	    t.enableRightClick = function () {
	        document.body.oncontextmenu = true;
	    };
	
	    t.disableRightClick = function () {
	        document.body.oncontextmenu = function () {
	            return false;
	        };
	    };
	
	    // dialogue
	    t.confirmUnsaved = function (title, fn) {
	        var i18n = t.i18nManager ? t.i18nManager.get() : {};
	
	        (0, _ConfirmWindow.ConfirmWindow)(refs, title, i18n.all_unsaved_changes_will_be_discarded_continue, null, fn).show();
	    };
	
	    t.confirmReplace = function (title, fn) {
	        var i18n = t.i18nManager ? t.i18nManager.get() : {};
	
	        (0, _ConfirmWindow.ConfirmWindow)(refs, title, i18n.existing_favorite_will_be_replaced_continue, null, fn).show();
	    };
	
	    t.confirmDelete = function (title, fn) {
	        var i18n = t.i18nManager ? t.i18nManager.get() : {};
	
	        (0, _ConfirmWindow.ConfirmWindow)(refs, title, i18n.this_favorite_will_be_deleted_continue, null, fn).show();
	    };
	
	    t.confirmRender = function (title, fn, cancelFn) {
	        var i18n = t.i18nManager ? t.i18nManager.get() : {};
	
	        (0, _ConfirmWindow.ConfirmWindow)(refs, title, i18n.render_table_warning, "Continue", fn, null, cancelFn, true).show();
	    };
	
	    t.confirmCustom = function (title, msg, btnText, fn, applyConfig) {
	        (0, _ConfirmWindow.ConfirmWindow)(refs, title, msg, btnText, fn, applyConfig).show();
	    };
	
	    t.confirmInterpretationDelete = function (fn) {
	        var i18n = t.i18nManager ? t.i18nManager.get() : {};
	        (0, _ConfirmWindow.ConfirmWindow)(refs, i18n.are_you_sure, i18n.this_interpretation_will_be_deleted_continue, null, fn).show();
	    };
	
	    t.confirmCommentDelete = function (fn) {
	        var i18n = t.i18nManager ? t.i18nManager.get() : {};
	        (0, _ConfirmWindow.ConfirmWindow)(refs, i18n.are_you_sure, i18n.this_comment_will_be_deleted_continue, null, fn).show();
	    };
	
	    // redirect
	    t.redirectCtrl = function (url, e) {
	        if (e.button === 0 && !e.ctrlKey) {
	            window.location.href = url;
	        } else if (e.ctrlKey && arrayContains([0, 1], e.button) || !e.ctrlKey && e.button === 1) {
	            window.open(url, '_blank');
	        }
	    };
	
	    // plugin
	    t.getTitleHtml = function (text) {
	        return text ? '<div style="' + 'height:19px;' + 'line-height:14px;' + 'width:100%;' + 'font:bold 12px LiberationSans,arial,sans-serif;' + 'color:#333;' + 'text-align:center;' + 'letter-spacing:-0.1px">' + text + '</div>' : '';
	    };
	
	    t.getEmbedHtml = function () {
	        var text = '',
	            version = 'v' + parseFloat(t.appManager.systemInfo.version.split('.').join('')),
	            resource = t.instanceManager.apiResource,
	            divId = resource + '1',
	            pluginName = resource + 'Plugin',
	            pluginFileName = (resource || '').toLowerCase(),
	            layout = t.instanceManager.getStateCurrent();
	
	        text += '<html>\n<head>\n';
	        text += '<script src="//code.jquery.com/jquery-2.2.4.min.js"></script>\n';
	        text += '<script src="//dhis2-cdn.org/' + version + '/plugin/' + pluginFileName + '.js"></script>\n';
	        text += '</head>\n\n<body>\n';
	        text += '<div id="' + divId + '"></div>\n\n';
	        text += '<script>\n\n';
	        text += pluginName + '.url = "<url to server>";\n';
	        text += pluginName + '.username = "<username>";\n';
	        text += pluginName + '.password = "<password>";\n\n';
	        text += resource + 'Plugin.load([' + JSON.stringify(layout.toPlugin(divId), null, 2) + ']);\n\n';
	        text += '</script>\n\n';
	        text += '</body>\n</html>';
	
	        return text;
	    };
	
	    t.renderLoadingIndicator = function (el) {
	        $('#' + el).append('<div class="spinner"></div>');
	    };
	
	    // resize
	    t.onResize = function (fn) {
	        resizeHandlers.push(fn);
	    };
	
	    t.resize = function (params) {
	        resizeHandlers.run(params);
	    };
	
	    // redirect
	    t.openTableLayoutTab = function (layout, type, isNewTab) {
	        layout = layout || t.instanceManager.getStateCurrent();
	        type = type || 'xls';
	
	        var url = layout.req(null, type, false, true).url();
	        var target = isNewTab ? '_blank' : '_top';
	
	        window.open(url, target);
	    };
	
	    t.openPlainDataSource = function (url, extraParamString, isNewTab) {
	        url = ((0, _isString2.default)(url) ? url : url.url()) + (extraParamString || '');
	        var target = isNewTab ? '_blank' : '_top';
	
	        window.open(url, target);
	    };
	
	    t.openDataDump = function (layout, format, scheme, isNewTab) {
	        layout = layout || t.instanceManager.getLayout();
	
	        var includeFilter = false;
	
	        if (layout) {
	            var extraParams = [];
	
	            layout.toRows(includeFilter);
	
	            format = format || 'csv';
	
	            if (layout.showHierarchy) {
	                extraParams.push('showHierarchy=true');
	            }
	
	            extraParams.push('rows=' + layout.getDimensionNames(includeFilter).join(';'));
	
	            var url = layout.req(null, format).url(extraParams);
	            var target = isNewTab ? '_blank' : '_top';
	
	            window.open(url, target);
	        }
	    };
	
	    // svg
	    t.getSvg = function () {
	        var svg = Ext.query('svg');
	
	        if (!((0, _isArray2.default)(svg) && svg.length)) {
	            alert('Browser does not support SVG');
	            return;
	        }
	
	        svg = Ext.get(svg[0]);
	        svg = svg.parent().dom.innerHTML;
	
	        return svg;
	    };
	
	    t.submitSvgForm = function (type, filename) {
	        var form = Ext.query('#exportForm')[0];
	        var chart = this.get('chart');
	
	        var svg = chart && (0, _isFunction2.default)(chart.getSVGForExport) ? chart.getSVGForExport() : this.getSvg();
	
	        if (!svg) {
	            return;
	        }
	
	        Ext.query('#svgField')[0].value = svg;
	        Ext.query('#filenameField')[0].value = filename || 'Untitled';
	
	        form.action = t.appManager.getPath() + '/api/svg.' + type;
	        form.submit();
	    };
	
	    // helpers
	    t.hexToRgb = function (hex) {
	        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	
	        return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null;
	    };
	
	    t.calculateColorBrightness = function (rgb) {
	        return Math.round((parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) / 1000);
	    };
	
	    t.isColorBright = function (rgbColor) {
	        return t.calculateColorBrightness(rgbColor) > 125;
	    };
	};
	
	UiManager.prototype.applyTo = function (modules) {
	    var t = this;
	
	    (0, _arrayTo2.default)(modules).forEach(function (module) {
	        module.uiManager = t;
	    });
	};
	
	UiManager.prototype.getWidth = function (cmpName) {
	    var t = this;
	
	    var cmp = cmpName ? t.componentFrom(cmpName) : t.getUpdateComponent();
	
	    return cmp.getWidth();
	};
	
	UiManager.prototype.getHeight = function (cmpName) {
	    var t = this;
	
	    var cmp = cmpName ? t.componentFrom(cmpName) : t.getUpdateComponent();
	
	    return cmp.getHeight();
	};
	
	UiManager.prototype.getUiState = function () {
	    return this.get('viewport').getUiState();
	};
	
	UiManager.prototype.enableConfirmUnload = function () {
	    var t = this;
	
	    window.onbeforeunload = function (event) {
	        return t.instanceManager && t.instanceManager.isStateUnsaved() ? ((typeof event === 'undefined' ? 'undefined' : _typeof(event)) ? event : window.event).returnValue = 'You have unsaved changes.' : null;
	    };
	};
	
	UiManager.prototype.disableConfirmUnload = function () {
	    window.onbeforeunload = function (event) {
	        return null;
	    };
	};
	//# sourceMappingURL=UiManager.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 145 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var extChartOverrides = exports.extChartOverrides = function extChartOverrides() {
	
	    Ext.override(Ext.chart.Chart, {
	        insetPaddingObject: {},
	
	        alignAxes: function alignAxes() {
	            var me = this,
	                axes = me.axes,
	                legend = me.legend,
	                edges = ['top', 'right', 'bottom', 'left'],
	                chartBBox,
	                insetPadding = me.insetPadding,
	                insetPaddingObject = me.insetPaddingObject,
	                insets = {
	                top: insetPaddingObject.top || insetPadding,
	                right: insetPaddingObject.right || insetPadding,
	                bottom: insetPaddingObject.bottom || insetPadding,
	                left: insetPaddingObject.left || insetPadding
	            };
	
	            function getAxis(edge) {
	                var i = axes.findIndex('position', edge);
	                return i < 0 ? null : axes.getAt(i);
	            }
	
	            Ext.each(edges, function (edge) {
	                var isVertical = edge === 'left' || edge === 'right',
	                    axis = getAxis(edge),
	                    bbox;
	
	                if (legend !== false) {
	                    if (legend.position === edge) {
	                        bbox = legend.getBBox();
	                        insets[edge] += (isVertical ? bbox.width : bbox.height) + insets[edge];
	                    }
	                }
	
	                if (axis && axis.bbox) {
	                    bbox = axis.bbox;
	                    insets[edge] += isVertical ? bbox.width : bbox.height;
	                }
	            });
	
	            chartBBox = {
	                x: insets.left,
	                y: insets.top,
	                width: me.curWidth - insets.left - insets.right,
	                height: me.curHeight - insets.top - insets.bottom
	            };
	            me.chartBBox = chartBBox;
	
	            axes.each(function (axis) {
	                var pos = axis.position,
	                    isVertical = pos === 'left' || pos === 'right';
	
	                axis.x = pos === 'right' ? chartBBox.x + chartBBox.width : chartBBox.x;
	                axis.y = pos === 'top' ? chartBBox.y : chartBBox.y + chartBBox.height;
	                axis.width = isVertical ? chartBBox.width : chartBBox.height;
	                axis.length = isVertical ? chartBBox.height : chartBBox.width;
	            });
	        }
	    });
	
	    Ext.override(Ext.chart.series.Line, {
	        drawSeries: function drawSeries() {
	            var ak = this,
	                au = ak.chart,
	                S = au.axes,
	                ao = au.getChartStore(),
	                V = ao.getCount(),
	                u = ak.chart.surface,
	                am = {},
	                R = ak.group,
	                K = ak.showMarkers,
	                aA = ak.markerGroup,
	                D = au.shadow,
	                C = ak.shadowGroups,
	                X = ak.shadowAttributes,
	                O = ak.smooth,
	                q = C.length,
	                ar = ["M"],
	                T = ["M"],
	                d = ["M"],
	                b = ["M"],
	                J = au.markerIndex,
	                ai = [].concat(ak.axis),
	                ah,
	                av = [],
	                ag = {},
	                aa = [],
	                v = {},
	                I = false,
	                Q = [],
	                az = ak.markerStyle,
	                Z = ak.style,
	                t = ak.colorArrayStyle,
	                P = t && t.length || 0,
	                L = Ext.isNumber,
	                aw = ak.seriesIdx,
	                g = ak.getAxesForXAndYFields(),
	                l = g.xAxis,
	                ay = g.yAxis,
	                ac,
	                h,
	                ab,
	                ad,
	                A,
	                c,
	                ae,
	                H,
	                G,
	                f,
	                e,
	                s,
	                r,
	                W,
	                N,
	                M,
	                at,
	                m,
	                F,
	                E,
	                aB,
	                n,
	                p,
	                B,
	                a,
	                Y,
	                af,
	                z,
	                aq,
	                w,
	                ap,
	                o,
	                ax,
	                an,
	                al,
	                U,
	                k,
	                aj;if (ak.fireEvent("beforedraw", ak) === false) {
	                return;
	            }if (!V || ak.seriesIsHidden) {
	                aj = this.items;if (aj) {
	                    for (N = 0, at = aj.length; N < at; ++N) {
	                        if (aj[N].sprite) {
	                            aj[N].sprite.hide(true);
	                        }
	                    }
	                }return;
	            }an = Ext.apply(az || {}, ak.markerConfig);U = an.type;delete an.type;al = Z;if (!al["stroke-width"]) {
	                al["stroke-width"] = 0.5;
	            }if (J && aA && aA.getCount()) {
	                for (N = 0; N < J; N++) {
	                    E = aA.getAt(N);aA.remove(E);aA.add(E);aB = aA.getAt(aA.getCount() - 2);E.setAttributes({ x: 0, y: 0, translate: { x: aB.attr.translation.x, y: aB.attr.translation.y } }, true);
	                }
	            }ak.unHighlightItem();ak.cleanHighlights();ak.setBBox();am = ak.bbox;ak.clipRect = [am.x, am.y, am.width, am.height];for (N = 0, at = ai.length; N < at; N++) {
	                m = S.get(ai[N]);if (m) {
	                    F = m.calcEnds();if (m.position == "top" || m.position == "bottom") {
	                        z = F.from;aq = F.to;
	                    } else {
	                        w = F.from;ap = F.to;
	                    }
	                }
	            }if (ak.xField && !L(z) && (l == "bottom" || l == "top") && !S.get(l)) {
	                m = Ext.create("Ext.chart.axis.Axis", { chart: au, fields: [].concat(ak.xField) }).calcEnds();z = m.from;aq = m.to;
	            }if (ak.yField && !L(w) && (ay == "right" || ay == "left") && !S.get(ay)) {
	                m = Ext.create("Ext.chart.axis.Axis", { chart: au, fields: [].concat(ak.yField) }).calcEnds();w = m.from;ap = m.to;
	            }if (isNaN(z)) {
	                z = 0;Y = am.width / (V - 1 || 1);
	            } else {
	                Y = am.width / (aq - z || V - 1 || 1);
	            }if (isNaN(w)) {
	                w = 0;af = am.height / (V - 1 || 1);
	            } else {
	                af = am.height / (ap - w || V - 1 || 1);
	            }ak.eachRecord(function (j, x) {
	                p = j.get(ak.xField);if (typeof p == "string" || (typeof p === 'undefined' ? 'undefined' : _typeof(p)) == "object" && !Ext.isDate(p) || l && S.get(l) && S.get(l).type == "Category") {
	                    if (p in ag) {
	                        p = ag[p];
	                    } else {
	                        p = ag[p] = x;
	                    }
	                }B = j.get(ak.yField);if (typeof B == "undefined" || typeof B == "string" && !B) {
	                    if (Ext.isDefined(Ext.global.console)) {
	                        Ext.global.console.warn("[Ext.chart.series.Line]  Skipping a store element with an undefined value at ", j, p, B);
	                    }return;
	                }if ((typeof B === 'undefined' ? 'undefined' : _typeof(B)) == "object" && !Ext.isDate(B) || ay && S.get(ay) && S.get(ay).type == "Category") {
	                    B = x;
	                }Q.push(x);av.push(p);aa.push(B);
	            });at = av.length;if (at > am.width) {
	                a = ak.shrink(av, aa, am.width);av = a.x;aa = a.y;
	            }ak.items = [];k = 0;at = av.length;for (N = 0; N < at; N++) {
	                p = av[N];B = aa[N];if (B === false) {
	                    if (T.length == 1) {
	                        T = [];
	                    }I = true;ak.items.push(false);continue;
	                } else {
	                    H = (am.x + (p - z) * Y).toFixed(2);G = (am.y + am.height - (B - w) * af).toFixed(2);if (I) {
	                        I = false;T.push("M");
	                    }T = T.concat([H, G]);
	                }if (typeof r == "undefined" && typeof G != "undefined") {
	                    r = G;s = H;
	                }if (!ak.line || au.resizing) {
	                    ar = ar.concat([H, am.y + am.height / 2]);
	                }if (au.animate && au.resizing && ak.line) {
	                    ak.line.setAttributes({ path: ar }, true);if (ak.fillPath) {
	                        ak.fillPath.setAttributes({ path: ar, opacity: 0.2 }, true);
	                    }if (ak.line.shadows) {
	                        ac = ak.line.shadows;for (M = 0, q = ac.length; M < q; M++) {
	                            h = ac[M];h.setAttributes({ path: ar }, true);
	                        }
	                    }
	                }if (K) {
	                    E = aA.getAt(k++);if (!E) {
	                        E = Ext.chart.Shape[U](u, Ext.apply({ group: [R, aA], x: 0, y: 0, translate: { x: +(f || H), y: e || am.y + am.height / 2 }, value: '"' + p + ", " + B + '"', zIndex: 4000 }, an));E._to = { translate: { x: +H, y: +G } };
	                    } else {
	                        E.setAttributes({ value: '"' + p + ", " + B + '"', x: 0, y: 0, hidden: false }, true);E._to = { translate: { x: +H, y: +G } };
	                    }
	                }ak.items.push({ series: ak, value: [p, B], point: [H, G], sprite: E, storeItem: ao.getAt(Q[N]) });f = H;e = G;
	            }if (T.length <= 1) {
	                return;
	            }if (ak.smooth) {
	                b = Ext.draw.Draw.smooth(T, L(O) ? O : ak.defaultSmoothness);
	            }d = O ? b : T;if (au.markerIndex && ak.previousPath) {
	                ad = ak.previousPath;if (!O) {
	                    Ext.Array.erase(ad, 1, 2);
	                }
	            } else {
	                ad = T;
	            }if (!ak.line) {
	                ak.line = u.add(Ext.apply({ type: "path", group: R, path: ar, stroke: al.stroke || al.fill }, al || {}));if (D) {
	                    ak.line.setAttributes(Ext.apply({}, ak.shadowOptions), true);
	                }ak.line.setAttributes({ fill: "none", zIndex: 3000 });if (!al.stroke && P) {
	                    ak.line.setAttributes({ stroke: t[aw % P] }, true);
	                }if (D) {
	                    ac = ak.line.shadows = [];for (ab = 0; ab < q; ab++) {
	                        ah = X[ab];ah = Ext.apply({}, ah, { path: ar });h = u.add(Ext.apply({}, { type: "path", group: C[ab] }, ah));ac.push(h);
	                    }
	                }
	            }if (ak.fill) {
	                c = d.concat([["L", H, am.y + am.height], ["L", s, am.y + am.height], ["L", s, r]]);if (!ak.fillPath) {
	                    ak.fillPath = u.add({ group: R, type: "path", opacity: al.opacity || 0.3, fill: al.fill || t[aw % P], path: ar });
	                }
	            }W = K && aA.getCount();if (au.animate) {
	                A = ak.fill;o = ak.line;ae = ak.renderer(o, false, { path: d }, N, ao);Ext.apply(ae, al || {}, { stroke: al.stroke || al.fill });delete ae.fill;o.show(true);if (au.markerIndex && ak.previousPath) {
	                    ak.animation = ax = ak.onAnimate(o, { to: ae, from: { path: ad } });
	                } else {
	                    ak.animation = ax = ak.onAnimate(o, { to: ae });
	                }if (D) {
	                    ac = o.shadows;for (M = 0; M < q; M++) {
	                        ac[M].show(true);if (au.markerIndex && ak.previousPath) {
	                            ak.onAnimate(ac[M], { to: { path: d }, from: { path: ad } });
	                        } else {
	                            ak.onAnimate(ac[M], { to: { path: d } });
	                        }
	                    }
	                }if (A) {
	                    ak.fillPath.show(true);ak.onAnimate(ak.fillPath, { to: Ext.apply({}, { path: c, fill: al.fill || t[aw % P], "stroke-width": 0 }, al || {}) });
	                }if (K) {
	                    k = 0;for (N = 0; N < at; N++) {
	                        if (ak.items[N]) {
	                            n = aA.getAt(k++);if (n) {
	                                ae = ak.renderer(n, ao.getAt(N), n._to, N, ao);ak.onAnimate(n, { to: Ext.apply(ae, an || {}) });n.show(true);
	                            }
	                        }
	                    }for (; k < W; k++) {
	                        n = aA.getAt(k);n.hide(true);
	                    }
	                }
	            } else {
	                ae = ak.renderer(ak.line, false, { path: d, hidden: false }, N, ao);Ext.apply(ae, al || {}, { stroke: al.stroke || al.fill });delete ae.fill;ak.line.setAttributes(ae, true);if (D) {
	                    ac = ak.line.shadows;for (M = 0; M < q; M++) {
	                        ac[M].setAttributes({ path: d, hidden: false }, true);
	                    }
	                }if (ak.fill) {
	                    ak.fillPath.setAttributes({ path: c, hidden: false }, true);
	                }if (K) {
	                    k = 0;for (N = 0; N < at; N++) {
	                        if (ak.items[N]) {
	                            n = aA.getAt(k++);if (n) {
	                                ae = ak.renderer(n, ao.getAt(N), n._to, N, ao);n.setAttributes(Ext.apply(an || {}, ae || {}), true);n.show(true);
	                            }
	                        }
	                    }for (; k < W; k++) {
	                        n = aA.getAt(k);n.hide(true);
	                    }
	                }
	            }if (au.markerIndex) {
	                if (ak.smooth) {
	                    Ext.Array.erase(T, 1, 2);
	                } else {
	                    Ext.Array.splice(T, 1, 0, T[1], T[2]);
	                }ak.previousPath = T;
	            }ak.renderLabels();ak.renderCallouts();ak.fireEvent("draw", ak);
	        }
	    });
	
	    Ext.override(Ext.chart.Legend, {
	        updatePosition: function updatePosition() {
	            var me = this,
	                x,
	                y,
	                legendWidth = me.width,
	                legendHeight = me.height,
	                padding = me.padding,
	                chart = me.chart,
	                chartBBox = chart.chartBBox,
	                insets = chart.insetPadding,
	                chartWidth = chartBBox.width - insets * 2,
	                chartHeight = chartBBox.height - insets * 2,
	                chartX = chartBBox.x + insets,
	                chartY = chartBBox.y + insets,
	                surface = chart.surface,
	                mfloor = Math.floor;
	
	            if (me.isDisplayed()) {
	                // Find the position based on the dimensions
	                switch (me.position) {
	                    case "left":
	                        x = insets;
	                        y = mfloor(chartY + chartHeight / 2 - legendHeight / 2);
	                        break;
	                    case "right":
	                        x = mfloor(surface.width - legendWidth) - insets;
	                        y = mfloor(chartY + chartHeight / 2 - legendHeight / 2);
	                        break;
	                    case "top":
	                        x = mfloor((chartX + chartBBox.width) / 2 - legendWidth / 2) - 7;
	                        y = insets;
	                        break;
	                    case "bottom":
	                        x = mfloor(chartX + chartWidth / 2 - legendWidth / 2);
	                        y = mfloor(surface.height - legendHeight) - insets;
	                        break;
	                    default:
	                        x = mfloor(me.origX) + insets;
	                        y = mfloor(me.origY) + insets;
	                }
	                me.x = x;
	                me.y = y;
	
	                // Update the position of each item
	                Ext.each(me.items, function (item) {
	                    item.updatePosition();
	                });
	                // Update the position of the outer box
	                me.boxSprite.setAttributes(me.getBBox(), true);
	            }
	        }
	    });
	
	    Ext.override(Ext.chart.LegendItem, {
	        createLegend: function createLegend(config) {
	            var me = this,
	                index = config.yFieldIndex,
	                series = me.series,
	                seriesType = series.type,
	                idx = me.yFieldIndex,
	                legend = me.legend,
	                surface = me.surface,
	                refX = legend.x + me.x,
	                refY = legend.y + me.y,
	                bbox,
	                z = me.zIndex,
	                markerConfig,
	                label,
	                mask,
	                radius,
	                toggle = false,
	                seriesStyle = Ext.apply(series.seriesStyle, series.style),
	                labelMarkerSize = legend.labelMarkerSize || 10;
	
	            function getSeriesProp(name) {
	                var val = series[name];
	                return Ext.isArray(val) ? val[idx] : val;
	            }
	
	            label = me.add('label', surface.add({
	                type: 'text',
	                x: 30,
	                y: 0,
	                zIndex: z || 0,
	                font: legend.labelFont,
	                fill: legend.labelColor || '#000',
	                text: getSeriesProp('title') || getSeriesProp('yField')
	            }));
	
	            if (seriesType === 'line' || seriesType === 'scatter') {
	                if (seriesType === 'line') {
	                    me.add('line', surface.add({
	                        type: 'path',
	                        path: 'M0.5,0.5L16.5,0.5',
	                        zIndex: z,
	                        "stroke-width": series.lineWidth,
	                        "stroke-linejoin": "round",
	                        "stroke-dasharray": series.dash,
	                        stroke: seriesStyle.stroke || '#000',
	                        style: {
	                            cursor: 'pointer'
	                        }
	                    }));
	                }
	                if (series.showMarkers || seriesType === 'scatter') {
	                    markerConfig = Ext.apply(series.markerStyle, series.markerConfig || {});
	                    me.add('marker', Ext.chart.Shape[markerConfig.type](surface, {
	                        fill: markerConfig.fill,
	                        x: 8.5,
	                        y: 0.5,
	                        zIndex: z,
	                        radius: markerConfig.radius || markerConfig.size,
	                        style: {
	                            cursor: 'pointer'
	                        }
	                    }));
	                }
	            } else {
	                me.add('box', surface.add({
	                    type: 'rect',
	                    zIndex: z,
	                    x: 6,
	                    y: 0,
	                    width: labelMarkerSize,
	                    height: labelMarkerSize,
	                    fill: series.getLegendColor(index),
	                    style: {
	                        cursor: 'pointer'
	                    }
	                }));
	            }
	
	            me.setAttributes({
	                hidden: false
	            }, true);
	
	            bbox = me.getBBox();
	
	            mask = me.add('mask', surface.add({
	                type: 'rect',
	                x: bbox.x,
	                y: bbox.y,
	                width: bbox.width || 20,
	                height: bbox.height || 20,
	                zIndex: (z || 0) + 1000,
	                fill: '#f00',
	                opacity: 0,
	                style: {
	                    'cursor': 'pointer'
	                }
	            }));
	
	            me.on('mouseover', function () {
	                label.setStyle({
	                    'font-weight': 'bold'
	                });
	                mask.setStyle({
	                    'cursor': 'pointer'
	                });
	                series._index = index;
	                series.highlightItem();
	            }, me);
	
	            me.on('mouseout', function () {
	                label.setStyle({
	                    'font-weight': 'normal'
	                });
	                series._index = index;
	                series.unHighlightItem();
	            }, me);
	
	            if (!series.visibleInLegend(index)) {
	                toggle = true;
	                label.setAttributes({
	                    opacity: 0.5
	                }, true);
	            }
	
	            me.on('mousedown', function () {
	                if (!toggle) {
	                    series.hideAll();
	                    label.setAttributes({
	                        opacity: 0.5
	                    }, true);
	                } else {
	                    series.showAll();
	                    label.setAttributes({
	                        opacity: 1
	                    }, true);
	                }
	                toggle = !toggle;
	            }, me);
	            me.updatePosition({ x: 0, y: 0 });
	        }
	    });
	
	    Ext.override(Ext.chart.axis.Axis, {
	        drawHorizontalLabels: function drawHorizontalLabels() {
	            var me = this,
	                labelConf = me.label,
	                floor = Math.floor,
	                max = Math.max,
	                axes = me.chart.axes,
	                position = me.position,
	                inflections = me.inflections,
	                ln = inflections.length,
	                labels = me.labels,
	                labelGroup = me.labelGroup,
	                maxHeight = 0,
	                ratio,
	                gutterY = me.chart.maxGutter[1],
	                ubbox,
	                bbox,
	                point,
	                prevX,
	                prevLabel,
	                projectedWidth = 0,
	                textLabel,
	                attr,
	                textRight,
	                text,
	                label,
	                last,
	                x,
	                y,
	                i,
	                firstLabel;
	
	            last = ln - 1;
	            // get a reference to the first text label dimensions
	            point = inflections[0];
	            firstLabel = me.getOrCreateLabel(0, me.label.renderer(labels[0]));
	            ratio = Math.floor(Math.abs(Math.sin(labelConf.rotate && labelConf.rotate.degrees * Math.PI / 180 || 0)));
	
	            for (i = 0; i < ln; i++) {
	                point = inflections[i];
	                text = me.label.renderer(labels[i]) || '';
	                textLabel = me.getOrCreateLabel(i, text);
	                bbox = textLabel._bbox;
	                maxHeight = max(maxHeight, bbox.height + me.dashSize + me.label.padding);
	                x = floor(point[0] - (ratio ? bbox.height : bbox.width) / 2);
	                if (me.chart.maxGutter[0] == 0) {
	                    if (i == 0 && axes.findIndex('position', 'left') == -1) {
	                        x = point[0];
	                    } else if (i == last && axes.findIndex('position', 'right') == -1) {
	                        x = point[0] - bbox.width;
	                    }
	                }
	                if (position == 'top') {
	                    y = point[1] - me.dashSize * 2 - me.label.padding - bbox.height / 2;
	                } else {
	                    y = point[1] + me.dashSize * 2 + me.label.padding + bbox.height / 2;
	                }
	
	                var moveLabels = labelConf.rotate && labelConf.rotate.degrees && !Ext.Array.contains([0, 90, 180, 270, 360], labelConf.rotate.degrees),
	                    adjust = Math.floor((textLabel.text.length - 12) * -1 * 0.75),
	                    newX = moveLabels ? point[0] - textLabel._bbox.width + adjust : x;
	
	                textLabel.setAttributes({
	                    hidden: false,
	                    x: newX,
	                    y: y
	                }, true);
	
	                // skip label if there isn't available minimum space
	                if (i != 0 && (me.intersect(textLabel, prevLabel) || me.intersect(textLabel, firstLabel))) {
	                    textLabel.hide(true);
	                    continue;
	                }
	
	                prevLabel = textLabel;
	            }
	
	            return maxHeight;
	        }
	    });
	
	    Ext.override(Ext.chart.axis.Radial, {
	        drawLabel: function drawLabel() {
	            var chart = this.chart,
	                surface = chart.surface,
	                bbox = chart.chartBBox,
	                store = chart.store,
	                centerX = bbox.x + bbox.width / 2,
	                centerY = bbox.y + bbox.height / 2,
	                rho = Math.min(bbox.width, bbox.height) / 2,
	                max = Math.max,
	                round = Math.round,
	                labelArray = [],
	                label,
	                fields = [],
	                nfields,
	                categories = [],
	                xField,
	                aggregate = !this.maximum,
	                maxValue = this.maximum || 0,
	                steps = this.steps,
	                i = 0,
	                j,
	                dx,
	                dy,
	                pi2 = Math.PI * 2,
	                cos = Math.cos,
	                sin = Math.sin,
	                display = this.label.display,
	                draw = display !== 'none',
	                margin = 10,
	                labelColor = '#333',
	                labelFont = 'normal 9px sans-serif',
	                seriesStyle = chart.seriesStyle;
	
	            labelColor = seriesStyle ? seriesStyle.labelColor : labelColor;
	            labelFont = seriesStyle ? seriesStyle.labelFont : labelFont;
	
	            if (!draw) {
	                return;
	            }
	
	            //get all rendered fields
	            chart.series.each(function (series) {
	                fields.push(series.yField);
	                xField = series.xField;
	            });
	
	            //get maxValue to interpolate
	            store.each(function (record, i) {
	                if (aggregate) {
	                    for (i = 0, nfields = fields.length; i < nfields; i++) {
	                        maxValue = max(+record.get(fields[i]), maxValue);
	                    }
	                }
	                categories.push(record.get(xField));
	            });
	            if (!this.labelArray) {
	                if (display != 'categories') {
	                    //draw scale
	                    for (i = 1; i <= steps; i++) {
	                        label = surface.add({
	                            type: 'text',
	                            text: round(i / steps * maxValue),
	                            x: centerX,
	                            y: centerY - rho * i / steps,
	                            'text-anchor': 'middle',
	                            'stroke-width': 0.1,
	                            stroke: '#333',
	                            fill: labelColor,
	                            font: labelFont
	                        });
	                        label.setAttributes({
	                            hidden: false
	                        }, true);
	                        labelArray.push(label);
	                    }
	                }
	                if (display != 'scale') {
	                    //draw text
	                    for (j = 0, steps = categories.length; j < steps; j++) {
	                        dx = cos(j / steps * pi2) * (rho + margin);
	                        dy = sin(j / steps * pi2) * (rho + margin);
	                        label = surface.add({
	                            type: 'text',
	                            text: categories[j],
	                            x: centerX + dx,
	                            y: centerY + dy,
	                            'text-anchor': dx * dx <= 0.001 ? 'middle' : dx < 0 ? 'end' : 'start',
	                            fill: labelColor,
	                            font: labelFont
	                        });
	                        label.setAttributes({
	                            hidden: false
	                        }, true);
	                        labelArray.push(label);
	                    }
	                }
	            } else {
	                labelArray = this.labelArray;
	                if (display != 'categories') {
	                    //draw values
	                    for (i = 0; i < steps; i++) {
	                        labelArray[i].setAttributes({
	                            text: round((i + 1) / steps * maxValue),
	                            x: centerX,
	                            y: centerY - rho * (i + 1) / steps,
	                            'text-anchor': 'middle',
	                            'stroke-width': 0.1,
	                            stroke: '#333',
	                            fill: labelColor,
	                            font: labelFont
	                        }, true);
	                    }
	                }
	                if (display != 'scale') {
	                    //draw text
	                    for (j = 0, steps = categories.length; j < steps; j++) {
	                        dx = cos(j / steps * pi2) * (rho + margin);
	                        dy = sin(j / steps * pi2) * (rho + margin);
	                        if (labelArray[i + j]) {
	                            labelArray[i + j].setAttributes({
	                                type: 'text',
	                                text: categories[j],
	                                x: centerX + dx,
	                                y: centerY + dy,
	                                'text-anchor': dx * dx <= 0.001 ? 'middle' : dx < 0 ? 'end' : 'start',
	                                fill: labelColor,
	                                font: labelFont
	                            }, true);
	                        }
	                    }
	                }
	            }
	            this.labelArray = labelArray;
	        }
	    });
	};
	//# sourceMappingURL=extChartOverrides.js.map

/***/ },
/* 146 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var extOverrides = exports.extOverrides = undefined;
	
	exports.extOverrides = extOverrides = function extOverrides() {
	
	    Ext.QuickTips.init();
	};
	//# sourceMappingURL=extOverrides.js.map

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EventDataTable = undefined;
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayClean = __webpack_require__(7);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _uuid = __webpack_require__(30);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventDataTable = exports.EventDataTable = undefined;
	
	exports.EventDataTable = EventDataTable = function EventDataTable(refs, layout, response) {
	    var t = this;
	
	    var appManager = refs.appManager,
	        uiManager = refs.uiManager,
	        i18nManager = refs.i18nManager,
	        dimensionConfig = refs.dimensionConfig,
	        optionConfig = refs.optionConfig;
	    var ResponseRowIdCombination = refs.api.ResponseRowIdCombination;
	
	
	    var i18n = i18nManager.get();
	
	    var FIXED_HEADERS = ['eventdate'];
	
	    var filteredHeaders = response.getFilteredHeaders([].concat(FIXED_HEADERS, layout.getDimensionNames()));
	
	    var rows = response.rows;
	    var items = response.metaData.items;
	    var cls = [];
	    var html = '';
	
	    var pager = response.metaData.pager;
	    var count = pager.page * pager.pageSize - pager.pageSize;
	
	    var sortableIdObjects = [];
	
	    cls.push('pivot');
	    cls.push(layout.displayDensity !== optionConfig.getDisplayDensity('normal') ? ' displaydensity-' + layout.displayDensity : null);
	    cls.push(layout.fontSize !== optionConfig.getFontSize('normal') ? ' fontsize-' + layout.fontSize : null);
	
	    html += '<table class="' + (0, _arrayClean2.default)(cls).join(' ') + '"><tr>';
	    html += '<td class="pivot-dim pivot-dim-subtotal">' + '#' + '</td>';
	
	    // get header indexes
	    filteredHeaders.forEach(function (header) {
	        var uid = (0, _uuid2.default)();
	
	        html += '<td id="' + uid + '" class="pivot-dim td-sortable">' + header.column + '</td>';
	
	        sortableIdObjects.push({
	            id: header.name,
	            uuid: uid
	        });
	    });
	
	    html += '</tr>';
	
	    // rows
	    for (var i = 0, row, rowHtml; i < rows.length; i++) {
	        row = rows[i];
	        rowHtml = '';
	
	        for (var ii = 0, header, rowValue, itemKey, name; ii < filteredHeaders.length; ii++) {
	            header = filteredHeaders[ii];
	            rowValue = row[header.index];
	
	            itemKey = (header.isPrefix ? header.name + '_' : '') + rowValue;
	
	            name = (items[itemKey] || {}).name || rowValue;
	
	            //isBoolean = header.type === 'java.lang.Boolean';
	            //str = row[header.index];
	            //str = optionNames[header.name + str] || optionNames[str] || (isBoolean ? booleanNames[str] : null) || names[str] || str;
	            //name = web.report.query.format(str);
	
	            //if (header.name === 'ouname' && layout.showHierarchy) {
	            //var a = Ext.Array.clean(name.split('/'));
	            //name = '';
	
	            //for (var k = 0, isLast; k < a.length; k++) {
	            //isLast = !!(i === a.length - 1);
	
	            //name += (!isLast ? '<span class="text-weak">' : '') + a[i] + (!isLast ? '</span>' : '') + (!isLast ? ' / ' : '');
	            //}
	            //}
	
	            rowHtml += '<td class="pivot-value align-left">' + name + '</td>';
	        }
	
	        html += '<tr><td class="pivot-value align-right">' + (count + (i + 1)) + '</td>' + rowHtml + '</tr>';
	    }
	
	    html += '</table>';
	
	    return {
	        sortableIdObjects: sortableIdObjects,
	        html: html
	    };
	};
	//# sourceMappingURL=EventDataTable.js.map

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PivotTable = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isNumber = __webpack_require__(9);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isBoolean = __webpack_require__(13);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isEmpty = __webpack_require__(29);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _numberConstrain = __webpack_require__(65);
	
	var _numberConstrain2 = _interopRequireDefault(_numberConstrain);
	
	var _objectApplyIf = __webpack_require__(66);
	
	var _objectApplyIf2 = _interopRequireDefault(_objectApplyIf);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayClean = __webpack_require__(7);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _uuid = __webpack_require__(30);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _ResponseRowIdCombination = __webpack_require__(35);
	
	var _colorUtils = __webpack_require__(169);
	
	var _PivotTableUtils = __webpack_require__(57);
	
	var _PivotTableCells = __webpack_require__(150);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * 
	 * 
	 * @param {object} refs 
	 * @param {object} layout 
	 * @param {object} response 
	 * @param {object} colAxis 
	 * @param {object} rowAxis 
	 * @param {object} [options={}] 
	 */
	var PivotTable = exports.PivotTable = function PivotTable(refs, layout, response, colAxis, rowAxis) {
	    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	
	    this.options = _extends({
	        renderLimit: 100000,
	        forceDynamic: false,
	        showColTotals: !!layout.showColTotals,
	        showRowTotals: !!layout.showRowTotals,
	        showColSubTotals: !!layout.showColSubTotals,
	        showRowSubTotals: !!layout.showRowSubTotals,
	        hideEmptyRows: !!layout.hideEmptyRows,
	        hideEmptyColumns: !!layout.hideEmptyColumns,
	        showDimensionLabels: !!layout.showDimensionLabels,
	        stickyColumnDimension: !!layout.stickyColumnDimension,
	        stickyRowDimension: !!layout.stickyRowDimension,
	        showHierarchy: !!layout.showHierarchy,
	        numberType: layout.numberType,
	        trueTotals: true
	    }, options);
	
	    this.cellHeight = 25;
	    this.cellWidth = 120;
	    this.renderOffset = 1;
	
	    this.title = layout.title;
	    this.digitGroupSeparator = layout.digitGroupSeparator;
	
	    this.fontSize = layout.fontSize;
	    this.displayDensity = layout.displayDensity;
	
	    this.uuidDimUuidsMap = {};
	
	    this.valueUuids = [];
	    this.dimensionUuids = [];
	    this.sortableIdObjects = [];
	
	    this.filters = layout.filters;
	    this.layout = layout;
	    this.response = response;
	    this.appManager = refs.appManager;
	    this.optionConfig = refs.optionConfig;
	    this.uiManager = refs.uiManager;
	
	    this.legendSet = (0, _isObject2.default)(layout.legendSet) ? this.appManager.getLegendSetById(layout.legendSet.id) : null;
	
	    this.colAxis = colAxis;
	    this.rowAxis = rowAxis;
	
	    this.legendDisplayStyle = layout.legendDisplayStyle;
	    this.legendDisplayStrategy = layout.legendDisplayStrategy;
	
	    this.numberOfEmptyRows = 0;
	    this.numberOfEmptyColumns = 0;
	};
	
	/**
	 * @description Pivot table initialization function, does most of the heavy lifting.
	 * 
	 */
	PivotTable.prototype.initialize = function () {
	
	    // number of dimensions for each axis
	    this.columnDimensionSize = this.colAxis.dims || 1;
	    this.rowDimensionSize = this.rowAxis.dims || 1;
	
	    this.idValueMap = this.response.getIdMap(this.layout, 'value', 'idValueMap');
	
	    if (this.options.trueTotals) {
	        this.idFactorMap = this.response.getIdMap(this.layout, 'factor', 'idFactorMap');
	        this.idNumeratorMap = this.response.getIdMap(this.layout, 'numerator', 'idNumeratorMap');
	        this.idDenominatorMap = this.response.getIdMap(this.layout, 'denominator', 'idDenominatorMap');
	    } else {
	        this.idFactorMap = {};
	        this.idNumeratorMap = {};
	        this.idDenominatorMap = {};
	    }
	
	    this.colUniqueFactor = (0, _PivotTableUtils.getUniqueFactor)(this.colAxis);
	    this.rowUniqueFactor = (0, _PivotTableUtils.getUniqueFactor)(this.rowAxis);
	
	    this.columnDimensionNames = this.colAxis.type ? this.layout.columns.getDimensionNames(this.response) : [];
	    this.rowDimensionNames = this.rowAxis.type ? this.layout.rows.getDimensionNames(this.response) : [];
	
	    // size size of table
	    this.rowSize = this.getRowSize();
	
	    // size of column axis not including corner axis
	    this.columnSize = this.getColumnSize();
	
	    // size of row axis not including corner axis
	    this.tableSize = this.getTableSize();
	
	    // lookup for changed column spans (used to calculate new spans when rows/columns are hidden).
	    this.rowAxisSpanMap = this.createRowSpanMap();
	    this.columnAxisSpanMap = this.createColumnSpanMap();
	
	    // lookup for values
	    this.valueLookup = {};
	    this.rowTotalLookup = (0, _PivotTableUtils.defaultProxyGenerator)(0);
	    this.columnTotalLookup = (0, _PivotTableUtils.defaultProxyGenerator)(0);
	
	    // initialize lookup tables
	    this.initializeLookups();
	
	    // lookup for rows/columns to render (used to determine what rows/columns are hidden).
	    if (this.doHideEmptyRows()) {
	        this.rowAxisLookup = this.createRowRenderMap();
	    }
	
	    if (this.doHideEmptyColumns()) {
	        this.columnAxisLookup = this.createColumnRenderMap();
	    }
	};
	
	// setters
	/**
	 * Sets the cell width of each cell in the  table.
	 * 
	 * @param {number} width The width of each cell in pixels
	 */
	PivotTable.prototype.setCellWidth = function (width) {
	    this.cellWidth = width;
	};
	
	/**
	 * Sets the cell height of each cell in the table.
	 * 
	 * @param {number} height The height of each cell in pixels
	 */
	PivotTable.prototype.setCellHeight = function (height) {
	    this.cellHeight = height;
	};
	
	/**
	 * Sets the width of the viewport used to render the table.
	 * 
	 * @param {number} width The width of the viewport in pixels
	 */
	PivotTable.prototype.setViewportWidth = function (width) {
	    this.viewportWidth = width;
	};
	
	/**
	 * Sets the height of the viewport used to render the table.
	 * 
	 * @param {number} height The height of the viewport in pixels
	 */
	PivotTable.prototype.setViewportHeight = function (height) {
	    this.viewportHeight = height;
	};
	
	/**
	 * Sets the index of where the table will start rendering columns.
	 * 
	 * @param {number} columnIndex The index of the column to render
	 */
	PivotTable.prototype.setColumnStart = function (columnIndex) {
	    this.columnStart = Math.max(0, columnIndex);
	};
	
	/**
	 * Sets the index of where the table will start rendering rows.
	 * 
	 * @param {number} rowIndex The index of the row to render
	 */
	PivotTable.prototype.setRowStart = function (rowIndex) {
	    this.rowStart = Math.max(0, rowIndex);
	};
	
	/**
	 * Sets the index of where the table will end rendering columns.
	 * 
	 * @param {number} columnIndex The index of the column to render
	 */
	PivotTable.prototype.setColumnEnd = function (columnIndex) {
	    this.columnEnd = this.constrainWidth(Math.min(this.columnSize + this.rowDimensionSize - 1, columnIndex));
	};
	
	/**
	 * Sets the index of where the table will end rendering rows.
	 * 
	 * @param {number} rowIndex The index of the row to render
	 */
	PivotTable.prototype.setRowEnd = function (rowIndex) {
	    this.rowEnd = this.constrainHeight(Math.min(this.rowSize + this.columnDimensionSize - 1, rowIndex));
	};
	
	/**
	 * Sets the index of where the table will start rendering columns and calculates and sets
	 * the index of where the table will stop rendering columns based on the start index and
	 * width of the viewport.
	 * 
	 * @param {number} columnStartIndex The index of the column to render
	 */
	PivotTable.prototype.setColumnStartAndEnd = function (columnStartIndex) {
	    this.setColumnStart(columnStartIndex);
	    this.columnEnd = this.getColumnEnd(columnStartIndex);
	};
	
	/**
	 * Sets the index of where the table will start rendering rows and calculates and sets
	 * the index of where the table will stop rendering rows based on the start index and
	 * height of the viewport.
	 * 
	 * @param {number} rowStartIndex The index of the row to render
	 */
	PivotTable.prototype.setRowStartAndEnd = function (rowStartIndex) {
	    this.setRowStart(rowStartIndex);
	    this.rowEnd = this.getRowEnd(rowStartIndex);
	};
	
	/**
	 * Sets the size of the viewport and rebuilds the table.
	 * 
	 * @param {number} [width=0] 
	 * @param {number} [height=0] 
	 */
	PivotTable.prototype.setViewportSize = function () {
	    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    this.setViewportWidth(width);
	    this.setViewportHeight(height);
	};
	
	// options
	/**
	 * Checks the size of the table compared to the render limit set by options.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doRender = function () {
	    return this.rowAxis.size * this.colAxis.size > this.options.renderLimit;
	};
	
	/**
	 * Checks if show total columns option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doColTotals = function () {
	    return this.options.showColTotals && !!this.rowAxis.size;
	};
	
	/**
	 * Checks if show total rows option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doRowTotals = function () {
	    return this.options.showRowTotals && !!this.colAxis.size;
	};
	
	/**
	 * Checks if show sub total columns option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doColSubTotals = function () {
	    return this.options.showColSubTotals && this.rowAxis.type && this.rowDimensionSize > 1;
	};
	
	/**
	 * Checks if show sub total rows option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doRowSubTotals = function () {
	    return this.options.showRowSubTotals && this.colAxis.type && this.columnDimensionSize > 1;
	};
	
	/**
	 * Checks if column percentage option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doColPercentage = function () {
	    return this.options.numberType === this.optionConfig.getNumberType().percentofcolumn.id;
	};
	
	/**
	 * Checks if row percentage option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doRowPercentage = function () {
	    return this.options.numberType === this.optionConfig.getNumberType().percentofrow.id;
	};
	
	/**
	 * Checks if sortable column headers option is enabled.
	 * 
	 * @returns 
	 */
	PivotTable.prototype.doSortableColumnHeaders = function () {
	    return this.rowAxis.type && this.rowDimensionSize === 1;
	};
	
	/**
	 * Checks if hide empty columns option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doHideEmptyRows = function () {
	    return this.options.hideEmptyRows && this.colAxis.type && this.rowAxis.type;
	};
	
	/**
	 * Checks if hide empty rows option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doHideEmptyColumns = function () {
	    return this.options.hideEmptyColumns && this.colAxis.type && this.rowAxis.type;
	};
	
	/**
	 * Checks if show dimension labels option is enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doShowDimensionLabels = function () {
	    return this.options.showDimensionLabels;
	};
	
	/**
	 * Checks if dynamic table rendering option should be enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doDynamicRendering = function () {
	    return this.doRender() || this.options.forceDynamic;
	};
	
	/**
	 * Checks if sticky columns option should be enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doStickyColumns = function () {
	    return this.options.stickyColumnDimension;
	};
	
	/**
	 * Checks if sticky rows option should be enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doStickyRows = function () {
	    return this.options.stickyRowDimension;
	};
	
	/**
	 * Checks if show hierarchy option should be enabled.
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doShowHierarchy = function () {
	    return this.options.showHierarchy;
	};
	
	/**
	 * Checks if legend display by data item option is enabled
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doLegendDisplayByDataItem = function () {
	    return this.legendDisplayStrategy === this.getLegendDisplayStrategyId('by_data_item');
	};
	
	/**
	 * Checks if legend display option is enbalied
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doLegendDisplay = function () {
	    return this.legendDisplayStrategy !== this.getLegendDisplayStrategyId('fixed');
	};
	
	/**
	 * Checks if legend display style fill option is enabled
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doLegendDisplayStyleFill = function () {
	    return this.legendDisplayStyle === this.getLegendDisplayStyleId('fill');
	};
	
	/**
	 * Checks if legend display style text option is enabled
	 * 
	 * @returns {boolean}
	 */
	PivotTable.prototype.doLegendDisplayStyleText = function () {
	    return this.legendDisplayStyle === this.getLegendDisplayStyleId('text');
	};
	
	// checkers
	/**
	 * Checks if column located at given column index is a sub total column.
	 * 
	 * @param {number} columnIndex index of column to be checked
	 * @returns {boolean}
	 */
	PivotTable.prototype.isColumnSubTotal = function (columnIndex) {
	    return this.doRowSubTotals() && (columnIndex + 1) % (this.colUniqueFactor + 1) === 0;
	};
	
	/**
	 * Checks if column located at given column index is a total column.
	 * 
	 * @param {number} columnIndex index of column to be checked
	 * @returns {boolean}
	 */
	PivotTable.prototype.isColumnGrandTotal = function (columnIndex) {
	    return this.doRowTotals() && columnIndex === this.getColumnSize() - 1;
	};
	
	/**
	 * Checks if row located at given row index is a sub total row.
	 * 
	 * @param {number} rowIndex index of column to be checked
	 * @returns {boolean}
	 */
	PivotTable.prototype.isRowSubTotal = function (rowIndex) {
	    return this.doColSubTotals() && (rowIndex + 1) % (this.rowUniqueFactor + 1) === 0;
	};
	
	/**
	 * Checks if row located at given row index is a sub total row.
	 * 
	 * @param {number} rowIndex index of row to be checked
	 * @returns {boolean}
	 */
	PivotTable.prototype.isRowGrandTotal = function (rowIndex) {
	    return this.doColTotals() && rowIndex === this.rowSize - 1;
	};
	
	/**
	 * Checks if row located at row index is empty.
	 * 
	 * @param {number} rowIndex 
	 * @returns {boolean}
	 */
	PivotTable.prototype.isRowEmpty = function (rowIndex) {
	    return this.rowTotalLookup[rowIndex] <= 0;
	};
	
	/**
	 * Checks if column located at column index is empty.
	 * 
	 * @param {number} columnIndex 
	 * @returns {boolean}
	 */
	PivotTable.prototype.isColumnEmpty = function (columnIndex) {
	    return this.columnTotalLookup[columnIndex] <= 0;
	};
	
	/**
	 * Checks if row located at row index is part of column axis.
	 * 
	 * @param {number} columnIndex 
	 * @returns {boolean}
	 */
	PivotTable.prototype.isColumnDimensionRow = function (rowIndex) {
	    return rowIndex < this.columnDimensionSize;
	};
	
	/**
	 * Checks if column located at column index is part of row axis.
	 * 
	 * @param {number} columnIndex 
	 * @returns {boolean}
	 */
	PivotTable.prototype.isRowDimensionColumn = function (columnIndex) {
	    return columnIndex < this.rowDimensionSize;
	};
	
	/**
	 * Checks if given cell is of type text field.
	 * 
	 * @param {string} type 
	 * @returns 
	 */
	PivotTable.prototype.isTextField = function (type) {
	    return !(0, _arrayContains2.default)(['dimension', 'filter'], type);
	};
	
	// getters
	PivotTable.prototype.getBaseCellStyling = function (cell) {
	    if (this.doDynamicRendering()) {
	        return '\n            min-width:' + cell.width + 'px!important;\n            min-height:' + cell.height + 'px!important;\n            max-width:' + cell.width + 'px!important;\n            max-height:' + cell.height + 'px!important;\n            width:' + cell.width + 'px!important;\n            height:' + cell.height + 'px!important;\n            white-space: nowrap!important;\n            overflow: hidden!important;\n            text-overflow: ellipsis!important;\n        ';
	    }
	    return '';
	};
	
	PivotTable.prototype.getColumnIndexWithHidden = function (columnIndex) {
	
	    if (this.doHideEmptyColumns()) {
	        return this.columnAxisLookup[columnIndex];
	    }
	
	    return columnIndex;
	};
	
	PivotTable.prototype.getRowIndexWithHidden = function (rowIndex) {
	
	    if (this.doHideEmptyRows()) {
	        return this.rowAxisLookup[rowIndex];
	    }
	
	    return rowIndex;
	};
	
	/**
	 * Get width of value table (table without axis).
	 * 
	 * @returns 
	 */
	PivotTable.prototype.getValueTableWidth = function () {
	    return Object.keys(this.valueLookup[0]).length - 1;
	};
	/**
	 * Get height of value table (table without axis).
	 * 
	 * @returns 
	 */
	PivotTable.prototype.getValueTableHeigth = function () {
	    return Object.keys(this.valueLookup).length - 1;
	};
	
	// TODO: REMOVE
	PivotTable.prototype.getAdjustedAxisSpan = function (cell, index, axisType, spanType) {
	    if (cell.children) {
	        return cell.oldestSibling.children * this[axisType].span[index + 1] - cell.siblingPosition;
	    }
	
	    return cell[spanType];
	};
	
	PivotTable.prototype.getAdjustedColSpan = function (cell, rowIndex) {
	    return this.getAdjustedAxisSpan(cell, rowIndex, 'colAxis', 'colSpan');
	};
	
	PivotTable.prototype.getAdjustedRowSpan = function (cell, columnIndex) {
	    return this.getAdjustedAxisSpan(cell, columnIndex, 'rowAxis', 'rowSpan');
	};
	
	/**
	 * Gets the row index of where the value table starts relative to the
	 * current state of the table.
	 * Mostly used to offset the row index to skip over column
	 * axis dimensions.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getValueRowStartOffset = function () {
	    return Math.max(0, this.columnDimensionSize - this.rowStart);
	};
	
	/**
	 * Gets the column index of where the value table starts relative to the
	 * current state of the table.
	 * Mostly used to offset the column index to skip over row
	 * axis dimensions.
	 * @returns {number}
	 */
	PivotTable.prototype.getValueColumnStartOffset = function () {
	    return Math.max(0, this.rowDimensionSize - this.columnStart);
	};
	
	/**
	 * Gets the amount of offset needed to get to row values,
	 * this is used to get values out of the value lookup table.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getValueOffsetRow = function () {
	    return Math.max(0, this.rowStart - this.columnDimensionSize);
	};
	
	/**
	 * Gets the amount of offset needed to get to column values,
	 * this is used to get values out of the value lookup table.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getValueOffsetColumn = function () {
	    return Math.max(0, this.columnStart - this.rowDimensionSize);
	};
	
	/**
	 * Gets the row span of a given dimension based on the current
	 * state of the table.
	 * 
	 * @param {number} rowIndex index of row axis
	 * @param {number} dimensionIndex dimension of row axis
	 * @returns {number}
	 */
	PivotTable.prototype.getRowAxisSpan = function (rowIndex, dimensionIndex) {
	    return this.rowAxisSpanMap[dimensionIndex][Math.floor(rowIndex / this.rowAxis.span[dimensionIndex])];
	};
	
	/**
	 * Gets normalized row index offset by hidden rows based on the current
	 * state of the table.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.normalizeRowIndexOffset = function (rowIndex, dimensionIndex) {
	    if (this.doColSubTotals()) {
	        return rowIndex - Math.floor(this.getRowIndexWithHidden(rowIndex) / (this.rowUniqueFactor + 1));
	    }
	    return rowIndex;
	};
	
	/**
	 * Gets the distance from last row axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceFromLastRowDimensionUnitActual = function (rowIndex, dimensionIndex) {
	    var normalized = this.normalizeRowIndex(this.getRowIndexWithHidden(rowIndex));
	    return this.normalizeRowIndexOffset(rowIndex) - (this.sumRowAxisSpanUpToIndex(normalized, dimensionIndex) - this.getRowAxisSpan(normalized, dimensionIndex));
	};
	
	/**
	 * Gets distance from last row axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceFromLastRowDimensionUnitOffset = function (rowIndex, dimensionIndex) {
	    var normalized = this.normalizeRowIndex(this.getRowIndexWithHidden(rowIndex));
	    return normalized % this.rowAxis.span[dimensionIndex];
	};
	
	/**
	 * Gets distance to next row axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceToNextRowDimensionUnitActual = function (rowIndex, dimensionIndex) {
	    var normalized = this.normalizeRowIndex(this.getRowIndexWithHidden(rowIndex));
	    return this.getRowAxisSpan(normalized, dimensionIndex) - (this.normalizeRowIndexOffset(rowIndex) - (this.sumRowAxisSpanUpToIndex(normalized, dimensionIndex) - this.getRowAxisSpan(normalized, dimensionIndex)));
	};
	
	/**
	 * Gets distance to next row axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceToNextRowDimensionUnitOffset = function (rowIndex, dimensionIndex) {
	    var normalized = this.normalizeRowIndex(this.getRowIndexWithHidden(rowIndex));
	    return this.rowAxis.span[dimensionIndex] - normalized % this.rowAxis.span[dimensionIndex];
	};
	
	/**
	 * Gets number of hidden rows above given row index up to start of current
	 * dimension unit.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getHiddenRowsAbove = function (rowIndex, dimensionIndex) {
	    return this.getDistanceFromLastRowDimensionUnitOffset(rowIndex, dimensionIndex) - this.getDistanceFromLastRowDimensionUnitActual(rowIndex, dimensionIndex);
	};
	
	/**
	 * Gets number of hidden rows below given row index up to end of current
	 * dimension unit.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getHiddenRowsBelow = function (rowIndex, dimensionIndex) {
	    return this.getDistanceToNextRowDimensionUnitOffset(rowIndex, dimensionIndex) - this.getDistanceToNextRowDimensionUnitActual(rowIndex, dimensionIndex);
	};
	
	/**
	 * Gets updated row dimension span based on given parameters.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getUpdatedRowSpan = function (rowIndex, dimensionIndex) {
	    return this.rowAxis.span[dimensionIndex] - this.getHiddenRowsAbove(rowIndex, dimensionIndex) - this.getHiddenRowsBelow(rowIndex, dimensionIndex) - this.getDistanceFromLastRowDimensionUnitActual(rowIndex, dimensionIndex);
	};
	
	/**
	 * Gets normalized row index offset by hidden columns.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.normalizeColumnIndexOffset = function (columnIndex, dimensionIndex) {
	    if (this.doRowSubTotals()) {
	        return columnIndex - Math.floor(this.getColumnIndexWithHidden(columnIndex) / (this.colUniqueFactor + 1));
	    }
	    return columnIndex;
	};
	/**
	 * Gets the distance from last column axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceFromLastColumnDimensionUnitActual = function (columnIndex, dimensionIndex) {
	    var normalized = this.normalizeColumnIndex(this.getColumnIndexWithHidden(columnIndex));
	    return this.normalizeColumnIndexOffset(columnIndex) - (this.sumColumnAxisSpanUpToIndex(normalized, dimensionIndex) - this.getColumnAxisSpan(normalized, dimensionIndex));
	};
	
	/**
	 * Gets distance from last column axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceFromLastColumnDimensionUnitOffset = function (columnIndex, dimensionIndex) {
	    var normalized = this.normalizeColumnIndex(this.getColumnIndexWithHidden(columnIndex));
	    return normalized % this.colAxis.span[dimensionIndex];
	};
	
	/**
	 * Gets the distance to next column axis dimension based on the current
	 * state of the table.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceToNextColumnDimensionUnitActual = function (columnIndex, dimensionIndex) {
	    var normalized = this.normalizeColumnIndex(this.getColumnIndexWithHidden(columnIndex));
	    return this.getColumnAxisSpan(normalized, dimensionIndex) - (this.normalizeColumnIndexOffset(columnIndex) - (this.sumColumnAxisSpanUpToIndex(normalized, dimensionIndex) - this.getColumnAxisSpan(normalized, dimensionIndex)));
	};
	
	/**
	 * Gets distance to next column axis dimension unit based on the current
	 * state of the table.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getDistanceToNextColumnDimensionUnitOffset = function (columnIndex, dimensionIndex) {
	    var normalized = this.normalizeColumnIndex(this.getColumnIndexWithHidden(columnIndex));
	    return this.colAxis.span[dimensionIndex] - normalized % this.colAxis.span[dimensionIndex];
	};
	
	/**
	 * Gets number of hidden columns to the left of given column index up to start of 
	 * current dimension unit.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getHiddenColumnsLeft = function (columnIndex, dimensionIndex) {
	    return this.getDistanceFromLastColumnDimensionUnitOffset(columnIndex, dimensionIndex) - this.getDistanceFromLastColumnDimensionUnitActual(columnIndex, dimensionIndex);
	};
	
	/**
	 * Gets number of hidden columns to the right of given column index up to end of 
	 * current dimension unit.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getHiddenColumnsRight = function (columnIndex, dimensionIndex) {
	    return this.getDistanceToNextColumnDimensionUnitOffset(columnIndex, dimensionIndex) - this.getDistanceToNextColumnDimensionUnitActual(columnIndex, dimensionIndex);
	};
	
	/**
	 * Gets updated column axis span based on given parameters.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getUpdatedColumnSpan = function (columnIndex, dimensionIndex) {
	    return this.colAxis.span[dimensionIndex] - this.getHiddenColumnsLeft(columnIndex, dimensionIndex) - this.getHiddenColumnsRight(columnIndex, dimensionIndex) - this.getDistanceFromLastColumnDimensionUnitActual(columnIndex, dimensionIndex);
	};
	
	/**
	 * Sums the column axis spans up to given column index.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.sumColumnAxisSpanUpToIndex = function (columnIndex, dimensionIndex) {
	    var sum = 0;
	    for (var i = 0; i < Math.floor(columnIndex / this.colAxis.span[dimensionIndex]) + 1; i++) {
	        sum += this.columnAxisSpanMap[dimensionIndex][i];
	    }
	    return sum;
	};
	
	/**
	 * Sums the row axis spans up to given row index.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} dimensionIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.sumRowAxisSpanUpToIndex = function (rowIndex, dimensionIndex) {
	    var sum = 0;
	    for (var i = 0; i < Math.floor(rowIndex / this.rowAxis.span[dimensionIndex]) + 1; i++) {
	        sum += this.rowAxisSpanMap[dimensionIndex][i];
	    }
	    return sum;
	};
	
	/**
	 * Gets the column span of a given dimension.
	 * 
	 * @param {number} columnIndex index of column axis
	 * @param {number} dimensionIndex dimension of column axis
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnAxisSpan = function (columnIndex, dimensionIndex) {
	    return this.columnAxisSpanMap[dimensionIndex][Math.floor(columnIndex / this.colAxis.span[dimensionIndex])];
	};
	
	/**
	 * Calculates true total values.
	 * 
	 * @param {number} numerator 
	 * @param {number} denominator 
	 * @param {number} factor 
	 * @returns 
	 */
	PivotTable.prototype.getTrueTotal = function (numerator, denominator, factor) {
	    return numerator * factor / denominator;
	};
	
	/**
	 * Gets record names.
	 * 
	 * @returns {array}
	 */
	PivotTable.prototype.getRecordNames = function () {
	    return this.filters.getRecordNames(false, this.response, true);
	};
	
	/**
	 * Gets the row axis object at given column/row index.
	 * 
	 * @param {number} columnIndex column index of axis object
	 * @param {number} rowIndex row index of axis object
	 * @returns {object}
	 */
	PivotTable.prototype.getRowAxisObject = function (columnIndex, rowIndex) {
	    return this.rowAxis.objects.all[columnIndex][rowIndex];
	};
	
	/**
	 * Gets the column axis object at given column/row index.
	 * 
	 * @param {number} rowIndex row index of axis object
	 * @param {number} columnIndex column index of axis object
	 * @returns {object}
	 */
	PivotTable.prototype.getColumnAxisObject = function (rowIndex, columnIndex) {
	    return this.colAxis.objects.all[rowIndex][columnIndex];
	};
	
	/**
	 * Gets the total of the row at given row index.
	 * 
	 * @param {number} rowIndex index of row to find total
	 * @returns {number}
	 */
	PivotTable.prototype.getRowTotal = function (rowIndex) {
	    return this.rowTotalLookup[rowIndex];
	};
	
	/**
	 * Gets the total of the column at given column index.
	 * 
	 * @param {number} columnIndex index of column to find total
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnTotal = function (columnIndex) {
	    return this.columnTotalLookup[columnIndex];
	};
	
	/**
	 * Gets the html value of a table cell.
	 * 
	 * @param {object} cell 
	 * @returns {string}
	 */
	PivotTable.prototype.getHtmlValue = function (cell) {
	    if (cell.collapsed) {
	        return '';
	    }
	
	    return this.isTextField(cell.type) ? this.getPrettyHtml(cell.htmlValue) : cell.htmlValue;
	};
	
	/**
	 * gets pretty print of given string.
	 * 
	 * @param {string} htmlValue 
	 * @returns {string}
	 */
	PivotTable.prototype.getPrettyHtml = function (htmlValue) {
	    return this.optionConfig.prettyPrint(htmlValue, this.digitGroupSeparator);
	};
	
	/**
	 * Gets legend display strategy id.
	 * 
	 * @param {string} type 
	 * @returns {number}
	 */
	PivotTable.prototype.getLegendDisplayStrategyId = function (type) {
	    return this.optionConfig.getLegendDisplayStrategy(type).id;
	};
	
	/**
	 * Gets legend display style id.
	 * 
	 * @param {string} type 
	 * @returns {number}
	 */
	PivotTable.prototype.getLegendDisplayStyleId = function (type) {
	    return this.optionConfig.getLegendDisplayStyle(type).id;
	};
	
	/**
	 * Gets the next total column index.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getNextTotalColumnIndex = function () {
	
	    if (!this.doRowTotals()) {
	        return this.columnSize;
	    }
	
	    return this.columnSize - 1;
	};
	
	/**
	 * Gets the next total row index.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getNextTotalRowIndex = function () {
	
	    if (!this.doColTotals()) {
	        return this.rowSize;
	    }
	
	    return this.rowSize - 1;
	};
	
	/**
	 * Gets the width of the viewport used to render the table.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getViewportWidth = function () {
	    return this.viewportWidth;
	};
	
	/**
	 *  Gets the height of the viewport used to render the table.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getViewportHeight = function () {
	    return this.viewportHeight;
	};
	
	/**
	 * Gets the number of cells that can be rendered horizontally within the viewport
	 * with offset for additional cells.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getViewportWidthIndex = function () {
	    return Math.floor(this.viewportWidth / this.cellWidth) + this.renderOffset;
	};
	
	/**
	 * Gets the number of cells that can be rendered vertically within the viewport
	 * with offset for additional cells.
	 * @returns {number}
	 */
	PivotTable.prototype.getViewportHeightIndex = function () {
	    return Math.floor(this.viewportHeight / this.cellHeight) + this.renderOffset;
	};
	
	/**
	 * Gets the height of the entire table in number of cells
	 * including total and sub total rows.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getRowAxisSize = function () {
	    return this.rowSize + this.columnDimensionSize - 1;
	};
	
	/**
	 * Gets the width of the entire table in number of cells
	 * including total and sub total columns.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnAxisSize = function () {
	    return this.columnSize + this.rowDimensionSize - 1;
	};
	
	/**
	 * Gets the number of row axis dimensions.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getRowDimensionSize = function () {
	    return this.rowDimensionSize || 0;
	};
	
	/**
	 * Gets the number of column axis dimensions.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnDimensionSize = function () {
	    return this.columnDimensionSize || 0;
	};
	
	/**
	 * Gets the amount of padding needed to finish the unrendered 
	 * top of the table. Padding is returned in number of pixels.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getTopPadding = function () {
	    var padding = this.rowStart * this.cellHeight;
	
	    if (!this.options.skipTitle && this.rowStart > 0) {
	        padding += this.cellHeight;
	    }
	
	    return padding;
	};
	
	/**
	 * Gets the amount of padding needed to finish the unrendered 
	 * left of the table. Padding is returned in number of pixels.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getLeftPadding = function () {
	    return this.columnStart * this.cellWidth;
	};
	
	/**
	 * Gets the amount of padding needed to finish the unrendered 
	 * right of the table. Padding is returned in number of pixels.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getBottomPadding = function () {
	    return (this.rowSize - this.rowEnd - this.numberOfEmptyRows) * this.cellHeight;
	};
	
	/**
	 * Gets the amount of padding needed to finish the unrendered 
	 * bottom of the table. Padding is returned in number of pixels.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getRightPadding = function () {
	    return (this.columnSize - this.columnEnd - this.numberOfEmptyColumns) * this.cellWidth;
	};
	
	/**
	 * Gets the legend set id.
	 * 
	 * @param {string} dxId 
	 * @returns {string}
	 */
	PivotTable.prototype.getLegendSetId = function (dxId) {
	    return this.response.metaData.items[dxId].legendSet;
	};
	
	/**
	 * Gets a value object used to calcualte correct totals
	 * and fill up the value lookup table.
	 * 
	 * @param {number} rowIndex row index of value
	 * @param {number} columnIndex column index of value
	 * @returns {object}
	 */
	PivotTable.prototype.getValueObject = function (rowIndex, columnIndex) {
	    var id = this.getRRIC(rowIndex, columnIndex).get();
	
	    var value = this.getValue(id),
	        empty = value === null;
	
	    return {
	        empty: empty,
	        value: empty ? 0 : value,
	        numerator: this.getNumeratorValue(id),
	        denominator: this.getDenominatorValue(id),
	        factor: this.getFactorValue(id)
	    };
	};
	
	/**
	 * Gets value id value map.
	 * 
	 * @param {string} id 
	 * @returns {number}
	 */
	PivotTable.prototype.getValue = function (id) {
	
	    var value = this.idValueMap[id],
	        n = parseFloat(value);
	
	    if ((0, _isBoolean2.default)(value)) {
	        return 1;
	    }
	
	    if (!(0, _isNumber2.default)(n) || n != value) {
	        return null;
	    }
	
	    return n;
	};
	/**
	 * Gets factor value from id factor map
	 * 
	 * @param {string} id 
	 * @returns {number}
	 */
	PivotTable.prototype.getFactorValue = function (id) {
	    return parseFloat(this.idFactorMap[id]) || 1;
	};
	/**
	 * Gets numerator value from id numerator map
	 * 
	 * @param {string} id 
	 * @returns {number}
	 */
	PivotTable.prototype.getNumeratorValue = function (id) {
	    return parseFloat(this.idNumeratorMap[id]) || this.getValue(id);
	};
	/**
	 * Gets denominator value from id denominator map
	 * 
	 * @param {string} id 
	 * @returns {number}
	 */
	PivotTable.prototype.getDenominatorValue = function (id) {
	    return parseFloat(this.idDenominatorMap[id]) || 0;
	};
	
	/**
	 * Gets number of rows in table in number of cells.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getRowSize = function () {
	
	    var size = this.rowAxis.size;
	
	    if (!size) {
	        size = 1;
	        return size;
	    }
	
	    if (this.doColSubTotals()) {
	        size += this.rowAxis.size / this.rowUniqueFactor;
	    }
	
	    if (this.doColTotals()) {
	        size += 1;
	    }
	
	    return size;
	};
	/**
	 * Gets number of columns in table in number of cells.
	 * 
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnSize = function () {
	
	    var size = this.colAxis.size;
	
	    if (!size) {
	        size = 1;
	        return size;
	    }
	
	    if (this.doRowSubTotals()) {
	        size += this.colAxis.size / this.colUniqueFactor;
	    }
	
	    if (this.doRowTotals()) {
	        size += 1;
	    }
	
	    return size;
	};
	
	/**
	 * Gets the size of the entire table in number of cells.
	 * 
	 * @returns {nubmer}
	 */
	PivotTable.prototype.getTableSize = function () {
	    return this.rowSize * this.columnSize;
	};
	
	/**
	 * Gets the next sub column index from given column index.
	 * 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getNextSubColumnIndex = function (columnIndex) {
	    return columnIndex + Math.floor(columnIndex / this.colUniqueFactor) + (this.colUniqueFactor - columnIndex % this.colUniqueFactor);
	};
	
	/**
	 * Gets the next sub row index from given row index.
	 * 
	 * @param {number} rowIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getNextSubRowIndex = function (rowIndex) {
	    return rowIndex + Math.floor(rowIndex / this.rowUniqueFactor) + (this.rowUniqueFactor - rowIndex % this.rowUniqueFactor);
	};
	
	/**
	 * Gets uuids object map.
	 * 
	 * @returns {object}
	 */
	PivotTable.prototype.getUuidObjectMap = function () {
	    return (0, _objectApplyIf2.default)(this.colAxis ? this.colAxis.uuidObjectMap || {} : {}, this.rowAxis ? this.rowAxis.uuidObjectMap || {} : {});
	};
	
	/**
	 * Gets the index of the last cell to be rendered in column.
	 * 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnEnd = function (columnIndex) {
	    if (this.doDynamicRendering()) {
	        return this.constrainWidth(this.getViewportWidthIndex() + columnIndex);
	    }
	    return this.getColumnAxisSize() - this.numberOfEmptyColumns;
	};
	
	/**
	 * Gets the index of the last cell to be rendered in row.
	 * 
	 * @param {number}
	 * @returns {number}
	 */
	PivotTable.prototype.getRowEnd = function (rowIndex) {
	    if (this.doDynamicRendering()) {
	        return this.constrainHeight(this.getViewportHeightIndex() + rowIndex);
	    }
	    return this.getRowAxisSize() - this.numberOfEmptyRows;
	};
	
	/**
	 * Gets the row sort id
	 * 
	 * @param {number} rowIndex 
	 * @returns {string}
	 */
	PivotTable.prototype.getRowSortId = function (rowIndex) {
	    if (this.doSortableColumnHeaders() && rowIndex === this.columnDimensionSize - 1) {
	        return this.colAxis.ids[rowIndex];
	    }
	    return null;
	};
	
	/**
	 * Gets the label for the column axis at given index.
	 * 
	 * @param {number} index 
	 * @returns {string}
	 */
	PivotTable.prototype.getColumnAxisLabel = function (index) {
	    if (this.columnDimensionSize) {
	        return this.response.getNameById(this.columnDimensionNames[index]);
	    }
	    return null;
	};
	
	/**
	 * Gets the dimension label for the row axis at given index
	 * 
	 * @param {number} index 
	 * @returns {string}
	 */
	PivotTable.prototype.getRowAxisLabel = function (index) {
	    if (this.rowDimensionSize) {
	        return this.response.getNameById(this.rowDimensionNames[index]);
	    }
	    return null;
	};
	
	/**
	 * Gets the dimension label for the shared column/row.
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.getCrossAxisLabel = function () {
	    var colAxisLabel = this.getColumnAxisLabel(this.columnDimensionSize - 1),
	        rowAxisLabel = this.getRowAxisLabel(this.rowDimensionSize - 1);
	
	    if (!this.rowAxis.type) {
	        return colAxisLabel;
	    }
	
	    if (!this.colAxis.type) {
	        return rowAxisLabel;
	    }
	
	    if (colAxisLabel) {
	        rowAxisLabel += '&nbsp;/&nbsp;' + colAxisLabel;
	    }
	
	    return rowAxisLabel;
	};
	
	/**
	 * Gets the span for the top title bar.
	 * 
	 * @param {number} span 
	 * @returns {number}
	 */
	PivotTable.prototype.getTopBarSpan = function (span) {
	    var rowDims = this.rowDimensionSize || 0;
	
	    if (!this.colAxis.type && this.rowAxis.type) {
	        return rowDims + 1;
	    }
	
	    return span;
	};
	
	/**
	 * Retrueves the ResponseRowIdCombination for given row and column index pair.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getRRIC = function (rowIndex, columnIndex) {
	    var rric = new _ResponseRowIdCombination.ResponseRowIdCombination();
	
	    if (this.colAxis.type) rric.add(this.colAxis.ids[columnIndex]);
	    if (this.rowAxis.type) rric.add(this.rowAxis.ids[rowIndex]);
	
	    return rric;
	};
	
	/**
	 * Gets associated uuids for given row and column index pair.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getCellUuids = function (rowIndex, columnIndex) {
	    var uuids = [];
	
	    if (this.colAxis.type) {
	        uuids = uuids.concat(this.colAxis.objects.all[this.colAxis.dims - 1][rowIndex].uuids);
	    }
	
	    if (this.rowAxis.type) {
	        uuids = uuids.concat(this.rowAxis.objects.all[this.rowAxis.dims - 1][columnIndex].uuids);
	    }
	
	    return uuids;
	};
	
	/**
	 * Gets percentage of value based on given row index.
	 * 
	 * @param {number} value 
	 * @param {number} rowIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getRowPercentage = function (value, rowIndex) {
	    return (0, _PivotTableUtils.getPercentageHtml)(value, this.getRowTotal(rowIndex));
	};
	/**
	 * Gets percentage of value based on given column index.
	 * 
	 * @param {number} value 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.getColumnPercentage = function (value, columnIndex) {
	    return (0, _PivotTableUtils.getPercentageHtml)(value, this.getColumnTotal(columnIndex));
	};
	
	// Table Modifiers
	/**
	 * Adds a column to the right side of the table.
	 * 
	 * @param {number} columnIndex index of column to render
	 * @param {number} rowStart index of the first row of the column
	 * @param {number} rowEnd  index of the last row of the column
	 */
	PivotTable.prototype.addRight = function (columnIndex, rowStart, rowEnd) {
	    var column = this.buildColumn(columnIndex, rowStart, rowEnd);
	    for (var i = 0; i < column.length; i++) {
	        this.table[i].push(column[i]);
	    }
	};
	
	/**
	 * Adds a column to the left side of the table.
	 * 
	 * @param {number} columnIndex index of column to render
	 * @param {number} rowStart index of the first row of the column
	 * @param {number} rowEnd index of the last row of the column
	 */
	PivotTable.prototype.addLeft = function (columnIndex, rowStart, rowEnd) {
	    var column = this.buildColumn(columnIndex, rowStart, rowEnd);
	    for (var i = 0; i < column.length; i++) {
	        this.table[i].unshift(column[i]);
	    }
	};
	
	/**
	 * Adds a row to the top side of the table.
	 * 
	 * @param {number} rowIndex index of row to render
	 * @param {number} columnStart index of the first column of the row
	 * @param {number} columnEnd index of the last column of the row
	 */
	PivotTable.prototype.addTop = function (rowIndex, columnStart, columnEnd) {
	    this.table.unshift(this.buildRow(rowIndex, columnStart, columnEnd));
	};
	
	/**
	 * Adds a row to the bottom side of the table.
	 * 
	 * @param {number} rowIndex index of row to render
	 * @param {number} columnStart index of the first column of the row
	 * @param {number} columnEnd index of the last column of the row
	 */
	PivotTable.prototype.addBottom = function (rowIndex, columnStart, columnEnd) {
	    this.table.push(this.buildRow(rowIndex, columnStart, columnEnd));
	};
	
	/**
	 * Removes a column from the left side of the table.
	 * 
	 */
	PivotTable.prototype.deleteLeft = function () {
	    for (var i = 0; i < this.table.length; i++) {
	        this.table[i].shift();
	    }
	};
	
	/**
	 * Removes a column from the right side of the table.
	 * 
	 */
	PivotTable.prototype.deleteRight = function () {
	    for (var i = 0; i < this.table.length; i++) {
	        this.table[i].pop();
	    }
	};
	
	/**
	 * Removes a column from the top side of the table.
	 * 
	 */
	PivotTable.prototype.deleteTop = function () {
	    this.table.shift();
	};
	
	/**
	 * Removes a column from the bottom side of the table.
	 * 
	 */
	PivotTable.prototype.deleteBottom = function () {
	    this.table.pop();
	};
	
	/**
	 * Removes row of given index from the table.
	 * 
	 * @param {number} rowIndex index of row to be removed
	 */
	PivotTable.prototype.deleteRow = function (rowIndex) {
	    this.table.splice(rowIndex, 1);
	};
	
	/**
	 * Removes column of given index from the table.
	 * 
	 * @param {number} columnIndex index of column to be removed
	 */
	PivotTable.prototype.deleteColumn = function (columnIndex) {
	    for (var i = 0; i < this.table.length; i++) {
	        this.table[i].splice(columnIndex, 1);
	    }
	};
	
	/**
	 * Builds a table row based on given parameters.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnStart 
	 * @param {number} columnEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildRow = function (rowIndex, columnStart, columnEnd) {
	    var rowAxisRow = [];
	
	    if (this.isColumnDimensionRow(rowIndex)) {
	        return this.buildColumnAxisRow(rowIndex, columnStart, columnEnd + 1); // TODO: why + 1?
	    }
	
	    rowIndex -= this.columnDimensionSize;
	
	    if (this.isRowDimensionColumn(columnStart)) {
	        rowAxisRow = this.buildRowAxisRow(rowIndex, columnStart);
	        columnStart = 0;
	    } else {
	        columnStart -= this.rowDimensionSize;
	    }
	
	    columnEnd -= this.rowDimensionSize - 1; // TODO: why - 1?
	
	    return rowAxisRow.concat(this.buildValueRow(rowIndex, columnStart, columnEnd));
	};
	
	/**
	 * Builds a table column based on given parameters
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowStart 
	 * @param {number} rowEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildColumn = function (columnIndex, rowStart, rowEnd) {
	    var columnAxis = this.buildColumnAxisColumn(columnIndex, rowStart);
	
	    if (this.isColumnDimensionRow(rowStart)) {
	        rowEnd -= columnAxis.length - 1; // TODO: why - 1?
	    } else {
	        rowStart -= this.columnDimensionSize;
	        rowEnd -= this.columnDimensionSize - 1; // TODO: why - 1?
	    }
	
	    if (this.isRowDimensionColumn(columnIndex)) {
	        return columnAxis.concat(this.buildRowAxisColumn(columnIndex, rowStart, rowEnd));
	    }
	
	    columnIndex -= this.rowDimensionSize;
	
	    return columnAxis.concat(this.buildValueColumn(columnIndex, rowStart, rowEnd));
	};
	
	/**
	 * Builds value portion of table row based on given parameters.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnStart 
	 * @param {number} columnEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildValueRow = function (rowIndex, columnStart, columnEnd) {
	    var row = [];
	
	    for (var i = 0, columnIndex = columnStart, cell; columnIndex < columnEnd; i++, columnIndex++) {
	        cell = this.buildValueCell(columnIndex, rowIndex);
	        if (cell) {
	            // TODO: Is this needed?
	            row[i] = cell;
	        }
	    }
	
	    return row;
	};
	
	/**
	 * Builds value portion of table column based on given parameters.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowStart 
	 * @param {number} rowEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildValueColumn = function (columnIndex, rowStart, rowEnd) {
	    var column = [];
	
	    for (var i = 0, rowIndex = rowStart; rowIndex < rowEnd; i++, rowIndex++) {
	        column[i] = this.buildValueCell(columnIndex, rowIndex);
	    }
	
	    return column;
	};
	
	/**
	 * Builds value cell based on row and column index pair.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowIndex 
	 * @returns {object}
	 */
	PivotTable.prototype.buildValueCell = function (columnIndex, rowIndex) {
	
	    rowIndex = this.getRowIndexWithHidden(rowIndex);
	    columnIndex = this.getColumnIndexWithHidden(columnIndex);
	
	    var value = this.valueLookup[rowIndex][columnIndex],
	        htmlValue = null;
	
	    if (this.doColPercentage()) {
	        htmlValue = this.getColumnPercentage(value, columnIndex);
	    }
	
	    if (this.doRowPercentage()) {
	        htmlValue = this.getRowPercentage(value, rowIndex);
	    }
	
	    if (this.isRowGrandTotal(rowIndex) || this.isColumnGrandTotal(columnIndex)) {
	        return (0, _PivotTableCells.ValueTotalCell)(value, htmlValue);
	    }
	
	    if (this.isColumnSubTotal(columnIndex) || this.isRowSubTotal(rowIndex)) {
	        return (0, _PivotTableCells.ValueSubTotalCell)(value, htmlValue);
	    }
	
	    if (value === null || typeof value === 'undefined') {
	        return (0, _PivotTableCells.PlainValueCell)(value);
	    }
	
	    rowIndex = this.normalizeRowIndex(rowIndex);
	    columnIndex = this.normalizeColumnIndex(columnIndex);
	
	    var cell = (0, _PivotTableCells.ValueCell)(value, this.response, this.getRRIC(rowIndex, columnIndex), this.getCellUuids(columnIndex, rowIndex), htmlValue);
	
	    this.uuidDimUuidsMap[cell.uuid] = cell.uuids;
	
	    return cell;
	};
	
	/**
	 * Builds row axis dimension based on given parameters.
	 * 
	 * @returns {array}
	 */
	PivotTable.prototype.buildRowAxis = function () {
	    var axis = [];
	
	    if (!this.rowAxis.type) {
	        if (this.doShowDimensionLabels()) {
	            axis[0] = [(0, _PivotTableCells.DimensionEmptyCell)(1, 1, false, 'visibility: hidden;')];
	        }
	        return axis;
	    }
	
	    for (var i = 0, rowIndex = this.rowStart; rowIndex <= this.rowEnd - this.columnDimensionSize; i++, rowIndex++) {
	        axis[i] = this.buildRowAxisRow(rowIndex, this.columnStart);
	    }
	
	    return axis;
	};
	
	/**
	 * Builds row axis dimension row based on given parameters.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnStart 
	 * @returns {array}
	 */
	PivotTable.prototype.buildRowAxisRow = function (rowIndex, columnStart) {
	    if (this.rowDimensionSize < columnStart) {
	        return [];
	    }
	
	    if (!this.rowAxis.type) {
	        return [(0, _PivotTableCells.DimensionEmptyCell)(1, 1, false, 'visibility: hidden;')];
	    }
	
	    var row = [];
	
	    for (var i = 0, columnIndex = columnStart; columnIndex < this.rowDimensionSize; i++, columnIndex++) {
	        row[i] = this.buildRowAxisCell(columnIndex, rowIndex);
	    }
	
	    return row;
	};
	
	/**
	 * Builds column axis dimension row based on given parameters.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnStart 
	 * @param {number} columnEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildColumnAxisRow = function (rowIndex, columnStart, columnEnd) {
	    if (this.columnDimensionSize < rowIndex) {
	        return [];
	    }
	
	    var row = [];
	
	    if (this.isRowDimensionColumn(columnStart)) {
	        _extends(row, this.buildCornerAxisRow(rowIndex, columnStart));
	    }
	
	    columnStart += row.length;
	
	    columnStart -= this.rowDimensionSize;
	    columnEnd -= this.rowDimensionSize;
	
	    for (var i = row.length; columnStart < columnEnd; i++, columnStart++) {
	        row[i] = this.buildColumnAxisCell(rowIndex, columnStart);
	    }
	
	    return row;
	};
	
	/**
	 * Builds row axis dimension column based on given parameters.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowStart 
	 * @param {number} rowEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildRowAxisColumn = function (columnIndex, rowStart, rowEnd) {
	
	    var column = [];
	
	    if (this.rowDimensionSize < columnIndex) {
	        return column;
	    }
	
	    if (!this.rowAxis.type) {
	        for (var i = 0; i < rowEnd - rowStart; i++) {
	            column[i] = (0, _PivotTableCells.DimensionEmptyCell)(1, 1, false, 'visibility: hidden;');
	        }
	        return column;
	    }
	
	    for (var _i = 0, rowIndex = rowStart; rowIndex < rowEnd; _i++, rowIndex++) {
	        column[_i] = this.buildRowAxisCell(columnIndex, rowIndex);
	    }
	
	    return column;
	};
	
	/**
	 * Builds row axis cell based on row and column index pair.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowIndex 
	 * @returns {object}
	 */
	PivotTable.prototype.buildRowAxisCell = function (columnIndex, rowIndex) {
	
	    rowIndex = this.getRowIndexWithHidden(rowIndex);
	
	    if (this.isRowSubTotal(rowIndex)) {
	        return (0, _PivotTableCells.DimensionSubTotalCell)('&nbsp;', this.rowDimensionSize - columnIndex, 1, true, columnIndex !== this.columnStart);
	    }
	
	    if (this.isRowGrandTotal(rowIndex)) {
	        return (0, _PivotTableCells.DimensionGrandTotalCell)(columnIndex === 0 ? 'Total' : '&nbsp;', this.rowDimensionSize - columnIndex, 1, columnIndex !== 0, columnIndex !== 0, columnIndex !== 0);
	    }
	
	    return (0, _PivotTableCells.RowAxisCell)(this.getRowAxisObject(columnIndex, this.normalizeRowIndex(rowIndex)), this.response, this.doShowHierarchy());
	};
	
	/**
	 * Builds column axis cell based on row and column index pair
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnIndex 
	 * @returns {object}
	 */
	PivotTable.prototype.buildColumnAxisCell = function (rowIndex, columnIndex) {
	
	    columnIndex = this.getColumnIndexWithHidden(columnIndex);
	
	    if (this.isColumnSubTotal(columnIndex)) {
	        return (0, _PivotTableCells.DimensionSubTotalCell)('&nbsp;', 1, this.columnDimensionSize - rowIndex, true, rowIndex !== this.rowStart);
	    }
	
	    if (this.isColumnGrandTotal(columnIndex)) {
	        return (0, _PivotTableCells.DimensionGrandTotalCell)(rowIndex === 0 ? 'Total' : '&nbsp;', 1, this.columnDimensionSize - rowIndex, rowIndex === this.rowStart && this.doSortableColumnHeaders(), rowIndex !== 0, rowIndex !== 0);
	    }
	
	    return (0, _PivotTableCells.ColumnAxisCell)(this.getColumnAxisObject(rowIndex, this.normalizeColumnIndex(columnIndex)), this.response, this.doShowHierarchy(), this.getRowSortId(rowIndex));
	};
	
	/**
	 * Builds column axis dimension based on given parameters
	 * 
	 * @param {number} columnStart 
	 * @param {number} columnEnd 
	 * @param {number} rowStart 
	 * @returns {array}
	 */
	PivotTable.prototype.buildColumnAxis = function () {
	    if (!this.colAxis.type) {
	        return this.buildCornerAxisRow(0, 0);
	    }
	
	    var axis = [];
	
	    for (var i = 0, columnIndex = this.columnStart; columnIndex <= this.columnEnd; i++, columnIndex++) {
	        axis[i] = this.buildColumnAxisColumn(columnIndex, this.rowStart);
	    }
	
	    return axis;
	};
	
	/**
	 * Builds column axis dimension column based on given parameters
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowStart 
	 * @returns {array}
	 */
	PivotTable.prototype.buildColumnAxisColumn = function (columnIndex, rowStart) {
	    if (this.columnDimensionSize < rowStart) {
	        return [];
	    }
	
	    if (this.isRowDimensionColumn(columnIndex)) {
	        return this.buildCornerAxisColumn(columnIndex, rowStart);
	    }
	
	    columnIndex -= this.rowDimensionSize;
	
	    var column = [];
	
	    for (var i = 0, rowIndex = rowStart; rowIndex < this.columnDimensionSize; i++, rowIndex++) {
	        column[i] = this.buildColumnAxisCell(rowIndex, columnIndex);
	    }
	
	    return column;
	};
	
	/**
	 * Builds corner axis dimension.
	 * 
	 * @returns {array}
	 */
	PivotTable.prototype.buildCornerAxis = function () {
	    var cornerAxis = [];
	
	    for (var i = 0; i < this.columnDimensionSize; i++) {
	        cornerAxis[i] = this.buildCornerAxisRow(i, 0);
	    }
	
	    return cornerAxis;
	};
	
	/**
	 * Builds corner axis dimension column based on given parameters.
	 * 
	 * @param {number} columnIndex 
	 * @param {number} rowStart 
	 * @returns {array}
	 */
	PivotTable.prototype.buildCornerAxisColumn = function (columnIndex, rowStart) {
	    var column = [];
	
	    if (!this.doShowDimensionLabels()) {
	        column[0] = (0, _PivotTableCells.DimensionEmptyCell)(this.rowDimensionSize - columnIndex, this.columnDimensionSize - rowStart, columnIndex !== this.columnStart);
	        for (var i = 1, rowIndex = rowStart + 1; rowIndex < this.columnDimensionSize; i++, rowIndex++) {
	            column[i] = (0, _PivotTableCells.DimensionEmptyCell)(this.rowDimensionSize - columnIndex, this.columnDimensionSize - rowIndex, true);
	        }
	        return column;
	    }
	
	    if (columnIndex === this.rowDimensionSize - 1) {
	        for (var _i2 = rowStart; _i2 < this.columnDimensionSize - 1; _i2++) {
	            column[_i2] = (0, _PivotTableCells.DimensionLabelCell)(this.getColumnAxisLabel(_i2));
	        }
	        column.push((0, _PivotTableCells.DimensionLabelCell)(this.getCrossAxisLabel()));
	        return column;
	    }
	
	    for (var _i3 = rowStart; _i3 < this.columnDimensionSize - 1; _i3++) {
	        column[_i3] = (0, _PivotTableCells.DimensionLabelCell)('&nbsp;');
	    }
	
	    column[this.columnDimensionSize - 1] = (0, _PivotTableCells.DimensionLabelCell)(this.getRowAxisLabel(columnIndex));
	
	    return column;
	};
	
	/**
	 * Builds corner axis dimension row based on given parameters.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnStart 
	 * @returns {array}
	 */
	PivotTable.prototype.buildCornerAxisRow = function (rowIndex, columnStart) {
	    var row = [];
	
	    if (!this.doShowDimensionLabels()) {
	        row[0] = (0, _PivotTableCells.DimensionEmptyCell)(this.rowDimensionSize - columnStart, this.columnDimensionSize - rowIndex, columnStart === this.columnStart);
	        for (var i = 1, columnIndex = columnStart + 1; columnIndex < this.rowDimensionSize; i++, columnIndex++) {
	            row[i] = (0, _PivotTableCells.DimensionEmptyCell)(this.rowDimensionSize - columnIndex, this.columnDimensionSize - rowIndex, true);
	        }
	        return row;
	    }
	
	    if (rowIndex === this.columnDimensionSize - 1 || this.columnDimensionSize === 0) {
	        for (var _i4 = 0, _columnIndex = columnStart; _columnIndex < this.rowDimensionSize - 1; _i4++, _columnIndex++) {
	            row[_i4] = (0, _PivotTableCells.DimensionLabelCell)(this.getRowAxisLabel(_i4));
	        }
	        row.push((0, _PivotTableCells.DimensionLabelCell)(this.getCrossAxisLabel()));
	        return row;
	    }
	
	    for (var _i5 = 0, _columnIndex2 = columnStart; _columnIndex2 < this.rowDimensionSize - 1; _i5++, _columnIndex2++) {
	        row[_i5] = (0, _PivotTableCells.DimensionLabelCell)('&nbsp;');
	    }
	
	    row.push((0, _PivotTableCells.DimensionLabelCell)(this.getColumnAxisLabel(rowIndex)));
	
	    return row;
	};
	
	/**
	 * Creates axis dimension span map.
	 * 
	 * @param {array} spanValues 
	 * @returns {array}
	 */
	PivotTable.prototype.createSpanMap = function (spanValues) {
	    if (!spanValues) {
	        spanValues = [];
	    }
	    return Array.from(spanValues, function (value) {
	        return (0, _PivotTableUtils.defaultProxyGenerator)(value);
	    });
	};
	
	/**
	 * Creates row axis dimension span map
	 * 
	 * @returns {array}
	 */
	PivotTable.prototype.createRowSpanMap = function () {
	    return this.createSpanMap(this.rowAxis.span);
	};
	
	/**
	 * Creates column axis dimension span map.
	 * 
	 * @returns {array}
	 */
	PivotTable.prototype.createColumnSpanMap = function () {
	    return this.createSpanMap(this.colAxis.span);
	};
	
	/**
	 * Update value of total object.
	 * 
	 * @param {number} rowIndex 
	 * @param {number} columnIndex 
	 * @param {object} valueObject 
	 * @param {object} totalObject 
	 */
	PivotTable.prototype.updateValueTotal = function (rowIndex, columnIndex, valueObject, totalObject) {
	
	    if (!totalObject[rowIndex]) {
	        totalObject[rowIndex] = {};
	    }
	
	    if (!totalObject[rowIndex][columnIndex]) {
	        totalObject[rowIndex][columnIndex] = {
	            numerator: 0,
	            denominator: 0,
	            factor: 0,
	            counter: 0,
	            empty: 0
	        };
	    }
	
	    if (valueObject.value === null) {
	        totalObject[rowIndex][columnIndex].empty++;
	    }
	
	    totalObject[rowIndex][columnIndex].counter++;
	
	    (0, _PivotTableUtils.addMerge)(totalObject[rowIndex][columnIndex], valueObject);
	};
	
	/**
	 * Increments value lookup iterator offset by row sub total columns.
	 * 
	 * @param {number} columnIndex 
	 * @returns 
	 */
	PivotTable.prototype.columnAxisOffsetIncrement = function (columnIndex) {
	    if (this.doRowSubTotals() && (columnIndex + 2) % (this.colUniqueFactor + 1) === 0) {
	        return 2;
	    }
	    return 1;
	};
	
	/**
	 * Increments value lookup iterator offset by column sub total rows.
	 * 
	 * @param {number} rowIndex 
	 * @returns 
	 */
	PivotTable.prototype.rowAxisOffsetIncrement = function (rowIndex) {
	    if (this.doColSubTotals() && (rowIndex + 2) % (this.rowUniqueFactor + 1) === 0) {
	        return 2;
	    }
	    return 1;
	};
	
	/**
	 * Initializes lookup tables.
	 */
	PivotTable.prototype.initializeLookups = function () {
	
	    var tableRowSize = this.rowSize,
	        tableColumnSize = this.columnSize;
	
	    var totalMap = {};
	
	    for (var i = 0, rowIndex = 0; rowIndex < tableRowSize; i++, rowIndex += this.rowAxisOffsetIncrement(rowIndex)) {
	        for (var j = 0, columnIndex = 0; columnIndex < tableColumnSize; j++, columnIndex += this.columnAxisOffsetIncrement(columnIndex)) {
	
	            var valueObject = this.getValueObject(i, j);
	
	            if (valueObject) {
	
	                if (!this.valueLookup[rowIndex]) {
	                    this.valueLookup[rowIndex] = {};
	                }
	
	                this.valueLookup[rowIndex][columnIndex] = valueObject.empty ? null : valueObject.value;
	            }
	
	            this.rowTotalLookup[rowIndex] += valueObject.value;
	            this.columnTotalLookup[columnIndex] += valueObject.value;
	
	            this.rowTotalLookup[this.getNextTotalRowIndex()] += valueObject.value;
	            this.columnTotalLookup[this.getNextTotalColumnIndex()] += valueObject.value;
	
	            if (this.doColSubTotals()) {
	                this.rowTotalLookup[this.getNextSubRowIndex(i)] += valueObject.value;
	            }
	
	            if (this.doRowSubTotals()) {
	                this.columnTotalLookup[this.getNextSubColumnIndex(j)] += valueObject.value;
	            }
	
	            // calculate grand totals
	            if (this.doColTotals()) this.updateValueTotal(this.getNextTotalRowIndex(), columnIndex, valueObject, totalMap);
	            if (this.doRowTotals()) this.updateValueTotal(rowIndex, this.getNextTotalColumnIndex(), valueObject, totalMap);
	
	            // calculate sub totals
	            if (this.doColSubTotals()) this.updateValueTotal(this.getNextSubRowIndex(i), columnIndex, valueObject, totalMap);
	            if (this.doRowSubTotals()) this.updateValueTotal(rowIndex, this.getNextSubColumnIndex(j), valueObject, totalMap);
	
	            // calculate intersection totals
	            if (this.doRowTotals() && this.doColTotals()) this.updateValueTotal(this.getNextTotalRowIndex(), this.getNextTotalColumnIndex(), valueObject, totalMap);
	            if (this.doColSubTotals() && this.doRowSubTotals()) this.updateValueTotal(this.getNextSubRowIndex(i), this.getNextSubColumnIndex(j), valueObject, totalMap);
	
	            if (this.doColTotals() && this.doRowSubTotals()) this.updateValueTotal(this.getNextTotalRowIndex(), this.getNextSubColumnIndex(j), valueObject, totalMap);
	            if (this.doRowTotals() && this.doColSubTotals()) this.updateValueTotal(this.getNextSubRowIndex(i), this.getNextTotalColumnIndex(), valueObject, totalMap);
	        }
	    }
	
	    var rowTotalIndices = Object.keys(totalMap);
	
	    for (var _i6 = 0; _i6 < rowTotalIndices.length; _i6++) {
	
	        var columnTotalIndicies = Object.keys(totalMap[rowTotalIndices[_i6]]);
	
	        for (var _j = 0; _j < columnTotalIndicies.length; _j++) {
	
	            var _rowIndex = rowTotalIndices[_i6],
	                _columnIndex3 = columnTotalIndicies[_j];
	
	            if (!this.valueLookup[_rowIndex]) {
	                this.valueLookup[_rowIndex] = {};
	            }
	
	            if (totalMap[_rowIndex][_columnIndex3].counter !== totalMap[_rowIndex][_columnIndex3].empty) {
	                var total = this.getTrueTotal(totalMap[_rowIndex][_columnIndex3].numerator, totalMap[_rowIndex][_columnIndex3].denominator || 1, totalMap[_rowIndex][_columnIndex3].factor / totalMap[_rowIndex][_columnIndex3].counter);
	
	                this.valueLookup[_rowIndex][_columnIndex3] = total;
	            }
	        }
	    }
	};
	
	/**
	 * Creates a row axis render map.
	 * 
	 * @returns {object}
	 */
	PivotTable.prototype.createRowRenderMap = function () {
	    var map = [];
	
	    for (var i = 0; i < this.rowSize; i++) {
	
	        if (!this.isRowEmpty(i) || !this.doHideEmptyRows()) {
	            map.push(i);
	            continue;
	        }
	
	        this.numberOfEmptyRows += 1;
	
	        for (var j = 0; j < this.rowAxis.span.length; j++) {
	            this.decremenetRowAxisSpan(this.normalizeRowIndex(i), j);
	        }
	    }
	    return map;
	};
	
	/**
	 * Creates a column axis render map.
	 * 
	 * @returns {object}
	 */
	PivotTable.prototype.createColumnRenderMap = function () {
	    var map = [];
	
	    for (var i = 0; i < this.columnSize; i++) {
	
	        if (!this.isColumnEmpty(i) || !this.doHideEmptyColumns()) {
	            map.push(i);
	            continue;
	        }
	
	        this.numberOfEmptyColumns += 1;
	        for (var j = 0; j < this.colAxis.span.length - 1; j++) {
	            this.decrementColumnAxisSpan(this.normalizeColumnIndex(i), j);
	        }
	    }
	    return map;
	};
	
	/**
	 * Returns row index constrained against the height of the table.
	 * 
	 * @param {number} rowIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.constrainHeight = function (rowIndex) {
	    return Math.min(this.getRowAxisSize() - this.numberOfEmptyRows, rowIndex);
	};
	/**
	 * Returns column index constrained against the width of the table.
	 * 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.constrainWidth = function (columnIndex) {
	    return Math.min(this.getColumnAxisSize() - this.numberOfEmptyColumns, columnIndex);
	};
	/**
	 * Normalizes given row index based on previous sub column rows.
	 * 
	 * @param {number} rowIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.normalizeRowIndex = function (rowIndex) {
	    if (this.doColSubTotals()) {
	        rowIndex = Math.max(0, rowIndex - Math.floor(rowIndex / (this.rowUniqueFactor + 1)));
	    }
	    return rowIndex;
	};
	/**
	 * Normalizes given column index based on previous sub row columns.
	 * 
	 * @param {number} columnIndex 
	 * @returns {number}
	 */
	PivotTable.prototype.normalizeColumnIndex = function (columnIndex) {
	    if (this.doRowSubTotals()) {
	        return Math.max(0, columnIndex - Math.floor(columnIndex / (this.colUniqueFactor + 1)));
	    }
	    return columnIndex;
	};
	
	/**
	 * Builds table filter.
	 * 
	 * @param {number} span 
	 * @returns {array}
	 */
	PivotTable.prototype.buildTableFilter = function (span) {
	    if (!this.filters) {
	        return [];
	    }
	
	    return [[this.buildHtmlCell((0, _PivotTableCells.FilterCell)(this.getRecordNames(), this.getTopBarSpan(span)))]];
	};
	
	/**
	 * Builds table title.
	 * 
	 * @param {number} span 
	 * @returns 
	 */
	PivotTable.prototype.buildTableTitle = function (span) {
	    if (!this.title) {
	        return [];
	    }
	
	    return [[this.buildHtmlCell((0, _PivotTableCells.FilterCell)(this.title, this.getTopBarSpan(span)))]];
	};
	
	/**
	 * Gets legends.
	 * 
	 * @param {string} dxId 
	 * @returns
	 */
	PivotTable.prototype.getLegends = function (dxId) {
	    return this.appManager.getLegendSetById(this.getLegendSetId(dxId)).legends;
	};
	
	/**
	 * Gets legend set.
	 * 
	 * @param {string} dxId 
	 * @returns 
	 */
	PivotTable.prototype.getLegendSet = function (dxId) {
	    if (!dxId) {
	        return null;
	    }
	
	    return this.response.metaData.items[dxId].legendSet;
	};
	
	/**
	 * Converts table cell to html string
	 * 
	 * @param {object} config 
	 * @returns {string}
	 */
	PivotTable.prototype.buildHtmlCell = function (cell) {
	
	    // validation
	    if (!(0, _isObject2.default)(cell) || cell.hidden || cell.collapsed) {
	        return '';
	    }
	
	    if ((0, _isString2.default)(cell.sort)) {
	        this.sortableIdObjects.push({
	            id: cell.sort,
	            uuid: cell.uuid
	        });
	    }
	
	    if (cell.type === 'value') {
	        this.valueUuids.push(cell.uuid);
	    }
	
	    if (cell.type === 'dimension') {
	        this.dimensionUuids.push(cell.uuid);
	    }
	
	    var style = this.getBaseCellStyling(cell);
	
	    if (cell.isValue) {
	
	        if (!this.options.unclickable) {
	            cell.cls += ' pointer';
	        }
	
	        var legends = this.legendSet ? this.legendSet.legends || [] : [],
	            bgColor = void 0;
	
	        if (this.doLegendDisplayByDataItem() && this.getLegendSet(cell.dxId)) {
	            legends = this.getLegends(cell.dxId);
	        }
	
	        for (var i = 0; i < legends.length; i++) {
	            if ((0, _numberConstrain2.default)(cell.value, legends[i].startValue, legends[i].endValue) === cell.value) {
	                bgColor = legends[i].color;
	            }
	        }
	
	        if (this.doLegendDisplayStyleFill() && bgColor) {
	            style += '\n                background-color:' + bgColor + ';\n                color:' + ((0, _colorUtils.isColorBright)(bgColor) ? 'black' : 'white') + ';\n            ';
	        }
	
	        if (this.doLegendDisplayStyleText() && bgColor) {
	            style += 'color:' + bgColor + ';';
	        }
	    }
	
	    style += cell.style ? cell.style : '';
	
	    return '\n        <td data-ou-id="' + (cell.ouId || '') + '"\n            data-period-id="' + (cell.peId || '') + '"\n            class="' + cell.cls + '"\n            id="' + (cell.uuid || '') + '"\n            title="' + (cell.title || '') + '"\n            style="' + style + '"\n            colspan="' + (cell.colSpan || '') + '"\n            rowSpan="' + (cell.rowSpan || '') + '"\n        >\n            ' + this.getHtmlValue(cell) + '\n        </td>\n    ';
	};
	
	/**
	 * Converts array of table cells to array of html strings
	 * 
	 * @param {array} rows 
	 * @returns {array}
	 */
	PivotTable.prototype.buildHtmlRows = function (rows) {
	    var _this = this;
	
	    return rows.map(function (row) {
	        return _this.buildHtmlRow(row);
	    });
	};
	
	/**
	 * Converts array of table cells to array of html strings
	 * 
	 * @param {array} row 
	 * @returns {array}
	 */
	PivotTable.prototype.buildHtmlRow = function (row) {
	    var _this2 = this;
	
	    return row.map(function (cell) {
	        return _this2.buildHtmlCell(cell);
	    });
	};
	
	/**
	 * Converts array of table cells to html strings
	 * 
	 * @param {any} htmlArray 
	 * @returns {array}
	 */
	PivotTable.prototype.buildHtmlTableRows = function (htmlArray) {
	    var _this3 = this;
	
	    return htmlArray.reduce(function (rows, row) {
	        return rows + _this3.buildHtmlTableRow(row.join(''));
	    }, '');
	};
	
	PivotTable.prototype.buildHtmlTableRow = function (htmlRow) {
	    return htmlRow ? '\n        <tr> \n            ' + (this.doDynamicRendering() ? this.buildLeftPaddingHtmlCell() : '') + '\n            ' + htmlRow + '\n            ' + (this.doDynamicRendering() ? this.buildRightPaddingHtmlCell() : '') + '\n        </tr>\n    ' : '';
	};
	
	/**
	 * Builds top padding row
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.buildTopPaddingHtmlRow = function () {
	    var cell = this.buildTopPaddingHtmlCell();
	
	    if (cell) {
	        return '<tr>' + cell + '</tr>';
	    }
	
	    return '';
	};
	
	/**
	 * Builds bottom padding row
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.buildBottomPaddingHtmlRow = function () {
	    var cell = this.buildBottomPaddingHtmlCell();
	
	    if (cell) {
	        return '<tr>' + cell + '</tr>';
	    }
	
	    return '';
	};
	
	/**
	 * Builds top padding cell
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.buildTopPaddingHtmlCell = function () {
	    var padding = this.getTopPadding(),
	        cell = (0, _PivotTableCells.VerticalPaddingCell)(padding, 'top-padding');
	
	    return this.buildHtmlCell(cell);
	};
	
	/**
	 * Builds bottom padding cell
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.buildBottomPaddingHtmlCell = function () {
	    var padding = this.getBottomPadding(),
	        cell = (0, _PivotTableCells.VerticalPaddingCell)(padding, 'bottom-padding');
	
	    return this.buildHtmlCell(cell);
	};
	
	/**
	 * Builds left padding cell
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.buildLeftPaddingHtmlCell = function () {
	    var padding = this.getLeftPadding(),
	        cell = (0, _PivotTableCells.HorizontalPaddingCell)(padding, 'left-padding');
	
	    return this.buildHtmlCell(cell);
	};
	
	/**
	 * Builds right padding cell
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.buildRightPaddingHtmlCell = function () {
	    var padding = this.getRightPadding(),
	        cell = (0, _PivotTableCells.HorizontalPaddingCell)(padding, 'right-padding');
	
	    return this.buildHtmlCell(cell);
	};
	
	/**
	 * Buidlds html table body
	 * 
	 * @param {array} htmlArray 
	 * @returns {string}
	 */
	PivotTable.prototype.buildHtmlTableBody = function (htmlArray) {
	    return '\n        <tbody>\n            ' + (this.doDynamicRendering() ? this.buildTopPaddingHtmlRow() : '') + '\n            ' + this.buildHtmlTableRows(htmlArray) + '\n            ' + (this.doDynamicRendering() ? this.buildBottomPaddingHtmlRow() : '') + '\n        </tbody>\n    ';
	};
	
	/**
	 * Build html table
	 * 
	 * @param {array} htmlArray 
	 * @returns {string}
	 */
	PivotTable.prototype.buildHtmlTable = function () {
	    var cls = 'pivot user-select',
	        style = 'display:flex!important;overflow:visible;';
	
	    cls += this.displayDensity ? ' displaydensity-' + this.displayDensity : '';
	    cls += this.fontSize ? ' fontsize-' + this.fontSize : '';
	
	    var htmlArray = (0, _arrayClean2.default)([].concat(this.options.skipTitle || this.rowStart > 0 ? [] : this.buildTableTitle(this.table[0].length), this.buildTableFilter(this.table[0].length), this.buildHtmlRows(this.table)));
	
	    return '\n        <div style="' + style + '">\n            <table class="' + cls + '">\n                ' + this.buildHtmlTableBody(htmlArray) + '\n            </table>\n        </div>\n    ';
	};
	
	// table actions
	/**
	 * Builds the initial table.
	 * 
	 * @param {number} [columnStart=0] 
	 * @param {number} [rowStart=0] 
	 */
	PivotTable.prototype.build = function () {
	    var columnStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var rowStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	
	    this.setColumnStartAndEnd(columnStart);
	    this.setRowStartAndEnd(rowStart);
	
	    var rowAxis = this.buildRowAxis(),
	        colAxis = this.buildColumnAxis(),
	        values = this.buildValueTable();
	
	    for (var i = 0; i < rowAxis.length; i++) {
	        var _rowAxis$i;
	
	        (_rowAxis$i = rowAxis[i]).push.apply(_rowAxis$i, _toConsumableArray(values[i]));
	    }
	
	    this.table = (0, _PivotTableUtils.toRow)(colAxis).concat(rowAxis);
	};
	
	/**
	 * Renders table in form of html string.
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.render = function () {
	
	    this.valueUuids = [];
	    this.dimensionUuids = [];
	    this.sortableIdObjects = [];
	
	    if (this.doHideEmptyRows() && (0, _isEmpty2.default)(this.rowAxisLookup) && this.doHideEmptyColumns() && (0, _isEmpty2.default)(this.columnAxisLookup)) {
	        return "There is no data to display, and empty rows and columns are hidden.";
	    }
	
	    if (this.doHideEmptyRows() && (0, _isEmpty2.default)(this.rowAxisLookup)) {
	        return "There is no data to display, and empty rows are hidden.";
	    }
	
	    if (this.doHideEmptyColumns() && (0, _isEmpty2.default)(this.columnAxisLookup)) {
	        return "There is no data to display, and empty columns are hidden.";
	    }
	
	    this.updateDimensionSpan();
	
	    return this.buildHtmlTable();
	};
	
	/**
	 * Updates the table given a new column start and row start.
	 * 
	 * @param {number} columnStart 
	 * @param {number} rowStart 
	 * @returns {string}
	 */
	PivotTable.prototype.update = function (columnStart, rowStart) {
	
	    // decrease rowStart by one if top title is present
	    if (rowStart > 0 && !this.options.skipTitle) {
	        rowStart -= 1;
	    }
	
	    var columnEnd = this.getColumnEnd(columnStart),
	        rowEnd = this.getRowEnd(rowStart);
	
	    while (columnStart !== this.columnStart || rowStart !== this.rowStart || columnEnd !== this.columnEnd || rowEnd !== this.rowEnd) {
	        this.applyChange(columnStart, columnEnd, rowStart, rowEnd);
	    }
	
	    return this.render();
	};
	
	/**
	 * Applies incremental changes to the table.
	 * 
	 * @param {number} columnStart new start column index
	 * @param {number} columnEnd new end column index
	 * @param {number} rowStart new start row index
	 * @param {number} rowEnd new end row index
	 */
	PivotTable.prototype.applyChange = function (columnStart, columnEnd, rowStart, rowEnd) {
	
	    if (this.columnStart > columnStart) {
	        this.columnStart--;
	        this.addLeft(this.columnStart, this.rowStart, this.rowEnd);
	    }
	
	    if (this.columnEnd < columnEnd) {
	        this.setColumnEnd(this.columnEnd + 1);
	        this.addRight(this.columnEnd, this.rowStart, this.rowEnd);
	    }
	
	    if (this.rowStart > rowStart) {
	        this.rowStart--;
	        this.addTop(this.rowStart, this.columnStart, this.columnEnd);
	    }
	
	    if (this.rowEnd < rowEnd) {
	        this.setRowEnd(this.rowEnd + 1);
	        this.addBottom(this.rowEnd, this.columnStart, this.columnEnd);
	    }
	
	    if (this.rowStart < rowStart) {
	        this.rowStart++;
	        this.deleteTop();
	    }
	
	    if (this.rowEnd > rowEnd) {
	        this.setRowEnd(this.rowEnd - 1);
	        this.deleteBottom();
	    }
	
	    if (this.columnStart < columnStart) {
	        this.columnStart++;
	        this.deleteLeft();
	    }
	
	    if (this.columnEnd > columnEnd) {
	        this.setColumnEnd(this.columnEnd - 1);
	        this.deleteRight();
	    }
	};
	
	/**
	 * Decreses the row span by 1 of the associated dimension at 
	 * given row index.
	 * 
	 * @param {number} rowIndex index of row dimension
	 * @param {number} dimensionIndex dimension id
	 */
	PivotTable.prototype.decremenetRowAxisSpan = function (rowIndex, dimensionIndex) {
	    this.rowAxisSpanMap[dimensionIndex][Math.floor(rowIndex / this.rowAxis.span[dimensionIndex])] -= 1;
	};
	
	/**
	 * Decreses the column span by 1 of the associated dimension at 
	 * given column index.
	 * 
	 * @param {number} columnIndex index of column dimension
	 * @param {number} dimensionIndex dimension id
	 */
	PivotTable.prototype.decrementColumnAxisSpan = function (columnIndex, dimensionIndex) {
	    this.columnAxisSpanMap[dimensionIndex][Math.floor(columnIndex / this.colAxis.span[dimensionIndex])] -= 1;
	};
	
	/**
	 * Builds value table based on given parameters
	 * 
	 * @param {number} rowStart 
	 * @param {number} rowEnd 
	 * @param {number} columnStart 
	 * @param {number} columnEnd 
	 * @returns {array}
	 */
	PivotTable.prototype.buildValueTable = function () {
	
	    var rowEnd = this.rowEnd - this.getValueRowStartOffset(),
	        columnEnd = this.columnEnd - this.getValueColumnStartOffset();
	
	    var rowSize = rowEnd - this.rowStart + 1,
	        // TODO: why + 1?
	    colSize = columnEnd - this.columnStart + 1; // TODO: why + 1?
	
	    if (!this.doHideEmptyColumns() && colSize === 0) {
	        colSize = 1;
	    }
	
	    if (!this.doHideEmptyRows() && rowSize === 0) {
	        rowSize = 1;
	    }
	
	    var table = [];
	
	    if (this.doDynamicRendering()) {
	        rowSize = Math.min(rowSize, this.rowSize);
	        colSize = Math.min(colSize, this.columnSize);
	    }
	
	    for (var i = 0, rowIndex = this.rowStart; i < rowSize; i++, rowIndex++) {
	        table.push([]);
	        for (var j = 0, columnIndex = this.columnStart; j < colSize; j++, columnIndex++) {
	            if (this.doSortableColumnHeaders()) {
	                var totalIdComb = new _ResponseRowIdCombination.ResponseRowIdCombination(this.refs, ['total', this.rowAxis.ids[rowIndex]]);
	                this.idValueMap[totalIdComb.get()] = this.isRowEmpty(rowIndex) ? null : this.getRowTotal(rowIndex);
	            }
	            table[i][j] = this.buildValueCell(columnIndex, rowIndex);
	        }
	    }
	
	    return table;
	};
	
	/**
	 * Updates row axis dimension spans based on current render area.
	 * 
	 */
	PivotTable.prototype.updateRowAxisDimensionSpan = function () {
	    if (!this.rowAxis.type) return;
	
	    var rowSpanLimit = this.rowEnd - this.rowStart + 1 - Math.max(0, this.columnDimensionSize - this.rowStart);
	
	    for (var i = 0, columnIndex = this.columnStart; i < this.rowDimensionSize - this.columnStart; i++, columnIndex++) {
	        for (var j = this.getValueRowStartOffset(), rowIndex = this.getValueOffsetRow(), rowSpanCounter = 0, currentRowSpan = 0; j < this.table.length; j++, rowIndex++) {
	
	            var cell = this.table[j][i];
	            if (cell.collapsed || this.doHideEmptyRows() && this.isRowEmpty(this.getRowIndexWithHidden(rowIndex))) {
	                continue;
	            }
	
	            if (cell.type === 'dimensionSubtotal' || cell.type === 'dimensionTotal') {
	                rowSpanCounter += 1;
	                cell.hidden = i !== 0;
	                continue;
	            }
	
	            currentRowSpan -= 1;
	            cell.hidden = !(currentRowSpan <= 0);
	
	            if (currentRowSpan <= 0 && this.rowAxis.span[columnIndex] !== 1) {
	                currentRowSpan = this.getUpdatedRowSpan(rowIndex, columnIndex);
	            }
	
	            if (this.rowAxis.span[columnIndex] === 1) {
	                currentRowSpan = 1;
	            }
	
	            cell.rowSpan = currentRowSpan;
	
	            if (cell.hidden) {
	                continue;
	            }
	
	            if (cell.rowSpan + rowSpanCounter > rowSpanLimit) {
	                cell.rowSpan = rowSpanLimit - rowSpanCounter;
	            }
	
	            rowSpanCounter += cell.rowSpan;
	        }
	    }
	};
	
	/**
	 * Updates column axis dimension span based on current render area.
	 * 
	 */
	PivotTable.prototype.updateColumnAxisDimensionSpan = function () {
	    if (!this.colAxis.type) return;
	
	    var colSpanLimit = this.columnEnd - this.columnStart + 1 - Math.max(0, this.rowDimensionSize - this.columnStart);
	
	    for (var i = 0, rowIndex = this.rowStart; i < this.columnDimensionSize - this.rowStart; i++, rowIndex++) {
	        for (var j = this.getValueColumnStartOffset(), columnIndex = this.getValueOffsetColumn(), colSpanCounter = 0, currentColSpan = 0; j < this.table[i].length; j++, columnIndex++) {
	
	            var cell = this.table[i][j];
	
	            if (cell.collapsed || this.doHideEmptyColumns() && this.isColumnEmpty(this.getColumnIndexWithHidden(columnIndex))) {
	                continue;
	            }
	
	            if (cell.type === 'dimensionSubtotal' || cell.type === 'dimensionTotal') {
	                colSpanCounter += 1;
	                cell.hidden = i !== 0;
	                continue;
	            }
	
	            currentColSpan -= 1;
	            cell.hidden = !(currentColSpan <= 0);
	
	            if (currentColSpan <= 0 && this.colAxis.span[rowIndex] !== 1) {
	                currentColSpan = this.getUpdatedColumnSpan(columnIndex, rowIndex);
	            }
	
	            if (this.colAxis.span[rowIndex] === 1) {
	                currentColSpan = 1;
	            }
	
	            cell.colSpan = currentColSpan;
	
	            if (cell.hidden) {
	                continue;
	            }
	
	            if (cell.colSpan + colSpanCounter > colSpanLimit) {
	                cell.colSpan = colSpanLimit - colSpanCounter;
	            }
	
	            colSpanCounter += cell.colSpan;
	        }
	    }
	};
	
	/**
	 * Updates corner axis dimension span based on current render area.
	 * 
	 */
	PivotTable.prototype.updateCornerAxisDimensionSpan = function () {
	    var rowSpanLimit = this.rowEnd - this.rowStart + 1;
	
	    for (var i = 0, columnIndex = this.columnStart, cell; i < this.rowDimensionSize - this.columnStart; i++, columnIndex++) {
	        for (var j = 0, rowSpanCounter = 0; j < this.columnDimensionSize - this.rowStart; j++) {
	
	            cell = this.table[j][i];
	
	            if (cell.collapsed) continue;
	
	            cell.rowSpan = this.getAdjustedRowSpan(cell, columnIndex);
	
	            if (cell.type === 'labeled') {
	                cell.hidden = false;
	            }
	
	            if (cell.type === 'empty') {
	                cell.hidden = !(i === 0 && j === 0);
	                if (this.doHideEmptyColumns() && this.columnEnd - this.columnStart - 1 === 0) {
	                    cell.hidden = i !== 0;
	                }
	
	                if (j === 0) {
	                    rowSpanCounter += Math.max(0, this.columnDimensionSize - this.rowStart);
	                    continue;
	                }
	            }
	
	            if (rowSpanCounter >= rowSpanLimit || cell.hidden) {
	                cell.hidden = true;
	                continue;
	            }
	
	            if (cell.rowSpan + rowSpanCounter > rowSpanLimit) {
	                cell.rowSpan = rowSpanLimit - rowSpanCounter;
	            }
	
	            rowSpanCounter += cell.rowSpan;
	        }
	    }
	};
	
	/**
	 * Utility function for updating dimension span.
	 * 
	 */
	PivotTable.prototype.updateDimensionSpan = function () {
	    this.updateCornerAxisDimensionSpan();
	    this.updateColumnAxisDimensionSpan();
	    this.updateRowAxisDimensionSpan();
	};
	
	/**
	 * Returns some table statistics in form of string.
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.statistics = function () {
	    return {
	        "rows:": Object.keys(this.valueLookup).length,
	        "columns:": Object.keys(this.valueLookup[0]).length,
	        "cells": Object.keys(this.valueLookup).length * Object.keys(this.valueLookup[0]).length
	    };
	};
	
	/**
	 * Prints statistics
	 * 
	 * @returns {string}
	 */
	PivotTable.prototype.printStatistics = function () {
	    console.log(this.statistics());
	};
	//# sourceMappingURL=PivotTable.js.map

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PivotTableAxis = undefined;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayPluck = __webpack_require__(27);
	
	var _arrayPluck2 = _interopRequireDefault(_arrayPluck);
	
	var _arraySort = __webpack_require__(8);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _arrayUnique = __webpack_require__(12);
	
	var _arrayUnique2 = _interopRequireDefault(_arrayUnique);
	
	var _arrayRepeat = __webpack_require__(180);
	
	var _arrayRepeat2 = _interopRequireDefault(_arrayRepeat);
	
	var _uuid = __webpack_require__(30);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var PivotTableAxis = exports.PivotTableAxis = function PivotTableAxis(refs, layout, response, type) {
	
	    var ignoreKeys = ['dy', 'longitude', 'latitude'];
	
	    var spanType = void 0,
	        aDimensions = [],
	        nAxisWidth = 1,
	        nAxisHeight = void 0,
	        aUniqueFloorWidth = [],
	        aAccFloorWidth = [],
	        aFloorSpan = [],
	        aCondoId = [],
	        uuidObjectMap = {};
	
	    if (type === 'col') {
	        aDimensions = (layout.columns || []).filter(function (dim) {
	            return !(0, _arrayContains2.default)(ignoreKeys, dim.dimension);
	        });
	        spanType = 'colSpan';
	    } else if (type === 'row') {
	        aDimensions = (layout.rows || []).filter(function (dim) {
	            return !(0, _arrayContains2.default)(ignoreKeys, dim.dimension);
	        });
	        spanType = 'rowSpan';
	    }
	
	    if (!((0, _isArray2.default)(aDimensions) && aDimensions.length)) {
	        return;
	    }
	
	    var dimensionNameIdsMap = layout.getDimensionNameIdsMap(response),
	        tableSize = Object.keys(dimensionNameIdsMap).reduce(function (sum, id) {
	        return sum * dimensionNameIdsMap[id].length;
	    }, 1);
	
	    var aaUniqueFloorIds = function () {
	        var dims = void 0;
	
	        return aDimensions.map(function (dimension, index) {
	            if (dimension.sorted) dims = (0, _arrayPluck2.default)(dimension.items, 'id');else dims = dimensionNameIdsMap[dimension.dimension];
	
	            nAxisWidth *= dims.length;
	            aUniqueFloorWidth.push(dims.length);
	            aAccFloorWidth.push(nAxisWidth);
	
	            return dims;
	        });
	    }();
	
	    nAxisHeight = aaUniqueFloorIds.length;
	
	    for (var i = 0; i < nAxisHeight; i++) {
	        aFloorSpan.push(nAxisWidth / aAccFloorWidth[i]);
	    }
	
	    var aaGuiFloorIds = aaUniqueFloorIds.map(function (ids, index) {
	        return (0, _arrayRepeat2.default)(ids, aAccFloorWidth[index - 1]);
	    });
	
	    var aaAllFloorIds = aaGuiFloorIds.map(function (id, index) {
	        return (0, _arrayRepeat2.default)(id, aFloorSpan[index], true);
	    });
	
	    var aaAllFloorObjects = aaAllFloorIds.map(function (ids, i) {
	
	        var siblingPosition = 0,
	            oldestObj = void 0;
	
	        return ids.map(function (id, j) {
	
	            var obj = {
	                id: aaAllFloorIds[i][j],
	                uuid: (0, _uuid2.default)(),
	                dim: i,
	                leaf: i === aaAllFloorIds.length - 1,
	                axis: type,
	                isOrganisationUnit: response.hasIdByDimensionName(aaAllFloorIds[i][j], 'ou')
	            };
	
	            uuidObjectMap[obj.uuid] = obj;
	
	            if (j % aFloorSpan[i] === 0) {
	                obj[spanType] = aFloorSpan[i];
	                obj.children = obj.leaf ? 0 : null;
	                obj.oldest = true;
	                obj.root = i === 0;
	                oldestObj = obj;
	                siblingPosition = 0;
	            }
	
	            obj.oldestSibling = oldestObj;
	            obj.siblingPosition = siblingPosition++;
	
	            if (aaUniqueFloorIds.length - 1 > i) {
	                obj.children = aaUniqueFloorIds[i + 1].length;
	            }
	
	            return obj;
	        });
	    });
	
	    // add parents if more than 1 floor
	    if (nAxisHeight > 1) {
	        for (var _i = 1, aAllFloor; _i < nAxisHeight; _i++) {
	            aAllFloor = aaAllFloorObjects[_i];
	
	            //for (let j = 0, obj, doorCount = 0, span = aFloorSpan[i - 1], parentObj = aaAllFloorObjects[i - 1][0]; j < aAllFloor.length; j++) {
	            for (var j = 0, doorCount = 0, span = aFloorSpan[_i - 1]; j < aAllFloor.length; j++) {
	                aAllFloor[j].parent = aaAllFloorObjects[_i - 1][j];
	            }
	        }
	    }
	
	    var _loop = function _loop(_ids, _i2) {
	        _ids = aaAllFloorIds.map(function (id) {
	            return id[_i2];
	        });
	
	        if (_ids.length) {
	            aCondoId.push(_ids.join('-'));
	        }
	        ids = _ids;
	    };
	
	    for (var _i2 = 0, ids; _i2 < nAxisWidth; _i2++) {
	        _loop(ids, _i2);
	    }
	
	    // add uuids array to leaves
	    if (aaAllFloorObjects.length) {
	
	        // set span to second lowest span number: if aFloorSpan == [15,3,15,1], set span to 3
	        var nSpan = nAxisHeight > 1 ? (0, _arraySort2.default)(aFloorSpan.slice())[1] : nAxisWidth,
	            aAllFloorObjectsLast = aaAllFloorObjects[aaAllFloorObjects.length - 1];
	
	        for (var _i3 = 0, leaf, parentUuids, obj, leafUuids = []; _i3 < aAllFloorObjectsLast.length; _i3++) {
	            leaf = aAllFloorObjectsLast[_i3];
	            leafUuids.push(leaf.uuid);
	            obj = leaf;
	            parentUuids = [];
	
	            // get the uuid of the oldest sibling
	            while (obj = obj.parent) {
	                parentUuids.push(!obj.root && obj.oldestSibling ? obj.oldestSibling.uuid : obj.uuid);
	            }
	
	            // add parent uuids to leaf
	            leaf.uuids = parentUuids.slice();
	
	            // add uuid for all leaves
	            if (leafUuids.length === nSpan) {
	                for (var _j = _i3 - nSpan + 1, _leaf; _j <= _i3; _j++) {
	                    var _leaf$uuids;
	
	                    _leaf = aAllFloorObjectsLast[_j];
	                    (_leaf$uuids = _leaf.uuids).push.apply(_leaf$uuids, _toConsumableArray(leafUuids));
	                }
	
	                leafUuids = [];
	            }
	        }
	    }
	
	    return {
	        type: type,
	        items: aDimensions,
	        xItems: {
	            unique: aaUniqueFloorIds,
	            gui: aaGuiFloorIds,
	            all: aaAllFloorIds
	        },
	        objects: {
	            all: aaAllFloorObjects
	        },
	        ids: aCondoId,
	        span: aFloorSpan,
	        dims: nAxisHeight,
	        size: nAxisWidth,
	        uuidObjectMap: uuidObjectMap
	    };
	};
	//# sourceMappingURL=PivotTableAxis.js.map

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FilterCell = exports.VerticalPaddingCell = exports.HorizontalPaddingCell = exports.PaddingCell = exports.DimensionLabelCell = exports.DimensionEmptyCell = exports.DimensionGrandTotalCell = exports.DimensionSubTotalCell = exports.ColumnAxisCell = exports.RowAxisCell = exports.ValueTotalCell = exports.ValueSubTotalCell = exports.PlainValueCell = exports.ValueCell = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ResponseRowIdCombination = __webpack_require__(35);
	
	var _PivotTableUtils = __webpack_require__(57);
	
	var _uuid = __webpack_require__(30);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @description factory function for cell with default options.
	 *  @returns {object}
	 */
	var DefaultCell = function DefaultCell() {
	    return {
	        htmlValue: '&nbsp;',
	
	        collapsed: false,
	        hidden: false,
	        empty: false,
	
	        colSpan: 1,
	        rowSpan: 1,
	
	        width: 120,
	        height: 25,
	
	        style: ''
	    };
	};
	
	var ValueCell = exports.ValueCell = function ValueCell(value, response, rric, uuids, htmlValue) {
	    var cell = DefaultCell();
	
	    cell.uuid = (0, _uuid2.default)();
	    cell.uuids = uuids;
	
	    cell.value = value;
	    cell.htmlValue = value === null || typeof value === 'undefined' ? '&nbsp;' : htmlValue ? htmlValue : value;
	
	    cell.isValue = !cell.empty;
	
	    cell.type = 'value';
	    cell.cls = 'pivot-value' + (cell.empty ? ' cursor-default' : '');
	
	    cell.dxId = rric.getIdByIds(response.metaData.dimensions.dx);
	    cell.peId = rric.getIdByIds(response.metaData.dimensions.pe);
	    cell.ouId = rric.getIdByIds(response.metaData.dimensions.ou);
	
	    return cell;
	};
	
	var PlainValueCell = exports.PlainValueCell = function PlainValueCell(value, rric, response) {
	    var cell = DefaultCell();
	
	    cell.value = value;
	    cell.type = 'value';
	    cell.cls = 'pivot-value' + (cell.empty ? ' cursor-default' : ' pointer');
	
	    cell.htmlValue = _typeof(!value) ? '&nbsp;' : value;
	
	    return cell;
	};
	
	var ValueSubTotalCell = exports.ValueSubTotalCell = function ValueSubTotalCell(value, htmlValue) {
	    var cell = DefaultCell();
	
	    cell.value = value;
	    cell.type = 'valueSubtotal';
	    cell.cls = 'pivot-value-subtotal';
	
	    cell.empty = value === null || typeof value === 'undefined';
	
	    if (typeof value === 'string') {
	        cell.htmlValue = value;
	    } else {
	        cell.htmlValue = cell.empty ? '&nbsp;' : htmlValue ? htmlValue : (0, _PivotTableUtils.getRoundedHtmlValue)(value);
	    }
	
	    return cell;
	};
	
	var ValueTotalCell = exports.ValueTotalCell = function ValueTotalCell(value, htmlValue) {
	    var cell = DefaultCell();
	
	    cell.value = value;
	    cell.type = 'valueTotal';
	    cell.cls = 'pivot-value-total-subgrandtotal';
	
	    cell.empty = value === null || typeof value === 'undefined';;
	
	    if (typeof value === 'string') {
	        cell.htmlValue = value;
	    } else {
	        cell.htmlValue = cell.empty ? '&nbsp;' : htmlValue ? htmlValue : (0, _PivotTableUtils.getRoundedHtmlValue)(value);
	    }
	
	    return cell;
	};
	
	var RowAxisCell = exports.RowAxisCell = function RowAxisCell(axisObject, response, showHierarchy, hidden) {
	
	    if (!axisObject) {
	        return null;
	    }
	
	    var cell = axisObject;
	
	    cell.collapsed = false;
	    cell.hidden = false;
	    cell.empty = false;
	    cell.width = 120;
	    cell.height = 25;
	
	    cell.type = 'dimension';
	    cell.axis = 'row';
	    cell.cls = 'pivot-dim pivot-row-dim td-nobreak';
	
	    if (showHierarchy) {
	        cell.csl += ' align-left';
	    }
	
	    cell.noBreak = true;
	    cell.hidden = typeof hidden === 'undefined' ? !(axisObject.rowSpan || axisObject.colSpan) : hidden;
	
	    var htmlValue = response.getItemName(cell.id, showHierarchy, true);
	
	    cell.htmlValue = htmlValue;
	    cell.title = htmlValue;
	
	    return cell;
	};
	
	var ColumnAxisCell = exports.ColumnAxisCell = function ColumnAxisCell(axisObject, response, showHierarchy, sort, hidden) {
	
	    if (!axisObject) {
	        return null;
	    }
	
	    var cell = axisObject;
	
	    cell.collapsed = false;
	    cell.hidden = false;
	    cell.empty = false;
	
	    cell.width = 120;
	    cell.height = 25;
	
	    cell.type = 'dimension';
	    cell.axis = 'column';
	    cell.cls = 'pivot-dim pivot-col-dim';
	
	    cell.noBreak = false;
	    cell.hidden = typeof hidden === 'undefined' ? !(axisObject.rowSpan || axisObject.colSpan) : hidden;
	
	    if (sort) {
	        cell.sort = sort;
	        cell.cls += ' td-sortable';
	    }
	
	    var htmlValue = response.getItemName(cell.id, showHierarchy, true);
	
	    cell.htmlValue = htmlValue;
	    cell.title = htmlValue;
	
	    return cell;
	};
	
	var DimensionSubTotalCell = exports.DimensionSubTotalCell = function DimensionSubTotalCell(value, colSpan, rowSpan, empty, hidden) {
	    var cell = DefaultCell();
	
	    cell.value = value;
	    cell.type = 'dimensionSubtotal';
	    cell.cls = 'pivot-dim-subtotal';
	
	    cell.colSpan = colSpan;
	    cell.rowSpan = rowSpan;
	
	    cell.empty = empty;
	    cell.hidden = hidden;
	
	    return cell;
	};
	
	var DimensionGrandTotalCell = exports.DimensionGrandTotalCell = function DimensionGrandTotalCell(value, colSpan, rowSpan, sort, generateUuid) {
	    var hidden = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	    var cell = DefaultCell();
	
	    cell.value = value;
	    cell.type = 'dimensionTotal';
	    cell.cls = 'pivot-dim-total';
	
	    cell.colSpan = colSpan;
	    cell.rowSpan = rowSpan;
	
	    cell.sort = sort ? 'total' : null;
	    cell.uuid = generateUuid ? (0, _uuid2.default)() : null;
	
	    cell.htmlValue = value;
	    cell.hidden = hidden;
	
	    return cell;
	};
	
	var DimensionEmptyCell = exports.DimensionEmptyCell = function DimensionEmptyCell(colSpan, rowSpan, hidden, style) {
	    var cell = DefaultCell();
	
	    cell.value = '&nbsp;';
	    cell.type = 'empty';
	    cell.cls = 'pivot-empty';
	
	    cell.colSpan = colSpan;
	    cell.rowSpan = rowSpan;
	
	    cell.width = colSpan * 120;
	    cell.height = rowSpan * 25;
	
	    cell.hidden = hidden;
	
	    cell.style = style;
	
	    return cell;
	};
	
	var DimensionLabelCell = exports.DimensionLabelCell = function DimensionLabelCell(value, dim) {
	    var cell = DefaultCell();
	
	    cell.value = value;
	    cell.type = 'labeled';
	    cell.cls = 'pivot-dim-label';
	
	    cell.dim = dim;
	    cell.axis = 'row';
	
	    cell.htmlValue = value;
	
	    return cell;
	};
	
	var PaddingCell = exports.PaddingCell = function PaddingCell() {
	    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var colSpan = arguments[2];
	    var rowSpan = arguments[3];
	    var hidden = arguments[4];
	
	    var cell = DefaultCell();
	
	    cell.value = '&nbsp;';
	    cell.type = 'padding';
	    cell.cls = 'pivot-padding';
	
	    cell.width = width;
	    cell.height = height;
	
	    cell.colSpan = colSpan;
	    cell.rowSpan = rowSpan;
	
	    cell.hidden = hidden;
	
	    return cell;
	};
	
	var HorizontalPaddingCell = exports.HorizontalPaddingCell = function HorizontalPaddingCell() {
	    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var cls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var hidden = arguments[2];
	
	    var cell = DefaultCell();
	
	    if (typeof hidden === 'undefined') {
	        hidden = width <= 0;
	    }
	
	    cell.value = '&nbsp;';
	    cell.type = 'padding';
	    cell.cls = 'pivot-padding ';
	
	    cell.cls += cls;
	
	    cell.width = width;
	
	    cell.hidden = hidden;
	
	    return cell;
	};
	
	var VerticalPaddingCell = exports.VerticalPaddingCell = function VerticalPaddingCell() {
	    var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var cls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var hidden = arguments[2];
	
	    var cell = DefaultCell();
	
	    if (typeof hidden === 'undefined') {
	        hidden = height <= 0;
	    }
	
	    cell.value = '&nbsp;';
	    cell.type = 'padding';
	    cell.cls = 'pivot-padding ';
	
	    cell.cls += cls;
	
	    cell.height = height;
	
	    cell.hidden = hidden;
	
	    return cell;
	};
	
	var FilterCell = exports.FilterCell = function FilterCell(text, colSpan) {
	    var cell = DefaultCell();
	
	    cell.cls = 'pivot-filter cursor-default', cell.type = 'filter', cell.colSpan = colSpan, cell.title = text, cell.htmlValue = text;
	
	    return cell;
	};
	//# sourceMappingURL=PivotTableCells.js.map

/***/ },
/* 151 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ChartDownloadButtonItems = exports.ChartDownloadButtonItems = undefined;
	
	exports.ChartDownloadButtonItems = ChartDownloadButtonItems = function ChartDownloadButtonItems(refs) {
	    var uiManager = refs.uiManager,
	        instanceManager = refs.instanceManager,
	        i18n = refs.i18nManager.get();
	
	    var getFilename = function getFilename() {
	        return instanceManager.getStateFavoriteName() || instanceManager.getStateCurrent().title || i18n.untitled;
	    };
	
	    return [{
	        xtype: 'label',
	        text: i18n.graphics,
	        style: 'padding:7px 5px 5px 7px; font-weight:bold'
	    }, {
	        text: i18n.image_png + ' (.png)',
	        iconCls: 'ns-menu-item-image',
	        handler: function handler() {
	            uiManager.submitSvgForm('png', getFilename());
	        }
	    }, {
	        text: 'PDF (.pdf)',
	        iconCls: 'ns-menu-item-image',
	        handler: function handler() {
	            uiManager.submitSvgForm('pdf', getFilename());
	        }
	    }];
	};
	//# sourceMappingURL=ChartDownloadButtonItems.js.map

/***/ },
/* 152 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ChartTypeToolbar = exports.ChartTypeToolbar = undefined;
	
	exports.ChartTypeToolbar = ChartTypeToolbar = function ChartTypeToolbar(refs) {
	    var appManager = refs.appManager,
	        uiManager = refs.uiManager,
	        instanceManager = refs.instanceManager,
	        i18n = refs.i18nManager.get(),
	        dimensionConfig = refs.dimensionConfig,
	        confData = dimensionConfig.get('data'),
	        confPeriod = dimensionConfig.get('period'),
	        confOrganisationUnit = dimensionConfig.get('organisationUnit'),
	        confCategory = dimensionConfig.get('category'),
	        chartConf = refs.chartConfig,
	        i18n = refs.i18nManager.get(),
	        buttons = [];
	
	    var buttonAddedListener = function buttonAddedListener(b) {
	        buttons.push(b);
	    };
	
	    var column = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.column,
	        iconCls: 'ns-button-icon-type-column',
	        name: chartConf.client.column,
	        tooltipText: i18n.column_chart,
	        pressed: true,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var stackedcolumn = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.stackedcolumn,
	        iconCls: 'ns-button-icon-type-columnstacked',
	        name: chartConf.client.stackedcolumn,
	        tooltipText: i18n.stacked_column_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var bar = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.bar,
	        iconCls: 'ns-button-icon-type-bar',
	        name: chartConf.client.bar,
	        tooltipText: i18n.bar_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var stackedbar = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.stackedbar,
	        iconCls: 'ns-button-icon-type-barstacked',
	        name: chartConf.client.stackedbar,
	        tooltipText: i18n.stacked_bar_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var line = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.line,
	        iconCls: 'ns-button-icon-type-line',
	        name: chartConf.client.line,
	        tooltipText: i18n.line_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var area = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.area,
	        iconCls: 'ns-button-icon-type-area',
	        name: chartConf.client.area,
	        tooltipText: i18n.area_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var pie = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.pie,
	        iconCls: 'ns-button-icon-type-pie',
	        name: chartConf.client.pie,
	        tooltipText: i18n.pie_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var radar = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.radar,
	        iconCls: 'ns-button-icon-type-radar',
	        name: chartConf.client.radar,
	        tooltipText: i18n.radar_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var gauge = Ext.create('Ext.button.Button', {
	        xtype: 'button',
	        chartType: chartConf.client.gauge,
	        iconCls: 'ns-button-icon-type-gauge',
	        name: chartConf.client.gauge,
	        tooltipText: i18n.meter_chart,
	        listeners: {
	            added: buttonAddedListener
	        }
	    });
	
	    var chartType = Ext.create('Ext.toolbar.Toolbar', {
	        height: 45,
	        style: 'padding-top:1px; border:0 none; border-top:1px solid #dadada',
	        reset: function reset() {
	            this.setChartType();
	        },
	        getChartType: function getChartType() {
	            for (var i = 0; i < buttons.length; i++) {
	                if (buttons[i].pressed) {
	                    return buttons[i].chartType;
	                }
	            }
	        },
	        setChartType: function setChartType(type) {
	            if (!type) {
	                buttons[0].toggle(true);
	                return;
	            }
	
	            for (var i = 0; i < buttons.length; i++) {
	                if (buttons[i].chartType === type) {
	                    buttons[i].toggle(true);
	                }
	            }
	        },
	        defaults: {
	            height: 40,
	            toggleGroup: 'charttype',
	            handler: function handler(b) {
	                if (!b.pressed) {
	                    b.toggle();
	                }
	            },
	            listeners: {
	                afterrender: function afterrender(b) {
	                    if (b.xtype === 'button') {
	                        Ext.create('Ext.tip.ToolTip', {
	                            target: b.getEl(),
	                            html: b.tooltipText,
	                            'anchor': 'bottom'
	                        });
	                    }
	                }
	            }
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.type,
	            style: 'font-size:11px; font-weight:bold; padding:13px 8px 0 6px'
	        }, column, stackedcolumn, bar, stackedbar, line, area, pie, radar, gauge]
	    });
	
	    return chartType;
	};
	//# sourceMappingURL=ChartTypeToolbar.js.map

/***/ },
/* 153 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ConfirmButton = exports.ConfirmButton = undefined;
	
	exports.ConfirmButton = ConfirmButton = function ConfirmButton(refs, _ref) {
	    var _ref$type = _ref.type,
	        type = _ref$type === undefined ? 'confirm' : _ref$type,
	        _ref$text = _ref.text,
	        text = _ref$text === undefined ? 'OK' : _ref$text,
	        _ref$fn = _ref.fn,
	        fn = _ref$fn === undefined ? Function.prototype : _ref$fn,
	        _ref$closeFn = _ref.closeFn,
	        closeFn = _ref$closeFn === undefined ? Function.prototype : _ref$closeFn,
	        _ref$applyConfig = _ref.applyConfig,
	        applyConfig = _ref$applyConfig === undefined ? {} : _ref$applyConfig;
	
	    var i18n = refs.i18nManager.get();
	
	    var defaults = {
	        padding: '0 3px',
	        borderRadius: '2px',
	        fontWeight: 'bold',
	        btnHeight: 29
	        //btnWidth: text ? null : 72
	    };
	
	    var typeStyle = {
	        'confirm': {
	            color: '#fff',
	            borderColor: '#3079ed',
	            background: '#619dff'
	        },
	        'close': {
	            color: '#555',
	            borderColor: '#ccc'
	        }
	    };
	
	    var style = _extends(defaults, typeStyle[type]);
	
	    return Ext.create('Ext.button.Button', _extends({
	        xtype: 'button',
	        //width: defaults.btnWidth,
	        height: defaults.btnHeight,
	        minWidth: 72,
	        text: '<span style="color:' + style.color + '; font-weight:' + style.fontWeight + '; padding:' + style.padding + '">' + text + '</span>',
	        style: 'border-color:' + style.borderColor + '; background:' + style.background + '; border-radius:' + style.borderRadius,
	        handler: function handler() {
	            fn();
	            closeFn();
	        }
	    }, applyConfig));
	};
	//# sourceMappingURL=ConfirmButton.js.map

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ConfirmWindow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ConfirmButton = __webpack_require__(153);
	
	var ConfirmWindow = exports.ConfirmWindow = undefined;
	
	exports.ConfirmWindow = ConfirmWindow = function ConfirmWindow(refs, title, msg, btnText, fn, applyConfig) {
	    var cancelFn = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : Function.prototype;
	    var closeOnAccept = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
	
	    applyConfig = applyConfig || {};
	
	    var i18n = refs.i18nManager.get();
	
	    var confirmButtonText = btnText || 'OK';
	    var cancelButtonText = i18n.cancel || 'Cancel';
	
	    var defaults = {
	        bodyStyle: 'background:#fff; border:0 none'
	    };
	
	    var closeFn = function closeFn() {
	        return window.destroy();
	    };
	
	    var confirmFn = function confirmFn() {
	        if (closeOnAccept) {
	            closeFn();
	            setTimeout(fn, 0);
	        } else {
	            fn();
	        }
	    };
	
	    var confirmButton = new _ConfirmButton.ConfirmButton(refs, { text: confirmButtonText, fn: confirmFn, closeFn: closeFn });
	    var cancelButton = new _ConfirmButton.ConfirmButton(refs, { type: 'close', text: cancelButtonText, fn: cancelFn, closeFn: closeFn });
	
	    var window = Ext.create('Ext.window.Window', _extends({
	        bodyStyle: 'background:#fff; padding:30px 60px 26px 42px',
	        defaults: defaults,
	        modal: true,
	        preventHeader: true,
	        resizable: false,
	        closeable: false,
	        items: [{
	            html: title,
	            bodyStyle: 'padding:0; border:0 none; font-size:16px',
	            style: 'margin-bottom:20px'
	        }, {
	            html: msg,
	            bodyStyle: 'padding:0; border:0 none; font-size:13px',
	            style: 'margin-bottom:16px'
	        }, {
	            layout: 'hbox',
	            defaults: defaults,
	            items: [confirmButton, {
	                width: 10
	            }, cancelButton]
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.setPosition(this.getPosition()[0], this.getPosition()[1] / 2);
	            },
	            show: function show() {
	                confirmButton.focus(false, 50);
	            }
	        }
	    }, applyConfig));
	
	    return window;
	};
	//# sourceMappingURL=ConfirmWindow.js.map

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EmbedButton = undefined;
	
	var _EmbedWindow = __webpack_require__(156);
	
	var EmbedButton = exports.EmbedButton = undefined;
	
	exports.EmbedButton = EmbedButton = function EmbedButton(c) {
	    var i18n = c.i18nManager.get();
	
	    return Ext.create('Ext.button.Button', {
	        text: i18n.embed,
	        disabled: true,
	        menu: {},
	        handler: function handler(b) {
	            (0, _EmbedWindow.EmbedWindow)(c).show();
	        }
	    });
	};
	//# sourceMappingURL=EmbedButton.js.map

/***/ },
/* 156 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var EmbedWindow = exports.EmbedWindow = undefined;
	
	exports.EmbedWindow = EmbedWindow = function EmbedWindow(c) {
	    var appManager = c.appManager,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        i18n = c.i18nManager.get();
	
	    var textArea = Ext.create('Ext.form.field.TextArea', {
	        width: 700,
	        height: 400,
	        readOnly: true,
	        cls: 'ns-textarea monospaced',
	        value: uiManager.getEmbedHtml()
	    });
	
	    var window = Ext.create('Ext.window.Window', {
	        title: i18n.embed_in_web_page,
	        layout: 'fit',
	        modal: true,
	        resizable: false,
	        items: textArea,
	        destroyOnBlur: true,
	        bbar: ['->', {
	            text: i18n.select,
	            handler: function handler() {
	                textArea.selectText();
	            }
	        }],
	        listeners: {
	            show: function show(w) {
	                uiManager.setAnchorPosition(w, 'favoriteButton');
	
	                uiManager.enableRightClick();
	
	                if (!w.hasDestroyOnBlurHandler) {
	                    uiManager.addDestroyOnBlurHandler(w);
	                }
	            },
	            hide: function hide() {
	                uiManager.disableRightClick();
	            }
	        }
	    });
	    uiManager.reg(window, 'embedWindow');
	
	    return window;
	};
	//# sourceMappingURL=EmbedWindow.js.map

/***/ },
/* 157 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var IntegrationButton = exports.IntegrationButton = undefined;
	
	exports.IntegrationButton = IntegrationButton = function IntegrationButton(refs, _ref) {
	    var isDefaultButton = _ref.isDefaultButton,
	        objectName = _ref.objectName,
	        moduleName = _ref.moduleName,
	        btnIconCls = _ref.btnIconCls,
	        btnText = _ref.btnText,
	        menuItem1Text = _ref.menuItem1Text,
	        menuItem2Text = _ref.menuItem2Text,
	        menuItem3Text = _ref.menuItem3Text;
	
	    var appManager = refs.appManager,
	        uiManager = refs.uiManager,
	        instanceManager = refs.instanceManager,
	        sessionStorageManager = refs.sessionStorageManager,
	        i18n = refs.i18nManager.get(),
	        path = appManager.getPath(),
	        config;
	
	    if (isDefaultButton) {
	        config = {
	            text: btnText,
	            iconCls: btnIconCls,
	            toggleGroup: 'module',
	            pressed: true,
	            handler: function handler() {
	                if (!this.pressed) {
	                    this.toggle();
	                }
	            }
	        };
	    } else {
	        config = {
	            text: btnText,
	            iconCls: btnIconCls,
	            toggleGroup: 'module',
	            menu: {},
	            handler: function handler(b) {
	                b.menu = Ext.create('Ext.menu.Menu', {
	                    closeAction: 'destroy',
	                    shadow: false,
	                    showSeparator: false,
	                    items: [{
	                        text: menuItem1Text + '&nbsp;&nbsp;',
	                        cls: 'ns-menu-item-noicon',
	                        listeners: {
	                            render: function render(b) {
	                                this.getEl().dom.addEventListener('click', function (e) {
	                                    if (!b.disabled) {
	                                        uiManager.redirectCtrl(path + '/' + moduleName, e);
	                                    }
	                                });
	                            }
	                        }
	                    }, '-', {
	                        text: menuItem2Text + '&nbsp;&nbsp;',
	                        cls: 'ns-menu-item-noicon',
	                        disabled: !instanceManager.isStateCurrent(),
	                        listeners: {
	                            render: function render(b) {
	                                this.getEl().dom.addEventListener('click', function (e) {
	                                    if (!b.disabled) {
	                                        var layout = instanceManager.getStateCurrent().toSession();
	                                        layout.parentGraphMap = uiManager.get('treePanel').getParentGraphMap();
	
	                                        sessionStorageManager.set(layout, 'analytical');
	
	                                        if (sessionStorageManager.supported) {
	                                            uiManager.redirectCtrl(path + '/' + moduleName + '/index.html?s=analytical', e);
	                                        }
	                                    }
	                                });
	                            }
	                        }
	                    }, {
	                        text: menuItem3Text + '&nbsp;&nbsp;',
	                        cls: 'ns-menu-item-noicon',
	                        disabled: !sessionStorageManager.get(objectName),
	                        listeners: {
	                            render: function render(b) {
	                                this.getEl().dom.addEventListener('click', function (e) {
	                                    if (!b.disabled) {
	                                        uiManager.redirectCtrl(path + '/' + moduleName + '/index.html?s=' + objectName, e);
	                                    }
	                                });
	                            }
	                        }
	                    }],
	                    listeners: {
	                        show: function show() {
	                            uiManager.setAnchorPosition(b.menu, b);
	                        },
	                        hide: function hide() {
	                            b.menu.destroy();
	                            uiManager.get('defaultIntegrationButton').toggle();
	                        },
	                        destroy: function destroy(m) {
	                            b.menu = null;
	                        }
	                    }
	                });
	
	                b.menu.show();
	            }
	        };
	    }
	
	    return Ext.create('Ext.button.Button', config);
	};
	//# sourceMappingURL=IntegrationButton.js.map

/***/ },
/* 158 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var LayoutButton = exports.LayoutButton = undefined;
	
	exports.LayoutButton = LayoutButton = function LayoutButton(refs) {
	    var uiManager = refs.uiManager;
	
	    var i18n = refs.i18nManager.get();
	
	    return Ext.create('Ext.button.Button', {
	        text: i18n.layout,
	        menu: {},
	        handler: function handler() {
	            uiManager.get('viewport').getLayoutWindow().show();
	        }
	    });
	};
	//# sourceMappingURL=LayoutButton.js.map

/***/ },
/* 159 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var LinkWindow = exports.LinkWindow = undefined;
	
	exports.LinkWindow = LinkWindow = function LinkWindow(c) {
	    var appManager = c.appManager,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        i18n = c.i18nManager.get(),
	        path = appManager.getPath(),
	        apiPath = appManager.getApiPath(),
	        apiEndpoint = instanceManager.apiEndpoint,
	        apiModule = instanceManager.apiModule;
	
	    var window = Ext.create('Ext.window.Window', {
	        title: i18n.favorite_link,
	        layout: 'fit',
	        modal: true,
	        resizable: false,
	        destroyOnBlur: true,
	        bodyStyle: 'padding:12px 12px 15px; background-color:#fff; font-size:11px',
	        html: function () {
	            var layout = instanceManager.getStateFavorite(),
	                appUrl = path + '/' + apiModule + '/index.html?id=' + layout.id,
	                apiUrl = apiPath + '/' + apiEndpoint + '/' + layout.id + '/data.html+css',
	                hStyle = 'padding-bottom:10px; font-weight:bold; color:#444',
	                html = '';
	
	            html += '<div style="' + hStyle + '">Open in this app</div>';
	            html += '<a class="user-select td-nobreak" target="_blank" href="' + appUrl + '">' + appUrl + '</a>';
	            html += '<br/><br/><br/>';
	            html += '<div style="' + hStyle + '">Open in web api</div>';
	            html += '<a class="user-select td-nobreak" target="_blank" href="' + apiUrl + '">' + apiUrl + '</a>';
	
	            return html;
	        }(),
	        listeners: {
	            show: function show(w) {
	                uiManager.setAnchorPosition(w, 'favoriteButton');
	
	                uiManager.enableRightClick();
	
	                if (!w.hasDestroyOnBlurHandler) {
	                    uiManager.addDestroyOnBlurHandler(w);
	                }
	            },
	            hide: function hide() {
	                uiManager.disableRightClick();
	            }
	        }
	    });
	    uiManager.reg(window, 'linkWindow');
	
	    return window;
	};
	//# sourceMappingURL=LinkWindow.js.map

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NorthRegion = undefined;
	
	var _AboutWindow = __webpack_require__(58);
	
	var _DateManager = __webpack_require__(23);
	
	var NorthRegion = exports.NorthRegion = undefined;
	
	exports.NorthRegion = NorthRegion = function NorthRegion(c, cmpConfig) {
	    var appManager = c.appManager,
	        instanceManager = c.instanceManager,
	        uiManager = c.uiManager,
	        i18nManager = c.i18nManager,
	        i18n = i18nManager.get(),
	        path = appManager.getPath();
	
	    // component
	    cmpConfig = cmpConfig || {};
	
	    cmpConfig.appName = appManager.appName || '';
	
	    cmpConfig.i18n = cmpConfig.i18n || {};
	    cmpConfig.i18n.about = cmpConfig.i18n.about || i18n.about || 'about';
	    cmpConfig.i18n.home = cmpConfig.i18n.home || i18n.home || 'home';
	    cmpConfig.i18n.untitled = cmpConfig.i18n.untitled || i18n.untitled || 'Untitled';
	
	    cmpConfig.theme = cmpConfig.theme || uiManager.getTheme();
	    cmpConfig.systemTitle = cmpConfig.systemTitle || appManager.systemSettings.systemTitle || 'DHIS 2';
	    cmpConfig.logoWidth = cmpConfig.logoWidth ? parseFloat(cmpConfig.logoWidth) : 418;
	    cmpConfig.aboutFn = cmpConfig.aboutFn || function () {
	        (0, _AboutWindow.AboutWindow)(c).getData();
	    };
	    cmpConfig.homeFn = cmpConfig.homeFn || function () {
	        var dest = path + '/dhis-web-commons-about/redirect.action';
	
	        if (instanceManager.isStateUnsaved()) {
	            uiManager.confirmUnsaved(i18n.leave_application, function () {
	                uiManager.disableConfirmUnload();
	                window.location.href = dest;
	            });
	        } else {
	            window.location.href = dest;
	        }
	    };
	
	    var cmp = {};
	
	    var setLogoWidth = function setLogoWidth(width, append) {
	        width = width || cmpConfig.logoWidth;
	        append = append || 0;
	
	        cmp.logo.setWidth(width + append);
	    };
	
	    var setState = function setState(layout, isFavorite) {
	        cmp.title.setState(layout, isFavorite);
	    };
	
	    return Ext.create('Ext.toolbar.Toolbar', {
	        componentCls: 'toolbar-north',
	        region: 'north',
	        cls: cmpConfig.theme + ' ' + cmpConfig.cls,
	        cmp: cmp,
	        setLogoWidth: setLogoWidth,
	        setState: setState,
	        items: function () {
	            var defaultTitleText = cmpConfig.i18n.untitled;
	
	            cmp.logo = Ext.create('Ext.toolbar.TextItem', {
	                cls: 'logo',
	                width: cmpConfig.logoWidth,
	                html: '<span class="brand">' + cmpConfig.systemTitle + '</span> ' + cmpConfig.appName
	            });
	
	            cmp.title = Ext.create('Ext.toolbar.TextItem', {
	                cls: 'title untitled user-select',
	                titleText: '',
	                appendixText: '',
	                text: defaultTitleText,
	                updateTitle: function updateTitle() {
	                    this.update(this.titleText ? this.titleText + this.appendixText : defaultTitleText);
	                },
	                setTitle: function setTitle(name) {
	                    this.titleText = name || '';
	                    //this.updateTitle();
	                },
	                setTitleAppendix: function setTitleAppendix(text) {
	                    this.appendixText = text ? '<span class="appendix">[' + _DateManager.DateManager.getYYYYMMDD(text, true) + ']</span>' : '';
	                    //this.updateTitle();
	                },
	                setStateSaved: function setStateSaved() {
	                    this.getEl().removeCls('unsaved');
	                    this.getEl().removeCls('untitled');
	                },
	                setStateUnsaved: function setStateUnsaved() {
	                    if (this.titleText) {
	                        this.getEl().removeCls('untitled');
	                        this.getEl().addCls('unsaved');
	                    }
	                },
	                setStateNew: function setStateNew() {
	                    this.getEl().removeCls('unsaved');
	                    this.getEl().addCls('untitled');
	                },
	                setState: function setState(layout, isFavorite) {
	                    if (layout) {
	                        if (isFavorite && layout.displayName) {
	                            this.setTitle(layout.displayName);
	                            this.setTitleAppendix(layout.relativePeriodDate);
	                            this.setStateSaved();
	                        } else {
	                            this.setTitleAppendix();
	                            this.setStateUnsaved();
	                        }
	                    } else {
	                        this.setTitle();
	                        this.setTitleAppendix();
	                        this.setStateNew();
	                    }
	
	                    this.updateTitle();
	                }
	            });
	
	            uiManager.reg(cmp.about = Ext.create('Ext.toolbar.TextItem', {
	                cls: 'about',
	                html: cmpConfig.i18n.about,
	                listeners: {
	                    render: function render(ti) {
	                        var el = ti.getEl();
	
	                        el.on('mouseover', function () {
	                            el.addCls('hover');
	                        });
	
	                        el.on('mouseout', function () {
	                            el.removeCls('hover');
	                        });
	
	                        el.on('click', function () {
	                            cmpConfig.aboutFn();
	                        });
	
	                        el.rendered = true;
	                    }
	                }
	            }), 'aboutButton');
	
	            uiManager.reg(cmp.home = Ext.create('Ext.toolbar.TextItem', {
	                cls: 'about home',
	                html: cmpConfig.i18n.home,
	                listeners: {
	                    render: function render(ti) {
	                        var el = ti.getEl();
	
	                        el.on('mouseover', function () {
	                            el.addCls('hover');
	                        });
	
	                        el.on('mouseout', function () {
	                            el.removeCls('hover');
	                        });
	
	                        el.on('click', function () {
	                            cmpConfig.homeFn();
	                        });
	
	                        el.rendered = true;
	                    }
	                }
	            }), 'homeButton');
	
	            return [cmp.logo, cmp.title, '->', cmp.about, cmp.home, ' ', ' '];
	        }()
	    });
	};
	//# sourceMappingURL=NorthRegion.js.map

/***/ },
/* 161 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var OptionsButton = exports.OptionsButton = undefined;
	
	exports.OptionsButton = OptionsButton = function OptionsButton(refs) {
	    var uiManager = refs.uiManager;
	
	    var i18n = refs.i18nManager.get();
	
	    return Ext.create('Ext.button.Button', {
	        text: i18n.options,
	        menu: {},
	        handler: function handler() {
	            uiManager.get('viewport').getOptionsWindow().show();
	        }
	    });
	};
	//# sourceMappingURL=OptionsButton.js.map

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var layout = _ref.layout,
	        i18n = _ref.i18n;
	
	    // Load Favorite textfield
	    var _getFavoriteTextCmp = (0, _FavoriteTextCmp2.default)({ layout: layout, i18n: i18n }),
	        nameTextField = _getFavoriteTextCmp.nameTextField,
	        descriptionTextField = _getFavoriteTextCmp.descriptionTextField,
	        titleTextField = _getFavoriteTextCmp.titleTextField;
	
	    // Customise them for translate Panel
	
	
	    delete nameTextField.height;
	    delete titleTextField.height;
	    delete descriptionTextField.height;
	
	    nameTextField.emptyText = i18n.no_translation_for_name;
	
	    if (!layout.title) {
	        titleTextField['disabled'] = true;
	        titleTextField.emptyText = i18n.no_title;
	    } else {
	        titleTextField.emptyText = i18n.no_translation_for_title;
	    }
	
	    if (!layout.description) {
	        descriptionTextField['disabled'] = true;
	        descriptionTextField.emptyText = i18n.no_description;
	    } else {
	        descriptionTextField.emptyText = i18n.no_translation_for_description;
	    }
	
	    // Create labels for keys
	    var getLabelKey = function getLabelKey(text) {
	        return Ext.create('Ext.panel.Panel', {
	            style: 'margin-bottom:0',
	            bodyStyle: 'font-size:11px; color:#666; padding-left:6px; padding-top:3px; border:0 none',
	            html: text
	        });
	    };
	
	    var nameLabelKey = getLabelKey(layout.name);
	    var titleLabelKey = getLabelKey(layout.title);
	    var descriptionLabelKey = getLabelKey(layout.description);
	
	    return {
	        nameTextField: nameTextField,
	        nameLabelKey: nameLabelKey,
	        titleTextField: titleTextField,
	        titleLabelKey: titleLabelKey,
	        descriptionTextField: descriptionTextField,
	        descriptionLabelKey: descriptionLabelKey
	    };
	};
	
	var _FavoriteTextCmp = __webpack_require__(36);
	
	var _FavoriteTextCmp2 = _interopRequireDefault(_FavoriteTextCmp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=TranslateTextCmp.js.map

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TranslateWindow = undefined;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _TranslateTextCmp = __webpack_require__(162);
	
	var _TranslateTextCmp2 = _interopRequireDefault(_TranslateTextCmp);
	
	var _FavoriteStyle = __webpack_require__(24);
	
	var _FavoriteStyle2 = _interopRequireDefault(_FavoriteStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TranslateWindow = exports.TranslateWindow = undefined;
	
	exports.TranslateWindow = TranslateWindow = function TranslateWindow(refs, layout, fn, listeners) {
	    var t = this,
	        appManager = refs.appManager,
	        uiManager = refs.uiManager,
	        instanceManager = refs.instanceManager,
	        i18n = refs.i18nManager.get(),
	        api = refs.api,
	        path = appManager.getPath(),
	        apiEndpoint = instanceManager.apiEndpoint;
	
	    listeners = listeners || {};
	
	    var _getTranslateTextCmp = (0, _TranslateTextCmp2.default)({ layout: layout, i18n: i18n }),
	        nameTextField = _getTranslateTextCmp.nameTextField,
	        nameLabelKey = _getTranslateTextCmp.nameLabelKey,
	        titleTextField = _getTranslateTextCmp.titleTextField,
	        titleLabelKey = _getTranslateTextCmp.titleLabelKey,
	        descriptionTextField = _getTranslateTextCmp.descriptionTextField,
	        descriptionLabelKey = _getTranslateTextCmp.descriptionLabelKey;
	
	    var translations = {};
	    var textfieldPropertyMapping = {};
	
	    var onEventLocaleSelect = function onEventLocaleSelect() {
	        var locale = localeComboBox.getValue();
	
	        // Initialise map between db property and textfield
	        textfieldPropertyMapping = {
	            NAME: nameTextField,
	            SHORT_NAME: titleTextField,
	            DESCRIPTION: descriptionTextField
	        };
	
	        // By default set them to empty
	        for (var property in textfieldPropertyMapping) {
	            textfieldPropertyMapping[property].setValue('');
	        }
	
	        // If any value is found, change textfield value
	        translations.forEach(function (trn) {
	            if (trn.locale === locale) {
	                if (trn.property in textfieldPropertyMapping) {
	                    textfieldPropertyMapping[trn.property].setValue(trn.value);
	                }
	            }
	        });
	
	        // Display translate Panel
	        translatePanel.show();
	    };
	
	    var localeStore = Ext.create('Ext.data.Store', {
	        fields: ['locale', 'name'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(path + '/api/locales/db.json?paging=false'),
	            reader: {
	                type: 'json'
	            },
	            pageParam: false,
	            startParam: false,
	            limitParam: false
	        }
	    });
	
	    var localeComboBox = Ext.create('Ext.form.ComboBox', {
	        cls: 'ns-combo',
	        width: _FavoriteStyle2.default.windowCmpWidth,
	        height: 45,
	        style: 'margin:2px 5px 0',
	        fieldStyle: 'padding-right:0; padding-left:5px; margin-bottom:3px; font-size:11px; line-height:13px;',
	        fieldLabel: i18n.select_a_locale_to_enter_translations_for,
	        labelAlign: 'top',
	        labelStyle: 'font-size:11px;font-weight:bold;color:#111;padding-top:4px;margin-bottom:2px',
	        labelSeparator: '',
	        store: localeStore,
	        queryMode: 'local',
	        displayField: 'name',
	        valueField: 'locale',
	        emptyText: i18n.select_locale,
	        listeners: {
	            select: function select(locale) {
	                onEventLocaleSelect();
	            }
	        }
	    });
	
	    var translatePanel = Ext.create('Ext.form.Panel', {
	        bodyStyle: 'border-style:none',
	        style: 'margin-bottom:0',
	        hidden: true,
	        defaults: {
	            bodyStyle: 'border-style:none',
	            style: 'margin-bottom:15px'
	        },
	        items: [{
	            items: [nameTextField, nameLabelKey]
	        }, {
	            items: [titleTextField, titleLabelKey]
	        }, {
	            items: [descriptionTextField, descriptionLabelKey]
	        }]
	    });
	
	    var saveButton = Ext.create('Ext.button.Button', {
	        text: i18n.save,
	        handler: function handler() {
	            var locale = localeComboBox.getValue();
	
	            // Remove existing translation for this locale
	            var i = translations.length;
	            while (i--) {
	                if (translations[i].locale == locale) {
	                    if (translations[i].property in textfieldPropertyMapping) {
	                        translations.splice(i, 1);
	                    }
	                }
	            }
	
	            // Add translation if value is not empyty
	            var newTranslations = [].concat(translations);
	            for (var property in textfieldPropertyMapping) {
	                if (textfieldPropertyMapping[property].getValue() != '') {
	                    newTranslations.push({
	                        property: property,
	                        locale: locale,
	                        value: textfieldPropertyMapping[property].getValue()
	                    });
	                }
	            }
	
	            // Update server with translations
	            $.ajax({
	                url: encodeURI(path + '/api/' + apiEndpoint + '/' + layout.id + '/translations/'),
	                type: 'PUT',
	                data: JSON.stringify({ translations: newTranslations }),
	                dataType: 'json',
	                headers: appManager.defaultRequestHeaders,
	                success: function success(obj, _success, r) {
	                    instanceManager.getById(null, function (layout, isFavorite) {
	                        instanceManager.getReport(layout, isFavorite, false, false, function () {
	                            uiManager.unmask();
	                        });
	                    });
	
	                    window.destroy();
	                }
	            });
	        }
	    });
	
	    var cancelButton = Ext.create('Ext.button.Button', {
	        text: i18n.cancel,
	        handler: function handler() {
	            window.destroy();
	        }
	    });
	
	    var window = Ext.create('Ext.window.Window', {
	        cls: 'ns-accordion',
	        title: 'Translate',
	        bodyStyle: 'padding:1px; background:#fff',
	        resizable: false,
	        modal: true,
	        items: [localeComboBox, translatePanel],
	        destroyOnBlur: true,
	        bbar: [cancelButton, '->', saveButton],
	        listeners: {
	            show: function show(w) {
	                // Load locales
	                localeStore.load();
	
	                // Load translations for all languages
	                Ext.Ajax.request({
	                    url: encodeURI(path + '/api/' + apiEndpoint + '/' + layout.id + '/translations.json?paging=false'),
	                    disableCaching: false,
	                    success: function success(r) {
	                        translations = Ext.decode(r.responseText).translations;
	                    }
	                });
	
	                var favoriteButton = uiManager.get('favoriteButton') || {};
	
	                if (favoriteButton.rendered) {
	                    uiManager.setAnchorPosition(w, favoriteButton);
	
	                    if (!w.hasDestroyOnBlurHandler) {
	                        uiManager.addDestroyOnBlurHandler(w);
	                    }
	                }
	
	                localeComboBox.focus(false, 500);
	
	                if (listeners.show) {
	                    listeners.show();
	                }
	            },
	            destroy: function destroy() {
	                if (listeners.destroy) {
	                    listeners.destroy();
	                }
	            }
	        }
	    });
	
	    return window;
	};
	//# sourceMappingURL=TranslateWindow.js.map

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Viewport = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isNumber = __webpack_require__(9);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isIE = __webpack_require__(182);
	
	var _isIE2 = _interopRequireDefault(_isIE);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayClean = __webpack_require__(7);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arraySort = __webpack_require__(8);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _clone = __webpack_require__(28);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _FavoriteWindow = __webpack_require__(37);
	
	var _InterpretationItem = __webpack_require__(62);
	
	var _PluginItem = __webpack_require__(63);
	
	var _FavoriteButton = __webpack_require__(60);
	
	var _EmbedButton = __webpack_require__(155);
	
	var _EastRegion = __webpack_require__(59);
	
	var _LayoutButton = __webpack_require__(158);
	
	var _OptionsButton = __webpack_require__(161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Viewport = exports.Viewport = undefined;
	
	exports.Viewport = Viewport = function Viewport(refs, cmp, config) {
	    var uiManager = refs.uiManager,
	        appManager = refs.appManager,
	        i18nManager = refs.i18nManager,
	        sessionStorageManager = refs.sessionStorageManager,
	        instanceManager = refs.instanceManager,
	        calendarManager = refs.calendarManager,
	        dimensionConfig = refs.dimensionConfig,
	        periodConfig = refs.periodConfig,
	        uiConfig = refs.uiConfig,
	        optionConfig = refs.optionConfig,
	        api = refs.api,
	        apiPath = appManager.getApiPath(),
	        i18n = i18nManager.get(),
	        dataObjectName = dimensionConfig.get('data').objectName,
	        indicatorObjectName = dimensionConfig.get('indicator').objectName,
	        dataElementObjectName = dimensionConfig.get('dataElement').objectName,
	        operandObjectName = dimensionConfig.get('operand').objectName,
	        dataSetObjectName = dimensionConfig.get('dataSet').objectName,
	        eventDataItemObjectName = dimensionConfig.get('eventDataItem').objectName,
	        programIndicatorObjectName = dimensionConfig.get('programIndicator').objectName,
	        periodObjectName = dimensionConfig.get('period').objectName,
	        organisationUnitObjectName = dimensionConfig.get('organisationUnit').objectName,
	        treePanel = uiManager.get('treePanel'),
	        layoutWindow = uiManager.get('layoutWindow'),
	        optionsWindow = uiManager.get('optionsWindow'),
	        favoriteWindow = uiManager.get('favoriteWindow'),
	        displayProperty = appManager.getDisplayProperty(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl(),
	        dimensionPanelMap = {};
	
	    cmp = cmp || {};
	
	    var northRegion = cmp.northRegion;
	
	    var eastRegion = cmp.eastRegion;
	
	    var westRegionItems = cmp.westRegionItems;
	
	    var chartTypeToolbar = cmp.chartTypeToolbar;
	
	    var getChartType = function getChartType() {
	        return chartTypeToolbar ? chartTypeToolbar.getChartType() : null;
	    };
	
	    var dataTypeToolbar = cmp.dataTypeToolbar;
	
	    var getDataType = function getDataType() {
	        return dataTypeToolbar ? dataTypeToolbar.getDataType() : null;
	    };
	
	    var statusBar = cmp.statusBar;
	
	    var favoriteButton = uiManager.reg((0, _FavoriteButton.FavoriteButton)(refs), 'favoriteButton');
	
	    var layoutButton = uiManager.reg((0, _LayoutButton.LayoutButton)(refs), 'layoutButton');
	
	    var optionsButton = uiManager.reg((0, _OptionsButton.OptionsButton)(refs), 'optionsButton');
	
	    var embedButton = uiManager.reg((0, _EmbedButton.EmbedButton)(refs), 'embedButton', 'onCurrent');
	
	    var integrationButtons = cmp.integrationButtons;
	
	    var DownloadButtonItems = cmp.DownloadButtonItems;
	
	    var detailsButton = Ext.create('Ext.Button', {
	        id: "toggleEastRegionButton",
	        text: ' ',
	        width: 26,
	        padding: '3',
	        iconCls: 'ns-button-icon-arrowlefttriple',
	        iconState: 1,
	        setIconState: function setIconState() {
	            switch (this.iconState++ % 2) {
	                case 1:
	                    this.el.dom.style.visibility = "hidden";break;
	                case 0:
	                    this.el.dom.style.visibility = "visible";break;
	            }
	        },
	        handler: function handler(b) {
	            eastRegion.toggleCollapse();
	            this.setIconState();
	        }
	    });
	
	    // viewport
	
	    //var accordionBody = Ext.create('Ext.panel.Panel', {
	    //layout: 'accordion',
	    //activeOnTop: true,
	    //cls: 'ns-accordion',
	    //bodyStyle: 'border:0 none; margin-bottom:2px',
	    //height: 700,
	    //dimensionPanels: null,
	    //items: westRegionItems
	    //});
	    //uiManager.reg(accordionBody, 'accordionBody');
	
	    //var accordion = Ext.create('Ext.panel.Panel', {
	    //bodyStyle: 'border-style:none; border-top:1px solid #d6d6d6; padding:1px; padding-bottom:0; overflow-y:scroll;',
	    //items: accordionBody,
	    //setThisHeight: function(mx) {
	    //var panelHeight = westRegionItems.length * 28,
	    //height;
	
	    //if (westRegion.hasScrollbar) {
	    //height = panelHeight + mx;
	    //this.setHeight(westRegion.getHeight() - 2);
	    //accordionBody.setHeight(height - 2);
	    //}
	    //else {
	    //height = westRegion.getHeight() - uiConfig.west_fill;
	    //mx += panelHeight;
	    //accordion.setHeight((height > mx ? mx : height) - 2);
	    //accordionBody.setHeight((height > mx ? mx : height) - 4);
	    //}
	    //},
	    //getExpandedPanel: function() {
	    //for (var i = 0, panel; i < westRegionItems.length; i++) {
	    //if (!westRegionItems[i].collapsed) {
	    //return westRegionItems[i];
	    //}
	    //}
	
	    //return null;
	    //},
	    //getFirstPanel: function() {
	    //return accordionBody.items.items[0];
	    //}
	    //});
	    //uiManager.reg(accordion, 'accordion');
	
	    var westRegion = Ext.create('Ext.panel.Panel', {
	        region: 'west',
	        preventHeader: true,
	        collapsible: true,
	        collapseMode: 'mini',
	        border: false,
	        hasScrollbar: false,
	        hasChartTypeToolbar: function hasChartTypeToolbar() {
	            return !!chartTypeToolbar;
	        },
	        width: uiConfig.west_width + uiManager.getScrollbarSize().width,
	        items: (0, _arrayClean2.default)([chartTypeToolbar, dataTypeToolbar, westRegionItems]),
	        onScrollbar: function onScrollbar() {
	            this.hasScrollbar = true;
	
	            if (dataTypeToolbar) {
	                dataTypeToolbar.setButtonWidth(uiManager.getScrollbarSize().width, true);
	            }
	        },
	        setState: function setState(layout) {
	            westRegionItems.setUiState(layout);
	        }
	    });
	    uiManager.reg(westRegion, 'westRegion');
	
	    var updateButton = Ext.create('Ext.button.Split', {
	        text: '<b>' + i18n.update + '</b>&nbsp;',
	        handler: function handler() {
	            instanceManager.getReport();
	        },
	        arrowHandler: function arrowHandler(b) {
	            b.menu = Ext.create('Ext.menu.Menu', {
	                closeAction: 'destroy',
	                shadow: false,
	                showSeparator: false,
	                items: [{
	                    xtype: 'label',
	                    text: i18n.download_data,
	                    style: 'padding:7px 40px 5px 7px; font-weight:bold; color:#111; border:0 none'
	                }, {
	                    text: 'CSV',
	                    iconCls: 'ns-menu-item-datasource',
	                    handler: function handler() {
	                        uiManager.openDataDump(null, 'csv');
	                    }
	                }],
	                listeners: {
	                    show: function show() {
	                        uiManager.setAnchorPosition(b.menu, b);
	                    },
	                    hide: function hide() {
	                        b.menu.destroy();
	                    },
	                    destroy: function destroy(m) {
	                        b.menu = null;
	                    }
	                }
	            });
	
	            this.menu.show();
	        }
	    });
	    uiManager.reg(updateButton, 'updateButton');
	
	    var downloadButton = Ext.create('Ext.button.Button', {
	        text: i18n.download,
	        disabled: true,
	        menu: {},
	        handler: function handler(b) {
	            b.menu = Ext.create('Ext.menu.Menu', {
	                closeAction: 'destroy',
	                shadow: false,
	                showSeparator: false,
	                items: function () {
	                    var layout = instanceManager.getStateCurrent();
	
	                    var jsonReq = layout.req();
	                    var xmlReq = layout.req(null, 'xml');
	                    var xlsReq = layout.req(null, 'xls');
	                    var csvReq = layout.req(null, 'csv');
	                    var jrxmlReq = layout.req(null, 'jrxml');
	                    var sqlReq = layout.req('/analytics/debug/sql', 'sql');
	                    var dataValueSetJsonReq = layout.req('/analytics/dataValueSet', 'json', null, null, true);
	                    var dataValueSetXmlReq = layout.req('/analytics/dataValueSet', 'xml', null, null, true);
	
	                    var items = [].concat(_toConsumableArray(DownloadButtonItems(refs)), [{
	                        xtype: 'menuseparator'
	                    }, {
	                        xtype: 'label',
	                        text: i18n.plain_data_sources,
	                        style: 'padding:7px 5px 5px 7px; font-weight:bold'
	                    }, {
	                        text: 'JSON',
	                        iconCls: 'ns-menu-item-datasource',
	                        handler: function handler() {
	                            uiManager.openPlainDataSource(jsonReq, null, true);
	                        },
	                        menu: [{
	                            xtype: 'label',
	                            text: i18n.metadata_id_scheme,
	                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
	                        }, {
	                            text: 'ID',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(jsonReq, '&outputIdScheme=UID', true);
	                            }
	                        }, {
	                            text: 'Code',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(jsonReq, '&outputIdScheme=CODE', true);
	                            }
	                        }, {
	                            text: 'Name',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(jsonReq, '&outputIdScheme=NAME', true);
	                            }
	                        }]
	                    }, {
	                        text: 'XML',
	                        iconCls: 'ns-menu-item-datasource',
	                        handler: function handler() {
	                            uiManager.openPlainDataSource(xmlReq, null, true);
	                        },
	                        menu: [{
	                            xtype: 'label',
	                            text: i18n.metadata_id_scheme,
	                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
	                        }, {
	                            text: 'ID',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(xmlReq, '&outputIdScheme=UID', true);
	                            }
	                        }, {
	                            text: 'Code',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(xmlReq, '&outputIdScheme=CODE', true);
	                            }
	                        }, {
	                            text: 'Name',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(xmlReq, '&outputIdScheme=NAME', true);
	                            }
	                        }]
	                    }, {
	                        text: 'Microsoft Excel',
	                        iconCls: 'ns-menu-item-datasource',
	                        handler: function handler() {
	                            uiManager.openPlainDataSource(xlsReq);
	                        },
	                        menu: [{
	                            xtype: 'label',
	                            text: i18n.metadata_id_scheme,
	                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
	                        }, {
	                            text: 'ID',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(xlsReq, '&outputIdScheme=UID');
	                            }
	                        }, {
	                            text: 'Code',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(xlsReq, '&outputIdScheme=CODE');
	                            }
	                        }, {
	                            text: 'Name',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(xlsReq, '&outputIdScheme=NAME');
	                            }
	                        }]
	                    }, {
	                        text: 'CSV',
	                        iconCls: 'ns-menu-item-datasource',
	                        handler: function handler() {
	                            uiManager.openPlainDataSource(csvReq);
	                        },
	                        menu: [{
	                            xtype: 'label',
	                            text: i18n.metadata_id_scheme,
	                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
	                        }, {
	                            text: 'ID',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(csvReq, '&outputIdScheme=UID');
	                            }
	                        }, {
	                            text: 'Code',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(csvReq, '&outputIdScheme=CODE');
	                            }
	                        }, {
	                            text: 'Name',
	                            iconCls: 'ns-menu-item-scheme',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(csvReq, '&outputIdScheme=NAME');
	                            }
	                        }]
	                    }, {
	                        text: i18n.advanced,
	                        iconCls: 'ns-menu-item-advanced',
	                        menu: [{
	                            xtype: 'label',
	                            text: i18n.data_value_set,
	                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
	                        }, {
	                            text: 'JSON',
	                            iconCls: 'ns-menu-item-datasource',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(dataValueSetJsonReq, null, true);
	                            }
	                        }, {
	                            text: 'XML',
	                            iconCls: 'ns-menu-item-datasource',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(dataValueSetXmlReq, null, true);
	                            }
	                        }, {
	                            xtype: 'menuseparator'
	                        }, {
	                            xtype: 'label',
	                            text: i18n.other_formats,
	                            style: 'padding:7px 18px 5px 7px; font-weight:bold; color:#333'
	                        }, {
	                            text: 'JRXML',
	                            iconCls: 'ns-menu-item-datasource',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(jrxmlReq, null, true);
	                            }
	                        }, {
	                            text: i18n.raw_data + ' SQL',
	                            iconCls: 'ns-menu-item-datasource',
	                            handler: function handler() {
	                                uiManager.openPlainDataSource(sqlReq, null, true);
	                            }
	                        }]
	                    }]);
	
	                    if (layout && !!layout.showHierarchy && layout.hasDimension('ou')) {
	                        items.push({
	                            xtype: 'label',
	                            text: i18n.plain_data_sources + ' w/ hierarchy',
	                            style: 'padding:7px 8px 5px 7px; font-weight:bold'
	                        });
	
	                        items.push({
	                            text: 'CSV',
	                            iconCls: 'ns-menu-item-datasource',
	                            handler: function handler() {
	                                layout.getResponse().clone().addOuHierarchyDimensions().printResponseCSV();
	                            }
	                        });
	                    }
	
	                    return items;
	                }(),
	                listeners: {
	                    show: function show() {
	                        uiManager.setAnchorPosition(b.menu, b);
	                    },
	                    hide: function hide() {
	                        b.menu.destroy();
	                    },
	                    destroy: function destroy(m) {
	                        b.menu = null;
	                    }
	                }
	            });
	
	            this.menu.show();
	        }
	    });
	    uiManager.reg(downloadButton, 'downloadButton', 'onCurrent');
	
	    var defaultButton = Ext.create('Ext.button.Button', {
	        text: i18n.table,
	        iconCls: 'ns-button-icon-table',
	        toggleGroup: 'module',
	        pressed: true
	    });
	
	    var centerRegion = Ext.create('Ext.panel.Panel', {
	        region: 'center',
	        bodyStyle: 'padding:1px',
	        autoScroll: true,
	        fullSize: true,
	        cmp: [defaultButton],
	        toggleCmp: function toggleCmp(show) {
	            integrationButtons.forEach(function (cmp) {
	                if (cmp && cmp.show && cmp.hide) {
	                    if (show) {
	                        cmp.show();
	                    } else {
	                        cmp.hide();
	                    }
	                }
	            });
	        },
	        subscribed: [],
	        subscribe: function subscribe(fn) {
	            this.subscribed.push(fn);
	        },
	        renew: function renew(html) {
	            this.update(html);
	            this.subscribed.forEach(function (fn) {
	                fn();
	            });
	        },
	        setScroll: function setScroll(fn) {
	            this.onScroll = fn;
	        },
	        removeScroll: function removeScroll() {
	            this.onScroll = Function.prototype;
	        },
	        setOnResize: function setOnResize(fn) {
	            this.onResize = fn;
	        },
	        removeOnResize: function removeOnResize() {
	            this.onResize = Function.prototype;;
	        },
	        setSidePanelsUIState: function setSidePanelsUIState(favoriteId, interpretationId) {
	            // If there is an interpretation loaded, collapse left panel and expand right panel
	            if (interpretationId) {
	                Ext.getCmp('toggleEastRegionButton').handler();
	                Ext.getCmp('toggleWestRegionButton').handler();
	
	                if (favoriteId && interpretationId == "new") {
	                    eastRegion.openInterpretationWindow(favoriteId);
	                }
	            }
	        },
	        scrollTo: function scrollTo(x, y) {
	            this.body.dom.scrollTo(x, y);
	        },
	        toggleEastRegion: function toggleEastRegion() {
	            detailsButton.setIconState();
	        },
	        onScroll: Function.prototype,
	        tbar: {
	            defaults: {
	                height: 26
	            },
	            items: [{
	                id: "toggleWestRegionButton",
	                text: ' ',
	                width: 26,
	                padding: '3',
	                iconCls: 'ns-button-icon-arrowlefttriple',
	                iconClsLeft: 'ns-button-icon-arrowlefttriple',
	                iconClsRight: 'ns-button-icon-arrowrighttriple',
	                iconState: 0,
	                setIconState: function setIconState() {
	                    this.setIconCls(this.iconState++ % 2 ? this.iconClsLeft : this.iconClsRight);
	                },
	                handler: function handler(b) {
	                    westRegion.toggleCollapse();
	                    this.setIconState();
	                }
	            }, ' ', updateButton, favoriteButton, {
	                xtype: 'tbseparator',
	                height: 24,
	                style: 'border-color:transparent; border-right-color:#d1d1d1; margin-right:4px'
	            }, layoutButton, optionsButton, {
	                xtype: 'tbseparator',
	                height: 24,
	                style: 'border-color:transparent; border-right-color:#d1d1d1; margin-right:4px'
	            }, downloadButton, embedButton, '->'].concat(_toConsumableArray(integrationButtons), [detailsButton])
	        },
	        bbar: statusBar,
	        listeners: {
	            render: function render(p) {
	                p.body.on('scroll', function (e) {
	                    this.onScroll(e);
	                }, p);
	            },
	            resize: {
	                fn: function fn(e) {
	                    this.onResize(e);
	                }
	            }
	        }
	    });
	    uiManager.reg(centerRegion, 'centerRegion');
	
	    var setUiState = function setUiState(layout) {
	        westRegion.setUiState(layout);
	    };
	
	    var getUiState = function getUiState() {
	        var viewport = uiManager.get('viewport'),
	            accordion = uiManager.get('accordion');
	
	        var layoutWindow = viewport.getLayoutWindow(),
	            optionsWindow = viewport.getOptionsWindow(),
	            chartType = getChartType(),
	            dataType = getDataType();
	
	        var config = _extends({}, accordion.getUiState(layoutWindow, optionsWindow), optionsWindow.getOptions());
	
	        if (chartType) {
	            config.type = chartType;
	        }
	
	        if (dataType) {
	            config.dataType = dataType;
	        }
	
	        return config;
	    };
	
	    var viewport = Ext.create('Ext.container.Viewport', _extends({
	        layout: 'border',
	        getUiState: getUiState,
	        setUiState: setUiState,
	        westRegion: westRegion,
	        eastRegion: eastRegion,
	        centerRegion: centerRegion,
	        northRegion: northRegion,
	        items: (0, _arrayClean2.default)([eastRegion, westRegion, centerRegion, northRegion]),
	        getLayoutWindow: null,
	        getOptionsWindow: null
	    }, config, {
	        listeners: {
	            afterrender: function afterrender() {
	
	                // west resize
	                westRegion.on('resize', function () {
	                    var panel = westRegionItems.getExpandedPanel();
	
	                    if (panel) {
	                        panel.onExpand();
	                    }
	                });
	
	                // update cmp resize
	                uiManager.getUpdateComponent().on('resize', function (cmp, width, height, eOpts) {
	                    uiManager.resize({
	                        cmp: cmp,
	                        width: width,
	                        height: height,
	                        eOpts: eOpts
	                    });
	                });
	
	                uiManager.onResize(function (cmp, width) {
	                    if (width < 700 && cmp.fullSize) {
	                        cmp.toggleCmp();
	                        cmp.fullSize = false;
	                    } else if (width >= 700 && !cmp.fullSize) {
	                        cmp.toggleCmp(true);
	                        cmp.fullSize = true;
	                    }
	                });
	
	                // left gui
	                var viewportHeight = uiManager.getHeight(),
	                    numberOfTabs = appManager.dimensions.length + 3,
	                    tabHeight = 28,
	                    minPeriodHeight = 380;
	
	                if (viewportHeight > numberOfTabs * tabHeight + minPeriodHeight) {
	                    if (!_isIE2.default) {
	                        accordion.setAutoScroll(false);
	                        //westRegion.setWidth(uiConfig.west_width + 100);
	                        accordion.doLayout();
	                    }
	                } else {
	                    westRegion.onScrollbar();
	                }
	
	                // north
	                if (northRegion) {
	                    northRegion.setLogoWidth(centerRegion.getPosition()[0]);
	                }
	
	                // expand to make sure treepanel is rendered
	                uiManager.get('organisationUnit').expand();
	                uiManager.get('data').expand();
	
	                // look for url params
	                var id = appManager.getUrlParam('id'),
	                    session = appManager.getUrlParam('s'),
	                    interpretationId = appManager.getUrlParam('interpretationid'),
	                    layout;
	
	                if (id) {
	                    if (interpretationId && interpretationId != "new") {
	                        instanceManager.getById(id, function (layout) {
	                            instanceManager.getInterpretationById(interpretationId, function (interpretation) {
	                                uiManager.updateInterpretation(interpretation, layout);
	                            });
	                        });
	                    } else {
	                        instanceManager.getById(id);
	                    }
	                } else if ((0, _isString2.default)(session) && sessionStorageManager.get(session)) {
	                    layout = new api.Layout(refs, sessionStorageManager.get(session)).val();
	
	                    if (layout) {
	                        instanceManager.getReport(layout, false, false, true);
	                    }
	                } else {
	                    uiManager.update();
	                }
	
	                var initEl = document.getElementById('init');
	                initEl.parentNode.removeChild(initEl);
	
	                Ext.getBody().setStyle('background', '#fff');
	                Ext.getBody().setStyle('opacity', 0);
	
	                centerRegion.setSidePanelsUIState(id, interpretationId);
	
	                // fade in
	                Ext.defer(function () {
	                    Ext.getBody().fadeIn({
	                        duration: 600
	                    });
	                }, 300);
	            }
	        }
	    }));
	
	    return viewport;
	};
	//# sourceMappingURL=Viewport.js.map

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WestRegionAggregateItems = undefined;
	
	var _clone = __webpack_require__(28);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _arrayClean = __webpack_require__(7);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arraySort = __webpack_require__(8);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isBoolean = __webpack_require__(13);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isNumber = __webpack_require__(9);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var WestRegionAggregateItems = exports.WestRegionAggregateItems = undefined;
	
	exports.WestRegionAggregateItems = WestRegionAggregateItems = function WestRegionAggregateItems(c) {
	    var _Ext$create;
	
	    var t = this,
	        uiManager = c.uiManager,
	        instanceManager = c.instanceManager,
	        appManager = c.appManager,
	        i18nManager = c.i18nManager,
	        sessionStorageManager = refs.sessionStorageManager,
	        calendarManager = refs.calendarManager,
	        dimensionConfig = refs.dimensionConfig,
	        periodConfig = refs.periodConfig,
	        uiConfig = refs.uiConfig,
	        optionConfig = refs.optionConfig,
	        api = refs.api;
	
	    var dataObjectName = dimensionConfig.get('data').objectName,
	        indicatorObjectName = dimensionConfig.get('indicator').objectName,
	        dataElementObjectName = dimensionConfig.get('dataElement').objectName,
	        operandObjectName = dimensionConfig.get('operand').objectName,
	        dataSetObjectName = dimensionConfig.get('dataSet').objectName,
	        eventDataItemObjectName = dimensionConfig.get('eventDataItem').objectName,
	        programIndicatorObjectName = dimensionConfig.get('programIndicator').objectName,
	        periodObjectName = dimensionConfig.get('period').objectName,
	        organisationUnitObjectName = dimensionConfig.get('organisationUnit').objectName,
	        i18n = i18nManager.get(),
	        path = appManager.getPath(),
	        apiPath = appManager.getApiPath(),
	        displayProperty = appManager.getDisplayProperty(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl(),
	        dimensionPanelMap = {},
	        accordionPanels = [],
	        periodCheckboxes = [],
	        baseWidth = uiConfig.west_fieldset_width - uiConfig.west_width_padding,
	        accBaseWidth = baseWidth;
	
	    // stores
	
	    var indicatorAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        lastPage: null,
	        nextPage: 1,
	        isPending: false,
	        reset: function reset() {
	            this.removeAll();
	            this.lastPage = null;
	            this.nextPage = 1;
	            this.isPending = false;
	            indicatorSearch.hideFilter();
	        },
	        loadDataAndUpdate: function loadDataAndUpdate(data, append) {
	            this.clearFilter(); // work around
	
	            if (!append) {
	                this.removeAll();
	            }
	
	            this.loadData(data, append);
	
	            this.updateFilter();
	        },
	        getRecordsByIds: function getRecordsByIds(ids) {
	            var records = [];
	
	            ids = (0, _arrayFrom2.default)(ids);
	
	            for (var i = 0, index; i < ids.length; i++) {
	                index = this.findExact('id', ids[i]);
	
	                if (index !== -1) {
	                    records.push(this.getAt(index));
	                }
	            }
	
	            return records;
	        },
	        updateFilter: function updateFilter() {
	            var selectedStoreIds = dataSelectedStore.getIds();
	
	            this.clearFilter();
	
	            this.filterBy(function (record) {
	                return !(0, _arrayContains2.default)(selectedStoreIds, record.data.id);
	            });
	        },
	        loadPage: function loadPage(uid, filter, append, noPaging, fn) {
	            var store = this,
	                params = {},
	                baseUrl = apiPath + '/indicators.json?',
	                fieldsUrl = 'fields=dimensionItem~rename(id),' + displayPropertyUrl,
	                filterUrl = filter ? '&filter=' + displayProperty + ':ilike:' + filter : '';
	
	            var url = baseUrl + fieldsUrl + filterUrl;
	
	            uid = (0, _isString2.default)(uid) || (0, _isNumber2.default)(uid) ? uid : indicatorGroup.getValue();
	            filter = filter || indicatorFilter.getValue() || null;
	
	            if (!append) {
	                this.lastPage = null;
	                this.nextPage = 1;
	            }
	
	            if (store.nextPage === store.lastPage) {
	                return;
	            }
	
	            if ((0, _isString2.default)(uid)) {
	                url += '&filter=indicatorGroups.id:eq:' + uid;
	            }
	
	            if (noPaging) {
	                params.paging = false;
	            } else {
	                params.page = store.nextPage;
	                params.pageSize = 50;
	            }
	
	            store.isPending = true;
	            uiManager.mask(indicatorAvailable.boundList);
	
	            $.getJSON(encodeURI(url), params, function (response) {
	                var data = response.indicators || [],
	                    pager = response.pager;
	
	                store.loadStore(data, pager, append, fn);
	            }).complete(function () {
	                store.isPending = false;
	                uiManager.unmask(indicatorAvailable.boundList);
	            });
	        },
	        loadStore: function loadStore(data, pager, append, fn) {
	            pager = pager || {};
	
	            this.loadDataAndUpdate(data, append);
	            this.sortStore();
	
	            this.lastPage = this.nextPage;
	
	            if (pager.pageCount > this.nextPage) {
	                this.nextPage++;
	            }
	
	            this.isPending = false;
	
	            //uiManager.msFilterAvailable({store: this}, {store: indicatorSelectedStore});
	
	            if (fn) {
	                fn();
	            }
	        },
	        storage: {},
	        parent: null,
	        sortStore: function sortStore() {
	            this.sort('name', 'ASC');
	        }
	    });
	
	    var indicatorGroupStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'index'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/indicatorGroups.json?fields=id,displayName~rename(name)&paging=false'),
	            reader: {
	                type: 'json',
	                root: 'indicatorGroups'
	            },
	            pageParam: false,
	            startParam: false,
	            limitParam: false
	        },
	        listeners: {
	            load: function load(s) {
	                s.add({
	                    id: 0,
	                    name: '[ ' + i18n['all_indicators'] + ' ]',
	                    index: -1
	                });
	                s.sort([{
	                    property: 'index',
	                    direction: 'ASC'
	                }, {
	                    property: 'name',
	                    direction: 'ASC'
	                }]);
	            }
	        }
	    });
	
	    var dataElementAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        lastPage: null,
	        nextPage: 1,
	        isPending: false,
	        reset: function reset() {
	            this.removeAll();
	            this.lastPage = null;
	            this.nextPage = 1;
	            this.isPending = false;
	            dataElementSearch.hideFilter();
	        },
	        loadDataAndUpdate: function loadDataAndUpdate(data, append) {
	            this.clearFilter(); // work around
	
	            if (!append) {
	                this.removeAll();
	            }
	
	            this.loadData(data, append);
	
	            this.updateFilter();
	        },
	        getRecordsByIds: function getRecordsByIds(ids) {
	            var records = [];
	
	            ids = (0, _arrayFrom2.default)(ids);
	
	            for (var i = 0, index; i < ids.length; i++) {
	                index = this.findExact('id', ids[i]);
	
	                if (index !== -1) {
	                    records.push(this.getAt(index));
	                }
	            }
	
	            return records;
	        },
	        updateFilter: function updateFilter() {
	            var selectedStoreIds = dataSelectedStore.getIds();
	
	            this.clearFilter();
	
	            if (selectedStoreIds.length) {
	                this.filterBy(function (record) {
	                    return !(0, _arrayContains2.default)(selectedStoreIds, record.data.id);
	                });
	            }
	        },
	        loadPage: function loadPage(uid, filter, append, noPaging, fn) {
	            uid = (0, _isString2.default)(uid) || (0, _isNumber2.default)(uid) ? uid : dataElementGroup.getValue();
	            filter = filter || dataElementFilter.getValue() || null;
	
	            if (!append) {
	                this.lastPage = null;
	                this.nextPage = 1;
	            }
	
	            if (dataElementDetailLevel.getValue() === dataElementObjectName) {
	                this.loadTotalsPage(uid, filter, append, noPaging, fn);
	            } else if (dataElementDetailLevel.getValue() === operandObjectName) {
	                this.loadDetailsPage(uid, filter, append, noPaging, fn);
	            }
	        },
	        loadTotalsPage: function loadTotalsPage(uid, filter, append, noPaging, fn) {
	            var store = this,
	                params = {},
	                baseUrl = apiPath + '/dataElements.json?',
	                fieldsUrl = 'fields=dimensionItem~rename(id),' + displayPropertyUrl,
	                filterUrl = '&filter=domainType:eq:AGGREGATE' + (filter ? '&filter=' + displayProperty + ':ilike:' + filter : '');
	
	            var url = baseUrl + fieldsUrl + filterUrl;
	
	            if (store.nextPage === store.lastPage) {
	                return;
	            }
	
	            if ((0, _isString2.default)(uid)) {
	                url += '&filter=dataElementGroups.id:eq:' + uid;
	            }
	
	            if (noPaging) {
	                params.paging = false;
	            } else {
	                params.page = store.nextPage;
	                params.pageSize = 50;
	            }
	
	            store.isPending = true;
	            uiManager.mask(dataElementAvailable.boundList);
	
	            $.getJSON(encodeURI(url), params, function (response) {
	                var data = response.dataElements || [],
	                    pager = response.pager;
	
	                store.loadStore(data, pager, append, fn);
	            }).complete(function () {
	                store.isPending = false;
	                uiManager.unmask(dataElementAvailable.boundList);
	            });
	        },
	        loadDetailsPage: function loadDetailsPage(uid, filter, append, noPaging, fn) {
	            var store = this,
	                params = {},
	                baseUrl = apiPath + '/dataElementOperands.json?',
	                fieldsUrl = 'fields=dimensionItem~rename(id),' + displayPropertyUrl,
	                filterUrl = filter ? '&filter=' + displayProperty + ':ilike:' + filter : '';
	
	            var url = baseUrl + fieldsUrl + filterUrl;
	
	            if (store.nextPage === store.lastPage) {
	                return;
	            }
	
	            if ((0, _isString2.default)(uid)) {
	                url += '&filter=dataElement.dataElementGroups.id:eq:' + uid;
	            }
	
	            if (noPaging) {
	                params.paging = false;
	            } else {
	                params.page = store.nextPage;
	                params.pageSize = 50;
	            }
	
	            store.isPending = true;
	            uiManager.mask(dataElementAvailable.boundList);
	
	            $.getJSON(encodeURI(url), params, function (response) {
	                var data = response.objects || response.dataElementOperands || [],
	                    pager = response.pager;
	
	                store.loadStore(data, pager, append, fn);
	            }).complete(function () {
	                store.isPending = false;
	                uiManager.unmask(dataElementAvailable.boundList);
	            });
	        },
	        loadStore: function loadStore(data, pager, append, fn) {
	            pager = pager || {};
	
	            this.loadDataAndUpdate(data, append);
	            this.sortStore();
	
	            this.lastPage = this.nextPage;
	
	            if (pager.pageCount > this.nextPage) {
	                this.nextPage++;
	            }
	
	            this.isPending = false;
	
	            //uiManager.msFilterAvailable({store: dataElementAvailableStore}, {store: dataElementSelectedStore});
	
	            if (fn) {
	                fn();
	            }
	        },
	        sortStore: function sortStore() {
	            this.sort('name', 'ASC');
	        }
	    });
	
	    var dataElementGroupStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'index'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/dataElementGroups.json?fields=id,' + displayPropertyUrl + '&paging=false'),
	            reader: {
	                type: 'json',
	                root: 'dataElementGroups'
	            },
	            pageParam: false,
	            startParam: false,
	            limitParam: false
	        },
	        listeners: {
	            load: function load(s) {
	                s.add({
	                    id: 0,
	                    name: '[ ' + i18n['all_data_elements'] + ' ]',
	                    index: -1
	                });
	
	                s.sort([{ property: 'index', direction: 'ASC' }, { property: 'name', direction: 'ASC' }]);
	            }
	        }
	    });
	
	    var dataSetAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        lastPage: null,
	        nextPage: 1,
	        isPending: false,
	        reset: function reset() {
	            this.removeAll();
	            this.lastPage = null;
	            this.nextPage = 1;
	            this.isPending = false;
	            dataSetSearch.hideFilter();
	        },
	        loadDataAndUpdate: function loadDataAndUpdate(data, append) {
	            this.clearFilter(); // work around
	            this.loadData(data, append);
	            this.updateFilter();
	        },
	        getRecordsByIds: function getRecordsByIds(ids) {
	            var records = [];
	
	            ids = (0, _arrayFrom2.default)(ids);
	
	            for (var i = 0, index; i < ids.length; i++) {
	                index = this.findExact('id', ids[i]);
	
	                if (index !== -1) {
	                    records.push(this.getAt(index));
	                }
	            }
	
	            return records;
	        },
	        updateFilter: function updateFilter() {
	            var selectedStoreIds = dataSelectedStore.getIds();
	            this.clearFilter();
	
	            var metric = dataSetMetric.getValue();
	
	            this.filterBy(function (record) {
	                return !(0, _arrayContains2.default)(selectedStoreIds, record.data.id) && (metric ? record.data.id.split('.')[1] === metric : true);
	            });
	        },
	        loadPage: function loadPage(filter, append, noPaging, fn) {
	            var store = this,
	                params = {},
	                baseUrl = apiPath + '/dataSets.json?',
	                fieldsUrl = 'fields=dimensionItem~rename(id),' + displayPropertyUrl,
	                filterUrl = filter ? '&filter=' + displayProperty + ':ilike:' + filter : '';
	
	            var url = baseUrl + fieldsUrl + filterUrl;
	
	            filter = filter || dataSetFilter.getValue() || null;
	
	            if (!append) {
	                this.lastPage = null;
	                this.nextPage = 1;
	            }
	
	            if (store.nextPage === store.lastPage) {
	                return;
	            }
	
	            if (noPaging) {
	                params.paging = false;
	            } else {
	                params.page = store.nextPage;
	                params.pageSize = 50;
	            }
	
	            store.isPending = true;
	            uiManager.mask(dataSetAvailable.boundList);
	
	            $.getJSON(encodeURI(url), params, function (response) {
	                var data = response.dataSets || [],
	                    pager = response.pager;
	
	                store.loadStore(data, pager, append, fn);
	            }).complete(function () {
	                store.isPending = false;
	                uiManager.unmask(dataSetAvailable.boundList);
	            });
	        },
	        getProcessedData: function getProcessedData(data) {
	            var metricRecords = optionConfig.getDataSetMetricRecords(),
	                processedData = [];
	
	            data.forEach(function (item) {
	                metricRecords.forEach(function (record) {
	                    processedData.push({
	                        id: item.id + '.' + record.id,
	                        name: item.name + ' (' + record.name + ')'
	                    });
	                });
	            });
	
	            return processedData;
	        },
	        loadStore: function loadStore(data, pager, append, fn) {
	            pager = pager || {};
	
	            data = this.getProcessedData(data);
	
	            this.loadDataAndUpdate(data, append);
	
	            this.sortStore();
	
	            this.lastPage = this.nextPage;
	
	            if (pager.pageCount > this.nextPage) {
	                this.nextPage++;
	            }
	
	            this.isPending = false;
	
	            //uiManager.msFilterAvailable({store: dataSetAvailableStore}, {store: dataSetSelectedStore});
	
	            if (fn) {
	                fn();
	            }
	        },
	        storage: {},
	        parent: null,
	        isLoaded: false,
	        sortStore: function sortStore() {
	            this.sort('name', 'ASC');
	        }
	    });
	
	    var eventDataItemAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: [],
	        sortStore: function sortStore() {
	            this.sort('name', 'ASC');
	        },
	        loadDataAndUpdate: function loadDataAndUpdate(data, append) {
	            this.clearFilter(); // work around
	
	            if (!append) {
	                this.removeAll();
	            }
	
	            this.loadData(data, append);
	
	            this.updateFilter();
	        },
	        getRecordsByIds: function getRecordsByIds(ids) {
	            var records = [];
	
	            ids = (0, _arrayFrom2.default)(ids);
	
	            for (var i = 0, index; i < ids.length; i++) {
	                index = this.findExact('id', ids[i]);
	
	                if (index !== -1) {
	                    records.push(this.getAt(index));
	                }
	            }
	
	            return records;
	        },
	        updateFilter: function updateFilter() {
	            var selectedStoreIds = dataSelectedStore.getIds();
	
	            this.clearFilter();
	
	            this.filterBy(function (record) {
	                return !(0, _arrayContains2.default)(selectedStoreIds, record.data.id);
	            });
	        }
	    });
	
	    var programIndicatorAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: [],
	        sortStore: function sortStore() {
	            this.sort('name', 'ASC');
	        },
	        loadDataAndUpdate: function loadDataAndUpdate(data, append) {
	            this.clearFilter(); // work around
	
	            if (!append) {
	                this.removeAll();
	            }
	
	            this.loadData(data, append);
	
	            this.updateFilter();
	        },
	        getRecordsByIds: function getRecordsByIds(ids) {
	            var records = [];
	
	            ids = (0, _arrayFrom2.default)(ids);
	
	            for (var i = 0, index; i < ids.length; i++) {
	                index = this.findExact('id', ids[i]);
	
	                if (index !== -1) {
	                    records.push(this.getAt(index));
	                }
	            }
	
	            return records;
	        },
	        updateFilter: function updateFilter() {
	            var selectedStoreIds = dataSelectedStore.getIds();
	
	            this.clearFilter();
	
	            this.filterBy(function (record) {
	                return !(0, _arrayContains2.default)(selectedStoreIds, record.data.id);
	            });
	        }
	    });
	
	    var programStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/programs.json?fields=id,displayName~rename(name)&paging=false'),
	            reader: {
	                type: 'json',
	                root: 'programs'
	            },
	            pageParam: false,
	            startParam: false,
	            limitParam: false
	        }
	    });
	
	    var dataSelectedStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: [],
	        getIds: function getIds() {
	            var records = this.getRange(),
	                ids = [];
	
	            for (var i = 0; i < records.length; i++) {
	                ids.push(records[i].data.id);
	            }
	
	            return ids;
	        },
	        addRecords: function addRecords(records, objectName) {
	            var prop = 'objectName',
	                recordsToAdd = [],
	                objectsToAdd = [];
	
	            records = (0, _arrayFrom2.default)(records);
	
	            if (records.length) {
	                for (var i = 0, record; i < records.length; i++) {
	                    record = records[i];
	
	                    // record
	                    if (record.data) {
	                        if (objectName) {
	                            record.set(prop, objectName);
	                        }
	                        recordsToAdd.push(record);
	                    }
	                    // object
	                    else {
	                            if (objectName) {
	                                record[prop] = objectName;
	                            }
	                            objectsToAdd.push(record);
	                        }
	                }
	
	                if (recordsToAdd.length) {
	                    this.add(recordsToAdd);
	                }
	
	                if (objectsToAdd.length) {
	                    this.loadData(objectsToAdd, true);
	                }
	            }
	        },
	        removeByIds: function removeByIds(ids) {
	            ids = (0, _arrayFrom2.default)(ids);
	
	            for (var i = 0, index; i < ids.length; i++) {
	                index = this.findExact('id', ids[i]);
	
	                if (index !== -1) {
	                    this.removeAt(index);
	                }
	            }
	        },
	        removeByProperty: function removeByProperty(property, values) {
	            if (!(property && values)) {
	                return;
	            }
	
	            var recordsToRemove = [];
	
	            values = (0, _arrayFrom2.default)(values);
	
	            this.each(function (record) {
	                if ((0, _arrayContains2.default)(values, record.data[property])) {
	                    recordsToRemove.push(record);
	                }
	            });
	
	            this.remove(recordsToRemove);
	        },
	        listeners: {
	            add: function add() {
	                data.updateStoreFilters();
	            },
	            remove: function remove() {
	                data.updateStoreFilters();
	            },
	            clear: function clear() {
	                data.updateStoreFilters();
	            }
	        }
	    });
	
	    var periodTypeStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: periodConfig.getPeriodTypeRecords()
	    });
	
	    var fixedPeriodAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'index'],
	        data: [],
	        setIndex: function setIndex(periods) {
	            for (var i = 0; i < periods.length; i++) {
	                periods[i].index = i;
	            }
	        },
	        sortStore: function sortStore() {
	            this.sort('index', 'ASC');
	        }
	    });
	
	    var fixedPeriodSelectedStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: []
	    });
	
	    var organisationUnitLevelStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'level'],
	        data: appManager.organisationUnitLevels,
	        sorters: [{
	            property: 'level',
	            direction: 'ASC'
	        }]
	    });
	
	    var organisationUnitGroupStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/organisationUnitGroups.json?fields=id,' + displayPropertyUrl + '&paging=false'),
	            reader: {
	                type: 'json',
	                root: 'organisationUnitGroups'
	            },
	            pageParam: false,
	            startParam: false,
	            limitParam: false
	        }
	    });
	
	    var legendSetStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'index'],
	        data: function () {
	            var data = appManager.legendSets;
	            data.unshift({ id: 0, name: i18n['none'], index: -1 });
	            return data;
	        }(),
	        sorters: [{ property: 'index', direction: 'ASC' }, { property: 'name', direction: 'ASC' }]
	    });
	
	    // data
	
	    var onDataTypeSelect = function onDataTypeSelect(type) {
	        type = type || 'in';
	
	        if (type === 'in') {
	            indicator.show();
	            dataElement.hide();
	            dataSet.hide();
	            eventDataItem.hide();
	            programIndicator.hide();
	        } else if (type === 'de') {
	            indicator.hide();
	            dataElement.show();
	            dataSet.hide();
	            eventDataItem.hide();
	            programIndicator.hide();
	        } else if (type === 'ds') {
	            indicator.hide();
	            dataElement.hide();
	            dataSet.show();
	            eventDataItem.hide();
	            programIndicator.hide();
	
	            if (!dataSetAvailableStore.isLoaded) {
	                dataSetAvailableStore.isLoaded = true;
	                dataSetAvailableStore.loadPage();
	            }
	        } else if (type === 'di') {
	            indicator.hide();
	            dataElement.hide();
	            dataSet.hide();
	            eventDataItem.show();
	            programIndicator.hide();
	
	            if (!programStore.isLoaded) {
	                programStore.isLoaded = true;
	                programStore.load();
	            }
	        } else if (type === 'pi') {
	            indicator.hide();
	            dataElement.hide();
	            dataSet.hide();
	            eventDataItem.hide();
	            programIndicator.show();
	
	            if (!programStore.isLoaded) {
	                programStore.isLoaded = true;
	                programStore.load();
	            }
	        }
	    };
	
	    var dataType = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin-bottom:1px',
	        width: accBaseWidth,
	        valueField: 'id',
	        displayField: 'name',
	        //emptyText: i18n.data_type,
	        editable: false,
	        queryMode: 'local',
	        value: 'in',
	        store: {
	            fields: ['id', 'name'],
	            data: [{ id: 'in', name: i18n['indicators'] }, { id: 'de', name: i18n['data_elements'] }, { id: 'ds', name: i18n['data_sets'] }, { id: 'di', name: i18n['event_data_items'] }, { id: 'pi', name: i18n['program_indicators'] }]
	        },
	        listeners: {
	            select: function select(cb) {
	                onDataTypeSelect(cb.getValue());
	            }
	        }
	    });
	
	    // indicator
	    var indicatorLabel = Ext.create('Ext.form.Label', {
	        text: i18n['available'],
	        cls: 'ns-toolbar-multiselect-left-label',
	        style: 'margin-right:5px'
	    });
	
	    var indicatorSearch = Ext.create('Ext.button.Button', {
	        width: 22,
	        height: 22,
	        cls: 'ns-button-icon',
	        iconCls: 'ns-button-icon-search',
	        disabled: true,
	        showFilter: function showFilter() {
	            indicatorLabel.hide();
	            this.hide();
	            indicatorFilter.show();
	            indicatorFilter.reset();
	        },
	        hideFilter: function hideFilter() {
	            indicatorLabel.show();
	            this.show();
	            indicatorFilter.hide();
	            indicatorFilter.reset();
	        },
	        handler: function handler() {
	            this.showFilter();
	        }
	    });
	
	    var indicatorFilter = Ext.create('Ext.form.field.Trigger', {
	        cls: 'ns-trigger-filter',
	        emptyText: 'Filter available..',
	        height: 22,
	        hidden: true,
	        enableKeyEvents: true,
	        fieldStyle: 'height:22px; border-right:0 none',
	        style: 'height:22px',
	        onTriggerClick: function onTriggerClick() {
	            this.reset();
	            this.onKeyUpHandler();
	
	            indicatorSearch.hideFilter();
	        },
	        onKeyUpHandler: function onKeyUpHandler() {
	            var value = indicatorGroup.getValue(),
	                store = indicatorAvailableStore;
	
	            if ((0, _isString2.default)(value) || (0, _isNumber2.default)(value)) {
	                store.loadPage(null, this.getValue(), false);
	            }
	        },
	        listeners: {
	            keyup: {
	                fn: function fn(cmp) {
	                    cmp.onKeyUpHandler();
	                },
	                buffer: 100
	            },
	            show: function show(cmp) {
	                cmp.focus(false, 50);
	            },
	            focus: function focus(cmp) {
	                cmp.addCls('ns-trigger-filter-focused');
	            },
	            blur: function blur(cmp) {
	                cmp.removeCls('ns-trigger-filter-focused');
	            }
	        }
	    });
	
	    var indicatorGroup = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin-bottom:1px; margin-top:0px',
	        width: accBaseWidth,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n['select_indicator_group'],
	        editable: false,
	        store: indicatorGroupStore,
	        loadAvailable: function loadAvailable(reset) {
	            var store = indicatorAvailableStore,
	                id = this.getValue();
	
	            if (id !== null) {
	                if (reset) {
	                    store.reset();
	                }
	
	                store.loadPage(id, null, false);
	            }
	        },
	        listeners: {
	            select: function select(cb) {
	                cb.loadAvailable(true);
	
	                indicatorSearch.enable();
	            }
	        }
	    });
	
	    var indicatorAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        store: indicatorAvailableStore,
	        tbar: [indicatorLabel, indicatorSearch, indicatorFilter, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                if (indicatorAvailable.getValue().length) {
	                    var records = indicatorAvailableStore.getRecordsByIds(indicatorAvailable.getValue());
	                    dataSelectedStore.addRecords(records, 'in');
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                indicatorAvailableStore.loadPage(null, null, null, true, function () {
	                    dataSelectedStore.addRecords(indicatorAvailableStore.getRange(), 'in');
	                });
	            }
	        }],
	        listeners: {
	            render: function render(ms) {
	                var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                el.addEventListener('scroll', function (e) {
	                    if (uiManager.isScrolled(e) && !indicatorAvailableStore.isPending) {
	                        indicatorAvailableStore.loadPage(null, null, true);
	                    }
	                });
	
	                ms.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.addRecords(record, 'in');
	                }, ms);
	            }
	        }
	    });
	
	    var indicatorSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: true,
	        store: dataSelectedStore,
	        tbar: [{
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                if (dataSelectedStore.getRange().length) {
	                    dataSelectedStore.removeAll();
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                if (indicatorSelected.getValue().length) {
	                    dataSelectedStore.removeByIds(indicatorSelected.getValue());
	                }
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n['selected'],
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.removeByIds(record.data.id);
	                }, this);
	            }
	        }
	    });
	
	    var indicator = Ext.create('Ext.panel.Panel', {
	        xtype: 'panel',
	        //title: '<div class="ns-panel-title-data">' + i18n.indicators + '</div>',
	        preventHeader: true,
	        hideCollapseTool: true,
	        dimension: indicatorObjectName,
	        bodyStyle: 'border:0 none',
	        items: [indicatorGroup, {
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none',
	            items: [indicatorAvailable, indicatorSelected]
	        }],
	        listeners: {
	            expand: function expand(p) {
	                //p.onExpand();
	            }
	        }
	    });
	
	    // data element
	    var dataElementLabel = Ext.create('Ext.form.Label', {
	        text: i18n['available'],
	        cls: 'ns-toolbar-multiselect-left-label',
	        style: 'margin-right:5px'
	    });
	
	    var dataElementSearch = Ext.create('Ext.button.Button', {
	        width: 22,
	        height: 22,
	        cls: 'ns-button-icon',
	        iconCls: 'ns-button-icon-search',
	        disabled: true,
	        showFilter: function showFilter() {
	            dataElementLabel.hide();
	            this.hide();
	            dataElementFilter.show();
	            dataElementFilter.reset();
	        },
	        hideFilter: function hideFilter() {
	            dataElementLabel.show();
	            this.show();
	            dataElementFilter.hide();
	            dataElementFilter.reset();
	        },
	        handler: function handler() {
	            this.showFilter();
	        }
	    });
	
	    var dataElementFilter = Ext.create('Ext.form.field.Trigger', {
	        cls: 'ns-trigger-filter',
	        emptyText: 'Filter available..',
	        height: 22,
	        hidden: true,
	        enableKeyEvents: true,
	        fieldStyle: 'height:22px; border-right:0 none',
	        style: 'height:22px',
	        onTriggerClick: function onTriggerClick() {
	            this.reset();
	            this.onKeyUpHandler();
	
	            dataElementSearch.hideFilter();
	        },
	        onKeyUpHandler: function onKeyUpHandler() {
	            var value = dataElementGroup.getValue(),
	                store = dataElementAvailableStore;
	
	            if ((0, _isString2.default)(value) || (0, _isNumber2.default)(value)) {
	                store.loadPage(null, this.getValue(), false);
	            }
	        },
	        listeners: {
	            keyup: {
	                fn: function fn(cmp) {
	                    cmp.onKeyUpHandler();
	                },
	                buffer: 100
	            },
	            show: function show(cmp) {
	                cmp.focus(false, 50);
	            },
	            focus: function focus(cmp) {
	                cmp.addCls('ns-trigger-filter-focused');
	            },
	            blur: function blur(cmp) {
	                cmp.removeCls('ns-trigger-filter-focused');
	            }
	        }
	    });
	
	    var dataElementAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        isPending: false,
	        page: 1,
	        store: dataElementAvailableStore,
	        tbar: [dataElementLabel, dataElementSearch, dataElementFilter, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                if (dataElementAvailable.getValue().length) {
	                    var records = dataElementAvailableStore.getRecordsByIds(dataElementAvailable.getValue());
	                    dataSelectedStore.addRecords(records, 'de');
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                dataElementAvailableStore.loadPage(null, null, null, true, function () {
	                    dataSelectedStore.addRecords(dataElementAvailableStore.getRange(), 'de');
	                });
	            }
	        }],
	        listeners: {
	            render: function render(ms) {
	                var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                el.addEventListener('scroll', function (e) {
	                    if (uiManager.isScrolled(e) && !dataElementAvailableStore.isPending) {
	                        dataElementAvailableStore.loadPage(null, null, true);
	                    }
	                });
	
	                ms.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.addRecords(record, 'de');
	                }, ms);
	            }
	        }
	    });
	
	    var dataElementSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: true,
	        store: dataSelectedStore,
	        tbar: [{
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                if (dataSelectedStore.getRange().length) {
	                    dataSelectedStore.removeAll();
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                if (dataElementSelected.getValue().length) {
	                    dataSelectedStore.removeByIds(dataElementSelected.getValue());
	                }
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n['selected'],
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.removeByIds(record.data.id);
	                }, this);
	            }
	        }
	    });
	
	    var dataElementGroup = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin:0 1px 1px 0',
	        width: accBaseWidth - 90,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n['select_data_element_group'],
	        editable: false,
	        store: dataElementGroupStore,
	        loadAvailable: function loadAvailable(reset) {
	            var store = dataElementAvailableStore,
	                id = this.getValue();
	
	            if (id !== null) {
	                if (reset) {
	                    store.reset();
	                }
	
	                store.loadPage(id, null, false);
	            }
	        },
	        listeners: {
	            select: function select(cb) {
	                cb.loadAvailable(true);
	
	                dataElementSearch.enable();
	            }
	        }
	    });
	
	    var dataElementDetailLevel = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin-bottom:1px',
	        baseBodyCls: 'small',
	        queryMode: 'local',
	        editable: false,
	        valueField: 'id',
	        displayField: 'text',
	        width: 90 - 1,
	        value: dataElementObjectName,
	        store: {
	            fields: ['id', 'text'],
	            data: [{ id: dataElementObjectName, text: i18n['totals'] }, { id: operandObjectName, text: i18n['details'] }]
	        },
	        listeners: {
	            select: function select(cb) {
	                dataElementGroup.loadAvailable(true);
	            }
	        }
	    });
	
	    var dataElement = Ext.create('Ext.panel.Panel', {
	        xtype: 'panel',
	        preventHeader: true,
	        hidden: true,
	        hideCollapseTool: true,
	        bodyStyle: 'border:0 none',
	        dimension: dataElementObjectName,
	        items: [{
	            xtype: 'container',
	            layout: 'column',
	            items: [dataElementGroup, dataElementDetailLevel]
	        }, {
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none',
	            items: [dataElementAvailable, dataElementSelected]
	        }]
	    });
	
	    // data set
	    var dataSetLabel = Ext.create('Ext.form.Label', {
	        text: i18n['available'],
	        cls: 'ns-toolbar-multiselect-left-label',
	        style: 'margin-right:5px'
	    });
	
	    var dataSetSearch = Ext.create('Ext.button.Button', {
	        width: 22,
	        height: 22,
	        cls: 'ns-button-icon',
	        iconCls: 'ns-button-icon-search',
	        showFilter: function showFilter() {
	            dataSetLabel.hide();
	            this.hide();
	            dataSetFilter.show();
	            dataSetFilter.reset();
	        },
	        hideFilter: function hideFilter() {
	            dataSetLabel.show();
	            this.show();
	            dataSetFilter.hide();
	            dataSetFilter.reset();
	        },
	        handler: function handler() {
	            this.showFilter();
	        }
	    });
	
	    var dataSetFilter = Ext.create('Ext.form.field.Trigger', {
	        cls: 'ns-trigger-filter',
	        emptyText: 'Filter available..',
	        height: 22,
	        hidden: true,
	        enableKeyEvents: true,
	        fieldStyle: 'height:22px; border-right:0 none',
	        style: 'height:22px',
	        onTriggerClick: function onTriggerClick() {
	            this.reset();
	            this.onKeyUpHandler();
	
	            dataSetSearch.hideFilter();
	        },
	        onKeyUpHandler: function onKeyUpHandler() {
	            var store = dataSetAvailableStore;
	            store.loadPage(this.getValue(), false);
	        },
	        listeners: {
	            keyup: {
	                fn: function fn(cmp) {
	                    cmp.onKeyUpHandler();
	                },
	                buffer: 100
	            },
	            show: function show(cmp) {
	                cmp.focus(false, 50);
	            },
	            focus: function focus(cmp) {
	                cmp.addCls('ns-trigger-filter-focused');
	            },
	            blur: function blur(cmp) {
	                cmp.removeCls('ns-trigger-filter-focused');
	            }
	        }
	    });
	
	    var dataSetAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        store: dataSetAvailableStore,
	        tbar: [dataSetLabel, dataSetSearch, dataSetFilter, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                if (dataSetAvailable.getValue().length) {
	                    var records = dataSetAvailableStore.getRecordsByIds(dataSetAvailable.getValue());
	                    dataSelectedStore.addRecords(records, 'ds');
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                dataSetAvailableStore.loadPage(null, null, true, function () {
	                    dataSelectedStore.addRecords(dataSetAvailableStore.getRange(), 'ds');
	                });
	            }
	        }],
	        listeners: {
	            render: function render(ms) {
	                var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                el.addEventListener('scroll', function (e) {
	                    if (uiManager.isScrolled(e) && !dataSetAvailableStore.isPending) {
	                        dataSetAvailableStore.loadPage(null, true);
	                    }
	                });
	
	                ms.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.addRecords(record, 'ds');
	                }, ms);
	            }
	        }
	    });
	
	    var dataSetSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: true,
	        store: dataSelectedStore,
	        tbar: [{
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                if (dataSelectedStore.getRange().length) {
	                    dataSelectedStore.removeAll();
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                if (dataSetSelected.getValue().length) {
	                    dataSelectedStore.removeByIds(dataSetSelected.getValue());
	                }
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n.selected,
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.removeByIds(record.data.id);
	                }, this);
	            }
	        }
	    });
	
	    var dataSetMetric = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin-bottom:1px; margin-top:0px',
	        width: accBaseWidth,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n['select_indicator_group'],
	        editable: false,
	        value: optionConfig.getDataSetMetric('reportingRates').id,
	        store: {
	            fields: ['id', 'name'],
	            data: [{ id: 0, name: '[ ' + i18n.all_metrics + ' ]' }].concat(optionConfig.getDataSetMetricRecords())
	        },
	        listeners: {
	            select: function select(cmp) {
	                dataSetAvailableStore.updateFilter();
	            }
	        }
	    });
	
	    var dataSet = Ext.create('Ext.panel.Panel', {
	        xtype: 'panel',
	        //title: '<div class="ns-panel-title-data">' + i18n.reporting_rates + '</div>',
	        preventHeader: true,
	        hidden: true,
	        hideCollapseTool: true,
	        bodyStyle: 'border:0 none',
	        dimension: dataSetObjectName,
	        items: [dataSetMetric, {
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none',
	            items: [dataSetAvailable, dataSetSelected]
	        }]
	    });
	
	    // event data item
	    var onEventDataItemProgramSelect = function onEventDataItemProgramSelect(programId, skipSync) {
	        if (!skipSync) {
	            //dataSelectedStore.removeByProperty('objectName', ['di','pi']);
	            programIndicatorProgram.setValue(programId);
	            onProgramIndicatorProgramSelect(programId, true);
	        }
	
	        Ext.Ajax.request({
	            url: encodeURI(apiPath + '/programDataElements.json?program=' + programId + '&fields=dimensionItem~rename(id),name,valueType&paging=false'),
	            disableCaching: false,
	            success: function success(r) {
	                var types = dimensionConfig.valueType['aggregate_aggregatable_types'],
	                    elements = Ext.decode(r.responseText).programDataElements.filter(function (item) {
	                    return (0, _arrayContains2.default)(types, (item || {}).valueType);
	                });
	
	                Ext.Ajax.request({
	                    url: encodeURI(apiPath + '/programs.json?filter=id:eq:' + programId + '&fields=programTrackedEntityAttributes[dimensionItem~rename(id),' + displayPropertyUrl + '~rename(name),valueType]&paging=false'),
	                    disableCaching: false,
	                    success: function success(r) {
	                        var attributes = ((Ext.decode(r.responseText).programs[0] || {}).programTrackedEntityAttributes || []).filter(function (item) {
	                            return (0, _arrayContains2.default)(types, (item || {}).valueType);
	                        }),
	                            data = (0, _arraySort2.default)((0, _arrayClean2.default)([].concat(elements, attributes))) || [];
	
	                        eventDataItemAvailableStore.loadDataAndUpdate(data);
	                    }
	                });
	            }
	        });
	    };
	
	    var eventDataItemProgram = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin:0 1px 1px 0',
	        width: accBaseWidth,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n.select_program,
	        editable: false,
	        queryMode: 'local',
	        store: programStore,
	        listeners: {
	            select: function select(cb) {
	                onEventDataItemProgramSelect(cb.getValue());
	            }
	        }
	    });
	
	    var eventDataItemLabel = Ext.create('Ext.form.Label', {
	        text: i18n.available,
	        cls: 'ns-toolbar-multiselect-left-label',
	        style: 'margin-right:5px'
	    });
	
	    var eventDataItemSearch = Ext.create('Ext.button.Button', {
	        width: 22,
	        height: 22,
	        cls: 'ns-button-icon',
	        iconCls: 'ns-button-icon-search',
	        //disabled: true,
	        showFilter: function showFilter() {
	            eventDataItemLabel.hide();
	            this.hide();
	            eventDataItemFilter.show();
	            eventDataItemFilter.reset();
	        },
	        hideFilter: function hideFilter() {
	            eventDataItemLabel.show();
	            this.show();
	            eventDataItemFilter.hide();
	            eventDataItemFilter.reset();
	        },
	        handler: function handler() {
	            this.showFilter();
	        }
	    });
	
	    var eventDataItemFilter = Ext.create('Ext.form.field.Trigger', {
	        cls: 'ns-trigger-filter',
	        emptyText: 'Filter available..',
	        height: 22,
	        hidden: true,
	        enableKeyEvents: true,
	        fieldStyle: 'height:22px; border-right:0 none',
	        style: 'height:22px',
	        onTriggerClick: function onTriggerClick() {
	            this.reset();
	            this.onKeyUpHandler();
	
	            eventDataItemSearch.hideFilter();
	        },
	        onKeyUpHandler: function onKeyUpHandler() {
	            var value = this.getValue() || '',
	                store = eventDataItemAvailableStore,
	                str;
	
	            store.filterBy(function (record) {
	                str = record.data.name || '';
	
	                return str.toLowerCase().indexOf(value.toLowerCase()) !== -1;
	            });
	        },
	        listeners: {
	            keyup: {
	                fn: function fn(cmp) {
	                    cmp.onKeyUpHandler();
	                },
	                buffer: 100
	            },
	            show: function show(cmp) {
	                cmp.focus(false, 50);
	            },
	            focus: function focus(cmp) {
	                cmp.addCls('ns-trigger-filter-focused');
	            },
	            blur: function blur(cmp) {
	                cmp.removeCls('ns-trigger-filter-focused');
	            }
	        }
	    });
	
	    var eventDataItemAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        store: eventDataItemAvailableStore,
	        tbar: [eventDataItemLabel, eventDataItemSearch, eventDataItemFilter, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                if (eventDataItemAvailable.getValue().length) {
	                    var records = eventDataItemAvailableStore.getRecordsByIds(eventDataItemAvailable.getValue());
	                    dataSelectedStore.addRecords(records, 'di');
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                //eventDataItemAvailableStore.loadPage(null, null, null, true, function() {
	                dataSelectedStore.addRecords(eventDataItemAvailableStore.getRange(), 'di');
	                //});
	            }
	        }],
	        listeners: {
	            render: function render(ms) {
	                var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                //el.addEventListener('scroll', function(e) {
	                //if (uiManager.isScrolled(e) && !eventDataItemAvailableStore.isPending) {
	                //eventDataItemAvailableStore.loadPage(null, null, true);
	                //}
	                //});
	
	                ms.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.addRecords(record, 'di');
	                }, ms);
	            }
	        }
	    });
	
	    var eventDataItemSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: true,
	        store: dataSelectedStore,
	        tbar: [{
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                if (dataSelectedStore.getRange().length) {
	                    dataSelectedStore.removeAll();
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                if (eventDataItemSelected.getValue().length) {
	                    dataSelectedStore.removeByIds(eventDataItemSelected.getValue());
	                }
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n.selected,
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.removeByIds(record.data.id);
	                }, this);
	            }
	        }
	    });
	
	    var eventDataItem = Ext.create('Ext.panel.Panel', {
	        xtype: 'panel',
	        //title: '<div class="ns-panel-title-data">' + i18n.eventDataItems + '</div>',
	        preventHeader: true,
	        hidden: true,
	        hideCollapseTool: true,
	        dimension: eventDataItemObjectName,
	        bodyStyle: 'border:0 none',
	        items: [eventDataItemProgram, {
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none',
	            items: [eventDataItemAvailable, eventDataItemSelected]
	        }]
	    });
	
	    // program indicator
	    var onProgramIndicatorProgramSelect = function onProgramIndicatorProgramSelect(programId, skipSync) {
	        if (!skipSync) {
	            //dataSelectedStore.removeByProperty('objectName', ['di','pi']);
	            eventDataItemProgram.setValue(programId);
	            onEventDataItemProgramSelect(programId, true);
	        }
	
	        Ext.Ajax.request({
	            url: encodeURI(apiPath + '/programs.json?filter=id:eq:' + programId + '&fields=programIndicators[dimensionItem~rename(id),' + displayPropertyUrl + ']&paging=false'),
	            disableCaching: false,
	            success: function success(r) {
	                var indicators = (Ext.decode(r.responseText).programs[0] || {}).programIndicators || [],
	                    data = (0, _arraySort2.default)(indicators);
	
	                programIndicatorAvailableStore.loadDataAndUpdate(data);
	            }
	        });
	    };
	
	    var programIndicatorProgram = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin:0 1px 1px 0',
	        width: accBaseWidth,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n.select_program,
	        editable: false,
	        queryMode: 'local',
	        store: programStore,
	        listeners: {
	            select: function select(cb) {
	                onProgramIndicatorProgramSelect(cb.getValue());
	            }
	        }
	    });
	
	    var programIndicatorLabel = Ext.create('Ext.form.Label', {
	        text: i18n.available,
	        cls: 'ns-toolbar-multiselect-left-label',
	        style: 'margin-right:5px'
	    });
	
	    var programIndicatorSearch = Ext.create('Ext.button.Button', {
	        width: 22,
	        height: 22,
	        cls: 'ns-button-icon',
	        iconCls: 'ns-button-icon-search',
	        //disabled: true,
	        showFilter: function showFilter() {
	            programIndicatorLabel.hide();
	            this.hide();
	            programIndicatorFilter.show();
	            programIndicatorFilter.reset();
	        },
	        hideFilter: function hideFilter() {
	            programIndicatorLabel.show();
	            this.show();
	            programIndicatorFilter.hide();
	            programIndicatorFilter.reset();
	        },
	        handler: function handler() {
	            this.showFilter();
	        }
	    });
	
	    var programIndicatorFilter = Ext.create('Ext.form.field.Trigger', {
	        cls: 'ns-trigger-filter',
	        emptyText: 'Filter available..',
	        height: 22,
	        hidden: true,
	        enableKeyEvents: true,
	        fieldStyle: 'height:22px; border-right:0 none',
	        style: 'height:22px',
	        onTriggerClick: function onTriggerClick() {
	            this.reset();
	            this.onKeyUpHandler();
	
	            programIndicatorSearch.hideFilter();
	        },
	        onKeyUpHandler: function onKeyUpHandler() {
	            var value = this.getValue() || '',
	                store = programIndicatorAvailableStore,
	                str;
	
	            store.filterBy(function (record) {
	                str = record.data.name || '';
	
	                return str.toLowerCase().indexOf(value.toLowerCase()) !== -1;
	            });
	        },
	        listeners: {
	            keyup: {
	                fn: function fn(cmp) {
	                    cmp.onKeyUpHandler();
	                },
	                buffer: 100
	            },
	            show: function show(cmp) {
	                cmp.focus(false, 50);
	            },
	            focus: function focus(cmp) {
	                cmp.addCls('ns-trigger-filter-focused');
	            },
	            blur: function blur(cmp) {
	                cmp.removeCls('ns-trigger-filter-focused');
	            }
	        }
	    });
	
	    var programIndicatorAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        store: programIndicatorAvailableStore,
	        tbar: [programIndicatorLabel, programIndicatorSearch, programIndicatorFilter, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                if (programIndicatorAvailable.getValue().length) {
	                    var records = programIndicatorAvailableStore.getRecordsByIds(programIndicatorAvailable.getValue());
	                    dataSelectedStore.addRecords(records, 'pi');
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                //programIndicatorAvailableStore.loadPage(null, null, null, true, function() {
	                dataSelectedStore.addRecords(programIndicatorAvailableStore.getRange(), 'pi');
	                //});
	            }
	        }],
	        listeners: {
	            render: function render(ms) {
	                var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                //el.addEventListener('scroll', function(e) {
	                //if (uiManager.isScrolled(e) && !programIndicatorAvailableStore.isPending) {
	                //programIndicatorAvailableStore.loadPage(null, null, true);
	                //}
	                //});
	
	                ms.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.addRecords(record, 'pi');
	                }, ms);
	            }
	        }
	    });
	
	    var programIndicatorSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: true,
	        store: dataSelectedStore,
	        tbar: [{
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                if (dataSelectedStore.getRange().length) {
	                    dataSelectedStore.removeAll();
	                }
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                if (programIndicatorSelected.getValue().length) {
	                    dataSelectedStore.removeByIds(programIndicatorSelected.getValue());
	                }
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n.selected,
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function (bl, record) {
	                    dataSelectedStore.removeByIds(record.data.id);
	                }, this);
	            }
	        }
	    });
	
	    var programIndicator = Ext.create('Ext.panel.Panel', {
	        xtype: 'panel',
	        //title: '<div class="ns-panel-title-data">' + i18n.programIndicators + '</div>',
	        preventHeader: true,
	        hidden: true,
	        hideCollapseTool: true,
	        dimension: programIndicatorObjectName,
	        bodyStyle: 'border:0 none',
	        items: [programIndicatorProgram, {
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none',
	            items: [programIndicatorAvailable, programIndicatorSelected]
	        }]
	    });
	
	    var data = Ext.create('Ext.panel.Panel', {
	        title: '<div class="ns-panel-title-data">' + i18n.data + '</div>',
	        cls: 'ns-accordion-first',
	        bodyStyle: 'padding:1px',
	        hideCollapseTool: true,
	        dimension: dataObjectName,
	        updateStoreFilters: function updateStoreFilters() {
	            indicatorAvailableStore.updateFilter();
	            dataElementAvailableStore.updateFilter();
	            dataSetAvailableStore.updateFilter();
	            eventDataItemAvailableStore.updateFilter();
	            programIndicatorAvailableStore.updateFilter();
	        },
	        getDimension: function getDimension() {
	            var config = {
	                dimension: dataObjectName,
	                items: []
	            };
	
	            dataSelectedStore.each(function (r) {
	                config.items.push({
	                    id: r.data.id,
	                    name: r.data.name
	                });
	            });
	
	            // TODO program
	            if (eventDataItemProgram.getValue() || programIndicatorProgram.getValue()) {
	                config.program = { id: eventDataItemProgram.getValue() || programIndicatorProgram.getValue() };
	            }
	
	            return config.items.length ? config : null;
	        },
	        clearDimension: function clearDimension() {
	            dataSelectedStore.removeAll();
	
	            indicatorAvailableStore.removeAll();
	            indicatorGroup.clearValue();
	
	            dataElementAvailableStore.removeAll();
	            dataElementGroup.clearValue();
	            dataElementDetailLevel.reset();
	
	            dataSetAvailableStore.removeAll();
	
	            eventDataItemAvailableStore.removeAll();
	            programIndicatorAvailableStore.removeAll();
	        },
	        setDimension: function setDimension(layout) {
	            if ((0, _isObject2.default)(layout.program) && (0, _isString2.default)(layout.program.id)) {
	                eventDataItemProgram.setValue(layout.program.id);
	                onEventDataItemProgramSelect(layout.program.id);
	            }
	
	            if (layout.hasDimension(this.dimension, true)) {
	                dataSelectedStore.addRecords(layout.getDimension(this.dimension).getRecords());
	            }
	        },
	        getHeightValue: function getHeightValue() {
	            var westRegion = uiManager.get('westRegion');
	
	            return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_indicator : uiConfig.west_maxheight_accordion_indicator;
	        },
	        onExpand: function onExpand() {
	            accordion.setThisHeight(this.getHeightValue());
	
	            uiManager.msSetHeight([indicatorAvailable, indicatorSelected], this, uiConfig.west_fill_accordion_indicator);
	            uiManager.msSetHeight([dataElementAvailable, dataElementSelected], this, uiConfig.west_fill_accordion_dataelement);
	            uiManager.msSetHeight([dataSetAvailable, dataSetSelected], this, uiConfig.west_fill_accordion_dataset);
	            uiManager.msSetHeight([eventDataItemAvailable, eventDataItemSelected], this, uiConfig.west_fill_accordion_eventdataitem);
	            uiManager.msSetHeight([programIndicatorAvailable, programIndicatorSelected], this, uiConfig.west_fill_accordion_programindicator);
	        },
	        items: [dataType, indicator, dataElement, dataSet, eventDataItem, programIndicator],
	        listeners: {
	            expand: function expand(p) {
	                p.onExpand();
	            }
	        }
	    });
	    accordionPanels.push(uiManager.reg(data, 'data'));
	
	    // period
	
	    var rewind = Ext.create('Ext.form.field.Checkbox', {
	        relativePeriodId: 'rewind',
	        boxLabel: i18n.rewind_one_period,
	        xable: function xable() {
	            this.setDisabled(period.isNoRelativePeriods());
	        }
	    });
	
	    var relativePeriodDefaults = {
	        labelSeparator: '',
	        style: 'margin-bottom:0',
	        listeners: {
	            added: function added(chb) {
	                if (chb.xtype === 'checkbox') {
	                    periodCheckboxes[chb.index] = chb;
	                    relativePeriod.valueComponentMap[chb.relativePeriodId] = chb;
	
	                    if (chb.relativePeriodId === appManager.getRelativePeriod()) {
	                        chb.setValue(true);
	                    }
	                }
	            }
	        }
	    };
	
	    var relativePeriod = {
	        xtype: 'panel',
	        layout: 'column',
	        hideCollapseTool: true,
	        autoScroll: true,
	        bodyStyle: 'border:0 none',
	        valueComponentMap: {},
	        items: [{
	            xtype: 'container',
	            columnWidth: 0.34,
	            bodyStyle: 'border-style:none',
	            items: [{
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:0 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['days'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'TODAY',
	                    boxLabel: i18n['today'],
	                    index: 0
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'YESTERDAY',
	                    boxLabel: i18n['yesterday'],
	                    index: 1
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_3_DAYS',
	                    boxLabel: i18n['last_3_days'],
	                    index: 2
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_7_DAYS',
	                    boxLabel: i18n['last_7_days'],
	                    index: 3
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_14_DAYS',
	                    boxLabel: i18n['last_14_days'],
	                    index: 4
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['bimonths'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_BIMONTH',
	                    boxLabel: i18n['this_bimonth'],
	                    index: 17
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_BIMONTH',
	                    boxLabel: i18n['last_bimonth'],
	                    index: 18
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_6_BIMONTHS',
	                    boxLabel: i18n['last_6_bimonths'],
	                    index: 19
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'BIMONTHS_THIS_YEAR',
	                    boxLabel: i18n['bimonths_this_year'],
	                    index: 20
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['financial_years'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_FINANCIAL_YEAR',
	                    boxLabel: i18n['this_financial_year'],
	                    index: 28
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_FINANCIAL_YEAR',
	                    boxLabel: i18n['last_financial_year'],
	                    index: 29
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_5_FINANCIAL_YEARS',
	                    boxLabel: i18n['last_5_financial_years'],
	                    index: 30
	                }]
	            }]
	        }, {
	            xtype: 'container',
	            columnWidth: 0.33,
	            bodyStyle: 'border-style:none',
	            items: [{
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:0 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['weeks'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_WEEK',
	                    boxLabel: i18n['this_week'],
	                    index: 5
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_WEEK',
	                    boxLabel: i18n['last_week'],
	                    index: 6
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_4_WEEKS',
	                    boxLabel: i18n['last_4_weeks'],
	                    index: 7
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_12_WEEKS',
	                    boxLabel: i18n['last_12_weeks'],
	                    index: 8
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_52_WEEKS',
	                    boxLabel: i18n['last_52_weeks'],
	                    index: 9
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'WEEKS_THIS_YEAR',
	                    boxLabel: i18n['weeks_this_year'],
	                    index: 10
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['quarters'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_QUARTER',
	                    boxLabel: i18n['this_quarter'],
	                    index: 21
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_QUARTER',
	                    boxLabel: i18n['last_quarter'],
	                    index: 22
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_4_QUARTERS',
	                    boxLabel: i18n['last_4_quarters'],
	                    index: 23
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'QUARTERS_THIS_YEAR',
	                    boxLabel: i18n['quarters_this_year'],
	                    index: 24
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['years'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_YEAR',
	                    boxLabel: i18n['this_year'],
	                    index: 31
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_YEAR',
	                    boxLabel: i18n['last_year'],
	                    index: 32
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_5_YEARS',
	                    boxLabel: i18n['last_5_years'],
	                    index: 33
	                }]
	            }]
	        }, {
	            xtype: 'container',
	            columnWidth: 0.33,
	            bodyStyle: 'border-style:none',
	            items: [{
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:0 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['months'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_MONTH',
	                    boxLabel: i18n['this_month'],
	                    index: 11
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_MONTH',
	                    boxLabel: i18n['last_month'],
	                    index: 12
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_3_MONTHS',
	                    boxLabel: i18n['last_3_months'],
	                    index: 13
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_6_MONTHS',
	                    boxLabel: i18n['last_6_months'],
	                    index: 14
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_12_MONTHS',
	                    boxLabel: i18n['last_12_months'],
	                    index: 15
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'MONTHS_THIS_YEAR',
	                    boxLabel: i18n['months_this_year'],
	                    index: 16
	                }]
	            }, {
	                xtype: 'panel',
	                bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	                defaults: relativePeriodDefaults,
	                items: [{
	                    xtype: 'label',
	                    text: i18n['sixmonths'],
	                    cls: 'ns-label-period-heading'
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'THIS_SIX_MONTH',
	                    boxLabel: i18n['this_sixmonth'],
	                    index: 25
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_SIX_MONTH',
	                    boxLabel: i18n['last_sixmonth'],
	                    index: 26
	                }, {
	                    xtype: 'checkbox',
	                    relativePeriodId: 'LAST_2_SIXMONTHS',
	                    boxLabel: i18n['last_2_sixmonths'],
	                    index: 27
	                }]
	            }]
	        }]
	    };
	
	    var fixedPeriodAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        height: 180,
	        valueField: 'id',
	        displayField: 'name',
	        store: fixedPeriodAvailableStore,
	        tbar: [{
	            xtype: 'label',
	            text: i18n.available,
	            cls: 'ns-toolbar-multiselect-left-label'
	        }, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                uiManager.msSelect(fixedPeriodAvailable, fixedPeriodSelected);
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                uiManager.msSelectAll(fixedPeriodAvailable, fixedPeriodSelected, true);
	            }
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function () {
	                    uiManager.msSelect(fixedPeriodAvailable, fixedPeriodSelected);
	                }, this);
	            }
	        }
	    });
	
	    var fixedPeriodSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        height: 180,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: true,
	        store: fixedPeriodSelectedStore,
	        tbar: [{
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                uiManager.msUnselectAll(fixedPeriodAvailable, fixedPeriodSelected);
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                uiManager.msUnselect(fixedPeriodAvailable, fixedPeriodSelected);
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n.selected,
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function () {
	                    uiManager.msUnselect(fixedPeriodAvailable, fixedPeriodSelected);
	                }, this);
	            }
	        }
	    });
	
	    var onPeriodTypeSelect = function onPeriodTypeSelect() {
	        var type = periodType.getValue(),
	            periodOffset = periodType.periodOffset,
	            gen = calendarManager.periodGenerator,
	            periods = gen.generateReversedPeriods(type, type === 'Yearly' ? periodOffset - 5 : periodOffset);
	
	        for (var i = 0; i < periods.length; i++) {
	            periods[i].id = periods[i].iso;
	        }
	
	        fixedPeriodAvailableStore.setIndex(periods);
	        fixedPeriodAvailableStore.loadData(periods);
	        uiManager.msFilterAvailable(fixedPeriodAvailable, fixedPeriodSelected);
	    };
	
	    var periodType = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin-bottom:1px',
	        width: accBaseWidth - 62 - 62 - 2,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n.select_period_type,
	        editable: false,
	        queryMode: 'remote',
	        store: periodTypeStore,
	        periodOffset: 0,
	        listeners: {
	            select: function select() {
	                periodType.periodOffset = 0;
	                onPeriodTypeSelect();
	            }
	        }
	    });
	
	    var period = Ext.create('Ext.panel.Panel', {
	        title: '<div class="ns-panel-title-period">Periods</div>',
	        hideCollapseTool: true,
	        dimension: periodObjectName,
	        checkboxes: periodCheckboxes,
	        clearDimension: function clearDimension(all) {
	            fixedPeriodSelectedStore.removeAll();
	            period.resetRelativePeriods();
	
	            if (!all) {
	                relativePeriod.valueComponentMap[appManager.getRelativePeriod()].setValue(true);
	            }
	        },
	        setDimension: function setDimension(layout) {
	            if (layout.hasDimension(this.dimension, true)) {
	                //var records = layout.getDimension(this.dimension).getRecords(null, layout.getResponse()),
	                var records = layout.getDimension(this.dimension).extendRecords(layout.getResponse()),
	                    fixedRecords = [],
	                    checkbox;
	
	                records.forEach(function (record) {
	                    checkbox = relativePeriod.valueComponentMap[record.id];
	
	                    if (checkbox) {
	                        checkbox.setValue(true);
	                    } else {
	                        fixedRecords.push(record);
	                    }
	                });
	
	                fixedPeriodSelectedStore.add(fixedRecords);
	
	                uiManager.msFilterAvailable({ store: fixedPeriodAvailableStore }, { store: fixedPeriodSelectedStore });
	            }
	        },
	        getDimension: function getDimension() {
	            var config = {
	                dimension: periodObjectName,
	                items: []
	            };
	
	            fixedPeriodSelectedStore.each(function (r) {
	                config.items.push({
	                    id: r.data.id,
	                    name: r.data.name
	                });
	            });
	
	            for (var i = 0, chb; i < this.checkboxes.length; i++) {
	                chb = this.checkboxes[i];
	
	                if (chb && chb.getValue()) {
	                    config.items.push({
	                        id: chb.relativePeriodId,
	                        name: ''
	                    });
	                }
	            }
	
	            return config.items.length ? config : null;
	        },
	        getHeightValue: function getHeightValue() {
	            var westRegion = uiManager.get('westRegion');
	
	            return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_period : uiConfig.west_maxheight_accordion_period;
	        },
	        onExpand: function onExpand() {
	            accordion.setThisHeight(this.getHeightValue());
	
	            uiManager.msSetHeight([fixedPeriodAvailable, fixedPeriodSelected], this, uiConfig.west_fill_accordion_period);
	        },
	        resetRelativePeriods: function resetRelativePeriods() {
	            var a = this.checkboxes;
	            for (var i = 0; i < a.length; i++) {
	                a[i].setValue(false);
	            }
	        },
	        isNoRelativePeriods: function isNoRelativePeriods() {
	            var a = this.checkboxes;
	            for (var i = 0; i < a.length; i++) {
	                if (a[i].getValue()) {
	                    return false;
	                }
	            }
	            return true;
	        },
	        items: [{
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none',
	            style: 'margin-top:0px',
	            items: [periodType, {
	                xtype: 'button',
	                text: i18n.prev_year,
	                style: 'margin-left:1px; border-radius:2px',
	                height: 24,
	                width: 62,
	                handler: function handler() {
	                    if (periodType.getValue()) {
	                        periodType.periodOffset--;
	                        onPeriodTypeSelect();
	                    }
	                }
	            }, {
	                xtype: 'button',
	                text: i18n.next_year,
	                style: 'margin-left:1px; border-radius:2px',
	                height: 24,
	                width: 62,
	                handler: function handler() {
	                    if (periodType.getValue()) {
	                        periodType.periodOffset++;
	                        onPeriodTypeSelect();
	                    }
	                }
	            }]
	        }, {
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none; padding-bottom:2px',
	            items: [fixedPeriodAvailable, fixedPeriodSelected]
	        }, relativePeriod],
	        listeners: {
	            expand: function expand(p) {
	                p.onExpand();
	            }
	        }
	    });
	    accordionPanels.push(uiManager.reg(period, 'period'));
	
	    // organisation unit
	
	    var treePanel = Ext.create('Ext.tree.Panel', {
	        cls: 'ns-tree',
	        style: 'border-top: 1px solid #ddd; padding-top: 1px',
	        width: accBaseWidth,
	        displayField: 'name',
	        rootVisible: false,
	        autoScroll: true,
	        multiSelect: true,
	        rendered: false,
	        reset: function reset() {
	            var rootNode = this.getRootNode().findChild('id', appManager.rootNodes[0].id);
	            this.collapseAll();
	            this.expandPath(rootNode.getPath());
	            this.getSelectionModel().select(rootNode);
	        },
	        selectRootIf: function selectRootIf() {
	            if (this.getSelectionModel().getSelection().length < 1) {
	                var node = this.getRootNode().findChild('id', appManager.rootNodes[0].id);
	                if (this.rendered) {
	                    this.getSelectionModel().select(node);
	                }
	                return node;
	            }
	        },
	        isPending: false,
	        recordsToSelect: [],
	        recordsToRestore: [],
	        multipleSelectIf: function multipleSelectIf(map, doUpdate) {
	            this.recordsToSelect = (0, _arrayClean2.default)(this.recordsToSelect);
	
	            if (this.recordsToSelect.length === Object.keys(map).length) {
	                this.getSelectionModel().select(this.recordsToSelect);
	                this.recordsToSelect = [];
	                this.isPending = false;
	
	                if (doUpdate) {
	                    update();
	                }
	            }
	        },
	        multipleExpand: function multipleExpand(id, map, doUpdate) {
	            var t = this,
	                rootId = appManager.rootNodeId,
	                path = map[id];
	
	            if (path.substr(0, rootId.length + 1) !== '/' + rootId) {
	                path = '/' + rootId + '/' + path;
	            }
	
	            t.expandPath(path, 'id', '/', function () {
	                var record = t.getRootNode().findChild('id', id, true);
	                t.recordsToSelect.push(record);
	                t.multipleSelectIf(map, doUpdate);
	            });
	        },
	        select: function select(url, params) {
	            if (!params) {
	                params = {};
	            }
	            Ext.Ajax.request({
	                url: encodeURI(url),
	                method: 'GET',
	                params: params,
	                scope: this,
	                success: function success(r) {
	                    var a = Ext.decode(r.responseText).organisationUnits;
	                    this.numberOfRecords = a.length;
	                    for (var i = 0; i < a.length; i++) {
	                        this.multipleExpand(a[i].id, a[i].path);
	                    }
	                }
	            });
	        },
	        getParentGraphMap: function getParentGraphMap() {
	            var selection = this.getSelectionModel().getSelection(),
	                map = {};
	
	            if ((0, _isArray2.default)(selection) && selection.length) {
	                for (var i = 0, pathArray, key; i < selection.length; i++) {
	                    pathArray = selection[i].getPath().split('/');
	                    map[pathArray.pop()] = pathArray.join('/');
	                }
	            }
	
	            return map;
	        },
	        selectGraphMap: function selectGraphMap(map, update) {
	            if (!Object.keys(map).length) {
	                return;
	            }
	
	            this.isPending = true;
	
	            for (var key in map) {
	                if (map.hasOwnProperty(key)) {
	                    treePanel.multipleExpand(key, map, update);
	                }
	            }
	        },
	        store: Ext.create('Ext.data.TreeStore', {
	            fields: ['id', 'name', 'hasChildren'],
	            proxy: {
	                type: 'rest',
	                format: 'json',
	                noCache: false,
	                extraParams: {
	                    fields: 'children[id,' + displayPropertyUrl + ',children::isNotEmpty~rename(hasChildren)&paging=false'
	                },
	                url: apiPath + '/organisationUnits',
	                reader: {
	                    type: 'json',
	                    root: 'children'
	                },
	                sortParam: false
	            },
	            sorters: [{
	                property: 'name',
	                direction: 'ASC'
	            }],
	            root: {
	                id: appManager.rootNodeId,
	                expanded: true,
	                children: appManager.getRootNodes()
	            },
	            listeners: {
	                beforeload: function beforeload(store, operation) {
	                    if (!store.proxy._url) {
	                        store.proxy._url = store.proxy.url;
	                    }
	
	                    store.proxy.url = store.proxy._url + '/' + operation.node.data.id;
	                },
	                load: function load(store, node, records) {
	                    records.forEach(function (record) {
	                        if ((0, _isBoolean2.default)(record.data.hasChildren)) {
	                            record.set('leaf', !record.data.hasChildren);
	                        }
	                    });
	                }
	            }
	        }),
	        xable: function xable(values) {
	            for (var i = 0; i < values.length; i++) {
	                if (!!values[i]) {
	                    this.disable();
	                    return;
	                }
	            }
	
	            this.enable();
	        },
	        listeners: {
	            beforeitemexpand: function beforeitemexpand() {
	                if (!treePanel.isPending) {
	                    treePanel.recordsToRestore = treePanel.getSelectionModel().getSelection();
	                }
	            },
	            itemexpand: function itemexpand() {
	                if (!treePanel.isPending && treePanel.recordsToRestore.length) {
	                    treePanel.getSelectionModel().select(treePanel.recordsToRestore);
	                    treePanel.recordsToRestore = [];
	                }
	            },
	            render: function render() {
	                this.rendered = true;
	            },
	            afterrender: function afterrender() {
	                this.getSelectionModel().select(0);
	            },
	            itemcontextmenu: function itemcontextmenu(v, r, h, i, e) {
	                v.getSelectionModel().select(r, false);
	
	                if (v.menu) {
	                    v.menu.destroy();
	                }
	                v.menu = Ext.create('Ext.menu.Menu', {
	                    id: 'treepanel-contextmenu',
	                    showSeparator: false,
	                    shadow: false
	                });
	                if (!r.data.leaf) {
	                    v.menu.add({
	                        id: 'treepanel-contextmenu-item',
	                        text: i18n.select_sub_units,
	                        iconCls: 'ns-button-icon-nodeselectchild',
	                        handler: function handler() {
	                            r.expand(false, function () {
	                                v.getSelectionModel().select(r.childNodes, true);
	                                v.getSelectionModel().deselect(r);
	                            });
	                        }
	                    });
	                } else {
	                    return;
	                }
	
	                v.menu.showAt(e.xy);
	            }
	        }
	    });
	    uiManager.reg(treePanel, 'treePanel');
	
	    var userOrganisationUnit = Ext.create('Ext.form.field.Checkbox', {
	        columnWidth: 0.25,
	        style: 'padding-top: 3px; padding-left: 5px; margin-bottom: 0',
	        boxLabel: i18n.user_organisation_unit,
	        labelWidth: uiConfig.form_label_width,
	        handler: function handler(chb, checked) {
	            treePanel.xable([checked, userOrganisationUnitChildren.getValue(), userOrganisationUnitGrandChildren.getValue()]);
	        }
	    });
	
	    var userOrganisationUnitChildren = Ext.create('Ext.form.field.Checkbox', {
	        columnWidth: 0.26,
	        style: 'padding-top: 3px; margin-bottom: 0',
	        boxLabel: i18n.user_sub_units,
	        labelWidth: uiConfig.form_label_width,
	        handler: function handler(chb, checked) {
	            treePanel.xable([checked, userOrganisationUnit.getValue(), userOrganisationUnitGrandChildren.getValue()]);
	        }
	    });
	
	    var userOrganisationUnitGrandChildren = Ext.create('Ext.form.field.Checkbox', {
	        columnWidth: 0.4,
	        style: 'padding-top: 3px; margin-bottom: 0',
	        boxLabel: i18n.user_sub_x2_units,
	        labelWidth: uiConfig.form_label_width,
	        handler: function handler(chb, checked) {
	            treePanel.xable([checked, userOrganisationUnit.getValue(), userOrganisationUnitChildren.getValue()]);
	        }
	    });
	
	    var organisationUnitLevel = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        multiSelect: true,
	        style: 'margin-bottom:0',
	        width: accBaseWidth - 37,
	        valueField: 'level',
	        displayField: 'name',
	        emptyText: i18n.select_organisation_unit_levels,
	        editable: false,
	        hidden: true,
	        store: organisationUnitLevelStore
	    });
	
	    var organisationUnitGroup = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        multiSelect: true,
	        style: 'margin-bottom:0',
	        width: accBaseWidth - 37,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n.select_organisation_unit_groups,
	        editable: false,
	        hidden: true,
	        store: organisationUnitGroupStore
	    });
	
	    var toolMenu = Ext.create('Ext.menu.Menu', {
	        shadow: false,
	        showSeparator: false,
	        menuValue: 'orgunit',
	        clickHandler: function clickHandler(param) {
	            if (!param) {
	                return;
	            }
	
	            var items = this.items.items;
	            this.menuValue = param;
	
	            // Menu item icon cls
	            for (var i = 0; i < items.length; i++) {
	                if (items[i].setIconCls) {
	                    if (items[i].param === param) {
	                        items[i].setIconCls('ns-menu-item-selected');
	                    } else {
	                        items[i].setIconCls('ns-menu-item-unselected');
	                    }
	                }
	            }
	
	            // Gui
	            if (param === 'orgunit') {
	                userOrganisationUnit.show();
	                userOrganisationUnitChildren.show();
	                userOrganisationUnitGrandChildren.show();
	                organisationUnitLevel.hide();
	                organisationUnitGroup.hide();
	
	                if (userOrganisationUnit.getValue() || userOrganisationUnitChildren.getValue()) {
	                    treePanel.disable();
	                }
	            } else if (param === 'level') {
	                userOrganisationUnit.hide();
	                userOrganisationUnitChildren.hide();
	                userOrganisationUnitGrandChildren.hide();
	                organisationUnitLevel.show();
	                organisationUnitGroup.hide();
	                treePanel.enable();
	            } else if (param === 'group') {
	                // DHIS2-561: avoid showing the group ids in the combobox when
	                // loading a favorite and expanding the OU panel
	                organisationUnitGroupStore.load();
	
	                userOrganisationUnit.hide();
	                userOrganisationUnitChildren.hide();
	                userOrganisationUnitGrandChildren.hide();
	                organisationUnitLevel.hide();
	                organisationUnitGroup.show();
	                treePanel.enable();
	            }
	        },
	        items: [{
	            xtype: 'label',
	            text: 'Selection mode',
	            style: 'padding:7px 5px 5px 7px; font-weight:bold; border:0 none'
	        }, {
	            text: i18n.select_organisation_units + '&nbsp;&nbsp;',
	            param: 'orgunit',
	            iconCls: 'ns-menu-item-selected'
	        }, {
	            text: 'Select levels' + '&nbsp;&nbsp;',
	            param: 'level',
	            iconCls: 'ns-menu-item-unselected'
	        }, {
	            text: 'Select groups' + '&nbsp;&nbsp;',
	            param: 'group',
	            iconCls: 'ns-menu-item-unselected'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.getEl().addCls('ns-btn-menu');
	            },
	            click: function click(menu, item) {
	                this.clickHandler(item.param);
	            }
	        }
	    });
	
	    var tool = Ext.create('Ext.button.Button', {
	        cls: 'ns-button-organisationunitselection',
	        iconCls: 'ns-button-icon-gear',
	        width: 36,
	        height: 24,
	        menu: toolMenu
	    });
	
	    var toolPanel = Ext.create('Ext.panel.Panel', {
	        width: 36,
	        bodyStyle: 'border:0 none; text-align:right',
	        style: 'margin-right:1px',
	        items: tool
	    });
	
	    var organisationUnit = Ext.create('Ext.panel.Panel', {
	        title: '<div class="ns-panel-title-organisationunit">' + i18n.organisation_units + '</div>',
	        bodyStyle: 'padding:1px',
	        hideCollapseTool: true,
	        dimension: organisationUnitObjectName,
	        collapsed: false,
	        clearDimension: function clearDimension(doClear) {
	            if (doClear) {
	                treePanel.reset();
	
	                userOrganisationUnit.setValue(false);
	                userOrganisationUnitChildren.setValue(false);
	                userOrganisationUnitGrandChildren.setValue(false);
	            }
	        },
	        setDimension: function setDimension(layout) {
	            if (layout.hasDimension(this.dimension, true)) {
	                var dimension = layout.getDimension(this.dimension, true),
	                    parentGraphMap = layout.parentGraphMap;
	
	                var records = dimension.getRecords(),
	                    ids = [],
	                    levels = [],
	                    groups = [],
	                    isOu,
	                    isOuc,
	                    isOugc;
	
	                records.forEach(function (record) {
	                    if (record.id === 'USER_ORGUNIT') {
	                        isOu = true;
	                    } else if (record.id === 'USER_ORGUNIT_CHILDREN') {
	                        isOuc = true;
	                    } else if (record.id === 'USER_ORGUNIT_GRANDCHILDREN') {
	                        isOugc = true;
	                    } else if (record.id.substr(0, 5) === 'LEVEL') {
	                        levels.push(parseInt(record.id.split('-')[1]));
	                    } else if (record.id.substr(0, 8) === 'OU_GROUP') {
	                        groups.push(record.id.split('-')[1]);
	                    } else {
	                        ids.push(record.id);
	                    }
	                });
	
	                if (levels.length) {
	                    toolMenu.clickHandler('level');
	                    organisationUnitLevel.setValue(levels);
	                } else if (groups.length) {
	                    toolMenu.clickHandler('group');
	                    organisationUnitGroup.setValue(groups);
	                } else {
	                    toolMenu.clickHandler('orgunit');
	                    userOrganisationUnit.setValue(isOu);
	                    userOrganisationUnitChildren.setValue(isOuc);
	                    userOrganisationUnitGrandChildren.setValue(isOugc);
	                }
	
	                if (!(isOu || isOuc || isOugc)) {
	                    if ((0, _isObject2.default)(parentGraphMap)) {
	                        treePanel.selectGraphMap(parentGraphMap);
	                    }
	                }
	            } else {
	                this.clearDimension(true);
	            }
	        },
	        getDimension: function getDimension() {
	            var r = treePanel.getSelectionModel().getSelection(),
	                config = {
	                dimension: organisationUnitObjectName,
	                items: []
	            };
	
	            if (toolMenu.menuValue === 'orgunit') {
	                if (userOrganisationUnit.getValue() || userOrganisationUnitChildren.getValue() || userOrganisationUnitGrandChildren.getValue()) {
	                    if (userOrganisationUnit.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT',
	                            name: ''
	                        });
	                    }
	                    if (userOrganisationUnitChildren.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT_CHILDREN',
	                            name: ''
	                        });
	                    }
	                    if (userOrganisationUnitGrandChildren.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT_GRANDCHILDREN',
	                            name: ''
	                        });
	                    }
	                } else {
	                    for (var i = 0; i < r.length; i++) {
	                        config.items.push({ id: r[i].data.id });
	                    }
	                }
	            } else if (toolMenu.menuValue === 'level') {
	                var levels = organisationUnitLevel.getValue();
	
	                for (var i = 0; i < levels.length; i++) {
	                    config.items.push({
	                        id: 'LEVEL-' + levels[i],
	                        name: ''
	                    });
	                }
	
	                for (var i = 0; i < r.length; i++) {
	                    config.items.push({
	                        id: r[i].data.id,
	                        name: ''
	                    });
	                }
	            } else if (toolMenu.menuValue === 'group') {
	                var groupIds = organisationUnitGroup.getValue();
	
	                for (var i = 0; i < groupIds.length; i++) {
	                    config.items.push({
	                        id: 'OU_GROUP-' + groupIds[i],
	                        name: ''
	                    });
	                }
	
	                for (var i = 0; i < r.length; i++) {
	                    config.items.push({
	                        id: r[i].data.id,
	                        name: ''
	                    });
	                }
	            }
	
	            return config.items.length ? config : null;
	        },
	        getHeightValue: function getHeightValue() {
	            var westRegion = uiManager.get('westRegion');
	
	            return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_organisationunit : uiConfig.west_maxheight_accordion_organisationunit;
	        },
	        onExpand: function onExpand() {
	            accordion.setThisHeight(this.getHeightValue);
	
	            treePanel.setHeight(this.getHeight() - uiConfig.west_fill_accordion_organisationunit);
	        },
	        items: [{
	            layout: 'column',
	            bodyStyle: 'border:0 none',
	            style: 'padding-bottom:1px',
	            items: [toolPanel, {
	                width: accBaseWidth - 37,
	                layout: 'column',
	                bodyStyle: 'border:0 none',
	                items: [userOrganisationUnit, userOrganisationUnitChildren, userOrganisationUnitGrandChildren, organisationUnitLevel, organisationUnitGroup]
	            }]
	        }, treePanel],
	        listeners: {
	            expand: function expand(p) {
	                p.onExpand();
	            }
	        }
	    });
	    accordionPanels.push(uiManager.reg(organisationUnit, 'organisationUnit'));
	
	    // dimensions
	
	    var getDimensionPanel = function getDimensionPanel(dimension, iconCls) {
	        var onSelect, availableStore, selectedStore, dataLabel, dataSearch, dataFilter, selectedAll, available, selected, onSelectAll, panel, createPanel, getPanels;
	
	        onSelect = function onSelect() {
	            var win = uiManager.get('layoutWindow');
	
	            if (selectedStore.getRange().length || selectedAll.getValue()) {
	                win.addDimension({ id: dimension.id, name: dimension.name });
	            } else if (win.hasDimension(dimension.id)) {
	                win.removeDimension(dimension.id);
	            }
	        };
	
	        availableStore = Ext.create('Ext.data.Store', {
	            fields: ['id', 'name'],
	            lastPage: null,
	            nextPage: 1,
	            isPending: false,
	            isLoaded: false,
	            reset: function reset() {
	                this.removeAll();
	                this.lastPage = null;
	                this.nextPage = 1;
	                this.isPending = false;
	                dataSearch.hideFilter();
	            },
	            storage: {},
	            addToStorage: function addToStorage(dimensionId, filter, data) {
	                filter = 'cache_' + ((0, _isString2.default)(filter) || (0, _isNumber2.default)(filter) ? filter : '');
	
	                if (!dimensionId) {
	                    return;
	                }
	
	                if (!this.storage.hasOwnProperty(dimensionId)) {
	                    this.storage[dimensionId] = {};
	                }
	
	                if (!this.storage[dimensionId][filter]) {
	                    this.storage[dimensionId][filter] = data;
	                }
	            },
	            getFromStorage: function getFromStorage(dimensionId, filter) {
	                filter = 'cache_' + ((0, _isString2.default)(filter) || (0, _isNumber2.default)(filter) ? filter : '');
	
	                if (this.storage.hasOwnProperty(dimensionId)) {
	                    if (this.storage[dimensionId].hasOwnProperty(filter)) {
	                        return this.storage[dimensionId][filter];
	                    }
	                }
	
	                return;
	            },
	            loadPage: function loadPage(filter, append, noPaging, fn) {
	                var store = this,
	                    params = {},
	                    url,
	                    cacheData;
	
	                filter = filter || dataFilter.getValue() || null;
	
	                // check session cache
	                cacheData = store.getFromStorage(dimension.id, filter);
	
	                if (!append && cacheData) {
	                    store.loadStore(cacheData, {}, append, fn);
	                } else {
	                    if (!append) {
	                        this.lastPage = null;
	                        this.nextPage = 1;
	                    }
	
	                    if (store.nextPage === store.lastPage) {
	                        return;
	                    }
	
	                    url = '/dimensions/' + dimension.id + '/items.json?fields=id,' + displayPropertyUrl + (filter ? '&filter=' + displayProperty + ':ilike:' + filter : '');
	
	                    if (noPaging) {
	                        params.paging = false;
	                    } else {
	                        params.page = store.nextPage;
	                        params.pageSize = 50;
	                    }
	
	                    store.isPending = true;
	                    uiManager.mask(available.boundList);
	
	                    Ext.Ajax.request({
	                        url: encodeURI(apiPath + url),
	                        method: 'GET',
	                        params: params,
	                        success: function success(r) {
	                            var response = Ext.decode(r.responseText),
	                                data = response.items || [],
	                                pager = response.pager;
	
	                            // add to session cache
	                            store.addToStorage(dimension.id, filter, data);
	
	                            store.loadStore(data, pager, append, fn);
	                        },
	                        callback: function callback() {
	                            store.isPending = false;
	                            uiManager.unmask(available.boundList);
	                        }
	                    });
	                }
	            },
	            loadStore: function loadStore(data, pager, append, fn) {
	                pager = pager || {};
	
	                this.loadData(data, append);
	                this.lastPage = this.nextPage;
	
	                if (pager.pageCount > this.nextPage) {
	                    this.nextPage++;
	                }
	
	                this.isPending = false;
	
	                uiManager.msFilterAvailable({ store: availableStore }, { store: selectedStore });
	
	                if (fn) {
	                    fn();
	                }
	            },
	            sortStore: function sortStore() {
	                this.sort('name', 'ASC');
	            }
	        });
	
	        selectedStore = Ext.create('Ext.data.Store', {
	            fields: ['id', 'name'],
	            data: [],
	            listeners: {
	                add: function add() {
	                    onSelect();
	                },
	                remove: function remove() {
	                    onSelect();
	                },
	                clear: function clear() {
	                    onSelect();
	                }
	            }
	        });
	
	        dataLabel = Ext.create('Ext.form.Label', {
	            text: i18n.available,
	            cls: 'ns-toolbar-multiselect-left-label',
	            style: 'margin-right:5px'
	        });
	
	        dataSearch = Ext.create('Ext.button.Button', {
	            width: 22,
	            height: 22,
	            cls: 'ns-button-icon',
	            iconCls: 'ns-button-icon-search',
	            showFilter: function showFilter() {
	                dataLabel.hide();
	                this.hide();
	                dataFilter.show();
	                dataFilter.reset();
	            },
	            hideFilter: function hideFilter() {
	                dataLabel.show();
	                this.show();
	                dataFilter.hide();
	                dataFilter.reset();
	            },
	            handler: function handler() {
	                this.showFilter();
	            }
	        });
	
	        dataFilter = Ext.create('Ext.form.field.Trigger', {
	            cls: 'ns-trigger-filter',
	            emptyText: 'Filter available..',
	            height: 22,
	            hidden: true,
	            enableKeyEvents: true,
	            fieldStyle: 'height:22px; border-right:0 none',
	            style: 'height:22px',
	            onTriggerClick: function onTriggerClick() {
	                this.reset();
	                this.onKeyUpHandler();
	
	                dataSearch.hideFilter();
	            },
	            onKeyUpHandler: function onKeyUpHandler() {
	                var value = this.getValue(),
	                    store = availableStore;
	
	                if ((0, _isString2.default)(value) || (0, _isNumber2.default)(value)) {
	                    store.loadPage(value, false, true);
	                }
	            },
	            listeners: {
	                keyup: {
	                    fn: function fn(cmp) {
	                        cmp.onKeyUpHandler();
	                    },
	                    buffer: 100
	                },
	                show: function show(cmp) {
	                    cmp.focus(false, 50);
	                },
	                focus: function focus(cmp) {
	                    cmp.addCls('ns-trigger-filter-focused');
	                },
	                blur: function blur(cmp) {
	                    cmp.removeCls('ns-trigger-filter-focused');
	                }
	            }
	        });
	
	        selectedAll = Ext.create('Ext.form.field.Checkbox', {
	            cls: 'ns-checkbox',
	            style: 'margin-left: 2px; margin-right: 5px',
	            boxLabel: 'All',
	            listeners: {
	                change: function change(chb, newVal) {
	                    onSelectAll(newVal);
	                }
	            }
	        });
	
	        available = Ext.create('Ext.ux.form.MultiSelect', {
	            cls: 'ns-toolbar-multiselect-left',
	            width: accBaseWidth / 2,
	            valueField: 'id',
	            displayField: 'name',
	            store: availableStore,
	            tbar: [dataLabel, dataSearch, dataFilter, '->', {
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowright',
	                width: 22,
	                handler: function handler() {
	                    uiManager.msSelect(available, selected);
	                }
	            }, {
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowrightdouble',
	                width: 22,
	                handler: function handler() {
	                    availableStore.loadPage(null, null, true, function () {
	                        uiManager.msSelectAll(available, selected);
	                    });
	                }
	            }],
	            listeners: {
	                render: function render(ms) {
	                    var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                    el.addEventListener('scroll', function (e) {
	                        if (uiManager.isScrolled(e) && !availableStore.isPending) {
	                            availableStore.loadPage(null, true);
	                        }
	                    });
	
	                    ms.boundList.on('itemdblclick', function () {
	                        uiManager.msSelect(available, selected);
	                    }, ms);
	                }
	            }
	        });
	
	        selected = Ext.create('Ext.ux.form.MultiSelect', {
	            cls: 'ns-toolbar-multiselect-right',
	            width: accBaseWidth / 2,
	            valueField: 'id',
	            displayField: 'name',
	            ddReorder: true,
	            store: selectedStore,
	            tbar: [{
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowleftdouble',
	                width: 22,
	                handler: function handler() {
	                    uiManager.msUnselectAll(available, selected);
	                }
	            }, {
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowleft',
	                width: 22,
	                handler: function handler() {
	                    uiManager.msUnselect(available, selected);
	                }
	            }, '->', {
	                xtype: 'label',
	                text: i18n.selected,
	                cls: 'ns-toolbar-multiselect-right-label'
	            }, selectedAll],
	            listeners: {
	                afterrender: function afterrender() {
	                    this.boundList.on('itemdblclick', function () {
	                        uiManager.msUnselect(available, selected);
	                    }, this);
	                }
	            }
	        });
	
	        onSelectAll = function onSelectAll(value) {
	            if (available.boundList && selected.boundList) {
	                if (value) {
	                    available.boundList.disable();
	                    selected.boundList.disable();
	                } else {
	                    available.boundList.enable();
	                    selected.boundList.enable();
	                }
	            }
	
	            onSelect();
	        };
	
	        panel = Ext.create('Ext.panel.Panel', {
	            title: '<div class="' + iconCls + '">' + dimension.name + '</div>',
	            hideCollapseTool: true,
	            dimension: dimension.id,
	            availableStore: availableStore,
	            selectedStore: selectedStore,
	            selectedAll: selectedAll,
	            isDynamic: true,
	            clearDimension: function clearDimension() {
	                availableStore.reset();
	                selectedStore.removeAll();
	                selectedAll.setValue(false);
	            },
	            setDimension: function setDimension(layout) {
	                if (layout.hasDimension(this.dimension, true)) {
	                    var records = layout.getDimension(this.dimension).getRecords();
	
	                    if (records.length) {
	                        selectedStore.add(records);
	                        uiManager.msFilterAvailable({ store: availableStore }, { store: selectedStore });
	                    } else {
	                        selectedAll.setValue(true);
	                    }
	                }
	            },
	            getDimension: function getDimension() {
	                var config = {};
	
	                if (dimension.id) {
	                    config.dimension = dimension.id;
	                }
	
	                if (!selectedAll.getValue() && selectedStore.getRange().length) {
	                    config.items = [];
	
	                    selectedStore.each(function (r) {
	                        config.items.push({ id: r.data.id });
	                    });
	                }
	
	                return config.dimension ? config : null;
	            },
	            onExpand: function onExpand() {
	
	                // load items
	                if (!availableStore.isLoaded) {
	                    availableStore.loadPage();
	                }
	
	                // enable/disable ui
	                if (selectedAll.getValue()) {
	                    available.boundList.disable();
	                    selected.boundList.disable();
	                }
	
	                // set height
	                var westRegion = uiManager.get('westRegion');
	                var accordion = uiManager.get('accordion');
	
	                var accordionHeight = westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_group : uiConfig.west_maxheight_accordion_group;
	
	                accordion.setThisHeight(accordionHeight);
	
	                uiManager.msSetHeight([available, selected], this, uiConfig.west_fill_accordion_group);
	            },
	            items: [{
	                xtype: 'panel',
	                layout: 'column',
	                bodyStyle: 'border-style:none',
	                items: [available, selected]
	            }],
	            listeners: {
	                expand: function expand(p) {
	                    p.onExpand();
	                }
	            }
	        });
	
	        return panel;
	    };
	
	    // accordion
	    var defaultItems = [data, period, organisationUnit].concat(_toConsumableArray(appManager.dimensions.map(function (dimension) {
	        var panel = getDimensionPanel(dimension, 'ns-panel-title-dimension');
	
	        accordionPanels.push(uiManager.reg(panel, panel.dimension));
	
	        return panel;
	    })));
	
	    var getItems = function getItems() {
	        var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        return dimensions.map(function (dimension) {
	            return getDimensionPanel(dimension, 'ns-panel-title-dimension');
	        });
	    };
	
	    var accordionBody = Ext.create('Ext.panel.Panel', {
	        layout: 'accordion',
	        activeOnTop: true,
	        cls: 'ns-accordion',
	        bodyStyle: 'border:0 none',
	        height: 700,
	        toBeRemoved: [],
	        addItems: function addItems(dimensions) {
	            this.toBeRemoved = this.add(getItems(dimensions));
	
	            accordion.setThisHeight();
	        },
	        removeItems: function removeItems() {
	            this.toBeRemoved.map(function (item) {
	                return (0, _isString2.default)(item) ? item : item.id;
	            }).forEach(function (id) {
	                accordionBody.remove(id);
	            });
	
	            accordion.setThisHeight();
	
	            this.toBeRemoved = [];
	        },
	        getExpandedPanel: function getExpandedPanel() {
	            var expandedPanel;
	
	            this.items.each(function (panel) {
	                if (!panel.collapsed) {
	                    expandedPanel = panel;
	                    return false;
	                }
	            });
	
	            return expandedPanel;
	        },
	        items: defaultItems
	    });
	
	    // state
	    var setUiState = function setUiState(layout) {
	        var layoutWindow = uiManager.get('layoutWindow'),
	            optionsWindow = uiManager.get('optionsWindow'),
	            chartTypeToolbar = uiManager.get('chartTypeToolbar');
	
	        if (chartTypeToolbar) {
	            chartTypeToolbar.reset();
	        }
	
	        // clear panels
	        accordion.clearDimensions(layout);
	
	        if (layout) {
	            var co = dimensionConfig.get('category');
	
	            // type
	            if (chartTypeToolbar) {
	                chartTypeToolbar.setChartType(layout.type);
	            }
	
	            // panels
	            accordion.setDimensions(layout);
	
	            // layout window
	            if (layoutWindow) {
	                layoutWindow.reset(true);
	                layoutWindow.setDimensions(layout);
	            }
	
	            // add assigned categories as dimension
	            if (!layoutWindow.hasDimension(co.dimensionName)) {
	                layoutWindow.addDimension({
	                    id: co.dimensionName,
	                    name: co.name
	                }, layoutWindow.dimensionStore);
	            }
	
	            // options window
	            if (optionsWindow) {
	                optionsWindow.setOptions(layout);
	            }
	        } else {
	            treePanel.reset();
	            layoutWindow.reset();
	            optionsWindow.reset();
	        }
	    };
	
	    var getUiState = function getUiState(layoutWindow, optionsWindow) {
	        var columnDimNames = layoutWindow.colStore.getDimensionNames(),
	            rowDimNames = layoutWindow.rowStore.getDimensionNames(),
	            filterDimNames = layoutWindow.filterStore.getDimensionNames(),
	            config = optionsWindow.getOptions(),
	            dx = dimensionConfig.get('data').dimensionName,
	            co = dimensionConfig.get('category').dimensionName,
	            nameDimArrayMap = {};
	
	        config.columns = [];
	        config.rows = [];
	        config.filters = [];
	
	        // all panels data
	        accordionBody.items.each(function (panel) {
	            if (panel.getDimension) {
	                var dim = panel.getDimension();
	
	                if (dim && dim.dimension) {
	                    nameDimArrayMap[dim.dimension] = [dim];
	                }
	            }
	        });
	
	        // columns, rows, filters
	        for (var i = 0, nameArrays = [columnDimNames, rowDimNames, filterDimNames], axes = [config.columns, config.rows, config.filters], dimNames; i < nameArrays.length; i++) {
	            dimNames = nameArrays[i];
	
	            for (var j = 0, dimName, dim; j < dimNames.length; j++) {
	                dimName = dimNames[j];
	
	                if (dimName === co) {
	                    axes[i].push({
	                        dimension: co,
	                        items: []
	                    });
	                } else if (dimName === dx && nameDimArrayMap.hasOwnProperty(dimName) && nameDimArrayMap[dimName]) {
	                    for (var k = 0; k < nameDimArrayMap[dx].length; k++) {
	                        axes[i].push(Ext.clone(nameDimArrayMap[dx][k]));
	
	                        // TODO program
	                        if (nameDimArrayMap[dx][k].program) {
	                            config.program = nameDimArrayMap[dx][k].program;
	                        }
	                    }
	                } else if (nameDimArrayMap.hasOwnProperty(dimName) && nameDimArrayMap[dimName]) {
	                    for (var k = 0; k < nameDimArrayMap[dimName].length; k++) {
	                        axes[i].push(Ext.clone(nameDimArrayMap[dimName][k]));
	                    }
	                }
	            }
	        }
	
	        return config;
	    };
	
	    // add listeners
	    (function () {
	        indicatorAvailableStore.on('load', function () {
	            uiManager.msFilterAvailable(indicatorAvailable, indicatorSelected);
	        });
	
	        dataElementAvailableStore.on('load', function () {
	            uiManager.msFilterAvailable(dataElementAvailable, dataElementSelected);
	        });
	
	        dataSetAvailableStore.on('load', function (store) {
	            uiManager.msFilterAvailable(dataSetAvailable, dataSetSelected);
	            store.sort('name', 'ASC');
	        });
	    })();
	
	    var accordion = Ext.create('Ext.panel.Panel', (_Ext$create = {
	        bodyStyle: 'border-style:none; border-top:1px solid #e1e1e1; padding:1px; padding-bottom:0; overflow-y:scroll;',
	        accordionBody: accordionBody,
	        items: accordionBody,
	        panels: accordionPanels,
	        expandInitPanels: function expandInitPanels() {
	            organisationUnit.expand();
	        },
	        clearDimensions: function clearDimensions(layout) {
	            accordionPanels.forEach(function (panel) {
	                panel.clearDimension(!!layout);
	            });
	        },
	        setDimensions: function setDimensions(layout) {
	            accordionPanels.forEach(function (panel) {
	                panel.setDimension(layout);
	            });
	        },
	        setThisHeight: function setThisHeight(mx) {
	            var westRegion = uiManager.get('westRegion'),
	                panelHeight = this.panels.length * 28,
	                chartTypeToolbarHeight = westRegion.hasChartTypeToolbar() ? 45 : 0,
	                height;
	
	            if (westRegion.hasScrollbar) {
	                height = panelHeight + mx;
	                this.setHeight(westRegion.getHeight() - chartTypeToolbarHeight - 2);
	                accordionBody.setHeight(height - 2);
	            } else {
	                height = westRegion.getHeight() - uiConfig.west_fill;
	                mx += panelHeight;
	                accordion.setHeight((height > mx ? mx : height) - 2);
	                accordionBody.setHeight((height > mx ? mx : height) - 4);
	            }
	        },
	        getExpandedPanel: function getExpandedPanel() {
	            return accordionBody.getExpandedPanel();
	        },
	        getFirstPanel: function getFirstPanel() {
	            return this.panels[0];
	        },
	        getParentGraphMap: function getParentGraphMap() {
	            return treePanel.getParentGraphMap();
	        },
	        getUxArray: function getUxArray(id) {
	            return dataElementSelected.getUxArrayById(id);
	        }
	
	    }, _defineProperty(_Ext$create, 'accordionBody', accordionBody), _defineProperty(_Ext$create, 'panels', accordionPanels), _defineProperty(_Ext$create, 'treePanel', treePanel), _defineProperty(_Ext$create, 'getUiState', getUiState), _defineProperty(_Ext$create, 'setUiState', setUiState), _Ext$create));
	
	    return accordion;
	};
	//# sourceMappingURL=WestRegionAggregateItems.js.map

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WestRegionTrackerItems = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _clone = __webpack_require__(28);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _arrayClean = __webpack_require__(7);
	
	var _arrayClean2 = _interopRequireDefault(_arrayClean);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayPluck = __webpack_require__(27);
	
	var _arrayPluck2 = _interopRequireDefault(_arrayPluck);
	
	var _arraySort = __webpack_require__(8);
	
	var _arraySort2 = _interopRequireDefault(_arraySort);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isBoolean = __webpack_require__(13);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isNumber = __webpack_require__(9);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var WestRegionTrackerItems = exports.WestRegionTrackerItems = undefined;
	
	exports.WestRegionTrackerItems = WestRegionTrackerItems = function WestRegionTrackerItems(refs) {
	    var _Ext$create;
	
	    var t = this,
	        uiManager = refs.uiManager,
	        instanceManager = refs.instanceManager,
	        appManager = refs.appManager,
	        i18nManager = refs.i18nManager,
	        sessionStorageManager = refs.sessionStorageManager,
	        calendarManager = refs.calendarManager,
	        dimensionConfig = refs.dimensionConfig,
	        periodConfig = refs.periodConfig,
	        uiConfig = refs.uiConfig,
	        optionConfig = refs.optionConfig,
	        api = refs.api;
	
	    var dataObjectName = dimensionConfig.get('data').objectName,
	        indicatorObjectName = dimensionConfig.get('indicator').objectName,
	        dataElementObjectName = dimensionConfig.get('dataElement').objectName,
	        operandObjectName = dimensionConfig.get('operand').objectName,
	        dataSetObjectName = dimensionConfig.get('dataSet').objectName,
	        eventDataItemObjectName = dimensionConfig.get('eventDataItem').objectName,
	        programIndicatorObjectName = dimensionConfig.get('programIndicator').objectName,
	        periodObjectName = dimensionConfig.get('period').objectName,
	        organisationUnitObjectName = dimensionConfig.get('organisationUnit').objectName,
	        i18n = i18nManager.get(),
	        path = appManager.getPath(),
	        apiPath = appManager.getApiPath(),
	        displayProperty = appManager.getDisplayProperty(),
	        displayPropertyUrl = appManager.getDisplayPropertyUrl(),
	        dimensionPanelMap = {},
	        dimensionIdAvailableStoreMap = {},
	        dimensionIdSelectedStoreMap = {},
	        accordionPanels = [],
	        programStorage = {},
	        stageStorage = {},
	        attributeStorage = {},
	        programIndicatorStorage = {},
	        dataElementStorage = {},
	        baseWidth = 448,
	        accBaseWidth = baseWidth - 2,
	        toolWidth = 36,
	        nextButtonWidth = 62;
	
	    // stores
	
	    var programStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/programs.json?fields=id,' + displayPropertyUrl + '&paging=false'),
	            reader: {
	                type: 'json',
	                root: 'programs'
	            },
	            pageParam: false,
	            startParam: false,
	            limitParam: false
	        },
	        sortInfo: { field: 'name', direction: 'ASC' },
	        isLoaded: false,
	        listeners: {
	            load: function load() {
	                if (!this.isLoaded) {
	                    this.isLoaded = true;
	                }
	            }
	        }
	    });
	
	    var stagesByProgramStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        isLoaded: false,
	        listeners: {
	            load: function load() {
	                if (!this.isLoaded) {
	                    this.isLoaded = true;
	                }
	                this.sort('name', 'ASC');
	            }
	        }
	    });
	
	    var dataElementsByStageStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'isAttribute', 'isProgramIndicator'],
	        data: [],
	        sorters: [{
	            property: 'name',
	            direction: 'ASC'
	        }],
	        onLoadData: function onLoadData() {
	            var layoutWindow = uiManager.get('aggregateLayoutWindow');
	            var numericValueTypes = dimensionConfig.valueType['numeric_types'];
	
	            // add to layout value store
	            this.each(function (record) {
	                if ((0, _arrayContains2.default)(numericValueTypes, record.data.valueType)) {
	                    layoutWindow.valueStore.add(record.data);
	                }
	            });
	
	            this.toggleProgramIndicators();
	        },
	        toggleProgramIndicators: function toggleProgramIndicators(type) {
	            var dataTypeToolbar = uiManager.get('dataTypeToolbar');
	
	            type = type || (dataTypeToolbar ? dataTypeToolbar.getDataType() : null);
	
	            this.clearFilter();
	
	            if (uiManager.disallowProgramIndicators || type === dimensionConfig.dataType['aggregated_values']) {
	                // reset to all to avoid the situation where in ER if PI is selected is shown
	                // as selected also when switching to the aggregate tab
	                dataElementType.select('all');
	                dataElementType.store.filterBy(function (record) {
	                    return record.data.id != 'pi';
	                });
	
	                this.filterBy(function (record) {
	                    return !record.data.isProgramIndicator;
	                });
	            } else {
	                dataElementType.store.clearFilter();
	            }
	        }
	    });
	
	    var organisationUnitGroupStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        proxy: {
	            type: 'ajax',
	            url: encodeURI(apiPath + '/organisationUnitGroups.json?fields=id,' + displayPropertyUrl + '&paging=false'),
	            reader: {
	                type: 'json',
	                root: 'organisationUnitGroups'
	            }
	        }
	    });
	
	    var periodTypeStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: periodConfig.getPeriodTypeRecords()
	    });
	
	    var fixedPeriodAvailableStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name', 'index'],
	        data: [],
	        setIndex: function setIndex(periods) {
	            for (var i = 0; i < periods.length; i++) {
	                periods[i].index = i;
	            }
	        },
	        sortStore: function sortStore() {
	            this.sort('index', 'ASC');
	        }
	    });
	
	    var fixedPeriodSelectedStore = Ext.create('Ext.data.Store', {
	        fields: ['id', 'name'],
	        data: []
	    });
	
	    // components
	    var onTypeClick = function onTypeClick(type) {
	        // available
	        dataElementsByStageStore.toggleProgramIndicators(type);
	
	        // selected
	        dataElementSelected.toggleProgramIndicators(type);
	    };
	
	    var setData = function setData(layout) {
	        // wait, more dynamic dimensions could be added by program
	        //accordion.setDimensions(layout, true);
	
	        // data items
	        onProgramSelect(null, layout);
	    };
	
	    var program = Ext.create('Ext.form.field.ComboBox', {
	        editable: false,
	        valueField: 'id',
	        displayField: 'name',
	        fieldLabel: 'Program',
	        labelAlign: 'top',
	        labelCls: 'ns-form-item-label-top',
	        labelSeparator: '',
	        emptyText: 'Select program',
	        forceSelection: true,
	        queryMode: 'remote',
	        columnWidth: 0.5,
	        style: 'margin:1px 1px 1px 0',
	        storage: {},
	        store: programStore,
	        getRecord: function getRecord() {
	            return this.getValue ? {
	                id: this.getValue(),
	                name: this.getRawValue()
	            } : null;
	        },
	        listeners: {
	            select: function select(cb) {
	                onProgramSelect(cb.getValue());
	            }
	        }
	    });
	
	    var onProgramSelect = function onProgramSelect(programId, layout) {
	        var DEFAULT = 'default';
	        var ATTRIBUTE = 'ATTRIBUTE';
	
	        programId = programId || (layout ? layout.program.id : null);
	
	        if (!programId) {
	            return;
	        }
	
	        // reset
	        stage.clearValue();
	        dataElementsByStageStore.removeAll();
	        dataElementSelected.removeAllDataElements(true);
	        uiManager.get('aggregateLayoutWindow').value.resetData();
	
	        var getCategories = function getCategories(categoryCombo) {
	            if (!((0, _isObject2.default)(categoryCombo) && (0, _isArray2.default)(categoryCombo.categories) && categoryCombo.categories.length)) {
	                return;
	            }
	
	            var categories = categoryCombo.categories.filter(function (c) {
	                return c.name !== DEFAULT;
	            });
	
	            categories.forEach(function (c) {
	                c.items = c.categoryOptions;
	
	                if ((0, _isArray2.default)(c.items)) {
	                    (0, _arraySort2.default)(c.items);
	                }
	            });
	
	            return categories;
	        };
	
	        var load = function load(_program) {
	            var stages = _program.programStages;
	            var dimensions = [];
	
	            // categories
	            dimensions = dimensions.concat(getCategories(_program.categoryCombo) || []);
	
	            // categoryOptionGroupSets
	            if (_program.categoryCombo.name !== DEFAULT) {
	                dimensions = dimensions.concat(appManager.categoryOptionGroupSets.filter(function (groupSet) {
	                    return groupSet.dataDimensionType === ATTRIBUTE;
	                }) || []);
	            }
	
	            // remove and add dynamic program related dimensions
	            accordionBody.removeItems();
	            accordionBody.addItems((0, _arraySort2.default)((0, _arrayClean2.default)(dimensions)));
	
	            // restore dynamic dimensions
	            if (layout) {
	                accordion.setDimensions(layout, true);
	            }
	
	            // stages
	            stage.enable();
	            stage.clearValue();
	
	            stagesByProgramStore.removeAll();
	            stagesByProgramStore.loadData(stages);
	
	            var stageId = (layout ? layout.programStage.id : null) || (stages.length === 1 ? stages[0].id : null);
	
	            if (stageId) {
	                stage.setValue(stageId);
	                onStageSelect(stageId, layout);
	            }
	        };
	
	        if (programStorage[programId]) {
	            load(programStorage[programId]);
	        } else {
	            new api.Request(refs, {
	                baseUrl: appManager.getApiPath() + '/programs.json',
	                type: 'json',
	                params: ['filter=id:eq:' + programId, ['fields=programStages[id,displayName~rename(name)]', 'programIndicators[id,' + displayPropertyUrl + ']', 'programTrackedEntityAttributes[trackedEntityAttribute[id,' + displayPropertyUrl + ',valueType,confidential,optionSet[id,displayName~rename(name)],legendSets~rename(storageLegendSets)[id,displayName~rename(name)]]]', 'categoryCombo[id,name,categories[id,' + displayPropertyUrl + ',categoryOptions[id,' + displayPropertyUrl + ']]]'].join(''), 'paging=false'],
	                success: function success(r) {
	                    var _program = r.programs[0];
	
	                    if (!_program) {
	                        return;
	                    }
	
	                    // program stages
	                    _program.programStages.forEach(function (stage) {
	                        stage.isProgramStage = true;
	                    });
	
	                    // attributes
	                    _program.attributes = (0, _arrayPluck2.default)(_program.programTrackedEntityAttributes, 'trackedEntityAttribute').filter(function (attribute) {
	                        attribute.isAttribute = true;
	                        attribute.name = '[PA] ' + attribute.name;
	                        return !attribute.confidential;
	                    });
	
	                    // mark as program indicator
	                    _program.programIndicators.forEach(function (item) {
	                        item.name = '[PI] ' + item.name;
	                        item.isProgramIndicator = true;
	                    });
	
	                    if ((0, _isArray2.default)(_program.programStages) && _program.programStages.length) {
	                        // program cache
	                        programStorage[programId] = _program;
	
	                        load(_program);
	                    }
	                }
	            }).run();
	        }
	    };
	
	    var stage = Ext.create('Ext.form.field.ComboBox', {
	        editable: false,
	        valueField: 'id',
	        displayField: 'name',
	        fieldLabel: 'Stage',
	        labelAlign: 'top',
	        labelCls: 'ns-form-item-label-top',
	        labelSeparator: '',
	        emptyText: 'Select stage',
	        queryMode: 'local',
	        forceSelection: true,
	        columnWidth: 0.5,
	        style: 'margin:1px 0 1px 0',
	        disabled: true,
	        listConfig: { loadMask: false },
	        store: stagesByProgramStore,
	        getRecord: function getRecord() {
	            return this.getValue() ? {
	                id: this.getValue(),
	                name: this.getRawValue()
	            } : null;
	        },
	        listeners: {
	            select: function select(cb) {
	                onStageSelect(cb.getValue());
	            }
	        }
	    });
	
	    var onStageSelect = function onStageSelect(stageId, layout) {
	        if (!layout) {
	            dataElementSelected.removeAllDataElements(true);
	            uiManager.get('aggregateLayoutWindow').value.resetData();
	        }
	
	        dataElementType.enable();
	        dataElementSearch.enable();
	        dataElementSearch.hideFilter();
	
	        loadDataElements(stageId, layout);
	    };
	
	    var loadDataElements = function loadDataElements(stageId, layout) {
	        var programId = layout ? layout.program.id : program.getValue() || null;
	
	        var _program = programStorage[programId];
	
	        var dataItems = (0, _arrayClean2.default)([].concat(_program.attributes || [], _program.programIndicators || []));
	
	        stageId = stageId || layout.programStage.id;
	
	        var load = function load(dataElements) {
	            var data = (0, _arrayClean2.default)(dataItems.concat(dataElements || []));
	
	            dataElementsByStageStore.loadData(data);
	            dataElementsByStageStore.onLoadData();
	
	            if (layout) {
	                var dataDimensions = layout ? layout.getDimensions(true).filter(function (dim) {
	                    return !(0, _arrayContains2.default)(['pe', 'ou'], dim.dimension);
	                }) : [],
	                    records = [];
	
	                for (var i = 0, dim, row; i < dataDimensions.length; i++) {
	                    dim = dataDimensions[i];
	                    row = dataElementsByStageStore.getById(dim.dimension);
	
	                    if (row) {
	                        records.push(Ext.applyIf(dim, row.data));
	                    }
	                }
	
	                selectDataElements(records, layout);
	            }
	        };
	
	        // data elements
	        if (dataElementStorage.hasOwnProperty(stageId)) {
	            load(dataElementStorage[stageId]);
	        } else {
	            new api.Request(refs, {
	                baseUrl: appManager.getApiPath() + '/programStages.json',
	                type: 'json',
	                params: ['filter=id:eq:' + stageId, 'fields=programStageDataElements[dataElement[id,' + displayPropertyUrl + ',valueType,optionSet[id,displayName~rename(name)],legendSets~rename(storageLegendSets)[id,displayName~rename(name)]]]', 'paging=false'],
	                success: function success(r) {
	                    var stages = r.programStages,
	                        types = dimensionConfig.valueType['tracker_aggregatable_types'];
	
	                    if (!stages.length) {
	                        load();
	                        return;
	                    }
	
	                    var include = function include(element) {
	                        return (0, _arrayContains2.default)(types, element.valueType) || (0, _isObject2.default)(element.optionSet) || (0, _isArray2.default)(element.legendSets || element.storageLegendSets);
	                    };
	
	                    // filter by type
	                    var dataElements = (0, _arrayPluck2.default)(stages[0].programStageDataElements, 'dataElement').filter(function (dataElement) {
	                        dataElement.isDataElement = true;
	                        dataElement.name = '[DE] ' + dataElement.name;
	                        return include(dataElement);
	                    });
	
	                    // data elements cache
	                    dataElementStorage[stageId] = dataElements;
	
	                    load(dataElements);
	                }
	            }).run();
	        }
	    };
	
	    // DHIS2-1496: filter by data element, program attribute or program indicator
	    var dataElementType = Ext.create('Ext.form.field.ComboBox', {
	        editable: false,
	        valueField: 'id',
	        displayField: 'name',
	        queryMode: 'local',
	        lastQuery: '',
	        width: accBaseWidth / 2 - 32,
	        disabled: true,
	        listConfig: { loadMask: false },
	        style: 'padding-bottom:1px; border-bottom:1px solid #ddd; margin-bottom:1px',
	        value: 'all',
	        store: {
	            fields: ['id', 'name'],
	            data: [{ id: 'all', name: 'All' }, { id: 'de', name: 'Data elements' }, { id: 'pa', name: 'Program attributes' }, { id: 'pi', name: 'Program indicators' }]
	        },
	        reset: function reset() {
	            onDataElementTypeSelect('all');
	        },
	        listeners: {
	            select: function select(cmp) {
	                onDataElementTypeSelect(cmp.getValue());
	            }
	        }
	    });
	
	    var onDataElementTypeSelect = function onDataElementTypeSelect(type) {
	        dataElementType.setValue(type);
	
	        var store = dataElementsByStageStore;
	
	        switch (type) {
	            case 'all':
	                store.clearFilter();
	
	                // filter out PI if in aggregated tab
	                if (uiManager.disallowProgramIndicators || uiManager.get('dataTypeToolbar').getDataType() === dimensionConfig.dataType['aggregated_values']) {
	                    store.filterBy(function (record) {
	                        return !record.data.isProgramIndicator;
	                    });
	                }
	                break;
	            case 'de':
	                store.filterBy(function (record) {
	                    return !record.data.isAttribute && !record.data.isProgramIndicator;
	                });
	                break;
	            case 'pa':
	                store.filterBy(function (record) {
	                    return record.data.isAttribute;
	                });
	                break;
	            case 'pi':
	                store.filterBy(function (record) {
	                    return record.data.isProgramIndicator;
	                });
	                break;
	        }
	    };
	
	    var dataElementLabel = Ext.create('Ext.form.Label', {
	        width: accBaseWidth / 2 - 32,
	        text: i18n.available,
	        cls: 'ns-toolbar-multiselect-left-label',
	        style: 'margin-right:5px'
	    });
	
	    var dataElementSearch = Ext.create('Ext.button.Button', {
	        width: 22,
	        height: 22,
	        cls: 'ns-button-icon',
	        iconCls: 'ns-button-icon-search',
	        disabled: true,
	        showFilter: function showFilter() {
	            dataElementLabel.hide();
	            this.hide();
	            dataElementFilter.show();
	            dataElementFilter.reset();
	        },
	        hideFilter: function hideFilter() {
	            dataElementLabel.show();
	            this.show();
	            dataElementFilter.hide();
	            dataElementFilter.reset();
	        },
	        handler: function handler() {
	            this.showFilter();
	        }
	    });
	
	    var dataElementFilter = Ext.create('Ext.form.field.Trigger', {
	        cls: 'ns-trigger-filter',
	        emptyText: 'Filter available...',
	        height: 22,
	        width: accBaseWidth / 2 - 5,
	        hidden: true,
	        enableKeyEvents: true,
	        fieldStyle: 'height:22px; border-right:0 none',
	        style: 'height:22px',
	        onTriggerClick: function onTriggerClick() {
	            if (this.getValue()) {
	                this.reset();
	                this.onKeyUpHandler();
	            }
	
	            dataElementSearch.hideFilter();
	        },
	        onKeyUpHandler: function onKeyUpHandler() {
	            var store = dataElementsByStageStore,
	                value = this.getValue(),
	                name;
	
	            if (value === '') {
	                store.clearFilter();
	                return;
	            }
	
	            store.filterBy(function (r) {
	                name = r.data.name || '';
	                return name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
	            });
	        },
	        listeners: {
	            keyup: {
	                fn: function fn(cmp) {
	                    cmp.onKeyUpHandler();
	                },
	                buffer: 100
	            },
	            show: function show(cmp) {
	                cmp.focus(false, 50);
	            },
	            focus: function focus(cmp) {
	                cmp.addCls('ns-trigger-filter-focused');
	            },
	            blur: function blur(cmp) {
	                cmp.removeCls('ns-trigger-filter-focused');
	            }
	        }
	    });
	
	    var dataElementAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth,
	        height: 180,
	        valueField: 'id',
	        displayField: 'name',
	        style: 'margin-bottom:1px',
	        store: dataElementsByStageStore,
	        tbar: [dataElementLabel, dataElementSearch, dataElementFilter, dataElementType, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowdown',
	            width: 22,
	            height: 22,
	            handler: function handler() {
	                if (dataElementAvailable.getValue().length) {
	                    selectDataElements(dataElementAvailable.getValue());
	                }
	            }
	        }],
	        listeners: {
	            afterrender: function afterrender(ms) {
	                this.boundList.on('itemdblclick', function () {
	                    if (ms.getValue().length) {
	                        selectDataElements(ms.getValue());
	                    }
	                });
	            }
	        }
	    });
	
	    var dataElementSelected = Ext.create('Ext.panel.Panel', {
	        width: accBaseWidth,
	        height: 242,
	        bodyStyle: 'padding-left:1px',
	        autoScroll: true,
	        tbar: [{
	            xtype: 'label',
	            text: 'Selected data items',
	            style: 'padding-left:6px; color:#333',
	            cls: 'ns-toolbar-multiselect-left-label'
	        }, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowupdouble',
	            width: 22,
	            height: 22,
	            handler: function handler() {
	                dataElementSelected.removeAllDataElements();
	            }
	        }],
	        getChildIndex: function getChildIndex(child) {
	            var items = this.items.items;
	
	            for (var i = 0; i < items.length; i++) {
	                if (items[i].id === child.id) {
	                    return i;
	                }
	            }
	
	            return items.length;
	        },
	        hasDataElement: function hasDataElement(dataElementId) {
	            var hasDataElement = false;
	
	            this.items.each(function (item) {
	                if (item.dataElement.id === dataElementId) {
	                    hasDataElement = true;
	                }
	            });
	
	            return hasDataElement;
	        },
	        getUxArrayById: function getUxArrayById(dataElementId) {
	            var uxArray = [];
	
	            this.items.each(function (item) {
	                if (item.dataElement.id === dataElementId) {
	                    uxArray.push(item);
	                }
	            });
	
	            return uxArray;
	        },
	        removeAllDataElements: function removeAllDataElements(reset) {
	            var items = this.items.items,
	                len = items.length;
	
	            for (var i = 0; i < len; i++) {
	                items[0].removeDataElement(reset);
	            }
	        },
	        toggleProgramIndicators: function toggleProgramIndicators(type) {
	            this.items.each(function (item) {
	                if (type === dimensionConfig.dataType['aggregated_values'] && item.isProgramIndicator) {
	                    item.disable();
	                } else {
	                    item.enable();
	                }
	            });
	        }
	    });
	
	    var addUxFromDataElement = function addUxFromDataElement(element, index) {
	        var aggWindow = uiManager.get('aggregateLayoutWindow'),
	            queryWindow = uiManager.get('queryLayoutWindow');
	
	        index = index || dataElementSelected.items.items.length;
	
	        var getUxType = function getUxType(element) {
	            var valueTypes = dimensionConfig.valueType;
	
	            if ((0, _isObject2.default)(element.optionSet) && (0, _isString2.default)(element.optionSet.id)) {
	                return 'Ext.ux.container.GroupSetContainer';
	            }
	
	            if ((0, _arrayContains2.default)(valueTypes['numeric_types'], element.valueType)) {
	                return 'Ext.ux.container.DataElementIntegerContainer';
	            }
	
	            if ((0, _arrayContains2.default)(valueTypes['text_types'], element.valueType)) {
	                return 'Ext.ux.container.DataElementStringContainer';
	            }
	
	            if ((0, _arrayContains2.default)(valueTypes['date_types'], element.valueType)) {
	                return 'Ext.ux.container.DataElementDateContainer';
	            }
	
	            if ((0, _arrayContains2.default)(valueTypes['boolean_types'], element.valueType)) {
	                return 'Ext.ux.container.DataElementBooleanContainer';
	            }
	
	            return 'Ext.ux.container.DataElementIntegerContainer';
	        };
	
	        // add
	        var ux = dataElementSelected.insert(index, Ext.create(getUxType(element), {
	            dataElement: element
	        }));
	
	        ux.isAttribute = element.isAttribute;
	        ux.isProgramIndicator = element.isProgramIndicator;
	        ux.isDataElement = element.isDataElement;
	
	        ux.removeDataElement = function (reset) {
	            dataElementSelected.remove(ux);
	
	            if (!dataElementSelected.hasDataElement(element.id)) {
	                if (!reset) {
	                    dataElementsByStageStore.add(element);
	                    dataElementsByStageStore.sort();
	                }
	
	                aggWindow.removeDimension(element.id, aggWindow.valueStore);
	
	                if (queryWindow) {
	                    queryWindow.removeDimension(element.id);
	                }
	            }
	        };
	
	        ux.duplicateDataElement = function () {
	            var index = dataElementSelected.getChildIndex(ux) + 1;
	            addUxFromDataElement(element, index);
	        };
	
	        dataElementsByStageStore.removeAt(dataElementsByStageStore.findExact('id', element.id));
	
	        return ux;
	    };
	
	    var selectDataElements = function selectDataElements(items, layout) {
	        var dataElements = [],
	            allElements = [],
	            aggWindow = uiManager.get('aggregateLayoutWindow'),
	            queryWindow = uiManager.get('queryLayoutWindow'),
	            includeKeys = dimensionConfig.valueType['tracker_aggregatable_types'],
	            ignoreKeys = ['pe', 'ou'],
	            recordMap = dimensionConfig.getObjectNameMap(),
	            extendDim = function extendDim(dim) {
	            dim.id = dim.id || dim.dimension;
	            dim.name = dim.name || layout ? layout.getResponse().getNameById(dim.dimension) : null || recordMap[dim.dimension].name;
	
	            return dim;
	        };
	
	        // data element objects
	        for (var i = 0, item; i < items.length; i++) {
	            item = items[i];
	
	            if ((0, _isString2.default)(item)) {
	                dataElements.push(dataElementsByStageStore.getById(item).data);
	            } else if ((0, _isObject2.default)(item)) {
	                if (item.data) {
	                    dataElements.push(item.data);
	                } else {
	                    dataElements.push(item);
	                }
	            }
	        }
	
	        // expand if multiple filter
	        for (var i = 0, element, a, numberOfElements; i < dataElements.length; i++) {
	            element = dataElements[i];
	            allElements.push(element);
	
	            if ((0, _arrayContains2.default)(dimensionConfig.valueType['numeric_types'], element.valueType) && element.filter) {
	                a = element.filter.split(':');
	                numberOfElements = a.length / 2;
	
	                if (numberOfElements > 1) {
	                    a.shift();
	                    a.shift();
	
	                    for (var j = 1, newElement; j < numberOfElements; j++) {
	                        //newElement = Ext.clone(element);
	                        newElement = _extends({}, element);
	                        newElement.filter = a.shift();
	                        newElement.filter += ':' + a.shift();
	
	                        allElements.push(newElement);
	                    }
	                }
	            }
	        }
	
	        // panel, store
	        for (var i = 0, element, ux, store; i < allElements.length; i++) {
	            element = allElements[i];
	            element.name = element.name || element.displayName;
	            recordMap[element.id] = element;
	
	            // dont create ux if dim is selected as value
	            if (element.id !== aggWindow.value.getValue()) {
	                ux = addUxFromDataElement(element);
	
	                if (layout) {
	                    ux.setRecord(element);
	                }
	            }
	
	            store = (0, _arrayContains2.default)(includeKeys, element.valueType) || element.optionSet ? aggWindow.getDefaultStore() : aggWindow.fixedFilterStore;
	
	            aggWindow.addDimension(element, store, aggWindow.valueStore);
	
	            if (queryWindow) {
	                queryWindow.colStore.add(element);
	            }
	        }
	
	        // favorite
	        if (layout && layout.dataType !== dimensionConfig.dataType['individual_cases']) {
	            aggWindow.reset(true, true);
	
	            // start end dates
	            if (layout.startDate && layout.endDate) {
	                aggWindow.fixedFilterStore.add({
	                    id: dimensionConfig.get('startEndDate').value,
	                    name: dimensionConfig.get('startEndDate').name
	                });
	            }
	
	            // columns
	            if (layout.columns) {
	                for (var i = 0, record, dim; i < layout.columns.length; i++) {
	                    dim = _extends({}, layout.columns[i]);
	                    record = recordMap[dim.dimension];
	
	                    aggWindow.colStore.add(record || extendDim(dim));
	                }
	            }
	
	            // rows
	            if (layout.rows) {
	                for (var i = 0, record, dim; i < layout.rows.length; i++) {
	                    dim = _extends({}, layout.rows[i]);
	                    record = recordMap[dim.dimension];
	
	                    aggWindow.rowStore.add(record || extendDim(dim));
	                }
	            }
	
	            // filters
	            if (layout.filters) {
	                for (var i = 0, store, record, dim; i < layout.filters.length; i++) {
	                    dim = _extends({}, layout.filters[i]);
	                    record = recordMap[dim.dimension];
	                    store = (0, _arrayContains2.default)(includeKeys, element.valueType) || element.optionSet ? aggWindow.filterStore : aggWindow.fixedFilterStore;
	
	                    store.add(record || extendDim(dim));
	                }
	            }
	
	            // value
	            if (layout.value && layout.aggregationType) {
	                aggWindow.setValueConfig(layout.value.id, layout.aggregationType);
	            }
	
	            // collapse data dimensions
	            if (aggWindow.collapseDataDimensions) {
	                aggWindow.collapseDataDimensions.setValue(layout.collapseDataDimensions);
	                aggWindow.onCollapseDataDimensionsChange(layout.collapseDataDimensions);
	            }
	        }
	    };
	
	    var programStagePanel = Ext.create('Ext.panel.Panel', {
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        style: 'margin-top:2px',
	        items: [program, stage]
	    });
	
	    var data = Ext.create('Ext.panel.Panel', {
	        title: '<div class="ns-panel-title-data">' + i18n.data + '</div>',
	        cls: 'ns-accordion-first',
	        bodyStyle: 'padding:1px',
	        hideCollapseTool: true,
	        dimension: dimensionConfig.get('data').objectName,
	        items: [programStagePanel, dataElementAvailable, dataElementSelected],
	        setDimension: function setDimension(layout) {
	            setData(layout);
	        },
	        clearDimension: function clearDimension() {
	            program.clearValue();
	            stage.clearValue();
	
	            dataElementsByStageStore.removeAll();
	            dataElementSelected.removeAll();
	
	            dataElementSearch.hideFilter();
	        },
	        getHeightValue: function getHeightValue() {
	            var westRegion = uiManager.get('westRegion');
	
	            return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_indicator : uiConfig.west_maxheight_accordion_indicator;
	        },
	        onExpand: function onExpand() {
	            accordion.setThisHeight(this.getHeightValue());
	
	            var msHeight = this.getHeight() - 28 - programStagePanel.getHeight() - 6;
	
	            dataElementAvailable.setHeight(msHeight * 0.4);
	            dataElementSelected.setHeight(msHeight * 0.6 - 1);
	        },
	        listeners: {
	            expand: function expand(cmp) {
	                cmp.onExpand();
	            }
	        }
	    });
	    accordionPanels.push(uiManager.reg(data, 'data'));
	
	    // dates
	    var periodMode = Ext.create('Ext.form.field.ComboBox', {
	        editable: false,
	        valueField: 'id',
	        displayField: 'name',
	        queryMode: 'local',
	        width: accBaseWidth,
	        listConfig: { loadMask: false },
	        style: 'padding-bottom:1px; border-bottom:1px solid #ddd; margin-bottom:1px',
	        value: 'periods',
	        store: {
	            fields: ['id', 'name'],
	            data: [{ id: 'periods', name: 'Fixed and relative periods' }, { id: 'dates', name: 'Start/end dates' }]
	        },
	        reset: function reset() {
	            onPeriodModeSelect('periods');
	        },
	        listeners: {
	            select: function select(cmp) {
	                onPeriodModeSelect(cmp.getValue());
	            }
	        }
	    });
	
	    var onPeriodModeSelect = function onPeriodModeSelect(mode) {
	        var aggregateLayoutWindow = uiManager.get('aggregateLayoutWindow');
	
	        periodMode.setValue(mode);
	
	        if (mode === 'dates') {
	            startEndDate.show();
	            periods.hide();
	
	            aggregateLayoutWindow.addDimension({
	                id: dimensionConfig.get('startEndDate').value,
	                name: dimensionConfig.get('startEndDate').name
	            }, aggregateLayoutWindow.fixedFilterStore);
	
	            aggregateLayoutWindow.removeDimension(dimensionConfig.get('period').dimensionName);
	        } else if (mode === 'periods') {
	            startEndDate.hide();
	            periods.show();
	
	            aggregateLayoutWindow.addDimension({
	                id: dimensionConfig.get('period').dimensionName,
	                name: dimensionConfig.get('period').name
	            }, aggregateLayoutWindow.colStore);
	
	            aggregateLayoutWindow.removeDimension(dimensionConfig.get('startEndDate').value);
	        }
	    };
	
	    var getDateLink = function getDateLink(text, fn, style) {
	        return Ext.create('Ext.form.Label', {
	            text: text,
	            style: 'padding-left: 5px; width: 100%; ' + style || '',
	            cls: 'ns-label-date',
	            updateValue: fn,
	            listeners: {
	                render: function render(cmp) {
	                    cmp.getEl().on('click', function () {
	                        cmp.updateValue();
	                    });
	                }
	            }
	        });
	    };
	
	    var onDateFieldRender = function onDateFieldRender(c) {
	        $('#' + c.inputEl.id).calendarsPicker({
	            calendar: calendarManager.calendar,
	            dateFormat: appManager.systemInfo.dateFormat
	        });
	    };
	
	    var startDate = Ext.create('Ext.form.field.Text', {
	        fieldLabel: 'Start date',
	        labelAlign: 'top',
	        labelCls: 'ns-form-item-label-top ns-form-item-label-top-padding',
	        labelSeparator: '',
	        columnWidth: 0.5,
	        height: 44,
	        value: calendarManager.calendar.formatDate(appManager.systemInfo.dateFormat, calendarManager.calendar.today().add(-3, 'm')),
	        listeners: {
	            render: function render(c) {
	                onDateFieldRender(c);
	            }
	        }
	    });
	
	    var endDate = Ext.create('Ext.form.field.Text', {
	        fieldLabel: 'End date',
	        labelAlign: 'top',
	        labelCls: 'ns-form-item-label-top ns-form-item-label-top-padding',
	        labelSeparator: '',
	        columnWidth: 0.5,
	        height: 44,
	        style: 'margin-left: 1px',
	        value: calendarManager.calendar.formatDate(appManager.systemInfo.dateFormat, calendarManager.calendar.today()),
	        listeners: {
	            render: function render(c) {
	                onDateFieldRender(c);
	            }
	        }
	    });
	
	    var startEndDate = Ext.create('Ext.container.Container', {
	        cls: 'ns-container-default',
	        layout: 'column',
	        hidden: true,
	        items: [startDate, endDate]
	    });
	
	    var onCheckboxAdd = function onCheckboxAdd(cmp) {
	        if (cmp.xtype === 'checkbox') {
	            uiManager.reg(cmp, cmp.relativePeriodId, null, 'relativePeriod');
	        }
	    };
	
	    var intervalListeners = {
	        added: function added(cmp) {
	            onCheckboxAdd(cmp);
	        }
	    };
	
	    var days = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:0 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n['days'],
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'TODAY',
	            boxLabel: i18n['today'],
	            index: 0
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'YESTERDAY',
	            boxLabel: i18n['yesterday'],
	            index: 1
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_3_DAYS',
	            boxLabel: i18n['last_3_days'],
	            index: 2
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_7_DAYS',
	            boxLabel: i18n['last_7_days'],
	            index: 3
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_14_DAYS',
	            boxLabel: i18n['last_14_days'],
	            index: 4
	        }]
	    });
	
	    var weeks = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:0 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.weeks,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_WEEK',
	            boxLabel: i18n.this_week
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_WEEK',
	            boxLabel: i18n.last_week
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_4_WEEKS',
	            boxLabel: i18n.last_4_weeks
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_12_WEEKS',
	            boxLabel: i18n.last_12_weeks
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_52_WEEKS',
	            boxLabel: i18n.last_52_weeks
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'WEEKS_THIS_YEAR',
	            boxLabel: i18n.weeks_this_year
	        }]
	    });
	
	    var months = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:0 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.months,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_MONTH',
	            boxLabel: i18n.this_month
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_MONTH',
	            boxLabel: i18n.last_month
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_3_MONTHS',
	            boxLabel: i18n.last_3_months
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_6_MONTHS',
	            boxLabel: i18n.last_6_months
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_12_MONTHS',
	            boxLabel: i18n.last_12_months,
	            checked: true
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'MONTHS_THIS_YEAR',
	            boxLabel: i18n.months_this_year
	        }]
	    });
	
	    var biMonths = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.bimonths,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_BIMONTH',
	            boxLabel: i18n.this_bimonth
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_BIMONTH',
	            boxLabel: i18n.last_bimonth
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_6_BIMONTHS',
	            boxLabel: i18n.last_6_bimonths
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'BIMONTHS_THIS_YEAR',
	            boxLabel: i18n.bimonths_this_year
	        }]
	    });
	
	    var quarters = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.quarters,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_QUARTER',
	            boxLabel: i18n.this_quarter
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_QUARTER',
	            boxLabel: i18n.last_quarter
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_4_QUARTERS',
	            boxLabel: i18n.last_4_quarters
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'QUARTERS_THIS_YEAR',
	            boxLabel: i18n.quarters_this_year
	        }]
	    });
	
	    var sixMonths = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.sixmonths,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_SIX_MONTH',
	            boxLabel: i18n.this_sixmonth
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_SIX_MONTH',
	            boxLabel: i18n.last_sixmonth
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_2_SIXMONTHS',
	            boxLabel: i18n.last_2_sixmonths
	        }]
	    });
	
	    var financialYears = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.financial_years,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_FINANCIAL_YEAR',
	            boxLabel: i18n.this_financial_year
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_FINANCIAL_YEAR',
	            boxLabel: i18n.last_financial_year
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_5_FINANCIAL_YEARS',
	            boxLabel: i18n.last_5_financial_years
	        }]
	    });
	
	    var years = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none; padding:5px 0 0 8px',
	        defaults: {
	            labelSeparator: '',
	            style: 'margin-bottom:0',
	            listeners: intervalListeners
	        },
	        items: [{
	            xtype: 'label',
	            text: i18n.years,
	            cls: 'ns-label-period-heading'
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'THIS_YEAR',
	            boxLabel: i18n.this_year
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_YEAR',
	            boxLabel: i18n.last_year
	        }, {
	            xtype: 'checkbox',
	            relativePeriodId: 'LAST_5_YEARS',
	            boxLabel: i18n.last_5_years
	        }]
	    });
	
	    var relativePeriod = Ext.create('Ext.panel.Panel', {
	        layout: 'column',
	        hideCollapseTool: true,
	        autoScroll: true,
	        bodyStyle: 'border:0 none',
	        items: [{
	            xtype: 'container',
	            columnWidth: 0.34,
	            bodyStyle: 'border-style:none',
	            items: [days, biMonths, financialYears]
	        }, {
	            xtype: 'container',
	            columnWidth: 0.33,
	            bodyStyle: 'border-style:none',
	            items: [weeks, quarters, years]
	        }, {
	            xtype: 'container',
	            columnWidth: 0.33,
	            bodyStyle: 'border-style:none',
	            items: [months, sixMonths]
	        }],
	        getRecords: function getRecords() {
	            return uiManager.getByGroup('relativePeriod').filter(function (cmp) {
	                return cmp.getValue();
	            }).map(function (cmp) {
	                return cmp.relativePeriodId;
	            });
	        }
	    });
	
	    // fixed periods
	    var fixedPeriodAvailable = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-left',
	        width: accBaseWidth / 2,
	        height: 160,
	        valueField: 'id',
	        displayField: 'name',
	        store: fixedPeriodAvailableStore,
	        tbar: [{
	            xtype: 'label',
	            text: i18n.available,
	            cls: 'ns-toolbar-multiselect-left-label'
	        }, '->', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowright',
	            width: 22,
	            handler: function handler() {
	                uiManager.msSelect(fixedPeriodAvailable, fixedPeriodSelected);
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowrightdouble',
	            width: 22,
	            handler: function handler() {
	                uiManager.msSelectAll(fixedPeriodAvailable, fixedPeriodSelected, true);
	            }
	        }, ' '],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function () {
	                    uiManager.msSelect(fixedPeriodAvailable, fixedPeriodSelected);
	                }, this);
	            }
	        }
	    });
	
	    var fixedPeriodSelected = Ext.create('Ext.ux.form.MultiSelect', {
	        cls: 'ns-toolbar-multiselect-right',
	        width: accBaseWidth / 2,
	        height: 160,
	        valueField: 'id',
	        displayField: 'name',
	        ddReorder: false,
	        store: fixedPeriodSelectedStore,
	        tbar: [' ', {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleftdouble',
	            width: 22,
	            handler: function handler() {
	                uiManager.msUnselectAll(fixedPeriodAvailable, fixedPeriodSelected);
	            }
	        }, {
	            xtype: 'button',
	            iconCls: 'ns-button-icon-arrowleft',
	            width: 22,
	            handler: function handler() {
	                uiManager.msUnselect(fixedPeriodAvailable, fixedPeriodSelected);
	            }
	        }, '->', {
	            xtype: 'label',
	            text: i18n.selected,
	            cls: 'ns-toolbar-multiselect-right-label'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.boundList.on('itemdblclick', function () {
	                    uiManager.msUnselect(fixedPeriodAvailable, fixedPeriodSelected);
	                }, this);
	            }
	        }
	    });
	
	    var onPeriodTypeSelect = function onPeriodTypeSelect() {
	        var type = periodType.getValue(),
	            periodOffset = periodType.periodOffset,
	            generator = calendarManager.periodGenerator,
	            periods = generator.generateReversedPeriods(type, type === 'Yearly' ? periodOffset - 5 : periodOffset);
	
	        periods.forEach(function (period) {
	            return period.id = period.iso;
	        });
	
	        fixedPeriodAvailableStore.setIndex(periods);
	        fixedPeriodAvailableStore.loadData(periods);
	        uiManager.msFilterAvailable(fixedPeriodAvailable, fixedPeriodSelected);
	    };
	
	    var periodType = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        style: 'margin-right:1px; margin-bottom:1px',
	        width: accBaseWidth - nextButtonWidth * 2 - 2,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n.select_period_type,
	        editable: false,
	        queryMode: 'remote',
	        store: periodTypeStore,
	        periodOffset: 0,
	        listeners: {
	            select: function select(cmp) {
	                periodType.periodOffset = 0;
	                onPeriodTypeSelect();
	            }
	        }
	    });
	
	    var prevYear = Ext.create('Ext.button.Button', {
	        text: i18n.prev_year,
	        style: 'border-radius:1px; margin-right:1px',
	        height: 24,
	        width: nextButtonWidth,
	        handler: function handler() {
	            if (periodType.getValue()) {
	                periodType.periodOffset--;
	                onPeriodTypeSelect();
	            }
	        }
	    });
	
	    var nextYear = Ext.create('Ext.button.Button', {
	        text: i18n.next_year,
	        style: 'border-radius:1px',
	        height: 24,
	        width: nextButtonWidth,
	        handler: function handler() {
	            if (periodType.getValue()) {
	                periodType.periodOffset++;
	                onPeriodTypeSelect();
	            }
	        }
	    });
	
	    var fixedPeriodSettings = Ext.create('Ext.container.Container', {
	        layout: 'column',
	        bodyStyle: 'border-style:none',
	        style: 'margin-top:0px',
	        items: [periodType, prevYear, nextYear]
	    });
	
	    var fixedPeriodAvailableSelected = Ext.create('Ext.container.Container', {
	        layout: 'column',
	        bodyStyle: 'border-style:none; padding-bottom:2px',
	        items: [fixedPeriodAvailable, fixedPeriodSelected]
	    });
	
	    var periods = Ext.create('Ext.panel.Panel', {
	        bodyStyle: 'border-style:none',
	        getRecords: function getRecords() {
	            var selectedRecords = [],
	                records;
	
	            fixedPeriodSelectedStore.each(function (r) {
	                selectedRecords.push({ id: r.data.id });
	            });
	
	            records = [].concat(selectedRecords, _toConsumableArray(uiManager.getByGroup('relativePeriod').filter(function (cmp) {
	                return cmp.getValue();
	            }).map(function (cmp) {
	                return { id: cmp.relativePeriodId };
	            })));
	
	            return records.length ? records : null;
	        },
	        getDimension: function getDimension() {
	            return {
	                dimension: 'pe',
	                items: this.getRecords()
	            };
	        },
	        items: [{
	            xtype: 'panel',
	            layout: 'column',
	            bodyStyle: 'border-style:none; padding-bottom:2px',
	            items: [fixedPeriodSettings, fixedPeriodAvailableSelected]
	        }, relativePeriod]
	    });
	
	    var period = Ext.create('Ext.panel.Panel', {
	        title: '<div class="ns-panel-title-period">Periods</div>',
	        bodyStyle: 'padding:1px',
	        hideCollapseTool: true,
	        dimension: dimensionConfig.get('period').objectName,
	        width: accBaseWidth,
	        clearDimension: function clearDimension(all) {
	            this.resetFixedPeriods();
	            this.resetRelativePeriods();
	            this.resetStartEndDates();
	
	            periodMode.reset();
	
	            if (!all) {
	                uiManager.get(appManager.getRelativePeriod()).setValue(true);
	            }
	        },
	        setDimension: function setDimension(layout) {
	            if (!layout) {
	                return;
	            }
	
	            if (layout.startDate && layout.endDate) {
	                onPeriodModeSelect('dates');
	                startDate.setValue(layout.startDate);
	                endDate.setValue(layout.endDate);
	            } else {
	                onPeriodModeSelect('periods');
	            }
	
	            if (layout.hasDimension(this.dimension, true)) {
	                var records = layout.getDimension(this.dimension).extendRecords(layout.getResponse()),
	                    fixedRecords = [],
	                    checkbox;
	
	                records.forEach(function (record) {
	                    checkbox = uiManager.get(record.id);
	
	                    if (checkbox) {
	                        checkbox.setValue(true);
	                    } else {
	                        fixedRecords.push(record);
	                    }
	                });
	
	                fixedPeriodSelectedStore.add(fixedRecords);
	
	                uiManager.msFilterAvailable({ store: fixedPeriodAvailableStore }, { store: fixedPeriodSelectedStore });
	            }
	        },
	        getDimension: function getDimension() {
	            var config = {
	                dimension: periodObjectName,
	                items: periods.getRecords()
	            };
	
	            return config.items.length ? config : null;
	        },
	        getHeightValue: function getHeightValue() {
	            var westRegion = uiManager.get('westRegion');
	
	            return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_period : uiConfig.west_maxheight_accordion_period;
	        },
	        onExpand: function onExpand() {
	            accordion.setThisHeight(this.getHeightValue());
	
	            uiManager.msSetHeight([fixedPeriodAvailable, fixedPeriodSelected], this, uiConfig.west_fill_accordion_period);
	        },
	        reset: function reset() {
	            this.resetRelativePeriods();
	            this.resetFixedPeriods();
	            this.resetStartEndDates();
	
	            periodMode.reset();
	        },
	        isRelativePeriods: function isRelativePeriods() {
	            return uiManager.getByGroup('relativePeriod').some(function (chb) {
	                return chb.getValue();
	            });
	        },
	        resetRelativePeriods: function resetRelativePeriods() {
	            uiManager.getByGroup('relativePeriod').forEach(function (cmp) {
	                return cmp.setValue(false);
	            });
	        },
	        isNoRelativePeriods: function isNoRelativePeriods() {
	            return !uiManager.getByGroup('relativePeriod').some(function (cmp) {
	                return cmp.getValue();
	            });
	        },
	        resetFixedPeriods: function resetFixedPeriods() {
	            fixedPeriodAvailableStore.removeAll();
	            fixedPeriodSelectedStore.removeAll();
	            periodType.clearValue();
	        },
	        resetStartEndDates: function resetStartEndDates() {
	            startDate.reset();
	            endDate.reset();
	        },
	        items: [periodMode, startEndDate, periods],
	        listeners: {
	            expand: function expand(cmp) {
	                cmp.onExpand();
	            }
	        }
	    });
	    accordionPanels.push(uiManager.reg(period, 'period'));
	
	    // organisation unit
	    var treePanel = Ext.create('Ext.tree.Panel', {
	        cls: 'ns-tree',
	        height: 436,
	        width: accBaseWidth,
	        bodyStyle: 'border:0 none',
	        style: 'border-top: 1px solid #ddd; padding-top: 1px',
	        displayField: 'name',
	        rootVisible: false,
	        autoScroll: true,
	        multiSelect: true,
	        rendered: false,
	        reset: function reset() {
	            var rootNode = this.getRootNode().findChild('id', appManager.rootNodes[0].id);
	            this.collapseAll();
	            this.expandPath(rootNode.getPath());
	            this.getSelectionModel().select(rootNode);
	        },
	        selectRootIf: function selectRootIf() {
	            if (this.getSelectionModel().getSelection().length < 1) {
	                var node = this.getRootNode().findChild('id', appManager.rootNodes[0].id);
	                if (this.rendered) {
	                    this.getSelectionModel().select(node);
	                }
	                return node;
	            }
	        },
	        isPending: false,
	        recordsToSelect: [],
	        recordsToRestore: [],
	        multipleSelectIf: function multipleSelectIf(map, doUpdate) {
	            this.recordsToSelect = (0, _arrayClean2.default)(this.recordsToSelect);
	
	            if (this.recordsToSelect.length === Object.keys(map).length) {
	                this.getSelectionModel().select(this.recordsToSelect);
	                this.recordsToSelect = [];
	                this.isPending = false;
	
	                if (doUpdate) {
	                    update();
	                }
	            }
	        },
	        multipleExpand: function multipleExpand(id, map, doUpdate) {
	            var t = this,
	                rootId = appManager.rootNodeId,
	                path = map[id];
	
	            if (path.substr(0, rootId.length + 1) !== '/' + rootId) {
	                path = '/' + rootId + '/' + path;
	            }
	
	            t.expandPath(path, 'id', '/', function () {
	                var record = t.getRootNode().findChild('id', id, true);
	                t.recordsToSelect.push(record);
	                t.multipleSelectIf(map, doUpdate);
	            });
	        },
	        select: function select(url, params) {
	            if (!params) {
	                params = {};
	            }
	            Ext.Ajax.request({
	                url: url,
	                method: 'GET',
	                params: params,
	                scope: this,
	                success: function success(r) {
	                    var a = Ext.decode(r.responseText).organisationUnits;
	                    this.numberOfRecords = a.length;
	                    for (var i = 0; i < a.length; i++) {
	                        this.multipleExpand(a[i].id, a[i].path);
	                    }
	                }
	            });
	        },
	        getParentGraphMap: function getParentGraphMap() {
	            var selection = this.getSelectionModel().getSelection(),
	                map = {};
	
	            if ((0, _isArray2.default)(selection) && selection.length) {
	                for (var i = 0, pathArray, key; i < selection.length; i++) {
	                    pathArray = selection[i].getPath().split('/');
	                    map[pathArray.pop()] = pathArray.join('/');
	                }
	            }
	
	            return map;
	        },
	        selectGraphMap: function selectGraphMap(map, update) {
	            if (!Object.keys(map).length) {
	                return;
	            }
	
	            this.isPending = true;
	
	            for (var key in map) {
	                if (map.hasOwnProperty(key)) {
	                    treePanel.multipleExpand(key, map, update);
	                }
	            }
	        },
	        store: Ext.create('Ext.data.TreeStore', {
	            fields: ['id', 'name', 'hasChildren'],
	            proxy: {
	                type: 'rest',
	                format: 'json',
	                noCache: false,
	                extraParams: {
	                    fields: 'children[id,' + displayPropertyUrl + ',children::isNotEmpty~rename(hasChildren)&paging=false'
	                },
	                url: appManager.getApiPath() + '/organisationUnits',
	                reader: {
	                    type: 'json',
	                    root: 'children'
	                },
	                sortParam: false
	            },
	            sorters: [{
	                property: 'name',
	                direction: 'ASC'
	            }],
	            root: {
	                id: appManager.rootNodeId,
	                expanded: true,
	                children: appManager.getRootNodes()
	            },
	            listeners: {
	                beforeload: function beforeload(store, operation) {
	                    if (!store.proxy._url) {
	                        store.proxy._url = store.proxy.url;
	                    }
	
	                    store.proxy.url = store.proxy._url + '/' + operation.node.data.id;
	                },
	                load: function load(store, node, records) {
	                    records.forEach(function (record) {
	                        if ((0, _isBoolean2.default)(record.data.hasChildren)) {
	                            record.set('leaf', !record.data.hasChildren);
	                        }
	                    });
	                }
	            }
	        }),
	        xable: function xable(values) {
	            for (var i = 0; i < values.length; i++) {
	                if (!!values[i]) {
	                    this.disable();
	                    return;
	                }
	            }
	
	            this.enable();
	        },
	        getDimension: function getDimension() {
	            var r = treePanel.getSelectionModel().getSelection(),
	                config = {
	                dimension: organisationUnitObjectName,
	                items: []
	            };
	
	            if (toolMenu.menuValue === 'orgunit') {
	                if (userOrganisationUnit.getValue() || userOrganisationUnitChildren.getValue() || userOrganisationUnitGrandChildren.getValue()) {
	                    if (userOrganisationUnit.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT',
	                            name: ''
	                        });
	                    }
	                    if (userOrganisationUnitChildren.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT_CHILDREN',
	                            name: ''
	                        });
	                    }
	                    if (userOrganisationUnitGrandChildren.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT_GRANDCHILDREN',
	                            name: ''
	                        });
	                    }
	                } else {
	                    for (var i = 0; i < r.length; i++) {
	                        config.items.push({ id: r[i].data.id });
	                    }
	                }
	            } else if (toolMenu.menuValue === 'level') {
	                var levels = organisationUnitLevel.getValue();
	
	                for (var i = 0; i < levels.length; i++) {
	                    config.items.push({
	                        id: 'LEVEL-' + levels[i],
	                        name: ''
	                    });
	                }
	
	                for (var i = 0; i < r.length; i++) {
	                    config.items.push({
	                        id: r[i].data.id,
	                        name: ''
	                    });
	                }
	            } else if (toolMenu.menuValue === 'group') {
	                var groupIds = organisationUnitGroup.getValue();
	
	                for (var i = 0; i < groupIds.length; i++) {
	                    config.items.push({
	                        id: 'OU_GROUP-' + groupIds[i],
	                        name: ''
	                    });
	                }
	
	                for (var i = 0; i < r.length; i++) {
	                    config.items.push({
	                        id: r[i].data.id,
	                        name: ''
	                    });
	                }
	            }
	
	            return config.items.length ? config : null;
	        },
	        listeners: {
	            beforeitemexpand: function beforeitemexpand() {
	                var rts = treePanel.recordsToSelect;
	
	                if (!treePanel.isPending) {
	                    treePanel.recordsToRestore = treePanel.getSelectionModel().getSelection();
	                }
	            },
	            itemexpand: function itemexpand() {
	                if (!treePanel.isPending && treePanel.recordsToRestore.length) {
	                    treePanel.getSelectionModel().select(treePanel.recordsToRestore);
	                    treePanel.recordsToRestore = [];
	                }
	            },
	            render: function render() {
	                this.rendered = true;
	            },
	            afterrender: function afterrender() {
	                this.getSelectionModel().select(0);
	
	                Ext.defer(function () {
	                    data.expand();
	                }, 20);
	            },
	            itemcontextmenu: function itemcontextmenu(v, r, h, i, e) {
	                v.getSelectionModel().select(r, false);
	
	                if (v.menu) {
	                    v.menu.destroy();
	                }
	                v.menu = Ext.create('Ext.menu.Menu', {
	                    id: 'treepanel-contextmenu',
	                    showSeparator: false,
	                    shadow: false
	                });
	                if (!r.data.leaf) {
	                    v.menu.add({
	                        id: 'treepanel-contextmenu-item',
	                        text: i18n.select_sub_units,
	                        iconCls: 'ns-button-icon-nodeselectchild',
	                        handler: function handler() {
	                            r.expand(false, function () {
	                                v.getSelectionModel().select(r.childNodes, true);
	                                v.getSelectionModel().deselect(r);
	                            });
	                        }
	                    });
	                } else {
	                    return;
	                }
	
	                v.menu.showAt(e.xy);
	            }
	        }
	    });
	    uiManager.reg(treePanel, 'treePanel');
	
	    var userOrganisationUnit = Ext.create('Ext.form.field.Checkbox', {
	        columnWidth: 0.25,
	        style: 'padding-top: 3px; padding-left: 5px; margin-bottom: 0',
	        boxLabel: 'User org unit',
	        labelWidth: uiConfig.form_label_width,
	        handler: function handler(chb, checked) {
	            treePanel.xable([checked, userOrganisationUnitChildren.getValue(), userOrganisationUnitGrandChildren.getValue()]);
	        }
	    });
	
	    var userOrganisationUnitChildren = Ext.create('Ext.form.field.Checkbox', {
	        columnWidth: 0.26,
	        style: 'padding-top: 3px; margin-bottom: 0',
	        boxLabel: i18n.user_sub_units,
	        labelWidth: uiConfig.form_label_width,
	        handler: function handler(chb, checked) {
	            treePanel.xable([checked, userOrganisationUnit.getValue(), userOrganisationUnitGrandChildren.getValue()]);
	        }
	    });
	
	    var userOrganisationUnitGrandChildren = Ext.create('Ext.form.field.Checkbox', {
	        columnWidth: 0.4,
	        style: 'padding-top: 3px; margin-bottom: 0',
	        boxLabel: i18n.user_sub_x2_units,
	        labelWidth: uiConfig.form_label_width,
	        handler: function handler(chb, checked) {
	            treePanel.xable([checked, userOrganisationUnit.getValue(), userOrganisationUnitChildren.getValue()]);
	        }
	    });
	
	    var organisationUnitLevel = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        multiSelect: true,
	        style: 'margin-bottom:0',
	        width: accBaseWidth - toolWidth - 1,
	        valueField: 'level',
	        displayField: 'name',
	        emptyText: i18n.select_organisation_unit_levels,
	        editable: false,
	        hidden: true,
	        store: {
	            fields: ['id', 'name', 'level'],
	            data: appManager.organisationUnitLevels
	        }
	    });
	
	    var organisationUnitGroup = Ext.create('Ext.form.field.ComboBox', {
	        cls: 'ns-combo',
	        multiSelect: true,
	        style: 'margin-bottom:0',
	        width: accBaseWidth - toolWidth - 1,
	        valueField: 'id',
	        displayField: 'name',
	        emptyText: i18n.select_organisation_unit_groups,
	        editable: false,
	        hidden: true,
	        store: organisationUnitGroupStore
	    });
	
	    var organisationUnitPanel = Ext.create('Ext.panel.Panel', {
	        width: accBaseWidth - toolWidth - 1,
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        items: [userOrganisationUnit, userOrganisationUnitChildren, userOrganisationUnitGrandChildren, organisationUnitLevel, organisationUnitGroup]
	    });
	
	    var toolMenu = Ext.create('Ext.menu.Menu', {
	        shadow: false,
	        showSeparator: false,
	        menuValue: 'orgunit',
	        clickHandler: function clickHandler(param) {
	            if (!param) {
	                return;
	            }
	
	            var items = this.items.items;
	            this.menuValue = param;
	
	            // Menu item icon cls
	            for (var i = 0; i < items.length; i++) {
	                if (items[i].setIconCls) {
	                    if (items[i].param === param) {
	                        items[i].setIconCls('ns-menu-item-selected');
	                    } else {
	                        items[i].setIconCls('ns-menu-item-unselected');
	                    }
	                }
	            }
	
	            // Gui
	            if (param === 'orgunit') {
	                userOrganisationUnit.show();
	                userOrganisationUnitChildren.show();
	                userOrganisationUnitGrandChildren.show();
	                organisationUnitLevel.hide();
	                organisationUnitGroup.hide();
	
	                if (userOrganisationUnit.getValue() || userOrganisationUnitChildren.getValue()) {
	                    treePanel.disable();
	                }
	            } else if (param === 'level') {
	                userOrganisationUnit.hide();
	                userOrganisationUnitChildren.hide();
	                userOrganisationUnitGrandChildren.hide();
	                organisationUnitLevel.show();
	                organisationUnitGroup.hide();
	                treePanel.enable();
	            } else if (param === 'group') {
	                // DHIS2-561: avoid showing the group ids in the combobox when
	                // loading a favorite and expanding the OU panel
	                organisationUnitGroupStore.load();
	
	                userOrganisationUnit.hide();
	                userOrganisationUnitChildren.hide();
	                userOrganisationUnitGrandChildren.hide();
	                organisationUnitLevel.hide();
	                organisationUnitGroup.show();
	                treePanel.enable();
	            }
	        },
	        items: [{
	            xtype: 'label',
	            text: 'Selection mode',
	            style: 'padding:7px 5px 5px 7px; font-weight:bold; border:0 none'
	        }, {
	            text: i18n.select_organisation_units + '&nbsp;&nbsp;',
	            param: 'orgunit',
	            iconCls: 'ns-menu-item-selected'
	        }, {
	            text: 'Select levels' + '&nbsp;&nbsp;',
	            param: 'level',
	            iconCls: 'ns-menu-item-unselected'
	        }, {
	            text: 'Select groups' + '&nbsp;&nbsp;',
	            param: 'group',
	            iconCls: 'ns-menu-item-unselected'
	        }],
	        listeners: {
	            afterrender: function afterrender() {
	                this.getEl().addCls('ns-btn-menu');
	            },
	            click: function click(menu, item) {
	                this.clickHandler(item.param);
	            }
	        }
	    });
	
	    var tool = Ext.create('Ext.button.Button', {
	        cls: 'ns-button-organisationunitselection',
	        iconCls: 'ns-button-icon-gear',
	        width: toolWidth,
	        height: 24,
	        menu: toolMenu
	    });
	
	    var toolPanel = Ext.create('Ext.panel.Panel', {
	        width: toolWidth,
	        bodyStyle: 'border:0 none; text-align:right',
	        style: 'margin-right:1px',
	        items: tool
	    });
	
	    var organisationUnit = Ext.create('Ext.panel.Panel', {
	        title: '<div class="ns-panel-title-organisationunit">' + i18n.organisation_units + '</div>',
	        bodyStyle: 'padding:1px',
	        hideCollapseTool: true,
	        dimension: dimensionConfig.get('organisationUnit').objectName,
	        collapsed: false,
	        clearDimension: function clearDimension(doClear, skipTree) {
	            if (doClear) {
	                toolMenu.clickHandler(toolMenu.menuValue);
	
	                if (!skipTree) {
	                    treePanel.reset();
	                }
	
	                userOrganisationUnit.setValue(false);
	                userOrganisationUnitChildren.setValue(false);
	                userOrganisationUnitGrandChildren.setValue(false);
	
	                organisationUnitLevel.clearValue();
	                organisationUnitGroup.clearValue();
	            }
	        },
	        setDimension: function setDimension(layout) {
	            if (layout.hasDimension(this.dimension, true)) {
	                var dimension = layout.getDimension(this.dimension, true),
	                    parentGraphMap = layout.parentGraphMap;
	
	                var records = dimension.getRecords(),
	                    ids = [],
	                    levels = [],
	                    groups = [],
	                    isOu,
	                    isOuc,
	                    isOugc;
	
	                records.forEach(function (record) {
	                    if (record.id === 'USER_ORGUNIT') {
	                        isOu = true;
	                    } else if (record.id === 'USER_ORGUNIT_CHILDREN') {
	                        isOuc = true;
	                    } else if (record.id === 'USER_ORGUNIT_GRANDCHILDREN') {
	                        isOugc = true;
	                    } else if (record.id.substr(0, 5) === 'LEVEL') {
	                        levels.push(parseInt(record.id.split('-')[1]));
	                    } else if (record.id.substr(0, 8) === 'OU_GROUP') {
	                        groups.push(record.id.split('-')[1]);
	                    } else {
	                        ids.push(record.id);
	                    }
	                });
	
	                if (levels.length) {
	                    toolMenu.clickHandler('level');
	                    organisationUnitLevel.setValue(levels);
	                } else if (groups.length) {
	                    toolMenu.clickHandler('group');
	                    organisationUnitGroup.setValue(groups);
	                } else {
	                    toolMenu.clickHandler('orgunit');
	                    userOrganisationUnit.setValue(isOu);
	                    userOrganisationUnitChildren.setValue(isOuc);
	                    userOrganisationUnitGrandChildren.setValue(isOugc);
	                }
	
	                if (!(isOu || isOuc || isOugc)) {
	                    if ((0, _isObject2.default)(parentGraphMap)) {
	                        treePanel.selectGraphMap(parentGraphMap);
	                    }
	                }
	            } else {
	                this.clearDimension(true);
	            }
	        },
	        getDimension: function getDimension() {
	            var r = treePanel.getSelectionModel().getSelection(),
	                config = {
	                dimension: organisationUnitObjectName,
	                items: []
	            };
	
	            if (toolMenu.menuValue === 'orgunit') {
	                if (userOrganisationUnit.getValue() || userOrganisationUnitChildren.getValue() || userOrganisationUnitGrandChildren.getValue()) {
	                    if (userOrganisationUnit.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT',
	                            name: ''
	                        });
	                    }
	                    if (userOrganisationUnitChildren.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT_CHILDREN',
	                            name: ''
	                        });
	                    }
	                    if (userOrganisationUnitGrandChildren.getValue()) {
	                        config.items.push({
	                            id: 'USER_ORGUNIT_GRANDCHILDREN',
	                            name: ''
	                        });
	                    }
	                } else {
	                    for (var i = 0; i < r.length; i++) {
	                        config.items.push({ id: r[i].data.id });
	                    }
	                }
	            } else if (toolMenu.menuValue === 'level') {
	                var levels = organisationUnitLevel.getValue();
	
	                for (var i = 0; i < levels.length; i++) {
	                    config.items.push({
	                        id: 'LEVEL-' + levels[i],
	                        name: ''
	                    });
	                }
	
	                for (var i = 0; i < r.length; i++) {
	                    config.items.push({
	                        id: r[i].data.id,
	                        name: ''
	                    });
	                }
	            } else if (toolMenu.menuValue === 'group') {
	                var groupIds = organisationUnitGroup.getValue();
	
	                for (var i = 0; i < groupIds.length; i++) {
	                    config.items.push({
	                        id: 'OU_GROUP-' + groupIds[i],
	                        name: ''
	                    });
	                }
	
	                for (var i = 0; i < r.length; i++) {
	                    config.items.push({
	                        id: r[i].data.id,
	                        name: ''
	                    });
	                }
	            }
	
	            return config.items.length ? config : null;
	        },
	        getHeightValue: function getHeightValue() {
	            var westRegion = uiManager.get('westRegion');
	
	            return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_organisationunit : uiConfig.west_maxheight_accordion_organisationunit;
	        },
	        onExpand: function onExpand() {
	            accordion.setThisHeight(this.getHeightValue);
	
	            treePanel.setHeight(this.getHeight() - uiConfig.west_fill_accordion_organisationunit);
	        },
	        items: [{
	            layout: 'column',
	            bodyStyle: 'border:0 none',
	            style: 'padding-bottom:1px',
	            items: [toolPanel, {
	                width: accBaseWidth - 37,
	                layout: 'column',
	                bodyStyle: 'border:0 none',
	                items: [userOrganisationUnit, userOrganisationUnitChildren, userOrganisationUnitGrandChildren, organisationUnitLevel, organisationUnitGroup]
	            }]
	        }, treePanel],
	        listeners: {
	            expand: function expand(p) {
	                p.onExpand();
	            }
	        }
	    });
	    accordionPanels.push(uiManager.reg(organisationUnit, 'organisationUnit'));
	
	    // dimensions
	
	    var getDimensionPanel = function getDimensionPanel(dimension, iconCls) {
	        var onSelect, availableStore, selectedStore, dataLabel, dataSearch, dataFilter, selectedAll, available, selected, onSelectAll, panel, createPanel, getPanels;
	
	        onSelect = function onSelect() {
	            var win = uiManager.get('viewport').getLayoutWindow();
	
	            if (selectedStore.getRange().length || selectedAll.getValue()) {
	                win.addDimension({ id: dimension.id, name: dimension.name });
	            } else if (win.hasDimension(dimension.id)) {
	                win.removeDimension(dimension.id);
	            }
	        };
	
	        availableStore = Ext.create('Ext.data.Store', {
	            fields: ['id', 'name'],
	            lastPage: null,
	            nextPage: 1,
	            isPending: false,
	            isLoaded: false,
	            reset: function reset() {
	                this.removeAll();
	                this.lastPage = null;
	                this.nextPage = 1;
	                this.isPending = false;
	                dataSearch.hideFilter();
	            },
	            storage: {},
	            addToStorage: function addToStorage(dimensionId, filter, data) {
	                filter = 'cache_' + ((0, _isString2.default)(filter) || (0, _isNumber2.default)(filter) ? filter : '');
	
	                if (!dimensionId) {
	                    return;
	                }
	
	                if (!this.storage.hasOwnProperty(dimensionId)) {
	                    this.storage[dimensionId] = {};
	                }
	
	                if (!this.storage[dimensionId][filter]) {
	                    this.storage[dimensionId][filter] = data;
	                }
	            },
	            getFromStorage: function getFromStorage(dimensionId, filter) {
	                filter = 'cache_' + ((0, _isString2.default)(filter) || (0, _isNumber2.default)(filter) ? filter : '');
	
	                if (this.storage.hasOwnProperty(dimensionId)) {
	                    if (this.storage[dimensionId].hasOwnProperty(filter)) {
	                        return this.storage[dimensionId][filter];
	                    }
	                }
	
	                return;
	            },
	            loadPage: function loadPage(filter, append, noPaging, fn) {
	                var store = this,
	                    params = {},
	                    url,
	                    cacheData;
	
	                filter = filter || dataFilter.getValue() || null;
	
	                // check session cache
	                cacheData = store.getFromStorage(dimension.id, filter);
	
	                if (!append && cacheData) {
	                    store.loadStore(cacheData, {}, append, fn);
	                } else {
	                    if (!append) {
	                        this.lastPage = null;
	                        this.nextPage = 1;
	                    }
	
	                    if (store.nextPage === store.lastPage) {
	                        return;
	                    }
	
	                    url = '/dimensions/' + dimension.id + '/items.json?fields=id,' + displayPropertyUrl + (filter ? '&filter=' + displayProperty + ':ilike:' + filter : '');
	
	                    if (noPaging) {
	                        params.paging = false;
	                    } else {
	                        params.page = store.nextPage;
	                        params.pageSize = 50;
	                    }
	
	                    store.isPending = true;
	                    uiManager.mask(available.boundList);
	
	                    Ext.Ajax.request({
	                        url: encodeURI(apiPath + url),
	                        method: 'GET',
	                        params: params,
	                        success: function success(r) {
	                            var response = Ext.decode(r.responseText),
	                                data = response.items || [],
	                                pager = response.pager;
	
	                            // add to session cache
	                            store.addToStorage(dimension.id, filter, data);
	
	                            store.loadStore(data, pager, append, fn);
	                        },
	                        callback: function callback() {
	                            store.isPending = false;
	                            uiManager.unmask(available.boundList);
	                        }
	                    });
	                }
	            },
	            loadStore: function loadStore(data, pager, append, fn) {
	                pager = pager || {};
	
	                this.loadData(data, append);
	                this.lastPage = this.nextPage;
	
	                if (pager.pageCount > this.nextPage) {
	                    this.nextPage++;
	                }
	
	                this.isPending = false;
	
	                uiManager.msFilterAvailable({ store: availableStore }, { store: selectedStore });
	
	                if (fn) {
	                    fn();
	                }
	            },
	            sortStore: function sortStore() {
	                this.sort('name', 'ASC');
	            }
	        });
	
	        selectedStore = Ext.create('Ext.data.Store', {
	            fields: ['id', 'name'],
	            data: [],
	            listeners: {
	                add: function add() {
	                    onSelect();
	                },
	                remove: function remove() {
	                    onSelect();
	                },
	                clear: function clear() {
	                    onSelect();
	                }
	            }
	        });
	
	        dataLabel = Ext.create('Ext.form.Label', {
	            text: i18n.available,
	            cls: 'ns-toolbar-multiselect-left-label',
	            style: 'margin-right:5px'
	        });
	
	        dataSearch = Ext.create('Ext.button.Button', {
	            width: 22,
	            height: 22,
	            cls: 'ns-button-icon',
	            iconCls: 'ns-button-icon-search',
	            showFilter: function showFilter() {
	                dataLabel.hide();
	                this.hide();
	                dataFilter.show();
	                dataFilter.reset();
	            },
	            hideFilter: function hideFilter() {
	                dataLabel.show();
	                this.show();
	                dataFilter.hide();
	                dataFilter.reset();
	            },
	            handler: function handler() {
	                this.showFilter();
	            }
	        });
	
	        dataFilter = Ext.create('Ext.form.field.Trigger', {
	            width: accBaseWidth / 2,
	            cls: 'ns-trigger-filter',
	            emptyText: 'Filter available...',
	            height: 22,
	            hidden: true,
	            enableKeyEvents: true,
	            fieldStyle: 'height:22px; border-right:0 none',
	            style: 'height:22px',
	            onTriggerClick: function onTriggerClick() {
	                this.reset();
	                this.onKeyUpHandler();
	
	                dataSearch.hideFilter();
	            },
	            onKeyUpHandler: function onKeyUpHandler() {
	                var value = this.getValue(),
	                    store = availableStore;
	
	                if ((0, _isString2.default)(value) || (0, _isNumber2.default)(value)) {
	                    store.loadPage(value, false, true);
	                }
	            },
	            listeners: {
	                keyup: {
	                    fn: function fn(cmp) {
	                        cmp.onKeyUpHandler();
	                    },
	                    buffer: 100
	                },
	                show: function show(cmp) {
	                    cmp.focus(false, 50);
	                },
	                focus: function focus(cmp) {
	                    cmp.addCls('ns-trigger-filter-focused');
	                },
	                blur: function blur(cmp) {
	                    cmp.removeCls('ns-trigger-filter-focused');
	                }
	            }
	        });
	
	        selectedAll = Ext.create('Ext.form.field.Checkbox', {
	            cls: 'ns-checkbox',
	            style: 'margin-left: 2px; margin-right: 5px',
	            boxLabel: 'All',
	            listeners: {
	                change: function change(chb, newVal) {
	                    onSelectAll(newVal);
	                }
	            }
	        });
	
	        available = Ext.create('Ext.ux.form.MultiSelect', {
	            cls: 'ns-toolbar-multiselect-left',
	            width: accBaseWidth / 2,
	            valueField: 'id',
	            displayField: 'name',
	            store: availableStore,
	            tbar: [dataLabel, dataSearch, dataFilter, '->', {
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowright',
	                width: 22,
	                handler: function handler() {
	                    uiManager.msSelect(available, selected);
	                }
	            }, {
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowrightdouble',
	                width: 22,
	                handler: function handler() {
	                    availableStore.loadPage(null, null, true, function () {
	                        uiManager.msSelectAll(available, selected);
	                    });
	                }
	            }],
	            listeners: {
	                render: function render(ms) {
	                    var el = Ext.get(ms.boundList.getEl().id + '-listEl').dom;
	
	                    el.addEventListener('scroll', function (e) {
	                        if (uiManager.isScrolled(e) && !availableStore.isPending) {
	                            availableStore.loadPage(null, true);
	                        }
	                    });
	
	                    ms.boundList.on('itemdblclick', function () {
	                        uiManager.msSelect(available, selected);
	                    }, ms);
	                }
	            }
	        });
	
	        selected = Ext.create('Ext.ux.form.MultiSelect', {
	            cls: 'ns-toolbar-multiselect-right',
	            width: accBaseWidth / 2,
	            valueField: 'id',
	            displayField: 'name',
	            ddReorder: true,
	            store: selectedStore,
	            tbar: [{
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowleftdouble',
	                width: 22,
	                handler: function handler() {
	                    uiManager.msUnselectAll(available, selected);
	                }
	            }, {
	                xtype: 'button',
	                iconCls: 'ns-button-icon-arrowleft',
	                width: 22,
	                handler: function handler() {
	                    uiManager.msUnselect(available, selected);
	                }
	            }, '->', {
	                xtype: 'label',
	                text: i18n.selected,
	                cls: 'ns-toolbar-multiselect-right-label'
	            }, selectedAll],
	            listeners: {
	                afterrender: function afterrender() {
	                    this.boundList.on('itemdblclick', function () {
	                        uiManager.msUnselect(available, selected);
	                    }, this);
	                }
	            }
	        });
	
	        onSelectAll = function onSelectAll(value) {
	            if (available.boundList && selected.boundList) {
	                if (value) {
	                    available.boundList.disable();
	                    selected.boundList.disable();
	                } else {
	                    available.boundList.enable();
	                    selected.boundList.enable();
	                }
	            }
	
	            onSelect();
	        };
	
	        panel = Ext.create('Ext.panel.Panel', {
	            title: '<div class="' + iconCls + '">' + dimension.name + '</div>',
	            hideCollapseTool: true,
	            dimension: dimension.id,
	            availableStore: availableStore,
	            selectedStore: selectedStore,
	            selectedAll: selectedAll,
	            isDynamic: true,
	            clearDimension: function clearDimension() {
	                availableStore.reset();
	                selectedStore.removeAll();
	                selectedAll.setValue(false);
	            },
	            setDimension: function setDimension(layout) {
	                if (layout.hasDimension(this.dimension, true)) {
	                    var records = layout.getDimension(this.dimension).getRecords();
	
	                    if (records.length) {
	                        selectedStore.add(records);
	                        uiManager.msFilterAvailable({ store: availableStore }, { store: selectedStore });
	                    } else {
	                        selectedAll.setValue(true);
	                    }
	                }
	            },
	            getDimension: function getDimension() {
	                var config = {};
	
	                if (dimension.id) {
	                    config.dimension = dimension.id;
	                }
	
	                if (!selectedAll.getValue() && selectedStore.getRange().length) {
	                    config.items = [];
	
	                    selectedStore.each(function (r) {
	                        config.items.push({ id: r.data.id });
	                    });
	                }
	
	                return config.dimension ? config : null;
	            },
	            getHeightValue: function getHeightValue() {
	                var westRegion = uiManager.get('westRegion');
	
	                return westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_group : uiConfig.west_maxheight_accordion_group;
	            },
	            onExpand: function onExpand() {
	                // load items
	                if (!availableStore.isLoaded) {
	                    availableStore.loadPage();
	                }
	
	                // enable/disable ui
	                if (selectedAll.getValue()) {
	                    available.boundList.disable();
	                    selected.boundList.disable();
	                }
	
	                // set height
	                var westRegion = uiManager.get('westRegion');
	                var accordion = uiManager.get('accordion');
	
	                var accordionHeight = westRegion.hasScrollbar ? uiConfig.west_scrollbarheight_accordion_group : uiConfig.west_maxheight_accordion_group;
	
	                accordion.setThisHeight(accordionHeight);
	
	                uiManager.msSetHeight([available, selected], this, uiConfig.west_fill_accordion_group);
	            },
	            items: [{
	                xtype: 'panel',
	                layout: 'column',
	                bodyStyle: 'border-style:none',
	                items: [available, selected]
	            }],
	            listeners: {
	                expand: function expand(p) {
	                    p.onExpand();
	                }
	            }
	        });
	
	        return panel;
	    };
	
	    // accordion
	    var defaultItems = [data, period, organisationUnit].concat(_toConsumableArray(appManager.dimensions.map(function (dimension) {
	        var panel = getDimensionPanel(dimension, 'ns-panel-title-dimension');
	
	        accordionPanels.push(uiManager.reg(panel, panel.dimension));
	
	        return panel;
	    })));
	
	    var getItems = function getItems() {
	        var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        return dimensions.map(function (dimension) {
	            return getDimensionPanel(dimension, 'ns-panel-title-dimension');
	        });
	    };
	
	    var accordionBody = Ext.create('Ext.panel.Panel', {
	        layout: 'accordion',
	        activeOnTop: true,
	        cls: 'ns-accordion',
	        bodyStyle: 'border:0 none',
	        height: 700,
	        toBeRemoved: [],
	        addItems: function addItems(dimensions) {
	            this.toBeRemoved = this.add(getItems(dimensions));
	
	            accordion.setThisHeight();
	        },
	        removeItems: function removeItems() {
	            this.toBeRemoved.map(function (item) {
	                return (0, _isString2.default)(item) ? item : item.id;
	            }).forEach(function (id) {
	                accordionBody.remove(id);
	            });
	
	            accordion.setThisHeight();
	
	            this.toBeRemoved = [];
	        },
	        getExpandedPanel: function getExpandedPanel() {
	            var expandedPanel;
	
	            this.items.each(function (panel) {
	                if (!panel.collapsed) {
	                    expandedPanel = panel;
	                    return false;
	                }
	            });
	
	            return expandedPanel;
	        },
	        items: defaultItems
	    });
	
	    // functions
	
	    var setUiState = function setUiState(layout, response) {
	        var viewport = uiManager.get('viewport');
	
	        var dataTypeToolbar = uiManager.get('dataTypeToolbar'),
	            chartTypeToolbar = uiManager.get('chartTypeToolbar'),
	            aggLayoutWindow = uiManager.get('aggregateLayoutWindow'),
	            queryLayoutWindow = uiManager.get('queryLayoutWindow'),
	            aggOptionsWindow = uiManager.get('aggregateOptionsWindow'),
	            queryOptionsWindow = uiManager.get('queryOptionsWindow');
	
	        if (dataTypeToolbar) {
	            dataTypeToolbar.setDataType(layout ? layout.dataType : null);
	        }
	
	        if (chartTypeToolbar) {
	            chartTypeToolbar.setChartType(layout ? layout.type : null);
	        }
	
	        if (aggLayoutWindow) {
	            aggLayoutWindow.reset();
	        }
	
	        if (queryLayoutWindow) {
	            queryLayoutWindow.reset();
	        }
	
	        if (aggOptionsWindow) {
	            aggOptionsWindow.setOptions(layout);
	        }
	
	        if (queryOptionsWindow) {
	            queryOptionsWindow.setOptions(layout);
	        }
	
	        // dimensions
	        accordion.clearDimensions(layout);
	
	        if (layout) {
	            // data
	            programStore.add(layout.program);
	            program.setValue(layout.program.id);
	
	            // periods
	            period.setDimension(layout);
	
	            // organisation units
	            organisationUnit.setDimension(layout);
	
	            // data, dynamic dimensions and layout window
	            setData(layout);
	        }
	
	        //var statusBar = uiManager.get('statusBar');
	
	        // state
	        //uiManager.get('downloadButton').enable();
	
	        //if (layout.id) {
	        //uiManager.get('shareButton').enable();
	        //}
	
	        //statusBar.setStatus(layout, response);
	    };
	
	    var getUiState = function getUiState(layoutWindow, optionsWindow, chartType, dataType) {
	        var viewport = uiManager.get('viewport'),
	            panels = uiManager.get('accordion').panels,
	            dataTypeToolbar = uiManager.get('dataTypeToolbar'),
	            aggregateLayoutWindow = uiManager.get('aggregateLayoutWindow'),
	            aggregateOptionsWindow = uiManager.get('aggregateOptionsWindow'),
	            queryOptionsWindow = uiManager.get('queryOptionsWindow'),
	            statusBar = uiManager.get('statusBar'),
	            config = {},
	            map = {},
	            columns = [],
	            rows = [],
	            filters = [],
	            values = [],
	            addAxisDimension,
	            store,
	            data;
	
	        layoutWindow = layoutWindow || viewport.getLayoutWindow();
	
	        config.program = program.getRecord();
	        config.programStage = stage.getRecord();
	
	        if (!(config.program && config.programStage)) {
	            return;
	        }
	
	        if (dataTypeToolbar) {
	            var dataType = dataTypeToolbar.getDataType();
	        }
	
	        // dy
	        map['dy'] = [{ dimension: 'dy' }];
	
	        // pe
	        if (periodMode.getValue() === 'dates') {
	            config.startDate = startDate.getSubmitValue();
	            config.endDate = endDate.getSubmitValue();
	
	            if (!(config.startDate && config.endDate)) {
	                return;
	            }
	        } else if (periodMode.getValue() === 'periods') {
	            map['pe'] = [periods.getDimension()];
	        }
	
	        // ou
	        map['ou'] = [treePanel.getDimension()];
	
	        // data items
	        for (var i = 0, record; i < dataElementSelected.items.items.length; i++) {
	            record = dataElementSelected.items.items[i].getRecord();
	
	            map[record.dimension] = map[record.dimension] || [];
	
	            map[record.dimension].push(record);
	        }
	
	        // dynamic dimensions data
	        accordionBody.items.each(function (panel) {
	            if (panel.isDynamic && panel.getDimension) {
	                var dim = panel.getDimension();
	
	                if (dim && dim.dimension) {
	                    map[dim.dimension] = [dim];
	                }
	            }
	        });
	
	        // other
	        map['longitude'] = [{ dimension: 'longitude' }];
	        map['latitude'] = [{ dimension: 'latitude' }];
	
	        addAxisDimension = function addAxisDimension(a, axis) {
	            if (a.length) {
	                if (a.length === 1) {
	                    axis.push(a[0]);
	                } else {
	                    var dim;
	
	                    for (var i = 0; i < a.length; i++) {
	                        if (!dim) {
	                            //todo ??
	                            dim = a[i];
	                        } else {
	                            dim.filter += ':' + a[i].filter;
	                        }
	                    }
	
	                    axis.push(dim);
	                }
	            }
	        };
	
	        // columns
	        store = layoutWindow.colStore;
	
	        if (store) {
	            data = store.findExact('id', 'dy') === -1 ? store.data : store.snapshot;
	
	            data.each(function (item) {
	                addAxisDimension(map[item.data.id || item.data.dimensionName] || [], columns);
	            });
	        }
	
	        // rows
	        store = layoutWindow.rowStore;
	
	        if (store) {
	            data = store.findExact('id', 'dy') === -1 ? store.data : store.snapshot;
	
	            data.each(function (item) {
	                addAxisDimension(map[item.data.id || item.data.dimensionName] || [], rows);
	            });
	        }
	
	        // filters
	        store = layoutWindow.filterStore;
	
	        if (store) {
	            data = store.findExact('id', 'dy') === -1 ? store.data : store.snapshot;
	
	            data.each(function (item) {
	                addAxisDimension(map[item.data.id || item.data.dimensionName] || [], filters);
	            });
	        }
	
	        // fixed filters
	        store = layoutWindow.fixedFilterStore;
	
	        if (store) {
	            data = store.findExact('id', 'dy') === -1 ? store.data : store.snapshot;
	
	            data.each(function (item) {
	                addAxisDimension(map[item.data.id || item.data.dimensionName] || [], filters);
	            });
	        }
	
	        if (columns.length) {
	            config.columns = columns;
	        }
	        if (rows.length) {
	            config.rows = rows;
	        }
	        if (filters.length) {
	            config.filters = filters;
	        }
	
	        // value, aggregation type
	        Ext.apply(config, layoutWindow.getValueConfig());
	
	        if (dataType === dimensionConfig.dataType['aggregated_values']) {
	            Ext.applyIf(config, aggregateOptionsWindow.getOptions());
	            Ext.applyIf(config, aggregateLayoutWindow.getOptions());
	
	            // if order and limit -> sort
	            if (config.sortOrder && config.topLimit) {
	                config.sorting = {
	                    id: 1,
	                    direction: config.sortOrder == 1 ? 'DESC' : 'ASC'
	                };
	            }
	        }
	
	        if (dataType === dimensionConfig.dataType['individual_cases']) {
	            Ext.applyIf(config, queryOptionsWindow.getOptions());
	
	            if (statusBar) {
	                config.paging = {
	                    page: uiManager.get('statusBar').getCurrentPage(),
	                    pageSize: 100
	                };
	            }
	        }
	
	        return config;
	    };
	
	    var accordion = Ext.create('Ext.panel.Panel', (_Ext$create = {
	        bodyStyle: 'border-style:none; padding:1px; padding-bottom:0; overflow-y:scroll;',
	        accordionBody: accordionBody,
	        items: accordionBody,
	        panels: accordionPanels,
	        expandInitPanels: function expandInitPanels() {
	            organisationUnit.expand();
	        },
	        clearDimensions: function clearDimensions(layout) {
	            accordionPanels.forEach(function (panel) {
	                panel.clearDimension(!!layout);
	            });
	        },
	        setDimensions: function setDimensions(layout, dynamicOnly) {
	            accordionPanels.forEach(function (panel) {
	                if (dynamicOnly && !panel.isDynamic) {
	                    return;
	                }
	
	                panel.setDimension(layout);
	            });
	        },
	        setThisHeight: function setThisHeight(mx) {
	            mx = mx || this.getExpandedPanel().getHeightValue();
	
	            var settingsHeight = 41;
	
	            var containerHeight = settingsHeight + accordionBody.items.items.length * 28 + mx,
	                accordionHeight = uiManager.get('westRegion').getHeight() - settingsHeight - uiConfig.west_fill,
	                accordionBodyHeight;
	
	            if (uiManager.get('westRegion').hasScrollbar) {
	                accordionBodyHeight = containerHeight - settingsHeight - uiConfig.west_fill;
	            } else {
	                accordionBodyHeight = (accordionHeight > containerHeight ? containerHeight : accordionHeight) - uiConfig.west_fill;
	            }
	
	            this.setHeight(accordionHeight);
	            accordionBody.setHeight(accordionBodyHeight);
	        },
	        getExpandedPanel: function getExpandedPanel() {
	            return accordionBody.getExpandedPanel();
	        },
	        getFirstPanel: function getFirstPanel() {
	            return this.panels[0];
	        },
	        getParentGraphMap: function getParentGraphMap() {
	            return treePanel.getParentGraphMap();
	        },
	        getUxArray: function getUxArray(id) {
	            return dataElementSelected.getUxArrayById(id);
	        }
	
	    }, _defineProperty(_Ext$create, 'accordionBody', accordionBody), _defineProperty(_Ext$create, 'panels', accordionPanels), _defineProperty(_Ext$create, 'treePanel', treePanel), _defineProperty(_Ext$create, 'getUiState', getUiState), _defineProperty(_Ext$create, 'setUiState', setUiState), _defineProperty(_Ext$create, 'onTypeClick', onTypeClick), _Ext$create));
	
	    return accordion;
	};
	//# sourceMappingURL=WestRegionTrackerItems.js.map

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Plugin = undefined;
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Plugin = exports.Plugin = undefined;
	
	exports.Plugin = Plugin = function Plugin(_ref) {
	    var refs = _ref.refs,
	        _ref$inits = _ref.inits,
	        inits = _ref$inits === undefined ? [] : _ref$inits,
	        renderFn = _ref.renderFn,
	        initializeFn = _ref.initializeFn,
	        type = _ref.type;
	
	    var t = this;
	
	    // public properties
	    t.url = null;
	    t.username = null;
	    t.password = null;
	    t.auth = null;
	    t.loadingIndicator = false;
	
	    // private properties
	    var _layouts = [];
	    var _isPending = false;
	    var _isReady = false;
	
	    // public functions
	    t.add = function () {
	        for (var _len = arguments.length, layouts = Array(_len), _key = 0; _key < _len; _key++) {
	            layouts[_key] = arguments[_key];
	        }
	
	        layouts = (0, _isArray2.default)(layouts[0]) ? layouts[0] : layouts;
	
	        if (layouts.length) {
	            _layouts = [].concat(_toConsumableArray(_layouts), _toConsumableArray(layouts));
	        }
	    };
	
	    t.load = function () {
	        for (var _len2 = arguments.length, layouts = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            layouts[_key2] = arguments[_key2];
	        }
	
	        t.add((0, _isArray2.default)(layouts[0]) ? layouts[0] : layouts);
	
	        _runFn();
	    };
	
	    t.getType = function () {
	        return type;
	    };
	
	    // private functions
	    var _readyFn = function _readyFn() {
	        _isReady = true;
	        _isPending = false;
	    };
	
	    var _pendingFn = function _pendingFn() {
	        _isPending = true;
	    };
	
	    var _runFn = function _runFn() {
	        var initializeFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initializeFn || _initializeFn;
	
	        if (_isReady) {
	            while (_layouts.length) {
	                renderFn(t, _layouts.shift());
	            }
	        } else if (!_isPending) {
	            _pendingFn();
	
	            initializeFn();
	        }
	    };
	
	    var _initializeFn = function _initializeFn() {
	        var readyFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _readyFn;
	        var runFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _runFn;
	        var appManager = refs.appManager,
	            requestManager = refs.requestManager,
	            init = refs.init;
	        var Request = refs.api.Request;
	
	
	        var credentials = t.username && t.password ? t.username + ':' + t.password : null;
	        var auth = t.auth;
	
	        appManager.setAuth(credentials, auth);
	        appManager.path = t.url;
	
	        // user account
	        new Request(refs, {
	            baseUrl: appManager.getApiPath() + '/me.json',
	            type: 'json',
	            param: ['fields=id,firstName,surname,userCredentials[username],settings'],
	            success: function success(response) {
	                appManager.userAccount = response;
	
	                // inits
	                inits.forEach(function (initFn) {
	                    return requestManager.add(new Request(refs, initFn(refs)));
	                });
	
	                readyFn();
	
	                requestManager.set(runFn);
	                requestManager.run();
	            }
	        }).run();
	    };
	};
	//# sourceMappingURL=Plugin.js.map

/***/ },
/* 168 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	/**
	 * Partial js port of commons math SimpleRegression class.
	 */
	
	var SimpleRegression = exports.SimpleRegression = undefined;
	
	exports.SimpleRegression = SimpleRegression = function SimpleRegression() {
	    var sumX = 0; // Sum of x values
	    var sumY = 0; // Sum of y values
	    var sumXX = 0; // Total variation in x
	    var sumXY = 0; // Sum of products
	    var n = 0; // Number of observations
	    var xbar = 0; // Mean of accumulated x values, used in updating formulas
	    var ybar = 0; // Mean of accumulated y values, used in updating formulas
	
	    this.addData = function (x, y) {
	        if (n == 0) {
	            xbar = x;
	            ybar = y;
	        } else {
	            var dx = x - xbar;
	            var dy = y - ybar;
	            sumXX += dx * dx * n / (n + 1);
	            sumXY += dx * dy * n / (n + 1);
	            xbar += dx / (n + 1);
	            ybar += dy / (n + 1);
	        }
	
	        sumX += x;
	        sumY += y;
	        n++;
	    };
	
	    this.predict = function (x) {
	        var b1 = this.getSlope();
	
	        return this.getIntercept(b1) + b1 * x;
	    };
	
	    this.getSlope = function () {
	        if (n < 2) {
	            return Number.NaN;
	        }
	
	        return sumXY / sumXX;
	    };
	
	    this.getIntercept = function (slope) {
	        return (sumY - slope * sumX) / n;
	    };
	};
	//# sourceMappingURL=SimpleRegression.js.map

/***/ },
/* 169 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var calculateColorBrightness = function calculateColorBrightness(rgb) {
	    return Math.round((parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) / 1000);
	};
	
	var isHex = function isHex(color) {
	    return typeof color === 'string' && color.charAt(0) === "#";
	};
	
	var isColorBright = exports.isColorBright = function isColorBright(color) {
	
	    if (isHex(color)) {
	        color = hexToRgb(color);
	    }
	
	    return calculateColorBrightness(color) > 125;
	};
	
	var hexToRgb = exports.hexToRgb = function hexToRgb(hex) {
	    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	
	    return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null;
	};
	//# sourceMappingURL=colorUtils.js.map

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (type) {
	    switch (type) {
	        case 'STRING':
	        case 'TEXT':
	            return function (item) {
	                return '' + item;
	            };
	        case 'INTEGER':
	        case 'NUMBER':
	            return function (item) {
	                return (0, _isNumeric2.default)(item) ? parseFloat(item) : item;
	            };
	        default:
	            return function (item) {
	                return item;
	            };
	    }
	};
	
	var _isNumeric = __webpack_require__(18);
	
	var _isNumeric2 = _interopRequireDefault(_isNumeric);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	//# sourceMappingURL=getParseMiddleware.js.map

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DataElementBooleanContainer = undefined;
	
	var _arrayDifference = __webpack_require__(39);
	
	var _arrayDifference2 = _interopRequireDefault(_arrayDifference);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _containerConfig = __webpack_require__(16);
	
	var _containerConfig2 = _interopRequireDefault(_containerConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataElementBooleanContainer = exports.DataElementBooleanContainer = undefined;
	
	exports.DataElementBooleanContainer = DataElementBooleanContainer = function DataElementBooleanContainer(refs) {
	    var i18n = refs.i18nManager.get();
	
	    Ext.define('Ext.ux.container.DataElementBooleanContainer', {
	        extend: 'Ext.container.Container',
	        alias: 'widget.dataelementbooleancontainer',
	        cls: 'ns-dxselector',
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        style: 'margin: ' + _containerConfig2.default.margin,
	        getRecord: function getRecord() {
	            var items = this.valueCmp.getValue(),
	                record = {
	                dimension: this.dataElement.id,
	                name: this.dataElement.name
	            };
	
	            // array or object
	            for (var i = 0; i < items.length; i++) {
	                if ((0, _isObject2.default)(items[i])) {
	                    items[i] = items[i].code;
	                }
	            }
	
	            if (items.length) {
	                record.filter = 'IN:' + items.join(';');
	            }
	
	            return record;
	        },
	        setRecord: function setRecord(record) {
	            if ((0, _isString2.default)(record.filter) && record.filter.length) {
	                var a = record.filter.split(':');
	                this.valueCmp.setOptionValues(a[1].split(';'));
	            }
	        },
	        getRecordsByCode: function getRecordsByCode(options, codeArray) {
	            var records = [];
	
	            for (var i = 0; i < options.length; i++) {
	                for (var j = 0; j < codeArray.length; j++) {
	                    if (options[i].code === codeArray[j]) {
	                        records.push(options[i]);
	                    }
	                }
	            }
	
	            return records;
	        },
	        initComponent: function initComponent() {
	            var container = this,
	                idProperty = 'id',
	                nameProperty = 'name';
	
	            this.nameCmp = Ext.create('Ext.form.Label', {
	                text: this.dataElement.name,
	                flex: 1,
	                style: 'padding:' + _containerConfig2.default.namePadding
	            });
	
	            this.addCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: 'padding: 0',
	                height: 18,
	                text: 'Duplicate',
	                handler: function handler() {
	                    container.duplicateDataElement();
	                }
	            });
	
	            this.removeCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: _containerConfig2.default.removeCmpStyle,
	                height: 18,
	                text: 'Remove',
	                handler: function handler() {
	                    container.removeDataElement();
	                }
	            });
	
	            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
	                valueField: 'id',
	                displayField: 'name',
	                queryMode: 'local',
	                editable: false,
	                style: 'margin-bottom:0',
	                width: _containerConfig2.default.operatorCmpWidth,
	                value: 'IN',
	                store: {
	                    fields: ['id', 'name'],
	                    data: [{ id: 'IN', name: 'One of' }]
	                }
	            });
	
	            this.getData = function (idArray) {
	                var data = [],
	                    yes = {},
	                    no = {};
	
	                yes[idProperty] = '1';
	                yes[nameProperty] = i18n.yes;
	                no[idProperty] = '0';
	                no[nameProperty] = i18n.no;
	
	                for (var i = 0; i < idArray.length; i++) {
	                    if (idArray[i] === '1' || idArray[i] === 1) {
	                        data.push(yes);
	                    } else if (idArray[i] === '0' || idArray[i] === 0) {
	                        data.push(no);
	                    }
	                }
	
	                return data;
	            };
	
	            this.searchStore = Ext.create('Ext.data.Store', {
	                fields: [idProperty, nameProperty],
	                data: container.getData(['1', '0'])
	            });
	
	            // function
	            this.filterSearchStore = function (isLayout) {
	                var selected = container.valueCmp.getValue();
	
	                // hack, using internal method to activate dropdown before filtering
	                if (isLayout) {
	                    container.searchCmp.onTriggerClick();
	                    container.searchCmp.collapse();
	                }
	
	                // filter
	                container.searchStore.clearFilter();
	
	                container.searchStore.filterBy(function (record) {
	                    return !(0, _arrayContains2.default)(selected, record.data[idProperty]);
	                });
	            };
	
	            this.searchCmp = Ext.create('Ext.form.field.ComboBox', {
	                multiSelect: true,
	                width: _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom:0',
	                emptyText: 'Select..',
	                valueField: idProperty,
	                displayField: nameProperty,
	                queryMode: 'local',
	                listConfig: {
	                    minWidth: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth
	                },
	                store: this.searchStore,
	                listeners: {
	                    select: function select() {
	                        var id = (0, _arrayFrom2.default)(this.getValue())[0];
	
	                        // value
	                        if (container.valueStore.findExact(idProperty, id) === -1) {
	                            container.valueStore.add(container.searchStore.getAt(container.searchStore.findExact(idProperty, id)).data);
	                        }
	
	                        // search
	                        this.select([]);
	
	                        // filter
	                        container.filterSearchStore();
	                    },
	                    expand: function expand() {
	                        container.filterSearchStore();
	                    }
	                }
	            });
	
	            this.valueStore = Ext.create('Ext.data.Store', {
	                fields: [idProperty, nameProperty],
	                listeners: {
	                    add: function add() {
	                        container.valueCmp.select(this.getRange());
	                    },
	                    remove: function remove() {
	                        container.valueCmp.select(this.getRange());
	                    }
	                }
	            });
	
	            this.valueCmp = Ext.create('Ext.form.field.ComboBox', {
	                multiSelect: true,
	                style: 'margin-bottom:0',
	                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.operatorCmpWidth,
	                valueField: idProperty,
	                displayField: nameProperty,
	                emptyText: 'No selected items',
	                editable: false,
	                hideTrigger: true,
	                store: container.valueStore,
	                queryMode: 'local',
	                listConfig: {
	                    minWidth: 266,
	                    cls: 'ns-optionselector'
	                },
	                setOptionValues: function setOptionValues(codeArray) {
	                    container.valueStore.removeAll();
	                    container.valueStore.loadData(container.getData(codeArray));
	
	                    this.setValue(codeArray);
	                    container.filterSearchStore(true);
	                    container.searchCmp.blur();
	                },
	                listeners: {
	                    change: function change(cmp, newVal, oldVal) {
	                        newVal = (0, _arrayFrom2.default)(newVal);
	                        oldVal = (0, _arrayFrom2.default)(oldVal);
	
	                        if (newVal.length < oldVal.length) {
	                            var id = (0, _arrayDifference2.default)(oldVal, newVal)[0];
	                            container.valueStore.removeAt(container.valueStore.findExact(idProperty, id));
	                        }
	                    }
	                }
	            });
	
	            this.items = [{
	                xtype: 'container',
	                layout: 'hbox',
	                width: _containerConfig2.default.nameCmpWidth,
	                items: [this.nameCmp,
	                //this.addCmp,
	                this.removeCmp]
	            }, this.operatorCmp, this.searchCmp, this.valueCmp];
	
	            this.self.superclass.initComponent.call(this);
	        }
	    });
	};
	//# sourceMappingURL=DataElementBooleanContainer.js.map

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DataElementDateContainer = undefined;
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _containerConfig = __webpack_require__(16);
	
	var _containerConfig2 = _interopRequireDefault(_containerConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataElementDateContainer = exports.DataElementDateContainer = undefined;
	
	exports.DataElementDateContainer = DataElementDateContainer = function DataElementDateContainer(refs) {
	    Ext.define('Ext.ux.container.DataElementDateContainer', {
	        extend: 'Ext.container.Container',
	        alias: 'widget.dataelementdatecontainer',
	        cls: 'ns-dxselector',
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        style: 'margin: ' + _containerConfig2.default.margin,
	        getRecord: function getRecord() {
	            var record = {};
	
	            record.dimension = this.dataElement.id;
	            record.name = this.dataElement.name;
	
	            if (this.valueCmp.getValue()) {
	                record.filter = this.operatorCmp.getValue() + ':' + this.valueCmp.getSubmitValue();
	            }
	
	            return record;
	        },
	        setRecord: function setRecord(record) {
	            if (record.filter && (0, _isString2.default)(record.filter)) {
	                var a = record.filter.split(':');
	
	                this.operatorCmp.setValue(a[0]);
	                this.valueCmp.setValue(a[1]);
	            }
	        },
	        initComponent: function initComponent() {
	            var container = this;
	
	            this.nameCmp = Ext.create('Ext.form.Label', {
	                text: this.dataElement.name,
	                flex: 1,
	                style: 'padding:' + _containerConfig2.default.namePadding
	            });
	
	            this.addCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: 'padding: 0',
	                height: 18,
	                text: 'Duplicate',
	                handler: function handler() {
	                    container.duplicateDataElement();
	                }
	            });
	
	            this.removeCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: _containerConfig2.default.removeCmpStyle,
	                height: 18,
	                text: 'Remove',
	                handler: function handler() {
	                    container.removeDataElement();
	                }
	            });
	
	            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
	                valueField: 'id',
	                displayField: 'name',
	                queryMode: 'local',
	                editable: false,
	                width: _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom:0',
	                value: 'EQ',
	                store: {
	                    fields: ['id', 'name'],
	                    data: [{ id: 'EQ', name: '=' }, { id: 'GT', name: '>' }, { id: 'GE', name: '>=' }, { id: 'LT', name: '<' }, { id: 'LE', name: '<=' }, { id: 'NE', name: '!=' }]
	                }
	            });
	
	            this.valueCmp = Ext.create('Ext.form.field.Date', {
	                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom:0',
	                format: 'Y-m-d'
	            });
	
	            this.items = [{
	                xtype: 'container',
	                layout: 'hbox',
	                width: _containerConfig2.default.nameCmpWidth,
	                items: [this.nameCmp, this.addCmp, this.removeCmp]
	            }, this.operatorCmp, this.valueCmp];
	
	            this.self.superclass.initComponent.call(this);
	        }
	    });
	};
	//# sourceMappingURL=DataElementDateContainer.js.map

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DataElementIntegerContainer = undefined;
	
	var _arrayDifference = __webpack_require__(39);
	
	var _arrayDifference2 = _interopRequireDefault(_arrayDifference);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _containerConfig = __webpack_require__(16);
	
	var _containerConfig2 = _interopRequireDefault(_containerConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataElementIntegerContainer = exports.DataElementIntegerContainer = undefined;
	
	exports.DataElementIntegerContainer = DataElementIntegerContainer = function DataElementIntegerContainer(refs) {
	    var appManager = refs.appManager;
	
	    var i18n = refs.i18nManager.get();
	
	    Ext.define('Ext.ux.container.DataElementIntegerContainer', {
	        extend: 'Ext.container.Container',
	        alias: 'widget.dataelementintegercontainer',
	        cls: 'ns-dxselector',
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        style: 'margin: ' + _containerConfig2.default.margin,
	        getRecord: function getRecord() {
	            var record = {},
	                rangeSet = this.rangeSetCmp.getValue();
	
	            var isRange = rangeSet !== _containerConfig2.default.defaultRangeSetId;
	
	            record.dimension = this.dataElement.id;
	            record.name = this.dataElement.name;
	
	            if (isRange) {
	                record.legendSet = {
	                    id: rangeSet
	                };
	
	                var ranges = this.rangeValueCmp.getValue();
	
	                if (ranges.length) {
	                    record.filter = 'IN:' + ranges.join(';');
	                }
	            } else {
	                if (this.valueCmp.getValue()) {
	                    record.filter = this.operatorCmp.getValue() + ':' + this.valueCmp.getValue();
	                }
	            }
	
	            return record;
	        },
	        setRecord: function setRecord(record) {
	            if ((0, _isObject2.default)(record.legendSet) && record.legendSet.id) {
	                //this.rangeSetCmp.pendingValue = record.legendSet.id;
	                this.rangeSetCmp.store.add(appManager.getLegendSetById(record.legendSet.id));
	                this.rangeSetCmp.setValue(record.legendSet.id);
	
	                this.onRangeSetSelect(record.legendSet.id);
	
	                if (record.filter) {
	                    var a = record.filter.split(':');
	
	                    if (a.length > 1 && (0, _isString2.default)(a[1])) {
	                        this.onRangeSearchSelect(a[1].split(';'), true);
	                    }
	                }
	            } else {
	                this.rangeSetCmp.setValue(_containerConfig2.default.defaultRangeSetId);
	                this.onRangeSetSelect(_containerConfig2.default.defaultRangeSetId);
	
	                if (record.filter) {
	                    var a = record.filter.split(':');
	
	                    if (a.length > 1) {
	                        this.operatorCmp.setValue(a[0]);
	                        this.valueCmp.setValue(a[1]);
	                    }
	                }
	            }
	        },
	        initComponent: function initComponent() {
	            var container = this,
	                idProperty = 'id',
	                nameProperty = 'name',
	                displayProperty = 'displayName';
	
	            this.nameCmp = Ext.create('Ext.form.Label', {
	                text: this.dataElement.name,
	                flex: 1,
	                style: 'padding:' + _containerConfig2.default.namePadding
	            });
	
	            this.addCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: 'padding: 0',
	                height: 18,
	                text: i18n.duplicate,
	                handler: function handler() {
	                    container.duplicateDataElement();
	                }
	            });
	
	            this.removeCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: _containerConfig2.default.removeCmpStyle,
	                height: 18,
	                text: i18n.remove,
	                handler: function handler() {
	                    container.removeDataElement();
	                }
	            });
	
	            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
	                valueField: idProperty,
	                displayField: nameProperty,
	                queryMode: 'local',
	                editable: false,
	                width: _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom:0',
	                value: 'EQ',
	                store: {
	                    fields: [idProperty, nameProperty],
	                    data: [{ id: 'EQ', name: '=' }, { id: 'GT', name: '>' }, { id: 'GE', name: '>=' }, { id: 'LT', name: '<' }, { id: 'LE', name: '<=' }, { id: 'NE', name: '!=' }]
	                }
	            });
	
	            this.valueCmp = Ext.create('Ext.form.field.Number', {
	                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.rangeSetWidth,
	                style: 'margin-bottom:0'
	            });
	
	            this.rangeSearchStore = Ext.create('Ext.data.Store', {
	                fields: [idProperty, nameProperty]
	            });
	
	            // function
	            this.filterSearchStore = function (isLayout) {
	                var selected = container.rangeValueCmp.getValue();
	
	                // hack, using internal method to activate dropdown before filtering
	                if (isLayout) {
	                    container.rangeSearchCmp.onTriggerClick();
	                    container.rangeSearchCmp.collapse();
	                }
	
	                // filter
	                container.rangeSearchStore.clearFilter();
	
	                container.rangeSearchStore.filterBy(function (record) {
	                    return !(0, _arrayContains2.default)(selected, record.data[idProperty]);
	                });
	            };
	
	            // function
	            this.onRangeSearchSelect = function (ids, isLayout) {
	                ids = (0, _arrayFrom2.default)(ids);
	
	                // store
	                for (var i = 0, id; i < ids.length; i++) {
	                    id = ids[i];
	
	                    if (container.rangeValueStore.findExact(idProperty, id) === -1) {
	                        container.rangeValueStore.add(container.rangeSearchStore.getAt(container.rangeSearchStore.findExact(idProperty, id)).data);
	                    }
	                }
	
	                // search cmp
	                container.rangeSearchCmp.select([]);
	
	                // filter
	                container.filterSearchStore(isLayout);
	            };
	
	            this.rangeSearchCmp = Ext.create('Ext.form.field.ComboBox', {
	                multiSelect: true,
	                width: _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom: 0',
	                emptyText: i18n.select + '..',
	                valueField: idProperty,
	                displayField: displayProperty,
	                editable: false,
	                queryMode: 'local',
	                hidden: true,
	                store: this.rangeSearchStore,
	                listConfig: {
	                    minWidth: _containerConfig2.default.operatorCmpWidth + (_containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.rangeSetWidth)
	                },
	                listeners: {
	                    select: function select() {
	                        container.onRangeSearchSelect((0, _arrayFrom2.default)(this.getValue())[0]);
	                    },
	                    expand: function expand() {
	                        container.filterSearchStore();
	                    }
	                }
	            });
	
	            this.rangeValueStore = Ext.create('Ext.data.Store', {
	                fields: [idProperty, nameProperty],
	                listeners: {
	                    add: function add() {
	                        container.rangeValueCmp.select(this.getRange());
	                    },
	                    remove: function remove() {
	                        container.rangeValueCmp.select(this.getRange());
	                    }
	                }
	            });
	
	            this.rangeValueCmp = Ext.create('Ext.form.field.ComboBox', {
	                multiSelect: true,
	                style: 'margin-bottom: 0',
	                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.rangeSetWidth,
	                valueField: idProperty,
	                displayField: nameProperty,
	                emptyText: 'No selected items',
	                editable: false,
	                hideTrigger: true,
	                queryMode: 'local',
	                hidden: true,
	                store: container.rangeValueStore,
	                listConfig: {
	                    minWidth: _containerConfig2.default.valueCmpWidth,
	                    cls: 'ns-optionselector'
	                },
	                setOptionValues: function setOptionValues(records) {
	                    var me = this;
	
	                    container.rangeValueStore.removeAll();
	                    container.rangeValueStore.loadData(records);
	
	                    me.setValue(records);
	                },
	                listeners: {
	                    change: function change(cmp, newVal, oldVal) {
	                        newVal = (0, _arrayFrom2.default)(newVal);
	                        oldVal = (0, _arrayFrom2.default)(oldVal);
	
	                        if (newVal.length < oldVal.length) {
	                            var id = (0, _arrayDifference2.default)(oldVal, newVal)[0];
	                            container.rangeValueStore.removeAt(container.rangeValueStore.findExact(idProperty, id));
	                        }
	                    }
	                }
	            });
	
	            // function
	            this.onRangeSetSelect = function (id) {
	                if (!id || id === _containerConfig2.default.defaultRangeSetId) {
	                    container.operatorCmp.show();
	                    container.valueCmp.show();
	                    container.rangeSearchCmp.hide();
	                    container.rangeValueCmp.hide();
	                } else {
	                    container.operatorCmp.hide();
	                    container.valueCmp.hide();
	                    container.rangeSearchCmp.show();
	                    container.rangeValueCmp.show();
	
	                    // legend display name
	                    var legends = appManager.getLegendSetById(id).legends.slice();
	
	                    legends.forEach(function (legend) {
	                        legend.displayName = legend.name + ' (' + legend.startValue + ' - ' + legend.endValue + ')';
	                    });
	
	                    container.rangeSearchStore.loadData(legends);
	                    container.rangeSearchStore.sort('startValue', 'ASC');
	                }
	            };
	
	            this.rangeSetCmp = Ext.create('Ext.form.field.ComboBox', {
	                cls: 'ns-combo h22',
	                style: 'margin-bottom: 0',
	                width: _containerConfig2.default.rangeSetWidth,
	                height: 22,
	                fieldStyle: 'height: 22px',
	                queryMode: 'local',
	                valueField: idProperty,
	                displayField: nameProperty,
	                editable: false,
	                storage: {},
	                pendingValue: null,
	                setPendingValue: function setPendingValue() {
	                    if (this.pendingValue) {
	                        this.setValue(this.pendingValue);
	                        container.onRangeSetSelect(this.pendingValue);
	
	                        this.pendingValue = null;
	                    }
	
	                    if (!this.getValue()) {
	                        this.pendingValue = _containerConfig2.default.defaultRangeSetId;
	                        this.setPendingValue();
	                    }
	                },
	                store: Ext.create('Ext.data.Store', {
	                    fields: [idProperty, nameProperty]
	                }),
	                listeners: {
	                    added: function added(cb) {
	                        cb.store.add({
	                            id: _containerConfig2.default.defaultRangeSetId,
	                            name: 'No range set'
	                        });
	
	                        var legendSetRecords = container.dataElement.legendSets || container.dataElement.storageLegendSets;
	
	                        if ((0, _isArray2.default)(legendSetRecords) && legendSetRecords.length) {
	
	                            // add legendsets to store
	                            cb.store.add(legendSetRecords.map(function (record) {
	                                return appManager.getLegendSetById(record.id);
	                            }).filter(function (legendSet) {
	                                return (0, _isObject2.default)(legendSet);
	                            }));
	
	                            // select first legendset
	                            cb.setValue(legendSetRecords[0].id);
	                            container.onRangeSetSelect(legendSetRecords[0].id);
	                        }
	
	                        cb.setPendingValue();
	                    },
	                    select: function select(cb, r) {
	                        var id = (0, _arrayFrom2.default)(r)[0].data.id;
	                        container.onRangeSetSelect(id);
	                    }
	                }
	            });
	
	            this.items = [{
	                xtype: 'container',
	                layout: 'hbox',
	                width: _containerConfig2.default.nameCmpWidth,
	                items: [this.nameCmp, this.addCmp, this.removeCmp]
	            }, this.rangeSearchCmp, this.rangeValueCmp, this.operatorCmp, this.valueCmp, this.rangeSetCmp];
	
	            this.self.superclass.initComponent.call(this);
	        }
	    });
	};
	//# sourceMappingURL=DataElementIntegerContainer.js.map

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DataElementStringContainer = undefined;
	
	var _containerConfig = __webpack_require__(16);
	
	var _containerConfig2 = _interopRequireDefault(_containerConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataElementStringContainer = exports.DataElementStringContainer = undefined;
	
	exports.DataElementStringContainer = DataElementStringContainer = function DataElementStringContainer(refs) {
	    Ext.define('Ext.ux.container.DataElementStringContainer', {
	        extend: 'Ext.container.Container',
	        alias: 'widget.dataelementstringcontainer',
	        cls: 'ns-dxselector',
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        style: 'margin: ' + _containerConfig2.default.margin,
	        getRecord: function getRecord() {
	            var record = {};
	
	            record.dimension = this.dataElement.id;
	            record.name = this.dataElement.name;
	
	            if (this.valueCmp.getValue()) {
	                record.filter = this.operatorCmp.getValue() + ':' + this.valueCmp.getValue();
	            }
	
	            return record;
	        },
	        setRecord: function setRecord(record) {
	            this.operatorCmp.setValue(record.operator);
	            this.valueCmp.setValue(record.filter);
	        },
	        initComponent: function initComponent() {
	            var container = this;
	
	            this.nameCmp = Ext.create('Ext.form.Label', {
	                text: this.dataElement.name,
	                flex: 1,
	                style: 'padding:' + _containerConfig2.default.namePadding
	            });
	
	            this.addCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: 'padding: 0',
	                height: 18,
	                text: 'Duplicate',
	                handler: function handler() {
	                    container.duplicateDataElement();
	                }
	            });
	
	            this.removeCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: _containerConfig2.default.removeCmpStyle,
	                height: 18,
	                text: 'Remove',
	                handler: function handler() {
	                    container.removeDataElement();
	                }
	            });
	
	            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
	                valueField: 'id',
	                displayField: 'name',
	                queryMode: 'local',
	                editable: false,
	                width: _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom:0',
	                value: 'LIKE',
	                store: {
	                    fields: ['id', 'name'],
	                    data: [{ id: 'LIKE', name: 'Contains' }, { id: 'EQ', name: 'Is exact' }]
	                }
	            });
	
	            this.valueCmp = Ext.create('Ext.form.field.Text', {
	                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth,
	                style: 'margin-bottom:0'
	            });
	
	            this.items = [{
	                xtype: 'container',
	                layout: 'hbox',
	                width: _containerConfig2.default.nameCmpWidth,
	                items: [this.nameCmp,
	                //this.addCmp,
	                this.removeCmp]
	            }, this.operatorCmp, this.valueCmp];
	
	            this.self.superclass.initComponent.call(this);
	        }
	    });
	};
	//# sourceMappingURL=DataElementStringContainer.js.map

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GroupSetContainer = undefined;
	
	var _arrayDifference = __webpack_require__(39);
	
	var _arrayDifference2 = _interopRequireDefault(_arrayDifference);
	
	var _arrayFrom = __webpack_require__(5);
	
	var _arrayFrom2 = _interopRequireDefault(_arrayFrom);
	
	var _arrayContains = __webpack_require__(4);
	
	var _arrayContains2 = _interopRequireDefault(_arrayContains);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(2);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(3);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _containerConfig = __webpack_require__(16);
	
	var _containerConfig2 = _interopRequireDefault(_containerConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupSetContainer = exports.GroupSetContainer = undefined;
	
	exports.GroupSetContainer = GroupSetContainer = function GroupSetContainer(refs) {
	    var api = refs.api,
	        appManager = refs.appManager;
	
	
	    var defaultPageSize = 100;
	
	    Ext.define('Ext.ux.container.GroupSetContainer', {
	        extend: 'Ext.container.Container',
	        alias: 'widget.groupsetcontainer',
	        cls: 'ns-dxselector',
	        layout: 'column',
	        bodyStyle: 'border:0 none',
	        style: 'margin: ' + _containerConfig2.default.margin,
	        getRecord: function getRecord() {
	            var items = this.valueCmp.getValue(),
	                record = {
	                dimension: this.dataElement.id,
	                name: this.dataElement.name
	            };
	
	            // array or object
	            for (var i = 0; i < items.length; i++) {
	                if ((0, _isObject2.default)(items[i])) {
	                    items[i] = items[i].code;
	                }
	            }
	
	            if (items.length) {
	                record.filter = 'IN:' + items.join(';');
	            }
	
	            return record;
	        },
	        setRecord: function setRecord(record) {
	            if ((0, _isString2.default)(record.filter) && record.filter.length) {
	                var a = record.filter.split(':');
	                this.valueCmp.setOptionValues(a[1].split(';'));
	            }
	        },
	        getOptionSetOptions: function getOptionSetOptions(optionSetId, filters, limit, callbackFn) {
	            var params = ['filter=optionSet.id:eq:' + optionSetId, 'fields=code,name'];
	
	            if (limit) {
	                params.push('pageSize=' + defaultPageSize);
	            }
	
	            if (filters) {
	                filters.forEach(function (filter) {
	                    return params.push('filter=' + filter);
	                });
	            }
	
	            new api.Request(refs, {
	                baseUrl: appManager.getApiPath() + '/options.json',
	                params: params,
	                success: callbackFn
	            }).run();
	        },
	        initComponent: function initComponent() {
	            var container = this,
	                idProperty = 'code',
	                nameProperty = 'name';
	
	            this.nameCmp = Ext.create('Ext.form.Label', {
	                text: this.dataElement.name,
	                flex: 1,
	                style: 'padding:' + _containerConfig2.default.namePadding
	            });
	
	            this.addCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: 'padding: 0',
	                height: 18,
	                text: 'Duplicate',
	                handler: function handler() {
	                    container.duplicateDataElement();
	                }
	            });
	
	            this.removeCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-linkbutton',
	                style: _containerConfig2.default.removeCmpStyle,
	                height: 18,
	                text: 'Remove',
	                handler: function handler() {
	                    container.removeDataElement();
	                }
	            });
	
	            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
	                valueField: 'id',
	                displayField: 'name',
	                queryMode: 'local',
	                editable: false,
	                style: 'margin-bottom:0',
	                width: _containerConfig2.default.operatorCmpWidth,
	                value: 'IN',
	                store: {
	                    fields: ['id', 'name'],
	                    data: [{ id: 'IN', name: 'One of' }]
	                }
	            });
	
	            this.searchStore = Ext.create('Ext.data.Store', {
	                fields: [idProperty, nameProperty],
	                data: [],
	                loadOptionSet: function loadOptionSet(optionSetId, filters, pageSize) {
	                    var store = this;
	
	                    optionSetId = optionSetId || container.dataElement.optionSet.id;
	                    pageSize = pageSize || defaultPageSize;
	
	                    container.getOptionSetOptions(optionSetId, filters, true, function (_ref) {
	                        var options = _ref.options;
	
	                        if ((0, _isArray2.default)(options) && options.length) {
	                            store.loadData(options.slice(0, pageSize));
	                        }
	                    });
	                },
	                listeners: {
	                    datachanged: function datachanged(s) {
	                        if (container.searchCmp && s.getRange().length) {
	                            container.searchCmp.expand();
	                        }
	                    }
	                }
	            });
	
	            // function
	            this.filterSearchStore = function () {
	                var selected = container.valueCmp.getValue();
	
	                container.searchStore.clearFilter();
	
	                container.searchStore.filterBy(function (record) {
	                    return !(0, _arrayContains2.default)(selected, record.data[idProperty]);
	                });
	            };
	
	            this.searchCmp = Ext.create('Ext.form.field.ComboBox', {
	                multiSelect: true,
	                width: _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.triggerCmpWidth,
	                style: 'margin-bottom:0',
	                emptyText: 'Search..',
	                valueField: idProperty,
	                displayField: nameProperty,
	                hideTrigger: true,
	                enableKeyEvents: true,
	                queryMode: 'local',
	                lastQuery: '',
	                listConfig: {
	                    minWidth: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth
	                },
	                store: this.searchStore,
	                listeners: {
	                    keyup: function keyup() {
	                        var value = this.getValue(),
	                            optionSetId = container.dataElement.optionSet.id;
	
	                        // search
	                        container.searchStore.loadOptionSet(optionSetId, ['name:ilike:' + value]);
	
	                        // trigger
	                        if (!value || (0, _isString2.default)(value) && value.length === 1) {
	                            container.triggerCmp.setDisabled(!!value);
	                        }
	                    },
	                    select: function select() {
	                        var id = (0, _arrayFrom2.default)(this.getValue())[0];
	
	                        // value
	                        if (container.valueStore.findExact(idProperty, id) === -1) {
	                            container.valueStore.add(container.searchStore.getAt(container.searchStore.findExact(idProperty, id)).data);
	                        }
	
	                        // search
	                        this.select([]);
	
	                        // filter
	                        container.filterSearchStore();
	
	                        // trigger
	                        container.triggerCmp.enable();
	                    },
	                    expand: function expand() {
	                        container.filterSearchStore();
	                    }
	                }
	            });
	
	            this.triggerCmp = Ext.create('Ext.button.Button', {
	                cls: 'ns-button-combotrigger',
	                disabledCls: 'ns-button-combotrigger-disabled',
	                width: _containerConfig2.default.triggerCmpWidth,
	                height: 22,
	                handler: function handler(b) {
	                    container.searchStore.loadOptionSet();
	                }
	            });
	
	            this.valueStore = Ext.create('Ext.data.Store', {
	                fields: [idProperty, nameProperty],
	                listeners: {
	                    add: function add() {
	                        container.valueCmp.select(this.getRange());
	                    },
	                    remove: function remove() {
	                        container.valueCmp.select(this.getRange());
	                    }
	                }
	            });
	
	            this.valueCmp = Ext.create('Ext.form.field.ComboBox', {
	                multiSelect: true,
	                style: 'margin-bottom:0',
	                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.operatorCmpWidth,
	                valueField: idProperty,
	                displayField: nameProperty,
	                emptyText: 'No selected items',
	                editable: false,
	                hideTrigger: true,
	                store: container.valueStore,
	                queryMode: 'local',
	                listConfig: {
	                    minWidth: 266,
	                    cls: 'ns-optionselector'
	                },
	                setOptionValues: function setOptionValues(codeArray) {
	                    var me = this,
	                        records = [];
	
	                    var filter = 'code:in:[' + codeArray.join(',') + ']';
	
	                    container.getOptionSetOptions(container.dataElement.optionSet.id, [filter], false, // no limit
	                    function (_ref2) {
	                        var options = _ref2.options;
	
	                        if ((0, _isArray2.default)(options) && options.length) {
	                            container.valueStore.loadData(options);
	
	                            me.setValue(options);
	                        }
	                    });
	                },
	                listeners: {
	                    change: function change(cmp, newVal, oldVal) {
	                        newVal = (0, _arrayFrom2.default)(newVal);
	                        oldVal = (0, _arrayFrom2.default)(oldVal);
	
	                        if (newVal.length < oldVal.length) {
	                            var id = (0, _arrayDifference2.default)(oldVal, newVal)[0];
	                            container.valueStore.removeAt(container.valueStore.findExact(idProperty, id));
	                        }
	                    }
	                }
	            });
	
	            this.items = [{
	                xtype: 'container',
	                layout: 'hbox',
	                width: _containerConfig2.default.nameCmpWidth,
	                items: [this.nameCmp,
	                //this.addCmp,
	                this.removeCmp]
	            }, this.operatorCmp, this.searchCmp, this.triggerCmp, this.valueCmp];
	
	            this.self.superclass.initComponent.call(this);
	        }
	    });
	};
	//# sourceMappingURL=GroupSetContainer.js.map

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LimitContainer = undefined;
	
	var _isNumber = __webpack_require__(9);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LimitContainer = exports.LimitContainer = undefined;
	
	exports.LimitContainer = LimitContainer = function LimitContainer(refs) {
	    var i18n = refs.i18nManager.get();
	
	    Ext.define('Ext.ux.container.LimitContainer', {
	        extend: 'Ext.container.Container',
	        alias: 'widget.limitcontainer',
	        layout: 'hbox',
	        sortOrder: null,
	        topLimit: null,
	        comboboxWidth: null,
	        comboBottomMargin: null,
	        onCheckboxChange: function onCheckboxChange(value) {
	            this.sortOrderCmp.setDisabled(!value);
	            this.topLimitCmp.setDisabled(!value);
	        },
	        getSortOrder: function getSortOrder() {
	            return this.activateCmp.getValue() ? this.sortOrderCmp.getValue() : 0;
	        },
	        getTopLimit: function getTopLimit() {
	            return this.activateCmp.getValue() ? this.topLimitCmp.getValue() : 0;
	        },
	        setValues: function setValues(sortOrder, topLimit) {
	            sortOrder = parseInt(sortOrder);
	            topLimit = parseInt(topLimit);
	
	            if ((0, _isNumber2.default)(sortOrder)) {
	                this.sortOrderCmp.setValue(sortOrder);
	            } else {
	                this.sortOrderCmp.reset();
	            }
	
	            if ((0, _isNumber2.default)(topLimit)) {
	                this.topLimitCmp.setValue(topLimit);
	            } else {
	                this.topLimitCmp.reset();
	            }
	
	            this.activateCmp.setValue(!!(sortOrder > 0 && topLimit > 0));
	        },
	        initComponent: function initComponent() {
	            var container = this,
	                activateWidth = 135,
	                sortWidth = (this.comboboxWidth - activateWidth) / 2;
	
	            this.activateCmp = Ext.create('Ext.form.field.Checkbox', {
	                boxLabel: container.boxLabel,
	                width: activateWidth,
	                style: 'margin-bottom:4px',
	                listeners: {
	                    change: function change(cmp, newValue) {
	                        container.onCheckboxChange(newValue);
	                    }
	                }
	            });
	
	            this.sortOrderCmp = Ext.create('Ext.form.field.ComboBox', {
	                cls: 'ns-combo',
	                style: 'margin-bottom:' + container.comboBottomMargin + 'px',
	                width: sortWidth,
	                queryMode: 'local',
	                valueField: 'id',
	                editable: false,
	                value: container.sortOrder,
	                store: Ext.create('Ext.data.Store', {
	                    fields: ['id', 'text'],
	                    data: [{ id: -1, text: i18n.bottom }, { id: 1, text: i18n.top }]
	                })
	            });
	
	            this.topLimitCmp = Ext.create('Ext.form.field.Number', {
	                width: sortWidth - 1,
	                style: 'margin-bottom:' + container.comboBottomMargin + 'px; margin-left:1px',
	                minValue: 1,
	                maxValue: 10000,
	                value: container.topLimit,
	                allowBlank: false
	            });
	
	            this.items = [this.activateCmp, this.sortOrderCmp, this.topLimitCmp];
	
	            this.self.superclass.initComponent.call(this);
	        },
	        listeners: {
	            render: function render() {
	                this.onCheckboxChange(false);
	            }
	        }
	    });
	};
	//# sourceMappingURL=LimitContainer.js.map

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.StatusBar = undefined;
	
	var _arrayMin = __webpack_require__(179);
	
	var _arrayMin2 = _interopRequireDefault(_arrayMin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatusBar = exports.StatusBar = undefined;
	
	exports.StatusBar = StatusBar = function StatusBar(refs) {
	    var instanceManager = refs.instanceManager,
	        dimensionConfig = refs.dimensionConfig;
	
	
	    var aggregated_values = dimensionConfig.dataType['aggregated_values'];
	    var individual_cases = dimensionConfig.dataType['individual_cases'];
	
	    Ext.define('Ext.ux.toolbar.StatusBar', {
	        extend: 'Ext.toolbar.Toolbar',
	        alias: 'widget.statusbar',
	        queryCmps: [],
	        showHideQueryCmps: function showHideQueryCmps(fnName) {
	            this.queryCmps.forEach(function (cmp) {
	                cmp[fnName]();
	            });
	        },
	        setStatus: function setStatus(layout, response) {
	            this.pager = response.metaData.pager;
	
	            this.reset(layout.dataType);
	
	            if (layout.dataType === aggregated_values) {
	                this.statusCmp.setText(response.rows.length + ' values');
	                return;
	            }
	
	            if (layout.dataType === individual_cases) {
	                var maxVal = this.pager.page * this.pager.pageSize,
	                    from = maxVal - this.pager.pageSize + 1,
	                    to = (0, _arrayMin2.default)([maxVal, this.pager.total]);
	
	                this.pageCmp.setValue(this.pager.page);
	                this.pageCmp.setMaxValue(this.pager.pageCount);
	                this.totalPageCmp.setText(' of ' + this.pager.pageCount);
	                this.statusCmp.setText(from + '-' + to + ' of ' + this.pager.total + ' cases');
	                return;
	            }
	        },
	        reset: function reset(dataType) {
	            if (!dataType || dataType === aggregated_values) {
	                this.showHideQueryCmps('hide');
	                this.pageCmp.setValue(1);
	                this.totalPageCmp.setText('');
	                this.statusCmp.setText('');
	                return;
	            }
	
	            if (dataType === individual_cases) {
	                this.showHideQueryCmps('show');
	                this.pageCmp.setValue(1);
	                this.totalPageCmp.setText(' of 1');
	                this.statusCmp.setText('');
	            }
	        },
	        getCurrentPage: function getCurrentPage() {
	            return this.pageCmp.getValue();
	        },
	        getPageCount: function getPageCount() {
	            return this.pageCount;
	        },
	        onPageChange: function onPageChange(page, currentPage) {
	            currentPage = currentPage || this.getCurrentPage();
	
	            if (page && page >= 1 && page <= this.pager.pageCount && page != currentPage) {
	                var layout = instanceManager.getStateCurrent();
	
	                layout.paging.page = page;
	                layout.setResponse(null);
	
	                this.pageCmp.setValue(page);
	                instanceManager.getReport(layout);
	            }
	        },
	        initComponent: function initComponent() {
	            var container = this,
	                size = this.pageSize;
	
	            this.firstCmp = Ext.create('Ext.button.Button', {
	                text: '<<',
	                handler: function handler() {
	                    container.onPageChange(1);
	                }
	            });
	            this.queryCmps.push(this.firstCmp);
	
	            this.prevCmp = Ext.create('Ext.button.Button', {
	                text: '<',
	                handler: function handler() {
	                    container.onPageChange(container.getCurrentPage() - 1);
	                }
	            });
	            this.queryCmps.push(this.prevCmp);
	
	            this.pageTextCmp = Ext.create('Ext.toolbar.TextItem', {
	                text: 'Page ',
	                style: 'line-height:21px'
	            });
	            this.queryCmps.push(this.pageTextCmp);
	
	            this.pageCmp = Ext.create('Ext.form.field.Number', {
	                width: 34,
	                height: 21,
	                minValue: 1,
	                value: 1,
	                hideTrigger: true,
	                enableKeyEvents: true,
	                currentPage: 1,
	                listeners: {
	                    render: function render() {
	                        Ext.get(this.getInputId()).setStyle('padding-top', '2px');
	                    },
	                    keyup: {
	                        fn: function fn(cmp) {
	                            var currentPage = cmp.currentPage;
	
	                            cmp.currentPage = cmp.getValue();
	
	                            container.onPageChange(cmp.getValue(), currentPage);
	                        },
	                        buffer: 200
	                    }
	                }
	            });
	            this.queryCmps.push(this.pageCmp);
	
	            this.totalPageCmp = Ext.create('Ext.toolbar.TextItem', {
	                text: '',
	                style: 'line-height:21px'
	            });
	            this.queryCmps.push(this.totalPageCmp);
	
	            this.nextCmp = Ext.create('Ext.button.Button', {
	                text: '>',
	                handler: function handler() {
	                    container.onPageChange(container.getCurrentPage() + 1);
	                }
	            });
	            this.queryCmps.push(this.nextCmp);
	
	            this.lastCmp = Ext.create('Ext.button.Button', {
	                text: '>>',
	                handler: function handler() {
	                    container.onPageChange(container.pager.pageCount);
	                }
	            });
	            this.queryCmps.push(this.lastCmp);
	
	            this.statusCmp = Ext.create('Ext.toolbar.TextItem', {
	                text: '',
	                style: 'line-height:21px'
	            });
	
	            this.items = [this.statusCmp, this.firstCmp, this.prevCmp, this.pageTextCmp, this.pageCmp, this.totalPageCmp, this.nextCmp, this.lastCmp, '->', this.statusCmp];
	
	            this.self.superclass.initComponent.call(this);
	        }
	    });
	};
	//# sourceMappingURL=StatusBar.js.map

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = arrayInsert;
	
	var _arrayReplace = __webpack_require__(181);
	
	var _arrayReplace2 = _interopRequireDefault(_arrayReplace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Insert a value into an array
	 *
	 * @param {Array} array The array to insert the items into
	 * @param {number} index The index where to insert the values
	 * @param {*} items The item(s) to insert
	 * @returns {Array} The resulting array with the inserted `items`
	 *
	 * @example
	 * const sourceArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	 * sourceArray, undefined, ['a', 'b', 'c']); // Returns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 'a', 'b', 'c']
	 */
	function arrayInsert(array, index, items) {
	  return (0, _arrayReplace2.default)(array, index, 0, items);
	}
	//# sourceMappingURL=arrayInsert.js.map

/***/ },
/* 179 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayMin;
	/**
	 * Return the lowest value (number) in the given array
	 *
	 * @param {Array} array The array to be scanned
	 * @returns {Array} The lowest value
	 *
	 * @throws {TypeError} When the passed array is not actually an array.
	 *
	 * @example
	 * const sourceArray = [3,1,2];
	 * arrayMax(sourceArray); // Returns: 1
	 *
	 * @example
	 * arrayClean() // throws: Cannot read property 'length' of undefined
	 */
	function arrayMin(array, comparisonFn) {
	    var i = 0,
	        ln = array.length,
	        item,
	        min = array[0];
	
	    for (; i < ln; i++) {
	        item = array[i];
	
	        if (comparisonFn) {
	            if (comparisonFn(min, item) === 1) {
	                min = item;
	            }
	        } else {
	            if (item < min) {
	                min = item;
	            }
	        }
	    }
	
	    return min;
	}
	//# sourceMappingURL=arrayMin.js.map

/***/ },
/* 180 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayRepeat;
	/**
	 * 
	 * Repeats content of array by structure or by index, returns flattened array.
	 * 
	 * @param   {array}   array 
	 * @param   {number}  n 
	 * @param   {boolean} [byIndex=false] 
	 * @returns {array}
	 *
	 * @example
	 * const values = [1, 2, 3];
	 * arrayRepeat(values, 3) // returns: [1, 2, 3, 1, 2, 3, 1, 2, 3]
	 *
	 * @example
	 * const values = [1, 2, 3];
	 * arrayRepeat(values, 3, true) // returns: [1, 1, 1, 2, 2, 2, 3, 3, 3]
	 */
	function arrayRepeat(array) {
	    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	    var byIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (typeof array === 'undefined') {
	        throw 'Cannot repeat array of type undefined';
	    }
	
	    if (byIndex) {
	        return [].concat.apply([], array.map(function (item, i) {
	            return Array(n).fill(array[i]);
	        }));
	    }
	    return [].concat.apply([], Array.apply(null, Array(n)).map(function () {
	        return array;
	    }));
	};
	//# sourceMappingURL=arrayRepeat.js.map

/***/ },
/* 181 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayReplace;
	/**
	 * Replace values in an array with given values or remove values from an array.
	 *
	 * @param {Array} array The array where the values should be replaced
	 * @param {number} index The index in the array where to start the replacement
	 * @param {number} removeCount The number of items to remove
	 * @param {*} insert The item(s) to be inserted
	 * @returns {Array} The array with the replaced values
	 *
	 * @example
	 * const sourceArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	 * arrayReplace(sourceArray, 0, 5, ['a', 'b', 'c', 'd']); // Returns: ['a', 'b', 'c', 'd', 6, 7, 8, 9, 10]
	 */
	function arrayReplace(array, index, removeCount, insert) {
	    if (insert && insert.length) {
	        if (index < array.length) {
	            array.splice.apply(array, [index, removeCount].concat(insert));
	        } else {
	            array.push.apply(array, insert);
	        }
	    } else {
	        array.splice(index, removeCount);
	    }
	    return array;
	}
	//# sourceMappingURL=arrayReplace.js.map

/***/ },
/* 182 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = isIE;
	/**
	 * Check if the users browser is a version of Internet Explorer
	 *
	 * @param [ua] The users user-agent string.
	 * @returns {boolean|number} Returns the version number (10, 11, 12) when the browser is IE, otherwise `false`
	 *
	 * @example
	 * // When using IE10
	 * isIE(); // Returns: 10
	 *
	 * // When using FireFox
	 * isIE(); // Returns: false
	 *
	 * TODO: It is not very good practice to return two different types of values from a function. Perhaps we can return `true` on IE and have a secondary function to get the version?
	 */
	function isIE() {
	    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
	
	    // test values
	    // IE 10: ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
	    // IE 11: ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
	    // IE 12 / Spartan: ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
	
	    var msie = ua.indexOf('MSIE ');
	    if (msie > 0) {
	        // IE 10 or older => return version number
	        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	    }
	
	    var trident = ua.indexOf('Trident/');
	    if (trident > 0) {
	        // IE 11 => return version number
	        var rv = ua.indexOf('rv:');
	        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	    }
	
	    var edge = ua.indexOf('Edge/');
	    if (edge > 0) {
	        // IE 12 => return version number
	        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	    }
	
	    // other browser
	    return false;
	}
	//# sourceMappingURL=isIE.js.map

/***/ },
/* 183 */
69,
/* 184 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * Fixes the number to a certain amount of decimals
	 *
	 * @param {Number} value The value to apply the function to
	 * @param {Number} [precision=0] The amount of decimal digits to fix to
	 * @returns {String} The "fixed" number with the specified amount of decimals
	 */
	var numberToFixed = function () {
	    function fixedToFixed(value, precision) {
	        precision = precision || 0;
	
	        var pow = math.pow(10, precision);
	        return (math.round(value * pow) / pow).toFixed(precision);
	    }
	
	    function standardToFixed(value, precision) {
	        precision = precision || 0;
	
	        return value.toFixed(precision);
	    }
	
	    // TODO: The "broken" toFixed is not easy to test? Should check if still relevant.
	    // return ((0.9).toFixed() !== '1') ? fixedToFixed : standardToFixed;
	    return standardToFixed;
	}();
	
	exports.default = numberToFixed;
	//# sourceMappingURL=numberToFixed.js.map

/***/ },
/* 185 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stringTrim;
	/**
	 * Removes all spaces before first after last text char.
	 *
	 * @param {string} str The string to operate on
	 * @returns {string} The resulting string.
	 */
	function stringTrim(str) {
	  return str.replace(/^[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]+|[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]+$/g, '');
	}
	//# sourceMappingURL=stringTrim.js.map

/***/ },
/* 186 */,
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(109);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(42)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wIFAoyLJQcQLkAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAATklEQVQY08XNsQnAQAxD0X+QUVx7gFvDAxmv6Nq7OFWOQMiViUrxhOC3DIDMfAWqCsBxFRHRVbWAiODu47HMTMys55xtZr17WXiL7vibnCFkHelcbNvXAAAAAElFTkSuQmCC"

/***/ },
/* 192 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMdDAU5FCvBmQAAAKlJREFUOMtjYBj+QFle3lBJTj4QlzwTXs1yilYMDIznmBgZBciwWcFBSV7hv6KsXDHJmhXl5Z2U5RX+K8kpRpGsWUlO3kdRVu6/srwCUZpZ0AUYGRmTGBgYnzD/ZtpOjAEYgfjhz58QRoZ/F/+y/rslLysnTnb0KcorzFKWV3ijJC+nQYkhS5XlFT4rycmp4FLDjM+ADx8/rBPi52dgYGT0eP/x49ZhmlcASpkjnx2uzJ4AAAAASUVORK5CYII="

/***/ },
/* 193 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMdDAADr1DsbgAAAP1JREFUOMvdk71KQ0EQhc8slsHGYOXumb2jCFoY7AWr3DqFCCJYpxMLbSxUfBXfQHwBfQQFEUS5PoS/2bW5QS2CW2e6gfnOYf6A6Y7Kxx0LrMe5kYsVdet3jZsERx9rkXyRBe8tvALIQxZ0C5x124LmiuyPYaO+Rerpv3AMsd/Cmy28ZNSk1LMCZw5auAYAU64b9TVS9ycxf2YgTvYgaPKnXAMARnkXwEhyuioSCL3VQQIaN4M7AHh8aQ4kpyMRd28MvfL1US8t6FNc0FkAMB+OjfwwhrVikej1xoI+z1fe/YhoMnK56A46nNvIwG3ny5207ZxLSkNkHE7Zv3wDP0BEJhOixVsAAAAASUVORK5CYII="

/***/ },
/* 194 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMdDAcNB6lXrgAAAL1JREFUOMvdkKEOAjEQRLd3aNKe722vlQSHIXwACkfweBSaXwIHf0CCIcHgCAQEBtH2HIguigRxyVEcPDnZ2cwMwM+TVokacZQJQda5W92DpEqkACIQ7Q1i66sErvTbjPMHEMwF5yvr/fWrfloWYyMVacw7UQle2NLtBG+eibFlxvnaen/8aIN3WJpsEoI7A+hFV0CJbYOKdK5m0eYCi75BFTTiJN4ssWtQBZOrad1to7I3gwEjNjxcTgv4f56mOTVLblp90AAAAABJRU5ErkJggg=="

/***/ },
/* 195 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMdDAA4HlsFSgAAARVJREFUOMvdULFKA0EUnN2kEry3FwtBuX2b3ULE2ko/QbBOoZBv8Cds/AYrIWIRSxFtRVKlVBBD0ig2dxvBwkTXIpcQ4cRr9XUzMPNmBvjzV5kHTpuGUvSaee8nuL4bU7Seen/3k4GcByFgWUI8GtY2Z8aAaDvmrVIJ0mF2W1uMFqQUx6So1Rv0OzWKuwG4VBF1s6G/L9XLaX3o2HzUmTmvtmM1h6IklSKD1PurJaJ3IdAiRe3eoH8zTRITdVLvHwo3+LYHxDmCkBJyDwCq47drAfEiIPd/rWC12XRsgk10c8YxPznmi3JibUY20QcAsLa6onLxWRnxhmPzORVvR1HVan4u9XliwCc20bOOjvnIMZ/if98XVR9SfNJ0yW0AAAAASUVORK5CYII="

/***/ },
/* 196 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AkbCSEk79XJcAAAAK5JREFUOMtjYBgFFANmXBLC0jJMUkJCawX5+b++//jxFi51TLgkBJiZNv3/z2D6////zYry8k4kGaAorzCLgZHJnOUPkx4TE1M0EwPjXmV5BQei/KQor7BUWV7hjbysnDhMTElOMUpJXuG/spyiFV7NynLylcryCp+V5OU0MAyWlStWllf4rywvb4jTC/8ZGWT///9neO/hoxvoBtx//KiXkYEh6f9/BoXRtEdlAAD7GinpqxpL6wAAAABJRU5ErkJggg=="

/***/ },
/* 197 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AwIDwI6JbKIwQAAAThJREFUOMvdkbFKA0EQhmc2go0kd+lvZy97QgxKFMHKwlSCFr5FLPIKATEPkGexSKNtlHSCiBKQ5LJiJ5LL2SRGdyxCwAsatdQp/5/5mP8fgD8/qa+M0sE+pobjEzedGfXjQfvXAByOmwiQR8Cyk3Fb0SDq/BiQI9UQDIF9hQKkuCkATt200+7H0c3cPGvbm+h76lxLFSaBtKOlYt/zd+desASLDYEQWAvFKI5G2pP1bNZ57BrTcp1Ma3KJe9ePo+vpjkjy+PJ54S0XPvTiQMoKCFEGxgtNtNw15oyRS4j2KdHVZ1G0J6sgRI3Z5hnFngCoA/Bqx5jbb/+qPVnVRC+a5PpUU6RqmtRQExXmLgeePNSkrCZZnPV8UscTj4KPeqIDRtwC4JWOub+aBYSmd2QRKgy4Af9r3gFStWhIQR8BoAAAAABJRU5ErkJggg=="

/***/ },
/* 198 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QwCDQMCwHYhZwAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAABwSURBVBjTnZCxDQMxDAP5vwV79R6Gc3oZ1+w1gWulMuJP8kEQNoKIAygK+FeSPvrHBtS+994v4LmgzASANSEJY4wnKKlsY84J2yBZtr9GYwci4hJ/SqrWWtkuABURdVtm3UgSmXmQfCuDl9a37/lZD16/OyLlnpYnAAAAAElFTkSuQmCC"

/***/ },
/* 199 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 200 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QkKCjk1VXnrCwAAAL1JREFUKM+t0D0uRAEUxfHfG5OMRGMFEtuQE9UkLIJSo2MBCh+d6EQsYQqxAwluqxTFVCorEIWC5pGXF8MUTnnu/9x7c5hDVdVUVQPNHPAIYzzjcfAHvIxTnGCU5GP4C7yES6xhK8kDDGfAi5hgHTtJbr9mw6pawC5Wk+y3/hU2cJ5k0l3WvbBXVSt4wSamOOhfbzr/XmC79d8xTnLXDwwgySuO8NT6hz/B34E2NMUxbnA2q71+S9e4x5v/0ieSsTVT+vpcFwAAAABJRU5ErkJggg=="

/***/ },
/* 201 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QgNDTctfW5ZXwAAAI5JREFUKM+t0TEOAVEUheFPJsFQsAGlFehNaQkSe7ADa5CIHegkSkp7UIleqVMKGc2bRES8V8xJbnPvf25OckhTI4wsAW5hgiZuMbiPNU4YxeAutriiiMFt7HHH9PuYYY7lx+6AJ1a/vlWGEruQ+YULev/yboKpxAPjWO4hzsGwSOzHDEd0Ug05BlWrtegN2D8WOaohhiEAAAAASUVORK5CYII="

/***/ },
/* 202 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhNAAnAOf1AAAAAIAAAACAAICAAAAAgIAAgACAgMDAwMDcwKbK8BMTEyoqKi4uLjIyMjU1NTk5OT09PQQicUJCQkZGRkhISExMTFJSUlVVVVlZWV1dXWJiYmRkZGlpaW1tbXJycnV1dXp6en5+fiI8gidBhSpEhy1GiCxUlTBJijBXlzNYlzZZmD9WkjpbmD1cmSxii0Vbk0lelkBkn0tgl0xhmFdqnUVqo0xwp1JwplRzqFZ4rF1womFzpGJ1pmR2pWd4p2h6qmt9q25/qlWGo1uCs3eGq3eTvXuWv1Sm1V6293+63Ge55Wi96WO692nA93XG93nG+XzI+YKCgoaGhoqKio2OjpGRkZWVlZmZmZ6enouZu4yZuoyavpCdvaGhoaampqioqK6urq6zubGxsbW1tbK3vLS5vbm5ubi7v729vYKbwZKfwYKjyYunyoC73ZWhw52nwJ6pyJex0Ju72YC+4qOuyKaxzam0z6+4z6W20aC616K82am71ru+wb6/wLC50ba+1bm/0ITF6IfL7orD44HM+YrQ+IzR+JbH45bR8JDU+ZzU8Z3V/J3Y+rLI37vC1avT6qLZ+6ra86rd+7fN47LZ77/b7bff9bHf/a3g/LHh+7Ti+7Xi/Lfl/Lzg87vk+8DAwcLDxMLExMXFxcbHyMbIysXJzcjIyMrLzMzMzMTL3svO1MnP3czQ1tHR0dXV1dHU2dXY3Nra29nb3drc3tzd3sXa68/U4svf79zf4sDj9sLk9sbl98Pm/MPo/Mjn98ro98zp98jq/M/q+M7s/d7h493h6dLl8tbo89Ps+dHu/dTs+dTu/drs9tvv+tzv+tXw/tnx/t3w+t3y/t75+uDh4uHi5ePk5eTl5eHl7ufn6Ojo6evr7Ovs7O3t7ers8u3u8ePz++Dz/uH0/uXy+eX1/uH5+uT6++j3/uz1++j7++z4/uz8/PDw8PLz9fT09Pb3+vP7/vH9/fj4+fn6/Pz8/f///////////////////////////////////////////ywAAAAANAAnAAAI/gBpfcFCsGDBL7QEGlyIUOHCg7RcSZxIceIXahgzaoz15aLGjxw9fszI0RW7kyhTsnOFhZq7lzBh0iPoMmbMmS1t3sRiUqVKljV1usMZVCdRoS9n9vTJrl07oEiH0ox6FKlSpk6dQrU6lWtOrktPZs26VWhVs13RLh07tqzRtG+/qhXL1p1WuXGL2jz71hXbrHaf4t0Ll/DgnX7rxnRrWO/OwzJ5/rXp6kssepgza+54WbNnzp4/JwZM2eFDLA0HnkadUPVphBVjSzT9MPVq1rQZ0rrGu7fv3iJHUgspnGTH4hg5XmOa8hpkd5cLw4z+PPpyn9y2nXTu2F0UCXxh/n4P/3I8lusqtWXbftiDhE/k3cOXLn8mepTdsmljr9cDADFSDeYfgOENKNV9J6nXDX/udFCFO6YA4EFSUzkIoYQU5mRhhBMeeFI33LDTjTb78RcCAAB4IYECaGRIzYkprthigC+iqCKLFF6nHjskLsggBwqgKEFkOQEpJJEuGQnAkDmiRCKJzeVEixdBToGkO1NWeWWWAFjZ5Enb9BhlUFVIEMuVL5V5poswqRnZfdto15xloW1GZ52YgYYnPV8g6NM1uRlk22qDvrbbb4gC6lptrd1WKKOJIhrcSMQhV2lxyjGHEndIUdcddOS9ZB07ppRqaiigmMIOpzqZB5mrnd2Zt5yppn7Sh6qsxlQffe/F1+t5pNIqSh+f4CrgfzTaZGCByNoXbK19iGKsSxtimGy1HR6FbZOmiBJKt58UOy2MN85IFLkyuogujh6aYqu7n0g7rTtKMplsvVfiyy284Zq6qpRUdrllwF4my2XBzpYKSrjyzpummWi64yabD6/ZrsKp+nvNnXjq2THHdfap6XaBQlQyQY/qFulvAQEAOw=="

/***/ },
/* 203 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3gEODxoaf0zN4AAAAPBJREFUOMvtktFqAjEQRc+km5J+VsR+dY2yVXT/Z5XVzSTjS10oWmnxoVB6YV4uw+HOZaQ/HIwH1Tjn+EOQJ3kc8jgBcOIEcYIWZb1ZU61y8UottO8tWfPk3RrnRHAidLsdfd+TUsJqpZZCSon9fk/XdVz2bo2YmQGoKouUGMeREAICDMcj3nte53OapvnynAkCUGslLZcMwwBACIFZjHcBV8WWUqi1/rjYKUnOmbfFAlXlJQQQYRiGb50zJVlvNqgq3ntijMxi5Nl7VJXtdns/in3odDrZcrWycRwvluWcrW1bU1W7p0/F/u7H/kOudAY1ua6xJgbfogAAAABJRU5ErkJggg=="

/***/ },
/* 204 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUBAMAAACZjst6AAAAG1BMVEXe4+bw8/Pz9fX19/f3+fn5+/v8/P39/v7///9kr4t5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3gEODiQjYE40ogAAAEtJREFUCNdjUIICBQZjKDBgcIECB4ZQKAhgSIOCBCRWeUF5OXt5eXkBQwcDRwNDR0cHkGhgYOCAsDoYQEKoLIQsko6ODpgOCCCDBQALNkfah4uKEgAAAABJRU5ErkJggg=="

/***/ },
/* 205 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wGAwoFAEQ9XSkAAAF3SURBVCjPfZI/bvJAFMR/b73G0ACNhZApEQ0lBSeAu0RKlO8oFJGoaDgIEhVwAIRER0FBY4EowH92N5X5QrAy5WpmZ+a9J/P5vJLn+VuSJO+ABizlUEAeBMGX7/tTnWXZW5qmExHBGIO1FhF5UjjnUErheR5JkkwAdJqmHwB5ntNsNmm1WqV2p9OJ8/lciD+0iHjOOfI8p9/v0+v1OB6PD1fnHFEUsd/vWS6XeJ6HiHiPTiKCiLDdbtlsNiilALDWMhwOqVQqPytY/buLc47io7L3Ak/CYkDGmAfRWosx5mVgT0JrLWEYEkXRU8cwDLler+VCay1xHNPtdhmPx/xOcjgcsPb/inWRv9FocLvdWCwWr7G0fnDu9/vDURlj6HQ6jEajl/1lWcZqtWIwGLBer9ntdmitlQJM0aUMvu/Tbrep1Wo/OUZms9lnmqYTpRT1er38SJXCOcflcsEYQ7Va/ae11lOAJEne4zj+88hFJA+C4EtrPf0G1Yq+tSV2WzIAAAAASUVORK5CYII="

/***/ },
/* 206 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QMHCxAqJS/TXgAAAdBJREFUKM+FkrFKM1EQhb9Z597NrlhJUkSwsLTWLi9gZbFPIegz5BVCFEydIlVEUvkIaazstVARRLSRFffea8bmT1AQ/lMdBs5wzsyR8XjsY4xHIYRjEVFgwd/IzCx5789U9VxTSkchhIGZEWNERDAzRARgxc0MVSXGOADQpmlOlsOtrS1EhBACzjkAYox47zEznp+fSSkRQjjJRGQtpUSn06HX61EUBVVV0W63abfbVFVFURT0ej06nQ4pJURkbZVJRLi5uWEymbC/v89sNgNgd3eXyWSCqq7sAwsZjUa3IYSdbrdLVVW8v7+zvr7Ox8cHAGVZUtc1GxsbXFxc8PT0hPf+LluucM4xn8/p9/vUdc1wOGQ4HFLXNf1+n/l8vsoNoEtiZjjnKMsSEaEoCpYRyrLEOYeZrYQyGo1uU0o7m5ubHBwcYGZ8fn6S5zkATdPQarUQEa6urnh9fUVV7xQgyzLe3t6YTqe/tv6EiNA0DVmWraxmKSW2t7c5PDz8U3R9fc3e3h6z2Yz7+3u895ma2Zeq8vLywuXlJYvF3417eHhY2sTMvjTP89OmaQYxRh4fH3/+6heW7RIRvPen6pw7/3eEY+/9f0ue5/mZqp5/A8xa3c+cLpFDAAAAAElFTkSuQmCC"

/***/ },
/* 207 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA/UlEQVQ4jZ2TPY6DMBCFPyMay42dbdPsibIXQByDhlQxEhwDcYHkYBtBgUyFt0iMvH/A7quex29+nkYjALquO43jWAIvwMw6EuBdKWWzLLuJtm1PzrnrRtKPUEq9pc65cwj0fY/3fjVJCIHWGoBxHM8pcAjJRVHs6tw0TShySHh63uocI9LOaWBaa8qy3GXheDwu76XAMAxYa3dNEFkgWWaZH9uz1i6FfuNB+2mCAOfcJo/xrUBVVZs8RvI1sMfC6gT/sZDAYz17LQQtkKTAHXg1xlDX9SLy3i/CmAMYYwK9p1LKyzRNV+99/LELSqmLAHhe5J/OWUpp8zy/fQAz3IWvDg2CYgAAAABJRU5ErkJggg=="

/***/ },
/* 208 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABI0lEQVQ4jaWTQW7CMBBFX4wtxTJhkZ6gJ6IXQFlyCIoCAi7BDqHsy63YNItYkS0iQTeENoTQUv7K/uP/PWPPBADb7XZYluU78AIcuQ8BfBpjlqPRaBdsNpuhc+7jF9FNGGPehHNu+h8xQFmWUwnENWGtpaqq71yFYDAYIITo8ogl55qttYzHY6IoapxYrVb0ej2CIABASkm/36/DR1mvqqpqiQEmk0ljv9/vybLsYiKvBWmaEoZhowyA0+mE957ZbMbhcLjEWwZhGBLH8TUNQJ7nLa7zdf6Kpw1aJXjvb6ZaxzoNlFIURcF8Pr97o7UWpVTDQABEUcR6vW400i0opX5+t5BADrzWJg8iF1rrRd1lj8IYswgAzhP50DhrrZdJkuy+AGbsYBP6fSg2AAAAAElFTkSuQmCC"

/***/ },
/* 209 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABQUlEQVQ4jZWTW2rCQBSGvxMHyTAYTbuCLsNV2A2I21CsCioYdBXiBnQLvgjupYpCGB8k6UM1TDRae97m57+cCyMAi8WiEcfxF/AOJDwvD/g2xoybzeZK5vN5w1q7/ENUWMaYT2Wt7bngfr8nTdMcUUTQWuP7fg6P47ingDdX3G63C9M2mw3r9ZparebCbwpn5mvyYDDI0tI0RUTodDoAbLdbt5PEK0rzfZ9SqYSIoJSiWq0ym82o1+tYa3NcVWRwPB6ZTCbZezqdcj6fc10+NQiCgH6/T5L8TlepVBCRIuprHQDZDl4yuO3A8zyCIHjd4HA4EEVRDnt03kKDcrlMt9u9wx4ZZKe8Lmo4HBaSXc6lPAXsgA+AMAyJoujuVK44DEMX2imt9eh0Oi2vohvC0zLGjATg8iP/9Z211uNWq7X6AfmVdrC4JzooAAAAAElFTkSuQmCC"

/***/ },
/* 210 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABNElEQVQ4jZWTsW7CMBCGvziJiLFYrk/Qx8lEVwbEW4AilQmkIMQbMCFWFMHG4yAx15lMwgDqQlEpAZp/ujv7/2yfdR7AcrlsO+c+gTfgzHMp4MsYM+52uxtvsVi0i6JYvzBVyhjzERRFMQSw1tYyiwjOuWEAiLWWJElqAdI0RUQk4Neb+/3+v8zT6fQnPAdPFis1GAxuclW1aT6fM5vNKgFhGN7kdzcAyPOcw+FQCVDq9sxKwN9eTCYTlFJ0Oh08z3sN2O12bLdb4jhmv98TRRGNRoPVakUURY8Bvu8DkGUZYRiSZRm+76O1BqDZbFKW5WPA6XQiSRJarRbH4/Fad85d4zzP7wDXrrz6wgqpALAi8p6maS2niADYQGs9KstyfSnUkjFm5AFcJrLWOGutx71eb/MN+BNpUa4itgUAAAAASUVORK5CYII="

/***/ },
/* 211 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wMJDBcsK1UgEQAAAihJREFUOMuVk7FKI1EUhr+5907MzAhChjxFICDbW1nYaCKOpViYF7BfK30IxUosTCFkDMFHUJFd0EZsooXaZUGEzB0zN3O3Ma5Z48Ke7sLPd89/zvkdgMPDw1q/3/8OhEDOv0sAv4Ig2FlbWztxDg4Oalrr2BjzSem6LtbaL0lBENSV1nrLGIMQAtd1cRznXWCMwRjzJajf728poDT6rdFo0O12Mcbg+z4AnU6HNE0pFouTICUx8uw4Dt1ul2azyd3dHWdnZ/R6PaIoolgskiTJWHdvlYuPryzLmJ2dpVAoMD8/z+npKbe3t6yurjI9PT0RMgaYmZlBa021WmUwGADw8PDA5eUlURTh+z5pmo5B1Mh/lmVYa6lUKuzv72OtZXNzEyklzWaTq6srlpeXOT4+JssylFJ/OrDWMhwOieOYUqlEvV4nDEMcx2Fqaoooiri/v+fp6YnFxUWklKRpOm7BdV2MMcRxTLlcZm5ujr29PZ6fnwmCgGq1ysXFBeVyGaUUWutxgLX2fdqtVoswDKnVahwdHXF+fs719TVLS0s8Pj5ijKFQKHweorUW3/fRWtNqtVBKsbKyws3NDQsLC7y+vtLpdMjz/P1OxCSI53lkWUa73ebl5YWNjQ2SJKHdbqOUQko52oRwdnd3fwDfJt36cDhECIFSCmMMeZ4jpfwo+Sk8z9uecGEASCkZDAb0ej2SJEEI8XeYth2At0T+V5w9z9tZX18/+Q1Ru/9QUjFkiwAAAABJRU5ErkJggg=="

/***/ },
/* 212 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABBklEQVQ4jdWTPW7CQBSEv7W28LKNTU6QK1jb+gzkApYlTkERKih8DFu+AJwBiQpxk+Bqva5wihBpITY/ZUbaZjQzb1Z6TwDUdT2z1n4Cb8CZ+wiAL631Osuyraiqauac2zwwDUJr/SGdc0ufbJqGvu+vhEIIlFKEYXjFW2uXEpj65sViMThtt9ux3++JosinpxLvz7eTfaRpCsDxePSbnINRx0iIc+6Kk0PCw+FAWZZMJhMA2rZlPp+TJMmfloMBxhiMMU+1ernBUwH/q0FwecDPxj3CjSaQwAl4B4jjmKIoRhdKCEEcxz51kkqpVdd1m1/TjeAutNYrAXC5yJfOWSm1zvN8+w1TaWzQr76JZwAAAABJRU5ErkJggg=="

/***/ },
/* 213 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wCFg0POu/We/kAAAJiSURBVCjPRdIxb1NXGIDh97vn3Gvn2jgEkqhY0CghoQNCRUJIFQOkI0FK11ZVh0gV6tR/wMTUCTF0aocOIDqjlgkpFWJgIBJSJ5TIEQSs2A6248S+9r3nnK8DSH3/wLs8AvAn8C3wABAwCgaI+FgQ8AH8D8Aj4DtAHgLfA78BJThbS9P1Urm8JsasoIqGsD0Zj58cjUaPJ/Dux/8H8CtwAq7Mzc/fqa+srH62tFQVEaOqqKrfbzSOm9vb/xx0OndHsPUTYP4ADJydnZv7Zfnq1Zu1er3S73ajeG2NsLhIf2srOnnmTDmt1ZaG/X49z7Ln38AgysGkabo+u7Cw6qxNDjod9vf2tL6xQX1jg/b799rt9WBqKjl17txqqVxed2CsA0Mc3ypNT1c77TZRFOlwOJSDZpPBYECj0RDbbmsURVKrVqtO5FaA320BUaG6rMaYyWRCdnQk/WaT3d1drLWELCMYIx7IwEycW3YQWQcUqhRZxrDVwo1GWOcwzpGWSpSBRARUiYsCr0oB2BzCxLmd42bzfGk4NGUR1UpF9m7fBhFmKhVEVRGRoii8U93JIVgPPiuKv3q93rV6HJ/0zsng8FCvt1pireWZtXpiZkYE2BuPj8ch/O3Amy9BQwj7zvuL09YunY4ik4jIMM/pbm5SevlSUmvpOpe/GY+f9kO414NDAVDgZ7g8a+2dC0ny9fk4rtk8NwAuSfxOng+283zzg/d378MrAcQAHmJgfhG+uCRyY0Hkq7LI5wBj1bdvVF/8q/psF14DLQOFfIJsPqpjKgGbQmQ/IXcQRhBy8MAIOAL8f7xJIc30s21fAAAAAElFTkSuQmCC"

/***/ },
/* 214 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABMklEQVQ4jZWTMW/CMBCFvwsICXnBdGHvD4KFEbGxMYehbAzmH6BsUfYI/k87MhazWEFIhA6taRIZSt/0zr73zne2BSDLsqFz7g14AUoeIwI+lVKryWSykzRNh0VRbKsZ5/MZ5xzX6xUAEUEpRafTqTkppUbtoiiWTfFgMGA8HteS8zxnv9/XTJxzyzbQ9wvWWqy1zOdzZrMZvV4PgOPxSJIkxHGM1hqttZf0ZbPZvAOv1loWi8Uf7X/DGONNPqKnFA/Q9kRrjTEGa+1teE2ISLOFXwOP9Xr9sKIxphbXWqhWjuM4yJunuzuDy+US5E3cNYiiKMifNijLMshDBkGTVqsV5E19BBx8JCK3neptVHk1BzhImqbD0+m09dN95h14KKVGAvDzI//1nbvd7mo6ne6+AB+zf9f/5Fb9AAAAAElFTkSuQmCC"

/***/ },
/* 215 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABwUlEQVQ4jZWTv2oiURSHv6uXGeU26mqrrA/gO/gEBuyEIGhjayMWCTapfArFys60Ymkh2grBgKBOKcYRHEbHOLPFrhITFfYHl8s58H33DxwB0Gq1MpZlPQG/AJf78QErpdTL4+Pjq2g2mxnbtjuWZbHf729SSik0TcO2baSUaJqGUupB2rb9bFkW2WyWRCJxUzAYDOj1euRyOd7e3phMJgDPEog4jkMikaBSqRAOh3/AnufhOA7VapVAIEAymcR1XWazWcQHuJ7nARAOh4lEIhcrFAohhDjDp6TTaRzHcX33fst1XUzTpFwuX8AAnU6HQCDATYHnedi2fRVuNBqsViuklLcFpmmSSqWuwpvN5ty/KrAsi2KxyGKxoN/vX8Dz+fxC+kPgeR6fn5/EYjEKhQLj8ZjhcEi73WY+n1Or1TBN87bgeDwSj8fPdalUotvtslwu0TQN+Pu5p8jvAiEEh8OB0WjE+/s7hmEQjUYRQlx7LfLrLdbr9XmfTqdIKfH7/Rf9b/FJ4EPX9d+GYVCv16+e8jWGYaDr+qn8EM1mM7Pb7Trb7fbuMJ2i6zpKKQCUUg8C4N9E/tc4B4PBl3w+//oHxnLOwBxtz8kAAAAASUVORK5CYII="

/***/ },
/* 216 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAACFklEQVQ4jZWTMUgjQRSGv53doLsxQZNeuWxjG6uksdVC0EKwEgWFQELAwvLExjKQIiGkDbETRBtrC9tACIjdXiUomJAiyWx0d+eKuyynEuX+cobv/9+8eU8DaDabm8Ph8CeQBAK+lgC60Wj0bHd391prNBqbUsqrrwjf95FSous6pmmG59FodEtIKU++gt/e3lBKcXh4yOrqKt1uN7wbDocnAkh8BxcKBeLxOCsrK+zs7PxrkhDT3uz7PgDFYpHBYMDp6SkXFxfYts36+jpSSoBATEsfjUbkcjn6/T63t7fE43E6nQ6e52HbdhhgfASDIEBKiVKKu7s7bNtmY2MDIQTZbBbDMDg/Pw+b+a4Cz/MYj8fs7++zvLxMKpVicXGRp6cnstksCwsLVCoVlFLouv7ewPM8pJQcHR0xOztLOp1maWmJx8dHHh4emJubo1qtomkakUgkDDUmZb++vnJ8fIzrutzc3LC9vc3z8zPtdpv7+3tarRaWZYXJE4lJww4ODvB9n1KphOM4XF5eEovFyGQyGIZBLBb7BIcGQgheXl7QdZ1kMomUkrW1NSzLotlsvpu+j9Lq9bqjlPrR6/XI5/PMz88zHo+ZmZmhVCphmiaG8emzJvolgJ6maSQSCWq1Go7j4Lou5XL5OxigpzUajU3Xda+UUiilkFISBAGWZSHE1DkD/iyTBvB3I/9rnU3TPNvb27v+DRPm60vlFQz6AAAAAElFTkSuQmCC"

/***/ },
/* 217 */
209,
/* 218 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABDUlEQVQ4jd2TMW6DQBBFH+vdAg1QOA1tTuRcwKJGHIG4st3T0LizEH18Kzdx4RVCwgKliMFCcnCcMr/anZ15mr+acQCKolhUVfUOvAAd01LAp4hslsvlwdnv94u6rj8eFN2ViLypuq5XfykGqKpqpYF5H7DWcrlcbr0qRRAEKKV+Ysw1V8/WWuI4RkRGGdvtltlshuM4AGit8Tyvf+50f2rbFhEhSRJEBGstWZaRpukIeDweKctygAyArvv+/DzPJ32HYUjTNDebk9m/0H8CGGM4n88PC6y1GGOGu+4hvu+z2+1Gg3RPxhh83x8a0MAJeO0hT+qkXNdd91P2rERk7QBcN/KpdXZddxNF0eELyfhUxDkoad4AAAAASUVORK5CYII="

/***/ },
/* 219 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABYUlEQVQ4jZXTTWrCQBjG8f+MJjiOEa1LF1IQV64E76ALScG1eJF24cfaO4gXaDeSkwjiygM0IBgGEky6aE1rS7S+ywd+DzMvvAJgtVq5QRA8AzUg5vpI4F1rPR+NRm9iuVy6xpjXG4jT6QRALpdLM631kzTGvNzCxhhKpRK2bWOMSfMgCF7ywMM1fDweaTabuK4LgOd5bLdbCoUCwIPkyp9/Y4BerwdAHMcAsbwHn6dcLpMkCfC50bvwer3mcDiky/xTEIYhrVYrE282G5RSaXZREEURvu8zGAwyseM4F7n8iev1OsPhkOl0+i98URCGIZ1Oh3a7Tb/fT0s8z8vEAPmfL2g0GgB0u12UUkwmE6rVaiY+F8gkSZDyex37/Z7dbketVsOyrEwMyDzgCyEeHcdhsVgQRRGWZWHb9i0M4Eul1EwIgRCCYrFIpVJBa/0fjNZ6JgC+LvKuc1ZKzcfj8dsHkpSPMXFgHGwAAAAASUVORK5CYII="

/***/ },
/* 220 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAB4ElEQVQ4jZWTv04iURSHv7lzh3Fy1ZDZisawPQmxIoSExsLSbSwJLQ+A3VppQngBWgK8gBY+AfAIRowmhM5GIUxGJpK5dxsHkN1g9leec37fPX9yLYBer3cWhuFv4Aeg2S0BvCqlriuVyq3V6XTOFovFzTemf0op9UssFovL7UQcx8zncz4+PnYCwjC8FIC/GXx/f8cYw8XFBblc7juIL/mcWWvNdDqlUChwcnICQBAEzOdzUqkUQghc18VxnE2AlolZa02tVsP31w2dnp5SLpeRUhIEAYPBgMlkwsHBwapGJDNns9kvZgDXdUmn0+zv75PJZDg/P6dYLBKG4VeA4zg8Pz/TarUwxqySw+GQdrtNt9ul3+8DUCqVUEoRx/EaALC3t4cxhkajwf39fbJlZrMZQRDQ7/d5eHgAIJ/Ps1wuAZCbLUsp8X2fu7s7np6eCMMQ13URQiClJIoiAGzbXnu276K1RgjB4+MjlmVh2zZxHHN0dMTx8TEAo9EIKeXfAK01Ukrq9fo2d6XxeMzLywuHh4crgNgsSJazLWMMw+GQwWBAOp1OwkICb8BPACEEWmuazeaXayS55KyWZSXhN+l53lUURTeJQQix+cJOKaWuLIDPH/lf39nzvOtqtXr7B1AExpQj6LP+AAAAAElFTkSuQmCC"

/***/ },
/* 221 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABKklEQVQ4ja2TTY6CQBSEv9dxo20iMjdhDqIHkHgK4gYTFm6MF3DbgQPoPRxvMsSFLSwMzAbiIPgzyVTSSae6XnW9RQlAHMcTa20IfAAFz6GAb631yvf9vRhjJlmW7V4MdUJrPe1lWbasidPpRFmWT4dEBMdxALDWLnuAWw8vFou3fl6v17WJq6h2LopXq9/wS1v07h+PxyNxHDMYDBr85XLB9308z2vwLQPP81qiZ+hMkCRJZ4LZbPb/CdTbygdoJQCIoghrLSICQFmWjEYjwjB8bKDULYy1ls1m0xAGQdCZQFWH4XCIMaZlVqNOc3dXst1uD8AnwPV65Xw+4zgOaZo2DFzXJU1TRITxeFzTX2KMmeR5vnvVgS5oracCUDXyT3Xu9/ur+Xy+/wGfSHNWSZ5srQAAAABJRU5ErkJggg=="

/***/ },
/* 222 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMRDxo071CyWwAAAeBJREFUOMuVk72K4mAYhZ/8GL6gEZytrOIW/hUqqbUVQQT3BsQ72CvY6eZGxBuYKe0jWKugjRArtdhZI4QEg8k2q6vrrsN+5ct3Duc9D68EMBwOu57nfQM+ARGPnwx8TyaTL71e700aDAZd3/dfPxBxPB45nU6oqkoikQAgmUx+kX3ff/5I7LoupVKJdrtNNpvF8zxOpxOe5z2rwNMjse/7NJtNLMvC8zwKhQKj0YjFYoGu60/y9c7H4xHf9wnD8GJQLpexLOscGYBisXj+E6nXMS3LwjRN1us1URRRq9UwDIPxeEy9Xr+Y2raNpmkAqP+Kud1uMQwD27aZz+dsNpuL+W63I5VK/TYIw/Au5lnsOA6pVIrtdovjOAghLuIzUzRNYzwePyQRxzGqqt7NVQAhBJPJ5BJzv99TqVRoNBoAzOdzqtUqpmkym81Yr9cIIVAUBaXT6XwFnjRN43A4sFqtcF2XMAzJZDLk83nS6TT1eh0hBLVajcPhwG63I5FI/LjJpCgKhmEA4DgOjuOQy+VotVp3GKfTKbquI597AJAk6Wa/KIpYLpd3/VxhlFXgHfj8NwNZlu/6+QPjuzQYDLpBELzGcfyQQhiGBEGAEOLmmCSAXxf5X+es6/pLv99/+wnRjuAwDaBEiAAAAABJRU5ErkJggg=="

/***/ },
/* 223 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AoLCyULNFXIDAAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAJASURBVDjLlZPNSiNBFIW/bgu6O21sMJpIQMKo4CIkWYqCGBAE3ZgXEF9kXOmLiC8wgquA6MKNbpSOxIWRQHARCB0SkzbSla7MwpnGHyYwd3epuqfuOXWOBnBycrLr+/5PIAEoxpcOeLZtH+3t7Z1qx8fHu4PB4NfHG4VCgdfXVx4fH8ci2bZdEoPB4CCTyaDU+8NSSrLZLP1+nyAICMMQTdMYjUZ0Oh36/X4E4Pv+gQCmNzY2GA6H0YGUEtM0WV1dxXEcwjDk5eWF29vbr1tNC0CdnZ1FgwBCCAAmJyfZ2dnh4uICz/N4e3v7ykIJgHa7ja7r5HI5lFJUKhUA8vk8nufx9PQ0VtF3KKXwfZ98Ps/MzAzpdJrl5WWurq4AMAyDpaUlHMf5BCA+NrVajbm5OYrFIo7j4LouzWYTgGQyyebmJq7rcnNzQxiGnzf4W/V6HcMwEELgum6kSSaTASCVShGPx79TAJidnWVtbY1er0en06FUKhGLxTBNk3Q6zd3dHZqmkUgkvlNIpVKsr68TBAHlchmA7e1tFhcX8X0fIQTVahXLslhYWKDRaCClfAcwTZOVlRWklJyfn0ffVS6XUUqxtbWFYRiRwI7jEIvF6Ha7CEAPw5CHhwdardZXpzE1NUUymaRWqyGEoNlsEo/HmZ+fp9vt6gJoSyl//Mv3uVyOXq/H5eUlExMTDIdDlFJks1nu7+/bumVZh+MCEwQB19fXjEajyO7VapXn52ds2z7UAP4k8r/ibFnW0f7+/ulvOQ4B+OkIi0EAAAAASUVORK5CYII="

/***/ },
/* 224 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wLDwoAFwjfV6IAAAG6SURBVCjPdZK/iiJBGMR/3dP2jCBqoE5qqNmAiaEP4Iss7HL3KAYLRiY+iiL4J/EBFCYwMVEQFJ2x57vgHNFbrpJuurq6+itKjcdje7/fP26326dSyohIppRCRADI90opLSJ33/e/C4XC0KRp+pEkyUAp9XYxyzJez/L1drsNAHSSJF85kbtcLhdarRbtdpvL5fLGPcRfGvB4QCmVE3S7XbrdLtfr9c31AU8rpbIsyzidThwOB+I4JooigiDAWkun0yGOY47HI6fTKR8hMyKCMYZ+v0+pVMJaS6VSeTr0ej2iKCJJEs7nM9PpFOccBiBNU47HI+12m3/h+z5hGAKwWCxI0xStNTqfaz6fM5/P+R+WyyWz2eyZgxYRtNYUi0UmkwmbzeaHaLvdMplMCIIArTUi8tcxj7tarVIsFn8IgyCgXC7zmr4BNIBzjjAMqdfrnM9n1us1AFEU0Wg0qNVq7HY7PM8D0EZEXO5qrWW1WhHHMfv9HoA4jmk2m1hrefmdU6PR6FeapoNHH3HOISL5yzjnUErhed6zPb7v/zbGmCFAkiSfImK01tlrS4wxiAgiooG7tfbbGDP8A+jp21tjVFaRAAAAAElFTkSuQmCC"

/***/ },
/* 225 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QYZDBMrBGwJUgAAAuJJREFUOMttVL1O81gUnDm+dmykTUiI+BNSoGe1QoKvzQugFDQ8AUhbUi8lW/AINLwGBU2IhBBQhBqBvgJRBEEs/hTHis/ZIjYbvt1pfC2Nzp0zc+5hu93G3d3dSpqmfwH4QdLMDCRhZgAAkgDw7d/MSPLKOff3wsLCTx4fH6+kaXoDoFyQSUJVISL/KfArx/O8dxH5wyVJsk+ybGaak6mqVnxfX18BgJVKBZZXnORkWfabqu47EdkwM0h+vaoaABmNRjoajWRvbw8k9ejoiDIGzMxERFRVRYSquuGKW2wMOOewtrZmcRyz1+sZSYgI5+bmUKvVrF6v4+rqClmWGceGgqS5wtRcJlZXV219fZ1mpkmSSBAEUFVttVoMw5AAMBgMrNvtEkChCA4TIIm3tzeYGcwMURQhTVMAQBiGXyZ/fn5+nQu4IpHcPDw/P2MwGNjU1BQfHh6s0+kAAJvNJpaWlixJEnx8fACAAShagxSF+v2+7ezs2Pb2NsIwtOFwiHa7bXEcWxzHODs7Q5qmFgSBtVot7O7uWhzHX4pEREASJAWA5OYKACPHQeXngi9Fyp7nWeGxt7m5+aeZzUVRhJubGzw9PaHRaLBUKlmlUmGv10MURdZsNlmtVpmmKU5PT3F+fk4RMc/zaGY9p6rFyOtwOEQURSyVSmpmbDQaOj8/D5Is0vN9H9Vqlff39+r7PrMsw0QXY83OOZmdnUXeog0GAymVSuKcsyRJICJCUur1Onzfl3wwYWb/plYM5uXlJUhar9fjy8uLbW1tAQBPTk5QLpdtcXERFxcXUFUTka/U3MR0kiTSNLVOp8PRaKRhGEoeivb7fT4+PvL29hYAzPM8TjwROgDXAH4v5iJPEM45ZFmGw8NDAMD09DR83/+2DSZwLUEQHIjIu5mxeNy5QgGAmZkZ1Go1Kdr4H857EAQH7Ha76Ha7K2ma7gPYsPHG+raPimR/2UdU1eswDA+Wl5d//gM6T8wasEPinAAAAABJRU5ErkJggg=="

/***/ },
/* 226 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wLBggYKTUpSbQAAAJVSURBVDjLdZPLalRBEIa/qu6Zc5IJQcQ4QbwgKIqCCCrqRleC6AOIl3kAQV/BpeAu4iULVzFLQdCVGxeCC11IFPGy8IKXBHXEC8nMmZkz3eVizhwNam2a6qq/6u+/qwRgdnaWVqvF/yyEgKoiIuVdrVaj0WggMzMzZFn2T9DQkiSh2WySpilpmpaFarUafsfoXNWS/ul+d+kMIh6ImJXgGHNEHLJGFej7ZOyy+sr0g69beq1WCx/7vdOh155CBMyIMQdAxGEWGJvYRPvbe2LoIeLod5emPGOY2UURQUOvfRYRLOTEmJOOTzKx+SATmw7Q+bnAtiPn2H3yGpPbDmMWMIv0u0tnO50OAB4RZzFgGPWth1i36xjqq7Sab3j7cJaCDuv3nADg0/M7iKjrdDqkaYpiFs0CK9buZMPeBuqrAxHzDF9JBgUKTdbvPo5qBbMY6/U6MUYUQF2VDXtOLUsWVWLolQyG5+iqjWCRLMtwzuHNIs4nJOOrlyVbjCxlfe5fOYqoI+RtRBzJeL1gYYUGUDqYMfyN8TXb2X/sQhlzlRG+f3jE11f3+RPjB03lL6qYsXLjvmXDtfj5BWYBEcV7D4CKKKGX8eXl3WUalMUK30LOz4VnZWzYVBFRw5h/fJPsx/xfwKE//+QW7e/vUa0McIUpZkG1Qt5d5OWd87+ZFMDuYpPX966y8PT2n88rF8W76uilkGdTwyLvHl7n49yN38IWMyHiEHVghk/GLpEVy6S+Og0Qeu0z6qoesxjybgkW0QFtEcWs76qjl8X56ZGRERqNBr8Aj4kVcknv0xUAAAAASUVORK5CYII="

/***/ },
/* 227 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wKFgs1LApWJ6IAAAIKSURBVDjLlZM7S1xREMd/c865Dy+GfTSykJBOSCcpbAI2lhb7AQRF2EYxRL+E7a4g2PsdFMEurYTEysLKSgtxd0n27uvcOyn24fogkKkOZ2b+M/ObcwTg1/4+g1aL/7GwWGSpXkd+7u0xbLefOfNej0GzieY5AGIMYamEieNXIg6R0M7Nbfs03RURp6q5hCHRwsJTpAgiYlTVuyQ5snF8PGg2B4NWC5f3+9s+TRsiAoB6j0uSZ5WybhecQ0TwadoYXx8COJ+mX0WE3HvSuzsWVleJl5eJggCAvvf0Ly+5v7ggqVQwzjHOGQmIiM29JywUKK2s8KFa5frsDPP4OOJRLvNpawtbLtO5umLQbmOcs5PuHJDrcEhcqbBYqwHweXPzFfXFWo3rgwP6Dw/gXD4rgIlj/tzc8H19nd/tNox5TE2Vd4UCc2H4ahNOVRERhq0W79fW+LixAarkwyEAJghAhNuTE+5PTwmKRSY5AGZKXxWxFhsEnFeroAqqnFer2CBArEVVx1t96tC99crU2ukYau0/X6SZqD6zWQYveQCzGUZEzMuArNOZjpB1Om+0qGYWYjaZyUYRAF8aDYL5+el51jepMW3wx87Ot6zXa2iWjeBYixiDZqMYsXb0qbJsBFEElyR7Wbd7GBaLOBNFxwA+TXcVHN7nszNOhBAxiHiXJEcmio5NGLJUr/MXfYjXXyC9NRUAAAAASUVORK5CYII="

/***/ },
/* 228 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wKEwsVDwprgkAAAAHxSURBVDjLlZO/TipBFMZ/MzvMYvgjGmPCNr4AiQ0Fj0AHiTUPYKLv4o0m1sbKCrOFz0BHRS8dCX+XuMAOMnMLL3sFNTf3lCfz+3K+b84RAI+Pj8RxzP9ULpej1WohHh4eWC6X/wQ2mw0AnuftiCghhNZaXyZJciWEUID9DDrnAJBSSuBda32XyWTuARPHMWq9Xl8aY26EEOyDQgistamI53kkSXLz58kvAGmMuf4JNsaQzWY5Pz/n9PQ0tZEkyXWSJAAoIYS3D0spWSwW5PN56vU6QRCwXC5pt9tMp1O8T0HIz563cBzH5PN5Go0GQRDgnOPg4IByuby1kzJqH357e6NYLHJxccHR0VFqZzAY8Pr6ykeWf0vtez4+PqbZbFIqldL+eDzm5eWFOI7RWu8ISAAhBM45ZrMZ1WqVUqnEtj+bzQjDkCiK0FqnP7IjYK1FKUWz2aTT6dDr9QCIooh2u81kMiGXy6UTfbFgraVYLFKpVDg7O+Pp6QnnHN1ul8lkQqFQwFr7Bd4KSGstvu8DUCgUqNVqPD8/c3h4+BOcJqmccxulFKPRiDAMWa1WzOdzTk5O0k38ZtE224yk1vpWSokxhn6/z3A4ZL1ep8F+t6W+79/6vv9xTEqpewBjzJXWeueY9sd2zr1rre+2TKvV4jdODvduJgAq6AAAAABJRU5ErkJggg=="

/***/ },
/* 229 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wKGg8LDD0iC3MAAAHsSURBVDjLnZNBSxVRGIafc+a7M3ec2+Ze02gjqOEuoqJFi35IcJcFgraSFkEUBC6MQFOSVnJx229oHUGLKIokN1GJ5lWhGU8znjmnRTZ4US/Uu/w453m/9z0cBbC6ukqWZfyLkiSh3W6jOp0Oxhj+R0mSIK9G34Wlt5OpzaYUWgB3ynntcbYhyZLo2vLF92NFlmXIgSsm90sz77zH+hyNOvG2wyNKSG0235AEYAFA9ksz7bwnCkJG6yN4708EKKX49muDvCxIbTZdARQ6sD5ntD7Co2v3+ma+/3qWtXSdSEXB31mV2XtPajPmPj3lu9lEtABgneV8PMzdiTtHt3NHAZUakjA9fhvrbY+zKOEw9zH1ALrFDpNvZtja2ULX9B+rA8dQc4jnV5/0B3g8rbDJi+srp3bg8f03APiRd9kudnpmg2GTs1Gr/wbq8P0ffphjO9+uMqc241x9mIVLs6cCdKACdu0eqc3Iy5xnlx/TCptVLzNvH/SYALoyvvny1mdgzDpLK2qxW+wxXB8k1jEAxhk2zCYTZy7wxXwlLwu0Uus31q6MA8hAEC+aMp8XLXTzLqKFDbOJOyxMoxAtfPy5hihBK0VDksXqM9V0uAywX5qpmg4FcDUdHssa6Uh7nB0I4qVAyXIcx7TbbX4DeATFa3Lu/0cAAAAASUVORK5CYII="

/***/ },
/* 230 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMRDyITXcW7ywAAAl5JREFUOMulk01IVFEYhp/zc++dOzbSCKOSVGZBEVKU5TIMom1BEAQVVBRUuGsVBGVBEoTClFIELQIXERFBblpUq4J2BUUuDDIJamyicWauc+85p8X4M6Gt+uBsDud7eN/3+w78ZwmAAxcrVBJJoeLXL1Yo55Y6cukazUHMo6sZ9KlrU37V/DxbS1R/exoNmAVwYz+ggCSbMvlMaEYni201AF2K1blSVQz9S2LNWprDBGMFlaqmUNHDKESh7A8DyFJV9C88lqJ+FiqqwfbOMsMnEwaPQXdnRJIkFMuqf8GRBpQUEBtBcc6iFQRCUEtgZ9cvbpxpQ3lZAC5lv3I8b0gipUQDwMwlAkeVE3sqlKqO4m/Hrq0t9G5u4cf3Eu0ddcD7LyFRVMWXGCGWACIM5rhyJGZL13qME/woFFm7ZjXPXnzm3stVnN8/QXPacmu8CWE1yKWQtbXghQE7utcteg98xZPnn7j/KoexgutPNdZBk1Z4+u+QpZSQRBEfPk7Mz9stm4SW4KmVN0QDVKIUZ+9KDvW8w9c1ere2cHDfJjz9mbHXaS4fjihVA0bGJV8KPqlAYt0SwAXaoYTHgzc5jHFMfPtNX/EXvdta2bs7pjm7AYCO1inO3I4xSeAaFSjrQErINQmkELyfzvJ20tKzcYbB062LcmdmQ2ITIUE1TsE0erIOPOXw0oJ306u5cOcnR/tmyYSGm499TKzQPiaXrtUBmdDly5EYssuzIyXh03QTAw9jHBKbSDwtyKZMvpzYOiBUboQUbn6ll30mTwtwvhOglCLJhC4fem50bCANwB8V8umz0lpU8gAAAABJRU5ErkJggg=="

/***/ },
/* 231 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wLDwoAIcdlwjsAAAF4SURBVCjPdZI9igJBEEZfdfXMMAqigXgBcxMzz+ERJljYNRK8huCCiZGxJxEPIHiCQURQUOanpzcaUXQ7rsf3qr+S9XodlmX5lWXZt4hYoOLD894boIyi6DcIgqUtiuIrz/O5iOCcwzn3AogIqooxBoAsy+YANs/znxpqNBq0Wi2qqnpO4nQ6URQFQRAgImRZ9mNFRAHu9zuDwYDRaPSmudvt2G63VFWFMQYRUVPvVKd+esPhkH6/T5ZltUVlnwdUlePxyGq1oixLAIIgIEkSms3mYwUR4QV0ztHtdpnNZnjvH0PGmDebt8Q0TVksFhRF8UicTCao6v+gc45er8d0On1JbLfb7Pf7/0FjDOfzmc1m81Cz1jIejx89PoOm7ktE6HQ6JEny9rMi8rAAjPXeOxEhjmMOhwNpmr4cQG1yuVyI47iuw9kwDBdFUcxVldvtxvV6/dilqqKqeO+JomhhrbVLgDzPv1XVqurHIweM974Mw/DXWrv8A5FtsjaW2MNCAAAAAElFTkSuQmCC"

/***/ },
/* 232 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhEAAQAKUxAAAAADVJYzZKZC9iyDFlzTly4j5240B240Z75Ep940D/QE6B5FaG5ViH5WKO5myU526X52WV82qZ9Xab6Hqf6XGd9X+h6Xei9n2n+ICAgJOit5alupqpvp6uw4Sl6Yam6ouq6oSr+Yuw+pC1+5a5/Jq9/aOyyKe2zJ/A/qLC/9Dg8ODg8ODo8PDw8PDw//D4///4/////////////////////////////////////////////////////////////yH5BAEKAD8ALAAAAAAQABAAAAZiwJ9wSCwaj8hkEcT8WCYPR2NhKBBBKRRpJAphLpUIgXiKmc/ml0tANMUAcED6xQoQO+i5q07kmDOAgRkrdkMbeWdqhUIab3FzfEONeS9qkYxoMGotLCqLPxoBoqOkn0qnSUEAOw=="

/***/ },
/* 233 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QwJDgc4t1EEiQAAAcNJREFUKM+Nks1KI0EUhb++VWLATtMLhYS0/bMUxAfwAVwkzyC+hctsssoT5El8AWFAFDdCtiGRthVBDJlIg91VNYuZtDrjYs7qVt06xbnnHm80Gv2o6/rYWstnOOfwPA/nXHPneR4igtZ6qeu6Pj4/P6eu6y+PRAQR4W+ICOPxONTWWpxznJ2dkSQJxhhOT095fHxksVgQxzEA9/f39Ho9+v0+xhhk80ur1aLT6VBVFUopkiRBKYVSCq01W1tbzRn4TdRaU1UV0+mUsiy5uLjg9fWVNE0pioI8zxER8jz/ShQRgiAgDEOMMby9vbFerwmCgJOTE7IswxhDFEXN3AKglGqM2dvbY39/n7u7O+bzOSLC4eEh29vbWGsbp/XGreVyyfv7O61Wi+fnZ56enlitVnS7XdrtNkdHR9zc3Hy4uynCMCQMw6ZxcHCAc46iKEjTFIDBYND09efdGWPwfb8hrddrXl5eKMsS5xxBEDThkM9Sfd8nSRKur6+5urpCa81qteLy8hLP85jNZv9K7XQ6xHHM7e0t1lp2dnZ4eHhgd3eXKIqw1pJl2YfUjb2TyYT/hVIKbzgcLoD4u5B/V/9J0s9f2FjHAkLdHMoAAAAASUVORK5CYII="

/***/ },
/* 234 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAjFJREFUeNqkk81rE0EYxt/Zj6SJNlvJBzkEiig0ubiJPdRDQVCkIojUW+PBg9KDJw+CQv4OIfSgR/+ABERIixCkVQgmYgwYCNFDFe0Su7tJm2x212dijKvmloEfs+/wzjvPvM8Oc12XZhkCzTikXC53ShCEy/gOA81xnG3btjutVmuSNK8+JsZYCjxDqIIalG+AhphMJm9ks9k74H4oFFLK5bKhaVodRSYFhuZHsoPp0vklv7q2EiTXsePt/d7qcDjMS+12O44ia91ul/iM+LmiKJtembbZpJ6hq6nFEPX7fUotClTa1bkSEjGWIpGIkkgkTheLxZ1CobAXCASeSJJUGQwGy8jZssRERXfPrPOT42GZXr39Ts1PnVq/f5xnkB2B3OtIjIFvKFhATw4ymQw/gCvZMqKPCPdNoT+THiBnAz1pSNh8YFnWU6/kaDRKpmlOYibvkD1/sYHctDcPh5E0zRpZlskwjEnsCEdkuxZU/GksYw6w//8PfD4f6br+F45yZWyjWAXur5mlRir4BlyBYAlx637bx9fAcq/Xqxz/+EALiWulm1fPqg/uZsjn98eb7aNVUZTzErfPO/hGLh8u8PALmrdpaTWam1PUSyvRkY18flE+HNk4tQfoNsFCLrsARmsocO/lG1O9cE6ivXdDHtfqpVskevaxcUEfCIKTYAEKwiDW1arVwYn19Ov3UuzzvlWvb99+ePh1t8P+KcDGD0ycguCB51mgy2Z9zj8FGADgHgwD6oj4yAAAAABJRU5ErkJggg=="

/***/ },
/* 235 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wGAwoODkBxqeUAAAFlSURBVCjPnZIxbuNADEUfRWoEGzAkNbmZDuAyQHIXAwng0oAPYF9B51GjaUcjzWyRSFCyW+3vhpxP/k9S7ve7m+f5NYTwJiIGpJwzOWcARAQRAShyznNVVZ9lWV4txvg6TdPlO8myLJgZADlnRIR5nlFVRIQQwgXApml6X0kA4zjSdR17PJ9P6rreuocQ3k1EdP9JVWmahpeXFwCGYcA596OQiKgBaVkWxnHEzNh3XzFNEyEElmWhbVtUNVnOGTOj6zqapuFfOJ/PAHjv6fuelBK2Tg/Y5K2D+R3z3iMipJQo+E/Y3tMwDH9138dWJUVRfBHneebxeOCcI8a4eVpxu91QVWKM1HWNqmJAsa5g3eNvlGXJ4XCgKDZnheWcl/W0AFJKeO/x3m/EGCPH43EvdzHn3EeM8bKeV9u29H2/Fco5czqdfryrqvowM7t+L/kNMFVNKSVSSl+aigJV3Y7cOfdpZtc/0guxqT7h+/IAAAAASUVORK5CYII="

/***/ },
/* 236 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wGAwoALuWcpKMAAAHHSURBVCjPdZJBSuxAEIa/6u7MMMEIQcQr9HqWWYp7mWMIyntHcSG4cuNa0J3gAQJzg5xiII4Gkkl1vYUkOIv3Qy+64Ov6q/qX5+fnxTiON33f34pIMLNkZpgZACIyHWdm43K5fMiy7DEcDoebYRjuAcZxxDmHc47T01MAPj8/SSmhqnjv6fv+HiAMw3A3QXmeU1UVMUbatmUcR87Ozmiahrqu6bqOEAJ93985EfGqSp7nbDYbYowAvL+/8/LyAkCMkc1mQ57nqCoi4p2ZJeccVVVRluU8m6qiqgCYGWVZUlUVzjnMLDkzwzk3dxIRALIsY9JUizFOIM7MKIpifnmSqs7331suiuIH5D86Pz+nbVu22+38Jb8VRIT9fn9kycy4urri+/ubj48PsixjvV4DsN/vEZEfMKVE0zTEGDEzRAQz4/r6mqIoWK1WADRNQ0ppBp2qUtc1FxcXlGV5ZOny8hKA3W5HXdeklAghOGdm6r2n6zpeX19pmubI9tTp7e2Nruvw3mNmKk9PT38Oh8O9maGqc+ROTk4A+Pr6IqVESgnvPQDL5fJvCCE8AgzDcBtCCGaWUkq0bXsU8hCCM7NxsVg8hBAe/wEV4Puq2zGzYAAAAABJRU5ErkJggg=="

/***/ },
/* 237 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3gEJDigBhEwC8wAAATtJREFUKM+F0jFLllEYxvHf+0bg3KB2lqChIYqgexAaHEUE+wC5WBBIZK3RUEHgVwiCFKSpXJP6DHGDu1JB4LEip6xoiJbz5sNT6DXe5/zPdd0XZ6ApIs7gMWYwgR28wAoOMlNXwwbN4QPGMY+zuIur+IZJPQ2b0ytMZ+Ys3mbme2xm5kU8wLtmcEhGxHpEvHaEIuJ3RCz2o87gXkQ8PYK9g6U+OIHPuPlPnEN9wlQf3MF5bEfEk8z8H3wJm93BiVLKZGvwCjZKKeewW0r5WWv9HhFjeINrtdbdruMKLuA2xvAFj3A5Ik7iJfbxsbvKEAc4jfv40aI/wzR+tSSnsBcRC6NVBr3aF1t7U22nh81pr3PtRmauDTqQ/rfqnC3geWe0PHCMRg9GxHWs/m31OLDWOoK3SilfMYdbfwCBsGMAyM9nwQAAAABJRU5ErkJggg=="

/***/ },
/* 238 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAIAAACQKrqGAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QwJDggEH6ZkwQAAASlJREFUKM+NkT+KwkAYxd/IEENaIbUnUdKYws7CImfwEB7CI0QQFBNCSBRJ4zUs0wUlZf5N5tviy8JarLuv+g38Zni8EdvttmkaIsLvEUKMx2PZNM10OjUM44Patm2e51II8Xg88Fcsy5KmaW42m77vP3ij0Wi/30sApmnGcfxB9TyPiCQfbNt2XRfA+XxerVYADofDer3WWp9OJ6UUgEHtuu71egHo+/75fBIRERVFAYCI3tSyLJMkYU7TlOF2uzG8qbZtLxYLIgqCYLlcaq2jKGJIkkQpNXRVShVF4fs+XzsejwxhGDLUdT28qrWeTCaz2YyIrtfrfD4noizLGO73O085FKiqKggC5svlwpBlGY/P3y4BGIbhOI7+Djfj/FxXAtjtdvhHvgCz/reiTTp6cgAAAABJRU5ErkJggg=="

/***/ },
/* 239 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAolBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgESU6AAAANXRSTlMAAQIDBAUGCQwNDxAREhMUFyApLzAxMkJHVFlebXF5e4CDm62+xcjKz9PZ3OTo6+/x9/n7/UnKJecAAAB/SURBVBgZBcGJQgEBAAXAcey6tY4KhcpVOgjv/3/NDMDob9MBAIfJ8w4AyktN6gB4WWmkBsD4u+lx3y4BeqcHPpK8wntymwLlTxdJ2gD7CkkKwOAMSQpA5xeSFIDZG2SXArCcQ57SB6QF6//L9WtRNZgcAXTn21vyOQQAzTq4A+uTC/LUhXbmAAAAAElFTkSuQmCC"

/***/ },
/* 240 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhEAAWAKUTAMzMzODg4NfX18nJyaSkpMjIyNHR0fz8/O7u7k9PT01NTfHx8d7e3vX19fb29rm5ud3d3d/f3/Dw8P///9vb2/j4+PPz8/39/dra2srKyu/v79LS0tPT09nZ2dTU1FBQUNbW1sfHx/v7++Li4vT09Pf39/n5+U5OTsXFxdzc3M3NzcvLy/r6+uzs7M/Pz1FRUdXV1cbGxuPj4+Xl5fLy8uHh4f7+/u3t7djY2Obm5v///////////////////////yH5BAEKAD8ALAAAAAAQABYAAAabwItwSCx2FsikUilcOpUNiXRKrYo02Kx2K0J4p14E2NtFLA6Xw8KMVpNvCNZLkTjQDgnFi4W4iVotGnh0F3l1GoAsEIsyJnkKdCYyixAOGJcYARWGFQGYGA4doqIRFR8VEaOiDgKtrgwkDK6uDiC2tyAduLcOHr6/wMEOHMTFxscOG8rLzM0OBtDR0tPP09bR1dfW2drS3N3QDkEAOw=="

/***/ },
/* 241 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9wCGAEcCdgs1SoAAAHeSURBVCjPVZG9a1NhGMV/7/1okqaaUMutaClqrzSttTTYpa1KpVb/Bh3ERYqomYo4dNDNqUO0IAjq0KG4Z/JbEalYB7FRGhWFeA2xuammob03ue/rkmg904Hz4zzwHJ2GDMNASgmwb2DAnrGs9pPFovsJKG/J/sEN9RyfPJJeK9zdXCvc2ZyYHEsDPf8xTRMOhxKW1THrOrc3VGlGqdKMKuXnNiyrYzYcbkk0WdFo3m9Z7Re/rcxdMr2X4mo6pACupWrC0w+oPX2XbxR//roJ5DTAHh8fnn63eGXKcx8JKZX6nv8isstvRbm6qlZ/PBAvHp6ZGhu1pwFb9PZ23XqSOXc2IpyQL33lG64YPfqYIKjz7OlhKpW6EgJRq233Tp1+fs9QUuoq8EQVF3fTIRrV6eyMAKBpPoYRIADfrwilAl0vuZWVV28KOyZObEuEzd+GLurKbNkrDg7spM+uKE1IsVGV/vkLH+4vZ9euN9/ZH4+3zn/9eEyWnUOqLYpsiyLLzrD6/D4pY7GWeaC/cVYDwDT1oXjMWMi+7vWD9ZQK1lMqu9jjx2PGgmlqQ1tZAB3QgJHkYCSTW+r2c0vdfnIwkgFGGrkO/N0hCuwGWgG7a5eRAsg79TSQAzwgD6z/AVpowc7P3/iuAAAAAElFTkSuQmCC"

/***/ },
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */
66,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = arrayTo;
	
	var _isArray = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isString = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Create an array from the passed `param`. (When the value is an object only takes the iterable properties from the object (not its prototypes))
	 *
	 * @param {Object|String|Array} param The value to transform to an array
	 * @returns {Array} Returns the `param` transformed into an array, or an empty array of the value can not be transformed.
	 *
	 * @example
	 * arrayTo('myData') // Returns: ['myData']
	 *
	 * @example
	 * const sourceObject = {
	 *     name: 'ANC First Visit',
	 *     shortName: 'ANC1',
	 *     level: 1,
	 * };
	 * arrayTo(sourceObject); // Returns: ['ANC First Visit', 'ANC1', 1]
	 *
	 * @example
	 * arrayTo(null); // Returns: []
	 */
	function arrayTo(param) {
	    if ((0, _isArray2.default)(param)) {
	        return param;
	    }
	
	    if ((0, _isObject2.default)(param)) {
	        var a = [];
	        for (var key in param) {
	            if (param.hasOwnProperty(key)) {
	                a.push(param[key]);
	            }
	        }
	        return a;
	    }
	
	    if ((0, _isString2.default)(param)) {
	        return param.split();
	    }
	
	    return [];
	}
	//# sourceMappingURL=arrayTo.js.map

/***/ },
/* 567 */,
/* 568 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmpty;
	
	var _isArray = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _lodash = __webpack_require__(72);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(74);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if a value is concidered _empty_. An _empty_ value is an empty `Set`, `Map` or `Array`.
	 * Depending on if the `allowEmptyString` flag, empty strings are also considered _empty_
	 *
	 * @param {*} param Value to check
	 * @param {boolean} allowEmptyString When set to true an empty string will not be considered _empty_.
	 * @returns {boolean} Returns `true` when the value is _empty_, otherwise false
	 *
	 * @example
	 * isEmpty(''); // Returns: true
	 * isEmpty('', true); // Returns: false
	 * isEmpty(null); // Returns: true
	 * isEmpty(new Map()); // Returns: true
	 */
	function isEmpty(param, allowEmptyString) {
	  return param == null || (!allowEmptyString ? param === '' : false) || (0, _isArray2.default)(param) && param.length === 0 || ((0, _lodash2.default)(param) || (0, _lodash4.default)(param)) && param.size === 0;
	}
	//# sourceMappingURL=isEmpty.js.map

/***/ },
/* 569 */,
/* 570 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumber;
	
	var _numberIsFinite = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _numberIsFinite2 = _interopRequireDefault(_numberIsFinite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if a value is a number
	 *
	 * @name isNumber
	 * @param param Value that will be checked if it is a number
	 * @returns {boolean} Returns true when param is a Number otherwise false
	 */
	function isNumber(param) {
	  return typeof param === 'number' && (0, _numberIsFinite2.default)(param);
	}
	//# sourceMappingURL=isNumber.js.map

/***/ },
/* 571 */,
/* 572 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	
	var _lodash = __webpack_require__(73);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _isArray = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if the value is an Object
	 *
	 * @param param Value to be checked
	 * @returns {boolean} Returns true when the `param` is an Object
	 */
	function isObject(param) {
	  return (0, _lodash2.default)(param) && !(0, _isArray2.default)(param);
	}
	//# sourceMappingURL=isObject.js.map

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** eventreport.js
 **/